var D1 = Object.defineProperty;
var A1 = (e, t, a) => t in e ? D1(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a;
var Xa = (e, t, a) => A1(e, typeof t != "symbol" ? t + "" : t, a);
import { defineComponent as se, renderSlot as j, reactive as Ur, ref as L, useSlots as Tt, createCommentVNode as W, computed as b, createBlock as ee, openBlock as y, resolveDynamicComponent as Ye, normalizeStyle as Ee, withCtx as N, createElementBlock as S, normalizeClass as ue, createElementVNode as H, unref as A, toDisplayString as ae, withKeys as lt, withModifiers as Ke, shallowRef as jp, watch as ne, getCurrentScope as Gp, onScopeDispose as Qp, shallowReadonly as vr, useAttrs as ea, onMounted as rt, mergeProps as Fe, toHandlers as Bs, Teleport as I1, toValue as Dn, getCurrentInstance as Zp, useId as bt, onBeforeUnmount as cn, createVNode as Z, createTextVNode as be, Transition as Zt, withDirectives as $a, vShow as Nr, useCssVars as Yt, nextTick as gt, Fragment as Ae, renderList as Le, onUnmounted as qa, isReadonly as E1, toRefs as Xp, watchEffect as Mu, useTemplateRef as mt, createSlots as yt, isVNode as Jp, normalizeProps as ra, warn as M1, inject as Li, toRef as Yo, provide as Bi, guardReactiveProps as Ma, isRef as wr, resolveComponent as zt, resolveDirective as O1, mergeModels as Ql, useModel as Zl, vModelText as Xl, Comment as x1, cloneVNode as P1, onBeforeMount as N1, TransitionGroup as L1, render as Bd, h as Rd, createPropsRestProxy as eh } from "vue";
async function th(e) {
  var n, r;
  if (navigator.clipboard)
    try {
      return await navigator.clipboard.writeText(e), !0;
    } catch {
    }
  const t = document == null ? void 0 : document.createElement("textarea");
  t && (t.style.position = "fixed", t.style.top = "0", t.style.left = "0", t.style.width = "32px", t.style.height = "32px", t.style.padding = "0", t.style.border = "none", t.style.outline = "none", t.style.boxShadow = "none", t.style.background = "transparent", t.value = e, (n = document == null ? void 0 : document.body) == null || n.appendChild(t), t.focus(), t.select());
  let a;
  try {
    a = document == null ? void 0 : document.execCommand("copy");
  } catch {
    a = !1;
  } finally {
    (r = document == null ? void 0 : document.body) == null || r.removeChild(t);
  }
  return a;
}
const ah = /* @__PURE__ */ se({
  __name: "KClipboardProvider",
  setup(e) {
    const t = (a = "") => th(a);
    return (a, n) => j(a.$slots, "default", { copyToClipboard: t });
  }
}), nh = se({
  name: "KComponent",
  props: {
    data: {
      type: Object,
      default: {},
      required: !0
    }
  },
  setup(e, { slots: t }) {
    const a = Ur(e.data);
    return () => (t == null ? void 0 : t.default) && t.default({
      data: a
    });
  }
}), Rs = /* @__PURE__ */ se({
  __name: "KToggle",
  props: {
    toggled: { type: Boolean }
  },
  emits: ["toggled"],
  setup(e, { emit: t }) {
    const a = t, n = L(e.toggled), r = [n], i = () => {
      n.value = !n.value, a("toggled", n.value);
    };
    return Tt().default || console.error(`KToggle expects to have slot content.

Example usage:

<KToggle>
  <template #default="{ isToggled, toggle }">
    <button @click="toggle">
      {{ isToggled ? 'hello' : 'goodbye' }}
    </button>
  </template>
</KToggle>
`), (u, l) => u.$slots.default ? j(u.$slots, "default", {
      key: 0,
      isToggled: r[0],
      toggle: i
    }) : W("", !0);
  }
}), ti = {
  info: "info",
  success: "success",
  danger: "danger",
  warning: "warning"
}, rh = {
  get: "get",
  post: "post",
  put: "put",
  delete: "delete",
  patch: "patch",
  options: "options",
  head: "head",
  connect: "connect",
  trace: "trace",
  custom: "custom"
}, nq = {
  info: "info",
  success: "success",
  warning: "warning",
  danger: "danger",
  decorative: "decorative",
  neutral: "neutral",
  ...rh
}, rq = {
  medium: "medium",
  small: "small"
}, B1 = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  danger: "danger",
  none: "none"
}, iq = {
  large: "large",
  medium: "medium",
  small: "small"
}, oq = ["div", "p", "span", "a", "legend", "h1", "h2", "h3", "h4", "h5", "h6"], sq = ["large", "medium", "small"], lq = ["leading", "trailing"];
var Fs = /* @__PURE__ */ ((e) => (e.Date = "date", e.Time = "time", e.Datetime = "dateTime", e.Relative = "relative", e.RelativeDate = "relativeDate", e.RelativeDateTime = "relativeDateTime", e))(Fs || {});
const uq = Fs, dq = Object.values(Fs), R1 = [
  "date",
  "time",
  "dateTime"
  /* Datetime */
], F1 = [
  "relative",
  "relativeDate",
  "relativeDateTime"
  /* RelativeDateTime */
], z1 = [
  "date",
  "relativeDate"
  /* RelativeDate */
];
var xa = /* @__PURE__ */ ((e) => (e.Default = "default", e.Error = "error", e.Search = "search", e.Kong = "kong", e))(xa || {});
const cq = ["get", "post", "put", "patch", "delete", "head", "options", "trace", "connect", "custom"], fq = ["click", "hover"], vq = [
  "auto",
  "top",
  "top-start",
  "top-end",
  "left",
  "left-start",
  "left-end",
  "right",
  "right-start",
  "right-end",
  "bottom",
  "bottom-start",
  "bottom-end"
], pq = ["", "radio", "card"], hq = [
  "table",
  "card",
  "form",
  "spinner",
  "fullscreen-kong",
  "fullscreen-generic",
  ""
  // default Skeleton.vue
], gq = ["1", "2", "5", "6", "10", "25", "50", "75", "100"], mq = ["1", "2"], yq = ["active", "default", "pending", "completed", "error"];
var We = /* @__PURE__ */ ((e) => (e.EXPANDABLE = "expandable", e.ACTIONS = "actions", e.BULK_ACTIONS = "bulkActions", e))(We || {});
const ih = {
  info: "info",
  success: "success",
  danger: "danger",
  warning: "warning",
  system: "system"
}, Te = "24px", Y1 = ["aria-hidden"], Fd = '<path d="M7 17H9V12H7V17ZM15 17H17V7H15V17ZM11 17H13V14H11V17ZM11 12H13V10H11V12ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM5 19H19V5H5V19Z" fill="currentColor"/>', zd = /* @__PURE__ */ se({
  __name: "AnalyticsIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Fd : r(Fd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon analytics-icon",
      "data-testid": "kui-icon-wrapper-analytics-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-analytics-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Y1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), H1 = ["aria-hidden"], Yd = '<path d="M12 20L4 12L5.4 10.575L11 16.175V4H13V16.175L18.6 10.575L20 12L12 20Z" fill="currentColor"/>', Ou = /* @__PURE__ */ se({
  __name: "ArrowDownIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Yd : r(Yd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon arrow-down-icon",
      "data-testid": "kui-icon-wrapper-arrow-down-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-arrow-down-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, H1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), q1 = ["aria-hidden"], Hd = '<path d="M11 20V7.825L5.4 13.425L4 12L12 4L20 12L18.6 13.425L13 7.825V20H11Z" fill="currentColor"/>', W1 = /* @__PURE__ */ se({
  __name: "ArrowUpIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Hd : r(Hd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon arrow-up-icon",
      "data-testid": "kui-icon-wrapper-arrow-up-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-arrow-up-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, q1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), _1 = ["aria-hidden"], qd = '<path d="M9 18L3 12L9 6L10.4 7.4L6.8 11H21V13H6.8L10.4 16.6L9 18Z" fill="currentColor"/>', oh = /* @__PURE__ */ se({
  __name: "BackIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? qd : r(qd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon back-icon",
      "data-testid": "kui-icon-wrapper-back-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-back-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, _1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), U1 = ["aria-hidden"], Wd = '<path d="M12 14C11.7167 14 11.4792 13.9042 11.2875 13.7125C11.0958 13.5208 11 13.2833 11 13C11 12.7167 11.0958 12.4792 11.2875 12.2875C11.4792 12.0958 11.7167 12 12 12C12.2833 12 12.5208 12.0958 12.7125 12.2875C12.9042 12.4792 13 12.7167 13 13C13 13.2833 12.9042 13.5208 12.7125 13.7125C12.5208 13.9042 12.2833 14 12 14ZM8 14C7.71667 14 7.47917 13.9042 7.2875 13.7125C7.09583 13.5208 7 13.2833 7 13C7 12.7167 7.09583 12.4792 7.2875 12.2875C7.47917 12.0958 7.71667 12 8 12C8.28333 12 8.52083 12.0958 8.7125 12.2875C8.90417 12.4792 9 12.7167 9 13C9 13.2833 8.90417 13.5208 8.7125 13.7125C8.52083 13.9042 8.28333 14 8 14ZM16 14C15.7167 14 15.4792 13.9042 15.2875 13.7125C15.0958 13.5208 15 13.2833 15 13C15 12.7167 15.0958 12.4792 15.2875 12.2875C15.4792 12.0958 15.7167 12 16 12C16.2833 12 16.5208 12.0958 16.7125 12.2875C16.9042 12.4792 17 12.7167 17 13C17 13.2833 16.9042 13.5208 16.7125 13.7125C16.5208 13.9042 16.2833 14 16 14ZM12 18C11.7167 18 11.4792 17.9042 11.2875 17.7125C11.0958 17.5208 11 17.2833 11 17C11 16.7167 11.0958 16.4792 11.2875 16.2875C11.4792 16.0958 11.7167 16 12 16C12.2833 16 12.5208 16.0958 12.7125 16.2875C12.9042 16.4792 13 16.7167 13 17C13 17.2833 12.9042 17.5208 12.7125 17.7125C12.5208 17.9042 12.2833 18 12 18ZM8 18C7.71667 18 7.47917 17.9042 7.2875 17.7125C7.09583 17.5208 7 17.2833 7 17C7 16.7167 7.09583 16.4792 7.2875 16.2875C7.47917 16.0958 7.71667 16 8 16C8.28333 16 8.52083 16.0958 8.7125 16.2875C8.90417 16.4792 9 16.7167 9 17C9 17.2833 8.90417 17.5208 8.7125 17.7125C8.52083 17.9042 8.28333 18 8 18ZM16 18C15.7167 18 15.4792 17.9042 15.2875 17.7125C15.0958 17.5208 15 17.2833 15 17C15 16.7167 15.0958 16.4792 15.2875 16.2875C15.4792 16.0958 15.7167 16 16 16C16.2833 16 16.5208 16.0958 16.7125 16.2875C16.9042 16.4792 17 16.7167 17 17C17 17.2833 16.9042 17.5208 16.7125 17.7125C16.5208 17.9042 16.2833 18 16 18ZM5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H6V2H8V4H16V2H18V4H19C19.55 4 20.0208 4.19583 20.4125 4.5875C20.8042 4.97917 21 5.45 21 6V20C21 20.55 20.8042 21.0208 20.4125 21.4125C20.0208 21.8042 19.55 22 19 22H5ZM5 20H19V10H5V20Z" fill="currentColor"/>', V1 = /* @__PURE__ */ se({
  __name: "CalIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Wd : r(Wd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon cal-icon",
      "data-testid": "kui-icon-wrapper-cal-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-cal-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, U1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), K1 = ["aria-hidden"], _d = '<path d="M10.6 16.6L17.65 9.55L16.25 8.15L10.6 13.8L7.75 10.95L6.35 12.35L10.6 16.6ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill="currentColor"/>', sh = /* @__PURE__ */ se({
  __name: "CheckCircleIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? _d : r(_d)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon check-circle-icon",
      "data-testid": "kui-icon-wrapper-check-circle-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-check-circle-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, K1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), j1 = ["aria-hidden"], Ud = '<path d="M8 14.4L4 10.4L5.4 9L8 11.6L14.6 5L16 6.4L8 14.4Z" fill="currentColor"/>', G1 = /* @__PURE__ */ se({
  __name: "CheckSmallIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Ud : r(Ud)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon check-small-icon",
      "data-testid": "kui-icon-wrapper-check-small-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-check-small-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, j1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Q1 = ["aria-hidden"], Vd = '<path d="M9.7 18.025L4 12.325L5.425 10.9L9.7 15.175L18.875 6L20.3 7.425L9.7 18.025Z" fill="currentColor"/>', Z1 = /* @__PURE__ */ se({
  __name: "CheckIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Vd : r(Vd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon check-icon",
      "data-testid": "kui-icon-wrapper-check-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-check-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Q1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), X1 = ["aria-hidden"], Kd = '<path d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z" fill="currentColor"/>', zs = /* @__PURE__ */ se({
  __name: "ChevronDownIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Kd : r(Kd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon chevron-down-icon",
      "data-testid": "kui-icon-wrapper-chevron-down-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-chevron-down-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, X1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), J1 = ["aria-hidden"], jd = '<path d="M9.4 18L8 16.6L12.6 12L8 7.4L9.4 6L15.4 12L9.4 18Z" fill="currentColor"/>', xu = /* @__PURE__ */ se({
  __name: "ChevronRightIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? jd : r(jd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon chevron-right-icon",
      "data-testid": "kui-icon-wrapper-chevron-right-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-chevron-right-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, J1))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), ey = ["aria-hidden"], Gd = '<path d="M7.4 15.4L6 14L12 8L18 14L16.6 15.4L12 10.8L7.4 15.4Z" fill="currentColor"/>', ty = /* @__PURE__ */ se({
  __name: "ChevronUpIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Gd : r(Gd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon chevron-up-icon",
      "data-testid": "kui-icon-wrapper-chevron-up-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-chevron-up-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, ey))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), ay = ["aria-hidden"], Qd = '<path d="M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill="currentColor"/>', ny = /* @__PURE__ */ se({
  __name: "ClearIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Qd : r(Qd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon clear-icon",
      "data-testid": "kui-icon-wrapper-clear-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-clear-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, ay))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), ry = ["aria-hidden"], Zd = '<path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="currentColor"/>', va = /* @__PURE__ */ se({
  __name: "CloseIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Zd : r(Zd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon close-icon",
      "data-testid": "kui-icon-wrapper-close-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-close-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, ry))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), iy = ["aria-hidden"], Xd = '<path d="M5 22C4.45 22 3.97917 21.8042 3.5875 21.4125C3.19583 21.0208 3 20.55 3 20V6H5V20H16V22H5ZM9 18C8.45 18 7.97917 17.8042 7.5875 17.4125C7.19583 17.0208 7 16.55 7 16V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H18C18.55 2 19.0208 2.19583 19.4125 2.5875C19.8042 2.97917 20 3.45 20 4V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H9ZM9 16H18V4H9V16Z" fill="currentColor"/>', lh = /* @__PURE__ */ se({
  __name: "CopyIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Xd : r(Xd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon copy-icon",
      "data-testid": "kui-icon-wrapper-copy-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-copy-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, iy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), oy = ["aria-hidden"], Jd = '<path d="M8.575 21.25C8.30833 21.25 8.05417 21.2 7.8125 21.1C7.57083 21 7.35833 20.8583 7.175 20.675L3.075 16.575C2.89167 16.3917 2.75 16.1792 2.65 15.9375C2.55 15.6958 2.5 15.4417 2.5 15.175V9.325C2.5 9.05833 2.55 8.80417 2.65 8.5625C2.75 8.32083 2.89167 8.10833 3.075 7.925L7.175 3.825C7.35833 3.64167 7.57083 3.5 7.8125 3.4C8.05417 3.3 8.30833 3.25 8.575 3.25H14.425C14.6917 3.25 14.9458 3.3 15.1875 3.4C15.4292 3.5 15.6417 3.64167 15.825 3.825L19.925 7.925C20.1083 8.10833 20.25 8.32083 20.35 8.5625C20.45 8.80417 20.5 9.05833 20.5 9.325V15.175C20.5 15.4417 20.45 15.6958 20.35 15.9375C20.25 16.1792 20.1083 16.3917 19.925 16.575L15.825 20.675C15.6417 20.8583 15.4292 21 15.1875 21.1C14.9458 21.2 14.6917 21.25 14.425 21.25H8.575ZM11.5 13.65L13.65 15.8C13.8333 15.9833 14.0667 16.075 14.35 16.075C14.6333 16.075 14.8667 15.9833 15.05 15.8C15.2333 15.6167 15.325 15.3833 15.325 15.1C15.325 14.8167 15.2333 14.5833 15.05 14.4L12.9 12.25L15.05 10.1C15.2333 9.91667 15.325 9.68333 15.325 9.4C15.325 9.11667 15.2333 8.88333 15.05 8.7C14.8667 8.51667 14.6333 8.425 14.35 8.425C14.0667 8.425 13.8333 8.51667 13.65 8.7L11.5 10.85L9.35 8.7C9.16667 8.51667 8.93333 8.425 8.65 8.425C8.36667 8.425 8.13333 8.51667 7.95 8.7C7.76667 8.88333 7.675 9.11667 7.675 9.4C7.675 9.68333 7.76667 9.91667 7.95 10.1L10.1 12.25L7.95 14.4C7.76667 14.5833 7.675 14.8167 7.675 15.1C7.675 15.3833 7.76667 15.6167 7.95 15.8C8.13333 15.9833 8.36667 16.075 8.65 16.075C8.93333 16.075 9.16667 15.9833 9.35 15.8L11.5 13.65Z" fill="currentColor"/>', sy = /* @__PURE__ */ se({
  __name: "DangerIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? Jd : r(Jd)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon danger-icon",
      "data-testid": "kui-icon-wrapper-danger-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-danger-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, oy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), ly = ["aria-hidden"], ec = '<path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H12V5H5V19H19V12H21V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM9.7 15.7L8.3 14.3L17.6 5H14V3H21V10H19V6.4L9.7 15.7Z" fill="currentColor"/>', uy = /* @__PURE__ */ se({
  __name: "ExternalLinkIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? ec : r(ec)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon external-link-icon",
      "data-testid": "kui-icon-wrapper-external-link-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-external-link-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, ly))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), dy = ["aria-hidden"], tc = '<path d="M10 18V16H14V18H10ZM6 13V11H18V13H6ZM3 8V6H21V8H3Z" fill="currentColor"/>', cy = /* @__PURE__ */ se({
  __name: "FilterIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? tc : r(tc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon filter-icon",
      "data-testid": "kui-icon-wrapper-filter-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-filter-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, dy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), fy = ["aria-hidden"], ac = '<path d="M15 18L21 12L15 6L13.6 7.4L17.2 11H3V13H17.2L13.6 16.6L15 18Z" fill="currentColor"/>', uh = /* @__PURE__ */ se({
  __name: "ForwardIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? ac : r(ac)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon forward-icon",
      "data-testid": "kui-icon-wrapper-forward-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-forward-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, fy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), vy = ["aria-hidden"], nc = '<path d="M5 11V9H15V11H5Z" fill="currentColor"/>', py = /* @__PURE__ */ se({
  __name: "IndeterminateSmallIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? nc : r(nc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon indeterminate-small-icon",
      "data-testid": "kui-icon-wrapper-indeterminate-small-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-indeterminate-small-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, vy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), hy = ["aria-hidden"], rc = '<path d="M11 17H13V11H11V17ZM12 9C12.2833 9 12.5208 8.90417 12.7125 8.7125C12.9042 8.52083 13 8.28333 13 8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8C11 8.28333 11.0958 8.52083 11.2875 8.7125C11.4792 8.90417 11.7167 9 12 9ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z" fill="currentColor"/>', In = /* @__PURE__ */ se({
  __name: "InfoIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? rc : r(rc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon info-icon",
      "data-testid": "kui-icon-wrapper-info-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-info-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, hy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), gy = ["aria-hidden"], ic = '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.56654 17.8134H12.2371L14.1429 20.2096L13.8152 21.026H9.0731L9.18942 20.2096L8.07153 18.4462L8.56654 17.8134ZM11.193 7.28639L13.1602 7.28343L22 17.822L21.3132 21.026H17.5245L17.7604 20.1233L9.50009 10.2732L11.193 7.28639ZM14.6686 3L18.778 6.22975L18.2519 6.77265L18.9644 7.76492V8.82592L16.9157 10.496L13.4703 6.42551H11.4644L12.272 4.94512L14.6686 3ZM6.04318 13.3443L8.90974 10.853L12.7144 15.4313L11.6342 17.1086H8.12603L5.69899 20.2934L5.14469 21.026H2V17.1183L4.93106 13.3443H6.04318Z" fill="currentColor"/>', Pu = /* @__PURE__ */ se({
  __name: "KongIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? ic : r(ic)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon kong-icon",
      "data-testid": "kui-icon-wrapper-kong-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-kong-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, gy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), my = ["aria-hidden"], oc = '<path d="M12 20C11.45 20 10.9792 19.8042 10.5875 19.4125C10.1958 19.0208 10 18.55 10 18C10 17.45 10.1958 16.9792 10.5875 16.5875C10.9792 16.1958 11.45 16 12 16C12.55 16 13.0208 16.1958 13.4125 16.5875C13.8042 16.9792 14 17.45 14 18C14 18.55 13.8042 19.0208 13.4125 19.4125C13.0208 19.8042 12.55 20 12 20ZM12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14ZM12 8C11.45 8 10.9792 7.80417 10.5875 7.4125C10.1958 7.02083 10 6.55 10 6C10 5.45 10.1958 4.97917 10.5875 4.5875C10.9792 4.19583 11.45 4 12 4C12.55 4 13.0208 4.19583 13.4125 4.5875C13.8042 4.97917 14 5.45 14 6C14 6.55 13.8042 7.02083 13.4125 7.4125C13.0208 7.80417 12.55 8 12 8Z" fill="currentColor"/>', dh = /* @__PURE__ */ se({
  __name: "MoreIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? oc : r(oc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon more-icon",
      "data-testid": "kui-icon-wrapper-more-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-more-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, my))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), yy = ["aria-hidden"], sc = `<style>@keyframes kong-icon-spin { from {transform: rotate(0deg);} to {transform: rotate(360deg);} }</style>
<path d="M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C12.2833 2 12.5208 2.09583 12.7125 2.2875C12.9042 2.47917 13 2.71667 13 3C13 3.28333 12.9042 3.52083 12.7125 3.7125C12.5208 3.90417 12.2833 4 12 4C9.78333 4 7.89583 4.77917 6.3375 6.3375C4.77917 7.89583 4 9.78333 4 12C4 14.2167 4.77917 16.1042 6.3375 17.6625C7.89583 19.2208 9.78333 20 12 20C14.2167 20 16.1042 19.2208 17.6625 17.6625C19.2208 16.1042 20 14.2167 20 12C20 11.7167 20.0958 11.4792 20.2875 11.2875C20.4792 11.0958 20.7167 11 21 11C21.2833 11 21.5208 11.0958 21.7125 11.2875C21.9042 11.4792 22 11.7167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22Z" fill="currentColor" style="transform-origin: 50% 50%; animation: kong-icon-spin 1.5s linear infinite;"/>`, Ri = /* @__PURE__ */ se({
  __name: "ProgressIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? sc : r(sc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon progress-icon",
      "data-testid": "kui-icon-wrapper-progress-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-progress-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, yy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), by = ["aria-hidden"], lc = '<path d="M4.30937 19.025C3.49271 18.075 2.86198 16.9917 2.41719 15.775C1.9724 14.5583 1.75 13.2833 1.75 11.95C1.75 10.6167 1.96875 9.34167 2.40625 8.125C2.84375 6.90833 3.47812 5.825 4.30937 4.875L5.55625 6.3C4.88542 7.05 4.375 7.9125 4.025 8.8875C3.675 9.8625 3.5 10.8833 3.5 11.95C3.5 13.0167 3.67865 14.0375 4.03594 15.0125C4.39323 15.9875 4.9 16.85 5.55625 17.6L4.30937 19.025ZM8.3125 18C7.94792 18 7.63802 17.8542 7.38281 17.5625C7.1276 17.2708 7 16.9167 7 16.5C7 16.0833 7.1276 15.7292 7.38281 15.4375C7.63802 15.1458 7.94792 15 8.3125 15C8.67708 15 8.98698 15.1458 9.24219 15.4375C9.49739 15.7292 9.625 16.0833 9.625 16.5C9.625 16.9167 9.49739 17.2708 9.24219 17.5625C8.98698 17.8542 8.67708 18 8.3125 18ZM11.3531 13V11.225L10.0187 12.125L9.14375 10.375L10.4781 9.5L9.14375 8.625L10.0187 6.875L11.3531 7.775V6H13.1031V7.775L14.4375 6.875L15.3125 8.625L13.9781 9.5L15.3125 10.375L14.4375 12.125L13.1031 11.225V13H11.3531ZM16.6906 19.025L15.4437 17.6C16.1146 16.85 16.625 15.9875 16.975 15.0125C17.325 14.0375 17.5 13.0167 17.5 11.95C17.5 10.8833 17.3214 9.8625 16.9641 8.8875C16.6068 7.9125 16.1 7.05 15.4437 6.3L16.6906 4.875C17.5073 5.825 18.138 6.90833 18.5828 8.125C19.0276 9.34167 19.25 10.6167 19.25 11.95C19.25 13.2833 19.0312 14.5583 18.5937 15.775C18.1562 16.9917 17.5219 18.075 16.6906 19.025Z" fill="currentColor"/>', wy = /* @__PURE__ */ se({
  __name: "RegexIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? lc : r(lc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon regex-icon",
      "data-testid": "kui-icon-wrapper-regex-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-regex-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, by))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Cy = ["aria-hidden"], uc = '<path d="M19.6 21L13.3 14.7C12.8 15.1 12.225 15.4167 11.575 15.65C10.925 15.8833 10.2333 16 9.5 16C7.68333 16 6.14583 15.3708 4.8875 14.1125C3.62917 12.8542 3 11.3167 3 9.5C3 7.68333 3.62917 6.14583 4.8875 4.8875C6.14583 3.62917 7.68333 3 9.5 3C11.3167 3 12.8542 3.62917 14.1125 4.8875C15.3708 6.14583 16 7.68333 16 9.5C16 10.2333 15.8833 10.925 15.65 11.575C15.4167 12.225 15.1 12.8 14.7 13.3L21 19.6L19.6 21ZM9.5 14C10.75 14 11.8125 13.5625 12.6875 12.6875C13.5625 11.8125 14 10.75 14 9.5C14 8.25 13.5625 7.1875 12.6875 6.3125C11.8125 5.4375 10.75 5 9.5 5C8.25 5 7.1875 5.4375 6.3125 6.3125C5.4375 7.1875 5 8.25 5 9.5C5 10.75 5.4375 11.8125 6.3125 12.6875C7.1875 13.5625 8.25 14 9.5 14Z" fill="currentColor"/>', Nu = /* @__PURE__ */ se({
  __name: "SearchIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? uc : r(uc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon search-icon",
      "data-testid": "kui-icon-wrapper-search-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-search-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Cy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), ky = ["aria-hidden"], dc = '<path d="M8 18H16V16H8V18ZM8 14H16V12H8V14ZM6 22C5.45 22 4.97917 21.8042 4.5875 21.4125C4.19583 21.0208 4 20.55 4 20V4C4 3.45 4.19583 2.97917 4.5875 2.5875C4.97917 2.19583 5.45 2 6 2H14L20 8V20C20 20.55 19.8042 21.0208 19.4125 21.4125C19.0208 21.8042 18.55 22 18 22H6ZM13 9V4H6V20H18V9H13Z" fill="currentColor"/>', $y = /* @__PURE__ */ se({
  __name: "ServiceDocumentIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? dc : r(dc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon service-document-icon",
      "data-testid": "kui-icon-wrapper-service-document-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-service-document-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, ky))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Sy = ["aria-hidden"], cc = '<path d="M8 13V5.825L5.425 8.4L4 7L9 2L14 7L12.575 8.4L10 5.825V13H8ZM15 22L10 17L11.425 15.6L14 18.175V11H16V18.175L18.575 15.6L20 17L15 22Z" fill="currentColor"/>', Ty = /* @__PURE__ */ se({
  __name: "SwapSortIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? cc : r(cc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon swap-sort-icon",
      "data-testid": "kui-icon-wrapper-swap-sort-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-swap-sort-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Sy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Dy = ["aria-hidden"], fc = '<path d="M3.0249 17.75V7.75C3.0249 7.2 3.22074 6.72917 3.6124 6.3375C4.00407 5.94583 4.4749 5.75 5.0249 5.75H18.9999C19.5499 5.75 20.0207 5.94583 20.4124 6.3375C20.8041 6.72917 20.9999 7.2 20.9999 7.75V17.75C20.9999 18.3 20.8041 18.7708 20.4124 19.1625C20.0207 19.5542 19.5499 19.75 18.9999 19.75H5.0249C4.4749 19.75 4.00407 19.5542 3.6124 19.1625C3.22074 18.7708 3.0249 18.3 3.0249 17.75ZM4.9999 17.75H8.3249V7.75H4.9999V17.75ZM10.3249 17.75H13.6499V7.75H10.3249V17.75ZM15.6499 17.75H18.9749V7.75H15.6499V17.75Z" fill="currentColor"/>', Ay = /* @__PURE__ */ se({
  __name: "TableColumnsIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? fc : r(fc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon table-columns-icon",
      "data-testid": "kui-icon-wrapper-table-columns-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-table-columns-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Dy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Iy = ["aria-hidden"], vc = '<path d="M19.0999 21.9L15.5999 18.45C15.0166 18.6333 14.4249 18.7708 13.8249 18.8625C13.2249 18.9541 12.6166 19 11.9999 19C9.76657 19 7.7249 18.4 5.8749 17.2C4.0249 16 2.5749 14.4166 1.5249 12.45C1.44157 12.3 1.37907 12.1458 1.3374 11.9875C1.29574 11.8291 1.2749 11.6666 1.2749 11.5C1.2749 11.3333 1.29574 11.1708 1.3374 11.0125C1.37907 10.8541 1.44157 10.7 1.5249 10.55C1.89157 9.89998 2.28324 9.26664 2.6999 8.64998C3.11657 8.03331 3.5999 7.48331 4.1499 6.99998L2.0749 4.89998C1.89157 4.71664 1.7999 4.48748 1.7999 4.21248C1.7999 3.93748 1.8999 3.69998 2.0999 3.49998C2.28324 3.31664 2.51657 3.22498 2.7999 3.22498C3.08324 3.22498 3.31657 3.31664 3.4999 3.49998L20.4999 20.5C20.6832 20.6833 20.7791 20.9125 20.7874 21.1875C20.7957 21.4625 20.6999 21.7 20.4999 21.9C20.3166 22.0833 20.0832 22.175 19.7999 22.175C19.5166 22.175 19.2832 22.0833 19.0999 21.9ZM11.9999 16C12.1832 16 12.3582 15.9916 12.5249 15.975C12.6916 15.9583 12.8582 15.925 13.0249 15.875L7.6249 10.475C7.5749 10.6416 7.54157 10.8083 7.5249 10.975C7.50824 11.1416 7.4999 11.3166 7.4999 11.5C7.4999 12.75 7.9374 13.8125 8.8124 14.6875C9.6874 15.5625 10.7499 16 11.9999 16ZM11.9999 3.99998C14.2332 3.99998 16.2791 4.60414 18.1374 5.81248C19.9957 7.02081 21.4499 8.60831 22.4999 10.575C22.5832 10.7083 22.6457 10.8541 22.6874 11.0125C22.7291 11.1708 22.7499 11.3333 22.7499 11.5C22.7499 11.6666 22.7332 11.8291 22.6999 11.9875C22.6666 12.1458 22.6082 12.2916 22.5249 12.425C22.2082 13.0416 21.8541 13.625 21.4624 14.175C21.0707 14.725 20.6332 15.2416 20.1499 15.725C19.9166 15.9583 19.6416 16.0666 19.3249 16.05C19.0082 16.0333 18.7332 15.9083 18.4999 15.675L16.4999 13.675C16.3832 13.5583 16.3082 13.4208 16.2749 13.2625C16.2416 13.1041 16.2499 12.9416 16.2999 12.775C16.3666 12.5583 16.4166 12.35 16.4499 12.15C16.4832 11.95 16.4999 11.7333 16.4999 11.5C16.4999 10.25 16.0624 9.18748 15.1874 8.31248C14.3124 7.43748 13.2499 6.99998 11.9999 6.99998C11.7666 6.99998 11.5499 7.01664 11.3499 7.04998C11.1499 7.08331 10.9416 7.13331 10.7249 7.19998C10.5582 7.24998 10.3916 7.25831 10.2249 7.22498C10.0582 7.19164 9.91657 7.11664 9.7999 6.99998L8.9749 6.17498C8.65824 5.85831 8.55407 5.49164 8.6624 5.07498C8.77074 4.65831 9.03324 4.39164 9.4499 4.27498C9.86657 4.19164 10.2874 4.12498 10.7124 4.07498C11.1374 4.02498 11.5666 3.99998 11.9999 3.99998ZM13.9749 9.64998C14.1582 9.86664 14.3124 10.1041 14.4374 10.3625C14.5624 10.6208 14.6416 10.8916 14.6749 11.175C14.6916 11.3083 14.6416 11.4 14.5249 11.45C14.4082 11.5 14.2999 11.475 14.1999 11.375L12.1499 9.32498C12.0499 9.22498 12.0291 9.11664 12.0874 8.99998C12.1457 8.88331 12.2416 8.82498 12.3749 8.82498C12.6916 8.85831 12.9832 8.94581 13.2499 9.08748C13.5166 9.22914 13.7582 9.41664 13.9749 9.64998Z" fill="currentColor"/>', Ey = /* @__PURE__ */ se({
  __name: "VisibilityOffIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? vc : r(vc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon visibility-off-icon",
      "data-testid": "kui-icon-wrapper-visibility-off-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-visibility-off-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, Iy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), My = ["aria-hidden"], pc = '<path d="M12 16C13.25 16 14.3125 15.5625 15.1875 14.6875C16.0625 13.8125 16.5 12.75 16.5 11.5C16.5 10.25 16.0625 9.1875 15.1875 8.3125C14.3125 7.4375 13.25 7 12 7C10.75 7 9.6875 7.4375 8.8125 8.3125C7.9375 9.1875 7.5 10.25 7.5 11.5C7.5 12.75 7.9375 13.8125 8.8125 14.6875C9.6875 15.5625 10.75 16 12 16ZM12 14.2C11.25 14.2 10.6125 13.9375 10.0875 13.4125C9.5625 12.8875 9.3 12.25 9.3 11.5C9.3 10.75 9.5625 10.1125 10.0875 9.5875C10.6125 9.0625 11.25 8.8 12 8.8C12.75 8.8 13.3875 9.0625 13.9125 9.5875C14.4375 10.1125 14.7 10.75 14.7 11.5C14.7 12.25 14.4375 12.8875 13.9125 13.4125C13.3875 13.9375 12.75 14.2 12 14.2ZM12 19C9.56667 19 7.35 18.3208 5.35 16.9625C3.35 15.6042 1.9 13.7833 1 11.5C1.9 9.21667 3.35 7.39583 5.35 6.0375C7.35 4.67917 9.56667 4 12 4C14.4333 4 16.65 4.67917 18.65 6.0375C20.65 7.39583 22.1 9.21667 23 11.5C22.1 13.7833 20.65 15.6042 18.65 16.9625C16.65 18.3208 14.4333 19 12 19Z" fill="currentColor"/>', Oy = /* @__PURE__ */ se({
  __name: "VisibilityIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? pc : r(pc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon visibility-icon",
      "data-testid": "kui-icon-wrapper-visibility-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-visibility-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, My))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), xy = ["aria-hidden"], hc = '<path d="M12.025 22.05C11.7583 22.05 11.5042 22 11.2625 21.9C11.0208 21.8 10.8 21.6583 10.6 21.475L2.575 13.45C2.39167 13.25 2.25 13.0292 2.15 12.7875C2.05 12.5458 2 12.2917 2 12.025C2 11.7583 2.05 11.5 2.15 11.25C2.25 11 2.39167 10.7833 2.575 10.6L10.6 2.575C10.8 2.375 11.0208 2.22917 11.2625 2.1375C11.5042 2.04583 11.7583 2 12.025 2C12.2917 2 12.55 2.04583 12.8 2.1375C13.05 2.22917 13.2667 2.375 13.45 2.575L21.475 10.6C21.675 10.7833 21.8208 11 21.9125 11.25C22.0042 11.5 22.05 11.7583 22.05 12.025C22.05 12.2917 22.0042 12.5458 21.9125 12.7875C21.8208 13.0292 21.675 13.25 21.475 13.45L13.45 21.475C13.2667 21.6583 13.05 21.8 12.8 21.9C12.55 22 12.2917 22.05 12.025 22.05ZM11.025 13.025H13.025V7.025H11.025V13.025ZM12.025 16.025C12.3083 16.025 12.5458 15.9292 12.7375 15.7375C12.9292 15.5458 13.025 15.3083 13.025 15.025C13.025 14.7417 12.9292 14.5042 12.7375 14.3125C12.5458 14.1208 12.3083 14.025 12.025 14.025C11.7417 14.025 11.5042 14.1208 11.3125 14.3125C11.1208 14.5042 11.025 14.7417 11.025 15.025C11.025 15.3083 11.1208 15.5458 11.3125 15.7375C11.5042 15.9292 11.7417 16.025 12.025 16.025Z" fill="currentColor"/>', Lu = /* @__PURE__ */ se({
  __name: "WarningIcon",
  props: {
    /** The accessibility text provided to screen readers */
    title: {
      type: String,
      required: !1,
      default: ""
    },
    /** The icon color. Defaults to `currentColor` which inherits text color from the parent element */
    color: {
      type: String,
      required: !1,
      default: "currentColor"
    },
    /** The CSS display property for the icon. Defaults to `block` */
    display: {
      type: String,
      required: !1,
      default: "block"
    },
    /** Whether the icon is just eye-candy or is meaningful to the page (should screen-readers ignore the icon?) */
    decorative: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** The icon size */
    size: {
      type: [Number, String],
      required: !1,
      default: Te,
      // if setting to the imported const fails, just pass a number of 24 as the default.
      validator: (e) => {
        if (typeof e == "number" && e > 0)
          return !0;
        if (typeof e == "string") {
          const t = String(e).replace(/px/gi, ""), a = Number(t);
          if (a && !isNaN(a) && Number.isInteger(a) && a > 0)
            return !0;
        }
        return !1;
      }
    },
    /** The HTML tag to utilize for the icon's wrapper element. Defaults to `span` */
    as: {
      type: String,
      required: !1,
      default: "span"
    },
    /**
     * A boolean to disable prefixing any internal SVG ids with a unique string which is done to resolve the potential for multiple SVG instances on the same page and the SVG utilizing the same ids and references internally (e.g. in the `<defs>` tag).
     * Typically only set to `true` during snapshot testing.
     * Defaults to `false`.
     */
    staticIds: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const t = e, a = b(() => {
      if (typeof t.size == "number" && t.size > 0)
        return `${t.size}px`;
      if (typeof t.size == "string") {
        const l = String(t.size).replace(/px/gi, ""), s = Number(l);
        if (s && !isNaN(s) && Number.isInteger(s) && s > 0)
          return `${s}px`;
      }
      return Te;
    }), n = b(() => ({
      boxSizing: "border-box",
      color: t.color,
      display: t.display,
      flexShrink: "0",
      height: a.value,
      lineHeight: "0",
      width: a.value,
      pointerEvents: t.decorative ? "none" : void 0
    })), r = (l) => {
      const s = {}, d = Math.random().toString(36).substring(2, 12);
      return l.replace(/id="([^"]+)"/g, (c, f) => {
        const v = `${d}-${f}`;
        return s[f] = v, `id="${v}"`;
      }).replace(/#([^\s^")]+)/g, (c, f) => s[f] ? `#${s[f]}` : c);
    }, i = {
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "&": "&amp;"
    }, o = (l) => l.replace(/[<>"'&]/g, (s) => i[s]), u = `${t.title ? `<title data-testid="kui-icon-svg-title">${o(t.title)}</title>` : ""}${t.staticIds ? hc : r(hc)}`;
    return (l, s) => (y(), ee(Ye(e.as), {
      "aria-hidden": e.decorative ? "true" : void 0,
      class: "kui-icon warning-icon",
      "data-testid": "kui-icon-wrapper-warning-icon",
      style: Ee(n.value),
      tabindex: e.decorative ? "-1" : void 0
    }, {
      default: N(() => [
        (y(), S("svg", {
          "aria-hidden": e.decorative ? "true" : void 0,
          "data-testid": "kui-icon-svg-warning-icon",
          fill: "none",
          height: "100%",
          role: "img",
          viewBox: "0 0 24 24",
          width: "100%",
          xmlns: "http://www.w3.org/2000/svg",
          innerHTML: u
        }, null, 8, xy))
      ]),
      _: 1
    }, 8, ["aria-hidden", "style", "tabindex"]));
  }
}), Py = "#000933", Ny = "#00abd2", Jl = "#ffffff", Fa = "#6c7489", Ly = "#52596e", ch = "#afb7c5", fh = "#0044f4", By = "#995c00", Ca = "16px", Vt = "20px", Ry = "24px", Fy = "32px", zy = "20px", Yy = "4px", Hy = "8px", qy = "12px", vh = "16px", Wy = {
  key: 0,
  class: "alert-icon-container"
}, _y = { class: "alert-content" }, Uy = {
  key: 0,
  class: "alert-title"
}, Vy = {
  key: 1,
  class: "alert-message"
}, Ky = /* @__PURE__ */ se({
  __name: "KAlert",
  props: {
    title: { default: "" },
    message: { default: "" },
    appearance: { default: () => ti.info },
    showIcon: { type: Boolean },
    dismissible: { type: Boolean }
  },
  emits: ["dismiss"],
  setup(e, { emit: t }) {
    const a = t, n = b(() => {
      switch (e.appearance) {
        case ti.info:
          return In;
        case ti.success:
          return sh;
        case ti.warning:
          return Lu;
        case ti.danger:
          return sy;
        default:
          return In;
      }
    });
    return (r, i) => (y(), S("div", {
      class: ue(["k-alert", [r.appearance]])
    }, [
      r.showIcon || r.$slots.icon ? (y(), S("div", Wy, [
        j(r.$slots, "icon", {}, () => [
          (y(), ee(Ye(n.value), {
            class: "alert-icon",
            decorative: "",
            size: A(Vt)
          }, null, 8, ["size"]))
        ])
      ])) : W("", !0),
      H("div", _y, [
        r.title ? (y(), S("span", Uy, ae(r.title), 1)) : W("", !0),
        r.message || r.$slots.default ? (y(), S("div", Vy, [
          j(r.$slots, "default", {}, () => [
            H("p", null, ae(r.message), 1)
          ])
        ])) : W("", !0)
      ]),
      r.dismissible ? (y(), ee(A(va), {
        key: 1,
        class: "alert-dismiss-icon",
        size: A(Vt),
        tabindex: "0",
        onClick: i[0] || (i[0] = (o) => a("dismiss")),
        onKeydown: i[1] || (i[1] = lt(Ke(() => {
        }, ["prevent"]), ["space"])),
        onKeyup: [
          i[2] || (i[2] = lt((o) => a("dismiss"), ["enter"])),
          i[3] || (i[3] = lt((o) => a("dismiss"), ["space"]))
        ]
      }, null, 8, ["size"])) : W("", !0)
    ], 2));
  }
}), Me = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [n, r] of t)
    a[n] = r;
  return a;
}, jy = /* @__PURE__ */ Me(Ky, [["__scopeId", "data-v-44f11078"]]), Gy = ["top", "right", "bottom", "left"], gc = ["start", "end"], mc = /* @__PURE__ */ Gy.reduce((e, t) => e.concat(t, t + "-" + gc[0], t + "-" + gc[1]), []), as = Math.min, jn = Math.max, ns = Math.round, Ui = Math.floor, La = (e) => ({
  x: e,
  y: e
}), Qy = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Zy = {
  start: "end",
  end: "start"
};
function yc(e, t, a) {
  return jn(e, as(t, a));
}
function Ys(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function En(e) {
  return e.split("-")[0];
}
function An(e) {
  return e.split("-")[1];
}
function ph(e) {
  return e === "x" ? "y" : "x";
}
function hh(e) {
  return e === "y" ? "height" : "width";
}
const Xy = /* @__PURE__ */ new Set(["top", "bottom"]);
function _n(e) {
  return Xy.has(En(e)) ? "y" : "x";
}
function gh(e) {
  return ph(_n(e));
}
function mh(e, t, a) {
  a === void 0 && (a = !1);
  const n = An(e), r = gh(e), i = hh(r);
  let o = r === "x" ? n === (a ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = is(o)), [o, is(o)];
}
function Jy(e) {
  const t = is(e);
  return [rs(e), t, rs(t)];
}
function rs(e) {
  return e.replace(/start|end/g, (t) => Zy[t]);
}
const bc = ["left", "right"], wc = ["right", "left"], eb = ["top", "bottom"], tb = ["bottom", "top"];
function ab(e, t, a) {
  switch (e) {
    case "top":
    case "bottom":
      return a ? t ? wc : bc : t ? bc : wc;
    case "left":
    case "right":
      return t ? eb : tb;
    default:
      return [];
  }
}
function nb(e, t, a, n) {
  const r = An(e);
  let i = ab(En(e), a === "start", n);
  return r && (i = i.map((o) => o + "-" + r), t && (i = i.concat(i.map(rs)))), i;
}
function is(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Qy[t]);
}
function rb(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ib(e) {
  return typeof e != "number" ? rb(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function os(e) {
  const {
    x: t,
    y: a,
    width: n,
    height: r
  } = e;
  return {
    width: n,
    height: r,
    top: a,
    left: t,
    right: t + n,
    bottom: a + r,
    x: t,
    y: a
  };
}
function Cc(e, t, a) {
  let {
    reference: n,
    floating: r
  } = e;
  const i = _n(t), o = gh(t), u = hh(o), l = En(t), s = i === "y", d = n.x + n.width / 2 - r.width / 2, c = n.y + n.height / 2 - r.height / 2, f = n[u] / 2 - r[u] / 2;
  let v;
  switch (l) {
    case "top":
      v = {
        x: d,
        y: n.y - r.height
      };
      break;
    case "bottom":
      v = {
        x: d,
        y: n.y + n.height
      };
      break;
    case "right":
      v = {
        x: n.x + n.width,
        y: c
      };
      break;
    case "left":
      v = {
        x: n.x - r.width,
        y: c
      };
      break;
    default:
      v = {
        x: n.x,
        y: n.y
      };
  }
  switch (An(t)) {
    case "start":
      v[o] -= f * (a && s ? -1 : 1);
      break;
    case "end":
      v[o] += f * (a && s ? -1 : 1);
      break;
  }
  return v;
}
const ob = async (e, t, a) => {
  const {
    placement: n = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: o
  } = a, u = i.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let s = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: d,
    y: c
  } = Cc(s, n, l), f = n, v = {}, m = 0;
  for (let C = 0; C < u.length; C++) {
    const {
      name: p,
      fn: h
    } = u[C], {
      x: g,
      y: w,
      data: $,
      reset: T
    } = await h({
      x: d,
      y: c,
      initialPlacement: n,
      placement: f,
      strategy: r,
      middlewareData: v,
      rects: s,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = g ?? d, c = w ?? c, v = {
      ...v,
      [p]: {
        ...v[p],
        ...$
      }
    }, T && m <= 50 && (m++, typeof T == "object" && (T.placement && (f = T.placement), T.rects && (s = T.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : T.rects), {
      x: d,
      y: c
    } = Cc(s, f, l)), C = -1);
  }
  return {
    x: d,
    y: c,
    placement: f,
    strategy: r,
    middlewareData: v
  };
};
async function Bu(e, t) {
  var a;
  t === void 0 && (t = {});
  const {
    x: n,
    y: r,
    platform: i,
    rects: o,
    elements: u,
    strategy: l
  } = e, {
    boundary: s = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: c = "floating",
    altBoundary: f = !1,
    padding: v = 0
  } = Ys(t, e), m = ib(v), p = u[f ? c === "floating" ? "reference" : "floating" : c], h = os(await i.getClippingRect({
    element: (a = await (i.isElement == null ? void 0 : i.isElement(p))) == null || a ? p : p.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(u.floating)),
    boundary: s,
    rootBoundary: d,
    strategy: l
  })), g = c === "floating" ? {
    x: n,
    y: r,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, w = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u.floating)), $ = await (i.isElement == null ? void 0 : i.isElement(w)) ? await (i.getScale == null ? void 0 : i.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, T = os(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: u,
    rect: g,
    offsetParent: w,
    strategy: l
  }) : g);
  return {
    top: (h.top - T.top + m.top) / $.y,
    bottom: (T.bottom - h.bottom + m.bottom) / $.y,
    left: (h.left - T.left + m.left) / $.x,
    right: (T.right - h.right + m.right) / $.x
  };
}
function sb(e, t, a) {
  return (e ? [...a.filter((r) => An(r) === e), ...a.filter((r) => An(r) !== e)] : a.filter((r) => En(r) === r)).filter((r) => e ? An(r) === e || (t ? rs(r) !== r : !1) : !0);
}
const lb = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(t) {
      var a, n, r;
      const {
        rects: i,
        middlewareData: o,
        placement: u,
        platform: l,
        elements: s
      } = t, {
        crossAxis: d = !1,
        alignment: c,
        allowedPlacements: f = mc,
        autoAlignment: v = !0,
        ...m
      } = Ys(e, t), C = c !== void 0 || f === mc ? sb(c || null, v, f) : f, p = await Bu(t, m), h = ((a = o.autoPlacement) == null ? void 0 : a.index) || 0, g = C[h];
      if (g == null)
        return {};
      const w = mh(g, i, await (l.isRTL == null ? void 0 : l.isRTL(s.floating)));
      if (u !== g)
        return {
          reset: {
            placement: C[0]
          }
        };
      const $ = [p[En(g)], p[w[0]], p[w[1]]], T = [...((n = o.autoPlacement) == null ? void 0 : n.overflows) || [], {
        placement: g,
        overflows: $
      }], O = C[h + 1];
      if (O)
        return {
          data: {
            index: h + 1,
            overflows: T
          },
          reset: {
            placement: O
          }
        };
      const M = T.map((x) => {
        const Y = An(x.placement);
        return [x.placement, Y && d ? (
          // Check along the mainAxis and main crossAxis side.
          x.overflows.slice(0, 2).reduce((R, k) => R + k, 0)
        ) : (
          // Check only the mainAxis.
          x.overflows[0]
        ), x.overflows];
      }).sort((x, Y) => x[1] - Y[1]), q = ((r = M.filter((x) => x[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        An(x[0]) ? 2 : 3
      ).every((Y) => Y <= 0))[0]) == null ? void 0 : r[0]) || M[0][0];
      return q !== u ? {
        data: {
          index: h + 1,
          overflows: T
        },
        reset: {
          placement: q
        }
      } : {};
    }
  };
}, ub = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var a, n;
      const {
        placement: r,
        middlewareData: i,
        rects: o,
        initialPlacement: u,
        platform: l,
        elements: s
      } = t, {
        mainAxis: d = !0,
        crossAxis: c = !0,
        fallbackPlacements: f,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: C = !0,
        ...p
      } = Ys(e, t);
      if ((a = i.arrow) != null && a.alignmentOffset)
        return {};
      const h = En(r), g = _n(u), w = En(u) === u, $ = await (l.isRTL == null ? void 0 : l.isRTL(s.floating)), T = f || (w || !C ? [is(u)] : Jy(u)), O = m !== "none";
      !f && O && T.push(...nb(u, C, m, $));
      const M = [u, ...T], F = await Bu(t, p), q = [];
      let x = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (d && q.push(F[h]), c) {
        const P = mh(r, o, $);
        q.push(F[P[0]], F[P[1]]);
      }
      if (x = [...x, {
        placement: r,
        overflows: q
      }], !q.every((P) => P <= 0)) {
        var Y, R;
        const P = (((Y = i.flip) == null ? void 0 : Y.index) || 0) + 1, D = M[P];
        if (D && (!(c === "alignment" ? g !== _n(D) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        x.every((_) => _.overflows[0] > 0 && _n(_.placement) === g)))
          return {
            data: {
              index: P,
              overflows: x
            },
            reset: {
              placement: D
            }
          };
        let B = (R = x.filter((J) => J.overflows[0] <= 0).sort((J, _) => J.overflows[1] - _.overflows[1])[0]) == null ? void 0 : R.placement;
        if (!B)
          switch (v) {
            case "bestFit": {
              var k;
              const J = (k = x.filter((_) => {
                if (O) {
                  const te = _n(_.placement);
                  return te === g || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  te === "y";
                }
                return !0;
              }).map((_) => [_.placement, _.overflows.filter((te) => te > 0).reduce((te, G) => te + G, 0)]).sort((_, te) => _[1] - te[1])[0]) == null ? void 0 : k[0];
              J && (B = J);
              break;
            }
            case "initialPlacement":
              B = u;
              break;
          }
        if (r !== B)
          return {
            reset: {
              placement: B
            }
          };
      }
      return {};
    }
  };
}, db = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: a,
        y: n,
        placement: r
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: u = {
          fn: (p) => {
            let {
              x: h,
              y: g
            } = p;
            return {
              x: h,
              y: g
            };
          }
        },
        ...l
      } = Ys(e, t), s = {
        x: a,
        y: n
      }, d = await Bu(t, l), c = _n(En(r)), f = ph(c);
      let v = s[f], m = s[c];
      if (i) {
        const p = f === "y" ? "top" : "left", h = f === "y" ? "bottom" : "right", g = v + d[p], w = v - d[h];
        v = yc(g, v, w);
      }
      if (o) {
        const p = c === "y" ? "top" : "left", h = c === "y" ? "bottom" : "right", g = m + d[p], w = m - d[h];
        m = yc(g, m, w);
      }
      const C = u.fn({
        ...t,
        [f]: v,
        [c]: m
      });
      return {
        ...C,
        data: {
          x: C.x - a,
          y: C.y - n,
          enabled: {
            [f]: i,
            [c]: o
          }
        }
      };
    }
  };
};
function Hs() {
  return typeof window < "u";
}
function rr(e) {
  return Ru(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function sa(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Wa(e) {
  var t;
  return (t = (Ru(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ru(e) {
  return Hs() ? e instanceof Node || e instanceof sa(e).Node : !1;
}
function Sa(e) {
  return Hs() ? e instanceof Element || e instanceof sa(e).Element : !1;
}
function za(e) {
  return Hs() ? e instanceof HTMLElement || e instanceof sa(e).HTMLElement : !1;
}
function kc(e) {
  return !Hs() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof sa(e).ShadowRoot;
}
const cb = /* @__PURE__ */ new Set(["inline", "contents"]);
function Fi(e) {
  const {
    overflow: t,
    overflowX: a,
    overflowY: n,
    display: r
  } = Ta(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + a) && !cb.has(r);
}
const fb = /* @__PURE__ */ new Set(["table", "td", "th"]);
function vb(e) {
  return fb.has(rr(e));
}
const pb = [":popover-open", ":modal"];
function qs(e) {
  return pb.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const hb = ["transform", "translate", "scale", "rotate", "perspective"], gb = ["transform", "translate", "scale", "rotate", "perspective", "filter"], mb = ["paint", "layout", "strict", "content"];
function Fu(e) {
  const t = zu(), a = Sa(e) ? Ta(e) : e;
  return hb.some((n) => a[n] ? a[n] !== "none" : !1) || (a.containerType ? a.containerType !== "normal" : !1) || !t && (a.backdropFilter ? a.backdropFilter !== "none" : !1) || !t && (a.filter ? a.filter !== "none" : !1) || gb.some((n) => (a.willChange || "").includes(n)) || mb.some((n) => (a.contain || "").includes(n));
}
function yb(e) {
  let t = Mn(e);
  for (; za(t) && !Lr(t); ) {
    if (Fu(t))
      return t;
    if (qs(t))
      return null;
    t = Mn(t);
  }
  return null;
}
function zu() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const bb = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Lr(e) {
  return bb.has(rr(e));
}
function Ta(e) {
  return sa(e).getComputedStyle(e);
}
function Ws(e) {
  return Sa(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Mn(e) {
  if (rr(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    kc(e) && e.host || // Fallback.
    Wa(e)
  );
  return kc(t) ? t.host : t;
}
function yh(e) {
  const t = Mn(e);
  return Lr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : za(t) && Fi(t) ? t : yh(t);
}
function Ai(e, t, a) {
  var n;
  t === void 0 && (t = []), a === void 0 && (a = !0);
  const r = yh(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = sa(r);
  if (i) {
    const u = eu(o);
    return t.concat(o, o.visualViewport || [], Fi(r) ? r : [], u && a ? Ai(u) : []);
  }
  return t.concat(r, Ai(r, [], a));
}
function eu(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function bh(e) {
  const t = Ta(e);
  let a = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const r = za(e), i = r ? e.offsetWidth : a, o = r ? e.offsetHeight : n, u = ns(a) !== i || ns(n) !== o;
  return u && (a = i, n = o), {
    width: a,
    height: n,
    $: u
  };
}
function Yu(e) {
  return Sa(e) ? e : e.contextElement;
}
function Er(e) {
  const t = Yu(e);
  if (!za(t))
    return La(1);
  const a = t.getBoundingClientRect(), {
    width: n,
    height: r,
    $: i
  } = bh(t);
  let o = (i ? ns(a.width) : a.width) / n, u = (i ? ns(a.height) : a.height) / r;
  return (!o || !Number.isFinite(o)) && (o = 1), (!u || !Number.isFinite(u)) && (u = 1), {
    x: o,
    y: u
  };
}
const wb = /* @__PURE__ */ La(0);
function wh(e) {
  const t = sa(e);
  return !zu() || !t.visualViewport ? wb : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Cb(e, t, a) {
  return t === void 0 && (t = !1), !a || t && a !== sa(e) ? !1 : t;
}
function Zn(e, t, a, n) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  const r = e.getBoundingClientRect(), i = Yu(e);
  let o = La(1);
  t && (n ? Sa(n) && (o = Er(n)) : o = Er(e));
  const u = Cb(i, a, n) ? wh(i) : La(0);
  let l = (r.left + u.x) / o.x, s = (r.top + u.y) / o.y, d = r.width / o.x, c = r.height / o.y;
  if (i) {
    const f = sa(i), v = n && Sa(n) ? sa(n) : n;
    let m = f, C = eu(m);
    for (; C && n && v !== m; ) {
      const p = Er(C), h = C.getBoundingClientRect(), g = Ta(C), w = h.left + (C.clientLeft + parseFloat(g.paddingLeft)) * p.x, $ = h.top + (C.clientTop + parseFloat(g.paddingTop)) * p.y;
      l *= p.x, s *= p.y, d *= p.x, c *= p.y, l += w, s += $, m = sa(C), C = eu(m);
    }
  }
  return os({
    width: d,
    height: c,
    x: l,
    y: s
  });
}
function Hu(e, t) {
  const a = Ws(e).scrollLeft;
  return t ? t.left + a : Zn(Wa(e)).left + a;
}
function Ch(e, t, a) {
  a === void 0 && (a = !1);
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - (a ? 0 : (
    // RTL <body> scrollbar.
    Hu(e, n)
  )), i = n.top + t.scrollTop;
  return {
    x: r,
    y: i
  };
}
function kb(e) {
  let {
    elements: t,
    rect: a,
    offsetParent: n,
    strategy: r
  } = e;
  const i = r === "fixed", o = Wa(n), u = t ? qs(t.floating) : !1;
  if (n === o || u && i)
    return a;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = La(1);
  const d = La(0), c = za(n);
  if ((c || !c && !i) && ((rr(n) !== "body" || Fi(o)) && (l = Ws(n)), za(n))) {
    const v = Zn(n);
    s = Er(n), d.x = v.x + n.clientLeft, d.y = v.y + n.clientTop;
  }
  const f = o && !c && !i ? Ch(o, l, !0) : La(0);
  return {
    width: a.width * s.x,
    height: a.height * s.y,
    x: a.x * s.x - l.scrollLeft * s.x + d.x + f.x,
    y: a.y * s.y - l.scrollTop * s.y + d.y + f.y
  };
}
function $b(e) {
  return Array.from(e.getClientRects());
}
function Sb(e) {
  const t = Wa(e), a = Ws(e), n = e.ownerDocument.body, r = jn(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = jn(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let o = -a.scrollLeft + Hu(e);
  const u = -a.scrollTop;
  return Ta(n).direction === "rtl" && (o += jn(t.clientWidth, n.clientWidth) - r), {
    width: r,
    height: i,
    x: o,
    y: u
  };
}
function Tb(e, t) {
  const a = sa(e), n = Wa(e), r = a.visualViewport;
  let i = n.clientWidth, o = n.clientHeight, u = 0, l = 0;
  if (r) {
    i = r.width, o = r.height;
    const s = zu();
    (!s || s && t === "fixed") && (u = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: u,
    y: l
  };
}
const Db = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Ab(e, t) {
  const a = Zn(e, !0, t === "fixed"), n = a.top + e.clientTop, r = a.left + e.clientLeft, i = za(e) ? Er(e) : La(1), o = e.clientWidth * i.x, u = e.clientHeight * i.y, l = r * i.x, s = n * i.y;
  return {
    width: o,
    height: u,
    x: l,
    y: s
  };
}
function $c(e, t, a) {
  let n;
  if (t === "viewport")
    n = Tb(e, a);
  else if (t === "document")
    n = Sb(Wa(e));
  else if (Sa(t))
    n = Ab(t, a);
  else {
    const r = wh(e);
    n = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return os(n);
}
function kh(e, t) {
  const a = Mn(e);
  return a === t || !Sa(a) || Lr(a) ? !1 : Ta(a).position === "fixed" || kh(a, t);
}
function Ib(e, t) {
  const a = t.get(e);
  if (a)
    return a;
  let n = Ai(e, [], !1).filter((u) => Sa(u) && rr(u) !== "body"), r = null;
  const i = Ta(e).position === "fixed";
  let o = i ? Mn(e) : e;
  for (; Sa(o) && !Lr(o); ) {
    const u = Ta(o), l = Fu(o);
    !l && u.position === "fixed" && (r = null), (i ? !l && !r : !l && u.position === "static" && !!r && Db.has(r.position) || Fi(o) && !l && kh(e, o)) ? n = n.filter((d) => d !== o) : r = u, o = Mn(o);
  }
  return t.set(e, n), n;
}
function Eb(e) {
  let {
    element: t,
    boundary: a,
    rootBoundary: n,
    strategy: r
  } = e;
  const o = [...a === "clippingAncestors" ? qs(t) ? [] : Ib(t, this._c) : [].concat(a), n], u = o[0], l = o.reduce((s, d) => {
    const c = $c(t, d, r);
    return s.top = jn(c.top, s.top), s.right = as(c.right, s.right), s.bottom = as(c.bottom, s.bottom), s.left = jn(c.left, s.left), s;
  }, $c(t, u, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Mb(e) {
  const {
    width: t,
    height: a
  } = bh(e);
  return {
    width: t,
    height: a
  };
}
function Ob(e, t, a) {
  const n = za(t), r = Wa(t), i = a === "fixed", o = Zn(e, !0, i, t);
  let u = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = La(0);
  function s() {
    l.x = Hu(r);
  }
  if (n || !n && !i)
    if ((rr(t) !== "body" || Fi(r)) && (u = Ws(t)), n) {
      const v = Zn(t, !0, i, t);
      l.x = v.x + t.clientLeft, l.y = v.y + t.clientTop;
    } else r && s();
  i && !n && r && s();
  const d = r && !n && !i ? Ch(r, u) : La(0), c = o.left + u.scrollLeft - l.x - d.x, f = o.top + u.scrollTop - l.y - d.y;
  return {
    x: c,
    y: f,
    width: o.width,
    height: o.height
  };
}
function dl(e) {
  return Ta(e).position === "static";
}
function Sc(e, t) {
  if (!za(e) || Ta(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let a = e.offsetParent;
  return Wa(e) === a && (a = a.ownerDocument.body), a;
}
function $h(e, t) {
  const a = sa(e);
  if (qs(e))
    return a;
  if (!za(e)) {
    let r = Mn(e);
    for (; r && !Lr(r); ) {
      if (Sa(r) && !dl(r))
        return r;
      r = Mn(r);
    }
    return a;
  }
  let n = Sc(e, t);
  for (; n && vb(n) && dl(n); )
    n = Sc(n, t);
  return n && Lr(n) && dl(n) && !Fu(n) ? a : n || yb(e) || a;
}
const xb = async function(e) {
  const t = this.getOffsetParent || $h, a = this.getDimensions, n = await a(e.floating);
  return {
    reference: Ob(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Pb(e) {
  return Ta(e).direction === "rtl";
}
const Nb = {
  convertOffsetParentRelativeRectToViewportRelativeRect: kb,
  getDocumentElement: Wa,
  getClippingRect: Eb,
  getOffsetParent: $h,
  getElementRects: xb,
  getClientRects: $b,
  getDimensions: Mb,
  getScale: Er,
  isElement: Sa,
  isRTL: Pb
};
function Sh(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Lb(e, t) {
  let a = null, n;
  const r = Wa(e);
  function i() {
    var u;
    clearTimeout(n), (u = a) == null || u.disconnect(), a = null;
  }
  function o(u, l) {
    u === void 0 && (u = !1), l === void 0 && (l = 1), i();
    const s = e.getBoundingClientRect(), {
      left: d,
      top: c,
      width: f,
      height: v
    } = s;
    if (u || t(), !f || !v)
      return;
    const m = Ui(c), C = Ui(r.clientWidth - (d + f)), p = Ui(r.clientHeight - (c + v)), h = Ui(d), w = {
      rootMargin: -m + "px " + -C + "px " + -p + "px " + -h + "px",
      threshold: jn(0, as(1, l)) || 1
    };
    let $ = !0;
    function T(O) {
      const M = O[0].intersectionRatio;
      if (M !== l) {
        if (!$)
          return o();
        M ? o(!1, M) : n = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      M === 1 && !Sh(s, e.getBoundingClientRect()) && o(), $ = !1;
    }
    try {
      a = new IntersectionObserver(T, {
        ...w,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      a = new IntersectionObserver(T, w);
    }
    a.observe(e);
  }
  return o(!0), i;
}
function Bb(e, t, a, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: u = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, s = Yu(e), d = r || i ? [...s ? Ai(s) : [], ...Ai(t)] : [];
  d.forEach((h) => {
    r && h.addEventListener("scroll", a, {
      passive: !0
    }), i && h.addEventListener("resize", a);
  });
  const c = s && u ? Lb(s, a) : null;
  let f = -1, v = null;
  o && (v = new ResizeObserver((h) => {
    let [g] = h;
    g && g.target === s && v && (v.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var w;
      (w = v) == null || w.observe(t);
    })), a();
  }), s && !l && v.observe(s), v.observe(t));
  let m, C = l ? Zn(e) : null;
  l && p();
  function p() {
    const h = Zn(e);
    C && !Sh(C, h) && a(), C = h, m = requestAnimationFrame(p);
  }
  return a(), () => {
    var h;
    d.forEach((g) => {
      r && g.removeEventListener("scroll", a), i && g.removeEventListener("resize", a);
    }), c == null || c(), (h = v) == null || h.disconnect(), v = null, l && cancelAnimationFrame(m);
  };
}
const Rb = lb, Fb = db, zb = ub, Yb = (e, t, a) => {
  const n = /* @__PURE__ */ new Map(), r = {
    platform: Nb,
    ...a
  }, i = {
    ...r.platform,
    _c: n
  };
  return ob(e, t, {
    ...r,
    platform: i
  });
};
function Hb(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Tc(e) {
  if (Hb(e)) {
    const t = e.$el;
    return Ru(t) && rr(t) === "#comment" ? null : t;
  }
  return e;
}
function ai(e) {
  return typeof e == "function" ? e() : A(e);
}
function Th(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Dc(e, t) {
  const a = Th(e);
  return Math.round(t * a) / a;
}
function qb(e, t, a) {
  a === void 0 && (a = {});
  const n = a.whileElementsMounted, r = b(() => {
    var M;
    return (M = ai(a.open)) != null ? M : !0;
  }), i = b(() => ai(a.middleware)), o = b(() => {
    var M;
    return (M = ai(a.placement)) != null ? M : "bottom";
  }), u = b(() => {
    var M;
    return (M = ai(a.strategy)) != null ? M : "absolute";
  }), l = b(() => {
    var M;
    return (M = ai(a.transform)) != null ? M : !0;
  }), s = b(() => Tc(e.value)), d = b(() => Tc(t.value)), c = L(0), f = L(0), v = L(u.value), m = L(o.value), C = jp({}), p = L(!1), h = b(() => {
    const M = {
      position: v.value,
      left: "0",
      top: "0"
    };
    if (!d.value)
      return M;
    const F = Dc(d.value, c.value), q = Dc(d.value, f.value);
    return l.value ? {
      ...M,
      transform: "translate(" + F + "px, " + q + "px)",
      ...Th(d.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: v.value,
      left: F + "px",
      top: q + "px"
    };
  });
  let g;
  function w() {
    if (s.value == null || d.value == null)
      return;
    const M = r.value;
    Yb(s.value, d.value, {
      middleware: i.value,
      placement: o.value,
      strategy: u.value
    }).then((F) => {
      c.value = F.x, f.value = F.y, v.value = F.strategy, m.value = F.placement, C.value = F.middlewareData, p.value = M !== !1;
    });
  }
  function $() {
    typeof g == "function" && (g(), g = void 0);
  }
  function T() {
    if ($(), n === void 0) {
      w();
      return;
    }
    if (s.value != null && d.value != null) {
      g = n(s.value, d.value, w);
      return;
    }
  }
  function O() {
    r.value || (p.value = !1);
  }
  return ne([i, o, u, r], w, {
    flush: "sync"
  }), ne([s, d], T, {
    flush: "sync"
  }), ne(r, O, {
    flush: "sync"
  }), Gp() && Qp($), {
    x: vr(c),
    y: vr(f),
    strategy: vr(v),
    placement: vr(m),
    middlewareData: vr(C),
    isPositioned: vr(p),
    floatingStyles: h,
    update: w
  };
}
const Wb = {
  inheritAttrs: !1
}, _b = /* @__PURE__ */ se({
  ...Wb,
  __name: "KButton",
  props: {
    appearance: { default: "primary" },
    size: { default: "medium" },
    to: { default: null },
    type: { default: "button" },
    disabled: { type: Boolean },
    icon: { type: Boolean }
  },
  setup(e) {
    ne(() => e.icon, (s) => {
      typeof s == "string" && console.warn("KButton: `icon` prop usage has changed. Please refer to the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kbutton");
    }, { immediate: !0 });
    const t = Tt(), a = ea(), n = b(() => e.to && typeof e.to == "string" ? "a" : e.to ? "router-link" : "button"), r = b(() => Object.values(B1).indexOf(e.appearance) === -1 ? ["primary", e.appearance] : e.appearance), i = b(() => e.appearance === "none" && !e.icon ? null : e.size), o = b(() => {
      const s = Object.assign({}, a);
      return e.to && (typeof e.to == "string" ? s.href = e.to : s.to = e.to, e.disabled && (s.href = null)), e.disabled !== void 0 && e.disabled !== !1 || delete s.disabled, s;
    }), u = (s) => {
      s.preventDefault(), s.stopPropagation();
    }, l = b(() => !e.disabled || n.value === "button" ? {} : {
      clickCapture: u,
      dblclickCapture: u,
      mousedownCapture: u,
      mouseupCapture: u
    });
    return rt(() => {
      t.icon && console.warn("KButton: `icon` slot is deprecated. Please slot an icon into the `default` slot instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kbutton");
    }), (s, d) => (y(), ee(Ye(n.value), Fe({
      class: ["k-button", [i.value, r.value, { "icon-button": s.icon === !0 || !t.default && t.icon }]],
      disabled: s.disabled ? s.disabled : void 0,
      tabindex: s.disabled && n.value !== "button" ? "-1" : void 0,
      type: s.type
    }, o.value, Bs(l.value)), {
      default: N(() => [
        j(s.$slots, "icon", {}, void 0, !0),
        j(s.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["class", "disabled", "tabindex", "type"]));
  }
}), nt = /* @__PURE__ */ Me(_b, [["__scopeId", "data-v-3ba3c07b"]]), Ub = /* @__PURE__ */ se({
  __name: "KPopTeleportWrapper",
  props: {
    useTeleport: { type: Boolean },
    target: { default: null }
  },
  setup(e) {
    return (t, a) => t.useTeleport ? (y(), ee(I1, {
      key: 0,
      to: t.target
    }, [
      j(t.$slots, "default")
    ], 8, ["to"])) : j(t.$slots, "default", { key: 1 });
  }
});
function Dh(e) {
  return Gp() ? (Qp(e), !0) : !1;
}
const Ah = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Vb = Object.prototype.toString, Kb = (e) => Vb.call(e) === "[object Object]", pr = () => {
}, jb = /* @__PURE__ */ Gb();
function Gb() {
  var e, t;
  return Ah && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function cl(e) {
  return Array.isArray(e) ? e : [e];
}
function Qb(e, t, a) {
  return ne(
    e,
    t,
    {
      ...a,
      immediate: !0
    }
  );
}
const _s = Ah ? window : void 0;
function Un(e) {
  var t;
  const a = Dn(e);
  return (t = a == null ? void 0 : a.$el) != null ? t : a;
}
function ia(...e) {
  const t = [], a = () => {
    t.forEach((u) => u()), t.length = 0;
  }, n = (u, l, s, d) => (u.addEventListener(l, s, d), () => u.removeEventListener(l, s, d)), r = b(() => {
    const u = cl(Dn(e[0])).filter((l) => l != null);
    return u.every((l) => typeof l != "string") ? u : void 0;
  }), i = Qb(
    () => {
      var u, l;
      return [
        (l = (u = r.value) == null ? void 0 : u.map((s) => Un(s))) != null ? l : [_s].filter((s) => s != null),
        cl(Dn(r.value ? e[1] : e[0])),
        cl(A(r.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        Dn(r.value ? e[3] : e[2])
      ];
    },
    ([u, l, s, d]) => {
      if (a(), !(u != null && u.length) || !(l != null && l.length) || !(s != null && s.length))
        return;
      const c = Kb(d) ? { ...d } : d;
      t.push(
        ...u.flatMap(
          (f) => l.flatMap(
            (v) => s.map((m) => n(f, v, m, c))
          )
        )
      );
    },
    { flush: "post" }
  ), o = () => {
    i(), a();
  };
  return Dh(a), o;
}
let Ac = !1;
function Zb(e, t, a = {}) {
  const { window: n = _s, ignore: r = [], capture: i = !0, detectIframe: o = !1, controls: u = !1 } = a;
  if (!n)
    return u ? { stop: pr, cancel: pr, trigger: pr } : pr;
  if (jb && !Ac) {
    Ac = !0;
    const p = { passive: !0 };
    Array.from(n.document.body.children).forEach((h) => ia(h, "click", pr, p)), ia(n.document.documentElement, "click", pr, p);
  }
  let l = !0;
  const s = (p) => Dn(r).some((h) => {
    if (typeof h == "string")
      return Array.from(n.document.querySelectorAll(h)).some((g) => g === p.target || p.composedPath().includes(g));
    {
      const g = Un(h);
      return g && (p.target === g || p.composedPath().includes(g));
    }
  });
  function d(p) {
    const h = Dn(p);
    return h && h.$.subTree.shapeFlag === 16;
  }
  function c(p, h) {
    const g = Dn(p), w = g.$.subTree && g.$.subTree.children;
    return w == null || !Array.isArray(w) ? !1 : w.some(($) => $.el === h.target || h.composedPath().includes($.el));
  }
  const f = (p) => {
    const h = Un(e);
    if (p.target != null && !(!(h instanceof Element) && d(e) && c(e, p)) && !(!h || h === p.target || p.composedPath().includes(h))) {
      if ("detail" in p && p.detail === 0 && (l = !s(p)), !l) {
        l = !0;
        return;
      }
      t(p);
    }
  };
  let v = !1;
  const m = [
    ia(n, "click", (p) => {
      v || (v = !0, setTimeout(() => {
        v = !1;
      }, 0), f(p));
    }, { passive: !0, capture: i }),
    ia(n, "pointerdown", (p) => {
      const h = Un(e);
      l = !s(p) && !!(h && !p.composedPath().includes(h));
    }, { passive: !0 }),
    o && ia(n, "blur", (p) => {
      setTimeout(() => {
        var h;
        const g = Un(e);
        ((h = n.document.activeElement) == null ? void 0 : h.tagName) === "IFRAME" && !(g != null && g.contains(n.document.activeElement)) && t(p);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), C = () => m.forEach((p) => p());
  return u ? {
    stop: C,
    cancel: () => {
      l = !1;
    },
    trigger: (p) => {
      l = !0, f(p), l = !1;
    }
  } : C;
}
function Xb() {
  const e = jp(!1), t = Zp();
  return t && rt(() => {
    e.value = !0;
  }, t), e;
}
function Jb(e) {
  const t = Xb();
  return b(() => (t.value, !!e()));
}
function e0(e, t, a = {}) {
  const { window: n = _s, ...r } = a;
  let i;
  const o = Jb(() => n && "ResizeObserver" in n), u = () => {
    i && (i.disconnect(), i = void 0);
  }, l = b(() => {
    const c = Dn(e);
    return Array.isArray(c) ? c.map((f) => Un(f)) : [Un(c)];
  }), s = ne(
    l,
    (c) => {
      if (u(), o.value && n) {
        i = new ResizeObserver(t);
        for (const f of c)
          f && i.observe(f, r);
      }
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    u(), s();
  };
  return Dh(d), {
    isSupported: o,
    stop: d
  };
}
function t0(e) {
  var t;
  const a = (t = e.rangeCount) != null ? t : 0;
  return Array.from({ length: a }, (n, r) => e.getRangeAt(r));
}
function a0(e = {}) {
  const {
    window: t = _s
  } = e, a = L(null), n = b(() => {
    var u, l;
    return (l = (u = a.value) == null ? void 0 : u.toString()) != null ? l : "";
  }), r = b(() => a.value ? t0(a.value) : []), i = b(() => r.value.map((u) => u.getBoundingClientRect()));
  function o() {
    a.value = null, t && (a.value = t.getSelection());
  }
  return t && ia(t.document, "selectionchange", o, { passive: !0 }), {
    text: n,
    rects: i,
    ranges: r,
    selection: a
  };
}
const Dt = (e) => {
  const t = Number(e);
  return Number.isNaN(t) ? `${e}` : `${t}px`;
}, n0 = ["id", "aria-labelledby", "x-placement"], r0 = ["tabindex"], i0 = {
  key: 1,
  class: "popover-header"
}, o0 = ["id"], s0 = {
  key: 2,
  class: "popover-footer"
}, l0 = /* @__PURE__ */ se({
  __name: "KPop",
  props: {
    buttonText: { default: "" },
    title: { default: "" },
    placement: { default: "auto" },
    trigger: { default: "click" },
    popoverTimeout: { default: 300 },
    hideCloseIcon: { type: Boolean },
    hideCaret: { type: Boolean },
    closeOnPopoverClick: { type: Boolean },
    disabled: { type: Boolean },
    width: { default: "200px" },
    maxWidth: { default: "none" },
    maxHeight: { default: "none" },
    popoverClasses: { default: "" },
    tag: { default: "div" },
    zIndex: { default: 1e3 },
    offset: { default: () => vh },
    target: { default: null }
  },
  emits: ["open", "close", "popover-click"],
  setup(e, { expose: t, emit: a }) {
    const n = a, r = Tt(), i = bt(), o = bt(), u = L(null), l = L(null), s = L(null), d = L(!1), c = b(() => {
      var k, P;
      return l.value && ((k = l.value) != null && k.children[0]) ? (P = l.value) == null ? void 0 : P.children[0] : null;
    }), f = L(null), v = () => {
      d.value ? h() : p();
    }, m = () => {
      R.value && R.value();
    }, C = () => {
      m(), c.value && s.value && (R.value = Bb(c.value, s.value, O));
    }, p = async () => {
      e.disabled || (f.value && clearTimeout(f.value), C(), d.value = !0);
    }, h = () => {
      f.value = setTimeout(() => {
        m(), d.value = !1;
      }, e.trigger === "hover" ? e.popoverTimeout : 0);
    }, g = (k) => {
      var D, B, J, _, te;
      const P = k.target;
      (D = c.value) != null && D.contains(P) && !((B = s.value) != null && B.contains(P)) ? v() : (J = s.value) != null && J.contains(P) && !((_ = l.value) != null && _.contains(P)) ? (e.closeOnPopoverClick && h(), n("popover-click")) : d.value && !((te = u.value) != null && te.contains(P)) && h();
    }, w = b(() => e.placement.trim().replace(/ /g, "-").replace(/[A-Z]+(?![a-z])|[A-Z]/g, (k, P) => (P ? "-" : "") + k.toLowerCase()).replace(/--+/g, "-").replace(/-+$/g, "")), { floatingStyles: $, placement: T, update: O } = qb(c, s, {
      ...w.value === "auto" && { middleware: [Rb()] },
      // when placement is auto just use autoPlacement middleware
      ...w.value !== "auto" && {
        placement: w.value,
        middleware: [
          Fb(),
          // Shifts the floating element to keep it in view.
          zb()
          // Changes the placement of the floating element to keep it in view.
        ]
      },
      strategy: "fixed",
      transform: !1
    }), M = b(() => Dt(e.offset)), F = b(() => T.value.includes("top") ? {
      marginBottom: M.value
    } : T.value.includes("bottom") ? {
      marginTop: M.value
    } : T.value.includes("right") ? {
      marginLeft: M.value
    } : T.value.includes("left") ? {
      marginRight: M.value
    } : {}), q = b(() => ({
      ...$.value,
      zIndex: e.zIndex
    })), x = b(() => ({
      ...F.value,
      width: Dt(e.width),
      maxWidth: Dt(e.maxWidth),
      maxHeight: Dt(e.maxHeight)
    })), Y = b(() => [e.popoverClasses, { "hide-caret": e.hideCaret }]), R = L();
    return t({
      hidePopover: h,
      showPopover: p
    }), rt(() => {
      if (document) {
        if (ia(document, "click", g), c.value) {
          const k = c.value.querySelector('button[data-dropdown-trigger="true"]') || c.value;
          k.hasAttribute("aria-controls") || k.setAttribute("aria-controls", i);
        }
        e.trigger === "hover" && [s.value, c.value].forEach((k) => {
          k && (ia(k, "mouseenter", p), ia(k, "focusin", p), ia(k, "mouseleave", h), ia(k, "focusout", h));
        });
      }
    }), cn(() => {
      m();
    }), ne(d, (k) => {
      n(k ? "open" : "close");
    }), (k, P) => (y(), ee(Ye(k.tag), {
      ref_key: "kPopoverElement",
      ref: u,
      class: "k-popover",
      onKeydown: lt(Ke(h, ["stop"]), ["esc"])
    }, {
      default: N(() => [
        H("div", {
          ref_key: "triggerWrapperElement",
          ref: l,
          class: "popover-trigger-wrapper"
        }, [
          j(k.$slots, "default", {}, () => [
            Z(nt, {
              "aria-controls": A(i),
              "data-testid": "popover-button"
            }, {
              default: N(() => [
                be(ae(k.buttonText), 1)
              ]),
              _: 1
            }, 8, ["aria-controls"])
          ], !0)
        ], 512),
        Z(Ub, {
          target: k.target,
          "use-teleport": !!k.target
        }, {
          default: N(() => [
            Z(Zt, { name: "kongponents-fade-transition" }, {
              default: N(() => [
                $a(H("div", {
                  id: A(i),
                  ref_key: "popoverElement",
                  ref: s,
                  "aria-labelledby": r.title || k.title ? A(o) : void 0,
                  class: ue(["popover", Y.value]),
                  role: "dialog",
                  style: Ee(q.value),
                  "x-placement": A(T)
                }, [
                  H("div", {
                    class: "popover-container",
                    style: Ee(x.value)
                  }, [
                    k.hideCloseIcon ? W("", !0) : (y(), S("button", {
                      key: 0,
                      ref: "popoverCloseButton",
                      "aria-label": "Close popover",
                      class: "popover-close-button",
                      tabindex: d.value ? 0 : -1,
                      type: "button",
                      onClick: h
                    }, [
                      Z(A(va), {
                        class: "popover-close-icon",
                        decorative: "",
                        size: A(Ca)
                      }, null, 8, ["size"])
                    ], 8, r0)),
                    r.title || k.title ? (y(), S("div", i0, [
                      r.title || k.title ? (y(), S("div", {
                        key: 0,
                        id: A(o),
                        class: ue(["popover-title", { "close-icon-spacing": !k.hideCloseIcon }])
                      }, [
                        j(k.$slots, "title", {}, () => [
                          be(ae(k.title), 1)
                        ], !0)
                      ], 10, o0)) : W("", !0)
                    ])) : W("", !0),
                    H("div", {
                      class: ue(["popover-content", { "close-icon-spacing": !k.hideCloseIcon && !(r.title || k.title) }])
                    }, [
                      j(k.$slots, "content", {}, void 0, !0)
                    ], 2),
                    r.footer ? (y(), S("div", s0, [
                      j(k.$slots, "footer", {}, void 0, !0)
                    ])) : W("", !0)
                  ], 4)
                ], 14, n0), [
                  [Nr, d.value]
                ])
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["target", "use-teleport"])
      ]),
      _: 3
    }, 40, ["onKeydown"]));
  }
}), ir = /* @__PURE__ */ Me(l0, [["__scopeId", "data-v-b25b7710"]]), u0 = ["id"], ga = /* @__PURE__ */ se({
  inheritAttrs: !1,
  __name: "KTooltip",
  props: {
    text: { default: "" },
    placement: { default: "bottom" },
    maxWidth: { default: "none" },
    label: { default: "" },
    tooltipId: { default: "" },
    zIndex: { default: 9999 },
    kpopAttributes: { default: () => ({}) },
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = Tt(), a = b(() => !e.disabled && (!!e.text || !!e.label || !!t.content)), n = bt();
    return (r, i) => a.value ? (y(), ee(ir, Fe({
      key: 0,
      "hide-caret": "",
      "hide-close-icon": "",
      "max-width": r.maxWidth,
      offset: A(Yy),
      placement: r.placement,
      "popover-classes": "k-tooltip",
      "popover-timeout": 100,
      trigger: "hover",
      width: "auto",
      "z-index": r.zIndex
    }, { ...r.$attrs, ...r.kpopAttributes }), {
      content: N(() => [
        H("div", {
          id: r.tooltipId || A(n),
          role: "tooltip"
        }, [
          j(r.$slots, "content", {
            label: r.text || r.label
          }, () => [
            be(ae(r.text || r.label), 1)
          ])
        ], 8, u0)
      ]),
      default: N(() => [
        j(r.$slots, "default")
      ]),
      _: 3
    }, 16, ["max-width", "offset", "placement", "z-index"])) : j(r.$slots, "default", { key: 1 });
  }
}), d0 = ["tabindex"], c0 = /* @__PURE__ */ se({
  __name: "KBadge",
  props: {
    appearance: { default: "info" },
    size: { default: "medium" },
    tooltip: { default: "" },
    truncationTooltip: { type: Boolean, default: !1 },
    maxWidth: { default: "200px" },
    iconBefore: { type: Boolean, default: !0 },
    tooltipAttributes: { default: () => ({}) }
  },
  setup(e) {
    Yt((u) => ({
      "815b0bb8": r.value
    }));
    const t = b(() => Object.keys(rh).includes(e.appearance)), a = L(), n = L(!1), r = b(() => Dt(e.maxWidth)), i = async () => {
      var u, l;
      a.value && (await gt(), n.value = ((u = a.value) == null ? void 0 : u.offsetWidth) < ((l = a.value) == null ? void 0 : l.scrollWidth));
    }, o = b(() => e.tooltip ? e.truncationTooltip ? n.value : !0 : !1);
    return rt(() => {
      i();
    }), (u, l) => (y(), S("div", {
      class: ue(["k-badge", [u.appearance, u.size, { method: t.value }]])
    }, [
      Z(ga, Fe({
        text: o.value ? u.tooltip : void 0
      }, u.tooltipAttributes), {
        default: N(() => [
          H("div", {
            class: ue(["badge-content", { "icon-after": !u.iconBefore }]),
            tabindex: o.value ? 0 : void 0
          }, [
            u.$slots.icon ? j(u.$slots, "icon", { key: 0 }, void 0, !0) : W("", !0),
            H("div", {
              ref_key: "badgeTextElement",
              ref: a,
              class: "badge-content-wrapper"
            }, [
              j(u.$slots, "default", {}, void 0, !0)
            ], 512)
          ], 10, d0)
        ]),
        _: 3
      }, 16, ["text"])
    ], 2));
  }
}), fi = /* @__PURE__ */ Me(c0, [["__scopeId", "data-v-56e217c6"]]), f0 = {
  key: 0,
  class: "breadcrumbs-icon-container"
}, v0 = {
  key: 0,
  class: "breadcrumbs-divider"
}, p0 = /* @__PURE__ */ se({
  inheritAttrs: !1,
  __name: "KBreadcrumbs",
  props: {
    items: {},
    itemMaxWidth: { default: "100px" }
  },
  setup(e) {
    const t = (n) => {
      const r = n.title || n.text;
      return n.to ? typeof n.to == "object" ? {
        type: "router-link",
        attrs: {
          title: r,
          to: n.to
        }
      } : {
        type: "a",
        attrs: {
          href: n.to,
          title: r
        }
      } : {
        type: "div",
        attrs: {
          title: r
        }
      };
    }, a = (n, r) => n.key || `breadcrumb-${r}`;
    return (n, r) => (y(), S("ul", Fe({ class: "k-breadcrumbs" }, n.$attrs), [
      (y(!0), S(Ae, null, Le(n.items, (i, o) => (y(), S("li", {
        key: a(i, o),
        class: "breadcrumbs-item-container"
      }, [
        (y(), ee(Ye(t(i).type), Fe({ ref_for: !0 }, t(i).attrs, {
          class: ["breadcrumbs-item", { link: !!i.to, active: o === n.items.length - 1 }]
        }), {
          default: N(() => [
            n.$slots[`icon-${a(i, o)}`] ? (y(), S("span", f0, [
              j(n.$slots, `icon-${a(i, o)}`, {}, void 0, !0)
            ])) : W("", !0),
            i.text ? (y(), S("span", {
              key: 1,
              class: "breadcrumbs-text",
              style: Ee({ maxWidth: A(Dt)(i.maxWidth ?? n.itemMaxWidth) })
            }, ae(i.text), 5)) : W("", !0)
          ]),
          _: 2
        }, 1040, ["class"])),
        o < n.items.length - 1 ? (y(), S("span", v0, [
          j(n.$slots, "divider", {}, () => [
            r[0] || (r[0] = be(" / "))
          ], !0)
        ])) : W("", !0)
      ]))), 128))
    ], 16));
  }
}), h0 = /* @__PURE__ */ Me(p0, [["__scopeId", "data-v-b4649555"]]), g0 = { class: "k-card" }, m0 = {
  key: 0,
  class: "card-header"
}, y0 = {
  key: 1,
  class: "card-actions"
}, b0 = {
  key: 1,
  class: "card-content"
}, w0 = {
  key: 2,
  class: "card-footer"
}, C0 = /* @__PURE__ */ se({
  __name: "KCard",
  props: {
    title: { default: "" },
    titleTag: { default: "div" }
  },
  setup(e) {
    const t = Tt(), a = b(() => !!(t.title || e.title || t.actions));
    return (n, r) => (y(), S("div", g0, [
      a.value ? (y(), S("div", m0, [
        t.title || n.title ? (y(), ee(Ye(n.titleTag), {
          key: 0,
          class: "card-title"
        }, {
          default: N(() => [
            j(n.$slots, "title", {}, () => [
              be(ae(n.title), 1)
            ], !0)
          ]),
          _: 3
        })) : W("", !0),
        t.actions ? (y(), S("div", y0, [
          j(n.$slots, "actions", {}, void 0, !0)
        ])) : W("", !0)
      ])) : W("", !0),
      t.default ? (y(), S("div", b0, [
        j(n.$slots, "default", {}, void 0, !0)
      ])) : W("", !0),
      t.footer ? (y(), S("div", w0, [
        j(n.$slots, "footer", {}, void 0, !0)
      ])) : W("", !0)
    ]));
  }
}), Ih = /* @__PURE__ */ Me(C0, [["__scopeId", "data-v-ee47edc8"]]);
var fl = /* @__PURE__ */ new WeakMap(), Ic = 0;
function k0(e) {
  if (!e.length)
    return "";
  for (var t = "arg", a = 0; a < e.length; ++a) {
    var n = void 0;
    e[a] === null || typeof e[a] != "object" && typeof e[a] != "function" ? typeof e[a] == "string" ? n = '"' + e[a] + '"' : n = String(e[a]) : fl.has(e[a]) ? n = fl.get(e[a]) : (n = Ic, fl.set(e[a], Ic++)), t += "@" + n;
  }
  return t;
}
function $0(e) {
  if (typeof e == "function")
    try {
      e = e();
    } catch {
      e = "";
    }
  return Array.isArray(e) ? e = k0(e) : e = String(e || ""), e;
}
var qu = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = 0), this.items = /* @__PURE__ */ new Map(), this.ttl = t;
    }
    return e.prototype.serializeKey = function(t) {
      return $0(t);
    }, e.prototype.get = function(t) {
      var a = this.serializeKey(t);
      return this.items.get(a);
    }, e.prototype.set = function(t, a, n) {
      var r = this.serializeKey(t), i = n || this.ttl, o = Date.now(), u = {
        data: a,
        createdAt: o,
        expiresAt: i ? o + i : 1 / 0
      };
      this.dispatchExpire(i, u, r), this.items.set(r, u);
    }, e.prototype.dispatchExpire = function(t, a, n) {
      var r = this;
      t && setTimeout(function() {
        var i = Date.now(), o = i >= a.expiresAt;
        o && r.delete(n);
      }, t);
    }, e.prototype.delete = function(t) {
      this.items.delete(t);
    }, e;
  }()
);
function S0() {
  return typeof navigator.onLine < "u" ? navigator.onLine : !0;
}
function T0() {
  return typeof document < "u" && typeof document.visibilityState < "u" ? document.visibilityState !== "hidden" : !0;
}
var D0 = function(e) {
  return fetch(e).then(function(t) {
    return t.json();
  });
};
const vl = {
  isOnline: S0,
  isDocumentVisible: T0,
  fetcher: D0
};
var en = function() {
  return en = Object.assign || function(e) {
    for (var t, a = 1, n = arguments.length; a < n; a++) {
      t = arguments[a];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, en.apply(this, arguments);
}, Cr = function(e, t, a, n) {
  function r(i) {
    return i instanceof a ? i : new a(function(o) {
      o(i);
    });
  }
  return new (a || (a = Promise))(function(i, o) {
    function u(d) {
      try {
        s(n.next(d));
      } catch (c) {
        o(c);
      }
    }
    function l(d) {
      try {
        s(n.throw(d));
      } catch (c) {
        o(c);
      }
    }
    function s(d) {
      d.done ? i(d.value) : r(d.value).then(u, l);
    }
    s((n = n.apply(e, t || [])).next());
  });
}, kr = function(e, t) {
  var a = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, r, i, o;
  return o = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function u(s) {
    return function(d) {
      return l([s, d]);
    };
  }
  function l(s) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; a; ) try {
      if (n = 1, r && (i = s[0] & 2 ? r.return : s[0] ? r.throw || ((i = r.return) && i.call(r), 0) : r.next) && !(i = i.call(r, s[1])).done) return i;
      switch (r = 0, i && (s = [s[0] & 2, i.value]), s[0]) {
        case 0:
        case 1:
          i = s;
          break;
        case 4:
          return a.label++, { value: s[1], done: !1 };
        case 5:
          a.label++, r = s[1], s = [0];
          continue;
        case 7:
          s = a.ops.pop(), a.trys.pop();
          continue;
        default:
          if (i = a.trys, !(i = i.length > 0 && i[i.length - 1]) && (s[0] === 6 || s[0] === 2)) {
            a = 0;
            continue;
          }
          if (s[0] === 3 && (!i || s[1] > i[0] && s[1] < i[3])) {
            a.label = s[1];
            break;
          }
          if (s[0] === 6 && a.label < i[1]) {
            a.label = i[1], i = s;
            break;
          }
          if (i && a.label < i[2]) {
            a.label = i[2], a.ops.push(s);
            break;
          }
          i[2] && a.ops.pop(), a.trys.pop();
          continue;
      }
      s = t.call(e, a);
    } catch (d) {
      s = [6, d], r = 0;
    } finally {
      n = i = 0;
    }
    if (s[0] & 5) throw s[1];
    return { value: s[0] ? s[1] : void 0, done: !0 };
  }
}, A0 = function(e, t) {
  var a = typeof Symbol == "function" && e[Symbol.iterator];
  if (!a) return e;
  var n = a.call(e), r, i = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(r = n.next()).done; ) i.push(r.value);
  } catch (u) {
    o = { error: u };
  } finally {
    try {
      r && !r.done && (a = n.return) && a.call(n);
    } finally {
      if (o) throw o.error;
    }
  }
  return i;
}, I0 = function(e, t, a) {
  if (a || arguments.length === 2) for (var n = 0, r = t.length, i; n < r; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}, Eh = new qu(), ss = new qu(), pl = new qu(), Mh = {
  cache: Eh,
  refreshInterval: 0,
  ttl: 0,
  serverTTL: 1e3,
  dedupingInterval: 2e3,
  revalidateOnFocus: !0,
  revalidateDebounce: 0,
  shouldRetryOnError: !0,
  errorRetryInterval: 5e3,
  errorRetryCount: 5,
  fetcher: vl.fetcher,
  isOnline: vl.isOnline,
  isDocumentVisible: vl.isDocumentVisible
};
function E0(e, t, a) {
  var n = ss.get(e);
  if (n)
    n.data.push(t);
  else {
    var r = 5e3;
    ss.set(e, [t], a > 0 ? a + r : a);
  }
}
function M0(e, t, a) {
  if (a.isDocumentVisible() && !(a.errorRetryCount !== void 0 && t > a.errorRetryCount)) {
    var n = Math.min(t || 0, a.errorRetryCount), r = n * a.errorRetryInterval;
    setTimeout(function() {
      e(null, { errorRetryCount: n + 1, shouldRetryOnError: !0 });
    }, r);
  }
}
var Ec = function(e, t, a, n) {
  return a === void 0 && (a = Eh), n === void 0 && (n = Mh.ttl), Cr(void 0, void 0, void 0, function() {
    var r, i, o, u, l, s, d;
    return kr(this, function(c) {
      switch (c.label) {
        case 0:
          if (!x0(t)) return [3, 5];
          c.label = 1;
        case 1:
          return c.trys.push([1, 3, , 4]), [4, t];
        case 2:
          return r = c.sent(), [3, 4];
        case 3:
          return u = c.sent(), i = u, [3, 4];
        case 4:
          return [3, 6];
        case 5:
          r = t, c.label = 6;
        case 6:
          if (o = !1, l = { data: r, error: i, isValidating: o }, typeof r < "u")
            try {
              a.set(e, l, n);
            } catch (f) {
              console.error("swrv(mutate): failed to set cache", f);
            }
          return s = ss.get(e), s && s.data.length && (d = s.data.filter(function(f) {
            return f.key === e;
          }), d.forEach(function(f, v) {
            typeof l.data < "u" && (f.data = l.data), f.error = l.error, f.isValidating = l.isValidating, f.isLoading = l.isValidating;
            var m = v === d.length - 1;
            m || delete d[v];
          }), d = d.filter(Boolean)), [2, l];
      }
    });
  });
};
function O0() {
  for (var e = this, t = [], a = 0; a < arguments.length; a++)
    t[a] = arguments[a];
  var n, r, i = en({}, Mh), o = !1, u = !1, l = Zp(), s = (l == null ? void 0 : l.proxy) || l;
  if (!s)
    return console.error("Could not get current instance, check to make sure that `useSwrv` is declared in the top level of the setup function."), null;
  var d = (s == null ? void 0 : s.$isServer) || !1;
  t.length >= 1 && (n = t[0]), t.length >= 2 && (r = t[1]), t.length > 2 && (i = en(en({}, i), t[2]));
  var c = d ? i.serverTTL : i.ttl, f = typeof n == "function" ? n : L(n);
  typeof r > "u" && (r = i.fetcher);
  var v = null;
  v || (v = Ur({
    data: void 0,
    error: void 0,
    isValidating: !0,
    isLoading: !0,
    key: null
  }));
  var m = function(g, w) {
    return Cr(e, void 0, void 0, function() {
      var $, T, O, M, F, q, x, Y = this;
      return kr(this, function(R) {
        switch (R.label) {
          case 0:
            return $ = v.data === void 0, T = f.value, T ? (O = i.cache.get(T), M = O && O.data, v.isValidating = !0, v.isLoading = !M, M && (v.data = M.data, v.error = M.error), F = g || r, !F || !i.isDocumentVisible() && !$ || (w == null ? void 0 : w.forceRevalidate) !== void 0 && !(w != null && w.forceRevalidate) ? (v.isValidating = !1, v.isLoading = !1, [
              2
              /*return*/
            ]) : O && (q = !!(Date.now() - O.createdAt >= i.dedupingInterval || w != null && w.forceRevalidate), !q) ? (v.isValidating = !1, v.isLoading = !1, [
              2
              /*return*/
            ]) : (x = function() {
              return Cr(Y, void 0, void 0, function() {
                var k, P, D, B;
                return kr(this, function(J) {
                  switch (J.label) {
                    case 0:
                      return k = pl.get(T), k ? [3, 2] : (P = Array.isArray(T) ? T : [T], D = F.apply(void 0, I0([], A0(P), !1)), pl.set(T, D, i.dedupingInterval), [4, Ec(T, D, i.cache, c)]);
                    case 1:
                      return J.sent(), [3, 4];
                    case 2:
                      return [4, Ec(T, k.data, i.cache, c)];
                    case 3:
                      J.sent(), J.label = 4;
                    case 4:
                      return v.isValidating = !1, v.isLoading = !1, pl.delete(T), v.error !== void 0 && (B = !o && i.shouldRetryOnError && (w ? w.shouldRetryOnError : !0), B && M0(m, w ? w.errorRetryCount : 1, i)), [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, M && i.revalidateDebounce ? (setTimeout(function() {
              return Cr(Y, void 0, void 0, function() {
                return kr(this, function(k) {
                  switch (k.label) {
                    case 0:
                      return o ? [3, 2] : [4, x()];
                    case 1:
                      k.sent(), k.label = 2;
                    case 2:
                      return [
                        2
                        /*return*/
                      ];
                  }
                });
              });
            }, i.revalidateDebounce), [3, 3]) : [3, 1])) : [
              2
              /*return*/
            ];
          case 1:
            return [4, x()];
          case 2:
            R.sent(), R.label = 3;
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }, C = function() {
    return Cr(e, void 0, void 0, function() {
      return kr(this, function(g) {
        return [2, m(null, { shouldRetryOnError: !1 })];
      });
    });
  }, p = null;
  rt(function() {
    var g = function() {
      return Cr(e, void 0, void 0, function() {
        return kr(this, function(w) {
          switch (w.label) {
            case 0:
              return !v.error && i.isOnline() ? [4, m()] : [3, 2];
            case 1:
              return w.sent(), [3, 3];
            case 2:
              p && clearTimeout(p), w.label = 3;
            case 3:
              return i.refreshInterval && !o && (p = setTimeout(g, i.refreshInterval)), [
                2
                /*return*/
              ];
          }
        });
      });
    };
    i.refreshInterval && (p = setTimeout(g, i.refreshInterval)), i.revalidateOnFocus && (document.addEventListener("visibilitychange", C, !1), window.addEventListener("focus", C, !1));
  }), qa(function() {
    o = !0, p && clearTimeout(p), i.revalidateOnFocus && (document.removeEventListener("visibilitychange", C, !1), window.removeEventListener("focus", C, !1));
    var g = ss.get(f.value);
    g && (g.data = g.data.filter(function(w) {
      return w !== v;
    }));
  });
  try {
    ne(f, function(g) {
      E1(f) || (f.value = g), v.key = g, v.isValidating = !!g, E0(f.value, v, c), !d && !u && f.value && m(), u = !1;
    }, {
      immediate: !0
    });
  } catch {
  }
  var h = en(en({}, Xp(v)), { mutate: function(g, w) {
    return m(g, en(en({}, w), { forceRevalidate: !0 }));
  } });
  return h;
}
function x0(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
const Ja = {
  VALIDATING: "VALIDATING",
  VALIDATING_HAS_DATA: "VALIDATING_HAS_DATA",
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  SUCCESS_HAS_DATA: "SUCCESS_HAS_DATA",
  ERROR: "ERROR",
  STALE_IF_ERROR: "STALE_IF_ERROR"
};
function Nn() {
  return {
    useRequest: (o, u, l) => {
      const {
        data: s,
        error: d,
        isValidating: c,
        isLoading: f,
        mutate: v
      } = O0(o, u, {
        revalidateDebounce: 500,
        dedupingInterval: 100,
        ...l
      });
      return {
        data: b(() => {
          var C;
          return (C = s.value) == null ? void 0 : C.data;
        }),
        response: s,
        error: d,
        isValidating: c,
        isLoading: f,
        revalidate: v
      };
    },
    useDebounce: (o, u = 300) => {
      let l;
      const s = (d) => async (...c) => {
        clearTimeout(l), d > 0 ? await new Promise((f) => {
          l = setTimeout(async () => {
            await o(...c), f();
          }, d);
        }) : await o(...c);
      };
      return {
        debouncedFn: s(u),
        generateDebouncedFn: s
      };
    },
    clientSideSorter: (o, u, l, s) => {
      let d = null;
      const c = (v, m) => typeof m == "number" && !Number.isNaN(v) && !Number.isNaN(m) ? v - m : 0, f = (v, m) => v.localeCompare(m);
      return o !== u ? (d = (v, m) => {
        const C = (g) => g == null ? "" : typeof g == "number" ? g : Array.isArray(g) && g.length && typeof g[0] == "number" ? g[0] : String(g), p = C(v[o]), h = C(m[o]);
        switch (typeof p) {
          case "number":
            return c(p, h);
          default:
            return f(p, h);
        }
      }, s.sort(d), u = o, l = "ascending") : (s.reverse(), l === "descending" || l === "desc" ? l = "ascending" : l = "descending"), { previousKey: u, sortOrder: l };
    },
    useSwrvState: (o, u, l) => {
      const s = L(Ja.PENDING), d = L(!1);
      return Mu(() => {
        var c, f, v, m, C, p;
        if (d.value = o.value && !!((c = Object.keys(o.value)) != null && c.length || (f = o.value.data) != null && f.length || (m = (v = o.value.data) == null ? void 0 : v.data) != null && m.length || !((C = o.value.data) != null && C.data) && typeof o.value.data == "object" && Object.keys((p = o.value) == null ? void 0 : p.data).length), o.value && d.value && l.value) {
          s.value = Ja.VALIDATING_HAS_DATA;
          return;
        }
        if (o.value && l.value) {
          s.value = Ja.VALIDATING;
          return;
        }
        if (o.value && u.value) {
          s.value = Ja.STALE_IF_ERROR;
          return;
        }
        if (o.value === void 0 && !u.value) {
          s.value = Ja.PENDING;
          return;
        }
        if (o.value && !u.value && d.value) {
          s.value = Ja.SUCCESS_HAS_DATA;
          return;
        }
        if (o.value && !u.value) {
          s.value = Ja.SUCCESS;
          return;
        }
        o.value === void 0 && u && (s.value = Ja.ERROR);
      }), {
        hasData: d,
        state: s,
        swrvState: Ja
      };
    },
    cloneDeep: (o) => {
      if (o)
        return JSON.parse(JSON.stringify(o));
    },
    stripRequiredLabel: (o, u) => !u || !o ? o || "" : /( )?\*$/gi.test(o) ? o.replace(/\*$/gi, "").trim() : o
  };
}
const P0 = /* @__PURE__ */ se({
  __name: "KSkeletonBox",
  props: {
    width: { default: "1" },
    height: { default: "1" }
  },
  setup(e) {
    return (t, a) => (y(), S("div", {
      class: ue(["skeleton-box", { [`width-${t.width}`]: !0, [`height-${t.height}`]: !0 }])
    }, null, 2));
  }
}), ka = /* @__PURE__ */ Me(P0, [["__scopeId", "data-v-5081cdc2"]]), N0 = { class: "skeleton-loader" }, L0 = /* @__PURE__ */ se({
  __name: "SkeletonBase",
  setup(e) {
    return (t, a) => (y(), S("div", N0, [
      j(t.$slots, "default", {}, () => [
        Z(ka, {
          height: "1",
          width: "100"
        }),
        Z(ka, {
          height: "1",
          width: "100"
        }),
        Z(ka, {
          height: "1",
          width: "100"
        })
      ], !0)
    ]));
  }
}), B0 = /* @__PURE__ */ Me(L0, [["__scopeId", "data-v-72b558ed"]]), R0 = { class: "skeleton-card-wrapper" }, F0 = { class: "skeleton-card-header" }, z0 = { class: "skeleton-card-content" }, Y0 = { class: "skeleton-card-footer" }, H0 = /* @__PURE__ */ se({
  __name: "CardSkeleton",
  props: {
    cardCount: {},
    maxWidth: {}
  },
  setup(e) {
    Yt((a) => ({
      "243e7eb5": t.value
    }));
    const t = b(() => e.maxWidth ? Dt(e.maxWidth) : e.cardCount === 1 ? "470px" : `calc((100% / 3) - ${qy})`);
    return (a, n) => (y(), S("div", R0, [
      (y(!0), S(Ae, null, Le(a.cardCount, (r) => (y(), S("div", {
        key: r,
        class: "skeleton-card"
      }, [
        H("div", F0, [
          j(a.$slots, "card-header", {}, () => [
            Z(ka, { width: "50" })
          ], !0)
        ]),
        H("div", z0, [
          j(a.$slots, "card-content", {}, () => [
            (y(), S(Ae, null, Le(3, (i) => Z(ka, {
              key: i,
              width: "100"
            })), 64)),
            Z(ka, { width: "50" })
          ], !0)
        ]),
        H("div", Y0, [
          j(a.$slots, "card-footer", {}, () => [
            (y(), S(Ae, null, Le(2, (i) => Z(ka, {
              key: i,
              height: "2",
              width: "5"
            })), 64))
          ], !0)
        ])
      ]))), 128))
    ]));
  }
}), q0 = /* @__PURE__ */ Me(H0, [["__scopeId", "data-v-0fa22dc7"]]), W0 = { class: "skeleton-table-wrapper" }, _0 = /* @__PURE__ */ se({
  __name: "TableSkeleton",
  props: {
    rows: {},
    columns: {}
  },
  setup(e) {
    Yt((a) => ({
      "11294cba": a.columns
    }));
    const t = (a, n) => a === 1 && n === 1 || a !== 1 && n !== 1 ? "25" : "50";
    return (a, n) => (y(), S("div", W0, [
      (y(!0), S(Ae, null, Le(a.rows, (r) => (y(), S("div", {
        key: r,
        class: "skeleton-table-row"
      }, [
        j(a.$slots, "default", {}, () => [
          (y(!0), S(Ae, null, Le(a.columns, (i) => (y(), S("div", {
            key: i,
            class: "skeleton-cell-container"
          }, [
            Z(ka, {
              class: "skeleton-cell",
              width: t(i, r)
            }, null, 8, ["width"])
          ]))), 128))
        ], !0)
      ]))), 128))
    ]));
  }
}), U0 = /* @__PURE__ */ Me(_0, [["__scopeId", "data-v-35dc3248"]]), V0 = { class: "skeleton-form-wrapper" }, K0 = /* @__PURE__ */ se({
  __name: "FormSkeleton",
  setup(e) {
    return (t, a) => (y(), S("div", V0, [
      (y(), S(Ae, null, Le(4, (n) => H("div", {
        key: n,
        class: "skeleton-form-row"
      }, [
        Z(ka, {
          height: "2",
          width: "10"
        }),
        Z(ka, {
          height: "2",
          width: "100"
        })
      ])), 64))
    ]));
  }
}), j0 = /* @__PURE__ */ Me(K0, [["__scopeId", "data-v-f750ceb7"]]), G0 = "data:image/gif;base64,R0lGODlhtwC3APf+AB9Uef7+/k94lQVAafn6+/z9/QM+aAI+Z9/n7Pv8/fX3+fb4+gtEbQQ/aF+Fn/L19whCa/f5+v39/uzw9A5HbgE9ZwdBahtRdhdOdOnu8jVlhkBtjHWVrLbH0y9ggluCnd3l6x5TeAxFbRBIcPP2+HuasDBhgxNLcSVYfOrv8vH098PR2+ft8ejt8RFJcEVxj2OIoeXr76G3x4aitlqBnNni6A9Hb+bs8G+Rqe/z9drj6YKftO3x9NHc4xhOdPj6+9Xf5sXT3Km9y6u/zRlPdWGGoDFhg0hzkfr7/AZBamuOpoWitlmAmyZZfbvL1jloiCFVeglDa9jh6KK4x9Ld5L/O2b3N18/a4nmZr0NvjlR8mBZNcyJWeiNXexxRd6/Cz8jV3p61xbXG0zdmh6W6yaS5yIejt8zY4ERwj2aKo0dykWiMpMfU3SdafShbfj5ri87a4gpEbODn7Jmxwn+dsg1GbuLp7kFujY6puxRLchJKcdPd5ZOsvsbT3fD09ipcf42ou+Tq74Ces2eLpJGrvaO5yOPq7m2Pp9vj6XGSqlN7mMrW3ylbf1Z+mrrK1qi8y1B5ltTe5cDP2RVMc97m65evwa3AzjtpiSxegLPF0YOgtXiYrlJ7l520xM3Z4YumuZ+2xX2csbHD0Fh/mzhniMnW3013lDJihLzM12mMpdfg567BzrLE0R1Sdz9sjOvw8+Ho7TZlhi5fgiBUeY+pvEx2lKe8yrDD0Kq+zEt1k4mluEJujjpoiVd/mpWuvytdgKC2xpqywl2DnlF6l3qZr6zAzVyCnT1ri26QqMvX4PT3+IqmuZavwKa7yjxqitzk6tbg5neXrSRYfJiwwbnJ1TRkhTNjhWqNpnKTqrfI1JKsvnaWrZStv2WJo7TG0oGfs8LQ2lV9mYShtS1egb7N2Juzw3SVrLjJ1NDb44ikuGSIomyPp3OUq0p1kkl0kkZykMHQ2nybsH6cspyzxO7y9WCFoBpQdpCqvIynusTS3HCSqWKHoQA8Zv///////wAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQwIDc5LjE2MDQ1MSwgMjAxNy8wNS8wNi0wMTowODoyMSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo3ZjIxZWJkYy04MzJhLTQwZjEtYWZlMy1lMjZhNzM4ZGY5YTMiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NjNGMkExNzA5QzQ2MTFFOThCRTFFOEI2M0M2NTQ0NUIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NjNGMkExNkY5QzQ2MTFFOThCRTFFOEI2M0M2NTQ0NUIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyN2YyODg3Yi1jY2Y3LTQxODItYjE3YS0xMTY4NjU4MjI5ZDgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6N2YyMWViZGMtODMyYS00MGYxLWFmZTMtZTI2YTczOGRmOWEzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBQoA/gAsAAAAALcAtwAACP8A+wkcSLCgwYMIEypcyLChw4cQI0qcSLGixYsYM2rcyLGjx48gQ4ocSbKkyZMoU6pcybKly5cwY8qcSbOmzZs4c+rcybOnz59AgwodSrSo0aNIkypdyrSp06dQo0qdSrWq1atYs2rdyrWr169gw4odS7as0zB/zDpNxI+f2qZt3fbjUOBtUVUC4+bNMsGu0A428rYVDMAv0E8H5Ortt9hwz8WQB/fDkcDxzRuCFUuG/KaFZZrJ7GUezXgzPy+fZZKBoLk16capXUZ2XZr2GgKxU6p4bZo2ZFKYc5d8xoi3796CfQgnicrF8efGl480gLx2dOvYi0SQ7nH2de/Y+VX/s8OdI/jz1SNPKr8RPfTw1dljdP89vWQaCuRXpA//PWQPCOg3EX8E2ueCgBIV6J99cgWA4EILRlifXIqQ8GBCEvY34Wu/6HDhQRkqWJ8zHxpUWD8ApChQiieKqGF4XaRQYoIMbogdF4bMKFFiIdbYDyI6SqSNjy4GOdEaPb63nZEQJZCFjfwhUyILDjggUJVW9oOlQN3kUBA9UBLZwYdFEJlFZQa5eJ4PMj5YAZH8rHFQA3AuWMuFRRJUSZ02IpgnQTgkeZ18P4QpVyQFFXCEoYOytwyjKGZQkB+QgsdeBhRUykuhafL5IntpCFraBwcN4Kml3PWQWKWSFRTGqfFx/4cGrLQZxIGosEmnZnXJJHrni/yVtyttPuRIkIXA+igsra8ZoQyIzErXV7I9QnKQBbBiwd01rL5XUBmeQkAGd5EY0G2jBGGR4SLlHYGrj/AUFAAnfXLXQbT8nfBMQfklS4N8buBLpBtedkrbAWboN2yYLxwURXWsCLgwtaQV9EisCgucoUGCaLYBnhrbOCZBAYyS1xpIXGjquxlSAERBCwjETInAhEwxY7O0yaRA0bAc5iVBriCvtTdPnKuAdfVzAiX8nlt0qwgqIEBef1BqsNP8FSPgDadotqhBD/t8cxRn6BcCxgINYTOBRAQiH6oELSF2gUZwF8x1TshrDNae5v8WwDbvjSBFQZwa3XdsWhCJAg/Qzu2jDLEVeMdBdazt4wBCG4bX03IV1MGqnFe6tF/kjACpQYQ4vqAbdgFjKqTeGCRn6LQfPdbEdexREJqGbzwWbrVvBoCkVwefITdiTUCi8YLxcpAelr93wDlg6YCC6gdJ8jrzRVMAzVcnRI9QJ9gnO0tVVaQvUPpV8E3bKra6X29UvdsYhScFSSD/zVPVX/QFMWjc/sCTMKdQYYBwssZBfCA+YMGPKTnoAgJ9N5BSPGyCr7nfUgJQi/L9aSAXwyB8RKOUHTTQReMqyA5ECDej8IiFPrIAG+QFQ9o46Cj+M9oW5CBA7vFHW0SJmQ//LSeLgwDghOmZAlGylEObFYQKIvBgejAnlD3V8HQF8cYBrliaPAQFDNtrotjmYRA8cNF2OrkAEsU2AEkgRIzXSRpP4DhExehhX8Wj42LW4RM9Wo51BmnCGl/jC53g4oxOJIgOnHNGA1ADJ0AQASLf9QuEkGMAiAyMTR7QBil68AClSMjd6jg/mQxjkKRkDDsa4kfaAE8mrdyfNPoFIVQuJkuwtKXNyOEQWehSMQV0CXlSGUuIwAIDnnxNBR7Ikh9oYJJOgwgbIIDIOLhEHckkJtQe0gxosoR82Wziv/bzS4HQ8iTYCufa8qCzAZWzH1q44UmKmcNuWmQM7+QHMVJC/0/JsGhFKkJRQP8p0BON0yIsOBsiC4GSfnZOJuiQpDaPk4SG6lKBNYnYRNE1Enq6gGk4cahAdkMSesYuJyLtxxHkGJJi7lMnG8jnIUqKSpb2wxtT64cAdiqQnebUpz3lqU6FmhEeXO+MdaBpNguiAxuIrZ0VkYLpNhoeNCgVgQ04yC9stgE0XcQKZ3ypSPxoxjziCwfmsaVGx3pCRciTIE1Uokbo6ZmONhAFD3ij5aipkXag8kR2Ld8B9Vq+jDwAE9nsRUnoqBA6etUictiCCMsa2P0pxBgNRGtG+iDCICzWctVgSArCN0C5zrWBQqysD10QIIbIwIMQKNtpC/vZudOJ4SHvQGAINtKIBprEf/GACEgZixEFaIC2V+WeTR1CXIzcoBWWrW003Vk+014EDtFN7q6yWhHqlC+2aRXbbwVGC4sAzoMhgKpF/DdeXGnhIgrgghQ/phFkile6tGtCXi+CWQR6cbbT1a6nBnuRWEiRA+0RmATnGS2NjECKQAJw8JhgUVFlZAIn3EV4WaWNCofJAxthwwmHsOHggcHD3cNjRqbQQAykLMG4SgKndkbjGtv4xjjOsY53zOMe+/jHQA6ykIdM5CIb+chITrKSl8xkqgQEACH5BAUKAP4ALA4AHACTAIYAAAj/APsJHEiwoMGDCBMqXMiwocOHECNKnEix4sIXPCxq3Mixo8VXAvlB6eGxpMmTHa8ACMkvDsqXMGMmFBKHH0ub/QrI3MmzJL+fNwXuStGzqNGHKoL2+4mTX4gzR6NKJVijjVKmLCFM3WpUjI2mQJeGxdoPCdezMA+MXQsW55sWaONyVHCV7dULYOTqnSjHSN22dZPsHexQ0iTAYhGTJUuAsOODA+wm/quU1I3HmClP3rx4rI8+mQcP0dxZ8doBofWqIEJacmmlP1KfVWK6dmucGuzInrqogm3Orl1vkbQ7qpHgv18Db1D8qPLnyDUvaM4TevLom0/JoS7T+u3vS0+g/+J+0hJ478BNHyBfUsWF89jRk1XGfiObXPCv6xe4o75HMkpokN+Am+nk30mfhPNeegQqd+BOHDgTRYPBvfBgUXQxqOFzFkxwYUUOABJERPLFx08qH1JE1iFkgMBQiful+FBjGi6BygMHwQiejAwVoEVr6xkkjIkxBsCjQofE6AhBMTAQI3rcHInQEkQKhEkCBInzJHYQACGlQTouxQxBC6y0YZVLeUDjlw3mkQNBj1BoGgJslkIhDgQZeeaWdEqpQx4UMgcmmtD1ySMLUGyJWEFhFiqlCYRKVpAIkc4pZaOSYTnQDJXWZeiFemKKGB8ERTCLop7KqI+cSrmQ0UC4oP8K3KcHfiLrc4cU5AqrSy2h54NldLqhAdAQdAWvq8gY2a3BHZGjsDyKuiNBmAp4pLR7PvvkKNNdKyx6BXGBJh2/Rvstdh4O9AWabPbjG7O/XVPQHdex1m4/MJz7mwGRENRDkM8ZYci9/dzgJK/PWUhQGpopkiHBO8DbmigEZaBZuTx2MOZACiyILXQoaMuSBQSLcMKbA8mAMHaMjoUBGwT/xA5BEqz8W8s4tQFLu0mJhdqgEmtYEBphIdJuICYohbPNSpE0EBUG4NTuFV4sStCyTG92R0FrSM0mpYiVi4y+pH1B0ASaxCwZGQTxMELQz3WxZrsSmKMZAN0KhAfcwS3/Q7ACnCQ3A0EEdJF1Z3UQHEt8dVg8UDGHS8pmiYOInO3lZElpBXwGWP6x5DKC8nOYS2OOpnkpxgMtQRCQrSEUEaSIrYECleD6c4MfmC62cxD0AAZ8KyYCC/7pELLpiGGA40BzBF9XEfWtcALcJRBUACaRg1VBfUncDoFuA1GTvdK7JUBJ5B94fntYmKnCyj0CSdOA85uV/jlieQ92/7QD7a+hOI/xH7gIUof1IYYBMdhLzZDHq7lxin6LccBeKMbACpIFD2QCAATHUgE7yeUS49PQCF4lEDJsECxPkEsQTkgaZOQpFiHM3FmGwcINDaAGBFlBDNnHFSn4ZoemgYT6/+h3lm4YkED2O2I/BrYVCyiRdNR6YlhowBUBrm4gepBiU2A2FSvK6mH90IYWQzIGjBXFiwTqz0AS0IQa/qQMR9EUGivIgMsMRBRu5MeCigJHCz4RBgXZABCP4oFBYq4CThMIHAzZE2rkcUtZGGLWekI0Q0Kxf2Psx4hkAodMYiuJ9NOAGU3CBE9eUSBE8CQoZBK1RyKRIGHwJBFIEJM5+q8gEvBAHolRS1NuiQEIsUIetQITW56LFgmpBSNL0i1j3ooUCzyIFJbpkd75sYZJKNaLMhlNjhxvjgAIp0DCaSZyjlOc/TBnP3ThEGcKpBM+CaFR3NkP5XmkhkZJlBs3cf9PeRYlVm60wPk4gs+iBIAXeeRERzYYpKOAIY/AJGjk3EAQkPRDABgVCEYFoNGMXtSjG3XIKHZ4jIVGjgkEWdI1HdInY9pNoisFjt8G8glePcSYcYKpFVUqkPTF9KZSdJFO12dRK/EKLg2xJaBMGtPFeIEgP+hcTMPgkD880VlMFaApCOKJoAmxIWJ4Yij62dSxjHUgseQVA2LXkBdA0BtkFWCyBjI2hInBIVQA2O2QOlS4feoNcEORQ9SRtVbEs6w4GUFBvoKwpzqEeIgVyI/i6rqtDQQB6zsWRPyXjsP6LxEEucX6BEEi122OskGbAkEEsb5qlDZoy8uq6/ZAEBp0EtEh1nCdSeinKYGI67YNgYduPTtcTAK3IZAI2m4nGcXjMmRINiWucpvL3IYEAHjRRW12/dmQTk5Xu37kgiR/6hAzFFe2t7KAJwiSjMjtIiIbOG9fGzQNmsEwsmIRQkSwRl7whskYBekABCcxt6SeSwQbCQgAIfkEBQoA/gAsFQAdAHkAhQAACP8A+wkcSLCgwYMIEypcyPDgA4EJGkqcSLGixYsEY5gQuCEDxo8gQ4okGKkVP4H8vCwaybKly4MU+J3sJ9PCy5s4Q8qcuVMggZxAgyLUhFJm0ZmkAgldCjQBDJ5GaUblh2EF06su1UzdCrUB1q8ie0qFSlbgArBoJUY6ynZs21MI0spFaIVCW7F4p+pxMrevwCkDyrodnPeA3755BSduS+Iw2sWEubb9VcMxU4+RFUsmbIOVZaEf7m6GDPkzTieaU4sWnMO0ywVdVGde3VbaHtcssYzeLRsvAyG4RTbgTXu28eAfSRM3DnkC8ovKey8XG+LMc4ksikfXPhoCqOsMHXD/l06+LfiEP/u1izm+PfOo5xkWuCJw0vT7suNTVBXM/fbIa+j3kRyFpOHfdDQUIGBBKWRXER/4FYdBegsO5AE/XQhUWUOGRMjcEhUShNcWigikIEJIeEhaAyuFaBwDL+yA0BblvYdChd+4N8YzBI1T43/6AfNjJgRpdWB+51kRmH/TEFTEj8sZcl5MPwpC0CZQyrbLef/hNQhBEB6p3XMPvaeYKQQNkeWYwSWghpg0aUBQEGsyh9xTcPJzAUEg1ElacJqoOFUDAQwUgZ+jBdflbi0QNEKeieK2qGY9EOQGpIqZBgSmRWVDUBacEvbZDSGEKlMnBNFgalRzWEaCEYhC/zUDQRysOtNnRwiqmRIEAbKqLK5Nyl2JA9li6jCNmSbse08QVEWooRQarK6iQUGQFKEit6xyNg2U7Lb8lPocuEgOtC0vjY5L7XEielgEhdquW1q7NcZHbnEFLfqofveya+50bWyInLQCMSDvZvku94Qf4G06UBMHC5awbLeB5whBx0RsHr34PjeFQIUQ1IjGg03cMW4B0DGTLgThQLJYJvvr2gdRYUOQGS/Dx3FkG6k70ygEyZDzrTvnZRVuG4q1AUHnDH0QaUwEB44ebbVBEBVOGwRZHEq5VsiSg9k1UAZZxyxWI4qOdtZAw9n69GZ/mJYeaSAQdEGsG/8rWAVlHv/GwxvaBUGQBniXXPRUqDiGCMTaDUFQLYXDfDhPsx52wnS+EJRG5DrrfZcAjnWJBUHycD7TDwQZMJoPcwUgo5kowUBQJaYLFNdAROxmR1oECPPjEQTdUns/fQy+Gy5pbaCiEQSBMbwlBOWyW62Pqcj6QLAMn/lAm2sGOFMFfIFGngec2A8Bw48+kMqaxXGVSYg6KNAJbvcj+0C0l/tSPqrC/h4cBGFE/YA3EFEsBycX4lwHCPKC+nmAIKU44E36lZd5ECQ0/vsPBggSCAm+hIJbAdFAtlG/CkREICnSX0tACJVr9Kp+/IgBQWh0MpewsChaIEgzYNgigchChSy5oVT/mjWQZ2VwOkQaiJFkJpITClEmXCCIKmDYpIE8qYYi8QQM+QEBgqgAhlYaiG6K07WRVGKLRPPcERXzpYGEyTjFaEkR0Pi2yKFpIGoqTjRaErc1usds8pLTQPogm6WN5AEVoKPWXrangfSpOCIwH0jIMTzJqZGChDJUbyoWknRUsnNbTJdAXKCdcoyEE59M4xYrNZBLMacbI7mbIgGJKE8NBFTMAVZIYpA1S24RVQPBIGkMoIyQfKGXoPTjeyonEOopBxwh0U0q67gqXg3EV+9ZRkiygExVKlM5xBKIsd6TQ5BQaZaTgxQRBSIJ7nhBJ92k5je3Yq2BYMt/yYnnIjnX/y2BfMuDFnkiwtI5T28CCSNCBIBCBaJQAMhTiLTMW0BJNhGBGhSgFYGoRCz60IFCh6IbLRtBfZlRkDaEo/vEIkU02hAbiPSSHp1o4dYmECUIAHT9qNtA2vDSPyKUZIggiCuicg6CKG94ETXcRwt3NIEwISoyIMgoeorPnxbuEbSKihkIgo2cGaCjErNqqGhBEFpEBQcE0UXOTkEQSvh0qaEi4UCEEBW0DaQMOUuFDt8q01BhUCCEnMkxCOKInAGjZXwtaeEaOBAERKUJBAFCzu4pkDEkliKBKZwAB4K+mTCAIBN42QgIRoAkXHYilyAZKWfIEwUQJAmRe9NAnMedr/+CpAQviwBBTMATHRAkBJGjA0EIIZ2efQQ1kdOpQNzBk6b2YwyRW+BAnsqdNn5EAWCjoOC4xxPgDEQAkXPOQLggnTCIJLWm8q5ABMETQhBkDYW70UBScB+H3TZy7h1IMHiyCYJ8o3DGIEgmpkMBCYgENabq70A6wJN6EGQOheMGQXDbm/GJBLumEs9A0MET2QpkwKFKBkHQMB1isOQSpnoHQeiLEg0LhMGhQgJBzskcz4ykBKa6gxd58rGB4DZbI50KZg4cKgasZSCJ4IkMBwJdIMNUMLNoiWsLKpAyEGQPqhNIHwXihwMULqli6cUE11WQoc7kEAQ55peDPBM8jLkcTjG7BUHWYVL3FO+DglptzBg2EEbU2X+6pUhAAAAh+QQFCgD+ACwYABwAeQCGAAAI/wD7CRxIsKDBgwgTKlzIcKCvcQ0jSpxIsaJFg9348bvIsaPHjwg1buwXTwLIkyhTFlwkUGRLd/RUypxpUYaFlhpxdqHJs2dCHDn7uRQa1KdRn0OTBuVQ4KjTkz1wjlQ6NcuEp1gvDokjtSvRqfwAZB0rsURQql6Hkl2bEO3XtEFxJGBLVwpcsHjTvmlBl2wmG3cDvyXqpW9WQgfyDnbr1rBTA2cjK2YcdA0Bx0glC6Y8ldQNzDw5b9ZM1AdolZ8XkxateuTpk+FGT15NukiE1x3FzN4tO201O7gtKgDAu3Vv1VuCV+RAuzjrxsojQnbe/PjQDwqiM3xe3bh3fh4QaP9XCGMS9fPW+Zkar7BAlfTov8fyw74hm2g7v3dnjelqfYqY7CegYin8Z5EOZsB3nIEInRGRNm8coKB3SDBoED8hYBNRBgINMKBgm1gokBheDeJEhQut8qF3B0hiYScGwOWCQLchRMiKjHmRg4HfdMdAL7YclAiOtPViIHcj6UCQAEQWp112+ilWCkEeNClYdBPwMuErBNVhpXfKyeFGfGoRhOSCwRHxZUFnRqldm2UOBGd3rz0yYZx30gkaHmSSxuaX0Dk2ZJ+K/UnolZjNWaiZgPrZF31uRmponovSBQqlXk0aKWMG8IEZHZgOpqmiArmACmgOhIrnpt0hctoxqhb/xeihop7WSqyuzZqnObghISGrTuoKrEBJyBAcCLQGGiobyjmRrKNzDVtrcOU8C9YFBIGQZyPjmRXrJQRZcecOAYz3gbU4CUNQOROuUt8T6BIVCkElTPifmrFeOhAT6Q1g4A+NgvXeQE+kV4iBNQSMkxwEmbbpvAZmo7BQDTRFY3x6WPxfJRPzwwVBQJCZzXjBEBRNx1kQpJt1Aoxn7ECNdKwOQXyQaQBwuNEiEDwEadDxEgSx0yeopxVwzUg4C2RevPyQQRAnfRLxWi5BmSRnx8wOZAStoK1K6mJ8DTQC131dkamwX0dBUA5r0tWBCGdfHe8fBMHR9lrMJBY3rgLl/0KQJV/+wJay0rqlBEGAfHlwVlAS/vVQgBCkxJfOZMVCNYjKHaolBFGdLBVPAUFc5nz3Y/ZAjAB6uFMU6Kl54UHtOFAUgNahjFOsjXp3rHP4xKWkaO8OO1hG+JQGmq9/rTvZMnlSAfKlL2+vTAGQEp/00mLf5kwyrKi998Ezn5IPAjJAEA/Rhz9huSpx9wtBDg6/t/yDDZwSd7UQNET6yX/JbfsCOgRBPsG/0g2AQyC5RXoiN5DVPU5W/UsW0D4SgVmkh3MDaUcB6ZeUWVitIzvoExwIwogNPhAsJOoILGiXHtkJRG0chGDpNLKejoQDR4AZSAaYJsMYguVXHIGTB/8IAgYexuhCHevhROAECYLYgodiQSIPc2UROCWCIGbg4R0OcsL5NQSBcCIEQQbBwyIcxARJpKJEYHAnURDkBTzUxEEekUaBKGkiKLgT6AaCAh4uriASaMIUBaKhiVTiTiQYSACSwMMgICQMg+yHHmoUkctI6wQEiUESY4AQAtzKhy15GUXaZA2CrKBjFmDfQcQISqEUrCJt0gJBCtGxNihkATPkBzpguSIOEEQTHXNHQ7pIlFRUJA8r8gVBYNAxY24niXCjSBbjk0KB3KFjBHxmJCdCghPEBxoEgULH9scQ2m1zIiE8DiX70YCOxW8hQDmnRHKQw9ypr3DoYwgsPLT/wYYQzZ4RnBAFJLKPSOZTIv4BaOmGGBEdPK+VeLiIQlvZRIkYqZVNUOUSXVe6K0rkdMTkh7h4GayASgsXVeyYLBuiUQhwtJUqSCnTGsAChcS0H18gyDpeSkyJJlGOCeFXP0ygyn2WtJ8RCSmGEkKNqeR0IGQkXSsvYo06HqQA45gKUQeCgCM6bmIXAZw8B1ItsDxVIKkC0z23ZxEJpK6fGIiMCQjiKrWalK01GatUv/qsGQ3kdhRJQBSJaUmTYu971KEBQVzUD40yhBmlE8Jhg3dEgQguhkEaiC4EIlmJ4LKVGxBI/NyiUaWMgSA1UFUDXNgPTgjEDdHaaLxy6Aqp/8YhMvggyMseV1uC2KMl+pJtqIx0i6OqRlsDqeHjcjsQQ0wlBIVN6sTKgARB7vUspyAICSCgqtQOZAhg8dREGDAxemiDp2eZoECeGKo8EoQ5OHGYRAYVKkmidyqqIMgNQ+VLgqDRiwlJBlgnOhRMEGQB5A0VAgVSxEoxZAYDvq9AICaQYoCVIA5wVEN+EeHZ+EuKAtmjQBbQg2IIxBnInN5ALBAZIEo3XvrprR0BXBBIyYMG2QVe/94xyg7DRRwE4QaNGQKOMERDIC4Fi2JBTBRg9PhZkxgIAKYskClHccrv7IczrYySAMjhVP3IxThSUxAu9wMA0njAk/NUj4EEBAAh+QQFCgD+ACwYABwAeQCGAAAI/wD7CRxIsKDBgwgTKlzIsKHDhxAjSpzY8IHABBQzatzI0WAMEwI3ZOhIsqRJhJFa8RPIz8uikzBjbqTAb2W/mhZk6tzpsKZNnwIJ8Bw6VBPLmkdtkgpEtOnJBDB+Ir05lR+GFU6zclRTtavUBlrDUgRKVapZgQvEqlUYKanbsm9PIVhLl6AVCm/J6q2qx0ldulMGnIVLeO+Bv2v3Dlb8lgRirYwLe337q8bjoSMlL55c2Aaryzs/5OUcOTJomE42qx49OMfpkgu6rNbM+q20Pa87YiHNe7ZeBkJyb2zQuzbt48LHFj9emvOE5BKb+15ONsQZ6A1ZGJe+nTQEUNgXOv/oPr382/AIhfZrR5O8e+ZT0S8scEXgJOr4Z8t/qCrYe+6SrbEfRXIUksZ/1NFQwIAEpaBdRHzkZxwG6jEokAf8dCGQZQ0ZIiFzS1g4kF5bKCLQgggh8WFpDbwkYmQMvLADQluYBx8KDH7z3hjPEDSOjQDKBwyQmRDEFYL6hWeFYP9NQ1ARQC5nSHg0ASkIQZtEOdsu4QGo1yAERYjkdslZBN9iphA0hJZk5paAGmPepAFBQbDJnHBRxcnPBQSBYGdpuWmyYlUNBDBQBH+SlpuXvLVA0Ah6Kvoao5v1QJAbkS4GGhCZHpUNQVl0WthlN4Qgak2dEETDqVPN8RgJRiT/KtUMBHHAqk2XHTHoZkoQBAirspxGaXcmDmTLqcM4Btqw8D1BUBWihmKosLuOBgVBUogqHLPN5TSQstzyY2py4SY54oq8OEputcgRxGwRFW7LrmnufoheucYVxCik8uHb7rm+tcGhcNMKxMC8nOm73BN+YMfpQE0gPJjCs+GGnSMEHSPxefWam9sUAhVCUCMbE0ZxvrkFQIdNuhCEQ8lknfzvaR9MhQ1BZsAcX8ejgbSuTaMQJIPOuPIsGVavcUjWBgSdQ/RBpTGRGzh6vNUGQVQ8bVBkcTB1WiFMEobXQBloLTNZjSxKWloDEXcr1Jz9AZp6pYFA0AWycgzwWxWY//kXD29sFwRBGuRtstF6oYIYIhFvNwRBtRgeM+JV0frXCdT5QlAaku+8d2ECIOYlFgTJ07lNPxBkAGk+rBXAjGeyBANBlZwu0FwDEcGbHWIRIAyQRxB0i+399EE4b7iItcGKRhAEBvGWEJQLb7aGxW3rA8FCvOYDcb5Z4EQV8AUaeh6AYj8EEE/6QCtvFkdTKiX6oEAnvN3P7APV7rFJ+awaO3xwIAgj7Be8gYhiOTHBUOc6QJAX2M8DBCkFAmHir73MgyCi+R+AMECQQEzwJBXsSogGsg37VQAjAlHR/kgSQqlcw1f240cMCFIjlIFQZ1ogSDNi6CKByGKFHWnhUf+cNRBoaZA6RRrIkWbGERQKkSpcIIgqYuikgUDJhh3xRAz5AQGCqCCGVxrIbozjtY5UYotF+1wFwTQQMR2nGCUpAhrhJrk0DWRNxolGSeR2RBudbV5zGkgfZsO0jjygAnPcGsz4NBA/GUcE59MIOYg3OTXOq1CH8o3FNpIOSnpui+oSiAu2U46OcMKTadyipQaCKeZ0oyN4S+QfE/WpgYSKOcHaSAy0VsktpmogGSyNAZSxkS/w8pN97I7lBFK95oBjI7tBJR1Z1auB/Ao+y9hIFo6ZymTCp1gCORZ8cqiRKsmScokiokAk0R0vbOSJ9LJkoq41kGz9LyPwTBg6I+X/LYGA64PR4eY0vRnP9+CzZABIqEASCoCBPnGWeguo4R6Sz24GSTkT7YnZ9nm4iTxUo8SDaEclqi2Q2k+kvYzIRxtig43KM6IqLRnbBKIEAYSuH3YbSBtcalCMigoRBHHFVM5BkOWFlKMphcgTkSYQJkxFBgQZBU/v6VOCTuURtZqKGQiCDZ0ZwKH69GjJaEEQWkwFBwTRhc5OQRBK9FSshivhQIQwlbQNpAw6S4UO30pSq9okgwIZpE2OQRBH6AwYLuNrTA3nwIEgYCpNIAgQdGZPgYxBsRARjOEGOJD02YQBBJkAzEZQMAIkAbMPuUTJRknDnyiAIEmQHJwG8rzu/3xVIyWAWQQIYoKf6IAgIZAcHQhCiOn4LCOpkVxOBeKOnzC1H2OQHAMH4tTusDEjCghbBQfXvZ8EZyACkNxzBsKF6YSBI6o91XcFIoifEIIgazAcjgaSAvw8DLeSe+9AgvGTTRDkG4YzBkEyQR0KSIAjqTmVfwfSgZ/UgyBzMBw3CJJb35CPI9k91XgGgo6fzFYgBBZVMgiCBuoQgySXONU7GvSTDQukwaJCAkHMyZzPdKQEp7qDF38CsoHktqQvLUxmECwqBrRlIIn4yQwHEl0gv2cWJXmtXwVSBoLsYXUC4aNA/HCAjAaZLL2gILsKIlSbHIIgxvTye/AgZjvJ7BwWBFlHyVA6FePdMEqslVnDBsKIOSN1KrudSEAAACH5BAUKAP4ALBUAHQB5AIUAAAj/APsJHEiwoMGDCBMqXMhQ4QseDSNKnEixokWCrwTyg9LjosePIEMSvAJAI784IlOqXHlQSBx+JmH2K8Cyps2L/HLGFLgrxc2fQA+q2Nkvp0x+Ic4EXfqzRhuiRk1CYEp1pRgbR3UW1Rq1H5KqYD0e4Eo2q8w3LcKqbagAalmoF8CsnXtQjhG3Zt0moctXoKRJebcG7tqVQN+1A94KxkuU1I3DYQkrljzYRx/IS4cwXsyZsskBmIGqILLZc2fFP0LXVDJ4suvAGuyoVrmoQuvbpblukTRbpJHXuXFvbdA7pOnjwE/LXFAcZ3LkwruektO8IvTg2IueQFW9oaXs15W7/z3QfaGKC+Cfq5eprPxBNrnSR18vcId7hWSUaJDPnzPN+w19Eg564hUYXlcAWsSBM1H0h9wLCX7UloH0FWXBBBES5AAgQVB0oHqpZDhQV4eQAQJDH84nU4KGFbgEKg8clGJ2ABagRW7kGSRMheEFcN8hKgrkCEExMBAkhTJx494SFWKSAEHiHBkeBECUN2NRzBC0QElIgudBi81dyU8eORD0iIOuIVBcKWjiQJCPXcaZk5qz6ZAHmsQZJGaas7EAhZSKFbRna3SGZgKPgRIkAqKEzjYoUU8ONAOjbhXaF5yPcsYHQRHMAmijkOmDZmAuQDQQLp9WCtknqRp4SEGujP+q0RJw8lUGpQYaAM1IsvazCmaJtYrcETLiGlqm4QmK6H6qIZucslKOwlyzuCZLEBcV0lHrsdUmh+FAX1TYnG3CJndNQXfMR1p1MHQrnAGRENRDjscZYUh3NxjZ63EQEpTGZopM2N0O5c4nCkEZbLZtaB1kOZACBDrbGgrFZmVBdyKcUOZAMuz7LEGEYcBGdzmxQ5AEHgsHrUBtwNLcUFuBpqe7mxWEhlaINBeICUStLGeFHQ1EhQErFneFF4EVFGzKRN1R0BpF97ZoYNsiQ7OBXxA0gSYkK0YGQTyMUHBpXYDZnATmbAbAtALhMTaFy3SnACfRzUAQAV0wfVod3cX/8lwdCQ9UjN6mhaneIBUTrtVsVqRnQOI/H6kaKDJf6bPERH0HWTzGEgTB1aZBEQFkmf4nUAmgT2Y3Xd9mOgdBD2Dw9nEisDCXDhRHThQGMQ40x+yuFbHWCifMXgJBBWCieFYVrJUE6BDINhA1y/e8VAKUKP4B5JhzZpMqrNwjkDQNAJ80yKkHxrZK3Vs7YvpEiVNT+x8PVAf8nDEQQ0oo6+5/YQSZlPmg4oCUHOx/uMKDlgAwwM5UgE0huUT1CjQCUwmEDA2UzBNCEoQMPgcZb4rFBBHkkWF4MDoDqAFBVjDCxV1ECrZpYWsgwT38eaQb+LMc+k4okHtZxAI5FNcO/ydIA+fwME4F0UMQjzIy6ywxOwLrhzaeWJQxLKwh9GuVfQaSgCYcMSdlkEikstgfBjxmIKL4Ij8I1JAwIjCDMCjIBmQoEQ/QUU4VCJpA4HBHhlBDjYDKQg0byJCb3VGH7ztihxICBypm6nL408AVB8IER3ZuIERwJCgSQjRA9qcgYXAkEUiAEDK+0XoDkYAH1EiMUloSUAxAiBXUOJVBHtI1tEhILfookGmZElmk6N9BpMDLfrzulMg0TRJ2hSIq9i93pgSANAUiTS5Vk5rT7Mc1+6GLiPxSK53QyATB8k2Z8K4o46zKn764CXQmM1FUQdUXLUCJI4IlALxQI90Ul/+jsIBBjfp6Z1bcgBGBCOCgBkVoPw4qgIQ2dKEKZcgoWngMDzKBIENCJkPo9E1zeDBuA/lEryTyzUd4MKMC2Z5GvRlEEHgwIwNRHjLTgsUc3imDXiDIDx6HzDBE5A85JFYGTUEQT7yNhg0RQw5D4c72MXUgoewVA0bXkBdk0BtNBd2vBmK1fYkhIlSgF+jSkkFLvWF2IYqIOvTWCnEKVCAjKAhW9pXTiNjurf24UVbf5rSBICB1V/DQ1dLh1u4lgiC3SJ0gBPu2xu21V1MgiCBSVw3G9qp3DdwDQUxIyIhY42oj0lukBIKtzjYEHqAtbGoTqbeJQOJtocUrJGErkR1MjVS1tGWtbCMSANnd9rEr1W33JNLI3AKPC7YMLkPMsNrZWcATBEmG4nZBkQ00d1/TOJkI8ZoTIVBkacF9mzEK0oEMTsJsNS2XCAoSEAA7", Q0 = {
  class: "fullscreen-loading-container",
  "data-testid": "full-screen-loader"
}, Z0 = ["src"], X0 = {
  key: 0,
  class: "progress"
}, J0 = /* @__PURE__ */ se({
  __name: "FullScreenKongSkeleton",
  props: {
    progress: {},
    hideProgress: { type: Boolean },
    zIndex: {}
  },
  setup(e) {
    Yt((r) => ({
      "4d434712": r.zIndex
    }));
    const t = L(0), a = L(0), n = b(() => e.progress !== null ? e.progress : a.value);
    return rt(() => {
      e.progress || (t.value = setInterval(() => {
        a.value >= 100 && (clearInterval(t.value), a.value = 100), a.value = Math.min(a.value + Math.ceil(Math.random() * 10 * 30), 100);
      }, 200));
    }), qa(() => {
      clearInterval(t.value);
    }), (r, i) => (y(), S("div", Q0, [
      H("div", null, [
        H("img", {
          alt: "Loading",
          src: A(G0)
        }, null, 8, Z0),
        r.hideProgress ? W("", !0) : (y(), S("div", X0, [
          H("div", {
            class: "progress-bar",
            role: "progressbar",
            style: Ee({ width: `${n.value}%` }),
            title: "Loading"
          }, null, 4)
        ]))
      ])
    ]));
  }
}), ew = /* @__PURE__ */ Me(J0, [["__scopeId", "data-v-bc7e2b16"]]), tw = {
  class: "fullscreen-loading-container",
  "data-testid": "full-screen-spinner-loader"
}, aw = {
  key: 0,
  class: "progress"
}, nw = /* @__PURE__ */ se({
  __name: "FullScreenGenericSpinner",
  props: {
    progress: {},
    hideProgress: { type: Boolean },
    zIndex: {}
  },
  setup(e) {
    Yt((r) => ({
      "07a3a490": r.zIndex
    }));
    const t = L(0), a = L(0), n = b(() => e.progress !== null ? e.progress : a.value);
    return rt(() => {
      e.progress || (t.value = setInterval(() => {
        a.value >= 100 && (clearInterval(t.value), a.value = 100), a.value = Math.min(a.value + Math.ceil(Math.random() * 10 * 30), 100);
      }, 200));
    }), qa(() => {
      clearInterval(t.value);
    }), (r, i) => (y(), S("div", tw, [
      H("div", null, [
        i[0] || (i[0] = H("div", { class: "spinner-loader" }, null, -1)),
        r.hideProgress ? W("", !0) : (y(), S("div", aw, [
          H("div", {
            class: "progress-bar",
            role: "progressbar",
            style: Ee({ width: `${n.value}%` }),
            title: "Loading"
          }, null, 4)
        ]))
      ])
    ]));
  }
}), rw = /* @__PURE__ */ Me(nw, [["__scopeId", "data-v-a0d12d73"]]), Us = /* @__PURE__ */ se({
  __name: "KSkeleton",
  props: {
    type: { default: "" },
    delayMilliseconds: { default: 0 },
    cardCount: { default: 1 },
    cardMaxWidth: { default: "" },
    tableRows: { default: 6 },
    tableColumns: { default: 5 },
    progress: { default: null },
    hideProgress: { type: Boolean },
    zIndex: { default: 10500 }
  },
  setup(e) {
    const t = L(e.delayMilliseconds === 0);
    return rt(() => {
      t.value || setTimeout(() => {
        t.value = !0;
      }, e.delayMilliseconds);
    }), (a, n) => t.value ? (y(), S("div", {
      key: 0,
      class: ue(["k-skeleton", { "not-spinner": a.type !== "spinner" }])
    }, [
      a.type === "card" ? (y(), ee(q0, {
        key: 0,
        "card-count": a.cardCount,
        "max-width": a.cardMaxWidth
      }, {
        "card-header": N(() => [
          j(a.$slots, "card-header")
        ]),
        "card-content": N(() => [
          j(a.$slots, "card-content")
        ]),
        "card-footer": N(() => [
          j(a.$slots, "card-footer")
        ]),
        _: 3
      }, 8, ["card-count", "max-width"])) : a.type === "table" ? (y(), ee(U0, {
        key: 1,
        columns: a.tableColumns,
        rows: a.tableRows
      }, {
        default: N(() => [
          j(a.$slots, "default")
        ]),
        _: 3
      }, 8, ["columns", "rows"])) : a.type === "form" ? (y(), ee(j0, { key: 2 })) : a.type === "fullscreen-kong" ? (y(), ee(ew, {
        key: 3,
        "hide-progress": a.hideProgress,
        progress: a.progress,
        "z-index": a.zIndex
      }, null, 8, ["hide-progress", "progress", "z-index"])) : a.type === "fullscreen-generic" ? (y(), ee(rw, {
        key: 4,
        "hide-progress": a.hideProgress,
        progress: a.progress,
        "z-index": a.zIndex
      }, null, 8, ["hide-progress", "progress", "z-index"])) : a.type === "spinner" ? (y(), ee(A(Ri), {
        key: 5,
        class: "skeleton-spinner",
        color: `var(--kui-color-text-neutral, ${A(Fa)})`,
        title: "Loading"
      }, null, 8, ["color"])) : (y(), ee(B0, { key: 6 }))
    ], 2)) : W("", !0);
  }
}), iw = { class: "empty-state-content" }, ow = { class: "empty-state-icon" }, sw = {
  key: 0,
  class: "empty-state-title"
}, lw = {
  key: 1,
  class: "empty-state-message"
}, uw = {
  key: 0,
  class: "empty-state-action"
}, dw = /* @__PURE__ */ se({
  __name: "KEmptyState",
  props: {
    title: { default: "" },
    message: { default: "" },
    actionButtonVisible: { type: Boolean, default: !0 },
    actionButtonText: { default: "" },
    actionButtonDisabled: { type: Boolean },
    iconVariant: { default: () => xa.Default }
  },
  emits: ["click-action"],
  setup(e, { emit: t }) {
    const a = t, n = b(() => {
      switch (e.iconVariant) {
        case xa.Default:
          return zd;
        case xa.Error:
          return Lu;
        case xa.Search:
          return Nu;
        case xa.Kong:
          return Pu;
        default:
          return zd;
      }
    }), r = b(() => {
      switch (e.iconVariant) {
        case xa.Error:
          return By;
        default:
          return Fa;
      }
    });
    return (i, o) => (y(), S("div", {
      class: ue(["k-empty-state", [i.iconVariant]])
    }, [
      H("div", iw, [
        H("div", ow, [
          j(i.$slots, "icon", {}, () => [
            (y(), ee(Ye(n.value), {
              color: r.value,
              decorative: "",
              size: A(Fy)
            }, null, 8, ["color", "size"]))
          ], !0)
        ]),
        i.title || i.$slots.title ? (y(), S("div", sw, [
          j(i.$slots, "title", {}, () => [
            be(ae(i.title), 1)
          ], !0)
        ])) : W("", !0),
        i.message || i.$slots.default ? (y(), S("div", lw, [
          j(i.$slots, "default", {}, () => [
            H("p", null, ae(i.message), 1)
          ], !0)
        ])) : W("", !0)
      ]),
      i.actionButtonVisible && i.actionButtonText || i.$slots.action ? (y(), S("div", uw, [
        j(i.$slots, "action", {}, () => [
          Z(nt, {
            disabled: i.actionButtonDisabled,
            type: "button",
            onClick: o[0] || (o[0] = (u) => a("click-action"))
          }, {
            default: N(() => [
              be(ae(i.actionButtonText), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ], !0)
      ])) : W("", !0)
    ], 2));
  }
}), Xn = /* @__PURE__ */ Me(dw, [["__scopeId", "data-v-38ed174b"]]), cw = { class: "dropdown-item-trigger-label" }, Vi = "dropdown-item-trigger", fw = /* @__PURE__ */ se({
  inheritAttrs: !1,
  __name: "KDropdownItem",
  props: {
    item: { default: null },
    hasDivider: { type: Boolean },
    danger: { type: Boolean },
    disabled: { type: Boolean },
    selected: { type: Boolean },
    selectionMenuChild: { type: Boolean },
    onClick: { type: Function },
    isDangerous: { type: Boolean, default: () => {
    } }
  },
  emits: ["click", "change"],
  setup(e, { emit: t }) {
    const a = ea();
    ne(() => e.isDangerous, (c) => {
      typeof c < "u" && console.warn("KDropdownItem: `isDangerous` prop is deprecated. Please use `danger` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kdropdownmenu");
    });
    const n = t, r = b(() => {
      var c;
      return (c = e.item) != null && c.to ? "link" : typeof e.onClick < "u" || e.selectionMenuChild ? "button" : "default";
    }), i = b(() => {
      var c;
      return ((c = e.item) == null ? void 0 : c.label) || "";
    }), o = b(() => {
      var c;
      return ((c = e.item) == null ? void 0 : c.to) || void 0;
    }), u = (c) => {
      n("click", c), e.selectionMenuChild && n("change", e.item);
    }, l = b(() => {
      let c = "div";
      return r.value === "link" && o.value && typeof o.value == "string" ? c = "link" : r.value === "link" && o.value && typeof o.value == "object" ? c = "router-link" : r.value === "button" && (c = "button"), c;
    }), s = b(() => {
      const c = Object.assign({}, a);
      return delete c.class, delete c.disabled, delete c.style, c;
    }), d = b(() => ({
      link: {
        tag: "a",
        attrs: {
          // add disabled class instead of disabled attribute because disabled is not a valid attribute for links
          class: `${Vi} ${e.disabled ? "disabled" : ""}`,
          href: o.value,
          ...s.value
        }
      },
      "router-link": {
        tag: "router-link",
        onClick: u,
        attrs: {
          // add disabled class instead of disabled attribute because disabled is not a valid attribute for links
          class: `${Vi} ${e.disabled ? "disabled" : ""}`,
          to: o.value,
          ...s.value
        }
      },
      button: {
        tag: "button",
        onClick: u,
        attrs: {
          type: "button",
          // don't add disabled class because we want the disabled attribute on the button
          class: Vi,
          disabled: e.disabled,
          ...s.value
        }
      },
      div: {
        tag: "div",
        attrs: {
          // add disabled class instead of disabled attribute because disabled is not a valid attribute for div
          class: `${Vi} ${e.disabled ? "disabled" : ""}`,
          ...s.value
        }
      }
    }));
    return (c, f) => (y(), S("li", {
      class: ue(["k-dropdown-item", [{
        "has-divider": c.hasDivider,
        disabled: c.disabled,
        danger: c.danger || c.isDangerous,
        "dropdown-selected-option": c.selected
      }, c.$attrs.class, c.$attrs.style]]),
      "data-testid": "dropdown-item"
    }, [
      (y(), ee(Ye(d.value[l.value].tag), Fe({ "data-testid": "dropdown-item-trigger" }, d.value[l.value].attrs, {
        onClick: d.value[l.value].onClick
      }), {
        default: N(() => [
          H("span", cw, [
            j(c.$slots, "default", {}, () => [
              be(ae(i.value), 1)
            ], !0)
          ])
        ]),
        _: 3
      }, 16, ["onClick"]))
    ], 2));
  }
}), Wu = /* @__PURE__ */ Me(fw, [["__scopeId", "data-v-2413eb0e"]]), vw = {
  class: "dropdown-list",
  "data-testid": "dropdown-list"
}, pw = /* @__PURE__ */ se({
  __name: "KDropdown",
  props: {
    selectionMenu: { type: Boolean },
    appearance: { default: "primary" },
    triggerText: { default: "" },
    showCaret: { type: Boolean },
    width: { default: "" },
    kpopAttributes: { default: () => ({}) },
    items: { default: () => [] },
    disabled: { type: Boolean },
    disabledTooltip: { default: "" },
    label: {}
  },
  emits: ["toggleDropdown", "change"],
  setup(e, { expose: t, emit: a }) {
    var v;
    ne(() => e.appearance, (m) => {
      (m === "menu" || m === "selectionMenu") && console.warn("KDropdown: the usage for the `appearance` prop has changed. Please see the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kdropdownmenu");
    }, { immediate: !0 }), ne(() => e.label, (m) => {
      m && console.warn("KDropdown: `label` prop is deprecated. Please use `triggerText` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kdropdownmenu");
    }, { immediate: !0 });
    const n = a, r = b(() => e.disabledTooltip ? ga : "div"), i = mt("kPop"), o = {
      hideCaret: !0,
      popoverClasses: "dropdown-popover",
      popoverTimeout: 0,
      placement: "bottom-start"
    }, u = {
      ...o,
      ...e.kpopAttributes,
      width: e.width || void 0,
      popoverClasses: `${o.popoverClasses} ${((v = e.kpopAttributes) == null ? void 0 : v.popoverClasses) || ""}`
    }, l = b(() => {
      var m;
      return ((m = s.value) == null ? void 0 : m.label) || e.triggerText || e.label || "";
    }), s = L(), d = (m) => {
      e.selectionMenu && (s.value = m);
    }, c = () => {
      var m;
      (m = i.value) == null || m.hidePopover();
    }, f = (m, C, p) => {
      m.value !== p && (C(), n("toggleDropdown", m.value));
    };
    return ne(s, (m, C) => {
      m && m !== C && n("change", m);
    }), rt(() => {
      if (e.items) {
        const m = e.items.filter((C) => C.selected);
        m.length && (s.value = m[0]);
      }
    }), t({
      openDropdown: () => {
        var m;
        (m = i.value) == null || m.showPopover();
      },
      closeDropdown: c
    }), (m, C) => (y(), S("div", {
      class: ue(["k-dropdown", { "selection-dropdown-menu": m.selectionMenu }])
    }, [
      Z(Rs, null, {
        default: N(({ toggle: p, isToggled: h }) => [
          Z(ir, Fe({ ref: "kPop" }, u, {
            "close-on-popover-click": "",
            "data-testid": "dropdown-popover",
            "hide-close-icon": "",
            onClose: () => f(h, p, !1),
            onOpen: () => f(h, p, !0),
            onPopoverClick: () => f(h, p, !1)
          }), {
            content: N(() => [
              H("ul", vw, [
                j(m.$slots, "items", {
                  closeDropdown: c,
                  handleSelection: d,
                  items: m.items
                }, () => [
                  (y(!0), S(Ae, null, Le(m.items, (g, w) => {
                    var $;
                    return y(), ee(Wu, Fe({ ref_for: !0 }, g, {
                      key: `${g.label}-${w}`,
                      item: g,
                      selected: m.selectionMenu && (($ = s.value) == null ? void 0 : $.value) === g.value,
                      "selection-menu-child": m.selectionMenu,
                      onChange: d
                    }), null, 16, ["item", "selected", "selection-menu-child"]);
                  }), 128))
                ], !0)
              ])
            ]),
            default: N(() => [
              (y(), ee(Ye(r.value), {
                class: "dropdown-trigger",
                "data-testid": "dropdown-trigger",
                label: m.disabledTooltip ? m.disabledTooltip : void 0,
                "max-width": m.disabledTooltip ? "240" : void 0,
                position: m.disabledTooltip ? "bottom" : void 0
              }, {
                default: N(() => [
                  j(m.$slots, "default", {
                    isOpen: h.value
                  }, () => [
                    l.value ? (y(), ee(nt, {
                      key: 0,
                      appearance: m.appearance,
                      class: "dropdown-trigger-button",
                      "data-dropdown-trigger": "true",
                      "data-testid": "dropdown-trigger-button",
                      disabled: m.disabled
                    }, {
                      default: N(() => [
                        be(ae(l.value) + " ", 1),
                        m.showCaret ? (y(), ee(A(zs), {
                          key: 0,
                          decorative: ""
                        })) : W("", !0)
                      ]),
                      _: 1
                    }, 8, ["appearance", "disabled"])) : W("", !0)
                  ], !0)
                ]),
                _: 2
              }, 1032, ["label", "max-width", "position"]))
            ]),
            _: 2
          }, 1040, ["onClose", "onOpen", "onPopoverClick"])
        ]),
        _: 3
      })
    ], 2));
  }
}), Br = /* @__PURE__ */ Me(pw, [["__scopeId", "data-v-101d559c"]]), hw = { class: "pagination-offset-button-container" }, gw = /* @__PURE__ */ se({
  __name: "PaginationOffset",
  props: {
    previousButtonDisabled: {
      type: Boolean,
      default: !1
    },
    nextButtonDisabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["getPreviousOffset", "getNextOffset"],
  setup(e, { emit: t }) {
    const a = t;
    return (n, r) => (y(), S("div", hw, [
      Z(nt, {
        appearance: "tertiary",
        "aria-label": "Go to the previous page",
        class: "pagination-button",
        "data-testid": "previous-button",
        disabled: e.previousButtonDisabled,
        icon: "",
        size: "small",
        type: "button",
        onClick: r[0] || (r[0] = Ke((i) => a("getPreviousOffset"), ["prevent"]))
      }, {
        default: N(() => [
          Z(A(oh), { decorative: "" })
        ]),
        _: 1
      }, 8, ["disabled"]),
      Z(nt, {
        appearance: "tertiary",
        "aria-label": "Go to the next page",
        class: "pagination-button",
        "data-testid": "next-button",
        disabled: e.nextButtonDisabled,
        icon: "",
        size: "small",
        type: "button",
        onClick: r[1] || (r[1] = Ke((i) => a("getNextOffset"), ["prevent"]))
      }, {
        default: N(() => [
          Z(A(uh), { decorative: "" })
        ]),
        _: 1
      }, 8, ["disabled"])
    ]));
  }
}), mw = /* @__PURE__ */ Me(gw, [["__scopeId", "data-v-34b46660"]]);
class or {
  constructor(t) {
    Xa(this, "resizeObserver");
    Xa(this, "callback");
    this.callback = t, this.resizeObserver = new ResizeObserver((a) => {
      window.requestAnimationFrame(() => {
        !Array.isArray(a) || !a.length || t();
      });
    });
  }
  static create(t) {
    return new or(t);
  }
  observe(t) {
    !this.resizeObserver || !t || this.resizeObserver.observe(t);
  }
  unobserve(t) {
    !this.resizeObserver || !t || this.resizeObserver.unobserve(t);
  }
}
const yw = {
  class: "pagination-text large-screen",
  "data-testid": "visible-items"
}, bw = { class: "pagination-text-pages" }, ww = { class: "pagination-button-container" }, Cw = { key: 0 }, kw = {
  key: 1,
  class: "pagination-button placeholder"
}, $w = ["aria-current", "aria-label", "data-testid", "onClick"], Sw = {
  key: 2,
  class: "pagination-button placeholder"
}, Tw = { key: 3 }, Dw = { class: "page-size-select" }, Aw = {
  key: 0,
  class: "pagination-text small-screen",
  "data-testid": "visible-items"
}, Iw = { class: "pagination-text-pages" }, Ew = /* @__PURE__ */ se({
  __name: "KPagination",
  props: {
    items: { default: () => [] },
    totalCount: { default: 0 },
    pageSizes: { default: () => [15, 30, 50, 75, 100] },
    initialPageSize: { default: null },
    neighbors: { default: 1 },
    currentPage: { default: null },
    disablePageJump: { type: Boolean },
    offset: { type: Boolean },
    offsetPreviousButtonDisabled: { type: Boolean },
    offsetNextButtonDisabled: { type: Boolean }
  },
  emits: ["pageChange", "pageSizeChange", "getNextOffset", "getPreviousOffset"],
  setup(e, { emit: t }) {
    const a = {
      placement: "top"
    }, n = t, r = L(null), i = L(), o = L(e.currentPage ? e.currentPage : 1), u = L(e.initialPageSize ? e.initialPageSize : e.pageSizes[0]), l = b(() => Math.ceil(e.totalCount / u.value)), s = e.pageSizes.map((_, te) => ({
      label: `${_}`,
      key: `size-${te}`,
      value: _,
      selected: _ === u.value
    })), d = b(() => `${u.value} ${u.value === 1 ? "item per page" : " items per page"}`), c = L(e.neighbors), f = L(3), v = async () => (await gt(), r.value ? r.value.scrollWidth > r.value.clientWidth : !1), m = async () => {
      await v() && (c.value > 1 || f.value > 1) && (c.value > 1 ? c.value-- : f.value > 1 && f.value--, x.value = C(o.value, l.value, F.value, q.value));
    }, C = (_, te, G, pe) => {
      if (e.disablePageJump)
        return [];
      let ce = [...Array(te).keys()].map((ge) => ge + 1);
      const $e = f.value + 2 + 2 * c.value;
      return ce.length <= $e || (G ? G && pe ? ce = ce.filter(
        (ge) => ge > _ - c.value - 1 && ge < _ + c.value + 1
      ) : G && !pe && (ce = ce.filter((ge) => ge > te - c.value * 2 - f.value)) : ce = ce.filter((ge) => ge <= c.value * 2 + f.value)), ce;
    }, p = L(o.value === 1), h = L(o.value === l.value), g = b(() => (o.value - 1) * u.value + 1), w = b(() => {
      const _ = g.value - 1 + u.value;
      return _ > e.totalCount ? e.totalCount : _;
    }), $ = b(() => `${g.value} to ${w.value}`), T = b(() => ` of ${e.totalCount}`), O = b(() => e.currentPage ? e.currentPage : o.value), M = b(() => 5 + 2 * c.value), F = L(O.value >= c.value + (f.value + 1) && l.value > M.value), q = L(l.value > f.value + 2 + 2 * c.value), x = L(C(
      O.value,
      l.value,
      F.value,
      q.value
    )), Y = () => {
      o.value++, P();
    }, R = () => {
      o.value--, P();
    }, k = (_) => {
      o.value = _, P();
    }, P = () => {
      const _ = (o.value - 1) * u.value + u.value;
      h.value = _ >= e.totalCount, p.value = o.value === 1, l.value <= M.value ? (F.value = !1, q.value = !1) : (F.value = o.value >= c.value + (f.value + 1), q.value = o.value <= l.value - c.value - f.value), x.value = C(o.value, l.value, F.value, q.value), n("pageChange", {
        page: o.value,
        pageCount: l.value,
        firstItem: g.value,
        lastItem: w.value,
        visibleItems: e.items.slice(g.value - 1, w.value)
      });
    }, D = (_) => {
      u.value !== _.value && (u.value = _.value, n("pageSizeChange", {
        pageSize: u.value,
        pageCount: l.value
      }), e.currentPage !== 1 && k(1));
    }, B = () => {
      n("getNextOffset");
    }, J = () => {
      n("getPreviousOffset");
    };
    return ne(() => e.currentPage, (_, te) => {
      _ !== te && _ && k(_);
    }), ne(l, (_, te) => {
      _ !== te && (h.value = o.value === _, q.value = _ > f.value + 2 + 2 * c.value, x.value = C(
        O.value,
        _,
        !1,
        q.value
      ));
    }), ne(x, () => {
      !e.disablePageJump && !e.offset && m();
    }), rt(() => {
      !e.disablePageJump && !e.offset && (i.value = or.create(m), i.value.observe(r.value));
    }), cn(() => {
      var _;
      !e.disablePageJump && !e.offset && ((_ = i.value) == null || _.unobserve(r.value));
    }), (_, te) => (y(), S("nav", {
      ref_key: "kPaginationElement",
      ref: r,
      class: ue(["k-pagination", { "page-jump": !_.disablePageJump && !_.offset }]),
      "data-testid": "k-pagination"
    }, [
      _.offset ? (y(), ee(mw, {
        key: 1,
        "next-button-disabled": _.offsetNextButtonDisabled,
        "previous-button-disabled": _.offsetPreviousButtonDisabled,
        onGetNextOffset: B,
        onGetPreviousOffset: J
      }, null, 8, ["next-button-disabled", "previous-button-disabled"])) : (y(), S(Ae, { key: 0 }, [
        H("span", yw, [
          H("span", bw, ae($.value), 1),
          be(" " + ae(T.value), 1)
        ]),
        H("ul", ww, [
          H("li", null, [
            Z(nt, {
              appearance: "tertiary",
              "aria-label": "Go to the previous page",
              class: "pagination-button arrow",
              "data-testid": "previous-button",
              disabled: p.value,
              icon: "",
              size: "small",
              type: "button",
              onClick: R
            }, {
              default: N(() => [
                Z(A(oh), {
                  class: "pagination-arrow-icon",
                  decorative: ""
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          !_.disablePageJump && F.value ? (y(), S("li", Cw, [
            H("button", {
              "aria-label": "Go to the first page",
              class: "pagination-button",
              "data-testid": "page-1-button",
              type: "button",
              onClick: te[0] || (te[0] = (G) => k(1))
            }, " 1 ")
          ])) : W("", !0),
          !_.disablePageJump && F.value ? (y(), S("li", kw, " ... ")) : W("", !0),
          (y(!0), S(Ae, null, Le(x.value, (G) => (y(), S("li", { key: G }, [
            H("button", {
              "aria-current": G == O.value && "page" || void 0,
              "aria-label": `Go to page ${G}`,
              class: ue(["pagination-button", { active: G == O.value }]),
              "data-testid": `page-${G}-button`,
              type: "button",
              onClick: (pe) => k(G)
            }, ae(G), 11, $w)
          ]))), 128)),
          !_.disablePageJump && q.value ? (y(), S("li", Sw, " ... ")) : W("", !0),
          !_.disablePageJump && q.value ? (y(), S("li", Tw, [
            H("button", {
              "aria-label": "Go to the last page",
              class: "pagination-button",
              "data-testid": "last-button",
              type: "button",
              onClick: te[1] || (te[1] = (G) => k(l.value))
            }, ae(l.value), 1)
          ])) : W("", !0),
          H("li", null, [
            Z(nt, {
              appearance: "tertiary",
              "aria-label": "Go to the next page",
              class: "pagination-button arrow",
              "data-testid": "next-button",
              disabled: h.value ? !0 : void 0,
              icon: "",
              size: "small",
              type: "button",
              onClick: Y
            }, {
              default: N(() => [
                Z(A(uh), {
                  class: "pagination-arrow-icon",
                  decorative: ""
                })
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ], 64)),
      H("div", Dw, [
        !_.disablePageJump && !_.offset ? (y(), S("span", Aw, [
          H("span", Iw, ae($.value), 1),
          be(" " + ae(T.value), 1)
        ])) : W("", !0),
        Z(Br, {
          class: "page-size-dropdown",
          "data-testid": "page-size-dropdown",
          disabled: A(s).length <= 1,
          items: A(s),
          "kpop-attributes": a,
          "selection-menu": "",
          onChange: D
        }, {
          default: N(() => [
            Z(nt, {
              appearance: "tertiary",
              class: "page-size-dropdown-trigger",
              "data-testid": "page-size-dropdown-trigger",
              disabled: A(s).length <= 1,
              size: "small",
              type: "button"
            }, {
              default: N(() => [
                be(ae(d.value) + " ", 1),
                A(s).length > 1 ? (y(), ee(A(zs), {
                  key: 0,
                  decorative: ""
                })) : W("", !0)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        }, 8, ["disabled", "items"])
      ])
    ], 2));
  }
}), Vs = /* @__PURE__ */ Me(Ew, [["__scopeId", "data-v-4c877fe6"]]), Mw = /* @__PURE__ */ se({
  __name: "KCatalogItem",
  props: {
    item: {},
    truncate: { type: Boolean, default: !0 }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const a = t, n = (r) => {
      a("click", {
        evt: r,
        item: e.item
      });
    };
    return (r, i) => (y(), ee(Ih, {
      class: "k-catalog-item",
      "data-testid": r.item && r.item.title ? `${r.item.title.replace(/[^0-9a-z]/gi, "-")}-catalog-item` : "catalog-item",
      role: "button",
      tabindex: "0",
      onClick: n
    }, {
      title: N(() => [
        j(r.$slots, "card-title", {}, () => [
          be(ae(r.item ? r.item.title : ""), 1)
        ], !0)
      ]),
      actions: N(() => [
        j(r.$slots, "card-actions", {}, void 0, !0)
      ]),
      footer: N(() => [
        j(r.$slots, "card-footer", {}, void 0, !0)
      ]),
      default: N(() => [
        H("div", {
          class: ue({ "multi-line-truncate": r.truncate })
        }, [
          j(r.$slots, "card-body", {}, () => [
            be(ae(r.item ? r.item.description : ""), 1)
          ], !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["data-testid"]));
  }
}), Oh = /* @__PURE__ */ Me(Mw, [["__scopeId", "data-v-fd663621"]]), Ow = { class: "k-catalog" }, xw = {
  key: 1,
  class: "catalog-toolbar",
  "data-testid": "catalog-toolbar"
}, Pw = {
  key: 3,
  class: "catalog-error-state",
  "data-testid": "catalog-error-state"
}, Nw = {
  key: 4,
  class: "catalog-empty-state",
  "data-testid": "catalog-empty-state"
}, Lw = ["data-tableid"], Mc = 15, Bw = /* @__PURE__ */ se({
  __name: "KCatalog",
  props: {
    titleTag: { default: "div" },
    loading: { type: Boolean },
    cardSize: { default: "medium" },
    title: { default: "" },
    truncateDescription: { type: Boolean, default: !0 },
    emptyStateTitle: { default: "No Data" },
    emptyStateMessage: { default: "There is no data to display." },
    emptyStateActionRoute: { default: "" },
    emptyStateActionMessage: { default: "" },
    emptyStateIconVariant: { default: "default" },
    error: { type: Boolean },
    errorStateTitle: { default: "An error occurred" },
    errorStateMessage: { default: "Data cannot be displayed due to an error." },
    errorStateActionRoute: { default: "" },
    errorStateActionMessage: { default: "" },
    fetcher: { type: Function },
    initialFetcherParams: { default: null },
    cacheIdentifier: { default: "" },
    fetcherCacheKey: { default: "" },
    searchInput: { default: "" },
    paginationNeighbors: { default: 1 },
    paginationPageSizes: { default: () => [15, 30, 50, 75, 100] },
    paginationTotalItems: { default: null },
    disablePaginationPageJump: { type: Boolean },
    disablePagination: { type: Boolean },
    hidePaginationWhenOptional: { type: Boolean },
    paginationOffset: { type: Boolean }
  },
  emits: ["card-click", "error-action-click", "empty-state-action-click", "update:catalog-preferences", "state"],
  setup(e, { emit: t }) {
    const { useRequest: a, useDebounce: n, useSwrvState: r } = Nn(), i = t, o = Tt(), u = bt(), l = () => {
      var le;
      const ie = (le = e.paginationPageSizes) == null ? void 0 : le[0];
      return ie || Mc;
    }, s = L([]), d = L(0), c = L(""), f = L(1), v = L(l()), m = L(null), C = L([]), p = b(() => C.value[f.value - 1]), h = L(null), g = L(!0), w = L(!1), $ = b(() => !!o.toolbar), T = {
      page: 1,
      pageSize: v.value,
      query: "",
      offset: null
    }, O = b(() => (ge.value || e.loading || et.value) && !e.error), M = b(() => !O.value && s.value && !s.value.length), F = b(() => ({
      pageSize: v.value
    })), q = L(!0), x = async () => {
      var le, fe;
      const ie = await e.fetcher({
        query: e.searchInput || c.value,
        pageSize: v.value,
        page: f.value,
        offset: m.value
      });
      if (ie == null)
        throw new Error("KCatalog: Fetcher did not return data correctly.");
      return s.value = ie.data, d.value = e.paginationTotalItems || ie.total || ((le = ie.data) == null ? void 0 : le.length), e.paginationOffset && ((fe = ie.pagination) != null && fe.offset ? (h.value = ie.pagination.offset, C.value[f.value] || C.value.push(ie.pagination.offset)) : h.value = null, g.value = ie.pagination && "hasNextPage" in ie.pagination ? !!ie.pagination.hasNextPage : !0), s.value.length === 0 && f.value > 1 && (f.value = 1, C.value = [null], m.value = null), q.value = !1, ie;
    }, Y = () => {
      const ie = {
        ...T,
        ...e.initialFetcherParams
      };
      f.value = ie.page ?? T.page, v.value = ie.pageSize ?? T.pageSize, c.value = ie.query ?? T.query, e.paginationOffset && (m.value = ie.offset, C.value.push(ie.offset)), w.value = !0;
    }, R = b(() => {
      if (!e.fetcher || !w.value)
        return "";
      let ie = u;
      return e.cacheIdentifier && (ie = e.cacheIdentifier), e.fetcherCacheKey && (ie += `-${e.fetcherCacheKey}`), `k-catalog_${ie}`;
    }), k = L(""), { debouncedFn: P, generateDebouncedFn: D } = n((ie) => {
      k.value = ie;
    }, 350), B = D(0), { data: J, error: _, revalidate: te, isValidating: G } = a(
      () => R.value,
      () => x(),
      { revalidateOnFocus: !1, revalidateDebounce: 0 }
    ), { state: pe, hasData: ce, swrvState: $e } = r(J, _, G), ge = L(!0), Se = b(() => ({
      hasData: ce.value,
      state: pe.value
    })), Ue = b(() => ge.value ? "loading" : _.value ? "error" : "success"), Ne = ({ page: ie }) => {
      f.value = ie;
    }, He = ({ pageSize: ie }) => {
      C.value = [null], m.value = null, v.value = ie, f.value = 1;
    }, Xe = () => {
      f.value++, m.value = h.value;
    }, ot = () => {
      f.value--, m.value = p.value;
    }, Ge = (ie) => ie.toLowerCase().replace(/[^[a-z0-9]/gi, "-"), Je = b(() => {
      var le;
      if (!e.fetcher || e.disablePagination || !s.value || !s.value.length || e.error)
        return !1;
      const ie = ((le = e.paginationPageSizes) == null ? void 0 : le[0]) ?? Mc;
      return e.hidePaginationWhenOptional && f.value === 1 ? e.paginationOffset ? !!p.value || !!h.value || s.value.length >= ie : d.value > ie : !0;
    });
    ne(J, (ie) => {
      ie != null && ie.length && !s.value.length && (s.value = ie);
    }, { deep: !0, immediate: !0 }), ne(pe, () => {
      switch (pe.value) {
        case $e.PENDING:
          ge.value = !0;
          break;
        case $e.VALIDATING_HAS_DATA:
          ge.value = et.value;
          break;
        default:
          ge.value = !1;
          break;
      }
    }, { immediate: !0 }), ne([Se, Ue], (ie) => {
      var le;
      i("state", {
        state: ie == null ? void 0 : ie[1],
        // newData[catalogState]
        hasData: (le = ie == null ? void 0 : ie[0]) == null ? void 0 : le.hasData
        // newData[stateData].hasData
      });
    }), ne(() => e.searchInput, (ie) => {
      f.value !== 1 && (f.value = 1), ie === "" ? B(ie) : P(ie);
    }, { immediate: !0 });
    const et = L(!1);
    return ne([k, f, v], async (ie, le) => {
      const fe = le == null ? void 0 : le[0], z = ie[0], Ce = ie[1];
      z !== fe && Ce !== 1 && (f.value = 1, C.value = [null], m.value = null), w.value && !q.value && (et.value = !0, await te(), et.value = !1);
    }, { deep: !0, immediate: !0 }), ne(F, (ie) => {
      i("update:catalog-preferences", ie);
    }), rt(() => {
      Y();
    }), (ie, le) => (y(), S("div", Ow, [
      ie.title ? (y(), ee(Ye(ie.titleTag), {
        key: 0,
        class: "catalog-title",
        "data-testid": "catalog-title"
      }, {
        default: N(() => [
          be(ae(ie.title), 1)
        ]),
        _: 1
      })) : W("", !0),
      $.value ? (y(), S("div", xw, [
        j(ie.$slots, "toolbar", { state: Se.value }, void 0, !0)
      ])) : W("", !0),
      O.value ? (y(), ee(Us, {
        key: 2,
        "card-count": 4,
        class: "catalog-skeleton-loader",
        "data-testid": "catalog-skeleton-loader",
        type: "card"
      })) : ie.error ? (y(), S("div", Pw, [
        j(ie.$slots, "error-state", {}, () => [
          Z(Xn, {
            "icon-variant": "error",
            message: ie.errorStateMessage,
            title: ie.errorStateTitle
          }, yt({ _: 2 }, [
            ie.errorStateActionMessage ? {
              name: "action",
              fn: N(() => [
                Z(nt, {
                  "data-testid": Ge(ie.errorStateActionMessage),
                  to: ie.errorStateActionRoute ? ie.errorStateActionRoute : void 0,
                  onClick: le[0] || (le[0] = (fe) => i("error-action-click"))
                }, {
                  default: N(() => [
                    be(ae(ie.errorStateActionMessage), 1)
                  ]),
                  _: 1
                }, 8, ["data-testid", "to"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["message", "title"])
        ], !0)
      ])) : M.value ? (y(), S("div", Nw, [
        j(ie.$slots, "empty-state", {}, () => [
          Z(Xn, {
            "icon-variant": ie.emptyStateIconVariant,
            message: ie.emptyStateMessage,
            title: ie.emptyStateTitle
          }, yt({ _: 2 }, [
            ie.emptyStateActionMessage ? {
              name: "action",
              fn: N(() => [
                Z(nt, {
                  appearance: ie.searchInput ? "tertiary" : "primary",
                  "data-testid": Ge(ie.emptyStateActionMessage),
                  to: ie.emptyStateActionRoute ? ie.emptyStateActionRoute : void 0,
                  onClick: le[1] || (le[1] = (fe) => i("empty-state-action-click"))
                }, {
                  default: N(() => [
                    j(ie.$slots, "empty-state-action-icon", {}, void 0, !0),
                    be(" " + ae(ie.emptyStateActionMessage), 1)
                  ]),
                  _: 3
                }, 8, ["appearance", "data-testid", "to"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["icon-variant", "message", "title"])
        ], !0)
      ])) : (y(), S("div", {
        key: 5,
        class: ue(["catalog-page", `card-${ie.cardSize}`]),
        "data-tableid": A(u)
      }, [
        j(ie.$slots, "body", { data: s.value }, () => [
          (y(!0), S(Ae, null, Le(s.value, (fe, z) => (y(), ee(Oh, {
            key: fe.key ? fe.key : `catalog-${A(u)}-item-${z}`,
            class: "catalog-item",
            "data-testid": fe.id ? fe.id : `catalog-item-${z}`,
            item: fe,
            truncate: ie.truncateDescription,
            onClick: (Ce) => i("card-click", fe)
          }, {
            "card-title": N(() => [
              j(ie.$slots, "card-title", { item: fe }, () => [
                be(ae(fe.title), 1)
              ], !0)
            ]),
            "card-actions": N(() => [
              j(ie.$slots, "card-actions", { item: fe }, void 0, !0)
            ]),
            "card-body": N(() => [
              j(ie.$slots, "card-body", { item: fe }, () => [
                be(ae(fe.description), 1)
              ], !0)
            ]),
            _: 2
          }, 1032, ["data-testid", "item", "truncate", "onClick"]))), 128))
        ], !0)
      ], 10, Lw)),
      Je.value ? (y(), ee(Vs, {
        key: 6,
        class: "card-pagination",
        "current-page": f.value,
        "data-testid": "catalog-pagination",
        "disable-page-jump": ie.disablePaginationPageJump,
        "initial-page-size": v.value,
        neighbors: ie.paginationNeighbors,
        offset: ie.paginationOffset,
        "offset-next-button-disabled": !h.value || !g.value,
        "offset-previous-button-disabled": !p.value,
        "page-sizes": ie.paginationPageSizes,
        "total-count": d.value,
        onGetNextOffset: Xe,
        onGetPreviousOffset: ot,
        onPageChange: Ne,
        onPageSizeChange: He
      }, null, 8, ["current-page", "disable-page-jump", "initial-page-size", "neighbors", "offset", "offset-next-button-disabled", "offset-previous-button-disabled", "page-sizes", "total-count"])) : W("", !0)
    ]));
  }
}), Rw = /* @__PURE__ */ Me(Bw, [["__scopeId", "data-v-2935e34d"]]), Fw = /* @__PURE__ */ se({
  __name: "KLabel",
  props: {
    info: { default: "" },
    required: { type: Boolean },
    tooltipAttributes: { default: () => ({}) },
    help: { default: "" }
  },
  setup(e) {
    ne(() => e.help, (r) => {
      r && console.warn("KLabel: `help` prop is deprecated. Please use `info` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#klabel");
    }, { immediate: !0 });
    const t = Tt(), a = b(() => !!(e.help || e.info || t.tooltip)), n = bt();
    return (r, i) => (y(), S("label", {
      class: ue(["k-label", { required: r.required }])
    }, [
      j(r.$slots, "default", {}, void 0, !0),
      a.value ? (y(), ee(ga, Fe({ key: 0 }, r.tooltipAttributes, {
        class: "label-tooltip",
        "tooltip-id": A(n)
      }), {
        content: N(() => [
          j(r.$slots, "tooltip", {}, () => [
            be(ae(r.info || r.help), 1)
          ], !0)
        ]),
        default: N(() => [
          Z(A(In), {
            "aria-describedby": A(n),
            class: "tooltip-trigger-icon",
            color: `var(--kui-color-text-neutral, ${A(Fa)})`,
            tabindex: "0"
          }, null, 8, ["aria-describedby", "color"])
        ]),
        _: 3
      }, 16, ["tooltip-id"])) : W("", !0)
    ], 2));
  }
}), _a = /* @__PURE__ */ Me(Fw, [["__scopeId", "data-v-9e393f6d"]]), zw = ["id", "aria-checked"], Yw = { class: "checkbox-label-wrapper" }, Hw = {
  key: 1,
  class: "checkbox-description"
}, qw = /* @__PURE__ */ se({
  inheritAttrs: !1,
  __name: "KCheckbox",
  props: {
    modelValue: { type: Boolean },
    label: { default: "" },
    labelAttributes: { default: () => ({}) },
    description: { default: "" },
    error: { type: Boolean, default: !1 }
  },
  emits: ["change", "input", "update:modelValue"],
  setup(e, { emit: t }) {
    const a = t, n = Tt(), r = ea(), i = bt(), o = b(() => r.id ? String(r.id) : i), u = b(() => !!(e.label || n.default)), l = b(() => (r == null ? void 0 : r.disabled) !== void 0 && String(r == null ? void 0 : r.disabled) !== "false"), s = b(() => u.value && (!!e.description || !!n.description)), d = b(() => !!n.tooltip), c = b(() => {
      const C = { ...r };
      return delete C.class, C.checked = e.modelValue, C.indeterminate !== void 0 && String(C.indeterminate) !== "false" && !e.modelValue ? (delete C.checked, C.indeterminate = !0) : delete C.indeterminate, C;
    }), f = b(() => ({
      disabled: l.value,
      "has-description": s.value,
      "input-error": e.error
    })), v = b(() => c.value.indeterminate !== void 0 && String(c.value.indeterminate) !== "false");
    ne(() => e.labelAttributes, (C) => {
      C.help && console.warn("KCheckbox: `help` property of `labelAttributes` prop is deprecated. Please use `info` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#klabel");
    }, { immediate: !0 });
    const m = (C) => {
      a("change", C.target.checked), a("input", C.target.checked), a("update:modelValue", C.target.checked);
    };
    return (C, p) => (y(), S("div", {
      class: ue(["k-checkbox", [C.$attrs.class, f.value]])
    }, [
      H("div", {
        class: ue(["checkbox-input-wrapper", { "has-label": u.value }])
      }, [
        H("input", Fe({ id: o.value }, c.value, {
          "aria-checked": C.modelValue,
          class: "checkbox-input",
          type: "checkbox",
          onChange: m
        }), null, 16, zw),
        C.modelValue ? (y(), ee(A(G1), {
          key: 0,
          class: "checkbox-icon",
          "data-testid": "check-icon",
          decorative: "",
          size: A(Vt),
          tabindex: "-1"
        }, null, 8, ["size"])) : W("", !0),
        v.value && !C.modelValue ? (y(), ee(A(py), {
          key: 1,
          class: "checkbox-icon",
          "data-testid": "indeterminate-icon",
          decorative: "",
          size: A(Vt),
          tabindex: "-1"
        }, null, 8, ["size"])) : W("", !0)
      ], 2),
      H("div", Yw, [
        u.value ? (y(), ee(_a, Fe({ key: 0 }, C.labelAttributes, {
          class: "checkbox-label",
          for: o.value
        }), yt({
          default: N(() => [
            j(C.$slots, "default", {}, () => [
              be(ae(C.label), 1)
            ], !0)
          ]),
          _: 2
        }, [
          d.value ? {
            name: "tooltip",
            fn: N(() => [
              j(C.$slots, "tooltip", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["for"])) : W("", !0),
        s.value ? (y(), S("div", Hw, [
          j(C.$slots, "description", {}, () => [
            H("p", null, ae(C.description), 1)
          ], !0)
        ])) : W("", !0)
      ])
    ], 2));
  }
}), ls = /* @__PURE__ */ Me(qw, [["__scopeId", "data-v-a6d9ed7c"]]), Mr = null, { min: Vn, max: Ea, abs: Oc, floor: Ww } = Math, xh = (e, t, a) => Vn(a, Ea(t, e)), Ph = (e) => [...e].sort((t, a) => t - a), xc = typeof queueMicrotask == "function" ? queueMicrotask : (e) => {
  Promise.resolve().then(e);
}, _u = (e) => {
  let t;
  return () => (e && (t = e(), e = void 0), t);
}, Gn = -1, us = (e, t, a) => {
  const n = a ? "unshift" : "push";
  for (let r = 0; r < t; r++) e[n](Gn);
  return e;
}, ds = (e, t) => {
  const a = e.t[t];
  return a === Gn ? e.o : a;
}, _w = (e, t, a) => {
  const n = e.t[t] === Gn;
  return e.t[t] = a, e.i = Vn(t, e.i), n;
}, Ho = (e, t) => {
  if (!e.l) return 0;
  if (e.i >= t) return e.u[t];
  e.i < 0 && (e.u[0] = 0, e.i = 0);
  let a = e.i, n = e.u[a];
  for (; a < t; ) n += ds(e, a), e.u[++a] = n;
  return e.i = t, n;
}, Rn = (e, t, a = 0, n = e.l - 1) => {
  for (; a <= n; ) {
    const r = Ww((a + n) / 2), i = Ho(e, r);
    if (i <= t) {
      if (i + ds(e, r) > t) return r;
      a = r + 1;
    } else n = r - 1;
  }
  return xh(a, 0, e.l - 1);
}, Pc = (e, t, a) => {
  const n = t - e.l;
  return e.i = a ? -1 : Vn(t - 1, e.i), e.l = t, n > 0 ? (us(e.u, n), us(e.t, n, a), e.o * n) : (e.u.splice(n), (a ? e.t.splice(0, -n) : e.t.splice(n)).reduce((r, i) => r - (i === Gn ? e.o : i), 0));
}, Uw = typeof window < "u", Nh = () => document.documentElement, Vw = (e) => e.ownerDocument, Kw = (e) => e.defaultView, Lh = /* @__PURE__ */ _u(() => !!Uw && getComputedStyle(Nh()).direction === "rtl"), Bh = /* @__PURE__ */ _u(() => /iP(hone|od|ad)/.test(navigator.userAgent)), jw = /* @__PURE__ */ _u(() => "scrollBehavior" in Nh().style), Gw = (e) => !!e.p(), Qw = (e, t = 40, a = 4, n = 0, r, i = !1) => {
  let o = !!n, u = 1, l = 0, s = 0, d = 0, c = 0, f = 0, v = 0, m = 0, C = 0, p = o ? [0, Ea(n - 1, 0)] : Mr, h = [0, 0], g = 0;
  const w = ((R, k) => ({ o: k, t: us([], R), l: R, i: -1, u: us([], R) }))(e, t), $ = /* @__PURE__ */ new Set(), T = () => d - s, O = () => T() + f + c, M = (R) => ((k, P, D, B) => {
    if (B = Vn(B, k.l - 1), Ho(k, B) <= P) {
      const J = Rn(k, P + D, B);
      return [Rn(k, P, B, J), J];
    }
    {
      const J = Rn(k, P, void 0, B);
      return [J, Rn(k, P + D, J)];
    }
  })(w, R, l, h[0]), F = () => ((R) => R.l ? Ho(R, R.l - 1) + ds(R, R.l - 1) : 0)(w), q = (R) => Ho(w, R) - f, x = (R) => ds(w, R), Y = (R) => {
    R && (Bh() && m !== 0 ? f += R : c += R);
  };
  return { h: () => u, m: () => ((R) => [R.t.slice(), R.o])(w), v: () => {
    let R, k;
    return v ? [R, k] = h : ([R, k] = h = M(Ea(0, O())), p && (R = Vn(R, p[0]), k = Ea(k, p[1]))), m !== 1 && (R -= Ea(0, a)), m !== 2 && (k += Ea(0, a)), [Ea(R, 0), Vn(k, w.l - 1)];
  }, S: () => Rn(w, O()), I: () => Rn(w, O() + l), k: (R) => w.t[R] === Gn, O: () => !!p && w.t.slice(Ea(0, p[0] - 1), Vn(w.l - 1, p[1] + 1) + 1).includes(Gn), j: q, T: x, B: () => w.l, q: () => d, P: () => m !== 0, p: () => l, R: () => s, M: F, N: () => (v = c, c = 0, [v, C === 2 || T() + l >= F()]), A: (R, k) => {
    const P = [R, k];
    return $.add(P), () => {
      $.delete(P);
    };
  }, H: (R, k) => {
    let P, D, B = 0;
    switch (R) {
      case 1: {
        const J = v;
        v = 0;
        const _ = k - d, te = Oc(_);
        J && te < Oc(J) + 1 || C !== 0 || (m = _ < 0 ? 2 : 1), o && (p = Mr, o = !1), d = k, B = 4;
        const G = T();
        G >= -l && G <= F() && (B += 1, D = te > l);
        break;
      }
      case 2:
        B = 8, m !== 0 && (P = !0, B += 1), m = 0, C = 0, p = Mr;
        break;
      case 3: {
        const J = k.filter(([_, te]) => w.t[_] !== te);
        if (!J.length) break;
        Y(J.reduce((_, [te, G]) => ((C === 2 || (p ? !o && te < p[0] : q(te) + (m === 0 && C === 0 ? x(te) : 0) < T())) && (_ += G - x(te)), _), 0));
        for (const [_, te] of J) {
          const G = x(_), pe = _w(w, _, te);
          i && (g += pe ? te : te - G);
        }
        i && l && g > l && (Y(((_, te) => {
          let G = 0;
          const pe = [];
          _.t.forEach((Ne, He) => {
            Ne !== Gn && (pe.push(Ne), He < te && G++);
          }), _.i = -1;
          const ce = Ph(pe), $e = ce.length, ge = $e / 2 | 0, Se = $e % 2 == 0 ? (ce[ge - 1] + ce[ge]) / 2 : ce[ge], Ue = _.o;
          return ((_.o = Se) - Ue) * Ea(te - G, 0);
        })(w, Rn(w, O()))), i = !1), B = 3, D = !0;
        break;
      }
      case 4:
        l !== k && (l = k, B = 3);
        break;
      case 5:
        k[1] ? (Y(Pc(w, k[0], !0)), C = 2, B = 1) : (Pc(w, k[0]), B = 1);
        break;
      case 6:
        s = k;
        break;
      case 7:
        C = 1;
        break;
      case 8:
        p = M(k), B = 1;
    }
    B && (u = 1 + (2147483647 & u), P && f && (c += f, f = 0), $.forEach(([J, _]) => {
      B & J && _(D);
    }));
  } };
}, tu = setTimeout, qo = (e, t) => t && Lh() ? -e : e, Zw = (e, t, a, n, r, i) => {
  const o = Date.now;
  let u = 0, l = !1, s = !1, d = !1, c = !1;
  const f = (() => {
    let h;
    const g = () => {
      h != Mr && clearTimeout(h);
    }, w = () => {
      g(), h = tu(() => {
        h = Mr, (() => {
          if (l || s) return l = !1, void f();
          d = !1, e.H(2);
        })();
      }, 150);
    };
    return w.V = g, w;
  })(), v = () => {
    u = o(), d && (c = !0), e.H(1, n()), f();
  }, m = (h) => {
    if (l || !e.P() || h.ctrlKey) return;
    const g = o() - u;
    150 > g && 50 < g && (a ? h.deltaX : h.deltaY) && (l = !0);
  }, C = () => {
    s = !0, d = c = !1;
  }, p = () => {
    s = !1, Bh() && (d = !0);
  };
  return t.addEventListener("scroll", v), t.addEventListener("wheel", m, { passive: !0 }), t.addEventListener("touchstart", C, { passive: !0 }), t.addEventListener("touchend", p, { passive: !0 }), { C: () => {
    t.removeEventListener("scroll", v), t.removeEventListener("wheel", m), t.removeEventListener("touchstart", C), t.removeEventListener("touchend", p), f.V();
  }, F: () => {
    const [h, g] = e.N();
    h && (r(qo(h, a), g, c), c = !1, g && e.p() > e.M() && e.H(1, n()));
  } };
}, Xw = (e) => {
  let t;
  return { J(a) {
    (t || (t = new (Kw(Vw(a))).ResizeObserver(e))).observe(a);
  }, L(a) {
    t.unobserve(a);
  }, C() {
    t && t.disconnect();
  } };
}, Jw = /* @__PURE__ */ se({ props: { W: { type: Object, required: !0 }, X: { type: Object, required: !0 }, Y: { type: Object, required: !0 }, U: { type: Function, required: !0 }, D: { type: Number, required: !0 }, G: { type: Boolean }, K: { type: Boolean }, Z: { type: String, required: !0 }, ee: Object }, setup(e) {
  const t = L(), a = b(() => e.W.value && e.X.j(e.D)), n = b(() => e.W.value && e.X.k(e.D));
  return ne(() => t.value && e.D, (r, i, o) => {
    o(e.U(t.value, e.D));
  }, { flush: "post" }), () => {
    var r;
    const { Y: i, G: o, K: u, Z: l } = e, s = n.value, { style: d, ...c } = (r = e.ee) !== null && r !== void 0 ? r : {}, f = { position: s && u ? void 0 : "absolute", [o ? "height" : "width"]: "100%", [o ? "top" : "left"]: "0px", [o ? Lh() ? "right" : "left" : "top"]: a.value + "px", visibility: !s || u ? "visible" : "hidden", ...d };
    return o && (f.display = "flex"), Z(l, Fe({ ref: t, style: f }, c), typeof (v = i) == "function" || Object.prototype.toString.call(v) === "[object Object]" && !Jp(v) ? i : { default: () => [i], _: 2 }, 16, ["style"]);
    var v;
  };
} }), e2 = (e, t) => {
  const a = e.key;
  return a ?? "_" + t;
}, t2 = (e, t) => e[0] === t[0] && e[1] === t[1], Nc = /* @__PURE__ */ se({ props: { data: { type: Array, required: !0 }, overscan: Number, itemSize: Number, shift: Boolean, horizontal: Boolean, startMargin: { type: Number, default: 0 }, ssrCount: Number, scrollRef: Object, as: { type: String, default: "div" }, item: { type: String, default: "div" }, itemProps: Function, keepMounted: Array }, emits: ["scroll", "scrollEnd"], setup(e, { emit: t, expose: a, slots: n }) {
  let r = !!e.ssrCount;
  const i = e.horizontal, o = L(), u = Qw(e.data.length, e.itemSize, e.overscan, e.ssrCount, 0, !e.itemSize), l = ((h, g) => {
    let w;
    const $ = g ? "width" : "height", T = /* @__PURE__ */ new WeakMap(), O = Xw((M) => {
      const F = [];
      for (const { target: q, contentRect: x } of M) if (q.offsetParent) if (q === w) h.H(4, x[$]);
      else {
        const Y = T.get(q);
        Y != Mr && F.push([Y, x[$]]);
      }
      F.length && h.H(3, F);
    });
    return { te(M) {
      O.J(w = M);
    }, re: (M, F) => (T.set(M, F), O.J(M), () => {
      T.delete(M), O.L(M);
    }), oe: O.C };
  })(u, i), s = /* @__PURE__ */ ((h, g) => {
    let w, $, T;
    const O = g ? "scrollLeft" : "scrollTop", M = g ? "overflowX" : "overflowY", F = async (q, x) => {
      if (!w) return void xc(() => F(q, x));
      T && T();
      const Y = () => {
        let R;
        return [new Promise((k, P) => {
          R = k, T = P, Gw(h) && tu(P, 150);
        }), h.A(2, () => {
          R && R();
        })];
      };
      if (x && jw()) {
        for (; h.H(8, q()), h.O(); ) {
          const [R, k] = Y();
          try {
            await R;
          } catch {
            return;
          } finally {
            k();
          }
        }
        w.scrollTo({ [g ? "left" : "top"]: qo(q(), g), behavior: "smooth" });
      } else for (; ; ) {
        const [R, k] = Y();
        try {
          w[O] = qo(q(), g), h.H(7), await R;
        } catch {
          return;
        } finally {
          k();
        }
      }
    };
    return { ne(q) {
      w = q, $ = Zw(h, q, g, () => qo(q[O], g), (x, Y, R) => {
        if (R) {
          const k = q.style, P = k[M];
          k[M] = "hidden", tu(() => {
            k[M] = P;
          });
        }
        Y ? (q[O] = h.q() + x, T && T()) : q[O] += x;
      });
    }, oe() {
      $ && $.C();
    }, se(q) {
      F(() => q);
    }, ie(q) {
      q += h.q(), F(() => q);
    }, le(q, { align: x, smooth: Y, offset: R = 0 } = {}) {
      if (q = xh(q, 0, h.B() - 1), x === "nearest") {
        const k = h.j(q), P = h.q();
        if (k < P) x = "start";
        else {
          if (!(k + h.T(q) > P + h.p())) return;
          x = "end";
        }
      }
      F(() => R + h.R() + h.j(q) + (x === "end" ? h.T(q) - h.p() : x === "center" ? (h.T(q) - h.p()) / 2 : 0), Y);
    }, ce: () => {
      $ && $.F();
    } };
  })(u, i), d = L(u.h()), c = u.A(1, () => {
    d.value = u.h();
  }), f = u.A(4, () => {
    t("scroll", u.q());
  }), v = u.A(8, () => {
    t("scrollEnd");
  }), m = b((h) => {
    d.value;
    const g = u.v();
    return h && t2(h, g) ? h : g;
  }), C = b(() => d.value && u.P()), p = b(() => d.value && u.M());
  return rt(() => {
    r = !1, xc(() => {
      const h = (g) => {
        l.te(g), s.ne(g);
      };
      e.scrollRef ? h(e.scrollRef) : h(o.value.parentElement);
    });
  }), qa(() => {
    c(), f(), v(), l.oe(), s.oe();
  }), ne(() => e.data.length, (h) => {
    u.H(5, [h, e.shift]);
  }), ne(() => e.startMargin, (h) => {
    u.H(6, h);
  }, { immediate: !0 }), ne([d], () => {
    s.ce();
  }, { flush: "post" }), a({ get scrollOffset() {
    return u.q();
  }, get scrollSize() {
    return ((h) => Ea(h.M(), h.p()))(u);
  }, get viewportSize() {
    return u.p();
  }, findStartIndex: u.S, findEndIndex: u.I, getItemOffset: u.j, getItemSize: u.T, scrollToIndex: s.le, scrollTo: s.se, scrollBy: s.ie }), () => {
    const h = e.as, g = e.item, [w, $] = m.value, T = p.value, O = [];
    function M(q) {
      var x;
      const Y = n.default({ item: e.data[q], index: q })[0];
      return Z(Jw, { key: e2(Y, q), W: d, X: u, U: l.re, D: q, Y, G: i, K: r, Z: g, ee: (x = e.itemProps) === null || x === void 0 ? void 0 : x.call(e, { item: e.data[q], index: q }) }, null, 8, ["W", "X", "U", "D", "Y", "G", "K", "Z", "ee"]);
    }
    for (let q = w, x = $; q <= x; q++) O.push(M(q));
    if (e.keepMounted) {
      const q = [], x = [];
      Ph(e.keepMounted).forEach((Y) => {
        Y < w && q.push(M(Y)), Y > $ && x.push(M(Y));
      }), O.unshift(...q), O.push(...x);
    }
    return Z(h, { ref: o, style: { overflowAnchor: "none", flex: "none", position: "relative", visibility: "hidden", width: i ? T + "px" : "100%", height: i ? "100%" : T + "px", pointerEvents: C.value ? "none" : void 0 } }, typeof (F = O) == "function" || Object.prototype.toString.call(F) === "[object Object]" && !Jp(F) ? O : { default: () => [O], _: 2 }, 8, ["style"]);
    var F;
  };
} });
var Rh = typeof global == "object" && global && global.Object === Object && global, a2 = typeof self == "object" && self && self.Object === Object && self, Ua = Rh || a2 || Function("return this")(), On = Ua.Symbol, Fh = Object.prototype, n2 = Fh.hasOwnProperty, r2 = Fh.toString, ni = On ? On.toStringTag : void 0;
function i2(e) {
  var t = n2.call(e, ni), a = e[ni];
  try {
    e[ni] = void 0;
    var n = !0;
  } catch {
  }
  var r = r2.call(e);
  return n && (t ? e[ni] = a : delete e[ni]), r;
}
var o2 = Object.prototype, s2 = o2.toString;
function l2(e) {
  return s2.call(e);
}
var u2 = "[object Null]", d2 = "[object Undefined]", Lc = On ? On.toStringTag : void 0;
function Vr(e) {
  return e == null ? e === void 0 ? d2 : u2 : Lc && Lc in Object(e) ? i2(e) : l2(e);
}
function Rr(e) {
  return e != null && typeof e == "object";
}
var c2 = "[object Symbol]";
function Ks(e) {
  return typeof e == "symbol" || Rr(e) && Vr(e) == c2;
}
function zh(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length, r = Array(n); ++a < n; )
    r[a] = t(e[a], a, e);
  return r;
}
var rn = Array.isArray, Bc = On ? On.prototype : void 0, Rc = Bc ? Bc.toString : void 0;
function Yh(e) {
  if (typeof e == "string")
    return e;
  if (rn(e))
    return zh(e, Yh) + "";
  if (Ks(e))
    return Rc ? Rc.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var f2 = /\s/;
function v2(e) {
  for (var t = e.length; t-- && f2.test(e.charAt(t)); )
    ;
  return t;
}
var p2 = /^\s+/;
function h2(e) {
  return e && e.slice(0, v2(e) + 1).replace(p2, "");
}
function on(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Fc = NaN, g2 = /^[-+]0x[0-9a-f]+$/i, m2 = /^0b[01]+$/i, y2 = /^0o[0-7]+$/i, b2 = parseInt;
function zc(e) {
  if (typeof e == "number")
    return e;
  if (Ks(e))
    return Fc;
  if (on(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = on(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = h2(e);
  var a = m2.test(e);
  return a || y2.test(e) ? b2(e.slice(2), a ? 2 : 8) : g2.test(e) ? Fc : +e;
}
function w2(e) {
  return e;
}
var C2 = "[object AsyncFunction]", k2 = "[object Function]", $2 = "[object GeneratorFunction]", S2 = "[object Proxy]";
function Hh(e) {
  if (!on(e))
    return !1;
  var t = Vr(e);
  return t == k2 || t == $2 || t == C2 || t == S2;
}
var hl = Ua["__core-js_shared__"], Yc = function() {
  var e = /[^.]+$/.exec(hl && hl.keys && hl.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function T2(e) {
  return !!Yc && Yc in e;
}
var D2 = Function.prototype, A2 = D2.toString;
function sr(e) {
  if (e != null) {
    try {
      return A2.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var I2 = /[\\^$.*+?()[\]{}|]/g, E2 = /^\[object .+?Constructor\]$/, M2 = Function.prototype, O2 = Object.prototype, x2 = M2.toString, P2 = O2.hasOwnProperty, N2 = RegExp(
  "^" + x2.call(P2).replace(I2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function L2(e) {
  if (!on(e) || T2(e))
    return !1;
  var t = Hh(e) ? N2 : E2;
  return t.test(sr(e));
}
function B2(e, t) {
  return e == null ? void 0 : e[t];
}
function lr(e, t) {
  var a = B2(e, t);
  return L2(a) ? a : void 0;
}
var au = lr(Ua, "WeakMap"), Hc = function() {
  try {
    var e = lr(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), R2 = 9007199254740991, F2 = /^(?:0|[1-9]\d*)$/;
function Uu(e, t) {
  var a = typeof e;
  return t = t ?? R2, !!t && (a == "number" || a != "symbol" && F2.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function qh(e, t, a) {
  t == "__proto__" && Hc ? Hc(e, t, {
    configurable: !0,
    enumerable: !0,
    value: a,
    writable: !0
  }) : e[t] = a;
}
function Vu(e, t) {
  return e === t || e !== e && t !== t;
}
var z2 = Object.prototype, Y2 = z2.hasOwnProperty;
function H2(e, t, a) {
  var n = e[t];
  (!(Y2.call(e, t) && Vu(n, a)) || a === void 0 && !(t in e)) && qh(e, t, a);
}
var q2 = 9007199254740991;
function Ku(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= q2;
}
function Wh(e) {
  return e != null && Ku(e.length) && !Hh(e);
}
var W2 = Object.prototype;
function _h(e) {
  var t = e && e.constructor, a = typeof t == "function" && t.prototype || W2;
  return e === a;
}
function _2(e, t) {
  for (var a = -1, n = Array(e); ++a < e; )
    n[a] = t(a);
  return n;
}
var U2 = "[object Arguments]";
function qc(e) {
  return Rr(e) && Vr(e) == U2;
}
var Uh = Object.prototype, V2 = Uh.hasOwnProperty, K2 = Uh.propertyIsEnumerable, Vh = qc(/* @__PURE__ */ function() {
  return arguments;
}()) ? qc : function(e) {
  return Rr(e) && V2.call(e, "callee") && !K2.call(e, "callee");
};
function j2() {
  return !1;
}
var Kh = typeof exports == "object" && exports && !exports.nodeType && exports, Wc = Kh && typeof module == "object" && module && !module.nodeType && module, G2 = Wc && Wc.exports === Kh, _c = G2 ? Ua.Buffer : void 0, Q2 = _c ? _c.isBuffer : void 0, nu = Q2 || j2, Z2 = "[object Arguments]", X2 = "[object Array]", J2 = "[object Boolean]", eC = "[object Date]", tC = "[object Error]", aC = "[object Function]", nC = "[object Map]", rC = "[object Number]", iC = "[object Object]", oC = "[object RegExp]", sC = "[object Set]", lC = "[object String]", uC = "[object WeakMap]", dC = "[object ArrayBuffer]", cC = "[object DataView]", fC = "[object Float32Array]", vC = "[object Float64Array]", pC = "[object Int8Array]", hC = "[object Int16Array]", gC = "[object Int32Array]", mC = "[object Uint8Array]", yC = "[object Uint8ClampedArray]", bC = "[object Uint16Array]", wC = "[object Uint32Array]", ft = {};
ft[fC] = ft[vC] = ft[pC] = ft[hC] = ft[gC] = ft[mC] = ft[yC] = ft[bC] = ft[wC] = !0;
ft[Z2] = ft[X2] = ft[dC] = ft[J2] = ft[cC] = ft[eC] = ft[tC] = ft[aC] = ft[nC] = ft[rC] = ft[iC] = ft[oC] = ft[sC] = ft[lC] = ft[uC] = !1;
function CC(e) {
  return Rr(e) && Ku(e.length) && !!ft[Vr(e)];
}
function kC(e) {
  return function(t) {
    return e(t);
  };
}
var jh = typeof exports == "object" && exports && !exports.nodeType && exports, yi = jh && typeof module == "object" && module && !module.nodeType && module, $C = yi && yi.exports === jh, gl = $C && Rh.process, Uc = function() {
  try {
    var e = yi && yi.require && yi.require("util").types;
    return e || gl && gl.binding && gl.binding("util");
  } catch {
  }
}(), Vc = Uc && Uc.isTypedArray, Gh = Vc ? kC(Vc) : CC, SC = Object.prototype, TC = SC.hasOwnProperty;
function Qh(e, t) {
  var a = rn(e), n = !a && Vh(e), r = !a && !n && nu(e), i = !a && !n && !r && Gh(e), o = a || n || r || i, u = o ? _2(e.length, String) : [], l = u.length;
  for (var s in e)
    (t || TC.call(e, s)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (s == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (s == "offset" || s == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (s == "buffer" || s == "byteLength" || s == "byteOffset") || // Skip index properties.
    Uu(s, l))) && u.push(s);
  return u;
}
function Zh(e, t) {
  return function(a) {
    return e(t(a));
  };
}
var DC = Zh(Object.keys, Object), AC = Object.prototype, IC = AC.hasOwnProperty;
function EC(e) {
  if (!_h(e))
    return DC(e);
  var t = [];
  for (var a in Object(e))
    IC.call(e, a) && a != "constructor" && t.push(a);
  return t;
}
function ju(e) {
  return Wh(e) ? Qh(e) : EC(e);
}
function MC(e) {
  var t = [];
  if (e != null)
    for (var a in Object(e))
      t.push(a);
  return t;
}
var OC = Object.prototype, xC = OC.hasOwnProperty;
function PC(e) {
  if (!on(e))
    return MC(e);
  var t = _h(e), a = [];
  for (var n in e)
    n == "constructor" && (t || !xC.call(e, n)) || a.push(n);
  return a;
}
function NC(e) {
  return Wh(e) ? Qh(e, !0) : PC(e);
}
var LC = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, BC = /^\w*$/;
function Gu(e, t) {
  if (rn(e))
    return !1;
  var a = typeof e;
  return a == "number" || a == "symbol" || a == "boolean" || e == null || Ks(e) ? !0 : BC.test(e) || !LC.test(e) || t != null && e in Object(t);
}
var Ii = lr(Object, "create");
function RC() {
  this.__data__ = Ii ? Ii(null) : {}, this.size = 0;
}
function FC(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var zC = "__lodash_hash_undefined__", YC = Object.prototype, HC = YC.hasOwnProperty;
function qC(e) {
  var t = this.__data__;
  if (Ii) {
    var a = t[e];
    return a === zC ? void 0 : a;
  }
  return HC.call(t, e) ? t[e] : void 0;
}
var WC = Object.prototype, _C = WC.hasOwnProperty;
function UC(e) {
  var t = this.__data__;
  return Ii ? t[e] !== void 0 : _C.call(t, e);
}
var VC = "__lodash_hash_undefined__";
function KC(e, t) {
  var a = this.__data__;
  return this.size += this.has(e) ? 0 : 1, a[e] = Ii && t === void 0 ? VC : t, this;
}
function Jn(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Jn.prototype.clear = RC;
Jn.prototype.delete = FC;
Jn.prototype.get = qC;
Jn.prototype.has = UC;
Jn.prototype.set = KC;
function jC() {
  this.__data__ = [], this.size = 0;
}
function js(e, t) {
  for (var a = e.length; a--; )
    if (Vu(e[a][0], t))
      return a;
  return -1;
}
var GC = Array.prototype, QC = GC.splice;
function ZC(e) {
  var t = this.__data__, a = js(t, e);
  if (a < 0)
    return !1;
  var n = t.length - 1;
  return a == n ? t.pop() : QC.call(t, a, 1), --this.size, !0;
}
function XC(e) {
  var t = this.__data__, a = js(t, e);
  return a < 0 ? void 0 : t[a][1];
}
function JC(e) {
  return js(this.__data__, e) > -1;
}
function ek(e, t) {
  var a = this.__data__, n = js(a, e);
  return n < 0 ? (++this.size, a.push([e, t])) : a[n][1] = t, this;
}
function fn(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
fn.prototype.clear = jC;
fn.prototype.delete = ZC;
fn.prototype.get = XC;
fn.prototype.has = JC;
fn.prototype.set = ek;
var Ei = lr(Ua, "Map");
function tk() {
  this.size = 0, this.__data__ = {
    hash: new Jn(),
    map: new (Ei || fn)(),
    string: new Jn()
  };
}
function ak(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Gs(e, t) {
  var a = e.__data__;
  return ak(t) ? a[typeof t == "string" ? "string" : "hash"] : a.map;
}
function nk(e) {
  var t = Gs(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function rk(e) {
  return Gs(this, e).get(e);
}
function ik(e) {
  return Gs(this, e).has(e);
}
function ok(e, t) {
  var a = Gs(this, e), n = a.size;
  return a.set(e, t), this.size += a.size == n ? 0 : 1, this;
}
function vn(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
vn.prototype.clear = tk;
vn.prototype.delete = nk;
vn.prototype.get = rk;
vn.prototype.has = ik;
vn.prototype.set = ok;
var sk = "Expected a function";
function Qu(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(sk);
  var a = function() {
    var n = arguments, r = t ? t.apply(this, n) : n[0], i = a.cache;
    if (i.has(r))
      return i.get(r);
    var o = e.apply(this, n);
    return a.cache = i.set(r, o) || i, o;
  };
  return a.cache = new (Qu.Cache || vn)(), a;
}
Qu.Cache = vn;
var lk = 500;
function uk(e) {
  var t = Qu(e, function(n) {
    return a.size === lk && a.clear(), n;
  }), a = t.cache;
  return t;
}
var dk = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ck = /\\(\\)?/g, fk = uk(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(dk, function(a, n, r, i) {
    t.push(r ? i.replace(ck, "$1") : n || a);
  }), t;
});
function Xh(e) {
  return e == null ? "" : Yh(e);
}
function Qs(e, t) {
  return rn(e) ? e : Gu(e, t) ? [e] : fk(Xh(e));
}
function zi(e) {
  if (typeof e == "string" || Ks(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
function Zu(e, t) {
  t = Qs(t, e);
  for (var a = 0, n = t.length; e != null && a < n; )
    e = e[zi(t[a++])];
  return a && a == n ? e : void 0;
}
function vk(e, t, a) {
  var n = e == null ? void 0 : Zu(e, t);
  return n === void 0 ? a : n;
}
function Jh(e, t) {
  for (var a = -1, n = t.length, r = e.length; ++a < n; )
    e[r + a] = t[a];
  return e;
}
var pk = Zh(Object.getPrototypeOf, Object);
function hk() {
  this.__data__ = new fn(), this.size = 0;
}
function gk(e) {
  var t = this.__data__, a = t.delete(e);
  return this.size = t.size, a;
}
function mk(e) {
  return this.__data__.get(e);
}
function yk(e) {
  return this.__data__.has(e);
}
var bk = 200;
function wk(e, t) {
  var a = this.__data__;
  if (a instanceof fn) {
    var n = a.__data__;
    if (!Ei || n.length < bk - 1)
      return n.push([e, t]), this.size = ++a.size, this;
    a = this.__data__ = new vn(n);
  }
  return a.set(e, t), this.size = a.size, this;
}
function an(e) {
  var t = this.__data__ = new fn(e);
  this.size = t.size;
}
an.prototype.clear = hk;
an.prototype.delete = gk;
an.prototype.get = mk;
an.prototype.has = yk;
an.prototype.set = wk;
function Ck(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length, r = 0, i = []; ++a < n; ) {
    var o = e[a];
    t(o, a, e) && (i[r++] = o);
  }
  return i;
}
function eg() {
  return [];
}
var kk = Object.prototype, $k = kk.propertyIsEnumerable, Kc = Object.getOwnPropertySymbols, tg = Kc ? function(e) {
  return e == null ? [] : (e = Object(e), Ck(Kc(e), function(t) {
    return $k.call(e, t);
  }));
} : eg, Sk = Object.getOwnPropertySymbols, Tk = Sk ? function(e) {
  for (var t = []; e; )
    Jh(t, tg(e)), e = pk(e);
  return t;
} : eg;
function ag(e, t, a) {
  var n = t(e);
  return rn(e) ? n : Jh(n, a(e));
}
function jc(e) {
  return ag(e, ju, tg);
}
function Dk(e) {
  return ag(e, NC, Tk);
}
var ru = lr(Ua, "DataView"), iu = lr(Ua, "Promise"), ou = lr(Ua, "Set"), Gc = "[object Map]", Ak = "[object Object]", Qc = "[object Promise]", Zc = "[object Set]", Xc = "[object WeakMap]", Jc = "[object DataView]", Ik = sr(ru), Ek = sr(Ei), Mk = sr(iu), Ok = sr(ou), xk = sr(au), bn = Vr;
(ru && bn(new ru(new ArrayBuffer(1))) != Jc || Ei && bn(new Ei()) != Gc || iu && bn(iu.resolve()) != Qc || ou && bn(new ou()) != Zc || au && bn(new au()) != Xc) && (bn = function(e) {
  var t = Vr(e), a = t == Ak ? e.constructor : void 0, n = a ? sr(a) : "";
  if (n)
    switch (n) {
      case Ik:
        return Jc;
      case Ek:
        return Gc;
      case Mk:
        return Qc;
      case Ok:
        return Zc;
      case xk:
        return Xc;
    }
  return t;
});
var ef = Ua.Uint8Array, Pk = "__lodash_hash_undefined__";
function Nk(e) {
  return this.__data__.set(e, Pk), this;
}
function Lk(e) {
  return this.__data__.has(e);
}
function cs(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.__data__ = new vn(); ++t < a; )
    this.add(e[t]);
}
cs.prototype.add = cs.prototype.push = Nk;
cs.prototype.has = Lk;
function Bk(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length; ++a < n; )
    if (t(e[a], a, e))
      return !0;
  return !1;
}
function Rk(e, t) {
  return e.has(t);
}
var Fk = 1, zk = 2;
function ng(e, t, a, n, r, i) {
  var o = a & Fk, u = e.length, l = t.length;
  if (u != l && !(o && l > u))
    return !1;
  var s = i.get(e), d = i.get(t);
  if (s && d)
    return s == t && d == e;
  var c = -1, f = !0, v = a & zk ? new cs() : void 0;
  for (i.set(e, t), i.set(t, e); ++c < u; ) {
    var m = e[c], C = t[c];
    if (n)
      var p = o ? n(C, m, c, t, e, i) : n(m, C, c, e, t, i);
    if (p !== void 0) {
      if (p)
        continue;
      f = !1;
      break;
    }
    if (v) {
      if (!Bk(t, function(h, g) {
        if (!Rk(v, g) && (m === h || r(m, h, a, n, i)))
          return v.push(g);
      })) {
        f = !1;
        break;
      }
    } else if (!(m === C || r(m, C, a, n, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
function Yk(e) {
  var t = -1, a = Array(e.size);
  return e.forEach(function(n, r) {
    a[++t] = [r, n];
  }), a;
}
function Hk(e) {
  var t = -1, a = Array(e.size);
  return e.forEach(function(n) {
    a[++t] = n;
  }), a;
}
var qk = 1, Wk = 2, _k = "[object Boolean]", Uk = "[object Date]", Vk = "[object Error]", Kk = "[object Map]", jk = "[object Number]", Gk = "[object RegExp]", Qk = "[object Set]", Zk = "[object String]", Xk = "[object Symbol]", Jk = "[object ArrayBuffer]", e$ = "[object DataView]", tf = On ? On.prototype : void 0, ml = tf ? tf.valueOf : void 0;
function t$(e, t, a, n, r, i, o) {
  switch (a) {
    case e$:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case Jk:
      return !(e.byteLength != t.byteLength || !i(new ef(e), new ef(t)));
    case _k:
    case Uk:
    case jk:
      return Vu(+e, +t);
    case Vk:
      return e.name == t.name && e.message == t.message;
    case Gk:
    case Zk:
      return e == t + "";
    case Kk:
      var u = Yk;
    case Qk:
      var l = n & qk;
      if (u || (u = Hk), e.size != t.size && !l)
        return !1;
      var s = o.get(e);
      if (s)
        return s == t;
      n |= Wk, o.set(e, t);
      var d = ng(u(e), u(t), n, r, i, o);
      return o.delete(e), d;
    case Xk:
      if (ml)
        return ml.call(e) == ml.call(t);
  }
  return !1;
}
var a$ = 1, n$ = Object.prototype, r$ = n$.hasOwnProperty;
function i$(e, t, a, n, r, i) {
  var o = a & a$, u = jc(e), l = u.length, s = jc(t), d = s.length;
  if (l != d && !o)
    return !1;
  for (var c = l; c--; ) {
    var f = u[c];
    if (!(o ? f in t : r$.call(t, f)))
      return !1;
  }
  var v = i.get(e), m = i.get(t);
  if (v && m)
    return v == t && m == e;
  var C = !0;
  i.set(e, t), i.set(t, e);
  for (var p = o; ++c < l; ) {
    f = u[c];
    var h = e[f], g = t[f];
    if (n)
      var w = o ? n(g, h, f, t, e, i) : n(h, g, f, e, t, i);
    if (!(w === void 0 ? h === g || r(h, g, a, n, i) : w)) {
      C = !1;
      break;
    }
    p || (p = f == "constructor");
  }
  if (C && !p) {
    var $ = e.constructor, T = t.constructor;
    $ != T && "constructor" in e && "constructor" in t && !(typeof $ == "function" && $ instanceof $ && typeof T == "function" && T instanceof T) && (C = !1);
  }
  return i.delete(e), i.delete(t), C;
}
var o$ = 1, af = "[object Arguments]", nf = "[object Array]", Ki = "[object Object]", s$ = Object.prototype, rf = s$.hasOwnProperty;
function l$(e, t, a, n, r, i) {
  var o = rn(e), u = rn(t), l = o ? nf : bn(e), s = u ? nf : bn(t);
  l = l == af ? Ki : l, s = s == af ? Ki : s;
  var d = l == Ki, c = s == Ki, f = l == s;
  if (f && nu(e)) {
    if (!nu(t))
      return !1;
    o = !0, d = !1;
  }
  if (f && !d)
    return i || (i = new an()), o || Gh(e) ? ng(e, t, a, n, r, i) : t$(e, t, l, a, n, r, i);
  if (!(a & o$)) {
    var v = d && rf.call(e, "__wrapped__"), m = c && rf.call(t, "__wrapped__");
    if (v || m) {
      var C = v ? e.value() : e, p = m ? t.value() : t;
      return i || (i = new an()), r(C, p, a, n, i);
    }
  }
  return f ? (i || (i = new an()), i$(e, t, a, n, r, i)) : !1;
}
function Xu(e, t, a, n, r) {
  return e === t ? !0 : e == null || t == null || !Rr(e) && !Rr(t) ? e !== e && t !== t : l$(e, t, a, n, Xu, r);
}
var u$ = 1, d$ = 2;
function c$(e, t, a, n) {
  var r = a.length, i = r;
  if (e == null)
    return !i;
  for (e = Object(e); r--; ) {
    var o = a[r];
    if (o[2] ? o[1] !== e[o[0]] : !(o[0] in e))
      return !1;
  }
  for (; ++r < i; ) {
    o = a[r];
    var u = o[0], l = e[u], s = o[1];
    if (o[2]) {
      if (l === void 0 && !(u in e))
        return !1;
    } else {
      var d = new an(), c;
      if (!(c === void 0 ? Xu(s, l, u$ | d$, n, d) : c))
        return !1;
    }
  }
  return !0;
}
function rg(e) {
  return e === e && !on(e);
}
function f$(e) {
  for (var t = ju(e), a = t.length; a--; ) {
    var n = t[a], r = e[n];
    t[a] = [n, r, rg(r)];
  }
  return t;
}
function ig(e, t) {
  return function(a) {
    return a == null ? !1 : a[e] === t && (t !== void 0 || e in Object(a));
  };
}
function v$(e) {
  var t = f$(e);
  return t.length == 1 && t[0][2] ? ig(t[0][0], t[0][1]) : function(a) {
    return a === e || c$(a, e, t);
  };
}
function p$(e, t) {
  return e != null && t in Object(e);
}
function h$(e, t, a) {
  t = Qs(t, e);
  for (var n = -1, r = t.length, i = !1; ++n < r; ) {
    var o = zi(t[n]);
    if (!(i = e != null && a(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != r ? i : (r = e == null ? 0 : e.length, !!r && Ku(r) && Uu(o, r) && (rn(e) || Vh(e)));
}
function g$(e, t) {
  return e != null && h$(e, t, p$);
}
var m$ = 1, y$ = 2;
function b$(e, t) {
  return Gu(e) && rg(t) ? ig(zi(e), t) : function(a) {
    var n = vk(a, e);
    return n === void 0 && n === t ? g$(a, e) : Xu(t, n, m$ | y$);
  };
}
function w$(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
function C$(e) {
  return function(t) {
    return Zu(t, e);
  };
}
function k$(e) {
  return Gu(e) ? w$(zi(e)) : C$(e);
}
function og(e) {
  return typeof e == "function" ? e : e == null ? w2 : typeof e == "object" ? rn(e) ? b$(e[0], e[1]) : v$(e) : k$(e);
}
function $$(e) {
  return function(t, a, n) {
    for (var r = -1, i = Object(t), o = n(t), u = o.length; u--; ) {
      var l = o[++r];
      if (a(i[l], l, i) === !1)
        break;
    }
    return t;
  };
}
var S$ = $$();
function T$(e, t) {
  return e && S$(e, t, ju);
}
var yl = function() {
  return Ua.Date.now();
}, D$ = "Expected a function", A$ = Math.max, I$ = Math.min;
function E$(e, t, a) {
  var n, r, i, o, u, l, s = 0, d = !1, c = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(D$);
  t = zc(t) || 0, on(a) && (d = !0, c = "maxWait" in a, i = c ? A$(zc(a.maxWait) || 0, t) : i, f = "trailing" in a ? !0 : f);
  function v(O) {
    var M = n, F = r;
    return n = r = void 0, s = O, o = e.apply(F, M), o;
  }
  function m(O) {
    return s = O, u = setTimeout(h, t), d ? v(O) : o;
  }
  function C(O) {
    var M = O - l, F = O - s, q = t - M;
    return c ? I$(q, i - F) : q;
  }
  function p(O) {
    var M = O - l, F = O - s;
    return l === void 0 || M >= t || M < 0 || c && F >= i;
  }
  function h() {
    var O = yl();
    if (p(O))
      return g(O);
    u = setTimeout(h, C(O));
  }
  function g(O) {
    return u = void 0, f && n ? v(O) : (n = r = void 0, o);
  }
  function w() {
    u !== void 0 && clearTimeout(u), s = 0, n = l = r = u = void 0;
  }
  function $() {
    return u === void 0 ? o : g(yl());
  }
  function T() {
    var O = yl(), M = p(O);
    if (n = arguments, r = this, l = O, M) {
      if (u === void 0)
        return m(l);
      if (c)
        return clearTimeout(u), u = setTimeout(h, t), v(l);
    }
    return u === void 0 && (u = setTimeout(h, t)), o;
  }
  return T.cancel = w, T.flush = $, T;
}
var sg = /[\\^$.*+?()[\]{}|]/g, M$ = RegExp(sg.source);
function O$(e) {
  return e = Xh(e), e && M$.test(e) ? e.replace(sg, "\\$&") : e;
}
function x$(e, t) {
  var a = {};
  return t = og(t), T$(e, function(n, r, i) {
    qh(a, r, t(n, r, i));
  }), a;
}
function P$(e, t, a, n) {
  if (!on(e))
    return e;
  t = Qs(t, e);
  for (var r = -1, i = t.length, o = i - 1, u = e; u != null && ++r < i; ) {
    var l = zi(t[r]), s = a;
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return e;
    if (r != o) {
      var d = u[l];
      s = void 0, s === void 0 && (s = on(d) ? d : Uu(t[r + 1]) ? [] : {});
    }
    H2(u, l, s), u = u[l];
  }
  return e;
}
function N$(e, t, a) {
  for (var n = -1, r = t.length, i = {}; ++n < r; ) {
    var o = t[n], u = Zu(e, o);
    a(u, o) && P$(i, Qs(o, e), u);
  }
  return i;
}
function L$(e, t) {
  if (e == null)
    return {};
  var a = zh(Dk(e), function(n) {
    return [n];
  });
  return t = og(t), N$(e, a, function(n, r) {
    return t(n, r[0]);
  });
}
const B$ = ["id", "aria-describedby", "aria-invalid", "type", "value"], R$ = ["aria-label"], F$ = ["id"], z$ = /* @__PURE__ */ se({
  inheritAttrs: !1,
  __name: "KInput",
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    labelAttributes: { default: () => ({}) },
    help: { default: "" },
    error: { type: Boolean },
    errorMessage: { default: "" },
    characterLimit: { default: null },
    hasError: { type: Boolean },
    type: { default: "text" },
    showPasswordMaskToggle: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "char-limit-exceeded"],
  setup(e, { expose: t, emit: a }) {
    Yt((D) => ({
      "691119a2": Y.value,
      bf8815ae: R.value
    })), ne(() => e.hasError, (D) => {
      D && console.warn("KInput: `hasError` prop is deprecated. Please use `error` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kinput");
    }, { immediate: !0 }), ne(() => e.labelAttributes.help, (D) => {
      D && console.warn("KInput: `help` property of `labelAttributes` prop is deprecated. Please use `info` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#klabel");
    });
    const n = a, r = mt("inputElement"), i = L(""), o = L(!1), u = L(0), { stripRequiredLabel: l } = Nn(), s = Tt(), d = ea(), c = b(() => (d == null ? void 0 : d.required) !== void 0 && String(d == null ? void 0 : d.required) !== "false"), f = bt(), v = b(() => d.id ? String(d.id) : f), m = bt(), C = b(() => l(e.label, c.value)), p = b(() => {
      var D;
      return !!((D = e.labelAttributes) != null && D.info || s["label-tooltip"]);
    }), h = b({
      get() {
        return e.modelValue;
      },
      set(D) {
        O({ target: { value: D } });
      }
    }), g = b(() => {
      const D = { ...d };
      return delete D.class, delete D.input, delete D.onInput, D;
    }), w = b(() => {
      var _, te;
      const D = ((_ = i.value) == null ? void 0 : _.toString().length) || 0, B = ((te = e.modelValue) == null ? void 0 : te.toString().length) || 0;
      let J = D;
      return !o.value && B && (J = B), !!e.characterLimit && J > e.characterLimit;
    }), $ = b(() => {
      var D, B;
      return w.value ? o.value ? `${(D = i.value) == null ? void 0 : D.toString().length} / ${e.characterLimit}` : `${(B = e.modelValue) == null ? void 0 : B.toString().length} / ${e.characterLimit}` : "";
    }), T = b(() => w.value ? $.value : (e.error || e.hasError) && e.errorMessage ? e.errorMessage : e.help);
    ne(w, (D, B) => {
      D !== B && (n("char-limit-exceeded", {
        value: i.value,
        length: i.value.length,
        characterLimit: e.characterLimit,
        limitExceeded: D
      }), u.value += 1);
    }), ne(h, (D, B) => {
      D !== B && O({ target: { value: D } });
    });
    const O = (D) => {
      var J;
      const B = JSON.parse(JSON.stringify((J = D == null ? void 0 : D.target) == null ? void 0 : J.value));
      M(B);
    }, M = (D) => {
      i.value = D, o.value = !0, n("input", D), n("update:modelValue", D);
    }, F = () => i.value || o.value ? i.value : e.modelValue;
    ne(() => e.error, (D, B) => {
      D !== B && (u.value += 1);
    });
    const q = L(null), x = L(null), Y = L(Vt), R = L(Vt), k = L(!1), P = b(() => e.type === "password" && k.value ? "text" : e.type);
    return rt(async () => {
      var D, B;
      await gt(), (D = q.value) != null && D.offsetWidth && (Y.value = q.value.offsetWidth + "px"), (B = x.value) != null && B.offsetWidth && (R.value = x.value.offsetWidth + "px");
    }), t({
      input: r
    }), (D, B) => (y(), S("div", {
      class: ue(["k-input", [D.$attrs.class, { "input-error": w.value || D.error || D.hasError }]])
    }, [
      D.label ? (y(), ee(_a, Fe({
        key: 0,
        for: v.value
      }, D.labelAttributes, { required: c.value }), yt({
        default: N(() => [
          be(ae(C.value) + " ", 1)
        ]),
        _: 2
      }, [
        p.value ? {
          name: "tooltip",
          fn: N(() => [
            j(D.$slots, "label-tooltip", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["for", "required"])) : W("", !0),
      H("div", {
        class: ue(["input-element-wrapper", { "has-before-content": D.$slots.before, "has-after-content": D.$slots.after || D.type === "password" && D.showPasswordMaskToggle }])
      }, [
        D.$slots.before ? (y(), S("div", {
          key: 0,
          ref_key: "beforeSlotElement",
          ref: q,
          class: "before-content-wrapper"
        }, [
          j(D.$slots, "before", {}, void 0, !0)
        ], 512)) : W("", !0),
        H("input", Fe({
          id: v.value,
          ref: "inputElement",
          "aria-describedby": T.value ? A(m) : void 0,
          "aria-invalid": D.error || D.hasError || w.value ? "true" : void 0,
          class: "input",
          type: P.value
        }, g.value, {
          value: F(),
          onInput: O
        }), null, 16, B$),
        D.$slots.after || D.type === "password" && D.showPasswordMaskToggle ? (y(), S("div", {
          key: 1,
          ref_key: "afterSlotElement",
          ref: x,
          class: "after-content-wrapper"
        }, [
          D.type === "password" && D.showPasswordMaskToggle ? (y(), S("button", {
            key: 0,
            "aria-label": `${k.value ? "Hide" : "Show"} value`,
            class: "mask-value-toggle-button",
            type: "button",
            onClick: B[0] || (B[0] = Ke((J) => k.value = !k.value, ["stop"])),
            onMousedown: B[1] || (B[1] = Ke(() => {
            }, ["prevent"])),
            onMouseup: B[2] || (B[2] = Ke(() => {
            }, ["prevent"]))
          }, [
            k.value ? (y(), ee(A(Ey), {
              key: 0,
              decorative: ""
            })) : (y(), ee(A(Oy), {
              key: 1,
              decorative: ""
            }))
          ], 40, R$)) : j(D.$slots, "after", { key: 1 }, void 0, !0)
        ], 512)) : W("", !0)
      ], 2),
      Z(Zt, {
        mode: "out-in",
        name: "kongponents-fade-transition"
      }, {
        default: N(() => [
          T.value ? (y(), S("p", {
            id: A(m),
            key: String(u.value),
            class: "help-text"
          }, ae(T.value), 9, F$)) : W("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), xn = /* @__PURE__ */ Me(z$, [["__scopeId", "data-v-aa672237"]]), Y$ = ["ControlLeft", "ControlRight", "ShiftLeft", "ShiftRight", "AltLeft"];
class H$ {
  constructor(t, a) {
    Xa(this, "commands");
    Xa(this, "keyMap");
    Xa(this, "boundTriggerShortcuts");
    this.commands = a, this.keyMap = Object.fromEntries(Object.entries(t).map(([n, r]) => [n.toLowerCase(), r])), this.boundTriggerShortcuts = this.triggerShortcuts.bind(this);
  }
  registerListener() {
    document == null || document.addEventListener("keydown", this.boundTriggerShortcuts);
  }
  unRegisterListener() {
    document == null || document.removeEventListener("keydown", this.boundTriggerShortcuts);
  }
  triggerShortcuts(t) {
    q$(t, this.keyMap, this.commands);
  }
}
function q$(e, t, a) {
  if (!e.code)
    return;
  const n = W$(e.code), r = [
    e.ctrlKey ? "ctrl" : "",
    e.shiftKey ? "shift" : "",
    e.altKey ? "alt" : "",
    n
  ].filter((u) => u !== "").join("+"), i = t[r];
  if (!i)
    return;
  const o = a[i];
  o.isAllowedContext && !o.isAllowedContext(e) || (o.shouldPreventDefaultAction && e.preventDefault(), !(o.isDisabled && o.isDisabled()) && o.trigger(e));
}
function W$(e) {
  return !e || Y$.includes(e) ? "" : e.replace(/^Key/, "").toLowerCase();
}
function lg(e) {
  const t = [0];
  for (let a = 0; a < e.length; a++)
    e[a] === `
` && t.push(a + 1);
  return t;
}
function su(e, t) {
  let a = 0, n = e.length - 1;
  for (; a < n; ) {
    const r = Math.floor((a + n + 1) / 2);
    e[r] <= t ? a = r : n = r - 1;
  }
  return a + 1;
}
function _$(e, t, a) {
  if (!e || !t)
    return [];
  const n = [];
  let r = 0;
  for (; ; ) {
    const i = e.indexOf(t, r);
    if (i === -1) break;
    const o = su(a, i);
    n.push(o), r = o < a.length ? a[o] : e.length;
  }
  return n;
}
function U$(e, t, a) {
  if (!e || !t)
    return [];
  const n = new RegExp(t, "sg"), r = [];
  let i;
  for (; (i = n.exec(e)) !== null; ) {
    const o = i.index, u = i.index + i[0].length - 1, l = su(a, o), s = su(a, u);
    for (let d = l; d <= s; d++)
      r[r.length - 1] !== d && r.push(d);
  }
  return r;
}
function V$(e, t, a, n = lg(e)) {
  return a ? U$(e, t, n) : _$(e, t, n);
}
const K$ = (e) => `<mark class="matched-term">${e}</mark>`, ug = /[<&]/;
function Wo(e) {
  return e.replace(/[&<]/g, (t) => t === "&" ? "&amp;" : "&lt;");
}
function of(e, t = ug, a = Wo) {
  return t.test(e) ? a(e) : e;
}
function j$(e, t, a) {
  if (!e || !t)
    return "";
  let n;
  try {
    n = new RegExp(`(?:${a ? t : O$(t)})+`, "sgi");
  } catch {
    return e;
  }
  const r = !ug.test(e);
  let i = "", o = 0, u;
  for (; (u = n.exec(e)) !== null; ) {
    const l = u.index;
    i += r ? e.slice(o, l) : Wo(e.slice(o, l)), i += K$(r ? u[0] : Wo(u[0])), o = l + u[0].length;
  }
  return i += r ? e.slice(o) : Wo(e.slice(o)), i;
}
const dg = /^\d+(?:-\d+)?(?:,\d+(?:-\d+)?)*$/;
function G$(e, t) {
  if (!dg.test(e))
    throw new Error("Invalid line number expression.");
  const a = e.split(",").map((n) => {
    const [r, i] = n.split("-").map(Number);
    return i == null ? r : [r, i];
  });
  return cg(a, t);
}
function cg(e, t) {
  const a = e.flatMap((n) => {
    if (typeof n == "number")
      return n < 1 || n > t ? [] : n;
    let [r, i] = n[0] < n[1] ? n : [n[1], n[0]];
    return r = Math.max(1, r), i = Math.min(t, i), Array.from({ length: i - r + 1 }, (o, u) => u + r);
  }).sort((n, r) => n - r);
  return Array.from(new Set(a));
}
function Q$(e, t) {
  return typeof e == "string" ? G$(e, t) : cg(e, t);
}
const Z$ = /* @__PURE__ */ se({
  inheritAttrs: !1,
  __name: "KCodeBlockIconButton",
  props: {
    theme: { default: "light" },
    active: { type: Boolean, default: !0 },
    copyTooltip: { default: "" }
  },
  setup(e) {
    const t = L(e.copyTooltip), a = ea(), n = () => {
      e.copyTooltip && (t.value = "Copied!");
    };
    return ne(t, () => {
      setTimeout(() => {
        t.value = e.copyTooltip;
      }, 3e3);
    }), (r, i) => (y(), ee(ga, {
      class: "code-block-action-tooltip",
      placement: "bottom-start",
      "popover-timeout": 300,
      text: t.value
    }, {
      default: N(() => [
        Z(nt, Fe({
          appearance: "tertiary",
          class: ["code-block-action-button", [`theme-${r.theme}`, { "code-block-action-button-active": r.active }]]
        }, A(a), {
          icon: "",
          onClick: n
        }), {
          default: N(() => [
            j(r.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }, 8, ["text"]));
  }
}), $r = /* @__PURE__ */ Me(Z$, [["__scopeId", "data-v-798b12f7"]]);
var Kp;
const X$ = typeof navigator < "u" && ("userAgentData" in navigator && navigator.userAgentData === "macOS" || ((Kp = navigator.platform) == null ? void 0 : Kp.toLowerCase().includes("mac"))), fg = typeof navigator < "u" && navigator.userAgent.includes("Firefox");
function J$(e, t) {
  return typeof CSS < "u" && CSS.supports(e, t);
}
let ji = null;
function vg() {
  if (ji !== null)
    return ji;
  if (typeof document > "u")
    return 0;
  const e = document.createElement("div");
  return e.style.width = "100px", e.style.height = "100px", e.style.overflow = "scroll", e.style.position = "absolute", e.style.top = "-9999px", document.body.appendChild(e), ji = e.offsetWidth - e.clientWidth, document.body.removeChild(e), ji;
}
const eS = ["id"], tS = {
  key: 0,
  class: "code-block-actions"
}, aS = {
  key: 0,
  class: "code-block-search-results-container"
}, nS = {
  key: 0,
  class: "code-block-search-results"
}, rS = { class: "code-block-search-actions" }, iS = {
  key: 0,
  class: "secondary-actions-wrapper"
}, oS = { class: "code-block-secondary-actions" }, sS = ["id", "href"], lS = ["innerHTML"], uS = ["id", "href"], dS = ["innerHTML"], cS = /* @__PURE__ */ se({
  __name: "KCodeBlock",
  props: {
    id: {},
    code: {},
    language: {},
    initialFilterMode: { type: Boolean },
    initialRegExpMode: { type: Boolean },
    searchable: { type: Boolean },
    highlightedLineNumbers: { default: () => [] },
    processing: { type: Boolean },
    query: { default: "" },
    showCopyButton: { type: Boolean, default: !0 },
    showLineNumbers: { type: Boolean, default: !0 },
    showLineNumberLinks: { type: Boolean },
    theme: { default: "light" },
    singleLine: { type: Boolean },
    maxHeight: { default: "none" }
  },
  emits: ["code-block-render", "matching-lines-change", "query-change", "filter-mode-change", "reg-exp-mode-change"],
  setup(e, { emit: t }) {
    Yt((le) => ({
      "464d2b86": D.value,
      "4098e79c": O.value
    }));
    const a = X$ ? "Option" : "Alt", n = E$($e, 150, { leading: !0, trailing: !0 });
    ne(() => e.highlightedLineNumbers, (le) => {
      typeof le == "string" && dg.test(le) || Array.isArray(le) && le.every((fe) => Array.isArray(fe) ? fe.length === 2 && fe.every((z) => typeof z == "number") : typeof fe == "number") || console.warn(
        "KCodeBlock: `highlightedLineNumbers` prop should be either a properly formatted string (e.g. '1,3-5,7'), an array of numbers or tuples of numbers."
      );
    }, { immediate: !0 });
    const r = t, i = Tt(), o = L(e.query), u = L(!1), l = L(e.initialRegExpMode), s = L(e.initialFilterMode), d = L(null), c = L(e.query), f = L(0), v = L([]), m = L(null), C = mt("codeBlock"), p = mt("codeBlockContent"), h = mt("codeBlockLineNumbers"), g = L(!1), w = L(!1), $ = b(() => new Set(v.value)), T = b(() => {
      var le;
      return Array.from({ length: (le = e.code) == null ? void 0 : le.split(`
`).length }, (fe, z) => z + 1);
    }), O = b(() => T.value[T.value.length - 1].toString().length + "ch"), M = b(() => e.processing || u.value), F = b(() => s.value && R.value !== ""), q = b(() => e.id.toLowerCase().replace(/\s+/g, "-"));
    function x(le) {
      return `${q.value}-L${le}`;
    }
    const Y = b(() => lg(e.code)), R = b(() => {
      var fe;
      if (c.value === "" || v.value.length === 0)
        return "";
      const le = (fe = e.code) == null ? void 0 : fe.split(`
`).filter((z, Ce) => $.value.has(Ce + 1)).join(`
`);
      return j$(le, c.value, l.value);
    }), k = b(() => !e.singleLine && e.searchable), P = b(
      () => e.singleLine ? of(e.code).replaceAll(`
`, "") : of(e.code)
    ), D = b(() => Dt(e.maxHeight));
    ne(() => e.code, async function() {
      await gt(), te(), Se();
    }), ne(() => l.value, function() {
      Se();
    }), ne(() => e.highlightedLineNumbers, function() {
      ge();
    }, { immediate: !0, deep: !0 }), ne(() => F.value, function(le) {
      var fe, z;
      typeof document > "u" || (((fe = document == null ? void 0 : document.activeElement) == null ? void 0 : fe.tagName) === "PRE" && ((z = C.value) == null || z.focus({ preventScroll: !0 })), w.value = w.value || le, g.value = g.value || !le, p.value && (p.value.scrollTop = 0));
    }, { immediate: !0 });
    const B = {
      "alt+c": "copyCode",
      "alt+f": "toggleFilterMode",
      "alt+g": "toggleFilterMode",
      "alt+r": "toggleRegExpMode",
      f3: "jumpToNextMatch",
      "shift+f3": "jumpToPreviousMatch",
      enter: "jumpToNextMatch",
      "shift+enter": "jumpToPreviousMatch"
    }, J = {
      toggleFilterMode: {
        trigger: He,
        isAllowedContext(le) {
          return C.value !== null && le.composedPath().includes(C.value);
        },
        shouldPreventDefaultAction: !0
      },
      toggleRegExpMode: {
        trigger: Ne,
        isAllowedContext(le) {
          return C.value !== null && le.composedPath().includes(C.value);
        },
        shouldPreventDefaultAction: !0
      },
      jumpToNextMatch: {
        trigger: Xe,
        isAllowedContext(le) {
          return C.value !== null && le.composedPath().includes(C.value);
        },
        isDisabled: () => v.value.length === 0 || s.value,
        shouldPreventDefaultAction: !0
      },
      jumpToPreviousMatch: {
        trigger: ot,
        isAllowedContext(le) {
          return C.value !== null && le.composedPath().includes(C.value);
        },
        isDisabled: () => v.value.length === 0 || s.value,
        shouldPreventDefaultAction: !0
      },
      copyCode: {
        trigger: Je,
        isAllowedContext(le) {
          return C.value !== null && le.composedPath().includes(C.value);
        },
        shouldPreventDefaultAction: !0
      }
    }, _ = new H$(B, J);
    rt(function() {
      _.registerListener(), te(), !e.query && e.highlightedLineNumbers.length ? ge() : Se();
    }), cn(function() {
      _.unRegisterListener();
    });
    function te() {
      var z;
      const le = (z = C.value) == null ? void 0 : z.querySelector(".highlighted-code-block"), fe = le == null ? void 0 : le.querySelector("code");
      le instanceof HTMLElement && fe instanceof HTMLElement && r("code-block-render", pe(le, fe));
    }
    function G() {
      var z;
      if (typeof HTMLElement > "u")
        return;
      const le = (z = C.value) == null ? void 0 : z.querySelector(".highlighted-code-block"), fe = le == null ? void 0 : le.querySelector("code");
      le instanceof HTMLElement && fe instanceof HTMLElement && r("matching-lines-change", pe(le, fe));
    }
    function pe(le, fe) {
      return {
        preElement: le,
        codeElement: fe,
        code: e.code,
        language: e.language,
        query: o.value,
        matchingLineNumbers: v.value
      };
    }
    function ce() {
      c.value !== o.value && (u.value = !0, n());
    }
    async function $e() {
      await gt(), r("query-change", c.value), Se();
    }
    function ge() {
      u.value = !0, d.value = null, v.value = Q$(e.highlightedLineNumbers, T.value.length), f.value = v.value.length, G(), u.value = !1;
    }
    function Se() {
      u.value = !0, d.value = null;
      let le = [];
      if (c.value.length > 0)
        try {
          le = V$(
            e.code.toLowerCase(),
            c.value.toLowerCase(),
            l.value,
            Y.value
          );
        } catch (fe) {
          if (fe instanceof Error)
            d.value = fe;
          else
            throw fe;
        }
      m.value = null, f.value = le.length, v.value = Array.from(new Set(le)), G(), u.value = !1;
    }
    function Ue() {
      c.value = "", $e();
    }
    function Ne() {
      l.value = !l.value, r("reg-exp-mode-change", l.value), l.value || (d.value = null);
    }
    function He() {
      s.value = !s.value, r("filter-mode-change", s.value);
    }
    function Xe() {
      Ge(1);
    }
    function ot() {
      Ge(-1);
    }
    function Ge(le) {
      if (v.value.length === 0 || !(C.value instanceof HTMLElement))
        return;
      typeof m.value == "number" ? m.value = (m.value + le + v.value.length) % v.value.length : m.value = 0;
      const fe = v.value[m.value];
      if (!fe)
        return;
      const z = C.value.querySelector(`.highlighted-code-block #${x(fe)}`);
      z ? "scrollIntoViewIfNeeded" in z && typeof z.scrollIntoViewIfNeeded == "function" ? z.scrollIntoViewIfNeeded(!0) : z.scrollIntoView({ block: "nearest" }) : h.value && h.value.scrollToIndex(fe - 1, { align: "center" });
    }
    async function Je(le) {
      const fe = le.target.closest("button");
      await th(e.code) && (fe == null || fe.setAttribute("data-tooltip-text", "Copied code!"), window == null || window.setTimeout(function() {
        fe == null || fe.removeAttribute("data-tooltip-text");
      }, 1500));
    }
    const et = b(() => e.theme === "light" ? Ly : Jl);
    function ie(le) {
      return {
        // These props essentially renders a structure like this:
        //
        // <span class="line-number-rows">
        //  <span class="line">...line number anchor...</span>
        // </span>
        as: "span",
        class: "line-number-rows",
        data: le ? v.value : T.value,
        item: "span",
        itemProps: ({ item: fe }) => ({
          class: ue({
            line: !0,
            "line-is-match": le ? !1 : $.value.has(fe),
            "line-is-highlighted-match": le ? !1 : m.value !== null && fe === v.value[m.value]
          })
        }),
        // slightly increase the number of items to render to avoid blank items when scrolling fast
        overscan: 8,
        // provide a fixed item height so that Virtualizer can skip estimation
        itemSize: parseInt(zy, 10),
        // the scrollable container isn't the parentElement so we need to manually provide it
        scrollRef: p.value ?? void 0,
        // to override the default `position: relative; width: 100%`.
        style: {
          position: "absolute",
          width: "auto"
        }
      };
    }
    return (le, fe) => (y(), S("div", {
      id: le.id,
      ref_key: "codeBlock",
      ref: C,
      class: ue(["k-code-block", [`theme-${le.theme}`]]),
      "data-testid": "k-code-block",
      tabindex: "-1",
      onBlur: fe[1] || (fe[1] = (z) => m.value = null)
    }, [
      k.value ? (y(), S("div", tS, [
        Z(xn, {
          modelValue: c.value,
          "onUpdate:modelValue": fe[0] || (fe[0] = (z) => c.value = z),
          "aria-label": "Search",
          autocomplete: "off",
          class: "code-block-search-input",
          "data-testid": "code-block-search-input",
          error: d.value !== null,
          "error-message": d.value !== null ? d.value.message : void 0,
          placeholder: "Search...",
          onInput: ce
        }, {
          before: N(() => [
            Z(Zt, {
              mode: "out-in",
              name: "kongponents-fade-transition"
            }, {
              default: N(() => [
                c.value ? (y(), S("button", {
                  key: 0,
                  "aria-label": "Clear query",
                  class: "clear-query-button",
                  "data-testid": "clear-query-button",
                  title: "Clear query",
                  type: "button",
                  onClick: Ue
                }, [
                  Z(A(va), { decorative: "" })
                ])) : (y(), ee(A(Nu), {
                  key: 1,
                  class: "code-block-search-icon",
                  decorative: ""
                }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "error", "error-message"]),
        Z(Zt, { name: "kongponents-fade-transition" }, {
          default: N(() => [
            M.value || c.value ? (y(), S("div", aS, [
              Z(Zt, { name: "kongponents-fade-transition" }, {
                default: N(() => [
                  M.value ? (y(), ee(A(Ri), {
                    key: 0,
                    class: "code-block-processing-icon",
                    color: et.value,
                    "data-testid": "code-block-processing-icon",
                    size: A(Ca),
                    title: "Loading"
                  }, null, 8, ["color", "size"])) : W("", !0)
                ]),
                _: 1
              }),
              c.value ? (y(), S("p", nS, [
                v.value.length === 0 ? (y(), S(Ae, { key: 0 }, [
                  be(" No results ")
                ], 64)) : typeof m.value == "number" && !F.value ? (y(), S(Ae, { key: 1 }, [
                  be(ae(m.value + 1) + " of " + ae(v.value.length), 1)
                ], 64)) : (y(), S(Ae, { key: 2 }, [
                  be(ae(v.value.length) + " " + ae(v.value.length === 1 ? "result" : "results"), 1)
                ], 64))
              ])) : W("", !0)
            ])) : W("", !0)
          ]),
          _: 1
        }),
        H("div", rS, [
          Z($r, {
            active: l.value,
            "aria-label": `Use regular expression (${A(a)}+R)`,
            "aria-pressed": l.value,
            class: "regexp-mode-button",
            "data-testid": "regexp-mode-button",
            theme: le.theme,
            title: `Use regular expression (${A(a)}+R)`,
            onClick: Ne
          }, {
            default: N(() => [
              Z(A(wy), { decorative: "" })
            ]),
            _: 1
          }, 8, ["active", "aria-label", "aria-pressed", "theme", "title"]),
          Z($r, {
            active: s.value,
            "aria-label": `Filter results (${A(a)}+F)`,
            "aria-pressed": s.value,
            class: "action-button filter-mode-button",
            "data-testid": "filter-mode-button",
            theme: le.theme,
            title: `Filter results (${A(a)}+F)`,
            onClick: He
          }, {
            default: N(() => [
              Z(A(cy), { decorative: "" })
            ]),
            _: 1
          }, 8, ["active", "aria-label", "aria-pressed", "theme", "title"]),
          Z($r, {
            "aria-label": "Previous match (Shift+F3)",
            class: "previous-match-button",
            "data-testid": "previous-match-button",
            disabled: v.value.length === 0 || s.value,
            theme: le.theme,
            title: "Previous match (Shift+F3)",
            onClick: ot
          }, {
            default: N(() => [
              Z(A(W1), { decorative: "" })
            ]),
            _: 1
          }, 8, ["disabled", "theme"]),
          Z($r, {
            "aria-label": "Next match (F3)",
            class: "next-match-button",
            "data-testid": "next-match-button",
            disabled: v.value.length === 0 || s.value,
            theme: le.theme,
            title: "Next match (F3)",
            onClick: Xe
          }, {
            default: N(() => [
              Z(A(Ou), { decorative: "" })
            ]),
            _: 1
          }, 8, ["disabled", "theme"])
        ])
      ])) : W("", !0),
      H("div", {
        ref_key: "codeBlockContent",
        ref: p,
        class: "code-block-content"
      }, [
        le.showCopyButton || i["secondary-actions"] ? (y(), S("div", iS, [
          H("div", oS, [
            le.showCopyButton ? (y(), ee($r, {
              key: 0,
              "aria-label": `Copy (${A(a)}+C)`,
              class: "code-block-copy-button",
              "copy-tooltip": `Copy (${A(a)}+C)`,
              "data-testid": `code-block-copy-button-${le.id}`,
              theme: le.theme,
              onClick: Je
            }, {
              default: N(() => [
                Z(A(lh), { decorative: "" })
              ]),
              _: 1
            }, 8, ["aria-label", "copy-tooltip", "data-testid", "theme"])) : W("", !0),
            j(le.$slots, "secondary-actions", {}, void 0, !0)
          ])
        ])) : W("", !0),
        F.value || w.value ? $a((y(), ee(Ye("pre"), {
          key: 1,
          class: ue(["filtered-code-block", {
            "show-line-numbers": le.showLineNumbers
          }]),
          "data-testid": "filtered-code-block"
        }, {
          default: N(() => [
            le.showLineNumbers && !le.singleLine ? (y(), ee(A(Nc), ra(Fe({ key: 0 }, ie(!0))), {
              default: N(({ item: z }) => [
                H("a", {
                  id: x(z),
                  class: "line-anchor",
                  href: le.showLineNumberLinks ? `#${x(z)}` : void 0
                }, ae(z), 9, sS)
              ]),
              _: 1
            }, 16)) : W("", !0),
            H("code", { innerHTML: R.value }, null, 8, lS)
          ]),
          _: 1
        }, 8, ["class"])), [
          [Nr, F.value]
        ]) : W("", !0),
        !F.value || g.value ? $a((y(), ee(Ye("pre"), {
          key: 2,
          class: ue(["highlighted-code-block", {
            "show-line-numbers": le.showLineNumbers,
            "single-line": le.singleLine
          }]),
          "data-testid": "highlighted-code-block"
        }, {
          default: N(() => [
            le.showLineNumbers && !le.singleLine ? (y(), ee(A(Nc), Fe({
              key: 0,
              ref_key: "codeBlockLineNumbers",
              ref: h
            }, ie(!1)), {
              default: N(({ item: z }) => [
                H("a", {
                  id: x(z),
                  class: ue(["line-anchor", { "hide-links": !le.showLineNumberLinks }]),
                  href: le.showLineNumberLinks ? `#${x(z)}` : void 0
                }, ae(z), 11, uS)
              ]),
              _: 1
            }, 16)) : W("", !0),
            H("code", { innerHTML: P.value }, null, 8, dS)
          ]),
          _: 1
        }, 8, ["class"])), [
          [Nr, !F.value]
        ]) : W("", !0)
      ], 512)
    ], 42, eS));
  }
}), fS = /* @__PURE__ */ Me(cS, [["__scopeId", "data-v-87854702"]]), vS = { class: "k-collapse" }, pS = { class: "collapse-trigger" }, hS = ["aria-controls", "aria-expanded", "aria-label"], gS = {
  key: 0,
  class: "collapse-trigger-label",
  "data-testid": "collapse-trigger-label"
}, mS = {
  key: 0,
  class: "collapse-visible-content",
  "data-testid": "collapse-visible-content"
}, yS = ["id"], bS = /* @__PURE__ */ se({
  __name: "KCollapse",
  props: {
    modelValue: { type: Boolean, default: !0 },
    title: { default: "" },
    titleTag: { default: "div" },
    triggerLabel: { default: "" },
    triggerAlignment: { default: "trailing" }
  },
  emits: ["toggle", "update:modelValue"],
  setup(e, { emit: t }) {
    const a = t, n = Tt(), r = bt(), i = L(!0), o = L(!1), u = b(() => e.triggerAlignment === "trailing"), l = b(() => !!n["visible-content"]), s = b({
      get() {
        return e.modelValue;
      },
      set(f) {
        c(f);
      }
    }), d = b(() => o.value ? i.value : e.modelValue), c = (f) => {
      o.value || (i.value = e.modelValue), i.value = f !== void 0 ? f : !i.value, o.value = !0, a("toggle", i.value), a("update:modelValue", i.value);
    };
    return ne(s, (f, v) => {
      f !== v && c(f);
    }), (f, v) => (y(), S("div", vS, [
      H("div", {
        class: ue(["collapse-heading", { "has-trailing-trigger": u.value }])
      }, [
        f.title || f.$slots.title ? (y(), ee(Ye(f.titleTag), {
          key: 0,
          class: "collapse-title",
          "data-testid": "collapse-title"
        }, {
          default: N(() => [
            j(f.$slots, "title", {}, () => [
              be(ae(f.title), 1)
            ], !0)
          ]),
          _: 3
        })) : W("", !0),
        H("div", pS, [
          j(f.$slots, "trigger", {
            isCollapsed: d.value,
            toggle: c
          }, () => [
            H("button", {
              "aria-controls": A(r),
              "aria-expanded": !d.value,
              "aria-label": f.triggerLabel ? void 0 : "Toggle content",
              class: "collapse-trigger-content",
              "data-testid": "collapse-trigger-content",
              type: "button",
              onClick: v[0] || (v[0] = Ke((m) => c(), ["prevent", "stop"]))
            }, [
              j(f.$slots, "trigger-content", {}, () => [
                Z(A(xu), {
                  class: ue(["collapse-trigger-icon", { "collapse-expanded": !d.value }]),
                  "data-testid": "collapse-trigger-icon",
                  decorative: "",
                  size: A(Vt)
                }, null, 8, ["class", "size"]),
                f.triggerLabel ? (y(), S("span", gS, ae(f.triggerLabel), 1)) : W("", !0)
              ], !0)
            ], 8, hS)
          ], !0)
        ])
      ], 2),
      l.value ? (y(), S("div", mS, [
        j(f.$slots, "visible-content", {}, void 0, !0)
      ])) : W("", !0),
      Z(Zt, { name: "kongponents-fade-transition" }, {
        default: N(() => [
          $a(H("div", {
            id: A(r),
            class: "collapse-hidden-content",
            "data-testid": "collapse-hidden-content"
          }, [
            j(f.$slots, "default", {}, void 0, !0)
          ], 8, yS), [
            [Nr, !d.value]
          ])
        ]),
        _: 3
      })
    ]));
  }
}), wS = /* @__PURE__ */ Me(bS, [["__scopeId", "data-v-3c78873f"]]);
function fs(e) {
  "@babel/helpers - typeof";
  return fs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, fs(e);
}
function er(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Kt(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Va(e) {
  Kt(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || fs(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function CS(e, t) {
  Kt(2, arguments);
  var a = Va(e).getTime(), n = er(t);
  return new Date(a + n);
}
var kS = {};
function Zs() {
  return kS;
}
function $S(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function SS(e) {
  return Kt(1, arguments), e instanceof Date || fs(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function TS(e) {
  if (Kt(1, arguments), !SS(e) && typeof e != "number")
    return !1;
  var t = Va(e);
  return !isNaN(Number(t));
}
function DS(e, t) {
  Kt(2, arguments);
  var a = er(t);
  return CS(e, -a);
}
var AS = 864e5;
function IS(e) {
  Kt(1, arguments);
  var t = Va(e), a = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var n = t.getTime(), r = a - n;
  return Math.floor(r / AS) + 1;
}
function vs(e) {
  Kt(1, arguments);
  var t = 1, a = Va(e), n = a.getUTCDay(), r = (n < t ? 7 : 0) + n - t;
  return a.setUTCDate(a.getUTCDate() - r), a.setUTCHours(0, 0, 0, 0), a;
}
function pg(e) {
  Kt(1, arguments);
  var t = Va(e), a = t.getUTCFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(a + 1, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = vs(n), i = /* @__PURE__ */ new Date(0);
  i.setUTCFullYear(a, 0, 4), i.setUTCHours(0, 0, 0, 0);
  var o = vs(i);
  return t.getTime() >= r.getTime() ? a + 1 : t.getTime() >= o.getTime() ? a : a - 1;
}
function ES(e) {
  Kt(1, arguments);
  var t = pg(e), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var n = vs(a);
  return n;
}
var MS = 6048e5;
function OS(e) {
  Kt(1, arguments);
  var t = Va(e), a = vs(t).getTime() - ES(t).getTime();
  return Math.round(a / MS) + 1;
}
function ps(e, t) {
  var a, n, r, i, o, u, l, s;
  Kt(1, arguments);
  var d = Zs(), c = er((a = (n = (r = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : d.weekStartsOn) !== null && n !== void 0 ? n : (l = d.locale) === null || l === void 0 || (s = l.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(c >= 0 && c <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Va(e), v = f.getUTCDay(), m = (v < c ? 7 : 0) + v - c;
  return f.setUTCDate(f.getUTCDate() - m), f.setUTCHours(0, 0, 0, 0), f;
}
function hg(e, t) {
  var a, n, r, i, o, u, l, s;
  Kt(1, arguments);
  var d = Va(e), c = d.getUTCFullYear(), f = Zs(), v = er((a = (n = (r = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : f.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = f.locale) === null || l === void 0 || (s = l.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(v >= 1 && v <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(c + 1, 0, v), m.setUTCHours(0, 0, 0, 0);
  var C = ps(m, t), p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(c, 0, v), p.setUTCHours(0, 0, 0, 0);
  var h = ps(p, t);
  return d.getTime() >= C.getTime() ? c + 1 : d.getTime() >= h.getTime() ? c : c - 1;
}
function xS(e, t) {
  var a, n, r, i, o, u, l, s;
  Kt(1, arguments);
  var d = Zs(), c = er((a = (n = (r = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : d.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = d.locale) === null || l === void 0 || (s = l.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : 1), f = hg(e, t), v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(f, 0, c), v.setUTCHours(0, 0, 0, 0);
  var m = ps(v, t);
  return m;
}
var PS = 6048e5;
function NS(e, t) {
  Kt(1, arguments);
  var a = Va(e), n = ps(a, t).getTime() - xS(a, t).getTime();
  return Math.round(n / PS) + 1;
}
function it(e, t) {
  for (var a = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return a + n;
}
var mn = {
  // Year
  y: function(t, a) {
    var n = t.getUTCFullYear(), r = n > 0 ? n : 1 - n;
    return it(a === "yy" ? r % 100 : r, a.length);
  },
  // Month
  M: function(t, a) {
    var n = t.getUTCMonth();
    return a === "M" ? String(n + 1) : it(n + 1, 2);
  },
  // Day of the month
  d: function(t, a) {
    return it(t.getUTCDate(), a.length);
  },
  // AM or PM
  a: function(t, a) {
    var n = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, a) {
    return it(t.getUTCHours() % 12 || 12, a.length);
  },
  // Hour [0-23]
  H: function(t, a) {
    return it(t.getUTCHours(), a.length);
  },
  // Minute
  m: function(t, a) {
    return it(t.getUTCMinutes(), a.length);
  },
  // Second
  s: function(t, a) {
    return it(t.getUTCSeconds(), a.length);
  },
  // Fraction of second
  S: function(t, a) {
    var n = a.length, r = t.getUTCMilliseconds(), i = Math.floor(r * Math.pow(10, n - 3));
    return it(i, a.length);
  }
}, hr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, LS = {
  // Era
  G: function(t, a, n) {
    var r = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (a) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return n.era(r, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, a, n) {
    if (a === "yo") {
      var r = t.getUTCFullYear(), i = r > 0 ? r : 1 - r;
      return n.ordinalNumber(i, {
        unit: "year"
      });
    }
    return mn.y(t, a);
  },
  // Local week-numbering year
  Y: function(t, a, n, r) {
    var i = hg(t, r), o = i > 0 ? i : 1 - i;
    if (a === "YY") {
      var u = o % 100;
      return it(u, 2);
    }
    return a === "Yo" ? n.ordinalNumber(o, {
      unit: "year"
    }) : it(o, a.length);
  },
  // ISO week-numbering year
  R: function(t, a) {
    var n = pg(t);
    return it(n, a.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, a) {
    var n = t.getUTCFullYear();
    return it(n, a.length);
  },
  // Quarter
  Q: function(t, a, n) {
    var r = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (a) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return it(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, a, n) {
    var r = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (a) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return it(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, a, n) {
    var r = t.getUTCMonth();
    switch (a) {
      case "M":
      case "MM":
        return mn.M(t, a);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, a, n) {
    var r = t.getUTCMonth();
    switch (a) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return it(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, a, n, r) {
    var i = NS(t, r);
    return a === "wo" ? n.ordinalNumber(i, {
      unit: "week"
    }) : it(i, a.length);
  },
  // ISO week of year
  I: function(t, a, n) {
    var r = OS(t);
    return a === "Io" ? n.ordinalNumber(r, {
      unit: "week"
    }) : it(r, a.length);
  },
  // Day of the month
  d: function(t, a, n) {
    return a === "do" ? n.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : mn.d(t, a);
  },
  // Day of year
  D: function(t, a, n) {
    var r = IS(t);
    return a === "Do" ? n.ordinalNumber(r, {
      unit: "dayOfYear"
    }) : it(r, a.length);
  },
  // Day of week
  E: function(t, a, n) {
    var r = t.getUTCDay();
    switch (a) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, a, n, r) {
    var i = t.getUTCDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(o);
      // Padded numerical value
      case "ee":
        return it(o, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "eee":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, a, n, r) {
    var i = t.getUTCDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      // Numerical value (same as in `e`)
      case "c":
        return String(o);
      // Padded numerical value
      case "cc":
        return it(o, a.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(o, {
          unit: "day"
        });
      case "ccc":
        return n.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, a, n) {
    var r = t.getUTCDay(), i = r === 0 ? 7 : r;
    switch (a) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return it(i, a.length);
      // 2nd
      case "io":
        return n.ordinalNumber(i, {
          unit: "day"
        });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, a, n) {
    var r = t.getUTCHours(), i = r / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, a, n) {
    var r = t.getUTCHours(), i;
    switch (r === 12 ? i = hr.noon : r === 0 ? i = hr.midnight : i = r / 12 >= 1 ? "pm" : "am", a) {
      case "b":
      case "bb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, a, n) {
    var r = t.getUTCHours(), i;
    switch (r >= 17 ? i = hr.evening : r >= 12 ? i = hr.afternoon : r >= 4 ? i = hr.morning : i = hr.night, a) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, a, n) {
    if (a === "ho") {
      var r = t.getUTCHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, {
        unit: "hour"
      });
    }
    return mn.h(t, a);
  },
  // Hour [0-23]
  H: function(t, a, n) {
    return a === "Ho" ? n.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : mn.H(t, a);
  },
  // Hour [0-11]
  K: function(t, a, n) {
    var r = t.getUTCHours() % 12;
    return a === "Ko" ? n.ordinalNumber(r, {
      unit: "hour"
    }) : it(r, a.length);
  },
  // Hour [1-24]
  k: function(t, a, n) {
    var r = t.getUTCHours();
    return r === 0 && (r = 24), a === "ko" ? n.ordinalNumber(r, {
      unit: "hour"
    }) : it(r, a.length);
  },
  // Minute
  m: function(t, a, n) {
    return a === "mo" ? n.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : mn.m(t, a);
  },
  // Second
  s: function(t, a, n) {
    return a === "so" ? n.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : mn.s(t, a);
  },
  // Fraction of second
  S: function(t, a) {
    return mn.S(t, a);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, a, n, r) {
    var i = r._originalDate || t, o = i.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (a) {
      // Hours and optional minutes
      case "X":
        return lf(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Yn(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Yn(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, a, n, r) {
    var i = r._originalDate || t, o = i.getTimezoneOffset();
    switch (a) {
      // Hours and optional minutes
      case "x":
        return lf(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Yn(o);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Yn(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, a, n, r) {
    var i = r._originalDate || t, o = i.getTimezoneOffset();
    switch (a) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + sf(o, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Yn(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, a, n, r) {
    var i = r._originalDate || t, o = i.getTimezoneOffset();
    switch (a) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + sf(o, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Yn(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, a, n, r) {
    var i = r._originalDate || t, o = Math.floor(i.getTime() / 1e3);
    return it(o, a.length);
  },
  // Milliseconds timestamp
  T: function(t, a, n, r) {
    var i = r._originalDate || t, o = i.getTime();
    return it(o, a.length);
  }
};
function sf(e, t) {
  var a = e > 0 ? "-" : "+", n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return a + String(r);
  var o = t;
  return a + String(r) + o + it(i, 2);
}
function lf(e, t) {
  if (e % 60 === 0) {
    var a = e > 0 ? "-" : "+";
    return a + it(Math.abs(e) / 60, 2);
  }
  return Yn(e, t);
}
function Yn(e, t) {
  var a = t || "", n = e > 0 ? "-" : "+", r = Math.abs(e), i = it(Math.floor(r / 60), 2), o = it(r % 60, 2);
  return n + i + a + o;
}
var uf = function(t, a) {
  switch (t) {
    case "P":
      return a.date({
        width: "short"
      });
    case "PP":
      return a.date({
        width: "medium"
      });
    case "PPP":
      return a.date({
        width: "long"
      });
    case "PPPP":
    default:
      return a.date({
        width: "full"
      });
  }
}, gg = function(t, a) {
  switch (t) {
    case "p":
      return a.time({
        width: "short"
      });
    case "pp":
      return a.time({
        width: "medium"
      });
    case "ppp":
      return a.time({
        width: "long"
      });
    case "pppp":
    default:
      return a.time({
        width: "full"
      });
  }
}, BS = function(t, a) {
  var n = t.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
  if (!i)
    return uf(t, a);
  var o;
  switch (r) {
    case "P":
      o = a.dateTime({
        width: "short"
      });
      break;
    case "PP":
      o = a.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      o = a.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      o = a.dateTime({
        width: "full"
      });
      break;
  }
  return o.replace("{{date}}", uf(r, a)).replace("{{time}}", gg(i, a));
}, RS = {
  p: gg,
  P: BS
}, FS = ["D", "DD"], zS = ["YY", "YYYY"];
function YS(e) {
  return FS.indexOf(e) !== -1;
}
function HS(e) {
  return zS.indexOf(e) !== -1;
}
function df(e, t, a) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(a, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var qS = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, WS = function(t, a, n) {
  var r, i = qS[t];
  return typeof i == "string" ? r = i : a === 1 ? r = i.one : r = i.other.replace("{{count}}", a.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function bl(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.width ? String(t.width) : e.defaultWidth, n = e.formats[a] || e.formats[e.defaultWidth];
    return n;
  };
}
var _S = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, US = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, VS = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, KS = {
  date: bl({
    formats: _S,
    defaultWidth: "full"
  }),
  time: bl({
    formats: US,
    defaultWidth: "full"
  }),
  dateTime: bl({
    formats: VS,
    defaultWidth: "full"
  })
}, jS = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, GS = function(t, a, n, r) {
  return jS[t];
};
function ri(e) {
  return function(t, a) {
    var n = a != null && a.context ? String(a.context) : "standalone", r;
    if (n === "formatting" && e.formattingValues) {
      var i = e.defaultFormattingWidth || e.defaultWidth, o = a != null && a.width ? String(a.width) : i;
      r = e.formattingValues[o] || e.formattingValues[i];
    } else {
      var u = e.defaultWidth, l = a != null && a.width ? String(a.width) : e.defaultWidth;
      r = e.values[l] || e.values[u];
    }
    var s = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[s];
  };
}
var QS = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, ZS = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, XS = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, JS = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, eT = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, tT = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, aT = function(t, a) {
  var n = Number(t), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, nT = {
  ordinalNumber: aT,
  era: ri({
    values: QS,
    defaultWidth: "wide"
  }),
  quarter: ri({
    values: ZS,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: ri({
    values: XS,
    defaultWidth: "wide"
  }),
  day: ri({
    values: JS,
    defaultWidth: "wide"
  }),
  dayPeriod: ri({
    values: eT,
    defaultWidth: "wide",
    formattingValues: tT,
    defaultFormattingWidth: "wide"
  })
};
function ii(e) {
  return function(t) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = a.width, r = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(r);
    if (!i)
      return null;
    var o = i[0], u = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(u) ? iT(u, function(c) {
      return c.test(o);
    }) : rT(u, function(c) {
      return c.test(o);
    }), s;
    s = e.valueCallback ? e.valueCallback(l) : l, s = a.valueCallback ? a.valueCallback(s) : s;
    var d = t.slice(o.length);
    return {
      value: s,
      rest: d
    };
  };
}
function rT(e, t) {
  for (var a in e)
    if (e.hasOwnProperty(a) && t(e[a]))
      return a;
}
function iT(e, t) {
  for (var a = 0; a < e.length; a++)
    if (t(e[a]))
      return a;
}
function oT(e) {
  return function(t) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.match(e.matchPattern);
    if (!n) return null;
    var r = n[0], i = t.match(e.parsePattern);
    if (!i) return null;
    var o = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    o = a.valueCallback ? a.valueCallback(o) : o;
    var u = t.slice(r.length);
    return {
      value: o,
      rest: u
    };
  };
}
var sT = /^(\d+)(th|st|nd|rd)?/i, lT = /\d+/i, uT = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, dT = {
  any: [/^b/i, /^(a|c)/i]
}, cT = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, fT = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, vT = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, pT = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, hT = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, gT = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, mT = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, yT = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, bT = {
  ordinalNumber: oT({
    matchPattern: sT,
    parsePattern: lT,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: ii({
    matchPatterns: uT,
    defaultMatchWidth: "wide",
    parsePatterns: dT,
    defaultParseWidth: "any"
  }),
  quarter: ii({
    matchPatterns: cT,
    defaultMatchWidth: "wide",
    parsePatterns: fT,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: ii({
    matchPatterns: vT,
    defaultMatchWidth: "wide",
    parsePatterns: pT,
    defaultParseWidth: "any"
  }),
  day: ii({
    matchPatterns: hT,
    defaultMatchWidth: "wide",
    parsePatterns: gT,
    defaultParseWidth: "any"
  }),
  dayPeriod: ii({
    matchPatterns: mT,
    defaultMatchWidth: "any",
    parsePatterns: yT,
    defaultParseWidth: "any"
  })
}, wT = {
  code: "en-US",
  formatDistance: WS,
  formatLong: KS,
  formatRelative: GS,
  localize: nT,
  match: bT,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, CT = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, kT = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $T = /^'([^]*?)'?$/, ST = /''/g, TT = /[a-zA-Z]/;
function Bt(e, t, a) {
  var n, r, i, o, u, l, s, d, c, f, v, m, C, p, h, g, w, $;
  Kt(2, arguments);
  var T = String(t), O = Zs(), M = (n = (r = a == null ? void 0 : a.locale) !== null && r !== void 0 ? r : O.locale) !== null && n !== void 0 ? n : wT, F = er((i = (o = (u = (l = a == null ? void 0 : a.firstWeekContainsDate) !== null && l !== void 0 ? l : a == null || (s = a.locale) === null || s === void 0 || (d = s.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && u !== void 0 ? u : O.firstWeekContainsDate) !== null && o !== void 0 ? o : (c = O.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
  if (!(F >= 1 && F <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var q = er((v = (m = (C = (p = a == null ? void 0 : a.weekStartsOn) !== null && p !== void 0 ? p : a == null || (h = a.locale) === null || h === void 0 || (g = h.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && C !== void 0 ? C : O.weekStartsOn) !== null && m !== void 0 ? m : (w = O.locale) === null || w === void 0 || ($ = w.options) === null || $ === void 0 ? void 0 : $.weekStartsOn) !== null && v !== void 0 ? v : 0);
  if (!(q >= 0 && q <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!M.localize)
    throw new RangeError("locale must contain localize property");
  if (!M.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var x = Va(e);
  if (!TS(x))
    throw new RangeError("Invalid time value");
  var Y = $S(x), R = DS(x, Y), k = {
    firstWeekContainsDate: F,
    weekStartsOn: q,
    locale: M,
    _originalDate: x
  }, P = T.match(kT).map(function(D) {
    var B = D[0];
    if (B === "p" || B === "P") {
      var J = RS[B];
      return J(D, M.formatLong);
    }
    return D;
  }).join("").match(CT).map(function(D) {
    if (D === "''")
      return "'";
    var B = D[0];
    if (B === "'")
      return DT(D);
    var J = LS[B];
    if (J)
      return !(a != null && a.useAdditionalWeekYearTokens) && HS(D) && df(D, t, String(e)), !(a != null && a.useAdditionalDayOfYearTokens) && YS(D) && df(D, t, String(e)), J(R, D, M.localize, k);
    if (B.match(TT))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + B + "`");
    return D;
  }).join("");
  return P;
}
function DT(e) {
  var t = e.match($T);
  return t ? t[1].replace(ST, "'") : e;
}
function Xs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Gi = { exports: {} }, wl = { exports: {} }, cf;
function wt() {
  return cf || (cf = 1, function(e) {
    function t(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(wl)), wl.exports;
}
var Qi = { exports: {} }, Zi = { exports: {} }, Cl = { exports: {} }, ff;
function mg() {
  return ff || (ff = 1, function(e) {
    function t(a) {
      "@babel/helpers - typeof";
      return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
      } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(a);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Cl)), Cl.exports;
}
var Xi = { exports: {} }, vf;
function jt() {
  return vf || (vf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n, r) {
      if (r.length < n)
        throw new TypeError(n + " argument" + (n > 1 ? "s" : "") + " required, but only " + r.length + " present");
    }
    e.exports = t.default;
  }(Xi, Xi.exports)), Xi.exports;
}
var pf;
function AT() {
  return pf || (pf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var n = a(mg()), r = a(/* @__PURE__ */ jt());
    function i(o) {
      return (0, r.default)(1, arguments), o instanceof Date || (0, n.default)(o) === "object" && Object.prototype.toString.call(o) === "[object Date]";
    }
    e.exports = t.default;
  }(Zi, Zi.exports)), Zi.exports;
}
var Ji = { exports: {} }, hf;
function Ka() {
  return hf || (hf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var n = a(mg()), r = a(/* @__PURE__ */ jt());
    function i(o) {
      (0, r.default)(1, arguments);
      var u = Object.prototype.toString.call(o);
      return o instanceof Date || (0, n.default)(o) === "object" && u === "[object Date]" ? new Date(o.getTime()) : typeof o == "number" || u === "[object Number]" ? new Date(o) : ((typeof o == "string" || u === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
    }
    e.exports = t.default;
  }(Ji, Ji.exports)), Ji.exports;
}
var gf;
function IT() {
  return gf || (gf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var n = a(/* @__PURE__ */ AT()), r = a(/* @__PURE__ */ Ka()), i = a(/* @__PURE__ */ jt());
    function o(u) {
      if ((0, i.default)(1, arguments), !(0, n.default)(u) && typeof u != "number")
        return !1;
      var l = (0, r.default)(u);
      return !isNaN(Number(l));
    }
    e.exports = t.default;
  }(Qi, Qi.exports)), Qi.exports;
}
var eo = { exports: {} }, to = { exports: {} }, ao = { exports: {} }, mf;
function ur() {
  return mf || (mf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n) {
      if (n === null || n === !0 || n === !1)
        return NaN;
      var r = Number(n);
      return isNaN(r) ? r : r < 0 ? Math.ceil(r) : Math.floor(r);
    }
    e.exports = t.default;
  }(ao, ao.exports)), ao.exports;
}
var yf;
function ET() {
  return yf || (yf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var n = a(/* @__PURE__ */ ur()), r = a(/* @__PURE__ */ Ka()), i = a(/* @__PURE__ */ jt());
    function o(u, l) {
      (0, i.default)(2, arguments);
      var s = (0, r.default)(u).getTime(), d = (0, n.default)(l);
      return new Date(s + d);
    }
    e.exports = t.default;
  }(to, to.exports)), to.exports;
}
var bf;
function MT() {
  return bf || (bf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var n = a(/* @__PURE__ */ ET()), r = a(/* @__PURE__ */ jt()), i = a(/* @__PURE__ */ ur());
    function o(u, l) {
      (0, r.default)(2, arguments);
      var s = (0, i.default)(l);
      return (0, n.default)(u, -s);
    }
    e.exports = t.default;
  }(eo, eo.exports)), eo.exports;
}
var no = { exports: {} }, ro = { exports: {} }, wf;
function OT() {
  return wf || (wf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var n = a(/* @__PURE__ */ Ka()), r = a(/* @__PURE__ */ jt()), i = 864e5;
    function o(u) {
      (0, r.default)(1, arguments);
      var l = (0, n.default)(u), s = l.getTime();
      l.setUTCMonth(0, 1), l.setUTCHours(0, 0, 0, 0);
      var d = l.getTime(), c = s - d;
      return Math.floor(c / i) + 1;
    }
    e.exports = t.default;
  }(ro, ro.exports)), ro.exports;
}
var io = { exports: {} }, oo = { exports: {} }, Cf;
function Ju() {
  return Cf || (Cf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var n = a(/* @__PURE__ */ Ka()), r = a(/* @__PURE__ */ jt());
    function i(o) {
      (0, r.default)(1, arguments);
      var u = 1, l = (0, n.default)(o), s = l.getUTCDay(), d = (s < u ? 7 : 0) + s - u;
      return l.setUTCDate(l.getUTCDate() - d), l.setUTCHours(0, 0, 0, 0), l;
    }
    e.exports = t.default;
  }(oo, oo.exports)), oo.exports;
}
var so = { exports: {} }, lo = { exports: {} }, kf;
function yg() {
  return kf || (kf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var n = a(/* @__PURE__ */ Ka()), r = a(/* @__PURE__ */ jt()), i = a(/* @__PURE__ */ Ju());
    function o(u) {
      (0, r.default)(1, arguments);
      var l = (0, n.default)(u), s = l.getUTCFullYear(), d = /* @__PURE__ */ new Date(0);
      d.setUTCFullYear(s + 1, 0, 4), d.setUTCHours(0, 0, 0, 0);
      var c = (0, i.default)(d), f = /* @__PURE__ */ new Date(0);
      f.setUTCFullYear(s, 0, 4), f.setUTCHours(0, 0, 0, 0);
      var v = (0, i.default)(f);
      return l.getTime() >= c.getTime() ? s + 1 : l.getTime() >= v.getTime() ? s : s - 1;
    }
    e.exports = t.default;
  }(lo, lo.exports)), lo.exports;
}
var $f;
function xT() {
  return $f || ($f = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var n = a(/* @__PURE__ */ yg()), r = a(/* @__PURE__ */ Ju()), i = a(/* @__PURE__ */ jt());
    function o(u) {
      (0, i.default)(1, arguments);
      var l = (0, n.default)(u), s = /* @__PURE__ */ new Date(0);
      s.setUTCFullYear(l, 0, 4), s.setUTCHours(0, 0, 0, 0);
      var d = (0, r.default)(s);
      return d;
    }
    e.exports = t.default;
  }(so, so.exports)), so.exports;
}
var Sf;
function PT() {
  return Sf || (Sf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = l;
    var n = a(/* @__PURE__ */ Ka()), r = a(/* @__PURE__ */ Ju()), i = a(/* @__PURE__ */ xT()), o = a(/* @__PURE__ */ jt()), u = 6048e5;
    function l(s) {
      (0, o.default)(1, arguments);
      var d = (0, n.default)(s), c = (0, r.default)(d).getTime() - (0, i.default)(d).getTime();
      return Math.round(c / u) + 1;
    }
    e.exports = t.default;
  }(io, io.exports)), io.exports;
}
var uo = { exports: {} }, co = { exports: {} }, oi = {}, Tf;
function Js() {
  if (Tf) return oi;
  Tf = 1, Object.defineProperty(oi, "__esModule", {
    value: !0
  }), oi.getDefaultOptions = t, oi.setDefaultOptions = a;
  var e = {};
  function t() {
    return e;
  }
  function a(n) {
    e = n;
  }
  return oi;
}
var Df;
function ed() {
  return Df || (Df = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var n = a(/* @__PURE__ */ Ka()), r = a(/* @__PURE__ */ jt()), i = a(/* @__PURE__ */ ur()), o = /* @__PURE__ */ Js();
    function u(l, s) {
      var d, c, f, v, m, C, p, h;
      (0, r.default)(1, arguments);
      var g = (0, o.getDefaultOptions)(), w = (0, i.default)((d = (c = (f = (v = s == null ? void 0 : s.weekStartsOn) !== null && v !== void 0 ? v : s == null || (m = s.locale) === null || m === void 0 || (C = m.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && f !== void 0 ? f : g.weekStartsOn) !== null && c !== void 0 ? c : (p = g.locale) === null || p === void 0 || (h = p.options) === null || h === void 0 ? void 0 : h.weekStartsOn) !== null && d !== void 0 ? d : 0);
      if (!(w >= 0 && w <= 6))
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
      var $ = (0, n.default)(l), T = $.getUTCDay(), O = (T < w ? 7 : 0) + T - w;
      return $.setUTCDate($.getUTCDate() - O), $.setUTCHours(0, 0, 0, 0), $;
    }
    e.exports = t.default;
  }(co, co.exports)), co.exports;
}
var fo = { exports: {} }, vo = { exports: {} }, Af;
function bg() {
  return Af || (Af = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = l;
    var n = a(/* @__PURE__ */ Ka()), r = a(/* @__PURE__ */ jt()), i = a(/* @__PURE__ */ ed()), o = a(/* @__PURE__ */ ur()), u = /* @__PURE__ */ Js();
    function l(s, d) {
      var c, f, v, m, C, p, h, g;
      (0, r.default)(1, arguments);
      var w = (0, n.default)(s), $ = w.getUTCFullYear(), T = (0, u.getDefaultOptions)(), O = (0, o.default)((c = (f = (v = (m = d == null ? void 0 : d.firstWeekContainsDate) !== null && m !== void 0 ? m : d == null || (C = d.locale) === null || C === void 0 || (p = C.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && v !== void 0 ? v : T.firstWeekContainsDate) !== null && f !== void 0 ? f : (h = T.locale) === null || h === void 0 || (g = h.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && c !== void 0 ? c : 1);
      if (!(O >= 1 && O <= 7))
        throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
      var M = /* @__PURE__ */ new Date(0);
      M.setUTCFullYear($ + 1, 0, O), M.setUTCHours(0, 0, 0, 0);
      var F = (0, i.default)(M, d), q = /* @__PURE__ */ new Date(0);
      q.setUTCFullYear($, 0, O), q.setUTCHours(0, 0, 0, 0);
      var x = (0, i.default)(q, d);
      return w.getTime() >= F.getTime() ? $ + 1 : w.getTime() >= x.getTime() ? $ : $ - 1;
    }
    e.exports = t.default;
  }(vo, vo.exports)), vo.exports;
}
var If;
function NT() {
  return If || (If = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = l;
    var n = a(/* @__PURE__ */ bg()), r = a(/* @__PURE__ */ jt()), i = a(/* @__PURE__ */ ed()), o = a(/* @__PURE__ */ ur()), u = /* @__PURE__ */ Js();
    function l(s, d) {
      var c, f, v, m, C, p, h, g;
      (0, r.default)(1, arguments);
      var w = (0, u.getDefaultOptions)(), $ = (0, o.default)((c = (f = (v = (m = d == null ? void 0 : d.firstWeekContainsDate) !== null && m !== void 0 ? m : d == null || (C = d.locale) === null || C === void 0 || (p = C.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && v !== void 0 ? v : w.firstWeekContainsDate) !== null && f !== void 0 ? f : (h = w.locale) === null || h === void 0 || (g = h.options) === null || g === void 0 ? void 0 : g.firstWeekContainsDate) !== null && c !== void 0 ? c : 1), T = (0, n.default)(s, d), O = /* @__PURE__ */ new Date(0);
      O.setUTCFullYear(T, 0, $), O.setUTCHours(0, 0, 0, 0);
      var M = (0, i.default)(O, d);
      return M;
    }
    e.exports = t.default;
  }(fo, fo.exports)), fo.exports;
}
var Ef;
function LT() {
  return Ef || (Ef = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = l;
    var n = a(/* @__PURE__ */ Ka()), r = a(/* @__PURE__ */ ed()), i = a(/* @__PURE__ */ NT()), o = a(/* @__PURE__ */ jt()), u = 6048e5;
    function l(s, d) {
      (0, o.default)(1, arguments);
      var c = (0, n.default)(s), f = (0, r.default)(c, d).getTime() - (0, i.default)(c, d).getTime();
      return Math.round(f / u) + 1;
    }
    e.exports = t.default;
  }(uo, uo.exports)), uo.exports;
}
var po = { exports: {} }, Mf;
function wg() {
  return Mf || (Mf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n, r) {
      for (var i = n < 0 ? "-" : "", o = Math.abs(n).toString(); o.length < r; )
        o = "0" + o;
      return i + o;
    }
    e.exports = t.default;
  }(po, po.exports)), po.exports;
}
var ho = { exports: {} }, Of;
function BT() {
  return Of || (Of = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ wg()), r = {
      // Year
      y: function(u, l) {
        var s = u.getUTCFullYear(), d = s > 0 ? s : 1 - s;
        return (0, n.default)(l === "yy" ? d % 100 : d, l.length);
      },
      // Month
      M: function(u, l) {
        var s = u.getUTCMonth();
        return l === "M" ? String(s + 1) : (0, n.default)(s + 1, 2);
      },
      // Day of the month
      d: function(u, l) {
        return (0, n.default)(u.getUTCDate(), l.length);
      },
      // AM or PM
      a: function(u, l) {
        var s = u.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch (l) {
          case "a":
          case "aa":
            return s.toUpperCase();
          case "aaa":
            return s;
          case "aaaaa":
            return s[0];
          case "aaaa":
          default:
            return s === "am" ? "a.m." : "p.m.";
        }
      },
      // Hour [1-12]
      h: function(u, l) {
        return (0, n.default)(u.getUTCHours() % 12 || 12, l.length);
      },
      // Hour [0-23]
      H: function(u, l) {
        return (0, n.default)(u.getUTCHours(), l.length);
      },
      // Minute
      m: function(u, l) {
        return (0, n.default)(u.getUTCMinutes(), l.length);
      },
      // Second
      s: function(u, l) {
        return (0, n.default)(u.getUTCSeconds(), l.length);
      },
      // Fraction of second
      S: function(u, l) {
        var s = l.length, d = u.getUTCMilliseconds(), c = Math.floor(d * Math.pow(10, s - 3));
        return (0, n.default)(c, l.length);
      }
    }, i = r;
    t.default = i, e.exports = t.default;
  }(ho, ho.exports)), ho.exports;
}
var xf;
function RT() {
  return xf || (xf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ OT()), r = a(/* @__PURE__ */ PT()), i = a(/* @__PURE__ */ yg()), o = a(/* @__PURE__ */ LT()), u = a(/* @__PURE__ */ bg()), l = a(/* @__PURE__ */ wg()), s = a(/* @__PURE__ */ BT()), d = {
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }, c = {
      // Era
      G: function(h, g, w) {
        var $ = h.getUTCFullYear() > 0 ? 1 : 0;
        switch (g) {
          // AD, BC
          case "G":
          case "GG":
          case "GGG":
            return w.era($, {
              width: "abbreviated"
            });
          // A, B
          case "GGGGG":
            return w.era($, {
              width: "narrow"
            });
          // Anno Domini, Before Christ
          case "GGGG":
          default:
            return w.era($, {
              width: "wide"
            });
        }
      },
      // Year
      y: function(h, g, w) {
        if (g === "yo") {
          var $ = h.getUTCFullYear(), T = $ > 0 ? $ : 1 - $;
          return w.ordinalNumber(T, {
            unit: "year"
          });
        }
        return s.default.y(h, g);
      },
      // Local week-numbering year
      Y: function(h, g, w, $) {
        var T = (0, u.default)(h, $), O = T > 0 ? T : 1 - T;
        if (g === "YY") {
          var M = O % 100;
          return (0, l.default)(M, 2);
        }
        return g === "Yo" ? w.ordinalNumber(O, {
          unit: "year"
        }) : (0, l.default)(O, g.length);
      },
      // ISO week-numbering year
      R: function(h, g) {
        var w = (0, i.default)(h);
        return (0, l.default)(w, g.length);
      },
      // Extended year. This is a single number designating the year of this calendar system.
      // The main difference between `y` and `u` localizers are B.C. years:
      // | Year | `y` | `u` |
      // |------|-----|-----|
      // | AC 1 |   1 |   1 |
      // | BC 1 |   1 |   0 |
      // | BC 2 |   2 |  -1 |
      // Also `yy` always returns the last two digits of a year,
      // while `uu` pads single digit years to 2 characters and returns other years unchanged.
      u: function(h, g) {
        var w = h.getUTCFullYear();
        return (0, l.default)(w, g.length);
      },
      // Quarter
      Q: function(h, g, w) {
        var $ = Math.ceil((h.getUTCMonth() + 1) / 3);
        switch (g) {
          // 1, 2, 3, 4
          case "Q":
            return String($);
          // 01, 02, 03, 04
          case "QQ":
            return (0, l.default)($, 2);
          // 1st, 2nd, 3rd, 4th
          case "Qo":
            return w.ordinalNumber($, {
              unit: "quarter"
            });
          // Q1, Q2, Q3, Q4
          case "QQQ":
            return w.quarter($, {
              width: "abbreviated",
              context: "formatting"
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case "QQQQQ":
            return w.quarter($, {
              width: "narrow",
              context: "formatting"
            });
          // 1st quarter, 2nd quarter, ...
          case "QQQQ":
          default:
            return w.quarter($, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone quarter
      q: function(h, g, w) {
        var $ = Math.ceil((h.getUTCMonth() + 1) / 3);
        switch (g) {
          // 1, 2, 3, 4
          case "q":
            return String($);
          // 01, 02, 03, 04
          case "qq":
            return (0, l.default)($, 2);
          // 1st, 2nd, 3rd, 4th
          case "qo":
            return w.ordinalNumber($, {
              unit: "quarter"
            });
          // Q1, Q2, Q3, Q4
          case "qqq":
            return w.quarter($, {
              width: "abbreviated",
              context: "standalone"
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case "qqqqq":
            return w.quarter($, {
              width: "narrow",
              context: "standalone"
            });
          // 1st quarter, 2nd quarter, ...
          case "qqqq":
          default:
            return w.quarter($, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // Month
      M: function(h, g, w) {
        var $ = h.getUTCMonth();
        switch (g) {
          case "M":
          case "MM":
            return s.default.M(h, g);
          // 1st, 2nd, ..., 12th
          case "Mo":
            return w.ordinalNumber($ + 1, {
              unit: "month"
            });
          // Jan, Feb, ..., Dec
          case "MMM":
            return w.month($, {
              width: "abbreviated",
              context: "formatting"
            });
          // J, F, ..., D
          case "MMMMM":
            return w.month($, {
              width: "narrow",
              context: "formatting"
            });
          // January, February, ..., December
          case "MMMM":
          default:
            return w.month($, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone month
      L: function(h, g, w) {
        var $ = h.getUTCMonth();
        switch (g) {
          // 1, 2, ..., 12
          case "L":
            return String($ + 1);
          // 01, 02, ..., 12
          case "LL":
            return (0, l.default)($ + 1, 2);
          // 1st, 2nd, ..., 12th
          case "Lo":
            return w.ordinalNumber($ + 1, {
              unit: "month"
            });
          // Jan, Feb, ..., Dec
          case "LLL":
            return w.month($, {
              width: "abbreviated",
              context: "standalone"
            });
          // J, F, ..., D
          case "LLLLL":
            return w.month($, {
              width: "narrow",
              context: "standalone"
            });
          // January, February, ..., December
          case "LLLL":
          default:
            return w.month($, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // Local week of year
      w: function(h, g, w, $) {
        var T = (0, o.default)(h, $);
        return g === "wo" ? w.ordinalNumber(T, {
          unit: "week"
        }) : (0, l.default)(T, g.length);
      },
      // ISO week of year
      I: function(h, g, w) {
        var $ = (0, r.default)(h);
        return g === "Io" ? w.ordinalNumber($, {
          unit: "week"
        }) : (0, l.default)($, g.length);
      },
      // Day of the month
      d: function(h, g, w) {
        return g === "do" ? w.ordinalNumber(h.getUTCDate(), {
          unit: "date"
        }) : s.default.d(h, g);
      },
      // Day of year
      D: function(h, g, w) {
        var $ = (0, n.default)(h);
        return g === "Do" ? w.ordinalNumber($, {
          unit: "dayOfYear"
        }) : (0, l.default)($, g.length);
      },
      // Day of week
      E: function(h, g, w) {
        var $ = h.getUTCDay();
        switch (g) {
          // Tue
          case "E":
          case "EE":
          case "EEE":
            return w.day($, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "EEEEE":
            return w.day($, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "EEEEEE":
            return w.day($, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "EEEE":
          default:
            return w.day($, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Local day of week
      e: function(h, g, w, $) {
        var T = h.getUTCDay(), O = (T - $.weekStartsOn + 8) % 7 || 7;
        switch (g) {
          // Numerical value (Nth day of week with current locale or weekStartsOn)
          case "e":
            return String(O);
          // Padded numerical value
          case "ee":
            return (0, l.default)(O, 2);
          // 1st, 2nd, ..., 7th
          case "eo":
            return w.ordinalNumber(O, {
              unit: "day"
            });
          case "eee":
            return w.day(T, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "eeeee":
            return w.day(T, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "eeeeee":
            return w.day(T, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "eeee":
          default:
            return w.day(T, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Stand-alone local day of week
      c: function(h, g, w, $) {
        var T = h.getUTCDay(), O = (T - $.weekStartsOn + 8) % 7 || 7;
        switch (g) {
          // Numerical value (same as in `e`)
          case "c":
            return String(O);
          // Padded numerical value
          case "cc":
            return (0, l.default)(O, g.length);
          // 1st, 2nd, ..., 7th
          case "co":
            return w.ordinalNumber(O, {
              unit: "day"
            });
          case "ccc":
            return w.day(T, {
              width: "abbreviated",
              context: "standalone"
            });
          // T
          case "ccccc":
            return w.day(T, {
              width: "narrow",
              context: "standalone"
            });
          // Tu
          case "cccccc":
            return w.day(T, {
              width: "short",
              context: "standalone"
            });
          // Tuesday
          case "cccc":
          default:
            return w.day(T, {
              width: "wide",
              context: "standalone"
            });
        }
      },
      // ISO day of week
      i: function(h, g, w) {
        var $ = h.getUTCDay(), T = $ === 0 ? 7 : $;
        switch (g) {
          // 2
          case "i":
            return String(T);
          // 02
          case "ii":
            return (0, l.default)(T, g.length);
          // 2nd
          case "io":
            return w.ordinalNumber(T, {
              unit: "day"
            });
          // Tue
          case "iii":
            return w.day($, {
              width: "abbreviated",
              context: "formatting"
            });
          // T
          case "iiiii":
            return w.day($, {
              width: "narrow",
              context: "formatting"
            });
          // Tu
          case "iiiiii":
            return w.day($, {
              width: "short",
              context: "formatting"
            });
          // Tuesday
          case "iiii":
          default:
            return w.day($, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // AM or PM
      a: function(h, g, w) {
        var $ = h.getUTCHours(), T = $ / 12 >= 1 ? "pm" : "am";
        switch (g) {
          case "a":
          case "aa":
            return w.dayPeriod(T, {
              width: "abbreviated",
              context: "formatting"
            });
          case "aaa":
            return w.dayPeriod(T, {
              width: "abbreviated",
              context: "formatting"
            }).toLowerCase();
          case "aaaaa":
            return w.dayPeriod(T, {
              width: "narrow",
              context: "formatting"
            });
          case "aaaa":
          default:
            return w.dayPeriod(T, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // AM, PM, midnight, noon
      b: function(h, g, w) {
        var $ = h.getUTCHours(), T;
        switch ($ === 12 ? T = d.noon : $ === 0 ? T = d.midnight : T = $ / 12 >= 1 ? "pm" : "am", g) {
          case "b":
          case "bb":
            return w.dayPeriod(T, {
              width: "abbreviated",
              context: "formatting"
            });
          case "bbb":
            return w.dayPeriod(T, {
              width: "abbreviated",
              context: "formatting"
            }).toLowerCase();
          case "bbbbb":
            return w.dayPeriod(T, {
              width: "narrow",
              context: "formatting"
            });
          case "bbbb":
          default:
            return w.dayPeriod(T, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // in the morning, in the afternoon, in the evening, at night
      B: function(h, g, w) {
        var $ = h.getUTCHours(), T;
        switch ($ >= 17 ? T = d.evening : $ >= 12 ? T = d.afternoon : $ >= 4 ? T = d.morning : T = d.night, g) {
          case "B":
          case "BB":
          case "BBB":
            return w.dayPeriod(T, {
              width: "abbreviated",
              context: "formatting"
            });
          case "BBBBB":
            return w.dayPeriod(T, {
              width: "narrow",
              context: "formatting"
            });
          case "BBBB":
          default:
            return w.dayPeriod(T, {
              width: "wide",
              context: "formatting"
            });
        }
      },
      // Hour [1-12]
      h: function(h, g, w) {
        if (g === "ho") {
          var $ = h.getUTCHours() % 12;
          return $ === 0 && ($ = 12), w.ordinalNumber($, {
            unit: "hour"
          });
        }
        return s.default.h(h, g);
      },
      // Hour [0-23]
      H: function(h, g, w) {
        return g === "Ho" ? w.ordinalNumber(h.getUTCHours(), {
          unit: "hour"
        }) : s.default.H(h, g);
      },
      // Hour [0-11]
      K: function(h, g, w) {
        var $ = h.getUTCHours() % 12;
        return g === "Ko" ? w.ordinalNumber($, {
          unit: "hour"
        }) : (0, l.default)($, g.length);
      },
      // Hour [1-24]
      k: function(h, g, w) {
        var $ = h.getUTCHours();
        return $ === 0 && ($ = 24), g === "ko" ? w.ordinalNumber($, {
          unit: "hour"
        }) : (0, l.default)($, g.length);
      },
      // Minute
      m: function(h, g, w) {
        return g === "mo" ? w.ordinalNumber(h.getUTCMinutes(), {
          unit: "minute"
        }) : s.default.m(h, g);
      },
      // Second
      s: function(h, g, w) {
        return g === "so" ? w.ordinalNumber(h.getUTCSeconds(), {
          unit: "second"
        }) : s.default.s(h, g);
      },
      // Fraction of second
      S: function(h, g) {
        return s.default.S(h, g);
      },
      // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
      X: function(h, g, w, $) {
        var T = $._originalDate || h, O = T.getTimezoneOffset();
        if (O === 0)
          return "Z";
        switch (g) {
          // Hours and optional minutes
          case "X":
            return v(O);
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XX`
          case "XXXX":
          case "XX":
            return m(O);
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `XXX`
          case "XXXXX":
          case "XXX":
          // Hours and minutes with `:` delimiter
          default:
            return m(O, ":");
        }
      },
      // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
      x: function(h, g, w, $) {
        var T = $._originalDate || h, O = T.getTimezoneOffset();
        switch (g) {
          // Hours and optional minutes
          case "x":
            return v(O);
          // Hours, minutes and optional seconds without `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xx`
          case "xxxx":
          case "xx":
            return m(O);
          // Hours, minutes and optional seconds with `:` delimiter
          // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
          // so this token always has the same output as `xxx`
          case "xxxxx":
          case "xxx":
          // Hours and minutes with `:` delimiter
          default:
            return m(O, ":");
        }
      },
      // Timezone (GMT)
      O: function(h, g, w, $) {
        var T = $._originalDate || h, O = T.getTimezoneOffset();
        switch (g) {
          // Short
          case "O":
          case "OO":
          case "OOO":
            return "GMT" + f(O, ":");
          // Long
          case "OOOO":
          default:
            return "GMT" + m(O, ":");
        }
      },
      // Timezone (specific non-location)
      z: function(h, g, w, $) {
        var T = $._originalDate || h, O = T.getTimezoneOffset();
        switch (g) {
          // Short
          case "z":
          case "zz":
          case "zzz":
            return "GMT" + f(O, ":");
          // Long
          case "zzzz":
          default:
            return "GMT" + m(O, ":");
        }
      },
      // Seconds timestamp
      t: function(h, g, w, $) {
        var T = $._originalDate || h, O = Math.floor(T.getTime() / 1e3);
        return (0, l.default)(O, g.length);
      },
      // Milliseconds timestamp
      T: function(h, g, w, $) {
        var T = $._originalDate || h, O = T.getTime();
        return (0, l.default)(O, g.length);
      }
    };
    function f(p, h) {
      var g = p > 0 ? "-" : "+", w = Math.abs(p), $ = Math.floor(w / 60), T = w % 60;
      if (T === 0)
        return g + String($);
      var O = h;
      return g + String($) + O + (0, l.default)(T, 2);
    }
    function v(p, h) {
      if (p % 60 === 0) {
        var g = p > 0 ? "-" : "+";
        return g + (0, l.default)(Math.abs(p) / 60, 2);
      }
      return m(p, h);
    }
    function m(p, h) {
      var g = h || "", w = p > 0 ? "-" : "+", $ = Math.abs(p), T = (0, l.default)(Math.floor($ / 60), 2), O = (0, l.default)($ % 60, 2);
      return w + T + g + O;
    }
    var C = c;
    t.default = C, e.exports = t.default;
  }(no, no.exports)), no.exports;
}
var go = { exports: {} }, Pf;
function FT() {
  return Pf || (Pf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = function(l, s) {
      switch (l) {
        case "P":
          return s.date({
            width: "short"
          });
        case "PP":
          return s.date({
            width: "medium"
          });
        case "PPP":
          return s.date({
            width: "long"
          });
        case "PPPP":
        default:
          return s.date({
            width: "full"
          });
      }
    }, n = function(l, s) {
      switch (l) {
        case "p":
          return s.time({
            width: "short"
          });
        case "pp":
          return s.time({
            width: "medium"
          });
        case "ppp":
          return s.time({
            width: "long"
          });
        case "pppp":
        default:
          return s.time({
            width: "full"
          });
      }
    }, r = function(l, s) {
      var d = l.match(/(P+)(p+)?/) || [], c = d[1], f = d[2];
      if (!f)
        return a(l, s);
      var v;
      switch (c) {
        case "P":
          v = s.dateTime({
            width: "short"
          });
          break;
        case "PP":
          v = s.dateTime({
            width: "medium"
          });
          break;
        case "PPP":
          v = s.dateTime({
            width: "long"
          });
          break;
        case "PPPP":
        default:
          v = s.dateTime({
            width: "full"
          });
          break;
      }
      return v.replace("{{date}}", a(c, s)).replace("{{time}}", n(f, s));
    }, i = {
      p: n,
      P: r
    }, o = i;
    t.default = o, e.exports = t.default;
  }(go, go.exports)), go.exports;
}
var mo = { exports: {} }, Nf;
function Cg() {
  return Nf || (Nf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n) {
      var r = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
      return r.setUTCFullYear(n.getFullYear()), n.getTime() - r.getTime();
    }
    e.exports = t.default;
  }(mo, mo.exports)), mo.exports;
}
var gr = {}, Lf;
function zT() {
  if (Lf) return gr;
  Lf = 1, Object.defineProperty(gr, "__esModule", {
    value: !0
  }), gr.isProtectedDayOfYearToken = a, gr.isProtectedWeekYearToken = n, gr.throwProtectedError = r;
  var e = ["D", "DD"], t = ["YY", "YYYY"];
  function a(i) {
    return e.indexOf(i) !== -1;
  }
  function n(i) {
    return t.indexOf(i) !== -1;
  }
  function r(i, o, u) {
    if (i === "YYYY")
      throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(o, "`) for formatting years to the input `").concat(u, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if (i === "YY")
      throw new RangeError("Use `yy` instead of `YY` (in `".concat(o, "`) for formatting years to the input `").concat(u, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if (i === "D")
      throw new RangeError("Use `d` instead of `D` (in `".concat(o, "`) for formatting days of the month to the input `").concat(u, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    if (i === "DD")
      throw new RangeError("Use `dd` instead of `DD` (in `".concat(o, "`) for formatting days of the month to the input `").concat(u, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
  return gr;
}
var yo = { exports: {} }, bo = { exports: {} }, wo = { exports: {} }, Bf;
function YT() {
  return Bf || (Bf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = {
      lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
      },
      xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
      },
      halfAMinute: "half a minute",
      lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
      },
      xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
      },
      aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
      },
      xHours: {
        one: "1 hour",
        other: "{{count}} hours"
      },
      xDays: {
        one: "1 day",
        other: "{{count}} days"
      },
      aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
      },
      xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
      },
      aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
      },
      xMonths: {
        one: "1 month",
        other: "{{count}} months"
      },
      aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
      },
      xYears: {
        one: "1 year",
        other: "{{count}} years"
      },
      overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
      },
      almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
      }
    }, n = function(o, u, l) {
      var s, d = a[o];
      return typeof d == "string" ? s = d : u === 1 ? s = d.one : s = d.other.replace("{{count}}", u.toString()), l != null && l.addSuffix ? l.comparison && l.comparison > 0 ? "in " + s : s + " ago" : s;
    }, r = n;
    t.default = r, e.exports = t.default;
  }(wo, wo.exports)), wo.exports;
}
var Co = { exports: {} }, ko = { exports: {} }, Rf;
function HT() {
  return Rf || (Rf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n) {
      return function() {
        var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = r.width ? String(r.width) : n.defaultWidth, o = n.formats[i] || n.formats[n.defaultWidth];
        return o;
      };
    }
    e.exports = t.default;
  }(ko, ko.exports)), ko.exports;
}
var Ff;
function qT() {
  return Ff || (Ff = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ HT()), r = {
      full: "EEEE, MMMM do, y",
      long: "MMMM do, y",
      medium: "MMM d, y",
      short: "MM/dd/yyyy"
    }, i = {
      full: "h:mm:ss a zzzz",
      long: "h:mm:ss a z",
      medium: "h:mm:ss a",
      short: "h:mm a"
    }, o = {
      full: "{{date}} 'at' {{time}}",
      long: "{{date}} 'at' {{time}}",
      medium: "{{date}}, {{time}}",
      short: "{{date}}, {{time}}"
    }, u = {
      date: (0, n.default)({
        formats: r,
        defaultWidth: "full"
      }),
      time: (0, n.default)({
        formats: i,
        defaultWidth: "full"
      }),
      dateTime: (0, n.default)({
        formats: o,
        defaultWidth: "full"
      })
    }, l = u;
    t.default = l, e.exports = t.default;
  }(Co, Co.exports)), Co.exports;
}
var $o = { exports: {} }, zf;
function WT() {
  return zf || (zf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var a = {
      lastWeek: "'last' eeee 'at' p",
      yesterday: "'yesterday at' p",
      today: "'today at' p",
      tomorrow: "'tomorrow at' p",
      nextWeek: "eeee 'at' p",
      other: "P"
    }, n = function(o, u, l, s) {
      return a[o];
    }, r = n;
    t.default = r, e.exports = t.default;
  }($o, $o.exports)), $o.exports;
}
var So = { exports: {} }, To = { exports: {} }, Yf;
function _T() {
  return Yf || (Yf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n) {
      return function(r, i) {
        var o = i != null && i.context ? String(i.context) : "standalone", u;
        if (o === "formatting" && n.formattingValues) {
          var l = n.defaultFormattingWidth || n.defaultWidth, s = i != null && i.width ? String(i.width) : l;
          u = n.formattingValues[s] || n.formattingValues[l];
        } else {
          var d = n.defaultWidth, c = i != null && i.width ? String(i.width) : n.defaultWidth;
          u = n.values[c] || n.values[d];
        }
        var f = n.argumentCallback ? n.argumentCallback(r) : r;
        return u[f];
      };
    }
    e.exports = t.default;
  }(To, To.exports)), To.exports;
}
var Hf;
function UT() {
  return Hf || (Hf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ _T()), r = {
      narrow: ["B", "A"],
      abbreviated: ["BC", "AD"],
      wide: ["Before Christ", "Anno Domini"]
    }, i = {
      narrow: ["1", "2", "3", "4"],
      abbreviated: ["Q1", "Q2", "Q3", "Q4"],
      wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
    }, o = {
      narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
      abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    }, u = {
      narrow: ["S", "M", "T", "W", "T", "F", "S"],
      short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    }, l = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
      }
    }, s = {
      narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      },
      abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      },
      wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
      }
    }, d = function(m, C) {
      var p = Number(m), h = p % 100;
      if (h > 20 || h < 10)
        switch (h % 10) {
          case 1:
            return p + "st";
          case 2:
            return p + "nd";
          case 3:
            return p + "rd";
        }
      return p + "th";
    }, c = {
      ordinalNumber: d,
      era: (0, n.default)({
        values: r,
        defaultWidth: "wide"
      }),
      quarter: (0, n.default)({
        values: i,
        defaultWidth: "wide",
        argumentCallback: function(m) {
          return m - 1;
        }
      }),
      month: (0, n.default)({
        values: o,
        defaultWidth: "wide"
      }),
      day: (0, n.default)({
        values: u,
        defaultWidth: "wide"
      }),
      dayPeriod: (0, n.default)({
        values: l,
        defaultWidth: "wide",
        formattingValues: s,
        defaultFormattingWidth: "wide"
      })
    }, f = c;
    t.default = f, e.exports = t.default;
  }(So, So.exports)), So.exports;
}
var Do = { exports: {} }, Ao = { exports: {} }, qf;
function VT() {
  return qf || (qf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(i) {
      return function(o) {
        var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, l = u.width, s = l && i.matchPatterns[l] || i.matchPatterns[i.defaultMatchWidth], d = o.match(s);
        if (!d)
          return null;
        var c = d[0], f = l && i.parsePatterns[l] || i.parsePatterns[i.defaultParseWidth], v = Array.isArray(f) ? r(f, function(p) {
          return p.test(c);
        }) : n(f, function(p) {
          return p.test(c);
        }), m;
        m = i.valueCallback ? i.valueCallback(v) : v, m = u.valueCallback ? u.valueCallback(m) : m;
        var C = o.slice(c.length);
        return {
          value: m,
          rest: C
        };
      };
    }
    function n(i, o) {
      for (var u in i)
        if (i.hasOwnProperty(u) && o(i[u]))
          return u;
    }
    function r(i, o) {
      for (var u = 0; u < i.length; u++)
        if (o(i[u]))
          return u;
    }
    e.exports = t.default;
  }(Ao, Ao.exports)), Ao.exports;
}
var Io = { exports: {} }, Wf;
function KT() {
  return Wf || (Wf = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n) {
      return function(r) {
        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = r.match(n.matchPattern);
        if (!o) return null;
        var u = o[0], l = r.match(n.parsePattern);
        if (!l) return null;
        var s = n.valueCallback ? n.valueCallback(l[0]) : l[0];
        s = i.valueCallback ? i.valueCallback(s) : s;
        var d = r.slice(u.length);
        return {
          value: s,
          rest: d
        };
      };
    }
    e.exports = t.default;
  }(Io, Io.exports)), Io.exports;
}
var _f;
function jT() {
  return _f || (_f = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ VT()), r = a(/* @__PURE__ */ KT()), i = /^(\d+)(th|st|nd|rd)?/i, o = /\d+/i, u = {
      narrow: /^(b|a)/i,
      abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
      wide: /^(before christ|before common era|anno domini|common era)/i
    }, l = {
      any: [/^b/i, /^(a|c)/i]
    }, s = {
      narrow: /^[1234]/i,
      abbreviated: /^q[1234]/i,
      wide: /^[1234](th|st|nd|rd)? quarter/i
    }, d = {
      any: [/1/i, /2/i, /3/i, /4/i]
    }, c = {
      narrow: /^[jfmasond]/i,
      abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
      wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
    }, f = {
      narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
      any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
    }, v = {
      narrow: /^[smtwf]/i,
      short: /^(su|mo|tu|we|th|fr|sa)/i,
      abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
      wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
    }, m = {
      narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
      any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
    }, C = {
      narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
      any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
    }, p = {
      any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
      }
    }, h = {
      ordinalNumber: (0, r.default)({
        matchPattern: i,
        parsePattern: o,
        valueCallback: function($) {
          return parseInt($, 10);
        }
      }),
      era: (0, n.default)({
        matchPatterns: u,
        defaultMatchWidth: "wide",
        parsePatterns: l,
        defaultParseWidth: "any"
      }),
      quarter: (0, n.default)({
        matchPatterns: s,
        defaultMatchWidth: "wide",
        parsePatterns: d,
        defaultParseWidth: "any",
        valueCallback: function($) {
          return $ + 1;
        }
      }),
      month: (0, n.default)({
        matchPatterns: c,
        defaultMatchWidth: "wide",
        parsePatterns: f,
        defaultParseWidth: "any"
      }),
      day: (0, n.default)({
        matchPatterns: v,
        defaultMatchWidth: "wide",
        parsePatterns: m,
        defaultParseWidth: "any"
      }),
      dayPeriod: (0, n.default)({
        matchPatterns: C,
        defaultMatchWidth: "any",
        parsePatterns: p,
        defaultParseWidth: "any"
      })
    }, g = h;
    t.default = g, e.exports = t.default;
  }(Do, Do.exports)), Do.exports;
}
var Uf;
function GT() {
  return Uf || (Uf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ YT()), r = a(/* @__PURE__ */ qT()), i = a(/* @__PURE__ */ WT()), o = a(/* @__PURE__ */ UT()), u = a(/* @__PURE__ */ jT()), l = {
      code: "en-US",
      formatDistance: n.default,
      formatLong: r.default,
      formatRelative: i.default,
      localize: o.default,
      match: u.default,
      options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
      }
    }, s = l;
    t.default = s, e.exports = t.default;
  }(bo, bo.exports)), bo.exports;
}
var Vf;
function QT() {
  return Vf || (Vf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var n = a(/* @__PURE__ */ GT()), r = n.default;
    t.default = r, e.exports = t.default;
  }(yo, yo.exports)), yo.exports;
}
var Kf;
function ZT() {
  return Kf || (Kf = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = w;
    var n = a(/* @__PURE__ */ IT()), r = a(/* @__PURE__ */ MT()), i = a(/* @__PURE__ */ Ka()), o = a(/* @__PURE__ */ RT()), u = a(/* @__PURE__ */ FT()), l = a(/* @__PURE__ */ Cg()), s = /* @__PURE__ */ zT(), d = a(/* @__PURE__ */ ur()), c = a(/* @__PURE__ */ jt()), f = /* @__PURE__ */ Js(), v = a(/* @__PURE__ */ QT()), m = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, C = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, p = /^'([^]*?)'?$/, h = /''/g, g = /[a-zA-Z]/;
    function w(T, O, M) {
      var F, q, x, Y, R, k, P, D, B, J, _, te, G, pe, ce, $e, ge, Se;
      (0, c.default)(2, arguments);
      var Ue = String(O), Ne = (0, f.getDefaultOptions)(), He = (F = (q = M == null ? void 0 : M.locale) !== null && q !== void 0 ? q : Ne.locale) !== null && F !== void 0 ? F : v.default, Xe = (0, d.default)((x = (Y = (R = (k = M == null ? void 0 : M.firstWeekContainsDate) !== null && k !== void 0 ? k : M == null || (P = M.locale) === null || P === void 0 || (D = P.options) === null || D === void 0 ? void 0 : D.firstWeekContainsDate) !== null && R !== void 0 ? R : Ne.firstWeekContainsDate) !== null && Y !== void 0 ? Y : (B = Ne.locale) === null || B === void 0 || (J = B.options) === null || J === void 0 ? void 0 : J.firstWeekContainsDate) !== null && x !== void 0 ? x : 1);
      if (!(Xe >= 1 && Xe <= 7))
        throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
      var ot = (0, d.default)((_ = (te = (G = (pe = M == null ? void 0 : M.weekStartsOn) !== null && pe !== void 0 ? pe : M == null || (ce = M.locale) === null || ce === void 0 || ($e = ce.options) === null || $e === void 0 ? void 0 : $e.weekStartsOn) !== null && G !== void 0 ? G : Ne.weekStartsOn) !== null && te !== void 0 ? te : (ge = Ne.locale) === null || ge === void 0 || (Se = ge.options) === null || Se === void 0 ? void 0 : Se.weekStartsOn) !== null && _ !== void 0 ? _ : 0);
      if (!(ot >= 0 && ot <= 6))
        throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
      if (!He.localize)
        throw new RangeError("locale must contain localize property");
      if (!He.formatLong)
        throw new RangeError("locale must contain formatLong property");
      var Ge = (0, i.default)(T);
      if (!(0, n.default)(Ge))
        throw new RangeError("Invalid time value");
      var Je = (0, l.default)(Ge), et = (0, r.default)(Ge, Je), ie = {
        firstWeekContainsDate: Xe,
        weekStartsOn: ot,
        locale: He,
        _originalDate: Ge
      }, le = Ue.match(C).map(function(fe) {
        var z = fe[0];
        if (z === "p" || z === "P") {
          var Ce = u.default[z];
          return Ce(fe, He.formatLong);
        }
        return fe;
      }).join("").match(m).map(function(fe) {
        if (fe === "''")
          return "'";
        var z = fe[0];
        if (z === "'")
          return $(fe);
        var Ce = o.default[z];
        if (Ce)
          return !(M != null && M.useAdditionalWeekYearTokens) && (0, s.isProtectedWeekYearToken)(fe) && (0, s.throwProtectedError)(fe, O, String(T)), !(M != null && M.useAdditionalDayOfYearTokens) && (0, s.isProtectedDayOfYearToken)(fe) && (0, s.throwProtectedError)(fe, O, String(T)), Ce(et, fe, He.localize, ie);
        if (z.match(g))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + z + "`");
        return fe;
      }).join("");
      return le;
    }
    function $(T) {
      var O = T.match(p);
      return O ? O[1].replace(h, "'") : T;
    }
    e.exports = t.default;
  }(Gi, Gi.exports)), Gi.exports;
}
var XT = /* @__PURE__ */ ZT();
const JT = /* @__PURE__ */ Xs(XT);
function jf(e, t, a) {
  var n = a5(e, a.timeZone, a.locale);
  return n.formatToParts ? e5(n, t) : t5(n, t);
}
function e5(e, t) {
  for (var a = e.formatToParts(t), n = a.length - 1; n >= 0; --n)
    if (a[n].type === "timeZoneName")
      return a[n].value;
}
function t5(e, t) {
  var a = e.format(t).replace(/\u200E/g, ""), n = / [\w-+ ]+$/.exec(a);
  return n ? n[0].substr(1) : "";
}
function a5(e, t, a) {
  if (a && !a.code)
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    );
  return new Intl.DateTimeFormat(a ? [a.code, "en-US"] : void 0, {
    timeZone: t,
    timeZoneName: e
  });
}
function n5(e, t) {
  var a = s5(t);
  return a.formatToParts ? i5(a, e) : o5(a, e);
}
var r5 = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function i5(e, t) {
  try {
    for (var a = e.formatToParts(t), n = [], r = 0; r < a.length; r++) {
      var i = r5[a[r].type];
      i >= 0 && (n[i] = parseInt(a[r].value, 10));
    }
    return n;
  } catch (o) {
    if (o instanceof RangeError)
      return [NaN];
    throw o;
  }
}
function o5(e, t) {
  var a = e.format(t), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [n[3], n[1], n[2], n[4], n[5], n[6]];
}
var kl = {};
function s5(e) {
  if (!kl[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), a = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    kl[e] = a ? new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return kl[e];
}
function kg(e, t, a, n, r, i, o) {
  var u = /* @__PURE__ */ new Date(0);
  return u.setUTCFullYear(e, t, a), u.setUTCHours(n, r, i, o), u;
}
var Gf = 36e5, l5 = 6e4, $l = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function td(e, t, a) {
  var n, r;
  if (!e || (n = $l.timezoneZ.exec(e), n))
    return 0;
  var i;
  if (n = $l.timezoneHH.exec(e), n)
    return i = parseInt(n[1], 10), Qf(i) ? -(i * Gf) : NaN;
  if (n = $l.timezoneHHMM.exec(e), n) {
    i = parseInt(n[2], 10);
    var o = parseInt(n[3], 10);
    return Qf(i, o) ? (r = Math.abs(i) * Gf + o * l5, n[1] === "+" ? -r : r) : NaN;
  }
  if (c5(e)) {
    t = new Date(t || Date.now());
    var u = a ? t : u5(t), l = lu(u, e), s = a ? l : d5(t, l, e);
    return -s;
  }
  return NaN;
}
function u5(e) {
  return kg(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function lu(e, t) {
  var a = n5(e, t), n = kg(
    a[0],
    a[1] - 1,
    a[2],
    a[3] % 24,
    a[4],
    a[5],
    0
  ).getTime(), r = e.getTime(), i = r % 1e3;
  return r -= i >= 0 ? i : 1e3 + i, n - r;
}
function d5(e, t, a) {
  var n = e.getTime(), r = n - t, i = lu(new Date(r), a);
  if (t === i)
    return t;
  r -= i - t;
  var o = lu(new Date(r), a);
  return i === o ? i : Math.max(i, o);
}
function Qf(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var Zf = {};
function c5(e) {
  if (Zf[e]) return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), Zf[e] = !0, !0;
  } catch {
    return !1;
  }
}
var f5 = 60 * 1e3, v5 = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, a, n) {
    var r = Sl(n.timeZone, e);
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Xf(r);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Sr(r);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimeter
      default:
        return Sr(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, a, n) {
    var r = Sl(n.timeZone, e);
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Xf(r);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Sr(r);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimeter
      default:
        return Sr(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, a, n) {
    var r = Sl(n.timeZone, e);
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + p5(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Sr(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, a, n) {
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return jf("short", e, n);
      // Long
      case "zzzz":
      default:
        return jf("long", e, n);
    }
  }
};
function Sl(e, t) {
  var a = e ? td(e, t, !0) / f5 : t.getTimezoneOffset();
  if (Number.isNaN(a))
    throw new RangeError("Invalid time zone specified: " + e);
  return a;
}
function hs(e, t) {
  for (var a = e < 0 ? "-" : "", n = Math.abs(e).toString(); n.length < t; )
    n = "0" + n;
  return a + n;
}
function Sr(e, t) {
  var a = t || "", n = e > 0 ? "-" : "+", r = Math.abs(e), i = hs(Math.floor(r / 60), 2), o = hs(Math.floor(r % 60), 2);
  return n + i + a + o;
}
function Xf(e, t) {
  if (e % 60 === 0) {
    var a = e > 0 ? "-" : "+";
    return a + hs(Math.abs(e) / 60, 2);
  }
  return Sr(e, t);
}
function p5(e, t) {
  var a = e > 0 ? "-" : "+", n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
  if (i === 0)
    return a + String(r);
  var o = t;
  return a + String(r) + o + hs(i, 2);
}
var h5 = /* @__PURE__ */ ur();
const g5 = /* @__PURE__ */ Xs(h5);
var m5 = /* @__PURE__ */ Cg();
const Jf = /* @__PURE__ */ Xs(m5);
var y5 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, Tl = 36e5, ev = 6e4, b5 = 2, _t = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: y5
};
function $g(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var a = t || {}, n = a.additionalDigits == null ? b5 : g5(a.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var r = w5(e), i = C5(r.date, n), o = i.year, u = i.restDateString, l = k5(u, o);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var s = l.getTime(), d = 0, c;
    if (r.time && (d = $5(r.time), isNaN(d)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || a.timeZone) {
      if (c = td(r.timeZone || a.timeZone, new Date(s + d)), isNaN(c))
        return /* @__PURE__ */ new Date(NaN);
    } else
      c = Jf(new Date(s + d)), c = Jf(new Date(s + d + c));
    return new Date(s + d + c);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function w5(e) {
  var t = {}, a = _t.dateTimePattern.exec(e), n;
  if (a ? (t.date = a[1], n = a[3]) : (a = _t.datePattern.exec(e), a ? (t.date = a[1], n = a[2]) : (t.date = null, n = e)), n) {
    var r = _t.timeZone.exec(n);
    r ? (t.time = n.replace(r[1], ""), t.timeZone = r[1].trim()) : t.time = n;
  }
  return t;
}
function C5(e, t) {
  var a = _t.YYY[t], n = _t.YYYYY[t], r;
  if (r = _t.YYYY.exec(e) || n.exec(e), r) {
    var i = r[1];
    return {
      year: parseInt(i, 10),
      restDateString: e.slice(i.length)
    };
  }
  if (r = _t.YY.exec(e) || a.exec(e), r) {
    var o = r[1];
    return {
      year: parseInt(o, 10) * 100,
      restDateString: e.slice(o.length)
    };
  }
  return {
    year: null
  };
}
function k5(e, t) {
  if (t === null)
    return null;
  var a, n, r, i;
  if (e.length === 0)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  if (a = _t.MM.exec(e), a)
    return n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1, av(t, r) ? (n.setUTCFullYear(t, r), n) : /* @__PURE__ */ new Date(NaN);
  if (a = _t.DDD.exec(e), a) {
    n = /* @__PURE__ */ new Date(0);
    var o = parseInt(a[1], 10);
    return D5(t, o) ? (n.setUTCFullYear(t, 0, o), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = _t.MMDD.exec(e), a) {
    n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1;
    var u = parseInt(a[2], 10);
    return av(t, r, u) ? (n.setUTCFullYear(t, r, u), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = _t.Www.exec(e), a)
    return i = parseInt(a[1], 10) - 1, nv(t, i) ? tv(t, i) : /* @__PURE__ */ new Date(NaN);
  if (a = _t.WwwD.exec(e), a) {
    i = parseInt(a[1], 10) - 1;
    var l = parseInt(a[2], 10) - 1;
    return nv(t, i, l) ? tv(t, i, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function $5(e) {
  var t, a, n;
  if (t = _t.HH.exec(e), t)
    return a = parseFloat(t[1].replace(",", ".")), Dl(a) ? a % 24 * Tl : NaN;
  if (t = _t.HHMM.exec(e), t)
    return a = parseInt(t[1], 10), n = parseFloat(t[2].replace(",", ".")), Dl(a, n) ? a % 24 * Tl + n * ev : NaN;
  if (t = _t.HHMMSS.exec(e), t) {
    a = parseInt(t[1], 10), n = parseInt(t[2], 10);
    var r = parseFloat(t[3].replace(",", "."));
    return Dl(a, n, r) ? a % 24 * Tl + n * ev + r * 1e3 : NaN;
  }
  return null;
}
function tv(e, t, a) {
  t = t || 0, a = a || 0;
  var n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  var r = n.getUTCDay() || 7, i = t * 7 + a + 1 - r;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
var S5 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], T5 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Sg(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function av(e, t, a) {
  if (t < 0 || t > 11)
    return !1;
  if (a != null) {
    if (a < 1)
      return !1;
    var n = Sg(e);
    if (n && a > T5[t] || !n && a > S5[t])
      return !1;
  }
  return !0;
}
function D5(e, t) {
  if (t < 1)
    return !1;
  var a = Sg(e);
  return !(a && t > 366 || !a && t > 365);
}
function nv(e, t, a) {
  return !(t < 0 || t > 52 || a != null && (a < 0 || a > 6));
}
function Dl(e, t, a) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || a != null && (a < 0 || a >= 60));
}
var A5 = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function I5(e, t, a) {
  var n = String(t), r = a || {}, i = n.match(A5);
  if (i) {
    var o = $g(r.originalDate || e, r);
    n = i.reduce(function(u, l) {
      if (l[0] === "'")
        return u;
      var s = u.indexOf(l), d = u[s - 1] === "'", c = u.replace(
        l,
        "'" + v5[l[0]](o, l, null, r) + "'"
      );
      return d ? c.substring(0, s - 1) + c.substring(s + 1) : c;
    }, n);
  }
  return JT(e, n, r);
}
var Eo = { exports: {} }, Mo = { exports: {} }, rv;
function E5() {
  return rv || (rv = 1, function(e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = a;
    function a(n, r) {
      if (n == null)
        throw new TypeError("assign requires that input parameter not be null or undefined");
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
      return n;
    }
    e.exports = t.default;
  }(Mo, Mo.exports)), Mo.exports;
}
var iv;
function M5() {
  return iv || (iv = 1, function(e, t) {
    var a = wt().default;
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var n = a(/* @__PURE__ */ E5());
    function r(i) {
      return (0, n.default)({}, i);
    }
    e.exports = t.default;
  }(Eo, Eo.exports)), Eo.exports;
}
var O5 = /* @__PURE__ */ M5();
const x5 = /* @__PURE__ */ Xs(O5);
function P5(e, t, a) {
  var n = $g(e, a), r = td(t, n, !0), i = new Date(n.getTime() - r), o = /* @__PURE__ */ new Date(0);
  return o.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), o.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), o;
}
function Al(e, t, a, n) {
  var r = x5(n);
  return r.timeZone = t, r.originalDate = e, I5(P5(e, t), a, r);
}
function Cn(e, t) {
  M1(`Invalid prop: validator check failed for prop "${e}". ${t}`);
}
const N5 = { class: "k-segmented-control" }, L5 = ["data-testid", "disabled", "onClick"], B5 = /* @__PURE__ */ se({
  __name: "KSegmentedControl",
  props: {
    modelValue: {},
    options: {},
    size: { default: "small" },
    disabled: { type: Boolean }
  },
  emits: ["click", "update:modelValue"],
  setup(e, { emit: t }) {
    const a = (c) => c.every((f) => f.value !== void 0), n = (c) => {
      const f = [];
      return c.forEach((v) => f.push(v.value + "")), f;
    }, r = (c) => {
      const f = n(c), v = new Set(f);
      return f.length === v.size;
    }, i = (c) => c.map((f) => ({
      label: typeof f == "string" ? f : f.label || f.value + "",
      value: typeof f == "string" ? f.toLocaleLowerCase().replace(" ", "-") : f.value,
      disabled: typeof f == "string" ? !1 : f.disabled
    })), o = (c) => {
      const f = typeof c[0] == "string", v = i(c), m = r(v);
      return f ? m && a(v) : m;
    };
    ne(() => e.options, (c) => {
      o(c) || Cn("options", "The options prop must be an array of unique strings or objects with a unique value property.");
    }, { immediate: !0 });
    const u = t, l = b(() => i(e.options)), s = (c) => !!c.disabled || e.disabled, d = (c) => {
      u("click", c.value), u("update:modelValue", c.value);
    };
    return (c, f) => (y(), S("div", N5, [
      (y(!0), S(Ae, null, Le(l.value, (v) => (y(), S("button", {
        key: `${v.value}-option`,
        class: ue(["segmented-control-button", [c.size, { selected: c.modelValue === v.value }]]),
        "data-testid": `${v.value}-option`,
        disabled: s(v),
        type: "button",
        onClick: (m) => d(v)
      }, [
        j(c.$slots, "option-label", { option: v }, () => [
          be(ae(v.label), 1)
        ], !0)
      ], 10, L5))), 128))
    ]));
  }
}), Tg = /* @__PURE__ */ Me(B5, [["__scopeId", "data-v-e4688e7a"]]);
var Xt = "top", ma = "bottom", ya = "right", Jt = "left", ad = "auto", Yi = [Xt, ma, ya, Jt], Fr = "start", Mi = "end", R5 = "clippingParents", Dg = "viewport", si = "popper", F5 = "reference", ov = /* @__PURE__ */ Yi.reduce(function(e, t) {
  return e.concat([t + "-" + Fr, t + "-" + Mi]);
}, []), Ag = /* @__PURE__ */ [].concat(Yi, [ad]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Fr, t + "-" + Mi]);
}, []), z5 = "beforeRead", Y5 = "read", H5 = "afterRead", q5 = "beforeMain", W5 = "main", _5 = "afterMain", U5 = "beforeWrite", V5 = "write", K5 = "afterWrite", j5 = [z5, Y5, H5, q5, W5, _5, U5, V5, K5];
function Ya(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function la(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function tr(e) {
  var t = la(e).Element;
  return e instanceof t || e instanceof Element;
}
function pa(e) {
  var t = la(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function nd(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = la(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function G5(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(a) {
    var n = t.styles[a] || {}, r = t.attributes[a] || {}, i = t.elements[a];
    !pa(i) || !Ya(i) || (Object.assign(i.style, n), Object.keys(r).forEach(function(o) {
      var u = r[o];
      u === !1 ? i.removeAttribute(o) : i.setAttribute(o, u === !0 ? "" : u);
    }));
  });
}
function Q5(e) {
  var t = e.state, a = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, a.popper), t.styles = a, t.elements.arrow && Object.assign(t.elements.arrow.style, a.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var r = t.elements[n], i = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : a[n]), u = o.reduce(function(l, s) {
        return l[s] = "", l;
      }, {});
      !pa(r) || !Ya(r) || (Object.assign(r.style, u), Object.keys(i).forEach(function(l) {
        r.removeAttribute(l);
      }));
    });
  };
}
const Z5 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: G5,
  effect: Q5,
  requires: ["computeStyles"]
};
function Ba(e) {
  return e.split("-")[0];
}
var Qn = Math.max, gs = Math.min, zr = Math.round;
function uu() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Ig() {
  return !/^((?!chrome|android).)*safari/i.test(uu());
}
function Yr(e, t, a) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  var n = e.getBoundingClientRect(), r = 1, i = 1;
  t && pa(e) && (r = e.offsetWidth > 0 && zr(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && zr(n.height) / e.offsetHeight || 1);
  var o = tr(e) ? la(e) : window, u = o.visualViewport, l = !Ig() && a, s = (n.left + (l && u ? u.offsetLeft : 0)) / r, d = (n.top + (l && u ? u.offsetTop : 0)) / i, c = n.width / r, f = n.height / i;
  return {
    width: c,
    height: f,
    top: d,
    right: s + c,
    bottom: d + f,
    left: s,
    x: s,
    y: d
  };
}
function rd(e) {
  var t = Yr(e), a = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - a) <= 1 && (a = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: a,
    height: n
  };
}
function Eg(e, t) {
  var a = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (a && nd(a)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function sn(e) {
  return la(e).getComputedStyle(e);
}
function X5(e) {
  return ["table", "td", "th"].indexOf(Ya(e)) >= 0;
}
function Ln(e) {
  return ((tr(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function el(e) {
  return Ya(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (nd(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ln(e)
  );
}
function sv(e) {
  return !pa(e) || // https://github.com/popperjs/popper-core/issues/837
  sn(e).position === "fixed" ? null : e.offsetParent;
}
function J5(e) {
  var t = /firefox/i.test(uu()), a = /Trident/i.test(uu());
  if (a && pa(e)) {
    var n = sn(e);
    if (n.position === "fixed")
      return null;
  }
  var r = el(e);
  for (nd(r) && (r = r.host); pa(r) && ["html", "body"].indexOf(Ya(r)) < 0; ) {
    var i = sn(r);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function Hi(e) {
  for (var t = la(e), a = sv(e); a && X5(a) && sn(a).position === "static"; )
    a = sv(a);
  return a && (Ya(a) === "html" || Ya(a) === "body" && sn(a).position === "static") ? t : a || J5(e) || t;
}
function id(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function bi(e, t, a) {
  return Qn(e, gs(t, a));
}
function eD(e, t, a) {
  var n = bi(e, t, a);
  return n > a ? a : n;
}
function Mg() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Og(e) {
  return Object.assign({}, Mg(), e);
}
function xg(e, t) {
  return t.reduce(function(a, n) {
    return a[n] = e, a;
  }, {});
}
var tD = function(t, a) {
  return t = typeof t == "function" ? t(Object.assign({}, a.rects, {
    placement: a.placement
  })) : t, Og(typeof t != "number" ? t : xg(t, Yi));
};
function aD(e) {
  var t, a = e.state, n = e.name, r = e.options, i = a.elements.arrow, o = a.modifiersData.popperOffsets, u = Ba(a.placement), l = id(u), s = [Jt, ya].indexOf(u) >= 0, d = s ? "height" : "width";
  if (!(!i || !o)) {
    var c = tD(r.padding, a), f = rd(i), v = l === "y" ? Xt : Jt, m = l === "y" ? ma : ya, C = a.rects.reference[d] + a.rects.reference[l] - o[l] - a.rects.popper[d], p = o[l] - a.rects.reference[l], h = Hi(i), g = h ? l === "y" ? h.clientHeight || 0 : h.clientWidth || 0 : 0, w = C / 2 - p / 2, $ = c[v], T = g - f[d] - c[m], O = g / 2 - f[d] / 2 + w, M = bi($, O, T), F = l;
    a.modifiersData[n] = (t = {}, t[F] = M, t.centerOffset = M - O, t);
  }
}
function nD(e) {
  var t = e.state, a = e.options, n = a.element, r = n === void 0 ? "[data-popper-arrow]" : n;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || Eg(t.elements.popper, r) && (t.elements.arrow = r));
}
const rD = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: aD,
  effect: nD,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Hr(e) {
  return e.split("-")[1];
}
var iD = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function oD(e, t) {
  var a = e.x, n = e.y, r = t.devicePixelRatio || 1;
  return {
    x: zr(a * r) / r || 0,
    y: zr(n * r) / r || 0
  };
}
function lv(e) {
  var t, a = e.popper, n = e.popperRect, r = e.placement, i = e.variation, o = e.offsets, u = e.position, l = e.gpuAcceleration, s = e.adaptive, d = e.roundOffsets, c = e.isFixed, f = o.x, v = f === void 0 ? 0 : f, m = o.y, C = m === void 0 ? 0 : m, p = typeof d == "function" ? d({
    x: v,
    y: C
  }) : {
    x: v,
    y: C
  };
  v = p.x, C = p.y;
  var h = o.hasOwnProperty("x"), g = o.hasOwnProperty("y"), w = Jt, $ = Xt, T = window;
  if (s) {
    var O = Hi(a), M = "clientHeight", F = "clientWidth";
    if (O === la(a) && (O = Ln(a), sn(O).position !== "static" && u === "absolute" && (M = "scrollHeight", F = "scrollWidth")), O = O, r === Xt || (r === Jt || r === ya) && i === Mi) {
      $ = ma;
      var q = c && O === T && T.visualViewport ? T.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        O[M]
      );
      C -= q - n.height, C *= l ? 1 : -1;
    }
    if (r === Jt || (r === Xt || r === ma) && i === Mi) {
      w = ya;
      var x = c && O === T && T.visualViewport ? T.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        O[F]
      );
      v -= x - n.width, v *= l ? 1 : -1;
    }
  }
  var Y = Object.assign({
    position: u
  }, s && iD), R = d === !0 ? oD({
    x: v,
    y: C
  }, la(a)) : {
    x: v,
    y: C
  };
  if (v = R.x, C = R.y, l) {
    var k;
    return Object.assign({}, Y, (k = {}, k[$] = g ? "0" : "", k[w] = h ? "0" : "", k.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + v + "px, " + C + "px)" : "translate3d(" + v + "px, " + C + "px, 0)", k));
  }
  return Object.assign({}, Y, (t = {}, t[$] = g ? C + "px" : "", t[w] = h ? v + "px" : "", t.transform = "", t));
}
function sD(e) {
  var t = e.state, a = e.options, n = a.gpuAcceleration, r = n === void 0 ? !0 : n, i = a.adaptive, o = i === void 0 ? !0 : i, u = a.roundOffsets, l = u === void 0 ? !0 : u, s = {
    placement: Ba(t.placement),
    variation: Hr(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: r,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, lv(Object.assign({}, s, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, lv(Object.assign({}, s, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const lD = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: sD,
  data: {}
};
var Oo = {
  passive: !0
};
function uD(e) {
  var t = e.state, a = e.instance, n = e.options, r = n.scroll, i = r === void 0 ? !0 : r, o = n.resize, u = o === void 0 ? !0 : o, l = la(t.elements.popper), s = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && s.forEach(function(d) {
    d.addEventListener("scroll", a.update, Oo);
  }), u && l.addEventListener("resize", a.update, Oo), function() {
    i && s.forEach(function(d) {
      d.removeEventListener("scroll", a.update, Oo);
    }), u && l.removeEventListener("resize", a.update, Oo);
  };
}
const dD = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: uD,
  data: {}
};
var cD = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function _o(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return cD[t];
  });
}
var fD = {
  start: "end",
  end: "start"
};
function uv(e) {
  return e.replace(/start|end/g, function(t) {
    return fD[t];
  });
}
function od(e) {
  var t = la(e), a = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: a,
    scrollTop: n
  };
}
function sd(e) {
  return Yr(Ln(e)).left + od(e).scrollLeft;
}
function vD(e, t) {
  var a = la(e), n = Ln(e), r = a.visualViewport, i = n.clientWidth, o = n.clientHeight, u = 0, l = 0;
  if (r) {
    i = r.width, o = r.height;
    var s = Ig();
    (s || !s && t === "fixed") && (u = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: u + sd(e),
    y: l
  };
}
function pD(e) {
  var t, a = Ln(e), n = od(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, i = Qn(a.scrollWidth, a.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), o = Qn(a.scrollHeight, a.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), u = -n.scrollLeft + sd(e), l = -n.scrollTop;
  return sn(r || a).direction === "rtl" && (u += Qn(a.clientWidth, r ? r.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: u,
    y: l
  };
}
function ld(e) {
  var t = sn(e), a = t.overflow, n = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(a + r + n);
}
function Pg(e) {
  return ["html", "body", "#document"].indexOf(Ya(e)) >= 0 ? e.ownerDocument.body : pa(e) && ld(e) ? e : Pg(el(e));
}
function wi(e, t) {
  var a;
  t === void 0 && (t = []);
  var n = Pg(e), r = n === ((a = e.ownerDocument) == null ? void 0 : a.body), i = la(n), o = r ? [i].concat(i.visualViewport || [], ld(n) ? n : []) : n, u = t.concat(o);
  return r ? u : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    u.concat(wi(el(o)))
  );
}
function du(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function hD(e, t) {
  var a = Yr(e, !1, t === "fixed");
  return a.top = a.top + e.clientTop, a.left = a.left + e.clientLeft, a.bottom = a.top + e.clientHeight, a.right = a.left + e.clientWidth, a.width = e.clientWidth, a.height = e.clientHeight, a.x = a.left, a.y = a.top, a;
}
function dv(e, t, a) {
  return t === Dg ? du(vD(e, a)) : tr(t) ? hD(t, a) : du(pD(Ln(e)));
}
function gD(e) {
  var t = wi(el(e)), a = ["absolute", "fixed"].indexOf(sn(e).position) >= 0, n = a && pa(e) ? Hi(e) : e;
  return tr(n) ? t.filter(function(r) {
    return tr(r) && Eg(r, n) && Ya(r) !== "body";
  }) : [];
}
function mD(e, t, a, n) {
  var r = t === "clippingParents" ? gD(e) : [].concat(t), i = [].concat(r, [a]), o = i[0], u = i.reduce(function(l, s) {
    var d = dv(e, s, n);
    return l.top = Qn(d.top, l.top), l.right = gs(d.right, l.right), l.bottom = gs(d.bottom, l.bottom), l.left = Qn(d.left, l.left), l;
  }, dv(e, o, n));
  return u.width = u.right - u.left, u.height = u.bottom - u.top, u.x = u.left, u.y = u.top, u;
}
function Ng(e) {
  var t = e.reference, a = e.element, n = e.placement, r = n ? Ba(n) : null, i = n ? Hr(n) : null, o = t.x + t.width / 2 - a.width / 2, u = t.y + t.height / 2 - a.height / 2, l;
  switch (r) {
    case Xt:
      l = {
        x: o,
        y: t.y - a.height
      };
      break;
    case ma:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case ya:
      l = {
        x: t.x + t.width,
        y: u
      };
      break;
    case Jt:
      l = {
        x: t.x - a.width,
        y: u
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var s = r ? id(r) : null;
  if (s != null) {
    var d = s === "y" ? "height" : "width";
    switch (i) {
      case Fr:
        l[s] = l[s] - (t[d] / 2 - a[d] / 2);
        break;
      case Mi:
        l[s] = l[s] + (t[d] / 2 - a[d] / 2);
        break;
    }
  }
  return l;
}
function Oi(e, t) {
  t === void 0 && (t = {});
  var a = t, n = a.placement, r = n === void 0 ? e.placement : n, i = a.strategy, o = i === void 0 ? e.strategy : i, u = a.boundary, l = u === void 0 ? R5 : u, s = a.rootBoundary, d = s === void 0 ? Dg : s, c = a.elementContext, f = c === void 0 ? si : c, v = a.altBoundary, m = v === void 0 ? !1 : v, C = a.padding, p = C === void 0 ? 0 : C, h = Og(typeof p != "number" ? p : xg(p, Yi)), g = f === si ? F5 : si, w = e.rects.popper, $ = e.elements[m ? g : f], T = mD(tr($) ? $ : $.contextElement || Ln(e.elements.popper), l, d, o), O = Yr(e.elements.reference), M = Ng({
    reference: O,
    element: w,
    placement: r
  }), F = du(Object.assign({}, w, M)), q = f === si ? F : O, x = {
    top: T.top - q.top + h.top,
    bottom: q.bottom - T.bottom + h.bottom,
    left: T.left - q.left + h.left,
    right: q.right - T.right + h.right
  }, Y = e.modifiersData.offset;
  if (f === si && Y) {
    var R = Y[r];
    Object.keys(x).forEach(function(k) {
      var P = [ya, ma].indexOf(k) >= 0 ? 1 : -1, D = [Xt, ma].indexOf(k) >= 0 ? "y" : "x";
      x[k] += R[D] * P;
    });
  }
  return x;
}
function yD(e, t) {
  t === void 0 && (t = {});
  var a = t, n = a.placement, r = a.boundary, i = a.rootBoundary, o = a.padding, u = a.flipVariations, l = a.allowedAutoPlacements, s = l === void 0 ? Ag : l, d = Hr(n), c = d ? u ? ov : ov.filter(function(m) {
    return Hr(m) === d;
  }) : Yi, f = c.filter(function(m) {
    return s.indexOf(m) >= 0;
  });
  f.length === 0 && (f = c);
  var v = f.reduce(function(m, C) {
    return m[C] = Oi(e, {
      placement: C,
      boundary: r,
      rootBoundary: i,
      padding: o
    })[Ba(C)], m;
  }, {});
  return Object.keys(v).sort(function(m, C) {
    return v[m] - v[C];
  });
}
function bD(e) {
  if (Ba(e) === ad)
    return [];
  var t = _o(e);
  return [uv(e), t, uv(t)];
}
function wD(e) {
  var t = e.state, a = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var r = a.mainAxis, i = r === void 0 ? !0 : r, o = a.altAxis, u = o === void 0 ? !0 : o, l = a.fallbackPlacements, s = a.padding, d = a.boundary, c = a.rootBoundary, f = a.altBoundary, v = a.flipVariations, m = v === void 0 ? !0 : v, C = a.allowedAutoPlacements, p = t.options.placement, h = Ba(p), g = h === p, w = l || (g || !m ? [_o(p)] : bD(p)), $ = [p].concat(w).reduce(function(ge, Se) {
      return ge.concat(Ba(Se) === ad ? yD(t, {
        placement: Se,
        boundary: d,
        rootBoundary: c,
        padding: s,
        flipVariations: m,
        allowedAutoPlacements: C
      }) : Se);
    }, []), T = t.rects.reference, O = t.rects.popper, M = /* @__PURE__ */ new Map(), F = !0, q = $[0], x = 0; x < $.length; x++) {
      var Y = $[x], R = Ba(Y), k = Hr(Y) === Fr, P = [Xt, ma].indexOf(R) >= 0, D = P ? "width" : "height", B = Oi(t, {
        placement: Y,
        boundary: d,
        rootBoundary: c,
        altBoundary: f,
        padding: s
      }), J = P ? k ? ya : Jt : k ? ma : Xt;
      T[D] > O[D] && (J = _o(J));
      var _ = _o(J), te = [];
      if (i && te.push(B[R] <= 0), u && te.push(B[J] <= 0, B[_] <= 0), te.every(function(ge) {
        return ge;
      })) {
        q = Y, F = !1;
        break;
      }
      M.set(Y, te);
    }
    if (F)
      for (var G = m ? 3 : 1, pe = function(Se) {
        var Ue = $.find(function(Ne) {
          var He = M.get(Ne);
          if (He)
            return He.slice(0, Se).every(function(Xe) {
              return Xe;
            });
        });
        if (Ue)
          return q = Ue, "break";
      }, ce = G; ce > 0; ce--) {
        var $e = pe(ce);
        if ($e === "break") break;
      }
    t.placement !== q && (t.modifiersData[n]._skip = !0, t.placement = q, t.reset = !0);
  }
}
const CD = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: wD,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function cv(e, t, a) {
  return a === void 0 && (a = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - a.y,
    right: e.right - t.width + a.x,
    bottom: e.bottom - t.height + a.y,
    left: e.left - t.width - a.x
  };
}
function fv(e) {
  return [Xt, ya, ma, Jt].some(function(t) {
    return e[t] >= 0;
  });
}
function kD(e) {
  var t = e.state, a = e.name, n = t.rects.reference, r = t.rects.popper, i = t.modifiersData.preventOverflow, o = Oi(t, {
    elementContext: "reference"
  }), u = Oi(t, {
    altBoundary: !0
  }), l = cv(o, n), s = cv(u, r, i), d = fv(l), c = fv(s);
  t.modifiersData[a] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: s,
    isReferenceHidden: d,
    hasPopperEscaped: c
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": c
  });
}
const $D = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: kD
};
function SD(e, t, a) {
  var n = Ba(e), r = [Jt, Xt].indexOf(n) >= 0 ? -1 : 1, i = typeof a == "function" ? a(Object.assign({}, t, {
    placement: e
  })) : a, o = i[0], u = i[1];
  return o = o || 0, u = (u || 0) * r, [Jt, ya].indexOf(n) >= 0 ? {
    x: u,
    y: o
  } : {
    x: o,
    y: u
  };
}
function TD(e) {
  var t = e.state, a = e.options, n = e.name, r = a.offset, i = r === void 0 ? [0, 0] : r, o = Ag.reduce(function(d, c) {
    return d[c] = SD(c, t.rects, i), d;
  }, {}), u = o[t.placement], l = u.x, s = u.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += s), t.modifiersData[n] = o;
}
const DD = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: TD
};
function AD(e) {
  var t = e.state, a = e.name;
  t.modifiersData[a] = Ng({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const ID = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: AD,
  data: {}
};
function ED(e) {
  return e === "x" ? "y" : "x";
}
function MD(e) {
  var t = e.state, a = e.options, n = e.name, r = a.mainAxis, i = r === void 0 ? !0 : r, o = a.altAxis, u = o === void 0 ? !1 : o, l = a.boundary, s = a.rootBoundary, d = a.altBoundary, c = a.padding, f = a.tether, v = f === void 0 ? !0 : f, m = a.tetherOffset, C = m === void 0 ? 0 : m, p = Oi(t, {
    boundary: l,
    rootBoundary: s,
    padding: c,
    altBoundary: d
  }), h = Ba(t.placement), g = Hr(t.placement), w = !g, $ = id(h), T = ED($), O = t.modifiersData.popperOffsets, M = t.rects.reference, F = t.rects.popper, q = typeof C == "function" ? C(Object.assign({}, t.rects, {
    placement: t.placement
  })) : C, x = typeof q == "number" ? {
    mainAxis: q,
    altAxis: q
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, q), Y = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, R = {
    x: 0,
    y: 0
  };
  if (O) {
    if (i) {
      var k, P = $ === "y" ? Xt : Jt, D = $ === "y" ? ma : ya, B = $ === "y" ? "height" : "width", J = O[$], _ = J + p[P], te = J - p[D], G = v ? -F[B] / 2 : 0, pe = g === Fr ? M[B] : F[B], ce = g === Fr ? -F[B] : -M[B], $e = t.elements.arrow, ge = v && $e ? rd($e) : {
        width: 0,
        height: 0
      }, Se = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Mg(), Ue = Se[P], Ne = Se[D], He = bi(0, M[B], ge[B]), Xe = w ? M[B] / 2 - G - He - Ue - x.mainAxis : pe - He - Ue - x.mainAxis, ot = w ? -M[B] / 2 + G + He + Ne + x.mainAxis : ce + He + Ne + x.mainAxis, Ge = t.elements.arrow && Hi(t.elements.arrow), Je = Ge ? $ === "y" ? Ge.clientTop || 0 : Ge.clientLeft || 0 : 0, et = (k = Y == null ? void 0 : Y[$]) != null ? k : 0, ie = J + Xe - et - Je, le = J + ot - et, fe = bi(v ? gs(_, ie) : _, J, v ? Qn(te, le) : te);
      O[$] = fe, R[$] = fe - J;
    }
    if (u) {
      var z, Ce = $ === "x" ? Xt : Jt, xe = $ === "x" ? ma : ya, De = O[T], qe = T === "y" ? "height" : "width", ct = De + p[Ce], dt = De - p[xe], Qe = [Xt, Jt].indexOf(h) !== -1, pt = (z = Y == null ? void 0 : Y[T]) != null ? z : 0, It = Qe ? ct : De - M[qe] - F[qe] - pt + x.altAxis, Ot = Qe ? De + M[qe] + F[qe] - pt - x.altAxis : dt, Gt = v && Qe ? eD(It, De, Ot) : bi(v ? It : ct, De, v ? Ot : dt);
      O[T] = Gt, R[T] = Gt - De;
    }
    t.modifiersData[n] = R;
  }
}
const OD = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: MD,
  requiresIfExists: ["offset"]
};
function xD(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function PD(e) {
  return e === la(e) || !pa(e) ? od(e) : xD(e);
}
function ND(e) {
  var t = e.getBoundingClientRect(), a = zr(t.width) / e.offsetWidth || 1, n = zr(t.height) / e.offsetHeight || 1;
  return a !== 1 || n !== 1;
}
function LD(e, t, a) {
  a === void 0 && (a = !1);
  var n = pa(t), r = pa(t) && ND(t), i = Ln(t), o = Yr(e, r, a), u = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !a) && ((Ya(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  ld(i)) && (u = PD(t)), pa(t) ? (l = Yr(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = sd(i))), {
    x: o.left + u.scrollLeft - l.x,
    y: o.top + u.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function BD(e) {
  var t = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function r(i) {
    a.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(u) {
      if (!a.has(u)) {
        var l = t.get(u);
        l && r(l);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    a.has(i.name) || r(i);
  }), n;
}
function RD(e) {
  var t = BD(e);
  return j5.reduce(function(a, n) {
    return a.concat(t.filter(function(r) {
      return r.phase === n;
    }));
  }, []);
}
function FD(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(a) {
      Promise.resolve().then(function() {
        t = void 0, a(e());
      });
    })), t;
  };
}
function zD(e) {
  var t = e.reduce(function(a, n) {
    var r = a[n.name];
    return a[n.name] = r ? Object.assign({}, r, n, {
      options: Object.assign({}, r.options, n.options),
      data: Object.assign({}, r.data, n.data)
    }) : n, a;
  }, {});
  return Object.keys(t).map(function(a) {
    return t[a];
  });
}
var vv = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function pv() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function YD(e) {
  e === void 0 && (e = {});
  var t = e, a = t.defaultModifiers, n = a === void 0 ? [] : a, r = t.defaultOptions, i = r === void 0 ? vv : r;
  return function(u, l, s) {
    s === void 0 && (s = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, vv, i),
      modifiersData: {},
      elements: {
        reference: u,
        popper: l
      },
      attributes: {},
      styles: {}
    }, c = [], f = !1, v = {
      state: d,
      setOptions: function(h) {
        var g = typeof h == "function" ? h(d.options) : h;
        C(), d.options = Object.assign({}, i, d.options, g), d.scrollParents = {
          reference: tr(u) ? wi(u) : u.contextElement ? wi(u.contextElement) : [],
          popper: wi(l)
        };
        var w = RD(zD([].concat(n, d.options.modifiers)));
        return d.orderedModifiers = w.filter(function($) {
          return $.enabled;
        }), m(), v.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var h = d.elements, g = h.reference, w = h.popper;
          if (pv(g, w)) {
            d.rects = {
              reference: LD(g, Hi(w), d.options.strategy === "fixed"),
              popper: rd(w)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(x) {
              return d.modifiersData[x.name] = Object.assign({}, x.data);
            });
            for (var $ = 0; $ < d.orderedModifiers.length; $++) {
              if (d.reset === !0) {
                d.reset = !1, $ = -1;
                continue;
              }
              var T = d.orderedModifiers[$], O = T.fn, M = T.options, F = M === void 0 ? {} : M, q = T.name;
              typeof O == "function" && (d = O({
                state: d,
                options: F,
                name: q,
                instance: v
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: FD(function() {
        return new Promise(function(p) {
          v.forceUpdate(), p(d);
        });
      }),
      destroy: function() {
        C(), f = !0;
      }
    };
    if (!pv(u, l))
      return v;
    v.setOptions(s).then(function(p) {
      !f && s.onFirstUpdate && s.onFirstUpdate(p);
    });
    function m() {
      d.orderedModifiers.forEach(function(p) {
        var h = p.name, g = p.options, w = g === void 0 ? {} : g, $ = p.effect;
        if (typeof $ == "function") {
          var T = $({
            state: d,
            name: h,
            instance: v,
            options: w
          }), O = function() {
          };
          c.push(T || O);
        }
      });
    }
    function C() {
      c.forEach(function(p) {
        return p();
      }), c = [];
    }
    return v;
  };
}
var HD = [dD, ID, lD, Z5, DD, CD, OD, rD, $D], qD = /* @__PURE__ */ YD({
  defaultModifiers: HD
}), WD = Object.defineProperty, _D = (e, t, a) => t in e ? WD(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, Oe = (e, t, a) => (_D(e, typeof t != "symbol" ? t + "" : t, a), a), xo = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Lg(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var UD = Object.prototype, VD = UD.hasOwnProperty;
function KD(e, t) {
  return e != null && VD.call(e, t);
}
var jD = KD, GD = Array.isArray, Aa = GD, QD = typeof xo == "object" && xo && xo.Object === Object && xo, Bg = QD, ZD = Bg, XD = typeof self == "object" && self && self.Object === Object && self, JD = ZD || XD || Function("return this")(), ja = JD, e3 = ja, t3 = e3.Symbol, tl = t3, hv = tl, Rg = Object.prototype, a3 = Rg.hasOwnProperty, n3 = Rg.toString, li = hv ? hv.toStringTag : void 0;
function r3(e) {
  var t = a3.call(e, li), a = e[li];
  try {
    e[li] = void 0;
    var n = !0;
  } catch {
  }
  var r = n3.call(e);
  return n && (t ? e[li] = a : delete e[li]), r;
}
var i3 = r3, o3 = Object.prototype, s3 = o3.toString;
function l3(e) {
  return s3.call(e);
}
var u3 = l3, gv = tl, d3 = i3, c3 = u3, f3 = "[object Null]", v3 = "[object Undefined]", mv = gv ? gv.toStringTag : void 0;
function p3(e) {
  return e == null ? e === void 0 ? v3 : f3 : mv && mv in Object(e) ? d3(e) : c3(e);
}
var Ga = p3;
function h3(e) {
  return e != null && typeof e == "object";
}
var Ia = h3, g3 = Ga, m3 = Ia, y3 = "[object Symbol]";
function b3(e) {
  return typeof e == "symbol" || m3(e) && g3(e) == y3;
}
var ud = b3, w3 = Aa, C3 = ud, k3 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $3 = /^\w*$/;
function S3(e, t) {
  if (w3(e))
    return !1;
  var a = typeof e;
  return a == "number" || a == "symbol" || a == "boolean" || e == null || C3(e) ? !0 : $3.test(e) || !k3.test(e) || t != null && e in Object(t);
}
var dd = S3;
function T3(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var pn = T3, D3 = Ga, A3 = pn, I3 = "[object AsyncFunction]", E3 = "[object Function]", M3 = "[object GeneratorFunction]", O3 = "[object Proxy]";
function x3(e) {
  if (!A3(e))
    return !1;
  var t = D3(e);
  return t == E3 || t == M3 || t == I3 || t == O3;
}
var dr = x3, P3 = ja, N3 = P3["__core-js_shared__"], L3 = N3, Il = L3, yv = function() {
  var e = /[^.]+$/.exec(Il && Il.keys && Il.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function B3(e) {
  return !!yv && yv in e;
}
var R3 = B3, F3 = Function.prototype, z3 = F3.toString;
function Y3(e) {
  if (e != null) {
    try {
      return z3.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Fg = Y3, H3 = dr, q3 = R3, W3 = pn, _3 = Fg, U3 = /[\\^$.*+?()[\]{}|]/g, V3 = /^\[object .+?Constructor\]$/, K3 = Function.prototype, j3 = Object.prototype, G3 = K3.toString, Q3 = j3.hasOwnProperty, Z3 = RegExp(
  "^" + G3.call(Q3).replace(U3, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function X3(e) {
  if (!W3(e) || q3(e))
    return !1;
  var t = H3(e) ? Z3 : V3;
  return t.test(_3(e));
}
var J3 = X3;
function eA(e, t) {
  return e == null ? void 0 : e[t];
}
var tA = eA, aA = J3, nA = tA;
function rA(e, t) {
  var a = nA(e, t);
  return aA(a) ? a : void 0;
}
var cr = rA, iA = cr, oA = iA(Object, "create"), al = oA, bv = al;
function sA() {
  this.__data__ = bv ? bv(null) : {}, this.size = 0;
}
var lA = sA;
function uA(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var dA = uA, cA = al, fA = "__lodash_hash_undefined__", vA = Object.prototype, pA = vA.hasOwnProperty;
function hA(e) {
  var t = this.__data__;
  if (cA) {
    var a = t[e];
    return a === fA ? void 0 : a;
  }
  return pA.call(t, e) ? t[e] : void 0;
}
var gA = hA, mA = al, yA = Object.prototype, bA = yA.hasOwnProperty;
function wA(e) {
  var t = this.__data__;
  return mA ? t[e] !== void 0 : bA.call(t, e);
}
var CA = wA, kA = al, $A = "__lodash_hash_undefined__";
function SA(e, t) {
  var a = this.__data__;
  return this.size += this.has(e) ? 0 : 1, a[e] = kA && t === void 0 ? $A : t, this;
}
var TA = SA, DA = lA, AA = dA, IA = gA, EA = CA, MA = TA;
function Kr(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Kr.prototype.clear = DA;
Kr.prototype.delete = AA;
Kr.prototype.get = IA;
Kr.prototype.has = EA;
Kr.prototype.set = MA;
var OA = Kr;
function xA() {
  this.__data__ = [], this.size = 0;
}
var PA = xA;
function NA(e, t) {
  return e === t || e !== e && t !== t;
}
var jr = NA, LA = jr;
function BA(e, t) {
  for (var a = e.length; a--; )
    if (LA(e[a][0], t))
      return a;
  return -1;
}
var nl = BA, RA = nl, FA = Array.prototype, zA = FA.splice;
function YA(e) {
  var t = this.__data__, a = RA(t, e);
  if (a < 0)
    return !1;
  var n = t.length - 1;
  return a == n ? t.pop() : zA.call(t, a, 1), --this.size, !0;
}
var HA = YA, qA = nl;
function WA(e) {
  var t = this.__data__, a = qA(t, e);
  return a < 0 ? void 0 : t[a][1];
}
var _A = WA, UA = nl;
function VA(e) {
  return UA(this.__data__, e) > -1;
}
var KA = VA, jA = nl;
function GA(e, t) {
  var a = this.__data__, n = jA(a, e);
  return n < 0 ? (++this.size, a.push([e, t])) : a[n][1] = t, this;
}
var QA = GA, ZA = PA, XA = HA, JA = _A, eI = KA, tI = QA;
function Gr(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Gr.prototype.clear = ZA;
Gr.prototype.delete = XA;
Gr.prototype.get = JA;
Gr.prototype.has = eI;
Gr.prototype.set = tI;
var rl = Gr, aI = cr, nI = ja, rI = aI(nI, "Map"), cd = rI, wv = OA, iI = rl, oI = cd;
function sI() {
  this.size = 0, this.__data__ = {
    hash: new wv(),
    map: new (oI || iI)(),
    string: new wv()
  };
}
var lI = sI;
function uI(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var dI = uI, cI = dI;
function fI(e, t) {
  var a = e.__data__;
  return cI(t) ? a[typeof t == "string" ? "string" : "hash"] : a.map;
}
var il = fI, vI = il;
function pI(e) {
  var t = vI(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var hI = pI, gI = il;
function mI(e) {
  return gI(this, e).get(e);
}
var yI = mI, bI = il;
function wI(e) {
  return bI(this, e).has(e);
}
var CI = wI, kI = il;
function $I(e, t) {
  var a = kI(this, e), n = a.size;
  return a.set(e, t), this.size += a.size == n ? 0 : 1, this;
}
var SI = $I, TI = lI, DI = hI, AI = yI, II = CI, EI = SI;
function Qr(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.clear(); ++t < a; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Qr.prototype.clear = TI;
Qr.prototype.delete = DI;
Qr.prototype.get = AI;
Qr.prototype.has = II;
Qr.prototype.set = EI;
var fd = Qr, zg = fd, MI = "Expected a function";
function vd(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(MI);
  var a = function() {
    var n = arguments, r = t ? t.apply(this, n) : n[0], i = a.cache;
    if (i.has(r))
      return i.get(r);
    var o = e.apply(this, n);
    return a.cache = i.set(r, o) || i, o;
  };
  return a.cache = new (vd.Cache || zg)(), a;
}
vd.Cache = zg;
var OI = vd, xI = OI, PI = 500;
function NI(e) {
  var t = xI(e, function(n) {
    return a.size === PI && a.clear(), n;
  }), a = t.cache;
  return t;
}
var LI = NI, BI = LI, RI = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, FI = /\\(\\)?/g, zI = BI(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(RI, function(a, n, r, i) {
    t.push(r ? i.replace(FI, "$1") : n || a);
  }), t;
}), YI = zI;
function HI(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length, r = Array(n); ++a < n; )
    r[a] = t(e[a], a, e);
  return r;
}
var qI = HI, Cv = tl, WI = qI, _I = Aa, UI = ud, kv = Cv ? Cv.prototype : void 0, $v = kv ? kv.toString : void 0;
function Yg(e) {
  if (typeof e == "string")
    return e;
  if (_I(e))
    return WI(e, Yg) + "";
  if (UI(e))
    return $v ? $v.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var VI = Yg, KI = VI;
function jI(e) {
  return e == null ? "" : KI(e);
}
var GI = jI, QI = Aa, ZI = dd, XI = YI, JI = GI;
function eE(e, t) {
  return QI(e) ? e : ZI(e, t) ? [e] : XI(JI(e));
}
var Hg = eE, tE = Ga, aE = Ia, nE = "[object Arguments]";
function rE(e) {
  return aE(e) && tE(e) == nE;
}
var iE = rE, Sv = iE, oE = Ia, qg = Object.prototype, sE = qg.hasOwnProperty, lE = qg.propertyIsEnumerable, uE = Sv(/* @__PURE__ */ function() {
  return arguments;
}()) ? Sv : function(e) {
  return oE(e) && sE.call(e, "callee") && !lE.call(e, "callee");
}, pd = uE, dE = 9007199254740991, cE = /^(?:0|[1-9]\d*)$/;
function fE(e, t) {
  var a = typeof e;
  return t = t ?? dE, !!t && (a == "number" || a != "symbol" && cE.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var hd = fE, vE = 9007199254740991;
function pE(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= vE;
}
var gd = pE, hE = ud;
function gE(e) {
  if (typeof e == "string" || hE(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -1 / 0 ? "-0" : t;
}
var ol = gE, mE = Hg, yE = pd, bE = Aa, wE = hd, CE = gd, kE = ol;
function $E(e, t, a) {
  t = mE(t, e);
  for (var n = -1, r = t.length, i = !1; ++n < r; ) {
    var o = kE(t[n]);
    if (!(i = e != null && a(e, o)))
      break;
    e = e[o];
  }
  return i || ++n != r ? i : (r = e == null ? 0 : e.length, !!r && CE(r) && wE(o, r) && (bE(e) || yE(e)));
}
var Wg = $E, SE = jD, TE = Wg;
function DE(e, t) {
  return e != null && TE(e, t, SE);
}
var _g = DE, AE = Ga, IE = Ia, EE = "[object Date]";
function ME(e) {
  return IE(e) && AE(e) == EE;
}
var OE = ME;
function xE(e) {
  return function(t) {
    return e(t);
  };
}
var Ug = xE, xi = {}, PE = {
  get exports() {
    return xi;
  },
  set exports(e) {
    xi = e;
  }
};
(function(e, t) {
  var a = Bg, n = t && !t.nodeType && t, r = n && !0 && e && !e.nodeType && e, i = r && r.exports === n, o = i && a.process, u = function() {
    try {
      var l = r && r.require && r.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch {
    }
  }();
  e.exports = u;
})(PE, xi);
var NE = OE, LE = Ug, Tv = xi, Dv = Tv && Tv.isDate, BE = Dv ? LE(Dv) : NE, RE = BE, FE = Ga, zE = Aa, YE = Ia, HE = "[object String]";
function qE(e) {
  return typeof e == "string" || !zE(e) && YE(e) && FE(e) == HE;
}
var Pa = qE;
function WE(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length; ++a < n; )
    if (t(e[a], a, e))
      return !0;
  return !1;
}
var Vg = WE, _E = rl;
function UE() {
  this.__data__ = new _E(), this.size = 0;
}
var VE = UE;
function KE(e) {
  var t = this.__data__, a = t.delete(e);
  return this.size = t.size, a;
}
var jE = KE;
function GE(e) {
  return this.__data__.get(e);
}
var QE = GE;
function ZE(e) {
  return this.__data__.has(e);
}
var XE = ZE, JE = rl, eM = cd, tM = fd, aM = 200;
function nM(e, t) {
  var a = this.__data__;
  if (a instanceof JE) {
    var n = a.__data__;
    if (!eM || n.length < aM - 1)
      return n.push([e, t]), this.size = ++a.size, this;
    a = this.__data__ = new tM(n);
  }
  return a.set(e, t), this.size = a.size, this;
}
var rM = nM, iM = rl, oM = VE, sM = jE, lM = QE, uM = XE, dM = rM;
function Zr(e) {
  var t = this.__data__ = new iM(e);
  this.size = t.size;
}
Zr.prototype.clear = oM;
Zr.prototype.delete = sM;
Zr.prototype.get = lM;
Zr.prototype.has = uM;
Zr.prototype.set = dM;
var md = Zr, cM = "__lodash_hash_undefined__";
function fM(e) {
  return this.__data__.set(e, cM), this;
}
var vM = fM;
function pM(e) {
  return this.__data__.has(e);
}
var hM = pM, gM = fd, mM = vM, yM = hM;
function ms(e) {
  var t = -1, a = e == null ? 0 : e.length;
  for (this.__data__ = new gM(); ++t < a; )
    this.add(e[t]);
}
ms.prototype.add = ms.prototype.push = mM;
ms.prototype.has = yM;
var bM = ms;
function wM(e, t) {
  return e.has(t);
}
var CM = wM, kM = bM, $M = Vg, SM = CM, TM = 1, DM = 2;
function AM(e, t, a, n, r, i) {
  var o = a & TM, u = e.length, l = t.length;
  if (u != l && !(o && l > u))
    return !1;
  var s = i.get(e), d = i.get(t);
  if (s && d)
    return s == t && d == e;
  var c = -1, f = !0, v = a & DM ? new kM() : void 0;
  for (i.set(e, t), i.set(t, e); ++c < u; ) {
    var m = e[c], C = t[c];
    if (n)
      var p = o ? n(C, m, c, t, e, i) : n(m, C, c, e, t, i);
    if (p !== void 0) {
      if (p)
        continue;
      f = !1;
      break;
    }
    if (v) {
      if (!$M(t, function(h, g) {
        if (!SM(v, g) && (m === h || r(m, h, a, n, i)))
          return v.push(g);
      })) {
        f = !1;
        break;
      }
    } else if (!(m === C || r(m, C, a, n, i))) {
      f = !1;
      break;
    }
  }
  return i.delete(e), i.delete(t), f;
}
var Kg = AM, IM = ja, EM = IM.Uint8Array, jg = EM;
function MM(e) {
  var t = -1, a = Array(e.size);
  return e.forEach(function(n, r) {
    a[++t] = [r, n];
  }), a;
}
var OM = MM;
function xM(e) {
  var t = -1, a = Array(e.size);
  return e.forEach(function(n) {
    a[++t] = n;
  }), a;
}
var PM = xM, Av = tl, Iv = jg, NM = jr, LM = Kg, BM = OM, RM = PM, FM = 1, zM = 2, YM = "[object Boolean]", HM = "[object Date]", qM = "[object Error]", WM = "[object Map]", _M = "[object Number]", UM = "[object RegExp]", VM = "[object Set]", KM = "[object String]", jM = "[object Symbol]", GM = "[object ArrayBuffer]", QM = "[object DataView]", Ev = Av ? Av.prototype : void 0, El = Ev ? Ev.valueOf : void 0;
function ZM(e, t, a, n, r, i, o) {
  switch (a) {
    case QM:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case GM:
      return !(e.byteLength != t.byteLength || !i(new Iv(e), new Iv(t)));
    case YM:
    case HM:
    case _M:
      return NM(+e, +t);
    case qM:
      return e.name == t.name && e.message == t.message;
    case UM:
    case KM:
      return e == t + "";
    case WM:
      var u = BM;
    case VM:
      var l = n & FM;
      if (u || (u = RM), e.size != t.size && !l)
        return !1;
      var s = o.get(e);
      if (s)
        return s == t;
      n |= zM, o.set(e, t);
      var d = LM(u(e), u(t), n, r, i, o);
      return o.delete(e), d;
    case jM:
      if (El)
        return El.call(e) == El.call(t);
  }
  return !1;
}
var XM = ZM;
function JM(e, t) {
  for (var a = -1, n = t.length, r = e.length; ++a < n; )
    e[r + a] = t[a];
  return e;
}
var eO = JM, tO = eO, aO = Aa;
function nO(e, t, a) {
  var n = t(e);
  return aO(e) ? n : tO(n, a(e));
}
var rO = nO;
function iO(e, t) {
  for (var a = -1, n = e == null ? 0 : e.length, r = 0, i = []; ++a < n; ) {
    var o = e[a];
    t(o, a, e) && (i[r++] = o);
  }
  return i;
}
var oO = iO;
function sO() {
  return [];
}
var lO = sO, uO = oO, dO = lO, cO = Object.prototype, fO = cO.propertyIsEnumerable, Mv = Object.getOwnPropertySymbols, vO = Mv ? function(e) {
  return e == null ? [] : (e = Object(e), uO(Mv(e), function(t) {
    return fO.call(e, t);
  }));
} : dO, pO = vO;
function hO(e, t) {
  for (var a = -1, n = Array(e); ++a < e; )
    n[a] = t(a);
  return n;
}
var gO = hO, qr = {}, mO = {
  get exports() {
    return qr;
  },
  set exports(e) {
    qr = e;
  }
};
function yO() {
  return !1;
}
var bO = yO;
(function(e, t) {
  var a = ja, n = bO, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, u = o ? a.Buffer : void 0, l = u ? u.isBuffer : void 0, s = l || n;
  e.exports = s;
})(mO, qr);
var wO = Ga, CO = gd, kO = Ia, $O = "[object Arguments]", SO = "[object Array]", TO = "[object Boolean]", DO = "[object Date]", AO = "[object Error]", IO = "[object Function]", EO = "[object Map]", MO = "[object Number]", OO = "[object Object]", xO = "[object RegExp]", PO = "[object Set]", NO = "[object String]", LO = "[object WeakMap]", BO = "[object ArrayBuffer]", RO = "[object DataView]", FO = "[object Float32Array]", zO = "[object Float64Array]", YO = "[object Int8Array]", HO = "[object Int16Array]", qO = "[object Int32Array]", WO = "[object Uint8Array]", _O = "[object Uint8ClampedArray]", UO = "[object Uint16Array]", VO = "[object Uint32Array]", vt = {};
vt[FO] = vt[zO] = vt[YO] = vt[HO] = vt[qO] = vt[WO] = vt[_O] = vt[UO] = vt[VO] = !0;
vt[$O] = vt[SO] = vt[BO] = vt[TO] = vt[RO] = vt[DO] = vt[AO] = vt[IO] = vt[EO] = vt[MO] = vt[OO] = vt[xO] = vt[PO] = vt[NO] = vt[LO] = !1;
function KO(e) {
  return kO(e) && CO(e.length) && !!vt[wO(e)];
}
var jO = KO, GO = jO, QO = Ug, Ov = xi, xv = Ov && Ov.isTypedArray, ZO = xv ? QO(xv) : GO, yd = ZO, XO = gO, JO = pd, ex = Aa, tx = qr, ax = hd, nx = yd, rx = Object.prototype, ix = rx.hasOwnProperty;
function ox(e, t) {
  var a = ex(e), n = !a && JO(e), r = !a && !n && tx(e), i = !a && !n && !r && nx(e), o = a || n || r || i, u = o ? XO(e.length, String) : [], l = u.length;
  for (var s in e)
    (t || ix.call(e, s)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (s == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (s == "offset" || s == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    i && (s == "buffer" || s == "byteLength" || s == "byteOffset") || // Skip index properties.
    ax(s, l))) && u.push(s);
  return u;
}
var Gg = ox, sx = Object.prototype;
function lx(e) {
  var t = e && e.constructor, a = typeof t == "function" && t.prototype || sx;
  return e === a;
}
var bd = lx;
function ux(e, t) {
  return function(a) {
    return e(t(a));
  };
}
var Qg = ux, dx = Qg, cx = dx(Object.keys, Object), fx = cx, vx = bd, px = fx, hx = Object.prototype, gx = hx.hasOwnProperty;
function mx(e) {
  if (!vx(e))
    return px(e);
  var t = [];
  for (var a in Object(e))
    gx.call(e, a) && a != "constructor" && t.push(a);
  return t;
}
var yx = mx, bx = dr, wx = gd;
function Cx(e) {
  return e != null && wx(e.length) && !bx(e);
}
var qi = Cx, kx = Gg, $x = yx, Sx = qi;
function Tx(e) {
  return Sx(e) ? kx(e) : $x(e);
}
var wd = Tx, Dx = rO, Ax = pO, Ix = wd;
function Ex(e) {
  return Dx(e, Ix, Ax);
}
var Mx = Ex, Pv = Mx, Ox = 1, xx = Object.prototype, Px = xx.hasOwnProperty;
function Nx(e, t, a, n, r, i) {
  var o = a & Ox, u = Pv(e), l = u.length, s = Pv(t), d = s.length;
  if (l != d && !o)
    return !1;
  for (var c = l; c--; ) {
    var f = u[c];
    if (!(o ? f in t : Px.call(t, f)))
      return !1;
  }
  var v = i.get(e), m = i.get(t);
  if (v && m)
    return v == t && m == e;
  var C = !0;
  i.set(e, t), i.set(t, e);
  for (var p = o; ++c < l; ) {
    f = u[c];
    var h = e[f], g = t[f];
    if (n)
      var w = o ? n(g, h, f, t, e, i) : n(h, g, f, e, t, i);
    if (!(w === void 0 ? h === g || r(h, g, a, n, i) : w)) {
      C = !1;
      break;
    }
    p || (p = f == "constructor");
  }
  if (C && !p) {
    var $ = e.constructor, T = t.constructor;
    $ != T && "constructor" in e && "constructor" in t && !(typeof $ == "function" && $ instanceof $ && typeof T == "function" && T instanceof T) && (C = !1);
  }
  return i.delete(e), i.delete(t), C;
}
var Lx = Nx, Bx = cr, Rx = ja, Fx = Bx(Rx, "DataView"), zx = Fx, Yx = cr, Hx = ja, qx = Yx(Hx, "Promise"), Wx = qx, _x = cr, Ux = ja, Vx = _x(Ux, "Set"), Kx = Vx, jx = cr, Gx = ja, Qx = jx(Gx, "WeakMap"), Zx = Qx, cu = zx, fu = cd, vu = Wx, pu = Kx, hu = Zx, Zg = Ga, Xr = Fg, Nv = "[object Map]", Xx = "[object Object]", Lv = "[object Promise]", Bv = "[object Set]", Rv = "[object WeakMap]", Fv = "[object DataView]", Jx = Xr(cu), e8 = Xr(fu), t8 = Xr(vu), a8 = Xr(pu), n8 = Xr(hu), Hn = Zg;
(cu && Hn(new cu(new ArrayBuffer(1))) != Fv || fu && Hn(new fu()) != Nv || vu && Hn(vu.resolve()) != Lv || pu && Hn(new pu()) != Bv || hu && Hn(new hu()) != Rv) && (Hn = function(e) {
  var t = Zg(e), a = t == Xx ? e.constructor : void 0, n = a ? Xr(a) : "";
  if (n)
    switch (n) {
      case Jx:
        return Fv;
      case e8:
        return Nv;
      case t8:
        return Lv;
      case a8:
        return Bv;
      case n8:
        return Rv;
    }
  return t;
});
var r8 = Hn, Ml = md, i8 = Kg, o8 = XM, s8 = Lx, zv = r8, Yv = Aa, Hv = qr, l8 = yd, u8 = 1, qv = "[object Arguments]", Wv = "[object Array]", Po = "[object Object]", d8 = Object.prototype, _v = d8.hasOwnProperty;
function c8(e, t, a, n, r, i) {
  var o = Yv(e), u = Yv(t), l = o ? Wv : zv(e), s = u ? Wv : zv(t);
  l = l == qv ? Po : l, s = s == qv ? Po : s;
  var d = l == Po, c = s == Po, f = l == s;
  if (f && Hv(e)) {
    if (!Hv(t))
      return !1;
    o = !0, d = !1;
  }
  if (f && !d)
    return i || (i = new Ml()), o || l8(e) ? i8(e, t, a, n, r, i) : o8(e, t, l, a, n, r, i);
  if (!(a & u8)) {
    var v = d && _v.call(e, "__wrapped__"), m = c && _v.call(t, "__wrapped__");
    if (v || m) {
      var C = v ? e.value() : e, p = m ? t.value() : t;
      return i || (i = new Ml()), r(C, p, a, n, i);
    }
  }
  return f ? (i || (i = new Ml()), s8(e, t, a, n, r, i)) : !1;
}
var f8 = c8, v8 = f8, Uv = Ia;
function Xg(e, t, a, n, r) {
  return e === t ? !0 : e == null || t == null || !Uv(e) && !Uv(t) ? e !== e && t !== t : v8(e, t, a, n, Xg, r);
}
var Jg = Xg, p8 = md, h8 = Jg, g8 = 1, m8 = 2;
function y8(e, t, a, n) {
  var r = a.length, i = r, o = !n;
  if (e == null)
    return !i;
  for (e = Object(e); r--; ) {
    var u = a[r];
    if (o && u[2] ? u[1] !== e[u[0]] : !(u[0] in e))
      return !1;
  }
  for (; ++r < i; ) {
    u = a[r];
    var l = u[0], s = e[l], d = u[1];
    if (o && u[2]) {
      if (s === void 0 && !(l in e))
        return !1;
    } else {
      var c = new p8();
      if (n)
        var f = n(s, d, l, e, t, c);
      if (!(f === void 0 ? h8(d, s, g8 | m8, n, c) : f))
        return !1;
    }
  }
  return !0;
}
var b8 = y8, w8 = pn;
function C8(e) {
  return e === e && !w8(e);
}
var em = C8, k8 = em, $8 = wd;
function S8(e) {
  for (var t = $8(e), a = t.length; a--; ) {
    var n = t[a], r = e[n];
    t[a] = [n, r, k8(r)];
  }
  return t;
}
var T8 = S8;
function D8(e, t) {
  return function(a) {
    return a == null ? !1 : a[e] === t && (t !== void 0 || e in Object(a));
  };
}
var tm = D8, A8 = b8, I8 = T8, E8 = tm;
function M8(e) {
  var t = I8(e);
  return t.length == 1 && t[0][2] ? E8(t[0][0], t[0][1]) : function(a) {
    return a === e || A8(a, e, t);
  };
}
var O8 = M8, x8 = Hg, P8 = ol;
function N8(e, t) {
  t = x8(t, e);
  for (var a = 0, n = t.length; e != null && a < n; )
    e = e[P8(t[a++])];
  return a && a == n ? e : void 0;
}
var am = N8, L8 = am;
function B8(e, t, a) {
  var n = e == null ? void 0 : L8(e, t);
  return n === void 0 ? a : n;
}
var Kn = B8;
function R8(e, t) {
  return e != null && t in Object(e);
}
var F8 = R8, z8 = F8, Y8 = Wg;
function H8(e, t) {
  return e != null && Y8(e, t, z8);
}
var q8 = H8, W8 = Jg, _8 = Kn, U8 = q8, V8 = dd, K8 = em, j8 = tm, G8 = ol, Q8 = 1, Z8 = 2;
function X8(e, t) {
  return V8(e) && K8(t) ? j8(G8(e), t) : function(a) {
    var n = _8(a, e);
    return n === void 0 && n === t ? U8(a, e) : W8(t, n, Q8 | Z8);
  };
}
var J8 = X8;
function e4(e) {
  return e;
}
var Cd = e4;
function t4(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var a4 = t4, n4 = am;
function r4(e) {
  return function(t) {
    return n4(t, e);
  };
}
var i4 = r4, o4 = a4, s4 = i4, l4 = dd, u4 = ol;
function d4(e) {
  return l4(e) ? o4(u4(e)) : s4(e);
}
var c4 = d4, f4 = O8, v4 = J8, p4 = Cd, h4 = Aa, g4 = c4;
function m4(e) {
  return typeof e == "function" ? e : e == null ? p4 : typeof e == "object" ? h4(e) ? v4(e[0], e[1]) : f4(e) : g4(e);
}
var nm = m4;
function y4(e) {
  return function(t, a, n) {
    for (var r = -1, i = Object(t), o = n(t), u = o.length; u--; ) {
      var l = o[e ? u : ++r];
      if (a(i[l], l, i) === !1)
        break;
    }
    return t;
  };
}
var b4 = y4, w4 = b4, C4 = w4(), rm = C4, k4 = rm, $4 = wd;
function S4(e, t) {
  return e && k4(e, t, $4);
}
var im = S4, T4 = qi;
function D4(e, t) {
  return function(a, n) {
    if (a == null)
      return a;
    if (!T4(a))
      return e(a, n);
    for (var r = a.length, i = t ? r : -1, o = Object(a); (t ? i-- : ++i < r) && n(o[i], i, o) !== !1; )
      ;
    return a;
  };
}
var A4 = D4, I4 = im, E4 = A4, M4 = E4(I4), O4 = M4, x4 = O4;
function P4(e, t) {
  var a;
  return x4(e, function(n, r, i) {
    return a = t(n, r, i), !a;
  }), !!a;
}
var N4 = P4, L4 = jr, B4 = qi, R4 = hd, F4 = pn;
function z4(e, t, a) {
  if (!F4(a))
    return !1;
  var n = typeof t;
  return (n == "number" ? B4(a) && R4(t, a.length) : n == "string" && t in a) ? L4(a[t], e) : !1;
}
var kd = z4, Y4 = Vg, H4 = nm, q4 = N4, W4 = Aa, _4 = kd;
function U4(e, t, a) {
  var n = W4(e) ? Y4 : q4;
  return a && _4(e, t, a) && (t = void 0), n(e, H4(t));
}
var V4 = U4, K4 = Ga, j4 = Ia, G4 = "[object Boolean]";
function Q4(e) {
  return e === !0 || e === !1 || j4(e) && K4(e) == G4;
}
var Z4 = Q4, X4 = Ga, J4 = Ia, eP = "[object Number]";
function tP(e) {
  return typeof e == "number" || J4(e) && X4(e) == eP;
}
var Da = tP, aP = cr, nP = function() {
  try {
    var e = aP(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), om = nP, Vv = om;
function rP(e, t, a) {
  t == "__proto__" && Vv ? Vv(e, t, {
    configurable: !0,
    enumerable: !0,
    value: a,
    writable: !0
  }) : e[t] = a;
}
var sl = rP, iP = sl, oP = jr, sP = Object.prototype, lP = sP.hasOwnProperty;
function uP(e, t, a) {
  var n = e[t];
  (!(lP.call(e, t) && oP(n, a)) || a === void 0 && !(t in e)) && iP(e, t, a);
}
var dP = uP, cP = sl, fP = im, vP = nm;
function pP(e, t) {
  var a = {};
  return t = vP(t), fP(e, function(n, r, i) {
    cP(a, r, t(n, r, i));
  }), a;
}
var hP = pP;
function gP(e, t, a) {
  switch (a.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, a[0]);
    case 2:
      return e.call(t, a[0], a[1]);
    case 3:
      return e.call(t, a[0], a[1], a[2]);
  }
  return e.apply(t, a);
}
var sm = gP, mP = sm, Kv = Math.max;
function yP(e, t, a) {
  return t = Kv(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var n = arguments, r = -1, i = Kv(n.length - t, 0), o = Array(i); ++r < i; )
      o[r] = n[t + r];
    r = -1;
    for (var u = Array(t + 1); ++r < t; )
      u[r] = n[r];
    return u[t] = a(o), mP(e, this, u);
  };
}
var bP = yP;
function wP(e) {
  return function() {
    return e;
  };
}
var CP = wP, kP = CP, jv = om, $P = Cd, SP = jv ? function(e, t) {
  return jv(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: kP(t),
    writable: !0
  });
} : $P, TP = SP, DP = 800, AP = 16, IP = Date.now;
function EP(e) {
  var t = 0, a = 0;
  return function() {
    var n = IP(), r = AP - (n - a);
    if (a = n, r > 0) {
      if (++t >= DP)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var MP = EP, OP = TP, xP = MP, PP = xP(OP), NP = PP, LP = Cd, BP = bP, RP = NP;
function FP(e, t) {
  return RP(BP(e, t, LP), e + "");
}
var $d = FP;
function zP(e) {
  var t = [];
  if (e != null)
    for (var a in Object(e))
      t.push(a);
  return t;
}
var YP = zP, HP = pn, qP = bd, WP = YP, _P = Object.prototype, UP = _P.hasOwnProperty;
function VP(e) {
  if (!HP(e))
    return WP(e);
  var t = qP(e), a = [];
  for (var n in e)
    n == "constructor" && (t || !UP.call(e, n)) || a.push(n);
  return a;
}
var KP = VP, jP = Gg, GP = KP, QP = qi;
function ZP(e) {
  return QP(e) ? jP(e, !0) : GP(e);
}
var Sd = ZP, XP = $d, JP = jr, e7 = kd, t7 = Sd, lm = Object.prototype, a7 = lm.hasOwnProperty, n7 = XP(function(e, t) {
  e = Object(e);
  var a = -1, n = t.length, r = n > 2 ? t[2] : void 0;
  for (r && e7(t[0], t[1], r) && (n = 1); ++a < n; )
    for (var i = t[a], o = t7(i), u = -1, l = o.length; ++u < l; ) {
      var s = o[u], d = e[s];
      (d === void 0 || JP(d, lm[s]) && !a7.call(e, s)) && (e[s] = i[s]);
    }
  return e;
}), Gv = n7, r7 = sl, i7 = jr;
function o7(e, t, a) {
  (a !== void 0 && !i7(e[t], a) || a === void 0 && !(t in e)) && r7(e, t, a);
}
var um = o7, ys = {}, s7 = {
  get exports() {
    return ys;
  },
  set exports(e) {
    ys = e;
  }
};
(function(e, t) {
  var a = ja, n = t && !t.nodeType && t, r = n && !0 && e && !e.nodeType && e, i = r && r.exports === n, o = i ? a.Buffer : void 0, u = o ? o.allocUnsafe : void 0;
  function l(s, d) {
    if (d)
      return s.slice();
    var c = s.length, f = u ? u(c) : new s.constructor(c);
    return s.copy(f), f;
  }
  e.exports = l;
})(s7, ys);
var Qv = jg;
function l7(e) {
  var t = new e.constructor(e.byteLength);
  return new Qv(t).set(new Qv(e)), t;
}
var u7 = l7, d7 = u7;
function c7(e, t) {
  var a = t ? d7(e.buffer) : e.buffer;
  return new e.constructor(a, e.byteOffset, e.length);
}
var f7 = c7;
function v7(e, t) {
  var a = -1, n = e.length;
  for (t || (t = Array(n)); ++a < n; )
    t[a] = e[a];
  return t;
}
var p7 = v7, h7 = pn, Zv = Object.create, g7 = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!h7(t))
      return {};
    if (Zv)
      return Zv(t);
    e.prototype = t;
    var a = new e();
    return e.prototype = void 0, a;
  };
}(), m7 = g7, y7 = Qg, b7 = y7(Object.getPrototypeOf, Object), dm = b7, w7 = m7, C7 = dm, k7 = bd;
function $7(e) {
  return typeof e.constructor == "function" && !k7(e) ? w7(C7(e)) : {};
}
var S7 = $7, T7 = qi, D7 = Ia;
function A7(e) {
  return D7(e) && T7(e);
}
var I7 = A7, E7 = Ga, M7 = dm, O7 = Ia, x7 = "[object Object]", P7 = Function.prototype, N7 = Object.prototype, cm = P7.toString, L7 = N7.hasOwnProperty, B7 = cm.call(Object);
function R7(e) {
  if (!O7(e) || E7(e) != x7)
    return !1;
  var t = M7(e);
  if (t === null)
    return !0;
  var a = L7.call(t, "constructor") && t.constructor;
  return typeof a == "function" && a instanceof a && cm.call(a) == B7;
}
var F7 = R7;
function z7(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var fm = z7, Y7 = dP, H7 = sl;
function q7(e, t, a, n) {
  var r = !a;
  a || (a = {});
  for (var i = -1, o = t.length; ++i < o; ) {
    var u = t[i], l = n ? n(a[u], e[u], u, a, e) : void 0;
    l === void 0 && (l = e[u]), r ? H7(a, u, l) : Y7(a, u, l);
  }
  return a;
}
var W7 = q7, _7 = W7, U7 = Sd;
function V7(e) {
  return _7(e, U7(e));
}
var K7 = V7, Xv = um, j7 = ys, G7 = f7, Q7 = p7, Z7 = S7, Jv = pd, ep = Aa, X7 = I7, J7 = qr, eN = dr, tN = pn, aN = F7, nN = yd, tp = fm, rN = K7;
function iN(e, t, a, n, r, i, o) {
  var u = tp(e, a), l = tp(t, a), s = o.get(l);
  if (s) {
    Xv(e, a, s);
    return;
  }
  var d = i ? i(u, l, a + "", e, t, o) : void 0, c = d === void 0;
  if (c) {
    var f = ep(l), v = !f && J7(l), m = !f && !v && nN(l);
    d = l, f || v || m ? ep(u) ? d = u : X7(u) ? d = Q7(u) : v ? (c = !1, d = j7(l, !0)) : m ? (c = !1, d = G7(l, !0)) : d = [] : aN(l) || Jv(l) ? (d = u, Jv(u) ? d = rN(u) : (!tN(u) || eN(u)) && (d = Z7(l))) : c = !1;
  }
  c && (o.set(l, d), r(d, l, n, i, o), o.delete(l)), Xv(e, a, d);
}
var oN = iN, sN = md, lN = um, uN = rm, dN = oN, cN = pn, fN = Sd, vN = fm;
function vm(e, t, a, n, r) {
  e !== t && uN(t, function(i, o) {
    if (r || (r = new sN()), cN(i))
      dN(e, t, o, a, vm, n, r);
    else {
      var u = n ? n(vN(e, o), i, o + "", e, t, r) : void 0;
      u === void 0 && (u = i), lN(e, o, u);
    }
  }, fN);
}
var pm = vm, pN = pm, ap = pn;
function hm(e, t, a, n, r, i) {
  return ap(e) && ap(t) && (i.set(t, e), pN(e, t, void 0, hm, i), i.delete(t)), e;
}
var hN = hm, gN = $d, mN = kd;
function yN(e) {
  return gN(function(t, a) {
    var n = -1, r = a.length, i = r > 1 ? a[r - 1] : void 0, o = r > 2 ? a[2] : void 0;
    for (i = e.length > 3 && typeof i == "function" ? (r--, i) : void 0, o && mN(a[0], a[1], o) && (i = r < 3 ? void 0 : i, r = 1), t = Object(t); ++n < r; ) {
      var u = a[n];
      u && e(t, u, n, i);
    }
    return t;
  });
}
var bN = yN, wN = pm, CN = bN, kN = CN(function(e, t, a, n) {
  wN(e, t, a, n);
}), $N = kN, SN = sm, TN = $d, DN = hN, AN = $N, IN = TN(function(e) {
  return e.push(void 0, DN), SN(AN, void 0, e);
}), Pi = IN;
function EN(e) {
  return e && e.length ? e[0] : void 0;
}
var gm = EN;
function MN(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Ar = MN;
const ON = (e) => Object.prototype.toString.call(e).slice(8, -1), Or = (e) => RE(e) && !isNaN(e.getTime()), ln = (e) => ON(e) === "Object", mm = _g, np = (e, t) => V4(t, (a) => _g(e, a)), st = (e, t, a = "0") => {
  for (e = e != null ? String(e) : "", t = t || 2; e.length < t; )
    e = `${a}${e}`;
  return e;
}, ha = (e) => Array.isArray(e), tn = (e) => ha(e) && e.length > 0, bs = (e) => e == null ? null : document && Pa(e) ? document.querySelector(e) : e.$el ?? e, kn = (e, t, a, n = void 0) => {
  e.removeEventListener(t, a, n);
}, $n = (e, t, a, n = void 0) => (e.addEventListener(t, a, n), () => kn(e, t, a, n)), Uo = (e, t) => !!e && !!t && (e === t || e.contains(t)), No = (e, t) => {
  (e.key === " " || e.key === "Enter") && (t(e), e.preventDefault());
}, ym = (e, ...t) => {
  const a = {};
  let n;
  for (n in e)
    t.includes(n) || (a[n] = e[n]);
  return a;
}, bm = (e, t) => {
  const a = {};
  return t.forEach((n) => {
    n in e && (a[n] = e[n]);
  }), a;
};
function xN(e, t, a) {
  return Math.min(Math.max(e, t), a);
}
var ws = {}, PN = {
  get exports() {
    return ws;
  },
  set exports(e) {
    ws = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(n) {
    if (n === null || n === !0 || n === !1)
      return NaN;
    var r = Number(n);
    return isNaN(r) ? r : r < 0 ? Math.ceil(r) : Math.floor(r);
  }
  e.exports = t.default;
})(PN, ws);
const NN = /* @__PURE__ */ Lg(ws);
var Cs = {}, LN = {
  get exports() {
    return Cs;
  },
  set exports(e) {
    Cs = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = a;
  function a(n) {
    var r = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()));
    return r.setUTCFullYear(n.getFullYear()), n.getTime() - r.getTime();
  }
  e.exports = t.default;
})(LN, Cs);
const rp = /* @__PURE__ */ Lg(Cs);
function BN(e, t) {
  var a = YN(t);
  return a.formatToParts ? FN(a, e) : zN(a, e);
}
var RN = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function FN(e, t) {
  try {
    for (var a = e.formatToParts(t), n = [], r = 0; r < a.length; r++) {
      var i = RN[a[r].type];
      i >= 0 && (n[i] = parseInt(a[r].value, 10));
    }
    return n;
  } catch (o) {
    if (o instanceof RangeError)
      return [NaN];
    throw o;
  }
}
function zN(e, t) {
  var a = e.format(t).replace(/\u200E/g, ""), n = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(a);
  return [n[3], n[1], n[2], n[4], n[5], n[6]];
}
var Ol = {};
function YN(e) {
  if (!Ol[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), a = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    Ol[e] = a ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return Ol[e];
}
function wm(e, t, a, n, r, i, o) {
  var u = /* @__PURE__ */ new Date(0);
  return u.setUTCFullYear(e, t, a), u.setUTCHours(n, r, i, o), u;
}
var ip = 36e5, HN = 6e4, xl = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function qN(e, t, a) {
  var n, r;
  if (!e || (n = xl.timezoneZ.exec(e), n))
    return 0;
  var i;
  if (n = xl.timezoneHH.exec(e), n)
    return i = parseInt(n[1], 10), op(i) ? -(i * ip) : NaN;
  if (n = xl.timezoneHHMM.exec(e), n) {
    i = parseInt(n[1], 10);
    var o = parseInt(n[2], 10);
    return op(i, o) ? (r = Math.abs(i) * ip + o * HN, i > 0 ? -r : r) : NaN;
  }
  if (UN(e)) {
    t = new Date(t || Date.now());
    var u = WN(t), l = gu(u, e), s = _N(t, l, e);
    return -s;
  }
  return NaN;
}
function WN(e) {
  return wm(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function gu(e, t) {
  var a = BN(e, t), n = wm(
    a[0],
    a[1] - 1,
    a[2],
    a[3] % 24,
    a[4],
    a[5],
    0
  ).getTime(), r = e.getTime(), i = r % 1e3;
  return r -= i >= 0 ? i : 1e3 + i, n - r;
}
function _N(e, t, a) {
  var n = e.getTime(), r = n - t, i = gu(new Date(r), a);
  if (t === i)
    return t;
  r -= i - t;
  var o = gu(new Date(r), a);
  return i === o ? i : Math.max(i, o);
}
function op(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var sp = {};
function UN(e) {
  if (sp[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), sp[e] = !0, !0;
  } catch {
    return !1;
  }
}
var VN = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const KN = VN;
var Pl = 36e5, lp = 6e4, jN = 2, Ut = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: KN
};
function GN(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var a = t || {}, n = a.additionalDigits == null ? jN : NN(a.additionalDigits);
  if (n !== 2 && n !== 1 && n !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var r = QN(e), i = ZN(r.date, n), o = i.year, u = i.restDateString, l = XN(u, o);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var s = l.getTime(), d = 0, c;
    if (r.time && (d = JN(r.time), isNaN(d)))
      return /* @__PURE__ */ new Date(NaN);
    if (r.timeZone || a.timeZone) {
      if (c = qN(r.timeZone || a.timeZone, new Date(s + d)), isNaN(c))
        return /* @__PURE__ */ new Date(NaN);
    } else
      c = rp(new Date(s + d)), c = rp(new Date(s + d + c));
    return new Date(s + d + c);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function QN(e) {
  var t = {}, a = Ut.dateTimePattern.exec(e), n;
  if (a ? (t.date = a[1], n = a[3]) : (a = Ut.datePattern.exec(e), a ? (t.date = a[1], n = a[2]) : (t.date = null, n = e)), n) {
    var r = Ut.timeZone.exec(n);
    r ? (t.time = n.replace(r[1], ""), t.timeZone = r[1].trim()) : t.time = n;
  }
  return t;
}
function ZN(e, t) {
  var a = Ut.YYY[t], n = Ut.YYYYY[t], r;
  if (r = Ut.YYYY.exec(e) || n.exec(e), r) {
    var i = r[1];
    return {
      year: parseInt(i, 10),
      restDateString: e.slice(i.length)
    };
  }
  if (r = Ut.YY.exec(e) || a.exec(e), r) {
    var o = r[1];
    return {
      year: parseInt(o, 10) * 100,
      restDateString: e.slice(o.length)
    };
  }
  return {
    year: null
  };
}
function XN(e, t) {
  if (t === null)
    return null;
  var a, n, r, i;
  if (e.length === 0)
    return n = /* @__PURE__ */ new Date(0), n.setUTCFullYear(t), n;
  if (a = Ut.MM.exec(e), a)
    return n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1, dp(t, r) ? (n.setUTCFullYear(t, r), n) : /* @__PURE__ */ new Date(NaN);
  if (a = Ut.DDD.exec(e), a) {
    n = /* @__PURE__ */ new Date(0);
    var o = parseInt(a[1], 10);
    return a9(t, o) ? (n.setUTCFullYear(t, 0, o), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = Ut.MMDD.exec(e), a) {
    n = /* @__PURE__ */ new Date(0), r = parseInt(a[1], 10) - 1;
    var u = parseInt(a[2], 10);
    return dp(t, r, u) ? (n.setUTCFullYear(t, r, u), n) : /* @__PURE__ */ new Date(NaN);
  }
  if (a = Ut.Www.exec(e), a)
    return i = parseInt(a[1], 10) - 1, cp(t, i) ? up(t, i) : /* @__PURE__ */ new Date(NaN);
  if (a = Ut.WwwD.exec(e), a) {
    i = parseInt(a[1], 10) - 1;
    var l = parseInt(a[2], 10) - 1;
    return cp(t, i, l) ? up(t, i, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function JN(e) {
  var t, a, n;
  if (t = Ut.HH.exec(e), t)
    return a = parseFloat(t[1].replace(",", ".")), Nl(a) ? a % 24 * Pl : NaN;
  if (t = Ut.HHMM.exec(e), t)
    return a = parseInt(t[1], 10), n = parseFloat(t[2].replace(",", ".")), Nl(a, n) ? a % 24 * Pl + n * lp : NaN;
  if (t = Ut.HHMMSS.exec(e), t) {
    a = parseInt(t[1], 10), n = parseInt(t[2], 10);
    var r = parseFloat(t[3].replace(",", "."));
    return Nl(a, n, r) ? a % 24 * Pl + n * lp + r * 1e3 : NaN;
  }
  return null;
}
function up(e, t, a) {
  t = t || 0, a = a || 0;
  var n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  var r = n.getUTCDay() || 7, i = t * 7 + a + 1 - r;
  return n.setUTCDate(n.getUTCDate() + i), n;
}
var e9 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], t9 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Cm(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function dp(e, t, a) {
  if (t < 0 || t > 11)
    return !1;
  if (a != null) {
    if (a < 1)
      return !1;
    var n = Cm(e);
    if (n && a > t9[t] || !n && a > e9[t])
      return !1;
  }
  return !0;
}
function a9(e, t) {
  if (t < 1)
    return !1;
  var a = Cm(e);
  return !(a && t > 366 || !a && t > 365);
}
function cp(e, t, a) {
  return !(t < 0 || t > 52 || a != null && (a < 0 || a > 6));
}
function Nl(e, t, a) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || a != null && (a < 0 || a >= 60));
}
function Ht(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function Vo(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Vo = function(a) {
    return typeof a;
  } : Vo = function(a) {
    return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, Vo(e);
}
function hn(e) {
  Ht(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Vo(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Jr(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
var n9 = {};
function Td() {
  return n9;
}
function ar(e, t) {
  var a, n, r, i, o, u, l, s;
  Ht(1, arguments);
  var d = Td(), c = Jr((a = (n = (r = (i = t == null ? void 0 : t.weekStartsOn) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && r !== void 0 ? r : d.weekStartsOn) !== null && n !== void 0 ? n : (l = d.locale) === null || l === void 0 || (s = l.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && a !== void 0 ? a : 0);
  if (!(c >= 0 && c <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = hn(e), v = f.getDay(), m = (v < c ? 7 : 0) + v - c;
  return f.setDate(f.getDate() - m), f.setHours(0, 0, 0, 0), f;
}
function fp(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
var r9 = 6048e5;
function i9(e, t, a) {
  Ht(2, arguments);
  var n = ar(e, a), r = ar(t, a), i = n.getTime() - fp(n), o = r.getTime() - fp(r);
  return Math.round((i - o) / r9);
}
function o9(e) {
  Ht(1, arguments);
  var t = hn(e), a = t.getMonth();
  return t.setFullYear(t.getFullYear(), a + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function s9(e) {
  Ht(1, arguments);
  var t = hn(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function l9(e, t) {
  return Ht(1, arguments), i9(o9(e), s9(e), t) + 1;
}
function u9(e, t) {
  var a, n, r, i, o, u, l, s;
  Ht(1, arguments);
  var d = hn(e), c = d.getFullYear(), f = Td(), v = Jr((a = (n = (r = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : f.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = f.locale) === null || l === void 0 || (s = l.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(v >= 1 && v <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var m = /* @__PURE__ */ new Date(0);
  m.setFullYear(c + 1, 0, v), m.setHours(0, 0, 0, 0);
  var C = ar(m, t), p = /* @__PURE__ */ new Date(0);
  p.setFullYear(c, 0, v), p.setHours(0, 0, 0, 0);
  var h = ar(p, t);
  return d.getTime() >= C.getTime() ? c + 1 : d.getTime() >= h.getTime() ? c : c - 1;
}
function d9(e, t) {
  var a, n, r, i, o, u, l, s;
  Ht(1, arguments);
  var d = Td(), c = Jr((a = (n = (r = (i = t == null ? void 0 : t.firstWeekContainsDate) !== null && i !== void 0 ? i : t == null || (o = t.locale) === null || o === void 0 || (u = o.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && r !== void 0 ? r : d.firstWeekContainsDate) !== null && n !== void 0 ? n : (l = d.locale) === null || l === void 0 || (s = l.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && a !== void 0 ? a : 1), f = u9(e, t), v = /* @__PURE__ */ new Date(0);
  v.setFullYear(f, 0, c), v.setHours(0, 0, 0, 0);
  var m = ar(v, t);
  return m;
}
var c9 = 6048e5;
function f9(e, t) {
  Ht(1, arguments);
  var a = hn(e), n = ar(a, t).getTime() - d9(a, t).getTime();
  return Math.round(n / c9) + 1;
}
function ks(e) {
  return Ht(1, arguments), ar(e, {
    weekStartsOn: 1
  });
}
function v9(e) {
  Ht(1, arguments);
  var t = hn(e), a = t.getFullYear(), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(a + 1, 0, 4), n.setHours(0, 0, 0, 0);
  var r = ks(n), i = /* @__PURE__ */ new Date(0);
  i.setFullYear(a, 0, 4), i.setHours(0, 0, 0, 0);
  var o = ks(i);
  return t.getTime() >= r.getTime() ? a + 1 : t.getTime() >= o.getTime() ? a : a - 1;
}
function p9(e) {
  Ht(1, arguments);
  var t = v9(e), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0);
  var n = ks(a);
  return n;
}
var h9 = 6048e5;
function g9(e) {
  Ht(1, arguments);
  var t = hn(e), a = ks(t).getTime() - p9(t).getTime();
  return Math.round(a / h9) + 1;
}
function Wt(e, t) {
  Ht(2, arguments);
  var a = hn(e), n = Jr(t);
  return isNaN(n) ? /* @__PURE__ */ new Date(NaN) : (n && a.setDate(a.getDate() + n), a);
}
function $s(e, t) {
  Ht(2, arguments);
  var a = hn(e), n = Jr(t);
  if (isNaN(n))
    return /* @__PURE__ */ new Date(NaN);
  if (!n)
    return a;
  var r = a.getDate(), i = new Date(a.getTime());
  i.setMonth(a.getMonth() + n + 1, 0);
  var o = i.getDate();
  return r >= o ? i : (a.setFullYear(i.getFullYear(), i.getMonth(), r), a);
}
function vp(e, t) {
  Ht(2, arguments);
  var a = Jr(t);
  return $s(e, a * 12);
}
const m9 = {
  daily: ["year", "month", "day"],
  weekly: ["year", "month", "week"],
  monthly: ["year", "month"]
};
function y9({
  monthComps: e,
  prevMonthComps: t,
  nextMonthComps: a
}, n) {
  const r = [], {
    firstDayOfWeek: i,
    firstWeekday: o,
    isoWeeknumbers: u,
    weeknumbers: l,
    numDays: s,
    numWeeks: d
  } = e, c = o + (o < i ? Ft : 0) - i;
  let f = !0, v = !1, m = !1, C = 0;
  const p = new Intl.DateTimeFormat(n.id, {
    weekday: "long",
    year: "numeric",
    month: "short",
    day: "numeric"
  });
  let h = t.numDays - c + 1, g = t.numDays - h + 1, w = Math.floor((h - 1) / Ft + 1), $ = 1, T = t.numWeeks, O = 1, M = t.month, F = t.year;
  const q = /* @__PURE__ */ new Date(), x = q.getDate(), Y = q.getMonth() + 1, R = q.getFullYear();
  for (let k = 1; k <= d6; k++) {
    for (let P = 1, D = i; P <= Ft; P++, D += D === Ft ? 1 - Ft : 1) {
      f && D === o && (h = 1, g = e.numDays, w = Math.floor((h - 1) / Ft + 1), $ = Math.floor((s - h) / Ft + 1), T = 1, O = d, M = e.month, F = e.year, f = !1, v = !0);
      const B = n.getDateFromParams(F, M, h, 0, 0, 0, 0), J = n.getDateFromParams(F, M, h, 12, 0, 0, 0), _ = n.getDateFromParams(
        F,
        M,
        h,
        23,
        59,
        59,
        999
      ), te = B, G = `${st(F, 4)}-${st(M, 2)}-${st(h, 2)}`, pe = P, ce = Ft - P, $e = l[k - 1], ge = u[k - 1], Se = h === x && M === Y && F === R, Ue = v && h === 1, Ne = v && h === s, He = k === 1, Xe = k === d, ot = P === 1, Ge = P === Ft, Je = Pm(F, M, h);
      r.push({
        locale: n,
        id: G,
        position: ++C,
        label: h.toString(),
        ariaLabel: p.format(new Date(F, M - 1, h)),
        day: h,
        dayFromEnd: g,
        weekday: D,
        weekdayPosition: pe,
        weekdayPositionFromEnd: ce,
        weekdayOrdinal: w,
        weekdayOrdinalFromEnd: $,
        week: T,
        weekFromEnd: O,
        weekPosition: k,
        weeknumber: $e,
        isoWeeknumber: ge,
        month: M,
        year: F,
        date: te,
        startDate: B,
        endDate: _,
        noonDate: J,
        dayIndex: Je,
        isToday: Se,
        isFirstDay: Ue,
        isLastDay: Ne,
        isDisabled: !v,
        isFocusable: !v,
        isFocused: !1,
        inMonth: v,
        inPrevMonth: f,
        inNextMonth: m,
        onTop: He,
        onBottom: Xe,
        onLeft: ot,
        onRight: Ge,
        classes: [
          `id-${G}`,
          `day-${h}`,
          `day-from-end-${g}`,
          `weekday-${D}`,
          `weekday-position-${pe}`,
          `weekday-ordinal-${w}`,
          `weekday-ordinal-from-end-${$}`,
          `week-${T}`,
          `week-from-end-${O}`,
          {
            "is-today": Se,
            "is-first-day": Ue,
            "is-last-day": Ne,
            "in-month": v,
            "in-prev-month": f,
            "in-next-month": m,
            "on-top": He,
            "on-bottom": Xe,
            "on-left": ot,
            "on-right": Ge
          }
        ]
      }), v && Ne ? (v = !1, m = !0, h = 1, g = s, w = 1, $ = Math.floor((s - h) / Ft + 1), T = 1, O = a.numWeeks, M = a.month, F = a.year) : (h++, g--, w = Math.floor((h - 1) / Ft + 1), $ = Math.floor((s - h) / Ft + 1));
    }
    T++, O--;
  }
  return r;
}
function b9(e, t, a, n) {
  const r = e.reduce((i, o, u) => {
    const l = Math.floor(u / 7);
    let s = i[l];
    return s || (s = {
      id: `week-${l + 1}`,
      title: "",
      week: o.week,
      weekPosition: o.weekPosition,
      weeknumber: o.weeknumber,
      isoWeeknumber: o.isoWeeknumber,
      weeknumberDisplay: t ? o.weeknumber : a ? o.isoWeeknumber : void 0,
      days: []
    }, i[l] = s), s.days.push(o), i;
  }, Array(e.length / Ft));
  return r.forEach((i) => {
    const o = i.days[0], u = i.days[i.days.length - 1];
    o.month === u.month ? i.title = `${n.formatDate(o.date, "MMMM YYYY")}` : o.year === u.year ? i.title = `${n.formatDate(
      o.date,
      "MMM"
    )} - ${n.formatDate(u.date, "MMM YYYY")}` : i.title = `${n.formatDate(
      o.date,
      "MMM YYYY"
    )} - ${n.formatDate(u.date, "MMM YYYY")}`;
  }), r;
}
function w9(e, t) {
  return e.days.map((a) => ({
    label: t.formatDate(a.date, t.masks.weekdays),
    weekday: a.weekday
  }));
}
function C9(e, t) {
  return `${t}.${st(e, 2)}`;
}
function km(e, t, a) {
  return bm(
    a.getDateParts(a.toDate(e)),
    m9[t]
  );
}
function $m({ day: e, week: t, month: a, year: n }, r, i, o) {
  if (i === "daily" && e) {
    const u = new Date(n, a - 1, e), l = Wt(u, r);
    return {
      day: l.getDate(),
      month: l.getMonth() + 1,
      year: l.getFullYear()
    };
  } else if (i === "weekly" && t) {
    const l = o.getMonthParts(a, n).firstDayOfMonth, s = Wt(l, (t - 1 + r) * 7), d = o.getDateParts(s);
    return {
      week: d.week,
      month: d.month,
      year: d.year
    };
  } else {
    const u = new Date(n, a - 1, 1), l = $s(u, r);
    return {
      month: l.getMonth() + 1,
      year: l.getFullYear()
    };
  }
}
function Na(e) {
  return e != null && e.month != null && e.year != null;
}
function mu(e, t) {
  return !Na(e) || !Na(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year < t.year : e.month && t.month && e.month !== t.month ? e.month < t.month : e.week && t.week && e.week !== t.week ? e.week < t.week : e.day && t.day && e.day !== t.day ? e.day < t.day : !1);
}
function Ss(e, t) {
  return !Na(e) || !Na(t) ? !1 : (e = e, t = t, e.year !== t.year ? e.year > t.year : e.month && t.month && e.month !== t.month ? e.month > t.month : e.week && t.week && e.week !== t.week ? e.week > t.week : e.day && t.day && e.day !== t.day ? e.day > t.day : !1);
}
function k9(e, t, a) {
  return (e || !1) && !mu(e, t) && !Ss(e, a);
}
function $9(e, t) {
  return !e && t || e && !t ? !1 : !e && !t ? !0 : (e = e, t = t, e.year === t.year && e.month === t.month && e.week === t.week && e.day === t.day);
}
function S9(e, t, a, n) {
  if (!Na(e) || !Na(t))
    return [];
  const r = [];
  for (; !Ss(e, t); )
    r.push(e), e = $m(e, 1, a, n);
  return r;
}
function Sm(e) {
  const { day: t, week: a, month: n, year: r } = e;
  let i = `${r}-${st(n, 2)}`;
  return a && (i = `${i}-w${a}`), t && (i = `${i}-${st(t, 2)}`), i;
}
function T9(e, t) {
  const { month: a, year: n, showWeeknumbers: r, showIsoWeeknumbers: i } = e, o = new Date(n, a - 1, 15), u = t.getMonthParts(a, n), l = t.getPrevMonthParts(a, n), s = t.getNextMonthParts(a, n), d = y9({ monthComps: u, prevMonthComps: l, nextMonthComps: s }, t), c = b9(d, r, i, t), f = w9(c[0], t);
  return {
    id: Sm(e),
    month: a,
    year: n,
    monthTitle: t.formatDate(o, t.masks.title),
    shortMonthLabel: t.formatDate(o, "MMM"),
    monthLabel: t.formatDate(o, "MMMM"),
    shortYearLabel: n.toString().substring(2),
    yearLabel: n.toString(),
    monthComps: u,
    prevMonthComps: l,
    nextMonthComps: s,
    days: d,
    weeks: c,
    weekdays: f
  };
}
function D9(e, t) {
  const { day: a, week: n, view: r, trimWeeks: i } = e, o = {
    ...t,
    ...e,
    title: "",
    viewDays: [],
    viewWeeks: []
  };
  switch (r) {
    case "daily": {
      let u = o.days.find((s) => s.inMonth);
      a ? u = o.days.find((s) => s.day === a && s.inMonth) || u : n && (u = o.days.find((s) => s.week === n && s.inMonth));
      const l = o.weeks[u.week - 1];
      o.viewWeeks = [l], o.viewDays = [u], o.week = u.week, o.weekTitle = l.title, o.day = u.day, o.dayTitle = u.ariaLabel, o.title = o.dayTitle;
      break;
    }
    case "weekly": {
      o.week = n || 1;
      const u = o.weeks[o.week - 1];
      o.viewWeeks = [u], o.viewDays = u.days, o.weekTitle = u.title, o.title = o.weekTitle;
      break;
    }
    default: {
      o.title = o.monthTitle, o.viewWeeks = o.weeks.slice(
        0,
        i ? o.monthComps.numWeeks : void 0
      ), o.viewDays = o.days;
      break;
    }
  }
  return o;
}
class pp {
  constructor(t, a, n) {
    Oe(this, "keys", []), Oe(this, "store", {}), this.size = t, this.createKey = a, this.createItem = n;
  }
  get(...t) {
    const a = this.createKey(...t);
    return this.store[a];
  }
  getOrSet(...t) {
    const a = this.createKey(...t);
    if (this.store[a])
      return this.store[a];
    const n = this.createItem(...t);
    if (this.keys.length >= this.size) {
      const r = this.keys.shift();
      r != null && delete this.store[r];
    }
    return this.keys.push(a), this.store[a] = n, n;
  }
}
class xr {
  constructor(t, a = new Ts()) {
    Oe(this, "order"), Oe(this, "locale"), Oe(this, "start", null), Oe(this, "end", null), Oe(this, "repeat", null);
    var n;
    this.locale = a;
    const { start: r, end: i, span: o, order: u, repeat: l } = t;
    Or(r) && (this.start = a.getDateParts(r)), Or(i) ? this.end = a.getDateParts(i) : this.start != null && o && (this.end = a.getDateParts(Wt(this.start.date, o - 1))), this.order = u ?? 0, l && (this.repeat = new Ds(
      {
        from: (n = this.start) == null ? void 0 : n.date,
        ...l
      },
      {
        locale: this.locale
      }
    ));
  }
  static fromMany(t, a) {
    return (ha(t) ? t : [t]).filter((n) => n).map((n) => xr.from(n, a));
  }
  static from(t, a) {
    if (t instanceof xr)
      return t;
    const n = {
      start: null,
      end: null
    };
    return t != null && (ha(t) ? (n.start = t[0] ?? null, n.end = t[1] ?? null) : ln(t) ? Object.assign(n, t) : (n.start = t, n.end = t)), n.start != null && (n.start = new Date(n.start)), n.end != null && (n.end = new Date(n.end)), new xr(n, a);
  }
  get opts() {
    const { order: t, locale: a } = this;
    return { order: t, locale: a };
  }
  get hasRepeat() {
    return !!this.repeat;
  }
  get isSingleDay() {
    const { start: t, end: a } = this;
    return t && a && t.year === a.year && t.month === a.month && t.day === a.day;
  }
  get isMultiDay() {
    return !this.isSingleDay;
  }
  get daySpan() {
    return this.start == null || this.end == null ? this.hasRepeat ? 1 : 1 / 0 : this.end.dayIndex - this.start.dayIndex;
  }
  startsOnDay(t) {
    var a, n;
    return ((a = this.start) == null ? void 0 : a.dayIndex) === t.dayIndex || !!((n = this.repeat) != null && n.passes(t));
  }
  intersectsDay(t) {
    return this.intersectsDayRange(t, t);
  }
  intersectsRange(t) {
    var a, n;
    return this.intersectsDayRange(
      ((a = t.start) == null ? void 0 : a.dayIndex) ?? -1 / 0,
      ((n = t.end) == null ? void 0 : n.dayIndex) ?? 1 / 0
    );
  }
  intersectsDayRange(t, a) {
    return !(this.start && this.start.dayIndex > a || this.end && this.end.dayIndex < t);
  }
}
class A9 {
  constructor() {
    Oe(this, "records", {});
  }
  render(t, a, n) {
    var r, i, o, u;
    let l = null;
    const s = n[0].dayIndex, d = n[n.length - 1].dayIndex;
    return a.hasRepeat ? n.forEach((c) => {
      var f, v;
      if (a.startsOnDay(c)) {
        const m = a.daySpan < 1 / 0 ? a.daySpan : 1;
        l = {
          startDay: c.dayIndex,
          startTime: ((f = a.start) == null ? void 0 : f.time) ?? 0,
          endDay: c.dayIndex + m - 1,
          endTime: ((v = a.end) == null ? void 0 : v.time) ?? Ko
        }, this.getRangeRecords(t).push(l);
      }
    }) : a.intersectsDayRange(s, d) && (l = {
      startDay: ((r = a.start) == null ? void 0 : r.dayIndex) ?? -1 / 0,
      startTime: ((i = a.start) == null ? void 0 : i.time) ?? -1 / 0,
      endDay: ((o = a.end) == null ? void 0 : o.dayIndex) ?? 1 / 0,
      endTime: ((u = a.end) == null ? void 0 : u.time) ?? 1 / 0
    }, this.getRangeRecords(t).push(l)), l;
  }
  getRangeRecords(t) {
    let a = this.records[t.key];
    return a || (a = {
      ranges: [],
      data: t
    }, this.records[t.key] = a), a.ranges;
  }
  getCell(t, a) {
    return this.getCells(a).find((i) => i.data.key === t);
  }
  cellExists(t, a) {
    const n = this.records[t];
    return n == null ? !1 : n.ranges.some(
      (r) => r.startDay <= a && r.endDay >= a
    );
  }
  getCells(t) {
    const a = Object.values(this.records), n = [], { dayIndex: r } = t;
    return a.forEach(({ data: i, ranges: o }) => {
      o.filter((u) => u.startDay <= r && u.endDay >= r).forEach((u) => {
        const l = r === u.startDay, s = r === u.endDay, d = l ? u.startTime : 0, c = new Date(t.startDate.getTime() + d), f = s ? u.endTime : Ko, v = new Date(t.endDate.getTime() + f), m = d === 0 && f === Ko, C = i.order || 0;
        n.push({
          ...u,
          data: i,
          onStart: l,
          onEnd: s,
          startTime: d,
          startDate: c,
          endTime: f,
          endDate: v,
          allDay: m,
          order: C
        });
      });
    }), n.sort((i, o) => i.order - o.order), n;
  }
}
const un = {
  // Arabic
  ar: { dow: 7, L: "D/‏M/‏YYYY" },
  // Bulgarian
  bg: { dow: 2, L: "D.MM.YYYY" },
  // Catalan
  ca: { dow: 2, L: "DD/MM/YYYY" },
  // Chinese (China)
  "zh-CN": { dow: 2, L: "YYYY/MM/DD" },
  // Chinese (Taiwan)
  "zh-TW": { dow: 1, L: "YYYY/MM/DD" },
  // Croatian
  hr: { dow: 2, L: "DD.MM.YYYY" },
  // Czech
  cs: { dow: 2, L: "DD.MM.YYYY" },
  // Danish
  da: { dow: 2, L: "DD.MM.YYYY" },
  // Dutch
  nl: { dow: 2, L: "DD-MM-YYYY" },
  // English (US)
  "en-US": { dow: 1, L: "MM/DD/YYYY" },
  // English (Australia)
  "en-AU": { dow: 2, L: "DD/MM/YYYY" },
  // English (Canada)
  "en-CA": { dow: 1, L: "YYYY-MM-DD" },
  // English (Great Britain)
  "en-GB": { dow: 2, L: "DD/MM/YYYY" },
  // English (Ireland)
  "en-IE": { dow: 2, L: "DD-MM-YYYY" },
  // English (New Zealand)
  "en-NZ": { dow: 2, L: "DD/MM/YYYY" },
  // English (South Africa)
  "en-ZA": { dow: 1, L: "YYYY/MM/DD" },
  // Esperanto
  eo: { dow: 2, L: "YYYY-MM-DD" },
  // Estonian
  et: { dow: 2, L: "DD.MM.YYYY" },
  // Finnish
  fi: { dow: 2, L: "DD.MM.YYYY" },
  // French
  fr: { dow: 2, L: "DD/MM/YYYY" },
  // French (Canada)
  "fr-CA": { dow: 1, L: "YYYY-MM-DD" },
  // French (Switzerland)
  "fr-CH": { dow: 2, L: "DD.MM.YYYY" },
  // German
  de: { dow: 2, L: "DD.MM.YYYY" },
  // Hebrew
  he: { dow: 1, L: "DD.MM.YYYY" },
  // Indonesian
  id: { dow: 2, L: "DD/MM/YYYY" },
  // Italian
  it: { dow: 2, L: "DD/MM/YYYY" },
  // Japanese
  ja: { dow: 1, L: "YYYY年M月D日" },
  // Korean
  ko: { dow: 1, L: "YYYY.MM.DD" },
  // Latvian
  lv: { dow: 2, L: "DD.MM.YYYY" },
  // Lithuanian
  lt: { dow: 2, L: "DD.MM.YYYY" },
  // Macedonian
  mk: { dow: 2, L: "D.MM.YYYY" },
  // Norwegian
  nb: { dow: 2, L: "D. MMMM YYYY" },
  nn: { dow: 2, L: "D. MMMM YYYY" },
  // Polish
  pl: { dow: 2, L: "DD.MM.YYYY" },
  // Portuguese
  pt: { dow: 2, L: "DD/MM/YYYY" },
  // Romanian
  ro: { dow: 2, L: "DD.MM.YYYY" },
  // Russian
  ru: { dow: 2, L: "DD.MM.YYYY" },
  // Slovak
  sk: { dow: 2, L: "DD.MM.YYYY" },
  // Spanish (Spain)
  "es-ES": { dow: 2, L: "DD/MM/YYYY" },
  // Spanish (Mexico)
  "es-MX": { dow: 2, L: "DD/MM/YYYY" },
  // Swedish
  sv: { dow: 2, L: "YYYY-MM-DD" },
  // Thai
  th: { dow: 1, L: "DD/MM/YYYY" },
  // Turkish
  tr: { dow: 2, L: "DD.MM.YYYY" },
  // Ukrainian
  uk: { dow: 2, L: "DD.MM.YYYY" },
  // Vietnam
  vi: { dow: 2, L: "DD/MM/YYYY" }
};
un.en = un["en-US"];
un.es = un["es-ES"];
un.no = un.nb;
un.zh = un["zh-CN"];
const I9 = Object.entries(un).reduce(
  (e, [t, { dow: a, L: n }]) => (e[t] = {
    id: t,
    firstDayOfWeek: a,
    masks: { L: n }
  }, e),
  {}
), E9 = "MMMM YYYY", M9 = "W", O9 = "MMM", x9 = "h A", P9 = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], N9 = [
  "L h:mm A",
  "YYYY-MM-DD h:mm A",
  "YYYY/MM/DD h:mm A"
], L9 = [
  "L HH:mm",
  "YYYY-MM-DD HH:mm",
  "YYYY/MM/DD HH:mm"
], B9 = [
  "h:mm A"
], R9 = [
  "HH:mm"
], F9 = "WWW, MMM D, YYYY", z9 = [
  "L",
  "YYYY-MM-DD",
  "YYYY/MM/DD"
], Y9 = "iso", H9 = "YYYY-MM-DDTHH:mm:ss.SSSZ", q9 = {
  title: E9,
  weekdays: M9,
  navMonths: O9,
  hours: x9,
  input: P9,
  inputDateTime: N9,
  inputDateTime24hr: L9,
  inputTime: B9,
  inputTime24hr: R9,
  dayPopover: F9,
  data: z9,
  model: Y9,
  iso: H9
}, W9 = 300, _9 = 60, U9 = 80, V9 = {
  maxSwipeTime: W9,
  minHorizontalSwipeDistance: _9,
  maxVerticalSwipeDistance: U9
}, K9 = {
  componentPrefix: "V",
  color: "blue",
  isDark: !1,
  navVisibility: "click",
  titlePosition: "center",
  transition: "slide-h",
  touch: V9,
  masks: q9,
  locales: I9,
  datePicker: {
    updateOnInput: !0,
    inputDebounce: 1e3,
    popover: {
      visibility: "hover-focus",
      placement: "bottom-start",
      isInteractive: !0
    }
  }
}, yu = Ur(K9), j9 = b(() => hP(yu.locales, (e) => (e.masks = Pi(e.masks, yu.masks), e))), Pn = (e) => typeof window < "u" && mm(window.__vcalendar__, e) ? Kn(window.__vcalendar__, e) : Kn(yu, e), G9 = 12, Q9 = 5;
function Z9(e, t) {
  const a = new Intl.DateTimeFormat().resolvedOptions().locale;
  let n;
  Pa(e) ? n = e : mm(e, "id") && (n = e.id), n = (n || a).toLowerCase();
  const r = Object.keys(t), i = (l) => r.find((s) => s.toLowerCase() === l);
  n = i(n) || i(n.substring(0, 2)) || a;
  const o = {
    ...t["en-IE"],
    ...t[n],
    id: n,
    monthCacheSize: G9,
    pageCacheSize: Q9
  };
  return ln(e) ? Pi(e, o) : o;
}
class Ts {
  constructor(t = void 0, a) {
    Oe(this, "id"), Oe(this, "daysInWeek"), Oe(this, "firstDayOfWeek"), Oe(this, "masks"), Oe(this, "timezone"), Oe(this, "hourLabels"), Oe(this, "dayNames"), Oe(this, "dayNamesShort"), Oe(this, "dayNamesShorter"), Oe(this, "dayNamesNarrow"), Oe(this, "monthNames"), Oe(this, "monthNamesShort"), Oe(this, "relativeTimeNames"), Oe(this, "amPm", ["am", "pm"]), Oe(this, "monthCache"), Oe(this, "pageCache");
    const { id: n, firstDayOfWeek: r, masks: i, monthCacheSize: o, pageCacheSize: u } = Z9(t, j9.value);
    this.monthCache = new pp(
      o,
      b6,
      w6
    ), this.pageCache = new pp(u, Sm, T9), this.id = n, this.daysInWeek = Ft, this.firstDayOfWeek = xN(r, 1, Ft), this.masks = i, this.timezone = a || void 0, this.hourLabels = this.getHourLabels(), this.dayNames = Ll("long", this.id), this.dayNamesShort = Ll("short", this.id), this.dayNamesShorter = this.dayNamesShort.map((l) => l.substring(0, 2)), this.dayNamesNarrow = Ll("narrow", this.id), this.monthNames = wp("long", this.id), this.monthNamesShort = wp("short", this.id), this.relativeTimeNames = $6(this.id);
  }
  formatDate(t, a) {
    return I6(t, a, this);
  }
  parseDate(t, a) {
    return Cp(t, a, this);
  }
  toDate(t, a = {}) {
    const n = /* @__PURE__ */ new Date(NaN);
    let r = n;
    const { fillDate: i, mask: o, patch: u, rules: l } = a;
    if (Da(t) ? (a.type = "number", r = /* @__PURE__ */ new Date(+t)) : Pa(t) ? (a.type = "string", r = t ? Cp(t, o || "iso", this) : n) : Or(t) ? (a.type = "date", r = new Date(t.getTime())) : Dd(t) && (a.type = "object", r = this.getDateFromParts(t)), r && (u || l)) {
      let s = this.getDateParts(r);
      if (u && i != null) {
        const d = this.getDateParts(this.toDate(i));
        s = this.getDateParts(
          this.toDate({ ...d, ...bm(s, u6[u]) })
        );
      }
      l && (s = A6(s, l)), r = this.getDateFromParts(s);
    }
    return r || n;
  }
  toDateOrNull(t, a = {}) {
    const n = this.toDate(t, a);
    return isNaN(n.getTime()) ? null : n;
  }
  fromDate(t, { type: a, mask: n } = {}) {
    switch (a) {
      case "number":
        return t ? t.getTime() : NaN;
      case "string":
        return t ? this.formatDate(t, n || "iso") : "";
      case "object":
        return t ? this.getDateParts(t) : null;
      default:
        return t ? new Date(t) : null;
    }
  }
  range(t) {
    return xr.from(t, this);
  }
  ranges(t) {
    return xr.fromMany(t, this);
  }
  getDateParts(t) {
    return y6(t, this);
  }
  getDateFromParts(t) {
    return Lm(t, this.timezone);
  }
  getDateFromParams(t, a, n, r, i, o, u) {
    return this.getDateFromParts({
      year: t,
      month: a,
      day: n,
      hours: r,
      minutes: i,
      seconds: o,
      milliseconds: u
    });
  }
  getPage(t) {
    const a = this.pageCache.getOrSet(t, this);
    return D9(t, a);
  }
  getMonthParts(t, a) {
    const { firstDayOfWeek: n } = this;
    return this.monthCache.getOrSet(t, a, n);
  }
  getThisMonthParts() {
    const t = /* @__PURE__ */ new Date();
    return this.getMonthParts(
      t.getMonth() + 1,
      t.getFullYear()
    );
  }
  getPrevMonthParts(t, a) {
    return t === 1 ? this.getMonthParts(12, a - 1) : this.getMonthParts(t - 1, a);
  }
  getNextMonthParts(t, a) {
    return t === 12 ? this.getMonthParts(1, a + 1) : this.getMonthParts(t + 1, a);
  }
  getHourLabels() {
    return k6().map((t) => this.formatDate(t, this.masks.hours));
  }
  getDayId(t) {
    return this.formatDate(t, "YYYY-MM-DD");
  }
}
var Tr = /* @__PURE__ */ ((e) => (e.Any = "any", e.All = "all", e))(Tr || {}), Tm = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(Tm || {}), Dm = /* @__PURE__ */ ((e) => (e.Days = "days", e.Weekdays = "weekdays", e.Weeks = "weeks", e.Months = "months", e.Years = "years", e))(Dm || {}), Am = /* @__PURE__ */ ((e) => (e.OrdinalWeekdays = "ordinalWeekdays", e))(Am || {});
class X9 {
  constructor(t, a, n) {
    Oe(this, "validated", !0), this.type = t, this.interval = a, this.from = n, this.from || (console.error(
      'A valid "from" date is required for date interval rule. This rule will be skipped.'
    ), this.validated = !1);
  }
  passes(t) {
    if (!this.validated)
      return !0;
    const { date: a } = t;
    switch (this.type) {
      case "days":
        return Ad(this.from.date, a) % this.interval === 0;
      case "weeks":
        return g6(this.from.date, a) % this.interval === 0;
      case "months":
        return m6(this.from.date, a) % this.interval === 0;
      case "years":
        return Nm(this.from.date, a) % this.interval === 0;
      default:
        return !1;
    }
  }
}
class ei {
  constructor(t, a, n, r) {
    Oe(this, "components", []), this.type = t, this.validator = n, this.getter = r, this.components = this.normalizeComponents(a);
  }
  static create(t, a) {
    switch (t) {
      case "days":
        return new J9(a);
      case "weekdays":
        return new e6(a);
      case "weeks":
        return new t6(a);
      case "months":
        return new a6(a);
      case "years":
        return new n6(a);
    }
  }
  normalizeComponents(t) {
    if (this.validator(t))
      return [t];
    if (!ha(t))
      return [];
    const a = [];
    return t.forEach((n) => {
      if (!this.validator(n)) {
        console.error(
          `Component value ${n} in invalid for "${this.type}" rule. This rule will be skipped.`
        );
        return;
      }
      a.push(n);
    }), a;
  }
  passes(t) {
    return this.getter(t).some((r) => this.components.includes(r));
  }
}
class J9 extends ei {
  constructor(t) {
    super(
      "days",
      t,
      o6,
      ({ day: a, dayFromEnd: n }) => [a, -n]
    );
  }
}
class e6 extends ei {
  constructor(t) {
    super(
      "weekdays",
      t,
      bu,
      ({ weekday: a }) => [a]
    );
  }
}
class t6 extends ei {
  constructor(t) {
    super(
      "weeks",
      t,
      s6,
      ({ week: a, weekFromEnd: n }) => [a, -n]
    );
  }
}
class a6 extends ei {
  constructor(t) {
    super("months", t, l6, ({ month: a }) => [
      a
    ]);
  }
}
class n6 extends ei {
  constructor(t) {
    super("years", t, Da, ({ year: a }) => [a]);
  }
}
class r6 {
  constructor(t, a) {
    Oe(this, "components"), this.type = t, this.components = this.normalizeComponents(a);
  }
  normalizeArrayConfig(t) {
    const a = [];
    return t.forEach((n, r) => {
      if (Da(n)) {
        if (r === 0)
          return;
        if (!hp(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!bu(n)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        a.push([t[0], n]);
      } else ha(n) && a.push(...this.normalizeArrayConfig(n));
    }), a;
  }
  normalizeComponents(t) {
    const a = [];
    return t.forEach((n, r) => {
      if (Da(n)) {
        if (r === 0)
          return;
        if (!hp(t[0])) {
          console.error(
            `Ordinal range for "${this.type}" rule is from -5 to -1 or 1 to 5. This rule will be skipped.`
          );
          return;
        }
        if (!bu(n)) {
          console.error(
            `Acceptable range for "${this.type}" rule is from 1 to 5. This rule will be skipped`
          );
          return;
        }
        a.push([t[0], n]);
      } else ha(n) && a.push(...this.normalizeArrayConfig(n));
    }), a;
  }
  passes(t) {
    const { weekday: a, weekdayOrdinal: n, weekdayOrdinalFromEnd: r } = t;
    return this.components.some(
      ([i, o]) => (i === n || i === -r) && a === o
    );
  }
}
class i6 {
  constructor(t) {
    Oe(this, "type", "function"), Oe(this, "validated", !0), this.fn = t, dr(t) || (console.error(
      "The function rule requires a valid function. This rule will be skipped."
    ), this.validated = !1);
  }
  passes(t) {
    return this.validated ? this.fn(t) : !0;
  }
}
class Ds {
  constructor(t, a = {}, n) {
    Oe(this, "validated", !0), Oe(this, "config"), Oe(this, "type", Tr.Any), Oe(this, "from"), Oe(this, "until"), Oe(this, "rules", []), Oe(this, "locale", new Ts()), this.parent = n, a.locale && (this.locale = a.locale), this.config = t, dr(t) ? (this.type = Tr.All, this.rules = [new i6(t)]) : ha(t) ? (this.type = Tr.Any, this.rules = t.map((r) => new Ds(r, a, this))) : ln(t) ? (this.type = Tr.All, this.from = t.from ? this.locale.getDateParts(t.from) : n == null ? void 0 : n.from, this.until = t.until ? this.locale.getDateParts(t.until) : n == null ? void 0 : n.until, this.rules = this.getObjectRules(t)) : (console.error("Rule group configuration must be an object or an array."), this.validated = !1);
  }
  getObjectRules(t) {
    const a = [];
    if (t.every && (Pa(t.every) && (t.every = [1, `${t.every}s`]), ha(t.every))) {
      const [n = 1, r = Tm.Days] = t.every;
      a.push(new X9(r, n, this.from));
    }
    return Object.values(Dm).forEach((n) => {
      n in t && a.push(ei.create(n, t[n]));
    }), Object.values(Am).forEach((n) => {
      n in t && a.push(new r6(n, t[n]));
    }), t.on != null && (ha(t.on) || (t.on = [t.on]), a.push(
      new Ds(t.on, { locale: this.locale }, this.parent)
    )), a;
  }
  passes(t) {
    return this.validated ? this.from && t.dayIndex <= this.from.dayIndex || this.until && t.dayIndex >= this.until.dayIndex ? !1 : this.type === Tr.Any ? this.rules.some((a) => a.passes(t)) : this.rules.every((a) => a.passes(t)) : !0;
  }
}
function o6(e) {
  return Da(e) ? e >= 1 && e <= 31 : !1;
}
function bu(e) {
  return Da(e) ? e >= 1 && e <= 7 : !1;
}
function s6(e) {
  return Da(e) ? e >= -6 && e <= -1 || e >= 1 && e <= 6 : !1;
}
function l6(e) {
  return Da(e) ? e >= 1 && e <= 12 : !1;
}
function hp(e) {
  return !(!Da(e) || e < -5 || e > 5 || e === 0);
}
const u6 = {
  dateTime: [
    "year",
    "month",
    "day",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
  ],
  date: ["year", "month", "day"],
  time: ["hours", "minutes", "seconds", "milliseconds"]
}, Ft = 7, d6 = 6, Im = 1e3, Em = Im * 60, Mm = Em * 60, Ko = Mm * 24, c6 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], f6 = ["L", "iso"], vi = {
  milliseconds: [0, 999, 3],
  seconds: [0, 59, 2],
  minutes: [0, 59, 2],
  hours: [0, 23, 2]
}, Om = /d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|Z{1,4}|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g, v6 = /\[([^]*?)\]/gm, gp = {
  D(e) {
    return e.day;
  },
  DD(e) {
    return st(e.day, 2);
  },
  // Do(d: DateParts, l: Locale) {
  //   return l.DoFn(d.day);
  // },
  d(e) {
    return e.weekday - 1;
  },
  dd(e) {
    return st(e.weekday - 1, 2);
  },
  W(e, t) {
    return t.dayNamesNarrow[e.weekday - 1];
  },
  WW(e, t) {
    return t.dayNamesShorter[e.weekday - 1];
  },
  WWW(e, t) {
    return t.dayNamesShort[e.weekday - 1];
  },
  WWWW(e, t) {
    return t.dayNames[e.weekday - 1];
  },
  M(e) {
    return e.month;
  },
  MM(e) {
    return st(e.month, 2);
  },
  MMM(e, t) {
    return t.monthNamesShort[e.month - 1];
  },
  MMMM(e, t) {
    return t.monthNames[e.month - 1];
  },
  YY(e) {
    return String(e.year).substr(2);
  },
  YYYY(e) {
    return st(e.year, 4);
  },
  h(e) {
    return e.hours % 12 || 12;
  },
  hh(e) {
    return st(e.hours % 12 || 12, 2);
  },
  H(e) {
    return e.hours;
  },
  HH(e) {
    return st(e.hours, 2);
  },
  m(e) {
    return e.minutes;
  },
  mm(e) {
    return st(e.minutes, 2);
  },
  s(e) {
    return e.seconds;
  },
  ss(e) {
    return st(e.seconds, 2);
  },
  S(e) {
    return Math.round(e.milliseconds / 100);
  },
  SS(e) {
    return st(Math.round(e.milliseconds / 10), 2);
  },
  SSS(e) {
    return st(e.milliseconds, 3);
  },
  a(e, t) {
    return e.hours < 12 ? t.amPm[0] : t.amPm[1];
  },
  A(e, t) {
    return e.hours < 12 ? t.amPm[0].toUpperCase() : t.amPm[1].toUpperCase();
  },
  Z() {
    return "Z";
  },
  ZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${st(Math.floor(Math.abs(t) / 60), 2)}`;
  },
  ZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${st(
      Math.floor(Math.abs(t) / 60) * 100 + Math.abs(t) % 60,
      4
    )}`;
  },
  ZZZZ(e) {
    const t = e.timezoneOffset;
    return `${t > 0 ? "-" : "+"}${st(Math.floor(Math.abs(t) / 60), 2)}:${st(
      Math.abs(t) % 60,
      2
    )}`;
  }
}, yn = /\d\d?/, p6 = /\d{3}/, h6 = /\d{4}/, ui = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF/]+(\s*?[\u0600-\u06FF]+){1,2}/i, mp = () => {
}, yp = (e) => (t, a, n) => {
  const r = n[e].indexOf(
    a.charAt(0).toUpperCase() + a.substr(1).toLowerCase()
  );
  ~r && (t.month = r);
}, ut = {
  D: [
    yn,
    (e, t) => {
      e.day = t;
    }
  ],
  Do: [
    new RegExp(yn.source + ui.source),
    (e, t) => {
      e.day = parseInt(t, 10);
    }
  ],
  d: [yn, mp],
  W: [ui, mp],
  M: [
    yn,
    (e, t) => {
      e.month = t - 1;
    }
  ],
  MMM: [ui, yp("monthNamesShort")],
  MMMM: [ui, yp("monthNames")],
  YY: [
    yn,
    (e, t) => {
      const n = +(/* @__PURE__ */ new Date()).getFullYear().toString().substr(0, 2);
      e.year = +`${t > 68 ? n - 1 : n}${t}`;
    }
  ],
  YYYY: [
    h6,
    (e, t) => {
      e.year = t;
    }
  ],
  S: [
    /\d/,
    (e, t) => {
      e.milliseconds = t * 100;
    }
  ],
  SS: [
    /\d{2}/,
    (e, t) => {
      e.milliseconds = t * 10;
    }
  ],
  SSS: [
    p6,
    (e, t) => {
      e.milliseconds = t;
    }
  ],
  h: [
    yn,
    (e, t) => {
      e.hours = t;
    }
  ],
  m: [
    yn,
    (e, t) => {
      e.minutes = t;
    }
  ],
  s: [
    yn,
    (e, t) => {
      e.seconds = t;
    }
  ],
  a: [
    ui,
    (e, t, a) => {
      const n = t.toLowerCase();
      n === a.amPm[0] ? e.isPm = !1 : n === a.amPm[1] && (e.isPm = !0);
    }
  ],
  Z: [
    /[^\s]*?[+-]\d\d:?\d\d|[^\s]*?Z?/,
    (e, t) => {
      t === "Z" && (t = "+00:00");
      const a = `${t}`.match(/([+-]|\d\d)/gi);
      if (a) {
        const n = +a[1] * 60 + parseInt(a[2], 10);
        e.timezoneOffset = a[0] === "+" ? n : -n;
      }
    }
  ]
};
ut.DD = ut.D;
ut.dd = ut.d;
ut.WWWW = ut.WWW = ut.WW = ut.W;
ut.MM = ut.M;
ut.mm = ut.m;
ut.hh = ut.H = ut.HH = ut.h;
ut.ss = ut.s;
ut.A = ut.a;
ut.ZZZZ = ut.ZZZ = ut.ZZ = ut.Z;
function xm(e, t) {
  return (tn(e) && e || [
    Pa(e) && e || "YYYY-MM-DD"
  ]).map(
    (a) => f6.reduce(
      (n, r) => n.replace(r, t.masks[r] || ""),
      a
    )
  );
}
function Dd(e) {
  return ln(e) && "year" in e && "month" in e && "day" in e;
}
function bp(e, t = 1) {
  const a = e.getDay() + 1, n = a >= t ? t - a : -(7 - (t - a));
  return Wt(e, n);
}
function Pm(e, t, a) {
  const n = Date.UTC(e, t - 1, a);
  return Ad(/* @__PURE__ */ new Date(0), new Date(n));
}
function Ad(e, t) {
  return Math.round((t.getTime() - e.getTime()) / Ko);
}
function g6(e, t) {
  return Math.ceil(Ad(bp(e), bp(t)) / 7);
}
function Nm(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}
function m6(e, t) {
  return Nm(e, t) * 12 + (t.getMonth() - e.getMonth());
}
function Lm(e, t = "") {
  const a = /* @__PURE__ */ new Date(), {
    year: n = a.getFullYear(),
    month: r = a.getMonth() + 1,
    day: i = a.getDate(),
    hours: o = 0,
    minutes: u = 0,
    seconds: l = 0,
    milliseconds: s = 0
  } = e;
  if (t) {
    const d = `${st(n, 4)}-${st(r, 2)}-${st(i, 2)}T${st(
      o,
      2
    )}:${st(u, 2)}:${st(l, 2)}.${st(s, 3)}`;
    return GN(d, { timeZone: t });
  }
  return new Date(n, r - 1, i, o, u, l, s);
}
function y6(e, t) {
  let a = new Date(e.getTime());
  t.timezone && (a = new Date(
    e.toLocaleString("en-US", { timeZone: t.timezone })
  ), a.setMilliseconds(e.getMilliseconds()));
  const n = a.getMilliseconds(), r = a.getSeconds(), i = a.getMinutes(), o = a.getHours(), u = n + r * Im + i * Em + o * Mm, l = a.getMonth() + 1, s = a.getFullYear(), d = t.getMonthParts(l, s), c = a.getDate(), f = d.numDays - c + 1, v = a.getDay() + 1, m = Math.floor((c - 1) / 7 + 1), C = Math.floor((d.numDays - c) / 7 + 1), p = Math.ceil(
    (c + Math.abs(d.firstWeekday - d.firstDayOfWeek)) / 7
  ), h = d.numWeeks - p + 1, g = d.weeknumbers[p], w = Pm(s, l, c);
  return {
    milliseconds: n,
    seconds: r,
    minutes: i,
    hours: o,
    time: u,
    day: c,
    dayFromEnd: f,
    weekday: v,
    weekdayOrdinal: m,
    weekdayOrdinalFromEnd: C,
    week: p,
    weekFromEnd: h,
    weeknumber: g,
    month: l,
    year: s,
    date: a,
    dateTime: a.getTime(),
    dayIndex: w,
    timezoneOffset: 0,
    isValid: !0
  };
}
function b6(e, t, a) {
  return `${t}-${e}-${a}`;
}
function w6(e, t, a) {
  const n = t % 4 === 0 && t % 100 !== 0 || t % 400 === 0, r = new Date(t, e - 1, 1), i = r.getDay() + 1, o = e === 2 && n ? 29 : c6[e - 1], u = a - 1, l = l9(r, {
    weekStartsOn: u
  }), s = [], d = [];
  for (let c = 0; c < l; c++) {
    const f = Wt(r, c * 7);
    s.push(f9(f, { weekStartsOn: u })), d.push(g9(f));
  }
  return {
    firstDayOfWeek: a,
    firstDayOfMonth: r,
    inLeapYear: n,
    firstWeekday: i,
    numDays: o,
    numWeeks: l,
    month: e,
    year: t,
    weeknumbers: s,
    isoWeeknumbers: d
  };
}
function C6() {
  const e = [];
  for (let r = 0; r < Ft; r++)
    e.push(
      Lm({
        year: 2020,
        month: 1,
        day: 5 + r,
        hours: 12
      })
    );
  return e;
}
function Ll(e, t = void 0) {
  const a = new Intl.DateTimeFormat(t, {
    weekday: e
  });
  return C6().map((n) => a.format(n));
}
function k6() {
  const e = [];
  for (let t = 0; t <= 24; t++)
    e.push(new Date(2e3, 0, 1, t));
  return e;
}
function $6(e = void 0) {
  const t = [
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
  ], a = new Intl.RelativeTimeFormat(e);
  return t.reduce((n, r) => {
    const i = a.formatToParts(100, r);
    return n[r] = i[1].unit, n;
  }, {});
}
function Bm() {
  const e = [];
  for (let t = 0; t < 12; t++)
    e.push(new Date(2e3, t, 15));
  return e;
}
function wp(e, t = void 0) {
  const a = new Intl.DateTimeFormat(t, {
    month: e,
    timeZone: "UTC"
  });
  return Bm().map((n) => a.format(n));
}
function S6(e, t, a) {
  return Da(t) ? t === e : ha(t) ? t.includes(e) : dr(t) ? t(e, a) : !(t.min != null && t.min > e || t.max != null && t.max < e || t.interval != null && e % t.interval !== 0);
}
function pi(e, t, a) {
  const n = [], [r, i, o] = t;
  for (let u = r; u <= i; u++)
    (a == null || S6(u, a, e)) && n.push({
      value: u,
      label: st(u, o)
    });
  return n;
}
function T6(e, t) {
  return {
    milliseconds: pi(
      e,
      vi.milliseconds,
      t.milliseconds
    ),
    seconds: pi(e, vi.seconds, t.seconds),
    minutes: pi(e, vi.minutes, t.minutes),
    hours: pi(e, vi.hours, t.hours)
  };
}
function D6(e, t, a, n) {
  const i = pi(e, t, n).reduce((o, u) => {
    if (u.disabled)
      return o;
    if (isNaN(o))
      return u.value;
    const l = Math.abs(o - a);
    return Math.abs(u.value - a) < l ? u.value : o;
  }, NaN);
  return isNaN(i) ? a : i;
}
function A6(e, t) {
  const a = { ...e };
  return Object.entries(t).forEach(([n, r]) => {
    const i = vi[n], o = e[n];
    a[n] = D6(
      e,
      i,
      o,
      r
    );
  }), a;
}
function Cp(e, t, a) {
  return xm(t, a).map((r) => {
    if (typeof r != "string")
      throw new Error("Invalid mask");
    let i = e;
    if (i.length > 1e3)
      return !1;
    let o = !0;
    const u = {};
    if (r.replace(Om, (d) => {
      if (ut[d]) {
        const c = ut[d], f = i.search(c[0]);
        ~f ? i.replace(c[0], (v) => (c[1](u, v, a), i = i.substr(f + v.length), v)) : o = !1;
      }
      return ut[d] ? "" : d.slice(1, d.length - 1);
    }), !o)
      return !1;
    const l = /* @__PURE__ */ new Date();
    u.hours != null && (u.isPm === !0 && +u.hours != 12 ? u.hours = +u.hours + 12 : u.isPm === !1 && +u.hours == 12 && (u.hours = 0));
    let s;
    return u.timezoneOffset != null ? (u.minutes = +(u.minutes || 0) - +u.timezoneOffset, s = new Date(
      Date.UTC(
        u.year || l.getFullYear(),
        u.month || 0,
        u.day || 1,
        u.hours || 0,
        u.minutes || 0,
        u.seconds || 0,
        u.milliseconds || 0
      )
    )) : s = a.getDateFromParts({
      year: u.year || l.getFullYear(),
      month: (u.month || 0) + 1,
      day: u.day || 1,
      hours: u.hours || 0,
      minutes: u.minutes || 0,
      seconds: u.seconds || 0,
      milliseconds: u.milliseconds || 0
    }), s;
  }).find((r) => r) || new Date(e);
}
function I6(e, t, a) {
  if (e == null)
    return "";
  let n = xm(t, a)[0];
  /Z$/.test(n) && (a.timezone = "utc");
  const r = [];
  n = n.replace(v6, (o, u) => (r.push(u), "??"));
  const i = a.getDateParts(e);
  return n = n.replace(
    Om,
    (o) => o in gp ? gp[o](i, a) : o.slice(1, o.length - 1)
  ), n.replace(/\?\?/g, () => r.shift());
}
let E6 = 0;
class Rm {
  constructor(t, a, n) {
    Oe(this, "key", ""), Oe(this, "hashcode", ""), Oe(this, "highlight", null), Oe(this, "content", null), Oe(this, "dot", null), Oe(this, "bar", null), Oe(this, "event", null), Oe(this, "popover", null), Oe(this, "customData", null), Oe(this, "ranges"), Oe(this, "hasRanges", !1), Oe(this, "order", 0), Oe(this, "pinPage", !1), Oe(this, "maxRepeatSpan", 0), Oe(this, "locale");
    const { dates: r } = Object.assign(
      this,
      { hashcode: "", order: 0, pinPage: !1 },
      t
    );
    this.key || (this.key = ++E6), this.locale = n, a.normalizeGlyphs(this), this.ranges = n.ranges(r ?? []), this.hasRanges = !!tn(this.ranges), this.maxRepeatSpan = this.ranges.filter((i) => i.hasRepeat).map((i) => i.daySpan).reduce((i, o) => Math.max(i, o), 0);
  }
  intersectsRange({ start: t, end: a }) {
    if (t == null || a == null)
      return !1;
    const n = this.ranges.filter((o) => !o.hasRepeat);
    for (const o of n)
      if (o.intersectsDayRange(t.dayIndex, a.dayIndex))
        return !0;
    const r = this.ranges.filter((o) => o.hasRepeat);
    if (!r.length)
      return !1;
    let i = t;
    for (this.maxRepeatSpan > 1 && (i = this.locale.getDateParts(Wt(i.date, -this.maxRepeatSpan))); i.dayIndex <= a.dayIndex; ) {
      for (const o of r)
        if (o.startsOnDay(i))
          return !0;
      i = this.locale.getDateParts(Wt(i.date, 1));
    }
    return !1;
  }
}
function wu(e) {
  document && document.dispatchEvent(
    new CustomEvent("show-popover", {
      detail: e
    })
  );
}
function Ni(e) {
  document && document.dispatchEvent(
    new CustomEvent("hide-popover", {
      detail: e
    })
  );
}
function Fm(e) {
  document && document.dispatchEvent(
    new CustomEvent("toggle-popover", {
      detail: e
    })
  );
}
function zm(e) {
  const { visibility: t } = e, a = t === "click", n = t === "hover", r = t === "hover-focus", i = t === "focus";
  e.autoHide = !a;
  let o = !1, u = !1;
  const l = (m) => {
    a && (Fm({
      ...e,
      target: e.target || m.currentTarget
    }), m.stopPropagation());
  }, s = (m) => {
    o || (o = !0, (n || r) && wu({
      ...e,
      target: e.target || m.currentTarget
    }));
  }, d = () => {
    o && (o = !1, (n || r && !u) && Ni(e));
  }, c = (m) => {
    u || (u = !0, (i || r) && wu({
      ...e,
      target: e.target || m.currentTarget
    }));
  }, f = (m) => {
    u && !Uo(m.currentTarget, m.relatedTarget) && (u = !1, (i || r && !o) && Ni(e));
  }, v = {};
  switch (e.visibility) {
    case "click":
      v.click = l;
      break;
    case "hover":
      v.mousemove = s, v.mouseleave = d;
      break;
    case "focus":
      v.focusin = c, v.focusout = f;
      break;
    case "hover-focus":
      v.mousemove = s, v.mouseleave = d, v.focusin = c, v.focusout = f;
      break;
  }
  return v;
}
const kp = (e) => {
  const t = bs(e);
  if (t == null)
    return;
  const a = t.popoverHandlers;
  !a || !a.length || (a.forEach((n) => n()), delete t.popoverHandlers);
}, $p = (e, t) => {
  const a = bs(e);
  if (a == null)
    return;
  const n = [], r = zm(t);
  Object.entries(r).forEach(([i, o]) => {
    n.push($n(a, i, o));
  }), a.popoverHandlers = n;
}, Ym = {
  mounted(e, t) {
    const { value: a } = t;
    a && $p(e, a);
  },
  updated(e, t) {
    const { oldValue: a, value: n } = t, r = a == null ? void 0 : a.visibility, i = n == null ? void 0 : n.visibility;
    r !== i && (r && (kp(e), i || Ni(a)), i && $p(e, n));
  },
  unmounted(e) {
    kp(e);
  }
}, M6 = (e, t, {
  maxSwipeTime: a,
  minHorizontalSwipeDistance: n,
  maxVerticalSwipeDistance: r
}) => {
  if (!e || !e.addEventListener || !dr(t))
    return null;
  let i = 0, o = 0, u = null, l = !1;
  function s(c) {
    const f = c.changedTouches[0];
    i = f.screenX, o = f.screenY, u = (/* @__PURE__ */ new Date()).getTime(), l = !0;
  }
  function d(c) {
    if (!l || !u)
      return;
    l = !1;
    const f = c.changedTouches[0], v = f.screenX - i, m = f.screenY - o;
    if ((/* @__PURE__ */ new Date()).getTime() - u < a && Math.abs(v) >= n && Math.abs(m) <= r) {
      const p = { toLeft: !1, toRight: !1 };
      v < 0 ? p.toLeft = !0 : p.toRight = !0, t(p);
    }
  }
  return $n(e, "touchstart", s, { passive: !0 }), $n(e, "touchend", d, { passive: !0 }), () => {
    kn(e, "touchstart", s), kn(e, "touchend", d);
  };
}, jo = {}, O6 = (e, t = 10) => {
  jo[e] = Date.now() + t;
}, x6 = (e, t) => {
  if (e in jo) {
    const a = jo[e];
    if (Date.now() < a)
      return;
    delete jo[e];
  }
  t();
};
function Hm() {
  return typeof window < "u";
}
function P6(e) {
  return Hm() && e in window;
}
function N6(e) {
  const t = L(!1), a = b(() => t.value ? "dark" : "light");
  let n, r;
  function i(v) {
    t.value = v.matches;
  }
  function o() {
    P6("matchMedia") && (n = window.matchMedia("(prefers-color-scheme: dark)"), n.addEventListener("change", i), t.value = n.matches);
  }
  function u() {
    const { selector: v = ":root", darkClass: m = "dark" } = e.value, C = document.querySelector(v);
    t.value = C.classList.contains(m);
  }
  function l(v) {
    const { selector: m = ":root", darkClass: C = "dark" } = v;
    if (Hm() && m && C) {
      const p = document.querySelector(m);
      p && (r = new MutationObserver(u), r.observe(p, {
        attributes: !0,
        attributeFilter: ["class"]
      }), t.value = p.classList.contains(C));
    }
  }
  function s() {
    c();
    const v = typeof e.value;
    v === "string" && e.value.toLowerCase() === "system" ? o() : v === "object" ? l(e.value) : t.value = !!e.value;
  }
  const d = ne(() => e.value, () => s(), {
    immediate: !0
  });
  function c() {
    n && (n.removeEventListener("change", i), n = void 0), r && (r.disconnect(), r = void 0);
  }
  function f() {
    c(), d();
  }
  return qa(() => f()), {
    isDark: t,
    displayMode: a,
    cleanup: f
  };
}
const L6 = ["base", "start", "end", "startEnd"], B6 = [
  "class",
  "wrapperClass",
  "contentClass",
  "style",
  "contentStyle",
  "color",
  "fillMode"
], R6 = { base: {}, start: {}, end: {} };
function Id(e, t, a = R6) {
  let n = e, r = {};
  t === !0 || Pa(t) ? (n = Pa(t) ? t : n, r = { ...a }) : ln(t) && (np(t, L6) ? r = { ...t } : r = {
    base: { ...t },
    start: { ...t },
    end: { ...t }
  });
  const i = Pi(
    r,
    { start: r.startEnd, end: r.startEnd },
    a
  );
  return Object.entries(i).forEach(([o, u]) => {
    let l = n;
    u === !0 || Pa(u) ? (l = Pa(u) ? u : l, i[o] = { color: l }) : ln(u) && (np(u, B6) ? i[o] = { ...u } : i[o] = {}), Pi(i[o], { color: l });
  }), i;
}
class F6 {
  constructor() {
    Oe(this, "type", "highlight");
  }
  normalizeConfig(t, a) {
    return Id(t, a, {
      base: { fillMode: "light" },
      start: { fillMode: "solid" },
      end: { fillMode: "solid" }
    });
  }
  prepareRender(t) {
    t.highlights = [], t.content || (t.content = []);
  }
  render({ data: t, onStart: a, onEnd: n }, r) {
    const { key: i, highlight: o } = t;
    if (!o)
      return;
    const { highlights: u } = r, { base: l, start: s, end: d } = o;
    a && n ? u.push({
      ...s,
      key: i,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${s.color}`,
      class: [`vc-highlight vc-highlight-bg-${s.fillMode}`, s.class],
      contentClass: [
        `vc-attr vc-highlight-content-${s.fillMode} vc-${s.color}`,
        s.contentClass
      ]
    }) : a ? (u.push({
      ...l,
      key: `${i}-base`,
      wrapperClass: `vc-day-layer vc-day-box-right-center vc-attr vc-${l.color}`,
      class: [
        `vc-highlight vc-highlight-base-start vc-highlight-bg-${l.fillMode}`,
        l.class
      ]
    }), u.push({
      ...s,
      key: i,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${s.color}`,
      class: [`vc-highlight vc-highlight-bg-${s.fillMode}`, s.class],
      contentClass: [
        `vc-attr vc-highlight-content-${s.fillMode} vc-${s.color}`,
        s.contentClass
      ]
    })) : n ? (u.push({
      ...l,
      key: `${i}-base`,
      wrapperClass: `vc-day-layer vc-day-box-left-center vc-attr vc-${l.color}`,
      class: [
        `vc-highlight vc-highlight-base-end vc-highlight-bg-${l.fillMode}`,
        l.class
      ]
    }), u.push({
      ...d,
      key: i,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${d.color}`,
      class: [`vc-highlight vc-highlight-bg-${d.fillMode}`, d.class],
      contentClass: [
        `vc-attr vc-highlight-content-${d.fillMode} vc-${d.color}`,
        d.contentClass
      ]
    })) : u.push({
      ...l,
      key: `${i}-middle`,
      wrapperClass: `vc-day-layer vc-day-box-center-center vc-attr vc-${l.color}`,
      class: [
        `vc-highlight vc-highlight-base-middle vc-highlight-bg-${l.fillMode}`,
        l.class
      ],
      contentClass: [
        `vc-attr vc-highlight-content-${l.fillMode} vc-${l.color}`,
        l.contentClass
      ]
    });
  }
}
class Ed {
  constructor(t, a) {
    Oe(this, "type", ""), Oe(this, "collectionType", ""), this.type = t, this.collectionType = a;
  }
  normalizeConfig(t, a) {
    return Id(t, a);
  }
  prepareRender(t) {
    t[this.collectionType] = [];
  }
  render({ data: t, onStart: a, onEnd: n }, r) {
    const { key: i } = t, o = t[this.type];
    if (!i || !o)
      return;
    const u = r[this.collectionType], { base: l, start: s, end: d } = o;
    a ? u.push({
      ...s,
      key: i,
      class: [
        `vc-${this.type} vc-${this.type}-start vc-${s.color} vc-attr`,
        s.class
      ]
    }) : n ? u.push({
      ...d,
      key: i,
      class: [
        `vc-${this.type} vc-${this.type}-end vc-${d.color} vc-attr`,
        d.class
      ]
    }) : u.push({
      ...l,
      key: i,
      class: [
        `vc-${this.type} vc-${this.type}-base vc-${l.color} vc-attr`,
        l.class
      ]
    });
  }
}
class z6 extends Ed {
  constructor() {
    super("content", "content");
  }
  normalizeConfig(t, a) {
    return Id("base", a);
  }
}
class Y6 extends Ed {
  constructor() {
    super("dot", "dots");
  }
}
class H6 extends Ed {
  constructor() {
    super("bar", "bars");
  }
}
class q6 {
  constructor(t) {
    Oe(this, "color"), Oe(this, "renderers", [
      new z6(),
      new F6(),
      new Y6(),
      new H6()
    ]), this.color = t;
  }
  normalizeGlyphs(t) {
    this.renderers.forEach((a) => {
      const n = a.type;
      t[n] != null && (t[n] = a.normalizeConfig(this.color, t[n]));
    });
  }
  prepareRender(t = {}) {
    return this.renderers.forEach((a) => {
      a.prepareRender(t);
    }), t;
  }
  render(t, a) {
    this.renderers.forEach((n) => {
      n.render(t, a);
    });
  }
}
const qm = Symbol("__vc_base_context__"), Wm = {
  color: {
    type: String,
    default: () => Pn("color")
  },
  isDark: {
    type: [Boolean, String, Object],
    default: () => Pn("isDark")
  },
  firstDayOfWeek: Number,
  masks: Object,
  locale: [String, Object],
  timezone: String,
  minDate: null,
  maxDate: null,
  disabledDates: null
};
function _m(e) {
  const t = b(() => e.color ?? ""), a = b(() => e.isDark ?? !1), { displayMode: n } = N6(a), r = b(() => new q6(t.value)), i = b(() => {
    if (e.locale instanceof Ts)
      return e.locale;
    const f = ln(e.locale) ? e.locale : {
      id: e.locale,
      firstDayOfWeek: e.firstDayOfWeek,
      masks: e.masks
    };
    return new Ts(f, e.timezone);
  }), o = b(() => i.value.masks), u = b(() => e.minDate), l = b(() => e.maxDate), s = b(() => {
    const f = e.disabledDates ? [...e.disabledDates] : [];
    return u.value != null && f.push({
      start: null,
      end: Wt(i.value.toDate(u.value), -1)
    }), l.value != null && f.push({
      start: Wt(i.value.toDate(l.value), 1),
      end: null
    }), i.value.ranges(f);
  }), d = b(() => new Rm(
    {
      key: "disabled",
      dates: s.value,
      order: 100
    },
    r.value,
    i.value
  )), c = {
    color: t,
    isDark: a,
    displayMode: n,
    theme: r,
    locale: i,
    masks: o,
    minDate: u,
    maxDate: l,
    disabledDates: s,
    disabledAttribute: d
  };
  return Bi(qm, c), c;
}
function W6(e) {
  return Li(qm, () => _m(e), !0);
}
function Um(e) {
  return `__vc_slot_${e}__`;
}
function Vm(e, t = {}) {
  Object.keys(e).forEach((a) => {
    Bi(Um(t[a] ?? a), e[a]);
  });
}
function Km(e) {
  return Li(Um(e), null);
}
const _6 = {
  ...Wm,
  view: {
    type: String,
    default: "monthly",
    validator(e) {
      return ["daily", "weekly", "monthly"].includes(e);
    }
  },
  rows: {
    type: Number,
    default: 1
  },
  columns: {
    type: Number,
    default: 1
  },
  step: Number,
  titlePosition: {
    type: String,
    default: () => Pn("titlePosition")
  },
  navVisibility: {
    type: String,
    default: () => Pn("navVisibility")
  },
  showWeeknumbers: [Boolean, String],
  showIsoWeeknumbers: [Boolean, String],
  expanded: Boolean,
  borderless: Boolean,
  transparent: Boolean,
  initialPage: Object,
  initialPagePosition: { type: Number, default: 1 },
  minPage: Object,
  maxPage: Object,
  transition: String,
  attributes: Array,
  trimWeeks: Boolean,
  disablePageSwipe: Boolean
}, U6 = [
  "dayclick",
  "daymouseenter",
  "daymouseleave",
  "dayfocusin",
  "dayfocusout",
  "daykeydown",
  "weeknumberclick",
  "transition-start",
  "transition-end",
  "did-move",
  "update:view",
  "update:pages"
], jm = Symbol("__vc_calendar_context__");
function V6(e, { slots: t, emit: a }) {
  const n = L(null), r = L(null), i = L((/* @__PURE__ */ new Date()).getDate()), o = L(!1), u = L(Symbol()), l = L(Symbol()), s = L(e.view), d = L([]), c = L("");
  let f = null, v = null;
  Vm(t);
  const {
    theme: m,
    color: C,
    displayMode: p,
    locale: h,
    masks: g,
    minDate: w,
    maxDate: $,
    disabledAttribute: T,
    disabledDates: O
  } = W6(e), M = b(() => e.rows * e.columns), F = b(() => e.step || M.value), q = b(() => gm(d.value) ?? null), x = b(() => Ar(d.value) ?? null), Y = b(
    () => e.minPage || (w.value ? ce(w.value) : null)
  ), R = b(
    () => e.maxPage || ($.value ? ce($.value) : null)
  ), k = b(() => e.navVisibility), P = b(() => !!e.showWeeknumbers), D = b(() => !!e.showIsoWeeknumbers), B = b(() => s.value === "monthly"), J = b(() => s.value === "weekly"), _ = b(() => s.value === "daily"), te = () => {
    o.value = !0, a("transition-start");
  }, G = () => {
    o.value = !1, a("transition-end"), f && (f.resolve(!0), f = null);
  }, pe = (X, I, Q = s.value) => $m(X, I, Q, h.value), ce = (X) => km(X, s.value, h.value), $e = (X) => {
    !T.value || !Xe.value || (X.isDisabled = Xe.value.cellExists(
      T.value.key,
      X.dayIndex
    ));
  }, ge = (X) => {
    X.isFocusable = X.inMonth && X.day === i.value;
  }, Se = (X, I) => {
    for (const Q of X)
      for (const ve of Q.days)
        if (I(ve) === !1)
          return;
  }, Ue = b(
    () => d.value.reduce((X, I) => (X.push(...I.viewDays), X), [])
  ), Ne = b(() => {
    const X = [];
    return (e.attributes || []).forEach((I, Q) => {
      !I || !I.dates || X.push(
        new Rm(
          {
            ...I,
            order: I.order || 0
          },
          m.value,
          h.value
        )
      );
    }), T.value && X.push(T.value), X;
  }), He = b(() => tn(Ne.value)), Xe = b(() => {
    const X = new A9();
    return Ne.value.forEach((I) => {
      I.ranges.forEach((Q) => {
        X.render(I, Q, Ue.value);
      });
    }), X;
  }), ot = b(() => Ue.value.reduce((X, I) => (X[I.dayIndex] = { day: I, cells: [] }, X[I.dayIndex].cells.push(...Xe.value.getCells(I)), X), {})), Ge = (X, I) => {
    const Q = e.showWeeknumbers || e.showIsoWeeknumbers;
    return Q == null ? "" : Z4(Q) ? Q ? "left" : "" : Q.startsWith("right") ? I > 1 ? "right" : Q : X > 1 ? "left" : Q;
  }, Je = () => {
    var X, I;
    if (!He.value)
      return null;
    const Q = Ne.value.find((Ze) => Ze.pinPage) || Ne.value[0];
    if (!Q || !Q.hasRanges)
      return null;
    const [ve] = Q.ranges, ke = ((X = ve.start) == null ? void 0 : X.date) || ((I = ve.end) == null ? void 0 : I.date);
    return ke ? ce(ke) : null;
  }, et = () => {
    if (Na(q.value))
      return q.value;
    const X = Je();
    return Na(X) ? X : ce(/* @__PURE__ */ new Date());
  }, ie = (X, I = {}) => {
    const { view: Q = s.value, position: ve = 1, force: ke } = I, Ze = ve > 0 ? 1 - ve : -(M.value + ve);
    let Ct = pe(X, Ze, Q), Pt = pe(Ct, M.value - 1, Q);
    return ke || (mu(Ct, Y.value) ? Ct = Y.value : Ss(Pt, R.value) && (Ct = pe(R.value, 1 - M.value)), Pt = pe(Ct, M.value - 1)), { fromPage: Ct, toPage: Pt };
  }, le = (X, I, Q = "") => {
    if (Q === "none" || Q === "fade")
      return Q;
    if ((X == null ? void 0 : X.view) !== (I == null ? void 0 : I.view))
      return "fade";
    const ve = Ss(I, X), ke = mu(I, X);
    return !ve && !ke ? "fade" : Q === "slide-v" ? ke ? "slide-down" : "slide-up" : ke ? "slide-right" : "slide-left";
  }, fe = (X = {}) => new Promise((I, Q) => {
    const { position: ve = 1, force: ke = !1, transition: Ze } = X, Ct = Na(X.page) ? X.page : et(), { fromPage: Pt } = ie(Ct, {
      position: ve,
      force: ke
    }), ba = [];
    for (let ua = 0; ua < M.value; ua++) {
      const da = pe(Pt, ua), kt = ua + 1, oe = Math.ceil(kt / e.columns), we = e.rows - oe + 1, E = kt % e.columns || e.columns, V = e.columns - E + 1, K = Ge(E, V);
      ba.push(
        h.value.getPage({
          ...da,
          view: s.value,
          titlePosition: e.titlePosition,
          trimWeeks: e.trimWeeks,
          position: kt,
          row: oe,
          rowFromEnd: we,
          column: E,
          columnFromEnd: V,
          showWeeknumbers: P.value,
          showIsoWeeknumbers: D.value,
          weeknumberPosition: K
        })
      );
    }
    c.value = le(
      d.value[0],
      ba[0],
      Ze
    ), d.value = ba, c.value && c.value !== "none" ? f = {
      resolve: I,
      reject: Q
    } : I(!0);
  }), z = (X) => {
    const I = q.value ?? ce(/* @__PURE__ */ new Date());
    return pe(I, X);
  }, Ce = (X, I = {}) => {
    const Q = Na(X) ? X : ce(X);
    return Object.assign(
      I,
      ie(Q, {
        ...I,
        force: !0
      })
    ), S9(
      I.fromPage,
      I.toPage,
      s.value,
      h.value
    ).map((ke) => k9(ke, Y.value, R.value)).some((ke) => ke);
  }, xe = (X, I = {}) => Ce(z(X), I), De = b(() => xe(-F.value)), qe = b(() => xe(F.value)), ct = async (X, I = {}) => !I.force && !Ce(X, I) ? !1 : (I.fromPage && !$9(I.fromPage, q.value) && (Ni({ id: u.value, hideDelay: 0 }), I.view && (O6("view", 10), s.value = I.view), await fe({
    ...I,
    page: I.fromPage,
    position: 1,
    force: !0
  }), a("did-move", d.value)), !0), dt = (X, I = {}) => ct(z(X), I), Qe = () => dt(-F.value), pt = () => dt(F.value), It = (X) => {
    const I = B.value ? ".in-month" : "", Q = `.id-${h.value.getDayId(X)}${I}`, ve = `${Q}.vc-focusable, ${Q} .vc-focusable`, ke = n.value;
    if (ke) {
      const Ze = ke.querySelector(ve);
      if (Ze)
        return Ze.focus(), !0;
    }
    return !1;
  }, Ot = async (X, I = {}) => It(X) ? !0 : (await ct(X, I), It(X)), Gt = (X, I) => {
    i.value = X.day, a("dayclick", X, I);
  }, ta = (X, I) => {
    a("daymouseenter", X, I);
  }, xt = (X, I) => {
    a("daymouseleave", X, I);
  }, Mt = (X, I) => {
    i.value = X.day, r.value = X, X.isFocused = !0, a("dayfocusin", X, I);
  }, re = (X, I) => {
    r.value = null, X.isFocused = !1, a("dayfocusout", X, I);
  }, ze = (X, I) => {
    a("daykeydown", X, I);
    const Q = X.noonDate;
    let ve = null;
    switch (I.key) {
      case "ArrowLeft": {
        ve = Wt(Q, -1);
        break;
      }
      case "ArrowRight": {
        ve = Wt(Q, 1);
        break;
      }
      case "ArrowUp": {
        ve = Wt(Q, -7);
        break;
      }
      case "ArrowDown": {
        ve = Wt(Q, 7);
        break;
      }
      case "Home": {
        ve = Wt(Q, -X.weekdayPosition + 1);
        break;
      }
      case "End": {
        ve = Wt(Q, X.weekdayPositionFromEnd);
        break;
      }
      case "PageUp": {
        I.altKey ? ve = vp(Q, -1) : ve = $s(Q, -1);
        break;
      }
      case "PageDown": {
        I.altKey ? ve = vp(Q, 1) : ve = $s(Q, 1);
        break;
      }
    }
    ve && (I.preventDefault(), Ot(ve).catch());
  }, U = (X) => {
    const I = r.value;
    I != null && ze(I, X);
  }, de = (X, I) => {
    a("weeknumberclick", X, I);
  };
  fe({
    page: e.initialPage,
    position: e.initialPagePosition
  }), rt(() => {
    !e.disablePageSwipe && n.value && (v = M6(
      n.value,
      ({ toLeft: X = !1, toRight: I = !1 }) => {
        X ? pt() : I && Qe();
      },
      Pn("touch")
    ));
  }), qa(() => {
    d.value = [], v && v();
  }), ne(
    () => h.value,
    () => {
      fe();
    }
  ), ne(
    () => M.value,
    () => fe()
  ), ne(
    () => e.view,
    () => s.value = e.view
  ), ne(
    () => s.value,
    () => {
      x6("view", () => {
        fe();
      }), a("update:view", s.value);
    }
  ), ne(
    () => i.value,
    () => {
      Se(d.value, (X) => ge(X));
    }
  ), Mu(() => {
    a("update:pages", d.value), Se(d.value, (X) => {
      $e(X), ge(X);
    });
  });
  const Ie = {
    emit: a,
    containerRef: n,
    focusedDay: r,
    inTransition: o,
    navPopoverId: u,
    dayPopoverId: l,
    view: s,
    pages: d,
    transitionName: c,
    theme: m,
    color: C,
    displayMode: p,
    locale: h,
    masks: g,
    attributes: Ne,
    disabledAttribute: T,
    disabledDates: O,
    attributeContext: Xe,
    days: Ue,
    dayCells: ot,
    count: M,
    step: F,
    firstPage: q,
    lastPage: x,
    canMovePrev: De,
    canMoveNext: qe,
    minPage: Y,
    maxPage: R,
    isMonthly: B,
    isWeekly: J,
    isDaily: _,
    navVisibility: k,
    showWeeknumbers: P,
    showIsoWeeknumbers: D,
    getDateAddress: ce,
    canMove: Ce,
    canMoveBy: xe,
    move: ct,
    moveBy: dt,
    movePrev: Qe,
    moveNext: pt,
    onTransitionBeforeEnter: te,
    onTransitionAfterEnter: G,
    tryFocusDate: It,
    focusDate: Ot,
    onKeydown: U,
    onDayKeydown: ze,
    onDayClick: Gt,
    onDayMouseenter: ta,
    onDayMouseleave: xt,
    onDayFocusin: Mt,
    onDayFocusout: re,
    onWeeknumberClick: de
  };
  return Bi(jm, Ie), Ie;
}
function fr() {
  const e = Li(jm);
  if (e)
    return e;
  throw new Error(
    "Calendar context missing. Please verify this component is nested within a valid context provider."
  );
}
const K6 = se({
  inheritAttrs: !1,
  emits: ["before-show", "after-show", "before-hide", "after-hide"],
  props: {
    id: { type: [Number, String, Symbol], required: !0 },
    showDelay: { type: Number, default: 0 },
    hideDelay: { type: Number, default: 110 },
    boundarySelector: { type: String }
  },
  setup(e, { emit: t }) {
    let a;
    const n = L();
    let r = null, i = null;
    const o = Ur({
      isVisible: !1,
      target: null,
      data: null,
      transition: "slide-fade",
      placement: "bottom",
      direction: "",
      positionFixed: !1,
      modifiers: [],
      isInteractive: !0,
      visibility: "click",
      isHovered: !1,
      isFocused: !1,
      autoHide: !1,
      force: !1
    });
    function u(G) {
      G && (o.direction = G.split("-")[0]);
    }
    function l({ placement: G, options: pe }) {
      u(G || (pe == null ? void 0 : pe.placement));
    }
    const s = b(() => ({
      placement: o.placement,
      strategy: o.positionFixed ? "fixed" : "absolute",
      boundary: "",
      modifiers: [
        {
          name: "onUpdate",
          enabled: !0,
          phase: "afterWrite",
          fn: l
        },
        ...o.modifiers || []
      ],
      onFirstUpdate: l
    })), d = b(() => {
      const G = o.direction === "left" || o.direction === "right";
      let pe = "";
      if (o.placement) {
        const ce = o.placement.split("-");
        ce.length > 1 && (pe = ce[1]);
      }
      return ["start", "top", "left"].includes(pe) ? G ? "top" : "left" : ["end", "bottom", "right"].includes(pe) ? G ? "bottom" : "right" : G ? "middle" : "center";
    });
    function c() {
      i && (i.destroy(), i = null);
    }
    function f() {
      gt(() => {
        const G = bs(o.target);
        !G || !n.value || (i && i.state.elements.reference !== G && c(), i ? i.update() : i = qD(
          G,
          n.value,
          s.value
        ));
      });
    }
    function v(G) {
      Object.assign(o, ym(G, "force"));
    }
    function m(G, pe) {
      clearTimeout(a), G > 0 ? a = setTimeout(pe, G) : pe();
    }
    function C(G) {
      return !G || !i ? !1 : bs(G) === i.state.elements.reference;
    }
    async function p(G = {}) {
      o.force || (G.force && (o.force = !0), m(G.showDelay ?? e.showDelay, () => {
        o.isVisible && (o.force = !1), v({
          ...G,
          isVisible: !0
        }), f();
      }));
    }
    function h(G = {}) {
      i && (G.target && !C(G.target) || o.force || (G.force && (o.force = !0), m(G.hideDelay ?? e.hideDelay, () => {
        o.isVisible || (o.force = !1), o.isVisible = !1;
      })));
    }
    function g(G = {}) {
      G.target != null && (o.isVisible && C(G.target) ? h(G) : p(G));
    }
    function w(G) {
      if (!i)
        return;
      const pe = i.state.elements.reference;
      if (!n.value || !pe)
        return;
      const ce = G.target;
      Uo(n.value, ce) || Uo(pe, ce) || h({ force: !0 });
    }
    function $(G) {
      (G.key === "Esc" || G.key === "Escape") && h();
    }
    function T({ detail: G }) {
      !G.id || G.id !== e.id || p(G);
    }
    function O({ detail: G }) {
      !G.id || G.id !== e.id || h(G);
    }
    function M({ detail: G }) {
      !G.id || G.id !== e.id || g(G);
    }
    function F() {
      $n(document, "keydown", $), $n(document, "click", w), $n(document, "show-popover", T), $n(document, "hide-popover", O), $n(document, "toggle-popover", M);
    }
    function q() {
      kn(document, "keydown", $), kn(document, "click", w), kn(document, "show-popover", T), kn(document, "hide-popover", O), kn(document, "toggle-popover", M);
    }
    function x(G) {
      t("before-show", G);
    }
    function Y(G) {
      o.force = !1, t("after-show", G);
    }
    function R(G) {
      t("before-hide", G);
    }
    function k(G) {
      o.force = !1, c(), t("after-hide", G);
    }
    function P(G) {
      G.stopPropagation();
    }
    function D() {
      o.isHovered = !0, o.isInteractive && ["hover", "hover-focus"].includes(o.visibility) && p();
    }
    function B() {
      if (o.isHovered = !1, !i)
        return;
      const G = i.state.elements.reference;
      o.autoHide && !o.isFocused && (!G || G !== document.activeElement) && ["hover", "hover-focus"].includes(o.visibility) && h();
    }
    function J() {
      o.isFocused = !0, o.isInteractive && ["focus", "hover-focus"].includes(o.visibility) && p();
    }
    function _(G) {
      ["focus", "hover-focus"].includes(o.visibility) && (!G.relatedTarget || !Uo(n.value, G.relatedTarget)) && (o.isFocused = !1, !o.isHovered && o.autoHide && h());
    }
    function te() {
      r != null && (r.disconnect(), r = null);
    }
    return ne(
      () => n.value,
      (G) => {
        te(), G && (r = new ResizeObserver(() => {
          i && i.update();
        }), r.observe(G));
      }
    ), ne(() => o.placement, u, {
      immediate: !0
    }), rt(() => {
      F();
    }), qa(() => {
      c(), te(), q();
    }), {
      ...Xp(o),
      popoverRef: n,
      alignment: d,
      hide: h,
      setupPopper: f,
      beforeEnter: x,
      afterEnter: Y,
      beforeLeave: R,
      afterLeave: k,
      onClick: P,
      onMouseOver: D,
      onMouseLeave: B,
      onFocusIn: J,
      onFocusOut: _
    };
  }
}), Bn = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [n, r] of t)
    a[n] = r;
  return a;
};
function j6(e, t, a, n, r, i) {
  return y(), S("div", {
    class: ue(["vc-popover-content-wrapper", { "is-interactive": e.isInteractive }]),
    ref: "popoverRef",
    onClick: t[0] || (t[0] = (...o) => e.onClick && e.onClick(...o)),
    onMouseover: t[1] || (t[1] = (...o) => e.onMouseOver && e.onMouseOver(...o)),
    onMouseleave: t[2] || (t[2] = (...o) => e.onMouseLeave && e.onMouseLeave(...o)),
    onFocusin: t[3] || (t[3] = (...o) => e.onFocusIn && e.onFocusIn(...o)),
    onFocusout: t[4] || (t[4] = (...o) => e.onFocusOut && e.onFocusOut(...o))
  }, [
    Z(Zt, {
      name: `vc-${e.transition}`,
      appear: "",
      onBeforeEnter: e.beforeEnter,
      onAfterEnter: e.afterEnter,
      onBeforeLeave: e.beforeLeave,
      onAfterLeave: e.afterLeave
    }, {
      default: N(() => [
        e.isVisible ? (y(), S("div", Fe({
          key: 0,
          tabindex: "-1",
          class: `vc-popover-content direction-${e.direction}`
        }, e.$attrs), [
          j(e.$slots, "default", {
            direction: e.direction,
            alignment: e.alignment,
            data: e.data,
            hide: e.hide
          }, () => [
            be(ae(e.data), 1)
          ]),
          H("span", {
            class: ue([
              "vc-popover-caret",
              `direction-${e.direction}`,
              `align-${e.alignment}`
            ])
          }, null, 2)
        ], 16)) : W("", !0)
      ]),
      _: 3
    }, 8, ["name", "onBeforeEnter", "onAfterEnter", "onBeforeLeave", "onAfterLeave"])
  ], 34);
}
const Md = /* @__PURE__ */ Bn(K6, [["render", j6]]), G6 = { class: "vc-day-popover-row" }, Q6 = {
  key: 0,
  class: "vc-day-popover-row-indicator"
}, Z6 = { class: "vc-day-popover-row-label" }, X6 = /* @__PURE__ */ se({
  __name: "PopoverRow",
  props: {
    attribute: null
  },
  setup(e) {
    const t = e, a = b(() => {
      const { content: n, highlight: r, dot: i, bar: o, popover: u } = t.attribute;
      return u && u.hideIndicator ? null : n ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${n.base.color}`
      } : r ? {
        class: `vc-highlight-bg-solid vc-day-popover-row-highlight vc-attr vc-${r.base.color}`
      } : i ? {
        class: `vc-dot vc-attr vc-${i.base.color}`
      } : o ? {
        class: `vc-bar vc-day-popover-row-bar vc-attr vc-${o.base.color}`
      } : null;
    });
    return (n, r) => (y(), S("div", G6, [
      A(a) ? (y(), S("div", Q6, [
        H("span", {
          class: ue(A(a).class)
        }, null, 2)
      ])) : W("", !0),
      H("div", Z6, [
        j(n.$slots, "default", {}, () => [
          be(ae(e.attribute.popover ? e.attribute.popover.label : "No content provided"), 1)
        ])
      ])
    ]));
  }
}), J6 = {
  inheritAttrs: !1
}, fa = /* @__PURE__ */ se({
  ...J6,
  __name: "CalendarSlot",
  props: {
    name: null
  },
  setup(e) {
    const a = Km(e.name);
    return (n, r) => A(a) ? (y(), ee(Ye(A(a)), ra(Fe({ key: 0 }, n.$attrs)), null, 16)) : j(n.$slots, "default", { key: 1 });
  }
}), eL = { class: "vc-day-popover-container" }, tL = {
  key: 0,
  class: "vc-day-popover-header"
}, aL = /* @__PURE__ */ se({
  __name: "CalendarDayPopover",
  setup(e) {
    const { dayPopoverId: t, displayMode: a, color: n, masks: r, locale: i } = fr();
    function o(l, s) {
      return i.value.formatDate(l, s);
    }
    function u(l) {
      return i.value.formatDate(l.date, r.value.dayPopover);
    }
    return (l, s) => (y(), ee(Md, {
      id: A(t),
      class: ue([`vc-${A(n)}`, `vc-${A(a)}`])
    }, {
      default: N(({ data: { day: d, attributes: c }, hide: f }) => [
        Z(fa, {
          name: "day-popover",
          day: d,
          "day-title": u(d),
          attributes: c,
          format: o,
          masks: A(r),
          hide: f
        }, {
          default: N(() => [
            H("div", eL, [
              A(r).dayPopover ? (y(), S("div", tL, ae(u(d)), 1)) : W("", !0),
              (y(!0), S(Ae, null, Le(c, (v) => (y(), ee(X6, {
                key: v.key,
                attribute: v
              }, null, 8, ["attribute"]))), 128))
            ])
          ]),
          _: 2
        }, 1032, ["day", "day-title", "attributes", "masks", "hide"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), nL = {}, rL = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, iL = /* @__PURE__ */ H("polyline", { points: "9 18 15 12 9 6" }, null, -1), oL = [
  iL
];
function sL(e, t) {
  return y(), S("svg", rL, oL);
}
const lL = /* @__PURE__ */ Bn(nL, [["render", sL]]), uL = {}, dL = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, cL = /* @__PURE__ */ H("polyline", { points: "15 18 9 12 15 6" }, null, -1), fL = [
  cL
];
function vL(e, t) {
  return y(), S("svg", dL, fL);
}
const pL = /* @__PURE__ */ Bn(uL, [["render", vL]]), hL = {}, gL = {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
}, mL = /* @__PURE__ */ H("polyline", { points: "6 9 12 15 18 9" }, null, -1), yL = [
  mL
];
function bL(e, t) {
  return y(), S("svg", gL, yL);
}
const wL = /* @__PURE__ */ Bn(hL, [["render", bL]]), CL = {}, kL = {
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, $L = /* @__PURE__ */ H("path", { d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" }, null, -1), SL = [
  $L
];
function TL(e, t) {
  return y(), S("svg", kL, SL);
}
const DL = /* @__PURE__ */ Bn(CL, [["render", TL]]), AL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconChevronDown: wL,
  IconChevronLeft: pL,
  IconChevronRight: lL,
  IconClock: DL
}, Symbol.toStringTag, { value: "Module" })), Wr = /* @__PURE__ */ se({
  __name: "BaseIcon",
  props: {
    name: { type: String, required: !0 },
    width: { type: String },
    height: { type: String },
    size: { type: String, default: "26" },
    viewBox: { type: String }
  },
  setup(e) {
    const t = e, a = b(() => t.width || t.size), n = b(() => t.height || t.size), r = b(() => AL[`Icon${t.name}`]);
    return (i, o) => (y(), ee(Ye(A(r)), {
      width: A(a),
      height: A(n),
      class: "vc-base-icon"
    }, null, 8, ["width", "height"]));
  }
}), IL = ["disabled"], EL = {
  key: 1,
  class: "vc-title-wrapper"
}, ML = {
  type: "button",
  class: "vc-title"
}, OL = ["disabled"], Gm = /* @__PURE__ */ se({
  __name: "CalendarHeader",
  props: {
    page: null,
    layout: null,
    isLg: { type: Boolean },
    isXl: { type: Boolean },
    is2xl: { type: Boolean },
    hideTitle: { type: Boolean },
    hideArrows: { type: Boolean }
  },
  setup(e) {
    const t = e, {
      navPopoverId: a,
      navVisibility: n,
      canMovePrev: r,
      movePrev: i,
      canMoveNext: o,
      moveNext: u
    } = fr(), l = b(() => {
      switch (t.page.titlePosition) {
        case "left":
          return "bottom-start";
        case "right":
          return "bottom-end";
        default:
          return "bottom";
      }
    }), s = b(() => {
      const { page: C } = t;
      return {
        id: a.value,
        visibility: n.value,
        placement: l.value,
        modifiers: [{ name: "flip", options: { fallbackPlacements: ["bottom"] } }],
        data: { page: C },
        isInteractive: !0
      };
    }), d = b(() => t.page.titlePosition.includes("left")), c = b(() => t.page.titlePosition.includes("right")), f = b(() => t.layout ? t.layout : d.value ? "tu-pn" : c.value ? "pn-tu" : "p-tu-n;"), v = b(() => ({
      prev: f.value.includes("p") && !t.hideArrows,
      title: f.value.includes("t") && !t.hideTitle,
      next: f.value.includes("n") && !t.hideArrows
    })), m = b(() => ({ gridTemplateColumns: f.value.split("").map((p) => {
      switch (p) {
        case "p":
          return "[prev] auto";
        case "n":
          return "[next] auto";
        case "t":
          return "[title] auto";
        case "-":
          return "1fr";
        default:
          return "";
      }
    }).join(" ") }));
    return (C, p) => (y(), S("div", {
      class: ue(["vc-header", { "is-lg": e.isLg, "is-xl": e.isXl, "is-2xl": e.is2xl }]),
      style: Ee(A(m))
    }, [
      A(v).prev ? (y(), S("button", {
        key: 0,
        type: "button",
        class: "vc-arrow vc-prev vc-focus",
        disabled: !A(r),
        onClick: p[0] || (p[0] = //@ts-ignore
        (...h) => A(i) && A(i)(...h)),
        onKeydown: p[1] || (p[1] = lt(
          //@ts-ignore
          (...h) => A(i) && A(i)(...h),
          ["space", "enter"]
        ))
      }, [
        Z(fa, {
          name: "header-prev-button",
          disabled: !A(r)
        }, {
          default: N(() => [
            Z(Wr, {
              name: "ChevronLeft",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, IL)) : W("", !0),
      A(v).title ? (y(), S("div", EL, [
        Z(fa, { name: "header-title-wrapper" }, {
          default: N(() => [
            $a((y(), S("button", ML, [
              Z(fa, {
                name: "header-title",
                title: e.page.title
              }, {
                default: N(() => [
                  H("span", null, ae(e.page.title), 1)
                ]),
                _: 1
              }, 8, ["title"])
            ])), [
              [A(Ym), A(s)]
            ])
          ]),
          _: 1
        })
      ])) : W("", !0),
      A(v).next ? (y(), S("button", {
        key: 2,
        type: "button",
        class: "vc-arrow vc-next vc-focus",
        disabled: !A(o),
        onClick: p[2] || (p[2] = //@ts-ignore
        (...h) => A(u) && A(u)(...h)),
        onKeydown: p[3] || (p[3] = lt(
          //@ts-ignore
          (...h) => A(u) && A(u)(...h),
          ["space", "enter"]
        ))
      }, [
        Z(fa, {
          name: "header-next-button",
          disabled: !A(o)
        }, {
          default: N(() => [
            Z(Wr, {
              name: "ChevronRight",
              size: "24"
            })
          ]),
          _: 1
        }, 8, ["disabled"])
      ], 40, OL)) : W("", !0)
    ], 6));
  }
}), Qm = Symbol("__vc_page_context__");
function xL(e) {
  const { locale: t, getDateAddress: a, canMove: n } = fr();
  function r(u, l) {
    const { month: s, year: d } = a(/* @__PURE__ */ new Date());
    return Bm().map((c, f) => {
      const v = f + 1;
      return {
        month: v,
        year: u,
        id: C9(v, u),
        label: t.value.formatDate(c, l),
        ariaLabel: t.value.formatDate(c, "MMMM"),
        isActive: v === e.value.month && u === e.value.year,
        isCurrent: v === s && u === d,
        isDisabled: !n(
          { month: v, year: u },
          { position: e.value.position }
        )
      };
    });
  }
  function i(u, l) {
    const { year: s } = a(/* @__PURE__ */ new Date()), { position: d } = e.value, c = [];
    for (let f = u; f <= l; f += 1) {
      const v = [...Array(12).keys()].some(
        (m) => n({ month: m + 1, year: f }, { position: d })
      );
      c.push({
        year: f,
        id: f.toString(),
        label: f.toString(),
        ariaLabel: f.toString(),
        isActive: f === e.value.year,
        isCurrent: f === s,
        isDisabled: !v
      });
    }
    return c;
  }
  const o = { page: e, getMonthItems: r, getYearItems: i };
  return Bi(Qm, o), o;
}
function Zm() {
  const e = Li(Qm);
  if (e)
    return e;
  throw new Error(
    "Page context missing. Please verify this component is nested within a valid context provider."
  );
}
const PL = { class: "vc-nav-header" }, NL = ["disabled"], LL = ["disabled"], BL = { class: "vc-nav-items" }, RL = ["data-id", "aria-label", "disabled", "onClick", "onKeydown"], FL = /* @__PURE__ */ se({
  __name: "CalendarNav",
  setup(e) {
    const { masks: t, move: a } = fr(), { page: n, getMonthItems: r, getYearItems: i } = Zm(), o = L(!0), u = 12, l = L(n.value.year), s = L(f(n.value.year)), d = L(null);
    function c() {
      setTimeout(() => {
        if (d.value == null)
          return;
        const ce = d.value.querySelector(
          ".vc-nav-item:not(:disabled)"
        );
        ce && ce.focus();
      }, 10);
    }
    function f(ce) {
      return Math.floor(ce / u);
    }
    function v() {
      o.value = !o.value;
    }
    function m(ce) {
      return ce * u;
    }
    function C(ce) {
      return u * (ce + 1) - 1;
    }
    function p() {
      J.value && (o.value && g(), $());
    }
    function h() {
      _.value && (o.value && w(), T());
    }
    function g() {
      l.value--;
    }
    function w() {
      l.value++;
    }
    function $() {
      s.value--;
    }
    function T() {
      s.value++;
    }
    const O = b(
      () => r(l.value, t.value.navMonths).map((ce) => ({
        ...ce,
        click: () => a(
          { month: ce.month, year: ce.year },
          { position: n.value.position }
        )
      }))
    ), M = b(
      () => r(l.value - 1, t.value.navMonths)
    ), F = b(
      () => M.value.some((ce) => !ce.isDisabled)
    ), q = b(
      () => r(l.value + 1, t.value.navMonths)
    ), x = b(
      () => q.value.some((ce) => !ce.isDisabled)
    ), Y = b(
      () => i(
        m(s.value),
        C(s.value)
      ).map((ce) => ({
        ...ce,
        click: () => {
          l.value = ce.year, o.value = !0, c();
        }
      }))
    ), R = b(
      () => i(
        m(s.value - 1),
        C(s.value - 1)
      )
    ), k = b(
      () => R.value.some((ce) => !ce.isDisabled)
    ), P = b(
      () => i(
        m(s.value + 1),
        C(s.value + 1)
      )
    ), D = b(
      () => P.value.some((ce) => !ce.isDisabled)
    ), B = b(
      () => o.value ? O.value : Y.value
    ), J = b(
      () => o.value ? F.value : k.value
    ), _ = b(
      () => o.value ? x.value : D.value
    ), te = b(() => gm(Y.value.map((ce) => ce.year))), G = b(() => Ar(Y.value.map((ce) => ce.year))), pe = b(() => o.value ? l.value : `${te.value} - ${G.value}`);
    return Mu(() => {
      l.value = n.value.year, c();
    }), ne(
      () => l.value,
      (ce) => s.value = f(ce)
    ), rt(() => c()), (ce, $e) => (y(), S("div", {
      class: "vc-nav-container",
      ref_key: "navContainer",
      ref: d
    }, [
      H("div", PL, [
        H("button", {
          type: "button",
          class: "vc-nav-arrow is-left vc-focus",
          disabled: !A(J),
          onClick: p,
          onKeydown: $e[0] || ($e[0] = (ge) => A(No)(ge, p))
        }, [
          Z(fa, {
            name: "nav-prev-button",
            move: p,
            disabled: !A(J)
          }, {
            default: N(() => [
              Z(Wr, {
                name: "ChevronLeft",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, NL),
        H("button", {
          type: "button",
          class: "vc-nav-title vc-focus",
          onClick: v,
          onKeydown: $e[1] || ($e[1] = (ge) => A(No)(ge, v))
        }, ae(A(pe)), 33),
        H("button", {
          type: "button",
          class: "vc-nav-arrow is-right vc-focus",
          disabled: !A(_),
          onClick: h,
          onKeydown: $e[2] || ($e[2] = (ge) => A(No)(ge, h))
        }, [
          Z(fa, {
            name: "nav-next-button",
            move: h,
            disabled: !A(_)
          }, {
            default: N(() => [
              Z(Wr, {
                name: "ChevronRight",
                width: "22px",
                height: "24px"
              })
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 40, LL)
      ]),
      H("div", BL, [
        (y(!0), S(Ae, null, Le(A(B), (ge) => (y(), S("button", {
          key: ge.label,
          type: "button",
          "data-id": ge.id,
          "aria-label": ge.ariaLabel,
          class: ue(["vc-nav-item vc-focus", [
            ge.isActive ? "is-active" : ge.isCurrent ? "is-current" : ""
          ]]),
          disabled: ge.isDisabled,
          onClick: ge.click,
          onKeydown: (Se) => A(No)(Se, ge.click)
        }, ae(ge.label), 43, RL))), 128))
      ])
    ], 512));
  }
}), Xm = /* @__PURE__ */ se({
  __name: "CalendarPageProvider",
  props: {
    page: null
  },
  setup(e) {
    return xL(Yo(e, "page")), (a, n) => j(a.$slots, "default");
  }
}), zL = /* @__PURE__ */ se({
  __name: "CalendarNavPopover",
  setup(e) {
    const { navPopoverId: t, color: a, displayMode: n } = fr();
    return (r, i) => (y(), ee(Md, {
      id: A(t),
      class: ue(["vc-nav-popover-container", `vc-${A(a)}`, `vc-${A(n)}`])
    }, {
      default: N(({ data: o }) => [
        Z(Xm, {
          page: o.page
        }, {
          default: N(() => [
            Z(fa, { name: "nav" }, {
              default: N(() => [
                Z(FL)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, 1032, ["page"])
      ]),
      _: 1
    }, 8, ["id", "class"]));
  }
}), YL = se({
  directives: { popover: Ym },
  components: { CalendarSlot: fa },
  props: {
    day: { type: Object, required: !0 }
  },
  setup(e) {
    const {
      locale: t,
      theme: a,
      attributeContext: n,
      dayPopoverId: r,
      onDayClick: i,
      onDayMouseenter: o,
      onDayMouseleave: u,
      onDayFocusin: l,
      onDayFocusout: s,
      onDayKeydown: d
    } = fr(), c = b(() => e.day), f = b(() => n.value.getCells(c.value)), v = b(
      () => f.value.map((D) => D.data)
    ), m = b(() => ({
      ...c.value,
      attributes: v.value,
      attributeCells: f.value
    }));
    function C({ data: D }, { popovers: B }) {
      const { key: J, customData: _, popover: te } = D;
      if (!te)
        return;
      const G = Gv(
        {
          key: J,
          customData: _,
          attribute: D
        },
        { ...te },
        {
          visibility: te.label ? "hover" : "click",
          placement: "bottom",
          isInteractive: !te.label
        }
      );
      B.splice(0, 0, G);
    }
    const p = b(() => {
      const D = {
        ...a.value.prepareRender({}),
        popovers: []
      };
      return f.value.forEach((B) => {
        a.value.render(B, D), C(B, D);
      }), D;
    }), h = b(() => p.value.highlights), g = b(() => !!tn(h.value)), w = b(() => p.value.content), $ = b(() => p.value.dots), T = b(() => !!tn($.value)), O = b(() => p.value.bars), M = b(() => !!tn(O.value)), F = b(() => p.value.popovers), q = b(
      () => F.value.map((D) => D.attribute)
    ), x = Km("day-content"), Y = b(() => [
      "vc-day",
      ...c.value.classes,
      { "vc-day-box-center-center": !x },
      { "is-not-in-month": !e.day.inMonth }
    ]), R = b(() => {
      let D;
      c.value.isFocusable ? D = "0" : D = "-1";
      const B = [
        "vc-day-content vc-focusable vc-focus vc-attr",
        { "vc-disabled": c.value.isDisabled },
        Kn(Ar(h.value), "contentClass"),
        Kn(Ar(w.value), "class") || ""
      ], J = {
        ...Kn(Ar(h.value), "contentStyle"),
        ...Kn(Ar(w.value), "style")
      };
      return {
        class: B,
        style: J,
        tabindex: D,
        "aria-label": c.value.ariaLabel,
        "aria-disabled": !!c.value.isDisabled,
        role: "button"
      };
    }), k = b(() => ({
      click(D) {
        i(m.value, D);
      },
      mouseenter(D) {
        o(m.value, D);
      },
      mouseleave(D) {
        u(m.value, D);
      },
      focusin(D) {
        l(m.value, D);
      },
      focusout(D) {
        s(m.value, D);
      },
      keydown(D) {
        d(m.value, D);
      }
    })), P = b(() => tn(F.value) ? Gv(
      {
        id: r.value,
        data: { day: c, attributes: q.value }
      },
      ...F.value
    ) : null);
    return {
      attributes: v,
      attributeCells: f,
      bars: O,
      dayClasses: Y,
      dayContentProps: R,
      dayContentEvents: k,
      dayPopover: P,
      glyphs: p,
      dots: $,
      hasDots: T,
      hasBars: M,
      highlights: h,
      hasHighlights: g,
      locale: t,
      popovers: F
    };
  }
}), HL = {
  key: 0,
  class: "vc-highlights vc-day-layer"
}, qL = {
  key: 1,
  class: "vc-day-layer vc-day-box-center-bottom"
}, WL = { class: "vc-dots" }, _L = {
  key: 2,
  class: "vc-day-layer vc-day-box-center-bottom"
}, UL = { class: "vc-bars" };
function VL(e, t, a, n, r, i) {
  const o = zt("CalendarSlot"), u = O1("popover");
  return y(), S("div", {
    class: ue(e.dayClasses)
  }, [
    e.hasHighlights ? (y(), S("div", HL, [
      (y(!0), S(Ae, null, Le(e.highlights, ({ key: l, wrapperClass: s, class: d, style: c }) => (y(), S("div", {
        key: l,
        class: ue(s)
      }, [
        H("div", {
          class: ue(d),
          style: Ee(c)
        }, null, 6)
      ], 2))), 128))
    ])) : W("", !0),
    Z(o, {
      name: "day-content",
      day: e.day,
      attributes: e.attributes,
      "attribute-cells": e.attributeCells,
      dayProps: e.dayContentProps,
      dayEvents: e.dayContentEvents,
      locale: e.locale
    }, {
      default: N(() => [
        $a((y(), S("div", Fe(e.dayContentProps, Bs(e.dayContentEvents, !0)), [
          be(ae(e.day.label), 1)
        ], 16)), [
          [u, e.dayPopover]
        ])
      ]),
      _: 1
    }, 8, ["day", "attributes", "attribute-cells", "dayProps", "dayEvents", "locale"]),
    e.hasDots ? (y(), S("div", qL, [
      H("div", WL, [
        (y(!0), S(Ae, null, Le(e.dots, ({ key: l, class: s, style: d }) => (y(), S("span", {
          key: l,
          class: ue(s),
          style: Ee(d)
        }, null, 6))), 128))
      ])
    ])) : W("", !0),
    e.hasBars ? (y(), S("div", _L, [
      H("div", UL, [
        (y(!0), S(Ae, null, Le(e.bars, ({ key: l, class: s, style: d }) => (y(), S("span", {
          key: l,
          class: ue(s),
          style: Ee(d)
        }, null, 6))), 128))
      ])
    ])) : W("", !0)
  ], 2);
}
const KL = /* @__PURE__ */ Bn(YL, [["render", VL]]), jL = { class: "vc-weekdays" }, GL = ["onClick"], QL = {
  inheritAttrs: !1
}, ZL = /* @__PURE__ */ se({
  ...QL,
  __name: "CalendarPage",
  setup(e) {
    const { page: t } = Zm(), { onWeeknumberClick: a } = fr();
    return (n, r) => (y(), S("div", {
      class: ue([
        "vc-pane",
        `row-${A(t).row}`,
        `row-from-end-${A(t).rowFromEnd}`,
        `column-${A(t).column}`,
        `column-from-end-${A(t).columnFromEnd}`
      ]),
      ref: "pane"
    }, [
      Z(Gm, {
        page: A(t),
        "is-lg": "",
        "hide-arrows": ""
      }, null, 8, ["page"]),
      H("div", {
        class: ue(["vc-weeks", {
          [`vc-show-weeknumbers-${A(t).weeknumberPosition}`]: A(t).weeknumberPosition
        }])
      }, [
        H("div", jL, [
          (y(!0), S(Ae, null, Le(A(t).weekdays, ({ weekday: i, label: o }, u) => (y(), S("div", {
            key: u,
            class: ue(`vc-weekday vc-weekday-${i}`)
          }, ae(o), 3))), 128))
        ]),
        (y(!0), S(Ae, null, Le(A(t).viewWeeks, (i) => (y(), S("div", {
          key: `weeknumber-${i.weeknumber}`,
          class: "vc-week"
        }, [
          A(t).weeknumberPosition ? (y(), S("div", {
            key: 0,
            class: ue(["vc-weeknumber", `is-${A(t).weeknumberPosition}`])
          }, [
            H("span", {
              class: ue(["vc-weeknumber-content"]),
              onClick: (o) => A(a)(i, o)
            }, ae(i.weeknumberDisplay), 9, GL)
          ], 2)) : W("", !0),
          (y(!0), S(Ae, null, Le(i.days, (o) => (y(), ee(KL, {
            key: o.id,
            day: o
          }, null, 8, ["day"]))), 128))
        ]))), 128))
      ], 2)
    ], 2));
  }
}), XL = se({
  components: {
    CalendarHeader: Gm,
    CalendarPage: ZL,
    CalendarNavPopover: zL,
    CalendarDayPopover: aL,
    CalendarPageProvider: Xm,
    CalendarSlot: fa
  },
  props: _6,
  emit: U6,
  setup(e, { emit: t, slots: a }) {
    return V6(e, { emit: t, slots: a });
  }
}), JL = { class: "vc-pane-header-wrapper" };
function eB(e, t, a, n, r, i) {
  const o = zt("CalendarHeader"), u = zt("CalendarPage"), l = zt("CalendarSlot"), s = zt("CalendarPageProvider"), d = zt("CalendarDayPopover"), c = zt("CalendarNavPopover");
  return y(), S(Ae, null, [
    H("div", Fe({ "data-helptext": "Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year" }, e.$attrs, {
      class: [
        "vc-container",
        `vc-${e.view}`,
        `vc-${e.color}`,
        `vc-${e.displayMode}`,
        {
          "vc-expanded": e.expanded,
          "vc-bordered": !e.borderless,
          "vc-transparent": e.transparent
        }
      ],
      onMouseup: t[0] || (t[0] = Ke(() => {
      }, ["prevent"])),
      ref: "containerRef"
    }), [
      H("div", {
        class: ue(["vc-pane-container", { "in-transition": e.inTransition }])
      }, [
        H("div", JL, [
          e.firstPage ? (y(), ee(o, {
            key: 0,
            page: e.firstPage,
            "is-lg": "",
            "hide-title": ""
          }, null, 8, ["page"])) : W("", !0)
        ]),
        Z(Zt, {
          name: `vc-${e.transitionName}`,
          onBeforeEnter: e.onTransitionBeforeEnter,
          onAfterEnter: e.onTransitionAfterEnter
        }, {
          default: N(() => [
            (y(), S("div", {
              key: e.pages[0].id,
              class: "vc-pane-layout",
              style: Ee({
                gridTemplateColumns: `repeat(${e.columns}, 1fr)`
              })
            }, [
              (y(!0), S(Ae, null, Le(e.pages, (f) => (y(), ee(s, {
                key: f.id,
                page: f
              }, {
                default: N(() => [
                  Z(l, {
                    name: "page",
                    page: f
                  }, {
                    default: N(() => [
                      Z(u)
                    ]),
                    _: 2
                  }, 1032, ["page"])
                ]),
                _: 2
              }, 1032, ["page"]))), 128))
            ], 4))
          ]),
          _: 1
        }, 8, ["name", "onBeforeEnter", "onAfterEnter"]),
        Z(l, { name: "footer" })
      ], 2)
    ], 16),
    Z(d),
    Z(c)
  ], 64);
}
const tB = /* @__PURE__ */ Bn(XL, [["render", eB]]), Jm = Symbol("__vc_date_picker_context__"), aB = {
  ...Wm,
  mode: { type: String, default: "date" },
  modelValue: {
    type: [Number, String, Date, Object]
  },
  modelModifiers: {
    type: Object,
    default: () => ({})
  },
  rules: [String, Object],
  is24hr: Boolean,
  hideTimeHeader: Boolean,
  timeAccuracy: { type: Number, default: 2 },
  isRequired: Boolean,
  isRange: Boolean,
  updateOnInput: {
    type: Boolean,
    default: () => Pn("datePicker.updateOnInput")
  },
  inputDebounce: {
    type: Number,
    default: () => Pn("datePicker.inputDebounce")
  },
  popover: {
    type: [Boolean, Object],
    default: !0
  },
  dragAttribute: Object,
  selectAttribute: Object,
  attributes: [Object, Array]
}, nB = [
  "update:modelValue",
  "drag",
  "dayclick",
  "daykeydown",
  "popover-will-show",
  "popover-did-show",
  "popover-will-hide",
  "popover-did-hide"
];
function rB(e, { emit: t, slots: a }) {
  Vm(a, { footer: "dp-footer" });
  const n = _m(e), { locale: r, masks: i, disabledAttribute: o } = n, u = L(!1), l = L(Symbol()), s = L(null), d = L(null), c = L(["", ""]), f = L(null), v = L(null);
  let m, C, p = !0;
  const h = b(() => e.isRange || e.modelModifiers.range === !0), g = b(
    () => h.value && s.value != null ? s.value.start : null
  ), w = b(
    () => h.value && s.value != null ? s.value.end : null
  ), $ = b(() => e.mode.toLowerCase() === "date"), T = b(
    () => e.mode.toLowerCase() === "datetime"
  ), O = b(() => e.mode.toLowerCase() === "time"), M = b(() => !!d.value), F = b(() => {
    let I = "date";
    e.modelModifiers.number && (I = "number"), e.modelModifiers.string && (I = "string");
    const Q = i.value.modelValue || "iso";
    return $e({ type: I, mask: Q });
  }), q = b(
    () => xe(d.value ?? s.value)
  ), x = b(() => O.value ? e.is24hr ? i.value.inputTime24hr : i.value.inputTime : T.value ? e.is24hr ? i.value.inputDateTime24hr : i.value.inputDateTime : i.value.input), Y = b(() => /[Hh]/g.test(x.value)), R = b(
    () => /[dD]{1,2}|Do|W{1,4}|M{1,4}|YY(?:YY)?/g.test(x.value)
  ), k = b(() => {
    if (Y.value && R.value)
      return "dateTime";
    if (R.value)
      return "date";
    if (Y.value)
      return "time";
  }), P = b(() => {
    var I;
    const Q = ((I = f.value) == null ? void 0 : I.$el.previousElementSibling) ?? void 0;
    return Pi({}, e.popover, Pn("datePicker.popover"), {
      target: Q
    });
  }), D = b(
    () => zm({
      ...P.value,
      id: l.value
    })
  ), B = b(() => h.value ? {
    start: c.value[0],
    end: c.value[1]
  } : c.value[0]), J = b(() => {
    const I = ["start", "end"].map((Q) => ({
      input: fe(Q),
      change: z(Q),
      keyup: Ce,
      ...e.popover && D.value
    }));
    return h.value ? {
      start: I[0],
      end: I[1]
    } : I[0];
  }), _ = b(() => {
    if (!Ne(s.value))
      return null;
    const I = {
      key: "select-drag",
      ...e.selectAttribute,
      dates: s.value,
      pinPage: !0
    }, { dot: Q, bar: ve, highlight: ke, content: Ze } = I;
    return !Q && !ve && !ke && !Ze && (I.highlight = !0), I;
  }), te = b(() => {
    if (!h.value || !Ne(d.value))
      return null;
    const I = {
      key: "select-drag",
      ...e.dragAttribute,
      dates: d.value
    }, { dot: Q, bar: ve, highlight: ke, content: Ze } = I;
    return !Q && !ve && !ke && !Ze && (I.highlight = {
      startEnd: {
        fillMode: "outline"
      }
    }), I;
  }), G = b(() => {
    const I = ha(e.attributes) ? [...e.attributes] : [];
    return te.value ? I.unshift(te.value) : _.value && I.unshift(_.value), I;
  }), pe = b(() => $e(
    e.rules === "auto" ? ce() : e.rules ?? {}
  ));
  function ce() {
    const I = {
      ms: [0, 999],
      sec: [0, 59],
      min: [0, 59],
      hr: [0, 23]
    }, Q = $.value ? 0 : e.timeAccuracy;
    return [0, 1].map((ve) => {
      switch (Q) {
        case 0:
          return {
            hours: I.hr[ve],
            minutes: I.min[ve],
            seconds: I.sec[ve],
            milliseconds: I.ms[ve]
          };
        case 1:
          return {
            minutes: I.min[ve],
            seconds: I.sec[ve],
            milliseconds: I.ms[ve]
          };
        case 3:
          return { milliseconds: I.ms[ve] };
        case 4:
          return {};
        default:
          return { seconds: I.sec[ve], milliseconds: I.ms[ve] };
      }
    });
  }
  function $e(I) {
    return ha(I) ? I.length === 1 ? [I[0], I[0]] : I : [I, I];
  }
  function ge(I) {
    return $e(I).map(
      (Q, ve) => ({
        ...Q,
        rules: pe.value[ve]
      })
    );
  }
  function Se(I) {
    return I == null ? !1 : Da(I) ? !isNaN(I) : Or(I) ? !isNaN(I.getTime()) : Pa(I) ? I !== "" : Dd(I);
  }
  function Ue(I) {
    return ln(I) && "start" in I && "end" in I && Se(I.start ?? null) && Se(I.end ?? null);
  }
  function Ne(I) {
    return Ue(I) || Se(I);
  }
  function He(I, Q) {
    if (I == null && Q == null)
      return !0;
    if (I == null || Q == null)
      return !1;
    const ve = Or(I), ke = Or(Q);
    return ve && ke ? I.getTime() === Q.getTime() : ve || ke ? !1 : He(I.start, Q.start) && He(I.end, Q.end);
  }
  function Xe(I) {
    return !Ne(I) || !o.value ? !1 : o.value.intersectsRange(r.value.range(I));
  }
  function ot(I, Q, ve, ke) {
    if (!Ne(I))
      return null;
    if (Ue(I)) {
      const Ze = r.value.toDate(I.start, {
        ...Q[0],
        fillDate: g.value ?? void 0,
        patch: ve
      }), Ct = r.value.toDate(I.end, {
        ...Q[1],
        fillDate: w.value ?? void 0,
        patch: ve
      });
      return re({ start: Ze, end: Ct }, ke);
    }
    return r.value.toDateOrNull(I, {
      ...Q[0],
      fillDate: s.value,
      patch: ve
    });
  }
  function Ge(I, Q) {
    return Ue(I) ? {
      start: r.value.fromDate(I.start, Q[0]),
      end: r.value.fromDate(I.end, Q[1])
    } : h.value ? null : r.value.fromDate(I, Q[0]);
  }
  function Je(I, Q = {}) {
    return clearTimeout(m), new Promise((ve) => {
      const { debounce: ke = 0, ...Ze } = Q;
      ke > 0 ? m = window.setTimeout(() => {
        ve(et(I, Ze));
      }, ke) : ve(et(I, Ze));
    });
  }
  function et(I, {
    config: Q = F.value,
    patch: ve = "dateTime",
    clearIfEqual: ke = !1,
    formatInput: Ze = !0,
    hidePopover: Ct = !1,
    dragging: Pt = M.value,
    targetPriority: ba,
    moveToValue: ua = !1
  } = {}) {
    const da = ge(Q);
    let kt = ot(
      I,
      da,
      ve,
      ba
    );
    if (Xe(kt)) {
      if (Pt)
        return null;
      kt = s.value, Ct = !1;
    } else kt == null && e.isRequired ? kt = s.value : (
      // Clear value if same value was passed
      kt != null && He(s.value, kt) && ke && (kt = null)
    );
    const we = Pt ? d : s, E = !He(we.value, kt);
    we.value = kt, Pt || (d.value = null);
    const V = Ge(
      kt,
      F.value
    );
    return E && (p = !1, t(Pt ? "drag" : "update:modelValue", V), gt(() => p = !0)), Ct && !Pt && xt(), Ze && ie(), ua && gt(() => de(ba ?? "start")), V;
  }
  function ie() {
    gt(() => {
      const I = ge({
        type: "string",
        mask: x.value
      }), Q = Ge(
        d.value ?? s.value,
        I
      );
      h.value ? c.value = [Q && Q.start, Q && Q.end] : c.value = [Q, ""];
    });
  }
  function le(I, Q, ve) {
    c.value.splice(Q === "start" ? 0 : 1, 1, I);
    const ke = h.value ? {
      start: c.value[0],
      end: c.value[1] || c.value[0]
    } : I, Ze = {
      type: "string",
      mask: x.value
    };
    Je(ke, {
      ...ve,
      config: Ze,
      patch: k.value,
      targetPriority: Q,
      moveToValue: !0
    });
  }
  function fe(I) {
    return (Q) => {
      e.updateOnInput && le(Q.currentTarget.value, I, {
        formatInput: !1,
        hidePopover: !1,
        debounce: e.inputDebounce
      });
    };
  }
  function z(I) {
    return (Q) => {
      le(Q.currentTarget.value, I, {
        formatInput: !0,
        hidePopover: !1
      });
    };
  }
  function Ce(I) {
    I.key === "Escape" && Je(s.value, {
      formatInput: !0,
      hidePopover: !0
    });
  }
  function xe(I) {
    return h.value ? [
      I && I.start ? r.value.getDateParts(I.start) : null,
      I && I.end ? r.value.getDateParts(I.end) : null
    ] : [I ? r.value.getDateParts(I) : null];
  }
  function De() {
    d.value = null, ie();
  }
  function qe(I) {
    t("popover-will-show", I);
  }
  function ct(I) {
    t("popover-did-show", I);
  }
  function dt(I) {
    De(), t("popover-will-hide", I);
  }
  function Qe(I) {
    t("popover-did-hide", I);
  }
  function pt(I) {
    const Q = {
      patch: "date",
      formatInput: !0,
      hidePopover: !0
    };
    if (h.value) {
      const ve = !M.value;
      ve ? C = { start: I.startDate, end: I.endDate } : C != null && (C.end = I.date), Je(C, {
        ...Q,
        dragging: ve
      });
    } else
      Je(I.date, {
        ...Q,
        clearIfEqual: !e.isRequired
      });
  }
  function It(I, Q) {
    pt(I), t("dayclick", I, Q);
  }
  function Ot(I, Q) {
    switch (Q.key) {
      case " ":
      case "Enter": {
        pt(I), Q.preventDefault();
        break;
      }
      case "Escape":
        xt();
    }
    t("daykeydown", I, Q);
  }
  function Gt(I, Q) {
    !M.value || C == null || (C.end = I.date, Je(re(C), {
      patch: "date",
      formatInput: !0
    }));
  }
  function ta(I = {}) {
    wu({
      ...P.value,
      ...I,
      isInteractive: !0,
      id: l.value
    });
  }
  function xt(I = {}) {
    Ni({
      hideDelay: 10,
      force: !0,
      ...P.value,
      ...I,
      id: l.value
    });
  }
  function Mt(I) {
    Fm({
      ...P.value,
      ...I,
      isInteractive: !0,
      id: l.value
    });
  }
  function re(I, Q) {
    const { start: ve, end: ke } = I;
    if (ve > ke)
      switch (Q) {
        case "start":
          return { start: ve, end: ve };
        case "end":
          return { start: ke, end: ke };
        default:
          return { start: ke, end: ve };
      }
    return { start: ve, end: ke };
  }
  async function ze(I, Q = {}) {
    return v.value == null ? !1 : v.value.move(I, Q);
  }
  async function U(I, Q = {}) {
    return v.value == null ? !1 : v.value.moveBy(I, Q);
  }
  async function de(I, Q = {}) {
    const ve = s.value;
    if (v.value == null || !Ne(ve))
      return !1;
    const ke = I !== "end", Ze = ke ? 1 : -1, Ct = Ue(ve) ? ke ? ve.start : ve.end : ve, Pt = km(Ct, "monthly", r.value);
    return v.value.move(Pt, { position: Ze, ...Q });
  }
  ne(
    () => e.isRange,
    (I) => {
      I && console.warn(
        "The `is-range` prop will be deprecated in future releases. Please use the `range` modifier."
      );
    },
    { immediate: !0 }
  ), ne(
    () => h.value,
    () => {
      et(null, { formatInput: !0 });
    }
  ), ne(
    () => x.value,
    () => ie()
  ), ne(
    () => e.modelValue,
    (I) => {
      p && et(I, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), ne(
    () => pe.value,
    () => {
      ln(e.rules) && et(e.modelValue, {
        formatInput: !0,
        hidePopover: !1
      });
    }
  ), ne(
    () => e.timezone,
    () => {
      et(s.value, { formatInput: !0 });
    }
  );
  const Ie = $e(F.value);
  s.value = ot(
    e.modelValue ?? null,
    Ie,
    "dateTime"
  ), rt(() => {
    et(e.modelValue, {
      formatInput: !0,
      hidePopover: !1
    });
  }), gt(() => u.value = !0);
  const X = {
    ...n,
    showCalendar: u,
    datePickerPopoverId: l,
    popoverRef: f,
    popoverEvents: D,
    calendarRef: v,
    isRange: h,
    isTimeMode: O,
    isDateTimeMode: T,
    is24hr: Yo(e, "is24hr"),
    hideTimeHeader: Yo(e, "hideTimeHeader"),
    timeAccuracy: Yo(e, "timeAccuracy"),
    isDragging: M,
    inputValue: B,
    inputEvents: J,
    dateParts: q,
    attributes: G,
    rules: pe,
    move: ze,
    moveBy: U,
    moveToValue: de,
    updateValue: Je,
    showPopover: ta,
    hidePopover: xt,
    togglePopover: Mt,
    onDayClick: It,
    onDayKeydown: Ot,
    onDayMouseEnter: Gt,
    onPopoverBeforeShow: qe,
    onPopoverAfterShow: ct,
    onPopoverBeforeHide: dt,
    onPopoverAfterHide: Qe
  };
  return Bi(Jm, X), X;
}
function Od() {
  const e = Li(Jm);
  if (e)
    return e;
  throw new Error(
    "DatePicker context missing. Please verify this component is nested within a valid context provider."
  );
}
const iB = [
  { value: 0, label: "12" },
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
  { value: 9, label: "9" },
  { value: 10, label: "10" },
  { value: 11, label: "11" }
], oB = [
  { value: 12, label: "12" },
  { value: 13, label: "1" },
  { value: 14, label: "2" },
  { value: 15, label: "3" },
  { value: 16, label: "4" },
  { value: 17, label: "5" },
  { value: 18, label: "6" },
  { value: 19, label: "7" },
  { value: 20, label: "8" },
  { value: 21, label: "9" },
  { value: 22, label: "10" },
  { value: 23, label: "11" }
];
function sB(e) {
  const t = Od(), {
    locale: a,
    isRange: n,
    isTimeMode: r,
    dateParts: i,
    rules: o,
    is24hr: u,
    hideTimeHeader: l,
    timeAccuracy: s,
    updateValue: d
  } = t;
  function c(R) {
    R = Object.assign(v.value, R);
    let k = null;
    if (n.value) {
      const P = f.value ? R : i.value[0], D = f.value ? i.value[1] : R;
      k = { start: P, end: D };
    } else
      k = R;
    d(k, {
      patch: "time",
      targetPriority: f.value ? "start" : "end",
      moveToValue: !0
    });
  }
  const f = b(() => e.position === 0), v = b(
    () => i.value[e.position] || { isValid: !1 }
  ), m = b(() => Dd(v.value)), C = b(() => !!v.value.isValid), p = b(() => !l.value && C.value), h = b(() => {
    if (!m.value)
      return null;
    let R = a.value.toDate(v.value);
    return v.value.hours === 24 && (R = new Date(R.getTime() - 1)), R;
  }), g = b({
    get() {
      return v.value.hours;
    },
    set(R) {
      c({ hours: R });
    }
  }), w = b({
    get() {
      return v.value.minutes;
    },
    set(R) {
      c({ minutes: R });
    }
  }), $ = b({
    get() {
      return v.value.seconds;
    },
    set(R) {
      c({ seconds: R });
    }
  }), T = b({
    get() {
      return v.value.milliseconds;
    },
    set(R) {
      c({ milliseconds: R });
    }
  }), O = b({
    get() {
      return v.value.hours < 12;
    },
    set(R) {
      R = String(R).toLowerCase() == "true";
      let k = g.value;
      R && k >= 12 ? k -= 12 : !R && k < 12 && (k += 12), c({ hours: k });
    }
  }), M = b(
    () => T6(v.value, o.value[e.position])
  ), F = b(() => iB.filter(
    (R) => M.value.hours.some((k) => k.value === R.value)
  )), q = b(() => oB.filter(
    (R) => M.value.hours.some((k) => k.value === R.value)
  )), x = b(() => u.value ? M.value.hours : O.value ? F.value : q.value), Y = b(() => {
    const R = [];
    return tn(F.value) && R.push({ value: !0, label: "AM" }), tn(q.value) && R.push({ value: !1, label: "PM" }), R;
  });
  return {
    ...t,
    showHeader: p,
    timeAccuracy: s,
    parts: v,
    isValid: C,
    date: h,
    hours: g,
    minutes: w,
    seconds: $,
    milliseconds: T,
    options: M,
    hourOptions: x,
    isAM: O,
    isAMOptions: Y,
    is24hr: u
  };
}
const lB = ["value"], uB = ["value", "disabled"], dB = {
  key: 1,
  class: "vc-base-sizer",
  "aria-hidden": "true"
}, cB = {
  inheritAttrs: !1
}, di = /* @__PURE__ */ se({
  ...cB,
  __name: "BaseSelect",
  props: {
    options: null,
    modelValue: null,
    alignRight: { type: Boolean },
    alignLeft: { type: Boolean },
    showIcon: { type: Boolean },
    fitContent: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, a = b(() => {
      const n = t.options.find((r) => r.value === t.modelValue);
      return n == null ? void 0 : n.label;
    });
    return (n, r) => (y(), S("div", {
      class: ue(["vc-base-select", {
        "vc-fit-content": e.fitContent,
        "vc-has-icon": e.showIcon
      }])
    }, [
      H("select", Fe(n.$attrs, {
        value: e.modelValue,
        class: ["vc-focus", {
          "vc-align-right": e.alignRight,
          "vc-align-left": e.alignLeft
        }],
        onChange: r[0] || (r[0] = (i) => n.$emit("update:modelValue", i.target.value))
      }), [
        (y(!0), S(Ae, null, Le(e.options, (i) => (y(), S("option", {
          key: i.value,
          value: i.value,
          disabled: i.disabled
        }, ae(i.label), 9, uB))), 128))
      ], 16, lB),
      e.showIcon ? (y(), ee(Wr, {
        key: 0,
        name: "ChevronDown",
        size: "18"
      })) : W("", !0),
      e.fitContent ? (y(), S("div", dB, ae(A(a)), 1)) : W("", !0)
    ], 2));
  }
}), fB = {
  key: 0,
  class: "vc-time-header"
}, vB = { class: "vc-time-weekday" }, pB = { class: "vc-time-month" }, hB = { class: "vc-time-day" }, gB = { class: "vc-time-year" }, mB = { class: "vc-time-select-group" }, yB = /* @__PURE__ */ H("span", { class: "vc-time-colon" }, ":", -1), bB = /* @__PURE__ */ H("span", { class: "vc-time-colon" }, ":", -1), wB = /* @__PURE__ */ H("span", { class: "vc-time-decimal" }, ".", -1), Sp = /* @__PURE__ */ se({
  __name: "TimePicker",
  props: {
    position: null
  },
  setup(e, { expose: t }) {
    const n = sB(e);
    t(n);
    const {
      locale: r,
      isValid: i,
      date: o,
      hours: u,
      minutes: l,
      seconds: s,
      milliseconds: d,
      options: c,
      hourOptions: f,
      isTimeMode: v,
      isAM: m,
      isAMOptions: C,
      is24hr: p,
      showHeader: h,
      timeAccuracy: g
    } = n;
    return (w, $) => (y(), S("div", {
      class: ue(["vc-time-picker", [{ "vc-invalid": !A(i), "vc-attached": !A(v) }]])
    }, [
      Z(fa, { name: "time-header" }, {
        default: N(() => [
          A(h) && A(o) ? (y(), S("div", fB, [
            H("span", vB, ae(A(r).formatDate(A(o), "WWW")), 1),
            H("span", pB, ae(A(r).formatDate(A(o), "MMM")), 1),
            H("span", hB, ae(A(r).formatDate(A(o), "D")), 1),
            H("span", gB, ae(A(r).formatDate(A(o), "YYYY")), 1)
          ])) : W("", !0)
        ]),
        _: 1
      }),
      H("div", mB, [
        Z(Wr, {
          name: "Clock",
          size: "17"
        }),
        Z(di, {
          modelValue: A(u),
          "onUpdate:modelValue": $[0] || ($[0] = (T) => wr(u) ? u.value = T : null),
          modelModifiers: { number: !0 },
          options: A(f),
          class: "vc-time-select-hours",
          "align-right": ""
        }, null, 8, ["modelValue", "options"]),
        A(g) > 1 ? (y(), S(Ae, { key: 0 }, [
          yB,
          Z(di, {
            modelValue: A(l),
            "onUpdate:modelValue": $[1] || ($[1] = (T) => wr(l) ? l.value = T : null),
            modelModifiers: { number: !0 },
            options: A(c).minutes,
            class: "vc-time-select-minutes",
            "align-left": A(g) === 2
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : W("", !0),
        A(g) > 2 ? (y(), S(Ae, { key: 1 }, [
          bB,
          Z(di, {
            modelValue: A(s),
            "onUpdate:modelValue": $[2] || ($[2] = (T) => wr(s) ? s.value = T : null),
            modelModifiers: { number: !0 },
            options: A(c).seconds,
            class: "vc-time-select-seconds",
            "align-left": A(g) === 3
          }, null, 8, ["modelValue", "options", "align-left"])
        ], 64)) : W("", !0),
        A(g) > 3 ? (y(), S(Ae, { key: 2 }, [
          wB,
          Z(di, {
            modelValue: A(d),
            "onUpdate:modelValue": $[3] || ($[3] = (T) => wr(d) ? d.value = T : null),
            modelModifiers: { number: !0 },
            options: A(c).milliseconds,
            class: "vc-time-select-milliseconds",
            "align-left": ""
          }, null, 8, ["modelValue", "options"])
        ], 64)) : W("", !0),
        A(p) ? W("", !0) : (y(), ee(di, {
          key: 3,
          modelValue: A(m),
          "onUpdate:modelValue": $[4] || ($[4] = (T) => wr(m) ? m.value = T : null),
          options: A(C)
        }, null, 8, ["modelValue", "options"]))
      ])
    ], 2));
  }
}), e1 = /* @__PURE__ */ se({
  __name: "DatePickerBase",
  setup(e) {
    const {
      attributes: t,
      calendarRef: a,
      color: n,
      displayMode: r,
      isDateTimeMode: i,
      isTimeMode: o,
      isRange: u,
      onDayClick: l,
      onDayMouseEnter: s,
      onDayKeydown: d
    } = Od(), c = u.value ? [0, 1] : [0];
    return (f, v) => A(o) ? (y(), S("div", {
      key: 0,
      class: ue(`vc-container vc-bordered vc-${A(n)} vc-${A(r)}`)
    }, [
      (y(!0), S(Ae, null, Le(A(c), (m) => (y(), ee(Sp, {
        key: m,
        position: m
      }, null, 8, ["position"]))), 128))
    ], 2)) : (y(), ee(tB, {
      key: 1,
      attributes: A(t),
      ref_key: "calendarRef",
      ref: a,
      onDayclick: A(l),
      onDaymouseenter: A(s),
      onDaykeydown: A(d)
    }, {
      footer: N(() => [
        A(i) ? (y(!0), S(Ae, { key: 0 }, Le(A(c), (m) => (y(), ee(Sp, {
          key: m,
          position: m
        }, null, 8, ["position"]))), 128)) : W("", !0),
        Z(fa, { name: "dp-footer" })
      ]),
      _: 1
    }, 8, ["attributes", "onDayclick", "onDaymouseenter", "onDaykeydown"]));
  }
}), CB = {
  inheritAttrs: !1
}, kB = /* @__PURE__ */ se({
  ...CB,
  __name: "DatePickerPopover",
  setup(e) {
    const {
      datePickerPopoverId: t,
      color: a,
      displayMode: n,
      popoverRef: r,
      onPopoverBeforeShow: i,
      onPopoverAfterShow: o,
      onPopoverBeforeHide: u,
      onPopoverAfterHide: l
    } = Od();
    return (s, d) => (y(), ee(Md, {
      id: A(t),
      placement: "bottom-start",
      class: ue(`vc-date-picker-content vc-${A(a)} vc-${A(n)}`),
      ref_key: "popoverRef",
      ref: r,
      onBeforeShow: A(i),
      onAfterShow: A(o),
      onBeforeHide: A(u),
      onAfterHide: A(l)
    }, {
      default: N(() => [
        Z(e1, ra(Ma(s.$attrs)), null, 16)
      ]),
      _: 1
    }, 8, ["id", "class", "onBeforeShow", "onAfterShow", "onBeforeHide", "onAfterHide"]));
  }
}), $B = se({
  inheritAttrs: !1,
  emits: nB,
  props: aB,
  components: { DatePickerBase: e1, DatePickerPopover: kB },
  setup(e, t) {
    const a = rB(e, t), n = Ur(ym(a, "calendarRef", "popoverRef"));
    return { ...a, slotCtx: n };
  }
});
function SB(e, t, a, n, r, i) {
  const o = zt("DatePickerPopover"), u = zt("DatePickerBase");
  return e.$slots.default ? (y(), S(Ae, { key: 0 }, [
    j(e.$slots, "default", ra(Ma(e.slotCtx))),
    Z(o, ra(Ma(e.$attrs)), null, 16)
  ], 64)) : (y(), ee(u, ra(Fe({ key: 1 }, e.$attrs)), null, 16));
}
const TB = /* @__PURE__ */ Bn($B, [["render", SB]]), DB = { class: "calendar-wrapper" }, AB = {
  key: 0,
  class: "time-wrapper"
}, IB = { class: "time-input" }, EB = ["for"], MB = { key: 0 }, OB = { key: 1 }, xB = ["id"], PB = ["for"], NB = { key: 0 }, LB = ["id"], BB = {
  key: 0,
  class: "help-text"
}, RB = /* @__PURE__ */ se({
  __name: "CalendarWrapper",
  props: /* @__PURE__ */ Ql({
    isRange: { type: Boolean },
    kDatePickerMode: {},
    maxDate: { default: void 0 },
    minDate: { default: void 0 },
    errorMessage: { default: void 0 }
  }, {
    modelValue: { required: !0 },
    modelModifiers: {},
    error: { type: Boolean, default: !1 },
    errorModifiers: {}
  }),
  emits: ["update:modelValue", "update:error"],
  setup(e, { expose: t }) {
    const a = e, n = Zl(e, "modelValue"), r = Zl(e, "error"), i = L(Bt(/* @__PURE__ */ new Date(), "HH:mm:ss")), o = L(Bt(/* @__PURE__ */ new Date(), "HH:mm:ss")), u = L({
      start: Bt(/* @__PURE__ */ new Date(), "HH:mm:ss"),
      end: Bt(/* @__PURE__ */ new Date(), "HH:mm:ss")
    }), l = bt(), s = b(() => ["time", "dateTime", "relativeDateTime"].includes(a.kDatePickerMode)), d = (h, g) => h > g, c = () => {
      if (n.value && s.value)
        if (a.isRange && n.value.start && n.value.end) {
          const h = n.value;
          i.value = Bt(h.start, "HH:mm"), o.value = Bt(h.end, "HH:mm");
        } else n.value instanceof Date ? i.value = Bt(n.value, "HH:mm") : i.value = Bt(/* @__PURE__ */ new Date(), "HH:mm");
    };
    rt(() => {
      c(), u.value.start = i.value, u.value.end = o.value;
    });
    const f = { type: "number" }, v = {
      key: "select-drag",
      highlight: {
        start: { contentClass: "vcal-day-drag-start" },
        base: { contentClass: "vcal-day-drag-base" },
        end: { contentClass: "vcal-day-drag-end" }
      }
    }, m = {
      key: "select-calendar",
      highlight: {
        start: { contentClass: "vcal-day-start" },
        base: { contentClass: "vcal-day-base" },
        end: { contentClass: "vcal-day-end" }
      }
    };
    ne(() => i.value, (h) => {
      if (n.value && a.isRange && "start" in n.value && n.value.start instanceof Date && "end" in n.value && n.value.end instanceof Date) {
        const g = /* @__PURE__ */ new Date(), w = h.split(":");
        g.setHours(parseInt(w[0], 10), parseInt(w[1], 10), 0, 0), n.value.start.setHours(g.getHours(), g.getMinutes(), 0, 0), r.value = d(n.value.start, n.value.end);
      } else if (n.value instanceof Date) {
        const g = /* @__PURE__ */ new Date(), w = h.split(":");
        g.setHours(parseInt(w[0], 10), parseInt(w[1], 10), 0, 0), n.value.setHours(g.getHours(), g.getMinutes(), g.getSeconds(), 0);
      }
    }), ne(() => o.value, (h) => {
      if (n.value && a.isRange && "end" in n.value && n.value.end instanceof Date && "start" in n.value && n.value.start instanceof Date) {
        const g = /* @__PURE__ */ new Date(), w = h.split(":");
        g.setHours(parseInt(w[0], 10), parseInt(w[1], 10), 0, 0), n.value.end.setHours(g.getHours(), g.getMinutes(), 0, 0), r.value = d(n.value.start, n.value.end);
      }
    }), ne(() => n.value, () => {
      n.value && a.isRange && "start" in n.value && n.value.start instanceof Date && "end" in n.value && n.value.end instanceof Date ? (i.value = Bt(n.value.start, "HH:mm"), o.value = Bt(n.value.end, "HH:mm"), r.value = d(n.value.start, n.value.end)) : n.value instanceof Date && (i.value = Bt(n.value, "HH:mm"));
    }, { immediate: !0, deep: !0 });
    const C = (h) => {
      const g = n.value;
      return a.isRange && g && h in g && g[h] instanceof Date;
    };
    return t({
      resetTime: () => {
        i.value = u.value.start, o.value = u.value.end;
      },
      initTimeInputs: c
    }), (h, g) => (y(), S("div", DB, [
      Z(A(TB), {
        modelValue: n.value,
        "onUpdate:modelValue": g[0] || (g[0] = (w) => n.value = w),
        borderless: "",
        color: "blue",
        "drag-attribute": v,
        expanded: "",
        "is-range": h.isRange,
        "max-date": h.maxDate,
        "min-date": h.minDate,
        mode: "date",
        "model-config": f,
        "select-attribute": m,
        transparent: ""
      }, null, 8, ["modelValue", "is-range", "max-date", "min-date"]),
      s.value ? (y(), S("div", AB, [
        H("div", IB, [
          H("label", {
            class: "time-input-label",
            for: `time-input-start-${A(l)}`
          }, [
            C("start") ? (y(), S("span", MB, ae(A(Bt)(n.value.start, "EEE MMM d yyyy")), 1)) : n.value && n.value instanceof Date ? (y(), S("span", OB, ae(A(Bt)(n.value, "EEE MMM d yyyy")), 1)) : W("", !0)
          ], 8, EB),
          $a(H("input", {
            id: `time-input-start-${A(l)}`,
            "onUpdate:modelValue": g[1] || (g[1] = (w) => i.value = w),
            class: ue(["time-input-start", { "input-error": r.value }]),
            "data-testid": "time-input-start",
            step: 60,
            type: "time"
          }, null, 10, xB), [
            [Xl, i.value]
          ]),
          H("label", {
            class: "time-input-label",
            for: `time-input-end-${A(l)}`
          }, [
            C("end") ? (y(), S("span", NB, ae(A(Bt)(n.value.end, "EEE MMM d yyyy")), 1)) : W("", !0)
          ], 8, PB),
          h.isRange ? $a((y(), S("input", {
            key: 0,
            id: `time-input-end-${A(l)}`,
            "onUpdate:modelValue": g[2] || (g[2] = (w) => o.value = w),
            class: ue(["time-input-end", { "input-error": r.value }]),
            "data-testid": "time-input-end",
            step: 60,
            type: "time"
          }, null, 10, LB)), [
            [Xl, o.value]
          ]) : W("", !0)
        ]),
        Z(Zt, {
          mode: "out-in",
          name: "kongponents-fade-transition"
        }, {
          default: N(() => [
            r.value && h.errorMessage ? (y(), S("div", BB, ae(h.errorMessage), 1)) : W("", !0)
          ]),
          _: 1
        })
      ])) : W("", !0)
    ]));
  }
}), FB = /* @__PURE__ */ Me(RB, [["__scopeId", "data-v-cc332f3e"]]), zB = ["tabindex"], YB = ["innerHTML"], HB = {
  key: 1,
  class: "range-display"
}, qB = {
  key: 3,
  class: "relative-periods-container"
}, WB = { class: "timeframe-section-title" }, _B = { class: "timeframe-buttons" }, UB = { class: "datetime-picker-footer-container" }, VB = /* @__PURE__ */ se({
  __name: "KDateTimePicker",
  props: {
    clearButton: { type: Boolean },
    icon: { type: Boolean, default: !0 },
    modelValue: { default: () => ({ start: null, end: null }) },
    maxDate: { default: () => {
    } },
    minDate: { default: () => {
    } },
    mode: {},
    placeholder: { default: "Select a time range" },
    range: { type: Boolean },
    timePeriods: { default: () => [] },
    width: { default: "100%" },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    popoverPlacement: { default: "bottom-start" },
    invalidTimeErrorMessage: { default: "Start time cannot exceed end time." }
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: t }) {
    var k, P;
    const a = t, n = L(null), r = b(() => e.mode !== Fs.Relative), i = b(() => R1.includes(e.mode) && !e.range), o = b(() => e.timePeriods.length > 0), u = b(() => g.tabName === "custom" || !o.value), l = L(!0), s = L(!1), d = L(0), c = {
      start: null,
      end: null,
      timePeriodsKey: ""
    }, f = L(e.modelValue.start), v = L(e.modelValue || c), m = i.value ? f : v, C = mt("calendarWrapperRef"), p = b(() => ({
      width: Dt(e.width)
    })), h = Intl.DateTimeFormat().resolvedOptions().timeZone, g = Ur({
      abbreviatedDisplay: e.placeholder,
      fullRangeDisplay: "",
      popoverOpen: !1,
      selectedRange: { start: /* @__PURE__ */ new Date(), end: /* @__PURE__ */ new Date(), timePeriodsKey: "" },
      previouslySelectedRange: { start: /* @__PURE__ */ new Date(), end: /* @__PURE__ */ new Date(), timePeriodsKey: "" },
      selectedTimeframe: (k = e.timePeriods[0]) == null ? void 0 : k.values[0],
      previouslySelectedTimeframe: (P = e.timePeriods[0]) == null ? void 0 : P.values[0],
      tabName: "relative"
    }), w = (D) => {
      if (!D) return;
      const B = i.value ? !D.start : !D.start || !D.end, J = (D == null ? void 0 : D.start) || /* @__PURE__ */ new Date(), _ = (D == null ? void 0 : D.end) || null;
      l.value = !!B, !i.value && D && D.start && D.end ? (v.value.start = J, v.value.end = _) : D && D.start && (f.value = J), g.selectedRange = g.previouslySelectedRange = {
        start: J,
        end: _,
        timePeriodsKey: ""
      };
    }, $ = (D, B = !1) => {
      g.selectedTimeframe = g.previouslySelectedTimeframe = D;
      const J = g.selectedTimeframe.start(), _ = g.selectedTimeframe.end();
      g.selectedRange = {
        start: new Date(J),
        end: new Date(_),
        timePeriodsKey: g.selectedTimeframe.key
      }, g.fullRangeDisplay = O(g.selectedRange, !1), l.value = !1, B && M();
    }, T = () => {
      var D;
      v.value = c, f.value = null, g.abbreviatedDisplay = e.placeholder, g.fullRangeDisplay = "", o.value && (g.selectedTimeframe = (D = e.timePeriods[0]) == null ? void 0 : D.values[0]), g.selectedRange = g.previouslySelectedRange = c, a("change", g.selectedRange), a("update:modelValue", g.selectedRange);
    }, O = (D, B) => {
      const { start: J, end: _ } = D;
      let te = "PP hh:mm a";
      const G = Al(J, h, "(z)");
      return !r.value && o.value ? te = "PP hh:mm a" : z1.includes(e.mode) && (te = "PP"), i.value ? `${Bt(J, te)} ${G}` : B ? `<div>${Bt(J, te)} -&nbsp;</div><div>${Al(_, h, te)} ${G}</div>` : `${Bt(J, te)} - ${Al(_, h, te)} ${G}`;
    }, M = async () => {
      var D;
      i.value ? (a("change", { start: g.selectedRange.start, end: null }), a("update:modelValue", { start: g.selectedRange.start, end: null })) : (a("change", g.selectedRange), a("update:modelValue", g.selectedRange)), (D = n.value) == null || D.hidePopover(), F();
    }, F = () => {
      var D;
      u.value && ((D = g.selectedRange) != null && D.start) ? g.abbreviatedDisplay = O(g.selectedRange, !0) : o.value && !u.value && (g.abbreviatedDisplay = g.selectedTimeframe.display);
    }, q = (D) => D.charAt(0).toUpperCase() + D.slice(1), x = (D) => g.selectedTimeframe.key === D.key ? "primary" : "secondary";
    ne(f, (D, B) => {
      D !== void 0 && D !== B && w({ start: D, end: null });
    }, { immediate: !0 }), ne(v, (D, B) => {
      D !== void 0 && D !== B && w(D);
    }, { immediate: !0 }), ne(() => g.tabName, (D, B) => {
      B !== void 0 && D === "relative" ? $(g.previouslySelectedTimeframe) : B !== void 0 && D === "custom" && w(g.previouslySelectedRange);
    }), ne(() => e.modelValue, () => {
      if (F1.includes(e.mode) && e.modelValue.timePeriodsKey) {
        g.tabName = "relative", l.value = !1;
        for (const D of e.timePeriods) {
          const B = D.values.find((J) => J.key === e.modelValue.timePeriodsKey);
          if (B) {
            $(B), F();
            break;
          }
        }
      } else
        g.tabName = "custom", w(e.modelValue), (e.modelValue.start && e.modelValue.end || i.value && e.modelValue.start) && F();
      d.value++;
    }, { immediate: !0 });
    const Y = () => {
      g.popoverOpen = !1, C.value && C.value.resetTime();
    }, R = () => {
      g.popoverOpen = !0, C.value && C.value.initTimeInputs();
    };
    return (D, B) => (y(), S("div", {
      class: ue(["k-datetime-picker", { "set-min-width": o.value }]),
      style: Ee(p.value)
    }, [
      Z(ir, {
        ref_key: "kPop",
        ref: n,
        disabled: D.disabled || D.readonly,
        "hide-caret": "",
        "hide-close-icon": "",
        placement: D.popoverPlacement,
        width: "auto",
        onClose: Y,
        onOpen: R
      }, {
        content: N(() => [
          o.value && r.value ? (y(), ee(Tg, {
            key: 0,
            modelValue: g.tabName,
            "onUpdate:modelValue": B[0] || (B[0] = (J) => g.tabName = J),
            class: "datetime-picker-toggle",
            "data-testid": "datetime-picker-toggle",
            options: [
              { label: "Relative", value: "relative" },
              { label: "Custom", value: "custom" }
            ],
            onClick: B[1] || (B[1] = (J) => g.tabName = J)
          }, null, 8, ["modelValue"])) : W("", !0),
          u.value ? W("", !0) : (y(), S("p", HB, ae(g.fullRangeDisplay), 1)),
          r.value && u.value ? (y(), ee(FB, {
            key: d.value,
            ref_key: "calendarWrapperRef",
            ref: C,
            modelValue: A(m),
            "onUpdate:modelValue": B[2] || (B[2] = (J) => wr(m) ? m.value = J : null),
            error: s.value,
            "onUpdate:error": B[3] || (B[3] = (J) => s.value = J),
            "error-message": D.invalidTimeErrorMessage,
            "is-range": !i.value,
            "k-date-picker-mode": D.mode,
            "max-date": D.maxDate,
            "min-date": D.minDate
          }, null, 8, ["modelValue", "error", "error-message", "is-range", "k-date-picker-mode", "max-date", "min-date"])) : o.value && !i.value ? (y(), S("div", qB, [
            (y(!0), S(Ae, null, Le(D.timePeriods, (J, _) => (y(), S("div", {
              key: `section-${String(J.section || _)}`,
              class: "timeframe-section"
            }, [
              H("div", WB, ae(J.section), 1),
              H("div", _B, [
                (y(!0), S(Ae, null, Le(J.values, (te, G) => (y(), ee(nt, {
                  key: `time-${G}`,
                  appearance: x(te),
                  class: "timeframe-button",
                  "data-testid": `select-timeframe-${te.timeframeLength()}`,
                  onClick: (pe) => $(te, !0)
                }, {
                  default: N(() => [
                    be(ae(q(te.timeframeText)), 1)
                  ]),
                  _: 2
                }, 1032, ["appearance", "data-testid", "onClick"]))), 128))
              ])
            ]))), 128))
          ])) : W("", !0)
        ]),
        footer: N(() => [
          H("div", UB, [
            D.clearButton ? (y(), ee(nt, {
              key: 0,
              appearance: "tertiary",
              class: "action-button",
              "data-testid": "datetime-picker-clear",
              onClick: B[4] || (B[4] = (J) => T())
            }, {
              default: N(() => B[6] || (B[6] = [
                be(" Clear ")
              ])),
              _: 1,
              __: [6]
            })) : W("", !0),
            u.value ? (y(), ee(nt, {
              key: 1,
              appearance: "tertiary",
              class: "action-button",
              "data-testid": "datetime-picker-submit",
              disabled: l.value || s.value,
              onClick: B[5] || (B[5] = (J) => M())
            }, {
              default: N(() => B[7] || (B[7] = [
                be(" Apply ")
              ])),
              _: 1,
              __: [7]
            }, 8, ["disabled"])) : W("", !0)
          ])
        ]),
        default: N(() => [
          H("div", {
            class: ue(["datetime-picker-trigger-wrapper", { disabled: D.disabled }])
          }, [
            H("div", {
              class: ue(["datetime-picker-trigger", { disabled: D.disabled, readonly: D.readonly }]),
              "data-testid": "datetime-picker-trigger",
              role: "button",
              style: Ee(p.value),
              tabindex: D.disabled ? -1 : 0
            }, [
              H("div", {
                class: ue(["datetime-picker-display", { "has-icon": D.icon, disabled: D.disabled }]),
                "data-testid": "datetime-picker-display",
                innerHTML: g.abbreviatedDisplay
              }, null, 10, YB)
            ], 14, zB),
            D.icon ? (y(), ee(A(V1), {
              key: 0,
              class: "calendar-icon",
              color: `var(--kui-color-text-neutral, ${A(Fa)})`,
              decorative: "",
              size: A(Vt)
            }, null, 8, ["color", "size"])) : W("", !0)
          ], 2)
        ]),
        _: 1
      }, 8, ["disabled", "placement"])
    ], 6));
  }
}), KB = /* @__PURE__ */ Me(VB, [["__scopeId", "data-v-8c1ff6b5"]]), jB = { class: "file-upload-input-wrapper" }, GB = /* @__PURE__ */ se({
  inheritAttrs: !1,
  __name: "KFileUpload",
  props: {
    labelAttributes: { default: () => ({}) },
    label: { default: "" },
    help: {},
    buttonText: { default: "Select file" },
    placeholder: { default: "No file selected" },
    accept: {},
    maxFileSize: { default: null },
    error: { type: Boolean },
    errorMessage: { default: "" },
    disabled: { type: Boolean }
  },
  emits: ["file-added", "file-removed", "error"],
  setup(e, { emit: t }) {
    const a = t, n = Tt(), r = ea(), { stripRequiredLabel: i } = Nn(), o = bt(), u = b(() => r.id ? String(r.id) : o), l = b(() => {
      const M = { ...r };
      return delete M.id, M;
    }), s = mt("input"), d = b(() => {
      var M;
      return !!((M = e.labelAttributes) != null && M.info || n["label-tooltip"]);
    }), c = b(() => i(e.label, f.value)), f = b(() => (r == null ? void 0 : r.required) !== void 0 && String(r == null ? void 0 : r.required) !== "false"), v = L(!1), m = b(() => {
      if (v.value) {
        let M = "bytes", F = C.value;
        return C.value >= 1024 && C.value < 1024 * 1024 && (F = C.value / 1024, M = "KB"), C.value >= 1024 * 1024 && (F = C.value / (1024 * 1024), M = "MB"), `File size must be less than ${F}${M}.`;
      }
      return "";
    }), C = b(() => e.maxFileSize || e.maxFileSize === 0 ? e.maxFileSize : 5 * 1024 * 1024), p = b(() => v.value || e.error), h = L(0), g = L(""), w = L(null), $ = (M) => {
      var Y, R, k, P, D;
      const F = M.target.files, q = (Y = F[0]) == null ? void 0 : Y.size;
      Number(q) > C.value && (h.value++, v.value = !0, a("error", F));
      const x = (k = (R = s.value) == null ? void 0 : R.$el) == null ? void 0 : k.querySelector("input");
      F.length ? (w.value = F, g.value = F[0].name || "", a("file-added", F)) : (x.files = w.value, g.value = ((D = (P = w.value) == null ? void 0 : P[0]) == null ? void 0 : D.name) || "");
    }, T = () => {
      var F, q;
      if (g.value) {
        O();
        return;
      }
      const M = (q = (F = s.value) == null ? void 0 : F.$el) == null ? void 0 : q.querySelector("input");
      M && M.click();
    }, O = () => {
      w.value = null, g.value = "", h.value++, v.value = !1, a("file-removed");
    };
    return ne(() => r.id, () => {
      h.value++;
    }, { immediate: !0 }), (M, F) => (y(), S("div", Fe({ class: "k-file-upload" }, l.value), [
      M.label ? (y(), ee(_a, Fe({ key: 0 }, M.labelAttributes, {
        for: u.value,
        required: f.value
      }), yt({
        default: N(() => [
          be(ae(c.value) + " ", 1)
        ]),
        _: 2
      }, [
        d.value ? {
          name: "tooltip",
          fn: N(() => [
            j(M.$slots, "label-tooltip", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["for", "required"])) : W("", !0),
      H("div", jB, [
        (y(), S("span", {
          key: h.value,
          class: ue(["file-upload-input-text", { placeholder: !g.value, "has-icon": M.$slots.icon, disabled: M.disabled }])
        }, ae(g.value ? g.value : M.placeholder), 3)),
        (y(), ee(xn, {
          id: u.value,
          key: h.value,
          ref: "input",
          accept: M.accept,
          class: "upload-input",
          disabled: M.disabled,
          error: p.value,
          "error-message": M.errorMessage || m.value,
          help: M.help,
          placeholder: M.placeholder,
          title: "",
          type: "file",
          onChange: $
        }, yt({
          after: N(() => [
            Z(nt, {
              appearance: "tertiary",
              class: "file-upload-button",
              "data-testid": "file-upload-button",
              disabled: M.disabled,
              size: "small",
              onClick: T
            }, {
              default: N(() => [
                be(ae(g.value ? "Clear" : M.buttonText), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 2
        }, [
          M.$slots.icon ? {
            name: "before",
            fn: N(() => [
              j(M.$slots, "icon", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["id", "accept", "disabled", "error", "error-message", "help", "placeholder"]))
      ])
    ], 16));
  }
}), QB = /* @__PURE__ */ Me(GB, [["__scopeId", "data-v-c42b9bb1"]]), ZB = ["id", "checked", "disabled"], XB = ["aria-checked", "aria-labelledby", "tabindex"], JB = {
  inheritAttrs: !1
}, eR = /* @__PURE__ */ se({
  ...JB,
  __name: "KInputSwitch",
  props: {
    modelValue: { type: Boolean },
    size: { default: "small" },
    label: { default: "" },
    disabled: { type: Boolean },
    disabledTooltipText: { default: "" },
    tooltipAttributes: { default: () => ({}) },
    labelBefore: { type: Boolean }
  },
  emits: ["change", "input", "update:modelValue"],
  setup(e, { emit: t }) {
    const a = t, n = ea(), r = L(null), i = bt(), o = b(() => n.id ? String(n.id) : i), u = b(() => {
      if (e.disabled !== void 0 && e.disabled !== !1)
        return n;
      const d = Object.assign({}, n);
      return delete d.class, delete d.disabled, d;
    }), l = (d) => {
      var c;
      e.disabled || (d.type === "click" || d.type === "keyup" && d.code === "Space") && ((c = r.value) == null || c.click());
    }, s = (d) => {
      e.modelValue !== d.target.checked && (a("update:modelValue", d.target.checked), a("change", d.target.checked), a("input", d.target.checked));
    };
    return (d, c) => {
      const f = zt("KTooltip"), v = zt("KLabel");
      return y(), S("div", {
        class: ue(["k-input-switch", [d.size, { "label-before": d.labelBefore, disabled: d.disabled }, d.$attrs.class]])
      }, [
        H("input", Fe(u.value, {
          id: o.value,
          ref_key: "switchInputElement",
          ref: r,
          checked: d.modelValue,
          disabled: d.disabled,
          tabindex: "-1",
          type: "checkbox",
          onInput: s
        }), null, 16, ZB),
        Z(f, Fe(d.disabled && d.disabledTooltipText ? d.tooltipAttributes : {}, {
          class: "switch-control-wrapper",
          text: d.disabled ? d.disabledTooltipText : ""
        }), {
          default: N(() => [
            H("span", {
              "aria-checked": d.modelValue,
              "aria-labelledby": o.value,
              class: ue(["switch-control", { checked: d.modelValue, disabled: d.disabled }]),
              "data-testid": "switch-control",
              role: "checkbox",
              tabindex: d.disabled ? -1 : 0,
              onClick: l,
              onKeydown: c[0] || (c[0] = lt(Ke(() => {
              }, ["prevent"]), ["space"])),
              onKeyup: lt(l, ["space"])
            }, c[1] || (c[1] = [
              H("span", { class: "switch-control-enabled-bar" }, null, -1)
            ]), 42, XB)
          ]),
          _: 1
        }, 16, ["text"]),
        d.label || d.$slots.label ? (y(), ee(v, {
          key: 0,
          for: o.value
        }, {
          default: N(() => [
            j(d.$slots, "label", {}, () => [
              be(ae(d.label), 1)
            ], !0)
          ]),
          _: 3
        }, 8, ["for"])) : W("", !0)
      ], 2);
    };
  }
}), tR = /* @__PURE__ */ Me(eR, [["__scopeId", "data-v-5e43199b"]]);
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var t1 = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], As = /* @__PURE__ */ t1.join(","), a1 = typeof Element > "u", nr = a1 ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Is = !a1 && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Es = function e(t, a) {
  var n;
  a === void 0 && (a = !0);
  var r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "inert"), i = r === "" || r === "true", o = i || a && t && e(t.parentNode);
  return o;
}, aR = function(t) {
  var a, n = t == null || (a = t.getAttribute) === null || a === void 0 ? void 0 : a.call(t, "contenteditable");
  return n === "" || n === "true";
}, n1 = function(t, a, n) {
  if (Es(t))
    return [];
  var r = Array.prototype.slice.apply(t.querySelectorAll(As));
  return a && nr.call(t, As) && r.unshift(t), r = r.filter(n), r;
}, r1 = function e(t, a, n) {
  for (var r = [], i = Array.from(t); i.length; ) {
    var o = i.shift();
    if (!Es(o, !1))
      if (o.tagName === "SLOT") {
        var u = o.assignedElements(), l = u.length ? u : o.children, s = e(l, !0, n);
        n.flatten ? r.push.apply(r, s) : r.push({
          scopeParent: o,
          candidates: s
        });
      } else {
        var d = nr.call(o, As);
        d && n.filter(o) && (a || !t.includes(o)) && r.push(o);
        var c = o.shadowRoot || // check for an undisclosed shadow
        typeof n.getShadowRoot == "function" && n.getShadowRoot(o), f = !Es(c, !1) && (!n.shadowRootFilter || n.shadowRootFilter(o));
        if (c && f) {
          var v = e(c === !0 ? o.children : c.children, !0, n);
          n.flatten ? r.push.apply(r, v) : r.push({
            scopeParent: o,
            candidates: v
          });
        } else
          i.unshift.apply(i, o.children);
      }
  }
  return r;
}, i1 = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Wn = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || aR(t)) && !i1(t) ? 0 : t.tabIndex;
}, nR = function(t, a) {
  var n = Wn(t);
  return n < 0 && a && !i1(t) ? 0 : n;
}, rR = function(t, a) {
  return t.tabIndex === a.tabIndex ? t.documentOrder - a.documentOrder : t.tabIndex - a.tabIndex;
}, o1 = function(t) {
  return t.tagName === "INPUT";
}, iR = function(t) {
  return o1(t) && t.type === "hidden";
}, oR = function(t) {
  var a = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
  return a;
}, sR = function(t, a) {
  for (var n = 0; n < t.length; n++)
    if (t[n].checked && t[n].form === a)
      return t[n];
}, lR = function(t) {
  if (!t.name)
    return !0;
  var a = t.form || Is(t), n = function(u) {
    return a.querySelectorAll('input[type="radio"][name="' + u + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    r = n(window.CSS.escape(t.name));
  else
    try {
      r = n(t.name);
    } catch (o) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
    }
  var i = sR(r, t.form);
  return !i || i === t;
}, uR = function(t) {
  return o1(t) && t.type === "radio";
}, dR = function(t) {
  return uR(t) && !lR(t);
}, cR = function(t) {
  var a, n = t && Is(t), r = (a = n) === null || a === void 0 ? void 0 : a.host, i = !1;
  if (n && n !== t) {
    var o, u, l;
    for (i = !!((o = r) !== null && o !== void 0 && (u = o.ownerDocument) !== null && u !== void 0 && u.contains(r) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && r; ) {
      var s, d, c;
      n = Is(r), r = (s = n) === null || s === void 0 ? void 0 : s.host, i = !!((d = r) !== null && d !== void 0 && (c = d.ownerDocument) !== null && c !== void 0 && c.contains(r));
    }
  }
  return i;
}, Tp = function(t) {
  var a = t.getBoundingClientRect(), n = a.width, r = a.height;
  return n === 0 && r === 0;
}, fR = function(t, a) {
  var n = a.displayCheck, r = a.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = nr.call(t, "details>summary:first-of-type"), o = i ? t.parentElement : t;
  if (nr.call(o, "details:not([open]) *"))
    return !0;
  if (!n || n === "full" || n === "legacy-full") {
    if (typeof r == "function") {
      for (var u = t; t; ) {
        var l = t.parentElement, s = Is(t);
        if (l && !l.shadowRoot && r(l) === !0)
          return Tp(t);
        t.assignedSlot ? t = t.assignedSlot : !l && s !== t.ownerDocument ? t = s.host : t = l;
      }
      t = u;
    }
    if (cR(t))
      return !t.getClientRects().length;
    if (n !== "legacy-full")
      return !0;
  } else if (n === "non-zero-area")
    return Tp(t);
  return !1;
}, vR = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var a = t.parentElement; a; ) {
      if (a.tagName === "FIELDSET" && a.disabled) {
        for (var n = 0; n < a.children.length; n++) {
          var r = a.children.item(n);
          if (r.tagName === "LEGEND")
            return nr.call(a, "fieldset[disabled] *") ? !0 : !r.contains(t);
        }
        return !0;
      }
      a = a.parentElement;
    }
  return !1;
}, Ms = function(t, a) {
  return !(a.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Es(a) || iR(a) || fR(a, t) || // For a details element with a summary, the summary element gets the focus
  oR(a) || vR(a));
}, Cu = function(t, a) {
  return !(dR(a) || Wn(a) < 0 || !Ms(t, a));
}, pR = function(t) {
  var a = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(a) || a >= 0);
}, hR = function e(t) {
  var a = [], n = [];
  return t.forEach(function(r, i) {
    var o = !!r.scopeParent, u = o ? r.scopeParent : r, l = nR(u, o), s = o ? e(r.candidates) : u;
    l === 0 ? o ? a.push.apply(a, s) : a.push(u) : n.push({
      documentOrder: i,
      tabIndex: l,
      item: r,
      isScope: o,
      content: s
    });
  }), n.sort(rR).reduce(function(r, i) {
    return i.isScope ? r.push.apply(r, i.content) : r.push(i.content), r;
  }, []).concat(a);
}, gR = function(t, a) {
  a = a || {};
  var n;
  return a.getShadowRoot ? n = r1([t], a.includeContainer, {
    filter: Cu.bind(null, a),
    flatten: !1,
    getShadowRoot: a.getShadowRoot,
    shadowRootFilter: pR
  }) : n = n1(t, a.includeContainer, Cu.bind(null, a)), hR(n);
}, mR = function(t, a) {
  a = a || {};
  var n;
  return a.getShadowRoot ? n = r1([t], a.includeContainer, {
    filter: Ms.bind(null, a),
    flatten: !0,
    getShadowRoot: a.getShadowRoot
  }) : n = n1(t, a.includeContainer, Ms.bind(null, a)), n;
}, mr = function(t, a) {
  if (a = a || {}, !t)
    throw new Error("No node provided");
  return nr.call(t, As) === !1 ? !1 : Cu(a, t);
}, yR = /* @__PURE__ */ t1.concat("iframe").join(","), Bl = function(t, a) {
  if (a = a || {}, !t)
    throw new Error("No node provided");
  return nr.call(t, yR) === !1 ? !1 : Ms(a, t);
};
/*!
* focus-trap 7.6.5
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function ku(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var a = 0, n = Array(t); a < t; a++) n[a] = e[a];
  return n;
}
function bR(e) {
  if (Array.isArray(e)) return ku(e);
}
function wR(e, t, a) {
  return (t = TR(t)) in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}
function CR(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function kR() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Dp(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), a.push.apply(a, n);
  }
  return a;
}
function Ap(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Dp(Object(a), !0).forEach(function(n) {
      wR(e, n, a[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : Dp(Object(a)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(a, n));
    });
  }
  return e;
}
function $R(e) {
  return bR(e) || CR(e) || DR(e) || kR();
}
function SR(e, t) {
  if (typeof e != "object" || !e) return e;
  var a = e[Symbol.toPrimitive];
  if (a !== void 0) {
    var n = a.call(e, t);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function TR(e) {
  var t = SR(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function DR(e, t) {
  if (e) {
    if (typeof e == "string") return ku(e, t);
    var a = {}.toString.call(e).slice(8, -1);
    return a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set" ? Array.from(e) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? ku(e, t) : void 0;
  }
}
var Ip = {
  activateTrap: function(t, a) {
    if (t.length > 0) {
      var n = t[t.length - 1];
      n !== a && n._setPausedState(!0);
    }
    var r = t.indexOf(a);
    r === -1 || t.splice(r, 1), t.push(a);
  },
  deactivateTrap: function(t, a) {
    var n = t.indexOf(a);
    n !== -1 && t.splice(n, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, AR = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, IR = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, Ci = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, ER = function(t) {
  return Ci(t) && !t.shiftKey;
}, MR = function(t) {
  return Ci(t) && t.shiftKey;
}, Ep = function(t) {
  return setTimeout(t, 0);
}, ci = function(t) {
  for (var a = arguments.length, n = new Array(a > 1 ? a - 1 : 0), r = 1; r < a; r++)
    n[r - 1] = arguments[r];
  return typeof t == "function" ? t.apply(void 0, n) : t;
}, Lo = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, OR = [], xR = function(t, a) {
  var n = (a == null ? void 0 : a.document) || document, r = (a == null ? void 0 : a.trapStack) || OR, i = Ap({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: ER,
    isKeyBackward: MR
  }, a), o = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, u, l = function(k, P, D) {
    return k && k[P] !== void 0 ? k[P] : i[D || P];
  }, s = function(k, P) {
    var D = typeof (P == null ? void 0 : P.composedPath) == "function" ? P.composedPath() : void 0;
    return o.containerGroups.findIndex(function(B) {
      var J = B.container, _ = B.tabbableNodes;
      return J.contains(k) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (D == null ? void 0 : D.includes(J)) || _.find(function(te) {
        return te === k;
      });
    });
  }, d = function(k) {
    var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, D = P.hasFallback, B = D === void 0 ? !1 : D, J = P.params, _ = J === void 0 ? [] : J, te = i[k];
    if (typeof te == "function" && (te = te.apply(void 0, $R(_))), te === !0 && (te = void 0), !te) {
      if (te === void 0 || te === !1)
        return te;
      throw new Error("`".concat(k, "` was specified but was not a node, or did not return a node"));
    }
    var G = te;
    if (typeof te == "string") {
      try {
        G = n.querySelector(te);
      } catch (pe) {
        throw new Error("`".concat(k, '` appears to be an invalid selector; error="').concat(pe.message, '"'));
      }
      if (!G && !B)
        throw new Error("`".concat(k, "` as selector refers to no known node"));
    }
    return G;
  }, c = function() {
    var k = d("initialFocus", {
      hasFallback: !0
    });
    if (k === !1)
      return !1;
    if (k === void 0 || k && !Bl(k, i.tabbableOptions))
      if (s(n.activeElement) >= 0)
        k = n.activeElement;
      else {
        var P = o.tabbableGroups[0], D = P && P.firstTabbableNode;
        k = D || d("fallbackFocus");
      }
    else k === null && (k = d("fallbackFocus"));
    if (!k)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return k;
  }, f = function() {
    if (o.containerGroups = o.containers.map(function(k) {
      var P = gR(k, i.tabbableOptions), D = mR(k, i.tabbableOptions), B = P.length > 0 ? P[0] : void 0, J = P.length > 0 ? P[P.length - 1] : void 0, _ = D.find(function(pe) {
        return mr(pe);
      }), te = D.slice().reverse().find(function(pe) {
        return mr(pe);
      }), G = !!P.find(function(pe) {
        return Wn(pe) > 0;
      });
      return {
        container: k,
        tabbableNodes: P,
        focusableNodes: D,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: G,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: B,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: J,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: _,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: te,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(ce) {
          var $e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, ge = P.indexOf(ce);
          return ge < 0 ? $e ? D.slice(D.indexOf(ce) + 1).find(function(Se) {
            return mr(Se);
          }) : D.slice(0, D.indexOf(ce)).reverse().find(function(Se) {
            return mr(Se);
          }) : P[ge + ($e ? 1 : -1)];
        }
      };
    }), o.tabbableGroups = o.containerGroups.filter(function(k) {
      return k.tabbableNodes.length > 0;
    }), o.tabbableGroups.length <= 0 && !d("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (o.containerGroups.find(function(k) {
      return k.posTabIndexesFound;
    }) && o.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, v = function(k) {
    var P = k.activeElement;
    if (P)
      return P.shadowRoot && P.shadowRoot.activeElement !== null ? v(P.shadowRoot) : P;
  }, m = function(k) {
    if (k !== !1 && k !== v(document)) {
      if (!k || !k.focus) {
        m(c());
        return;
      }
      k.focus({
        preventScroll: !!i.preventScroll
      }), o.mostRecentlyFocusedNode = k, AR(k) && k.select();
    }
  }, C = function(k) {
    var P = d("setReturnFocus", {
      params: [k]
    });
    return P || (P === !1 ? !1 : k);
  }, p = function(k) {
    var P = k.target, D = k.event, B = k.isBackward, J = B === void 0 ? !1 : B;
    P = P || Lo(D), f();
    var _ = null;
    if (o.tabbableGroups.length > 0) {
      var te = s(P, D), G = te >= 0 ? o.containerGroups[te] : void 0;
      if (te < 0)
        J ? _ = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : _ = o.tabbableGroups[0].firstTabbableNode;
      else if (J) {
        var pe = o.tabbableGroups.findIndex(function(Ne) {
          var He = Ne.firstTabbableNode;
          return P === He;
        });
        if (pe < 0 && (G.container === P || Bl(P, i.tabbableOptions) && !mr(P, i.tabbableOptions) && !G.nextTabbableNode(P, !1)) && (pe = te), pe >= 0) {
          var ce = pe === 0 ? o.tabbableGroups.length - 1 : pe - 1, $e = o.tabbableGroups[ce];
          _ = Wn(P) >= 0 ? $e.lastTabbableNode : $e.lastDomTabbableNode;
        } else Ci(D) || (_ = G.nextTabbableNode(P, !1));
      } else {
        var ge = o.tabbableGroups.findIndex(function(Ne) {
          var He = Ne.lastTabbableNode;
          return P === He;
        });
        if (ge < 0 && (G.container === P || Bl(P, i.tabbableOptions) && !mr(P, i.tabbableOptions) && !G.nextTabbableNode(P)) && (ge = te), ge >= 0) {
          var Se = ge === o.tabbableGroups.length - 1 ? 0 : ge + 1, Ue = o.tabbableGroups[Se];
          _ = Wn(P) >= 0 ? Ue.firstTabbableNode : Ue.firstDomTabbableNode;
        } else Ci(D) || (_ = G.nextTabbableNode(P));
      }
    } else
      _ = d("fallbackFocus");
    return _;
  }, h = function(k) {
    var P = Lo(k);
    if (!(s(P, k) >= 0)) {
      if (ci(i.clickOutsideDeactivates, k)) {
        u.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      ci(i.allowOutsideClick, k) || k.preventDefault();
    }
  }, g = function(k) {
    var P = Lo(k), D = s(P, k) >= 0;
    if (D || P instanceof Document)
      D && (o.mostRecentlyFocusedNode = P);
    else {
      k.stopImmediatePropagation();
      var B, J = !0;
      if (o.mostRecentlyFocusedNode)
        if (Wn(o.mostRecentlyFocusedNode) > 0) {
          var _ = s(o.mostRecentlyFocusedNode), te = o.containerGroups[_].tabbableNodes;
          if (te.length > 0) {
            var G = te.findIndex(function(pe) {
              return pe === o.mostRecentlyFocusedNode;
            });
            G >= 0 && (i.isKeyForward(o.recentNavEvent) ? G + 1 < te.length && (B = te[G + 1], J = !1) : G - 1 >= 0 && (B = te[G - 1], J = !1));
          }
        } else
          o.containerGroups.some(function(pe) {
            return pe.tabbableNodes.some(function(ce) {
              return Wn(ce) > 0;
            });
          }) || (J = !1);
      else
        J = !1;
      J && (B = p({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: o.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(o.recentNavEvent)
      })), m(B || o.mostRecentlyFocusedNode || c());
    }
    o.recentNavEvent = void 0;
  }, w = function(k) {
    var P = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    o.recentNavEvent = k;
    var D = p({
      event: k,
      isBackward: P
    });
    D && (Ci(k) && k.preventDefault(), m(D));
  }, $ = function(k) {
    (i.isKeyForward(k) || i.isKeyBackward(k)) && w(k, i.isKeyBackward(k));
  }, T = function(k) {
    IR(k) && ci(i.escapeDeactivates, k) !== !1 && (k.preventDefault(), u.deactivate());
  }, O = function(k) {
    var P = Lo(k);
    s(P, k) >= 0 || ci(i.clickOutsideDeactivates, k) || ci(i.allowOutsideClick, k) || (k.preventDefault(), k.stopImmediatePropagation());
  }, M = function() {
    if (o.active)
      return Ip.activateTrap(r, u), o.delayInitialFocusTimer = i.delayInitialFocus ? Ep(function() {
        m(c());
      }) : m(c()), n.addEventListener("focusin", g, !0), n.addEventListener("mousedown", h, {
        capture: !0,
        passive: !1
      }), n.addEventListener("touchstart", h, {
        capture: !0,
        passive: !1
      }), n.addEventListener("click", O, {
        capture: !0,
        passive: !1
      }), n.addEventListener("keydown", $, {
        capture: !0,
        passive: !1
      }), n.addEventListener("keydown", T), u;
  }, F = function() {
    if (o.active)
      return n.removeEventListener("focusin", g, !0), n.removeEventListener("mousedown", h, !0), n.removeEventListener("touchstart", h, !0), n.removeEventListener("click", O, !0), n.removeEventListener("keydown", $, !0), n.removeEventListener("keydown", T), u;
  }, q = function(k) {
    var P = k.some(function(D) {
      var B = Array.from(D.removedNodes);
      return B.some(function(J) {
        return J === o.mostRecentlyFocusedNode;
      });
    });
    P && m(c());
  }, x = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(q) : void 0, Y = function() {
    x && (x.disconnect(), o.active && !o.paused && o.containers.map(function(k) {
      x.observe(k, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return u = {
    get active() {
      return o.active;
    },
    get paused() {
      return o.paused;
    },
    activate: function(k) {
      if (o.active)
        return this;
      var P = l(k, "onActivate"), D = l(k, "onPostActivate"), B = l(k, "checkCanFocusTrap");
      B || f(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = v(n), P == null || P();
      var J = function() {
        B && f(), M(), Y(), D == null || D();
      };
      return B ? (B(o.containers.concat()).then(J, J), this) : (J(), this);
    },
    deactivate: function(k) {
      if (!o.active)
        return this;
      var P = Ap({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, k);
      clearTimeout(o.delayInitialFocusTimer), o.delayInitialFocusTimer = void 0, F(), o.active = !1, o.paused = !1, Y(), Ip.deactivateTrap(r, u);
      var D = l(P, "onDeactivate"), B = l(P, "onPostDeactivate"), J = l(P, "checkCanReturnFocus"), _ = l(P, "returnFocus", "returnFocusOnDeactivate");
      D == null || D();
      var te = function() {
        Ep(function() {
          _ && m(C(o.nodeFocusedBeforeActivation)), B == null || B();
        });
      };
      return _ && J ? (J(C(o.nodeFocusedBeforeActivation)).then(te, te), this) : (te(), this);
    },
    pause: function(k) {
      return o.active ? (o.manuallyPaused = !0, this._setPausedState(!0, k)) : this;
    },
    unpause: function(k) {
      return o.active ? (o.manuallyPaused = !1, r[r.length - 1] !== this ? this : this._setPausedState(!1, k)) : this;
    },
    updateContainerElements: function(k) {
      var P = [].concat(k).filter(Boolean);
      return o.containers = P.map(function(D) {
        return typeof D == "string" ? n.querySelector(D) : D;
      }), o.active && f(), Y(), this;
    }
  }, Object.defineProperties(u, {
    _isManuallyPaused: {
      value: function() {
        return o.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(k, P) {
        if (o.paused === k)
          return this;
        if (o.paused = k, k) {
          var D = l(P, "onPause"), B = l(P, "onPostPause");
          D == null || D(), F(), Y(), B == null || B();
        } else {
          var J = l(P, "onUnpause"), _ = l(P, "onPostUnpause");
          J == null || J(), f(), M(), Y(), _ == null || _();
        }
        return this;
      }
    }
  }), u.updateContainerElements(t), u;
};
/*!
  * focus-trap-vue v4.0.2
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
const PR = {
  escapeDeactivates: {
    type: Boolean,
    default: !0
  },
  returnFocusOnDeactivate: {
    type: Boolean,
    default: !0
  },
  allowOutsideClick: {
    type: [Boolean, Function],
    default: !0
  },
  clickOutsideDeactivates: [Boolean, Function],
  initialFocus: [String, Function, Boolean],
  fallbackFocus: [String, Function],
  checkCanFocusTrap: Function,
  checkCanReturnFocus: Function,
  delayInitialFocus: {
    type: Boolean,
    default: !0
  },
  document: Object,
  preventScroll: Boolean,
  setReturnFocus: [Object, String, Boolean, Function],
  tabbableOptions: Object
}, NR = se({
  props: Object.assign({
    active: {
      // TODO: could be options for activate but what about the options for deactivating?
      type: Boolean,
      default: !0
    }
  }, PR),
  emits: [
    "update:active",
    "activate",
    "postActivate",
    "deactivate",
    "postDeactivate"
  ],
  render() {
    return this.renderImpl();
  },
  setup(e, { slots: t, emit: a }) {
    let n;
    const r = L(null), i = b(() => {
      const u = r.value;
      return u && (u instanceof HTMLElement ? u : u.$el);
    });
    function o() {
      return n || (n = xR(i.value, {
        escapeDeactivates: e.escapeDeactivates,
        allowOutsideClick: e.allowOutsideClick,
        returnFocusOnDeactivate: e.returnFocusOnDeactivate,
        clickOutsideDeactivates: e.clickOutsideDeactivates,
        onActivate: () => {
          a("update:active", !0), a("activate");
        },
        onDeactivate: () => {
          a("update:active", !1), a("deactivate");
        },
        onPostActivate: () => a("postActivate"),
        onPostDeactivate: () => a("postDeactivate"),
        initialFocus: e.initialFocus,
        fallbackFocus: e.fallbackFocus,
        tabbableOptions: e.tabbableOptions,
        delayInitialFocus: e.delayInitialFocus,
        preventScroll: e.preventScroll
      }));
    }
    return rt(() => {
      ne(() => e.active, (u) => {
        u && i.value ? o().activate() : n && (n.deactivate(), (!i.value || i.value.nodeType === Node.COMMENT_NODE) && (n = null));
      }, { immediate: !0, flush: "post" });
    }), qa(() => {
      n && n.deactivate(), n = null;
    }), {
      activate() {
        o().activate();
      },
      deactivate() {
        n && n.deactivate();
      },
      renderImpl() {
        if (!t.default)
          return null;
        const u = t.default().filter((s) => s.type !== x1);
        return !u || !u.length || u.length > 1 ? (console.error("[focus-trap-vue]: FocusTrap requires exactly one child."), u) : P1(u[0], { ref: r });
      }
    };
  }
}), LR = ["aria-label"], BR = {
  key: 0,
  class: "modal-header"
}, RR = {
  key: 0,
  class: "modal-title"
}, FR = { class: "modal-footer" }, zR = { class: "footer-actions" }, YR = /* @__PURE__ */ se({
  inheritAttrs: !1,
  __name: "KModal",
  props: {
    visible: { type: Boolean },
    title: { default: "" },
    actionButtonText: { default: "Submit" },
    actionButtonAppearance: { default: "primary" },
    actionButtonDisabled: { type: Boolean },
    hideCancelButton: { type: Boolean },
    cancelButtonText: { default: "Cancel" },
    cancelButtonAppearance: { default: "tertiary" },
    cancelButtonDisabled: { type: Boolean },
    tabbableOptions: { default: () => ({}) },
    maxWidth: { default: "500px" },
    maxHeight: { default: "calc(100vh - 200px)" },
    closeOnBackdropClick: { type: Boolean },
    closeOnEscape: { type: Boolean, default: !0 },
    hideCloseIcon: { type: Boolean },
    fullScreen: { type: Boolean },
    inputAutofocus: { type: Boolean },
    zIndex: { default: 1100 }
  },
  emits: ["proceed", "cancel"],
  setup(e, { emit: t }) {
    Yt((g) => ({
      "079ed64b": g.zIndex,
      "5c7fae9c": l.value,
      "7a620b59": s.value
    }));
    const a = t, n = Tt(), r = ea(), i = a0(), o = L(null), u = L(null), l = b(() => e.fullScreen && !n.content ? "95%" : Dt(e.maxWidth)), s = b(() => e.fullScreen && !n.content ? "95vh" : Dt(e.maxHeight)), d = b(() => {
      const g = Object.assign({}, r);
      return delete g.class, g;
    }), c = b(() => !!e.title || !!n.title || !e.hideCloseIcon), f = (g) => {
      e.visible && e.closeOnEscape && g.key === "Escape" && v(!0);
    }, v = (g = !1, w) => {
      var $, T;
      (g || (T = ($ = w == null ? void 0 : w.target) == null ? void 0 : $.classList) != null && T.contains("modal-backdrop") && e.closeOnBackdropClick && !i.text.value) && a("cancel");
    }, m = async (g) => {
      var w, $;
      g ? (await gt(), await new Promise((T) => setTimeout(T, 0)), (w = o.value) == null || w.activate()) : ($ = o.value) == null || $.deactivate();
    }, C = (g) => {
      var w, $, T, O;
      typeof document < "u" && (g ? ($ = (w = document == null ? void 0 : document.body) == null ? void 0 : w.classList) == null || $.remove("k-modal-overflow-hidden") : (O = (T = document == null ? void 0 : document.body) == null ? void 0 : T.classList) == null || O.add("k-modal-overflow-hidden"));
    }, p = (g) => {
      typeof document < "u" && (g ? document == null || document.addEventListener("keydown", f) : document == null || document.removeEventListener("keydown", f));
    }, h = () => {
      var w, $, T;
      const g = (T = ($ = (w = o.value) == null ? void 0 : w.$el) == null ? void 0 : $.querySelector(".modal-content")) == null ? void 0 : T.querySelectorAll("input");
      g != null && g.length && Array.from(g).every((O) => !O.disabled && !O.readOnly ? (O.focus(), !1) : !0);
    };
    return ne(() => e.visible, async (g) => {
      g ? (await m(!0), e.inputAutofocus && h(), C(!1), p(!0)) : (await m(!1), C(!0), p(!1));
    }, { immediate: !0 }), ne(() => e.inputAutofocus, async (g) => {
      g && (await gt(), h());
    }), cn(async () => {
      await m(!1), p(!1);
    }), (g, w) => g.visible ? (y(), S("div", Fe({
      key: 0,
      "aria-label": g.title,
      "aria-modal": "true",
      class: ["k-modal", [A(r).class]]
    }, d.value, { role: "dialog" }), [
      H("div", {
        ref_key: "modalWrapperElement",
        ref: u,
        class: ue(["modal-backdrop", { "modal-full-screen": g.fullScreen && !g.$slots.content }]),
        onClick: w[3] || (w[3] = ($) => v(!1, $))
      }, [
        Z(A(NR), {
          ref_key: "focusTrapElement",
          ref: o,
          active: !1,
          "fallback-focus": () => u.value,
          "tabbable-options": g.tabbableOptions
        }, {
          default: N(() => [
            H("div", {
              class: ue(["modal-container", { "custom-content": g.$slots.content }]),
              tabindex: "-1"
            }, [
              j(g.$slots, "content", {}, () => [
                c.value ? (y(), S("div", BR, [
                  g.title || g.$slots.title ? (y(), S("div", RR, [
                    j(g.$slots, "title", {}, () => [
                      be(ae(g.title), 1)
                    ], !0)
                  ])) : W("", !0),
                  g.hideCloseIcon ? W("", !0) : (y(), S("button", {
                    key: 1,
                    "aria-label": "Close",
                    class: "close-icon",
                    "data-testid": "modal-close-icon",
                    type: "button",
                    onClick: w[0] || (w[0] = ($) => g.$emit("cancel"))
                  }, [
                    Z(A(va), {
                      color: `var(--kui-color-text-neutral, ${A(Fa)})`,
                      decorative: ""
                    }, null, 8, ["color"])
                  ]))
                ])) : W("", !0),
                H("div", {
                  class: ue(["modal-content", { "no-header": !c.value }])
                }, [
                  j(g.$slots, "default", {}, void 0, !0)
                ], 2),
                H("div", FR, [
                  j(g.$slots, "footer", {}, () => [
                    H("div", zR, [
                      j(g.$slots, "footer-actions", {}, () => [
                        g.hideCancelButton ? W("", !0) : (y(), ee(nt, {
                          key: 0,
                          appearance: g.cancelButtonAppearance,
                          "data-testid": "modal-cancel-button",
                          disabled: g.cancelButtonDisabled,
                          onClick: w[1] || (w[1] = ($) => g.$emit("cancel"))
                        }, {
                          default: N(() => [
                            be(ae(g.cancelButtonText), 1)
                          ]),
                          _: 1
                        }, 8, ["appearance", "disabled"])),
                        Z(nt, {
                          appearance: g.actionButtonAppearance,
                          "data-testid": "modal-action-button",
                          disabled: g.actionButtonDisabled,
                          onClick: w[2] || (w[2] = ($) => g.$emit("proceed"))
                        }, {
                          default: N(() => [
                            be(ae(g.actionButtonText), 1)
                          ]),
                          _: 1
                        }, 8, ["appearance", "disabled"])
                      ], !0)
                    ])
                  ], !0)
                ])
              ], !0)
            ], 2)
          ]),
          _: 3
        }, 8, ["fallback-focus", "tabbable-options"])
      ], 2)
    ], 16, LR)) : W("", !0);
  }
}), s1 = /* @__PURE__ */ Me(YR, [["__scopeId", "data-v-16661290"]]), HR = ["aria-label"], qR = { class: "k-modal-fullscreen-body-header" }, WR = {
  key: 0,
  class: "body-header"
}, _R = {
  key: 1,
  class: "body-header-description"
}, UR = { class: "k-modal-fullscreen-body" }, VR = { class: "k-modal-fullscreen-header" }, KR = {
  "aria-level": "2",
  class: "k-modal-fullscreen-header-description",
  role: "heading"
}, jR = { class: "k-modal-fullscreen-title" }, GR = { class: "header-icon" }, QR = { class: "header-content" }, ZR = { class: "k-modal-fullscreen-action" }, XR = { class: "k-modal-fullscreen-action-buttons" }, JR = {
  key: 0,
  class: "k-modal-fullscreen-footer"
}, eF = { class: "k-modal-fullscreen-action" }, tF = { class: "k-modal-fullscreen-action-buttons" }, aF = /* @__PURE__ */ se({
  __name: "KModalFullscreen",
  props: {
    /**
    * Set the text of the title, if using title slot
    */
    title: {
      type: String,
      required: !0
    },
    /**
    * Set the title in the body
    */
    bodyHeader: {
      type: String,
      default: ""
    },
    /**
    * Text to display as a description of the body's title
    */
    bodyHeaderDescription: {
      type: String,
      default: ""
    },
    /**
    *  Pass whether or not the modal should be visible
    */
    isVisible: {
      type: Boolean,
      default: !1
    },
    /**
    * Set the text of the close/cancel button
    */
    cancelButtonText: {
      type: String,
      default: "Cancel"
    },
    /**
    * Set the text of the action/proceed button
    */
    actionButtonText: {
      type: String,
      default: "Save"
    },
    /**
    * Set the appearance of the action/proceed button
    */
    actionButtonAppearance: {
      type: String,
      default: "primary"
    },
    /**
    * Set the appearance of the close/cancel button
    */
    cancelButtonAppearance: {
      type: String,
      default: "secondary"
    },
    /**
    * @deprecated
    * Pass the type of icon for the header on the left
    */
    iconString: {
      type: String,
      default: "kong"
    }
  },
  emits: ["canceled", "proceed"],
  setup(e, { emit: t }) {
    const a = e, n = t, r = L(null), i = b(() => !!a.isVisible);
    ne(() => a.isVisible, async () => {
      typeof document > "u" || (i.value ? (document.body.style.overflow = "hidden", await gt(), r.value && r.value.focus()) : document.body.style.overflow = "");
    });
    const o = (s) => {
      a.isVisible && (s.keyCode === 27 ? u() : s.keyCode === 13 && l());
    }, u = () => {
      n("canceled");
    }, l = () => {
      n("proceed");
    };
    return rt(() => {
      document.addEventListener("keydown", o), console.warn(`The Kongponents 'KModalFullscreen' component is deprecated and will be removed in the next major release.
We suggest using 'KModal' component instead.
Docs: https://kongponents.konghq.com/components/modal.html#fullscreen`);
    }), cn(() => {
      document.removeEventListener("keydown", o);
    }), qa(() => {
      document.body.style.overflow = "";
    }), (s, d) => e.isVisible ? (y(), S("div", {
      key: 0,
      "aria-label": e.title,
      "aria-modal": "true",
      class: "k-modal-fullscreen isOpen",
      role: "dialog",
      onKeyup: [
        lt(l, ["enter"]),
        lt(u, ["esc"])
      ]
    }, [
      H("div", {
        ref_key: "modalBodyContent",
        ref: r,
        class: ue(["k-modal-fullscreen-dialog", { "has-footer": s.$slots["footer-content"] }]),
        tabindex: "0"
      }, [
        H("div", qR, [
          s.$slots["body-header"] || e.bodyHeader ? (y(), S("div", WR, [
            j(s.$slots, "body-header", {}, () => [
              be(ae(e.bodyHeader), 1)
            ], !0)
          ])) : W("", !0),
          s.$slots["body-header-description"] || e.bodyHeaderDescription ? (y(), S("div", _R, [
            j(s.$slots, "body-header-description", {}, () => [
              be(ae(e.bodyHeaderDescription), 1)
            ], !0)
          ])) : W("", !0)
        ]),
        H("div", UR, [
          j(s.$slots, "default", {}, void 0, !0)
        ]),
        H("div", VR, [
          H("div", KR, [
            H("div", jR, [
              H("span", GR, [
                j(s.$slots, "header-icon", {}, () => [
                  Z(A(Pu), { color: A(Ny) }, null, 8, ["color"])
                ], !0)
              ]),
              H("span", QR, [
                j(s.$slots, "header-content", {}, () => [
                  be(ae(e.title), 1)
                ], !0)
              ])
            ]),
            H("div", ZR, [
              H("div", XR, [
                j(s.$slots, "action-buttons", {}, () => [
                  Z(nt, {
                    appearance: e.cancelButtonAppearance,
                    class: "cancel-button",
                    onClick: u
                  }, {
                    default: N(() => [
                      be(ae(e.cancelButtonText), 1)
                    ]),
                    _: 1
                  }, 8, ["appearance"]),
                  Z(nt, {
                    appearance: e.actionButtonAppearance,
                    class: "proceed-button",
                    onClick: l
                  }, {
                    default: N(() => [
                      be(ae(e.actionButtonText), 1)
                    ]),
                    _: 1
                  }, 8, ["appearance"])
                ], !0)
              ])
            ])
          ])
        ]),
        s.$slots["footer-content"] ? (y(), S("div", JR, [
          j(s.$slots, "footer-content", {}, void 0, !0),
          H("div", eF, [
            H("div", tF, [
              j(s.$slots, "action-buttons", {}, () => [
                Z(nt, {
                  appearance: e.actionButtonAppearance,
                  class: "proceed-button",
                  onClick: l
                }, {
                  default: N(() => [
                    be(ae(e.actionButtonText), 1)
                  ]),
                  _: 1
                }, 8, ["appearance"])
              ], !0)
            ])
          ])
        ])) : W("", !0)
      ], 2)
    ], 40, HR)) : W("", !0);
  }
}), nF = /* @__PURE__ */ Me(aF, [["__scopeId", "data-v-ff332793"]]), rF = ["aria-selected", "data-testid"], iF = { class: "multiselect-item-container" }, oF = ["disabled", "value"], sF = { class: "multiselect-item-label" }, lF = /* @__PURE__ */ se({
  __name: "KMultiselectItem",
  props: {
    item: {}
  },
  emits: ["selected", "arrow-down", "arrow-up"],
  setup(e, { emit: t }) {
    const a = t, n = () => {
      e.item.disabled || a("selected", e.item);
    };
    return (r, i) => (y(), S("div", {
      key: r.item.key,
      "aria-selected": r.item.selected,
      class: "multiselect-item",
      "data-testid": `multiselect-item-${r.item.value}`,
      role: "option"
    }, [
      H("div", iF, [
        H("button", {
          class: ue({ selected: r.item.selected }),
          disabled: r.item.disabled === !0 ? !0 : void 0,
          type: "button",
          value: r.item.value,
          onClick: n,
          onKeydown: [
            i[0] || (i[0] = lt(Ke((o) => r.$emit("arrow-down"), ["prevent"]), ["down"])),
            i[1] || (i[1] = lt(Ke((o) => r.$emit("arrow-up"), ["prevent"]), ["up"]))
          ]
        }, [
          H("span", sF, [
            j(r.$slots, "content", {}, () => [
              be(ae(r.item.label), 1)
            ], !0)
          ])
        ], 42, oF)
      ])
    ], 8, rF));
  }
}), Go = /* @__PURE__ */ Me(lF, [["__scopeId", "data-v-e01a7f81"]]), uF = {
  ref: "itemsContainer",
  "aria-live": "polite",
  class: "multiselect-items-container"
}, dF = { class: "multiselect-group-title" }, cF = { class: "select-item-description" }, Mp = ".multiselect-item button:not(:disabled)", fF = /* @__PURE__ */ se({
  __name: "KMultiselectItems",
  props: {
    items: { default: () => [] },
    itemCreationEnabled: { type: Boolean },
    filterString: { default: "" },
    itemCreationValid: { type: Boolean, default: !0 }
  },
  emits: ["selected", "add-item"],
  setup(e, { expose: t, emit: a }) {
    const n = a, r = (c) => n("selected", c), i = b(() => {
      var c;
      return (c = e.items) == null ? void 0 : c.filter((f) => !f.group);
    }), o = b(() => {
      var c, f;
      return [...new Set((f = (c = e.items) == null ? void 0 : c.filter((v) => v.group)) == null ? void 0 : f.map((v) => v.group))].sort((v, m) => v.toLowerCase().localeCompare(m.toLowerCase()));
    }), u = (c) => {
      var f;
      return (f = e.items) == null ? void 0 : f.filter((v) => v.group === c);
    }, l = mt("itemsContainer"), s = (c) => {
      var m;
      const f = l.value;
      if (!f)
        return;
      const v = f.querySelectorAll(Mp);
      (m = v[c === "down" ? 0 : v.length - 1]) == null || m.focus();
    }, d = ({ target: c, key: f }) => {
      var v;
      if (f === "ArrowDown" || f === "ArrowUp") {
        const m = (v = l.value) == null ? void 0 : v.querySelectorAll(Mp);
        if (m != null && m.length) {
          const C = [...m].indexOf(c), p = f === "ArrowDown" ? C + 1 : C - 1, h = m[p];
          h == null || h.focus();
        }
      }
    };
    return t({ setFocus: s }), (c, f) => (y(), S("div", uF, [
      (y(!0), S(Ae, null, Le(i.value, (v, m) => (y(), ee(Go, {
        key: `${v.key ? v.key : m}-item`,
        item: v,
        onKeydown: d,
        onSelected: r
      }, {
        content: N(() => [
          j(c.$slots, "content", { item: v }, void 0, !0)
        ]),
        _: 2
      }, 1032, ["item"]))), 128)),
      (y(!0), S(Ae, null, Le(o.value, (v) => (y(), S("div", {
        key: `${v}-group`,
        class: "multiselect-group"
      }, [
        H("span", dF, ae(v), 1),
        (y(!0), S(Ae, null, Le(u(v), (m, C) => (y(), ee(Go, {
          key: `${m.key ? m.key : v + "-" + C + "-item"}`,
          item: m,
          onKeydown: d,
          onSelected: r
        }, {
          content: N(() => [
            j(c.$slots, "content", { item: m }, void 0, !0)
          ]),
          _: 2
        }, 1032, ["item"]))), 128))
      ]))), 128)),
      c.itemCreationEnabled ? (y(), ee(Go, {
        key: "multiselect-add-item",
        class: "multiselect-add-item",
        "data-testid": "multiselect-add-item",
        item: { label: `${c.filterString} (Add new value)`, value: "add_item", disabled: !c.itemCreationValid },
        onKeydown: d,
        onSelected: f[0] || (f[0] = (v) => c.$emit("add-item"))
      }, {
        content: N(() => [
          H("div", cF, [
            be(ae(c.filterString) + " ", 1),
            f[1] || (f[1] = H("span", { class: "select-item-new-indicator" }, "(Add new value)", -1))
          ])
        ]),
        _: 1
      }, 8, ["item"])) : W("", !0)
    ], 512));
  }
}), vF = /* @__PURE__ */ Me(fF, [["__scopeId", "data-v-a2ee6e0d"]]);
function $u(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
function pF(e, t) {
  let a;
  return (...n) => {
    clearTimeout(a), a = window == null ? void 0 : window.setTimeout(() => {
      e(...n);
    }, t);
  };
}
const Op = (e) => {
  try {
    return new URL(e), !0;
  } catch {
    return !1;
  }
}, l1 = 15, u1 = (e, t) => e.pageSize ? e.pageSize : t.initialPageSize ? t.initialPageSize : t.pageSizes && Array.isArray(t.pageSizes) && t.pageSizes.length ? t.pageSizes[0] : l1, hF = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let gF = (e = 21) => {
  let t = "", a = crypto.getRandomValues(new Uint8Array(e |= 0));
  for (; e--; )
    t += hF[a[e] & 63];
  return t;
};
const ll = () => gF(), mF = { "data-testid": "multiselect-container" }, yF = ["id", "tabindex"], bF = { key: 0 }, wF = {
  key: 1,
  class: "expanded-selection-empty"
}, CF = { class: "multiselect-selection-badge-label" }, kF = ["aria-label", "onClick"], $F = { class: "multiselect-icons-container" }, SF = {
  key: 0,
  class: "multiselect-input-wrapper"
}, TF = {
  key: 2,
  class: "multiselect-empty",
  "data-propagate-clicks": "false"
}, DF = {
  key: 1,
  class: "help-text"
}, AF = {
  key: 2,
  "aria-hidden": "true",
  class: "staging-area"
}, IF = { class: "multiselect-selection-badge-label" }, EF = (e) => {
  const t = [];
  return e.forEach((a) => t.push(a.value)), t;
}, MF = (e) => {
  const t = EF(e), a = new Set(t);
  return t.length === a.size;
}, OF = /* @__PURE__ */ se({
  inheritAttrs: !1,
  __name: "KMultiselect",
  props: {
    modelValue: { default: () => [] },
    label: { default: "" },
    help: { default: "" },
    error: { type: Boolean },
    labelAttributes: { default: () => ({}) },
    placeholder: { default: "" },
    searchPlaceholder: { default: "" },
    kpopAttributes: { default: () => ({}) },
    dropdownMaxHeight: { default: "300px" },
    width: { default: "100%" },
    selectedRowCount: { default: 1 },
    collapsedContext: { type: Boolean },
    items: { default: () => [] },
    filterFunction: { type: Function, default: (e) => e.items.filter((t) => {
      var a, n;
      return (n = t.label) == null ? void 0 : n.toLowerCase().includes((a = e.query) == null ? void 0 : a.toLowerCase());
    }) },
    autosuggest: { type: Boolean },
    enableItemCreation: { type: Boolean },
    loading: { type: Boolean },
    dropdownFooterText: { default: "" },
    dropdownFooterTextPosition: { default: "sticky" },
    itemCreationValidator: { type: Function, default: () => !0 }
  },
  emits: ["selected", "input", "change", "update:modelValue", "query-change", "item-added", "item-removed"],
  setup(e, { emit: t }) {
    Yt((U) => ({
      "2fa83352": He.value
    }));
    const a = ea(), n = Tt(), { cloneDeep: r, stripRequiredLabel: i } = Nn(), o = 36, u = "Filter...";
    ne(() => e.items, (U) => {
      !U.length || U.every((Ie) => Ie.label !== void 0 && Ie.value !== void 0) && MF(U) || console.warn("KMultiselect: Items must have a label & value and value must be unique");
    }, { immediate: !0 });
    const l = t, s = mt("kMultiselectItems"), d = b(() => a.required !== void 0 && String(a.required) !== "false"), c = b(() => i(e.label, d.value)), f = b(() => {
      var U, de;
      return !!((U = e.labelAttributes) != null && U.help || (de = e.labelAttributes) != null && de.info || n["label-tooltip"]);
    }), v = (U) => $e.value || ge.value || U != null && U.disabled ? "neutral" : e.error ? "danger" : "info", m = {
      hideCaret: !0,
      placement: "bottom-start",
      popoverTimeout: 0,
      popoverClasses: "multiselect-popover"
    }, C = L(0), p = L(0), h = bt(), g = b(() => a.id ? String(a.id) : h), w = bt(), $ = mt("multiselectElement"), T = mt("multiselectDropdownInputElement"), O = mt("multiselectSelectionsStagingElement"), M = b(() => e.selectedRowCount * o), F = L(""), q = b(() => !(!F.value || Y.value.filter((U) => U.label === F.value).length)), x = L(null), Y = L([]), R = L([]), k = L([]), P = L([]), D = L([]), B = /* @__PURE__ */ new Set(), J = L([]), _ = L([]), te = b(() => _.value.map((U) => U.label).join(", ")), G = L(!1), pe = L(!1), ce = L(!1), $e = b(() => (a == null ? void 0 : a.disabled) !== void 0 && String(a == null ? void 0 : a.disabled) !== "false"), ge = b(() => (a == null ? void 0 : a.readonly) !== void 0 && String(a == null ? void 0 : a.readonly) !== "false"), Se = b({
      get() {
        return e.modelValue;
      },
      set(U) {
        const de = Y.value.filter((Ie) => U.includes(Ie.value));
        de.length ? Ce(de) : U.length || Qe();
      }
    }), Ue = b(() => {
      const U = { ...a };
      return delete U.class, U;
    }), Ne = b(() => {
      var U;
      return {
        ...m,
        ...e.kpopAttributes,
        popoverClasses: `${m.popoverClasses} ${((U = e.kpopAttributes) == null ? void 0 : U.popoverClasses) ?? ""} ${e.dropdownFooterText || n["dropdown-footer-text"] ? "has-dropdown-footer" : ""}`,
        width: Mt.value + "px",
        maxWidth: Mt.value + "px",
        disabled: a.disabled !== void 0 && String(a.disabled) !== "false" || a.readonly !== void 0 && String(a.readonly) !== "false"
      };
    }), He = b(() => Dt(e.dropdownMaxHeight)), Xe = b(() => ({ ...Ne.value })), ot = b(() => {
      const U = e.width ? e.width : "300";
      return Dt(U);
    }), Ge = b(() => ({
      width: ot.value
    })), Je = b(() => ({
      width: Mt.value + "px"
    })), et = b(() => {
      if (k.value.length === 0) {
        if (!e.collapsedContext && e.placeholder)
          return e.placeholder;
        if (e.collapsedContext && e.searchPlaceholder)
          return e.searchPlaceholder;
      }
      return k.value.length === 1 ? `${k.value.length} item selected` : `${k.value.length} items selected`;
    }), ie = b(() => e.autosuggest ? Y.value : e.filterFunction({ items: Y.value, query: F.value })), le = (U) => {
      var de;
      ($e.value || ((de = U == null ? void 0 : U.target) == null ? void 0 : de.dataset.propagateClicks) === "false") && U.stopPropagation();
    }, fe = async (U, de, Ie) => {
      var X, I;
      if (U) {
        if (!de.value) {
          F.value = "", Ie(), dt(), await gt();
          const Q = (I = (X = T.value) == null ? void 0 : X.$el) == null ? void 0 : I.querySelector("input");
          Q == null || Q.focus({ preventScroll: !0 });
        }
      } else
        de.value && (F.value = "", Ie());
    }, z = () => {
      setTimeout(() => {
        const U = O.value;
        if (e.collapsedContext) {
          p.value++;
          return;
        }
        if (U) {
          if (U.clientHeight > M.value) {
            const Ie = Array.from(U.querySelectorAll(".multiselect-selection-badge")).filter((Q) => Q.offsetTop >= M.value), X = P.value.length - Ie.length, I = P.value.splice(X, Ie.length);
            for (const Q of I)
              B.has(Q.value) || (B.add(Q.value), D.value.push(Q));
          }
          p.value++;
        }
      }, 0);
    }, Ce = (U) => {
      U.forEach((de) => {
        var X;
        const Ie = ((X = Y.value.filter((I) => I.value === de.value)) == null ? void 0 : X[0]) || null;
        Ie.selected = !0, k.value.filter((I) => I.value === Ie.value).length || (k.value.push(Ie), P.value.push(Ie));
      }), z();
    }, xe = (U, de = !1) => {
      const Ie = new Set(U.map((X) => X.value));
      k.value = k.value.filter((X) => !Ie.has(X.value)), P.value = P.value.filter((X) => !Ie.has(X.value)), D.value = D.value.filter((X) => !Ie.has(X.value)), U.forEach((X) => {
        if (B.delete(X.value), X.selected = !1, D.value.length) {
          const I = D.value.pop();
          I && (P.value.push(I), B.delete(I.value));
        }
        e.enableItemCreation && X.custom && (Y.value = Y.value.filter((I) => I.value !== X.value), l("item-removed", X));
      }), de && z();
    }, De = (U, de) => {
      var Q, ve;
      let Ie = !1, X = de ? U : ((Q = Y.value.filter((ke) => ke.value === U.value)) == null ? void 0 : Q[0]) || null;
      if (e.enableItemCreation && (X != null && X.custom) && (Ie = !0), X === null && (X = ((ve = k.value.filter((ke) => ke.value === U.value)) == null ? void 0 : ve[0]) || null), X === null)
        return;
      if (X.selected) {
        if (k.value = k.value.filter((ke) => ke.value !== U.value), P.value.filter((ke) => ke.value === U.value).length ? P.value = P.value.filter((ke) => ke.value !== U.value) : B.delete(U.value) && (D.value = D.value.filter((ke) => ke.value !== U.value)), X.selected = !1, D.value.length) {
          const ke = D.value.pop();
          ke && (P.value.push(ke), B.delete(ke.value));
        }
        Ie && (Y.value = Y.value.filter((ke) => ke.value !== U.value), l("item-removed", U));
      } else
        X.selected = !0, k.value.push(X), P.value.push(X), de && (X.custom = !0, Y.value.push(X));
      z();
      const I = k.value.map((ke) => ke.value);
      l("selected", k.value), l("change", X), l("update:modelValue", I);
    }, qe = (U) => {
      e.enableItemCreation && ct(), U.preventDefault();
    }, ct = () => {
      var Ie;
      if (!e.enableItemCreation || !F.value || !q.value || !e.itemCreationValidator(F.value))
        return;
      const U = Y.value.length + 1, de = {
        label: F.value.trim(),
        value: ll(),
        key: `${(Ie = $u(F.value.trim()).replace(/ /gi, "-")) == null ? void 0 : Ie.replace(/[^a-z0-9-_]/gi, "")}-${U}`
      };
      l("item-added", de), De(de, !0), F.value = "";
    }, dt = () => {
      const U = ie.value.filter((Q) => Q.selected), de = ie.value.filter((Q) => !Q.selected), Ie = [...U, ...de], X = Ie.filter((Q) => !Q.group), I = Ie.filter((Q) => Q.group).sort((Q, ve) => Q.group.toLowerCase().localeCompare(ve.group.toLowerCase()));
      R.value = [...X, ...I];
    }, Qe = () => {
      Y.value.forEach((de) => {
        de.disabled || (de.selected = !1, de.custom && l("item-removed", de));
      }), Y.value = Y.value.filter((de) => !(de.custom && !de.disabled)), k.value = k.value.filter((de) => de.disabled), P.value = P.value.filter((de) => de.disabled), D.value = D.value.filter((de) => (de.disabled || B.delete(de.value), de.disabled)), F.value = "", z();
      const U = k.value.map((de) => de.value);
      l("selected", k.value), l("update:modelValue", U), l("query-change", "");
    }, pt = (U) => {
      F.value = U.trim(), l("query-change", U.trim());
    }, It = (U, de) => {
      var Ie;
      U.keyCode === 27 && (de.value = !1), (U.key === "ArrowDown" || U.key === "ArrowUp") && ((Ie = s.value) == null || Ie.setFocus(U.key === "ArrowDown" ? "down" : "up"));
    }, Ot = () => {
      var U;
      (U = x.value) == null || U.showPopover();
    }, Gt = (U) => {
      var de;
      (U.key === "ArrowDown" || U.key === "ArrowUp") && ((de = s.value) == null || de.setFocus(U.key === "ArrowDown" ? "down" : "up"));
    }, ta = async () => {
      ce.value = !0, xt();
    }, xt = () => {
      G.value || (G.value = !0, l("query-change", ""));
    };
    ne(p, () => {
      setTimeout(() => {
        const U = O.value;
        if (e.collapsedContext) {
          J.value = r(P.value), _.value = [], C.value++;
          return;
        }
        if (U)
          if (U.clientHeight > M.value) {
            const Ie = P.value.pop();
            Ie && !B.has(Ie.value) && (D.value.push(Ie), B.add(Ie.value)), p.value++;
          } else
            J.value = r(P.value), _.value = r(D.value), C.value++;
      }, 0);
    }), ne(C, async () => {
      x.value && typeof x.value.updatePopper == "function" && (await gt(), x.value.updatePopper());
    }), ne(ie, () => {
      dt();
    }), ne(Se, (U, de) => {
      if (JSON.stringify(U) !== JSON.stringify(de)) {
        if (!U.length) {
          Qe();
          return;
        }
        const Ie = new Set(de), X = new Set(U), I = Y.value.filter((ve) => X.has(ve.value)), Q = k.value.filter((ve) => !X.has(ve.value) && Ie.has(ve.value));
        Q.length && xe(Q), I.length && Ce(I);
      }
    }), ne(() => e.items, (U, de) => {
      var Ie, X;
      if (JSON.stringify(U) !== JSON.stringify(de)) {
        Y.value = r(e.items);
        for (let I = 0; I < Y.value.length; I++) {
          Y.value[I].selected === void 0 && (Y.value[I].selected = !1);
          let Q = `${(X = (Ie = Y.value[I].label) == null ? void 0 : Ie.replace(/ /gi, "-")) == null ? void 0 : X.replace(/[^a-z0-9-_]/gi, "")}-${I}`;
          if (Q.includes("undefined") && (Q = `multiselect-item-label-${I}`), Y.value[I].key = Q, e.modelValue.includes(Y.value[I].value) || Y.value[I].selected) {
            const ve = Y.value[I];
            ve.selected = !0, k.value.filter((ke) => ke.value === ve.value).length || k.value.push(ve), P.value.filter((ke) => ke.value === ve.value).length || P.value.push(ve);
          }
        }
        z(), x.value && typeof x.value.updatePopper == "function" && gt(() => {
          x.value.updatePopper();
        });
      }
    }, { deep: !0, immediate: !0 });
    const Mt = L(300), re = async () => {
      var U;
      Mt.value = 300, await gt(), Mt.value = ((U = $.value) == null ? void 0 : U.clientWidth) || 300, z();
    }, ze = L();
    return rt(() => {
      ia("resize", re), ze.value = or.create(re), ze.value.observe($.value);
    }), cn(() => {
      ze.value && $.value && ze.value.unobserve($.value);
    }), (U, de) => {
      const Ie = zt("KTooltip");
      return y(), S("div", {
        class: ue(["k-multiselect", [U.$attrs.class, { "multiselect-error": U.error }]]),
        style: Ee(Ge.value)
      }, [
        U.label ? (y(), ee(_a, Fe({ key: 0 }, U.labelAttributes, {
          "data-testid": U.labelAttributes["data-testid"] ? U.labelAttributes["data-testid"] : "multiselect-label",
          for: g.value,
          required: d.value
        }), yt({
          default: N(() => [
            be(ae(c.value) + " ", 1)
          ]),
          _: 2
        }, [
          f.value ? {
            name: "tooltip",
            fn: N(() => [
              j(U.$slots, "label-tooltip", {}, void 0, !0)
            ]),
            key: "0"
          } : void 0
        ]), 1040, ["data-testid", "for", "required"])) : W("", !0),
        H("div", mF, [
          Z(Rs, null, {
            default: N(({ isToggled: X, toggle: I }) => [
              Z(ir, Fe({
                ref_key: "popper",
                ref: x,
                "hide-close-icon": ""
              }, Xe.value, {
                onClose: () => fe(!1, X, I),
                onOpen: () => fe(!0, X, I)
              }), {
                content: N(() => [
                  H("div", {
                    class: "multiselect-list",
                    onClick: de[7] || (de[7] = Ke(() => {
                    }, ["stop"])),
                    onMouseenter: de[8] || (de[8] = () => pe.value = !0),
                    onMouseleave: de[9] || (de[9] = () => pe.value = !1)
                  }, [
                    !U.collapsedContext && !ge.value ? (y(), S("div", SF, [
                      Z(xn, {
                        ref: "multiselectDropdownInputElement",
                        autocapitalize: "off",
                        autocomplete: "off",
                        autocorrect: "off",
                        class: "multiselect-dropdown-input",
                        "data-testid": "multiselect-dropdown-input",
                        "model-value": F.value,
                        placeholder: U.searchPlaceholder || u,
                        spellcheck: "false",
                        type: "text",
                        onClick: de[5] || (de[5] = Ke(() => {
                        }, ["stop"])),
                        onFocus: xt,
                        onKeydown: lt(qe, ["enter"]),
                        onKeyup: [
                          Gt,
                          de[6] || (de[6] = lt(Ke(() => {
                          }, ["stop"]), ["enter"]))
                        ],
                        "onUpdate:modelValue": pt
                      }, null, 8, ["model-value", "placeholder"])
                    ])) : W("", !0),
                    Z(vF, {
                      ref: "kMultiselectItems",
                      "filter-string": F.value,
                      "item-creation-enabled": U.enableItemCreation && q.value,
                      "item-creation-valid": U.itemCreationValidator(F.value),
                      items: R.value,
                      onAddItem: ct,
                      onSelected: De
                    }, {
                      content: N(({ item: Q }) => [
                        j(U.$slots, "item-template", {
                          class: "multiselect-item",
                          item: Q
                        }, void 0, !0)
                      ]),
                      _: 3
                    }, 8, ["filter-string", "item-creation-enabled", "item-creation-valid", "items"]),
                    !R.value.length && !U.$slots.empty && !U.enableItemCreation ? (y(), ee(Go, {
                      key: "multiselect-empty-item",
                      class: "multiselect-empty-item",
                      "data-testid": "multiselect-empty-item",
                      item: { label: "No results", value: "no_results", disabled: !0 }
                    })) : W("", !0),
                    U.$slots.empty && !U.loading && !R.value.length ? (y(), S("div", TF, [
                      j(U.$slots, "empty", {}, void 0, !0)
                    ])) : W("", !0)
                  ], 32),
                  U.dropdownFooterText || U.$slots["dropdown-footer-text"] ? (y(), S("div", {
                    key: 0,
                    class: ue(["dropdown-footer", `dropdown-footer-${U.dropdownFooterTextPosition}`]),
                    "data-testid": "dropdown-footer"
                  }, [
                    j(U.$slots, "dropdown-footer-text", {}, () => [
                      be(ae(U.dropdownFooterText), 1)
                    ], !0)
                  ], 2)) : W("", !0)
                ]),
                default: N(() => [
                  H("div", Fe({
                    id: g.value,
                    ref: "multiselectElement",
                    class: ["multiselect-trigger", { focused: ce.value, hovered: pe.value, disabled: $e.value, readonly: ge.value }],
                    "data-testid": "multiselect-trigger",
                    role: "listbox",
                    tabindex: $e.value || ge.value || U.collapsedContext ? -1 : 0
                  }, Ue.value, {
                    onClick: le,
                    onKeydown: [
                      lt(Ot, ["enter"]),
                      lt(Ot, ["space"])
                    ]
                  }), [
                    U.collapsedContext ? (y(), S("div", bF, [
                      Z(xn, {
                        autocapitalize: "off",
                        autocomplete: "off",
                        autocorrect: "off",
                        class: ue(["multiselect-input", { "is-readonly": ge.value }]),
                        "data-testid": "multiselect-input",
                        disabled: $e.value,
                        "model-value": F.value,
                        placeholder: et.value,
                        readonly: ge.value ? !0 : void 0,
                        spellcheck: "false",
                        type: "text",
                        onBlur: de[0] || (de[0] = () => ce.value = !1),
                        onClick: (Q) => {
                          X.value && Q.stopPropagation();
                        },
                        onFocus: ta,
                        onKeydown: lt(qe, ["enter"]),
                        onKeyup: (Q) => It(Q, X),
                        onMouseenter: de[1] || (de[1] = () => pe.value = !0),
                        onMouseleave: de[2] || (de[2] = () => pe.value = !1),
                        "onUpdate:modelValue": pt
                      }, null, 8, ["class", "disabled", "model-value", "placeholder", "readonly", "onClick", "onKeyup"])
                    ])) : k.value.length ? (y(), S("div", {
                      key: 2,
                      class: "selection-badges-container",
                      "data-testid": "selection-badges-container",
                      style: Ee(Je.value)
                    }, [
                      (y(!0), S(Ae, null, Le(J.value, (Q, ve) => (y(), ee(fi, {
                        key: `${A(w)}-${Q.key ? Q.key : ve}-badge-${C.value}`,
                        appearance: v(Q),
                        class: "multiselect-selection-badge",
                        "icon-before": !1,
                        tooltip: Q.label,
                        "truncation-tooltip": "",
                        onClick: de[3] || (de[3] = Ke(() => {
                        }, ["stop"]))
                      }, yt({
                        default: N(() => [
                          j(U.$slots, "item-badge-icon", { item: Q }, void 0, !0),
                          H("span", CF, ae(Q.label), 1)
                        ]),
                        _: 2
                      }, [
                        Q.selected && !Q.disabled && !$e.value && !ge.value ? {
                          name: "icon",
                          fn: N(() => [
                            H("button", {
                              "aria-label": `Unselect ${Q.label}`,
                              class: "badge-dismiss-button",
                              "data-testid": "badge-dismiss-button",
                              type: "button",
                              onClick: (ke) => De(Q)
                            }, [
                              Z(A(va), { decorative: "" })
                            ], 8, kF)
                          ]),
                          key: "0"
                        } : void 0
                      ]), 1032, ["appearance", "tooltip"]))), 128)),
                      _.value.length ? (y(), ee(Ie, {
                        key: 0,
                        class: "hidden-selection-count-tooltip",
                        "max-width": "300",
                        text: te.value
                      }, {
                        default: N(() => [
                          Z(fi, {
                            appearance: v(),
                            class: "hidden-selection-count",
                            "data-testid": "hidden-selection-count",
                            onClick: de[4] || (de[4] = Ke(() => {
                            }, ["stop"]))
                          }, {
                            default: N(() => [
                              be(" +" + ae(_.value.length), 1)
                            ]),
                            _: 1
                          }, 8, ["appearance"])
                        ]),
                        _: 1
                      }, 8, ["text"])) : W("", !0)
                    ], 4)) : (y(), S("div", wF, ae(et.value), 1)),
                    H("div", $F, [
                      !U.loading && k.value.length && X.value ? (y(), S("button", {
                        key: 0,
                        "aria-label": "Clear",
                        class: "multiselect-clear-icon",
                        "data-testid": "multiselect-clear-icon",
                        type: "button",
                        onClick: Qe
                      }, [
                        Z(A(va), { size: A(Vt) }, null, 8, ["size"])
                      ])) : U.loading ? (y(), ee(A(Ri), {
                        key: 1,
                        class: "multiselect-loading-icon",
                        size: A(Vt),
                        title: "Loading"
                      }, null, 8, ["size"])) : (y(), ee(A(zs), {
                        key: 2,
                        class: "multiselect-chevron-icon",
                        decorative: "",
                        size: A(Vt)
                      }, null, 8, ["size"]))
                    ])
                  ], 16, yF)
                ]),
                _: 2
              }, 1040, ["onClose", "onOpen"])
            ]),
            _: 3
          })
        ]),
        U.help ? (y(), S("p", DF, ae(U.help), 1)) : W("", !0),
        U.collapsedContext ? W("", !0) : (y(), S("div", AF, [
          (y(), S("div", {
            key: p.value,
            ref: "multiselectSelectionsStagingElement",
            class: "selection-badges-container staging",
            style: Ee(Je.value),
            tabindex: "-1"
          }, [
            (y(!0), S(Ae, null, Le(P.value, (X, I) => (y(), ee(fi, {
              key: `${A(w)}-${X.key ? X.key : I}-badge`,
              "aria-hidden": "true",
              class: "multiselect-selection-badge",
              "icon-before": !1
            }, yt({
              default: N(() => [
                j(U.$slots, "item-badge-icon", { item: X }, void 0, !0),
                H("span", IF, ae(X.label), 1)
              ]),
              _: 2
            }, [
              X.selected && !X.disabled && !$e.value && !ge.value ? {
                name: "icon",
                fn: N(() => [
                  Z(A(va), { "aria-hidden": "true" })
                ]),
                key: "0"
              } : void 0
            ]), 1024))), 128)),
            Z(fi, {
              "aria-hidden": "true",
              class: "hidden-selection-count"
            }, {
              default: N(() => [
                be(" +" + ae(D.value.length), 1)
              ]),
              _: 1
            })
          ], 4))
        ]))
      ], 6);
    };
  }
}), xF = /* @__PURE__ */ Me(OF, [["__scopeId", "data-v-d6951189"]]), PF = {
  key: 0,
  class: "prompt-content"
}, NF = { class: "prompt-message" }, LF = {
  key: 1,
  class: "prompt-confirmation-container"
}, BF = { class: "prompt-confirmation-text" }, RF = { class: "confirmation-text" }, FF = /* @__PURE__ */ se({
  inheritAttrs: !1,
  __name: "KPrompt",
  props: {
    visible: { type: Boolean },
    title: { default: "" },
    message: { default: "" },
    actionButtonText: { default: "Confirm" },
    actionButtonAppearance: { default: "primary" },
    actionButtonDisabled: { type: Boolean },
    cancelButtonText: { default: "Cancel" },
    cancelButtonAppearance: { default: "tertiary" },
    cancelButtonDisabled: { type: Boolean },
    confirmationText: { default: "" },
    confirmationPrompt: { default: "Type {confirmationText} to confirm your action." },
    modalAttributes: { default: () => ({}) },
    errorMessage: { default: "You must enter the text as indicated above to confirm." }
  },
  emits: ["proceed", "cancel"],
  setup(e, { emit: t }) {
    const a = t, n = Tt(), r = ea(), i = b(() => {
      const c = Object.assign({}, r);
      return delete c["tabbable-options"], delete c["max-width"], delete c["max-height"], delete c["close-on-backdrop-click"], delete c["input-autofocus"], delete c["hide-close-icon"], delete c["hide-cancel-button"], delete c["full-screen"], c;
    }), o = L(""), u = L(!1), l = b(() => e.actionButtonDisabled ? !0 : e.confirmationText ? e.confirmationText !== o.value : !1), s = b(() => e.confirmationPrompt.split("{confirmationText}")), d = () => {
      l.value ? u.value = !0 : a("proceed");
    };
    return ne(() => e.visible, (c) => {
      c || (o.value = "", u.value = !1);
    }), ne(o, (c) => {
      c && c === e.confirmationText && (u.value = !1);
    }), (c, f) => (y(), ee(s1, Fe({ ...i.value, ...c.modalAttributes }, {
      "action-button-appearance": c.actionButtonAppearance,
      "action-button-disabled": l.value,
      "action-button-text": c.actionButtonText,
      "cancel-button-appearance": c.cancelButtonAppearance,
      "cancel-button-disabled": c.cancelButtonDisabled,
      "cancel-button-text": c.cancelButtonText,
      class: "k-prompt",
      "input-autofocus": c.modalAttributes.inputAutofocus === void 0 ? !0 : c.modalAttributes.inputAutofocus,
      title: c.title || "Confirm your action",
      visible: c.visible,
      onCancel: f[1] || (f[1] = (v) => a("cancel")),
      onProceed: f[2] || (f[2] = (v) => a("proceed"))
    }), yt({
      default: N(() => [
        n.default || c.message ? (y(), S("div", PF, [
          j(c.$slots, "default", {}, () => [
            H("p", NF, ae(c.message), 1)
          ], !0)
        ])) : W("", !0),
        c.confirmationText ? (y(), S("div", LF, [
          H("p", BF, [
            be(ae(s.value[0]) + " ", 1),
            H("span", RF, '"' + ae(c.confirmationText) + '"', 1),
            be(" " + ae(s.value[1] ? s.value[1] : ""), 1)
          ]),
          Z(xn, {
            modelValue: o.value,
            "onUpdate:modelValue": f[0] || (f[0] = (v) => o.value = v),
            "aria-label": `${s.value[0]}'${c.confirmationText}'${s.value[1] ? s.value[1] : ""}`,
            autocapitalize: "off",
            autocomplete: "off",
            "data-testid": "confirmation-input",
            error: u.value,
            "error-message": c.errorMessage,
            onKeydown: lt(Ke(d, ["prevent"]), ["enter"])
          }, null, 8, ["modelValue", "aria-label", "error", "error-message", "onKeydown"])
        ])) : W("", !0)
      ]),
      _: 2
    }, [
      n.title ? {
        name: "title",
        fn: N(() => [
          j(c.$slots, "title", {}, void 0, !0)
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["action-button-appearance", "action-button-disabled", "action-button-text", "cancel-button-appearance", "cancel-button-disabled", "cancel-button-text", "input-autofocus", "title", "visible"]));
  }
}), zF = /* @__PURE__ */ Me(FF, [["__scopeId", "data-v-6fbede40"]]), YF = ["id", "aria-checked", "checked", "disabled", "tabindex"], HF = {
  key: 0,
  class: "radio-description"
}, qF = ["data-testid", "for", "tabindex"], WF = {
  key: 0,
  class: "card-content-wrapper"
}, _F = {
  key: 1,
  class: "card-label-container"
}, UF = {
  key: 0,
  class: "radio-label"
}, VF = {
  key: 1,
  class: "radio-description"
}, KF = {
  inheritAttrs: !1
}, jF = /* @__PURE__ */ se({
  ...KF,
  __name: "KRadio",
  props: {
    modelValue: {},
    label: { default: "" },
    labelAttributes: { default: () => ({}) },
    description: { default: "" },
    selectedValue: {},
    error: { type: Boolean },
    card: { type: Boolean },
    cardRadioVisible: { type: Boolean, default: !0 },
    cardOrientation: { default: "vertical" },
    type: { default: "" }
  },
  emits: ["change", "update:modelValue"],
  setup(e, { emit: t }) {
    ne(() => e.labelAttributes, (h) => {
      h.help && console.warn("KRadio: `help` property of `labelAttributes` prop is deprecated. Please use `info` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#klabel");
    }, { deep: !0, immediate: !0 }), ne(() => e.type, (h) => {
      h && console.warn("KRadio: `type` prop is deprecated. Please use `card` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#kradio");
    }, { immediate: !0 });
    const a = t, n = Tt(), r = ea(), i = bt(), o = b(() => r.id ? String(r.id) : i), u = b(() => (r == null ? void 0 : r.disabled) !== void 0 && String(r == null ? void 0 : r.disabled) !== "false"), l = b(() => !!(e.label || n.default)), s = b(() => l.value && (!!e.description || !!n.description)), d = b(() => !!e.label && (!!e.description || !!n.description)), c = b(() => !!n.tooltip), f = b(() => e.selectedValue === e.modelValue), v = () => {
      a("change", e.selectedValue), a("update:modelValue", e.selectedValue);
    }, m = b(() => {
      const h = { ...r };
      return delete h.class, h;
    }), C = b(() => ({
      disabled: u.value,
      "radio-card": e.card || e.type === "card",
      "input-error": e.error,
      checked: f.value,
      "has-description": s.value,
      "card-horizontal": e.card && e.cardOrientation === "horizontal",
      // Add vertical class for `vertical` or an invalid prop value
      "card-vertical": e.card && e.cardOrientation !== "horizontal"
    })), p = b(() => e.card && r["data-testid"] ? `${r["data-testid"]}-label` : void 0);
    return (h, g) => {
      const w = zt("KTooltip");
      return y(), S("div", {
        class: ue(["k-radio", [
          h.$attrs.class ? h.$attrs.class : "",
          C.value
        ]])
      }, [
        H("input", Fe({ id: o.value }, m.value, {
          "aria-checked": f.value,
          checked: f.value,
          class: ["radio-input", { hidden: h.card && !h.cardRadioVisible }],
          disabled: u.value,
          tabindex: h.card || u.value || f.value ? -1 : 0,
          type: "radio",
          onClick: v
        }), null, 16, YF),
        !h.card && (h.label || h.$slots.default) ? (y(), S("div", {
          key: 0,
          class: ue(["radio-label-wrapper", { "has-description": s.value }])
        }, [
          Z(_a, Fe(h.labelAttributes, {
            class: "radio-label",
            for: o.value
          }), yt({
            default: N(() => [
              j(h.$slots, "default", {}, () => [
                be(ae(h.label), 1)
              ], !0)
            ]),
            _: 2
          }, [
            c.value ? {
              name: "tooltip",
              fn: N(() => [
                j(h.$slots, "tooltip", {}, void 0, !0)
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["for"]),
          s.value ? (y(), S("div", HF, [
            j(h.$slots, "description", {}, () => [
              H("p", null, ae(h.description), 1)
            ], !0)
          ])) : W("", !0)
        ], 2)) : h.label || h.$slots.default ? (y(), S("label", {
          key: 1,
          class: ue(["radio-card-wrapper radio-label-wrapper", { "has-label": h.label, "has-description": d.value, "show-radio": h.cardRadioVisible }]),
          "data-testid": p.value,
          for: o.value,
          tabindex: u.value || f.value ? -1 : 0,
          onKeydown: g[0] || (g[0] = lt(Ke(() => {
          }, ["prevent"]), ["space"])),
          onKeyup: lt(v, ["space"])
        }, [
          h.$slots.default ? (y(), S("span", WF, [
            j(h.$slots, "default", {}, void 0, !0)
          ])) : W("", !0),
          h.label || d.value ? (y(), S("span", _F, [
            h.label ? (y(), S("span", UF, [
              be(ae(h.label) + " ", 1),
              n.tooltip ? (y(), ee(w, {
                key: 0,
                class: "label-tooltip"
              }, {
                content: N(() => [
                  j(h.$slots, "tooltip", {}, void 0, !0)
                ]),
                default: N(() => [
                  Z(A(In), {
                    class: "tooltip-trigger-icon",
                    color: `var(--kui-color-text-neutral, ${A(Fa)})`,
                    tabindex: "0"
                  }, null, 8, ["color"])
                ]),
                _: 3
              })) : W("", !0)
            ])) : W("", !0),
            d.value ? (y(), S("span", VF, [
              j(h.$slots, "description", {}, () => [
                be(ae(h.description), 1)
              ], !0)
            ])) : W("", !0)
          ])) : W("", !0)
        ], 42, qF)) : W("", !0)
      ], 2);
    };
  }
}), GF = /* @__PURE__ */ Me(jF, [["__scopeId", "data-v-3fb0c380"]]), QF = ["aria-selected", "data-testid"], ZF = { class: "select-item-container" }, XF = ["disabled", "value"], JF = { class: "select-item-label" }, ez = /* @__PURE__ */ se({
  __name: "KSelectItem",
  props: {
    item: {}
  },
  emits: ["selected", "arrow-down", "arrow-up"],
  setup(e, { emit: t }) {
    const a = t, n = (r) => {
      if (e.item.disabled) {
        r.stopPropagation();
        return;
      }
      a("selected", e.item);
    };
    return (r, i) => (y(), S("div", {
      key: r.item.key,
      "aria-selected": r.item.selected,
      class: "select-item",
      "data-testid": `select-item-${r.item.value}`,
      role: "option"
    }, [
      H("div", ZF, [
        H("button", {
          class: ue({ selected: r.item.selected }),
          disabled: r.item.disabled === !0 ? !0 : void 0,
          type: "button",
          value: r.item.value,
          onClick: n,
          onKeydown: [
            i[0] || (i[0] = lt(Ke((o) => r.$emit("arrow-down"), ["prevent"]), ["down"])),
            i[1] || (i[1] = lt(Ke((o) => r.$emit("arrow-up"), ["prevent"]), ["up"]))
          ]
        }, [
          H("span", JF, [
            j(r.$slots, "content", {}, () => [
              be(ae(r.item.label), 1)
            ], !0)
          ])
        ], 42, XF)
      ])
    ], 8, QF));
  }
}), Qo = /* @__PURE__ */ Me(ez, [["__scopeId", "data-v-11bc36aa"]]), tz = { ref: "itemsContainer" }, az = { class: "select-group-title" }, nz = { class: "select-item-description" }, xp = ".select-item button:not(:disabled)", rz = '.select-item[aria-selected="true"] button:not(:disabled)', iz = /* @__PURE__ */ se({
  __name: "KSelectItems",
  props: {
    items: { default: () => [] },
    itemCreationEnabled: { type: Boolean },
    filterString: { default: "" },
    itemCreationValid: { type: Boolean, default: !0 }
  },
  emits: ["selected", "add-item"],
  setup(e, { expose: t, emit: a }) {
    const n = a, r = (c) => n("selected", c), i = b(() => {
      var c;
      return (c = e.items) == null ? void 0 : c.filter((f) => !f.group);
    }), o = b(() => {
      var c, f;
      return [...new Set((f = (c = e.items) == null ? void 0 : c.filter((v) => v.group)) == null ? void 0 : f.map((v) => v.group))].sort((v, m) => v.toLowerCase().localeCompare(m.toLowerCase()));
    }), u = (c) => {
      var f;
      return (f = e.items) == null ? void 0 : f.filter((v) => v.group === c);
    }, l = mt("itemsContainer"), s = (c) => {
      var C, p;
      const f = l.value;
      if (!f)
        return;
      const v = f.querySelectorAll(xp);
      if (!(v != null && v.length))
        return;
      const m = f.querySelector(rz);
      if (m) {
        const h = [...v].indexOf(m);
        (C = v[c === "down" ? h + 1 : h - 1]) == null || C.focus();
      } else
        (p = v[c === "down" ? 0 : v.length - 1]) == null || p.focus();
    }, d = ({ target: c, key: f }) => {
      var v;
      if (f === "ArrowDown" || f === "ArrowUp") {
        const m = (v = l.value) == null ? void 0 : v.querySelectorAll(xp);
        if (m != null && m.length) {
          const C = [...m].indexOf(c), p = f === "ArrowDown" ? C + 1 : C - 1, h = m[p];
          h == null || h.focus();
        }
      }
    };
    return t({ setFocus: s }), (c, f) => (y(), S("div", tz, [
      (y(!0), S(Ae, null, Le(i.value, (v) => (y(), ee(Qo, {
        key: v.key,
        item: v,
        onKeydown: d,
        onSelected: r
      }, {
        content: N(() => [
          j(c.$slots, "content", { item: v }, void 0, !0)
        ]),
        _: 2
      }, 1032, ["item"]))), 128)),
      (y(!0), S(Ae, null, Le(o.value, (v) => (y(), S("div", {
        key: `${v}-group`,
        class: "select-group",
        "data-propagate-clicks": "false"
      }, [
        H("span", az, ae(v), 1),
        (y(!0), S(Ae, null, Le(u(v), (m) => (y(), ee(Qo, {
          key: m.key,
          item: m,
          onKeydown: d,
          onSelected: r
        }, {
          content: N(() => [
            j(c.$slots, "content", { item: m }, void 0, !0)
          ]),
          _: 2
        }, 1032, ["item"]))), 128))
      ]))), 128)),
      c.itemCreationEnabled ? (y(), ee(Qo, {
        key: "select-add-item",
        class: "select-add-item",
        "data-testid": "select-add-item",
        item: { label: `${c.filterString} (Add new value)`, value: "add_item", disabled: !c.itemCreationValid },
        onKeydown: d,
        onSelected: f[0] || (f[0] = (v) => c.$emit("add-item"))
      }, {
        content: N(() => [
          H("div", nz, [
            be(ae(c.filterString) + " ", 1),
            f[1] || (f[1] = H("span", { class: "select-item-new-indicator" }, "(Add new value)", -1))
          ])
        ]),
        _: 1
      }, 8, ["item"])) : W("", !0)
    ], 512));
  }
}), oz = /* @__PURE__ */ Me(iz, [["__scopeId", "data-v-2f823fac"]]), sz = ["id"], lz = ["aria-live"], uz = {
  key: 0,
  class: "select-loading",
  "data-propagate-clicks": "false",
  "data-testid": "select-loading"
}, dz = {
  key: 1,
  class: "select-items-container",
  "data-propagate-clicks": "false"
}, cz = {
  key: 1,
  class: "dropdown-footer dropdown-footer-static"
}, fz = {
  key: 2,
  class: "select-empty",
  "data-propagate-clicks": "false"
}, vz = {
  key: 0,
  class: "dropdown-footer dropdown-footer-sticky"
}, pz = /* @__PURE__ */ se({
  inheritAttrs: !1,
  __name: "KSelect",
  props: {
    modelValue: { default: "" },
    kpopAttributes: { default: () => ({}) },
    dropdownMaxHeight: { default: "300px" },
    label: { default: "" },
    labelAttributes: { default: () => ({}) },
    width: { default: "100%" },
    placeholder: { default: "" },
    items: { default: () => [] },
    enableFiltering: { type: Boolean },
    filterFunction: { default: () => (e) => {
      var t;
      return (t = e.items) == null ? void 0 : t.filter((a) => {
        var n, r;
        return (r = a.label) == null ? void 0 : r.toLowerCase().includes((n = e.query) == null ? void 0 : n.toLowerCase());
      });
    } },
    loading: { type: Boolean },
    clearable: { type: Boolean },
    dropdownFooterText: { default: "" },
    dropdownFooterTextPosition: { default: "sticky" },
    reuseItemTemplate: { type: Boolean },
    enableItemCreation: { type: Boolean },
    itemCreationValidator: { type: Function, default: () => !0 },
    error: { type: Boolean },
    help: { default: "" }
  },
  emits: ["selected", "input", "change", "update:modelValue", "query-change", "item-added", "item-removed"],
  setup(e, { emit: t }) {
    Yt((z) => ({
      "33d114c6": R.value,
      "41506c0b": k.value,
      "7dc574a4": B.value
    }));
    const { stripRequiredLabel: a } = Nn(), n = t, r = ea(), i = Tt(), o = bt(), u = b(() => r.id ? String(r.id) : o), l = L(!1), s = L(), d = b(() => {
      var z;
      return !!((z = e.labelAttributes) != null && z.info || i["label-tooltip"]);
    }), c = b(() => r.required !== void 0 && String(r.required) !== "false"), f = b(() => r.disabled !== void 0 && String(r.disabled) !== "false"), v = b(() => r.readonly !== void 0 && String(r.readonly) !== "false"), m = {
      popoverClasses: `select-popover ${e.dropdownFooterText || i["dropdown-footer-text"] ? `has-${e.dropdownFooterTextPosition}-dropdown-footer` : ""}`,
      popoverTimeout: 0,
      placement: "bottom-start",
      hideCaret: !0
    }, C = L(0), p = mt("inputElement"), h = b(() => a(e.label, c.value)), g = L(!1), w = L(""), $ = b(() => {
      var z, Ce;
      return !(!w.value || (Ce = (z = M.value) == null ? void 0 : z.filter((xe) => xe.label === w.value)) != null && Ce.length);
    }), T = bt(), O = L(null), M = L([]), F = L(!1), q = mt("popperElement"), x = mt("selectWrapperElement"), Y = b({
      get() {
        return e.modelValue;
      },
      set(z) {
        var xe;
        const Ce = (xe = M.value) == null ? void 0 : xe.filter((De) => De.value === z);
        Ce != null && Ce.length ? Se(Ce[0]) : z || Ue();
      }
    }), R = b(() => Dt(e.width || "100%")), k = L(""), P = b(() => {
      const z = { ...r };
      return delete z.class, z;
    }), D = b(() => {
      var z;
      return {
        ...m,
        ...e.kpopAttributes,
        popoverClasses: `${m.popoverClasses} ${((z = e.kpopAttributes) == null ? void 0 : z.popoverClasses) ?? ""}`,
        width: String(k.value),
        maxWidth: String(k.value),
        disabled: f.value || v.value
      };
    }), B = b(() => Dt(e.dropdownMaxHeight)), J = b(() => ({ ...D.value })), _ = b(() => e.placeholder || r.placeholder || "Select..."), te = b(() => !f.value && e.clearable && !!O.value), G = b(() => !!(O.value && (i["selected-item-template"] || e.reuseItemTemplate && i["item-template"]))), pe = b(() => {
      let z = [];
      if (!e.enableFiltering || !w.value)
        z = M.value;
      else {
        const De = e.filterFunction({ query: w.value, items: M.value });
        z = De === !0 ? M.value : De;
      }
      const Ce = z.filter((De) => !De.group), xe = z.filter((De) => De.group).sort((De, qe) => De.group.toLowerCase().localeCompare(qe.group.toLowerCase()));
      return [...Ce, ...xe];
    }), ce = (z) => {
      if (!e.enableFiltering)
        return z.preventDefault(), !1;
    }, $e = (z) => {
      e.enableItemCreation && ge(), z.preventDefault();
    }, ge = () => {
      var xe, De;
      if (!e.enableItemCreation || !w.value || !$.value || !e.itemCreationValidator(w.value))
        return;
      const z = (((xe = M.value) == null ? void 0 : xe.length) || 0) + 1, Ce = {
        label: $u(w.value),
        value: ll(),
        key: `${(De = $u(w.value).replace(/ /gi, "-")) == null ? void 0 : De.replace(/[^a-z0-9-_]/gi, "")}-${z}`,
        custom: !0
      };
      n("item-added", Ce), Se(Ce, !0), w.value = "";
    }, Se = (z, Ce) => {
      var xe, De;
      Ce && ((xe = M.value) == null || xe.push(z)), (De = M.value) == null || De.forEach((qe, ct) => {
        var dt;
        qe.key === z.key ? (qe.selected = !0, O.value = qe) : qe.selected ? (qe.selected = !1, qe.custom && ((dt = M.value) == null || dt.splice(ct, 1), n("item-removed", qe))) : qe.selected = !1;
      }), g.value = !0, w.value = z.label;
    }, Ue = () => {
      var z;
      (z = M.value) == null || z.forEach((Ce, xe) => {
        var De;
        Ce.selected = !1, Ce.custom && ((De = M.value) == null || De.splice(xe, 1), n("item-removed", Ce));
      }), O.value = null, w.value = "", n("input", null), n("change", null), n("update:modelValue", null);
    }, Ne = mt("kSelectItems"), He = (z, Ce) => {
      var De, qe;
      if (z.keyCode === 27) {
        Ce.value = !1;
        return;
      }
      const xe = (De = x.value) == null ? void 0 : De.children[0];
      !Ce.value && xe && xe.click(), (z.key === "ArrowDown" || z.key === "ArrowUp") && Ce.value && ((qe = Ne.value) == null || qe.setFocus(z.key === "ArrowDown" ? "down" : "up"));
    }, Xe = (z) => {
      w.value !== z && (w.value = z);
    }, ot = () => {
      F.value = !0;
    }, Ge = () => {
      F.value = !1;
    }, Je = () => {
      var z, Ce, xe;
      e.enableFiltering || (xe = (Ce = (z = p.value) == null ? void 0 : z.$el) == null ? void 0 : Ce.querySelector("input")) == null || xe.blur();
    }, et = (z) => {
      var Ce;
      (f.value || ((Ce = z == null ? void 0 : z.target) == null ? void 0 : Ce.dataset.propagateClicks) === "false") && z.stopPropagation();
    }, ie = (z) => {
      z();
    }, le = (z, Ce) => {
      l.value = !1, O.value ? (g.value = !0, w.value = O.value.label) : w.value = "", Ce && z();
    }, fe = (z) => {
      l.value = !0, e.enableFiltering && (w.value = ""), z();
    };
    return ne(Y, (z, Ce) => {
      var xe;
      if (z !== Ce) {
        const De = (xe = M.value) == null ? void 0 : xe.filter((qe) => qe.value === z);
        De != null && De.length ? Se(De[0]) : z || Ue();
      }
    }), ne(() => e.items, (z, Ce) => {
      var xe, De, qe, ct, dt;
      if (JSON.stringify(z) !== JSON.stringify(Ce)) {
        M.value = JSON.parse(JSON.stringify(e.items)), (xe = M.value) != null && xe.length && (O.value = null);
        for (let Qe = 0; Qe < ((De = M.value) == null ? void 0 : De.length); Qe++) {
          M.value[Qe].selected === void 0 && (M.value[Qe].selected = !1);
          let pt = `${(ct = (qe = M.value[Qe].label) == null ? void 0 : qe.replace(/ /gi, "-")) == null ? void 0 : ct.replace(/[^a-z0-9-_]/gi, "")}-${Qe}`;
          pt.includes("undefined") && (pt = `select-item-label-${Qe}`), M.value[Qe].key = pt, (M.value[Qe].value === e.modelValue || M.value[Qe].selected) && (M.value[Qe].selected = !0, O.value = M.value[Qe], F.value || (g.value = !0, w.value = O.value.label)), ((dt = O.value) == null ? void 0 : dt.value) === M.value[Qe].value && (M.value[Qe].selected = !0);
        }
        q.value && typeof q.value.updatePopper == "function" && gt(() => {
          q.value.updatePopper();
        });
      }
    }, { deep: !0, immediate: !0 }), ne(w, (z) => {
      g.value && z || (n("query-change", z), g.value = !1);
    }), ne(O, (z, Ce) => {
      z && z !== Ce && (n("selected", z), n("input", z.value), n("change", z), n("update:modelValue", z.value));
    }, { deep: !0 }), rt(() => {
      x.value && (s.value = or.create(() => {
        var z;
        k.value = `${(z = x.value) == null ? void 0 : z.offsetWidth}px`;
      }), s.value.observe(x.value)), ia(document, "keydown", (z) => {
        var Ce, xe;
        !e.enableFiltering && ((Ce = document.activeElement) == null ? void 0 : Ce.tagName) === "BODY" && !F.value && l.value && (z.key === "ArrowDown" || z.key === "ArrowUp") && (z.preventDefault(), (xe = Ne.value) == null || xe.setFocus(z.key === "ArrowDown" ? "down" : "up"));
      });
    }), cn(() => {
      var z;
      x.value && ((z = s.value) == null || z.unobserve(x.value));
    }), (z, Ce) => (y(), S("div", {
      class: ue(["k-select", [z.$attrs.class]])
    }, [
      z.label ? (y(), ee(_a, Fe({
        key: 0,
        "data-testid": "select-label"
      }, z.labelAttributes, {
        for: u.value,
        required: c.value
      }), yt({
        default: N(() => [
          be(ae(h.value) + " ", 1)
        ]),
        _: 2
      }, [
        d.value ? {
          name: "tooltip",
          fn: N(() => [
            j(z.$slots, "label-tooltip", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["for", "required"])) : W("", !0),
      Z(Rs, null, {
        default: N(({ toggle: xe, isToggled: De }) => [
          Z(ir, Fe({ ref: "popperElement" }, J.value, {
            "close-on-popover-click": "",
            "hide-close-icon": "",
            onClose: () => le(xe, De.value),
            onOpen: () => fe(xe),
            onPopoverClick: () => ie(xe)
          }), {
            content: N(() => [
              H("div", {
                "aria-live": z.enableFiltering ? "polite" : "off"
              }, [
                z.enableFiltering && z.loading ? (y(), S("div", uz, [
                  j(z.$slots, "loading", {}, () => [
                    Z(A(Ri), {
                      class: "loading-icon",
                      title: "Loading"
                    })
                  ], !0)
                ])) : (y(), S("div", dz, [
                  Z(oz, {
                    ref: "kSelectItems",
                    "filter-string": w.value,
                    "item-creation-enabled": z.enableItemCreation && $.value,
                    "item-creation-valid": z.itemCreationValidator(w.value),
                    items: pe.value,
                    onAddItem: ge,
                    onSelected: Se
                  }, {
                    content: N(({ item: qe }) => [
                      j(z.$slots, "item-template", { item: qe }, void 0, !0)
                    ]),
                    _: 3
                  }, 8, ["filter-string", "item-creation-enabled", "item-creation-valid", "items"]),
                  !pe.value.length && !z.$slots.empty && !z.enableItemCreation ? (y(), ee(Qo, {
                    key: 0,
                    item: { label: "No results", value: "no_results", disabled: !0 }
                  })) : W("", !0),
                  (z.dropdownFooterText || z.$slots["dropdown-footer-text"]) && z.dropdownFooterTextPosition === "static" ? (y(), S("div", cz, [
                    j(z.$slots, "dropdown-footer-text", {}, () => [
                      be(ae(z.dropdownFooterText), 1)
                    ], !0)
                  ])) : W("", !0)
                ])),
                !z.loading && !pe.value.length && z.$slots.empty ? (y(), S("div", fz, [
                  j(z.$slots, "empty", {}, void 0, !0)
                ])) : W("", !0)
              ], 8, lz),
              (z.dropdownFooterText || z.$slots["dropdown-footer-text"]) && z.dropdownFooterTextPosition === "sticky" ? (y(), S("div", vz, [
                j(z.$slots, "dropdown-footer-text", {}, () => [
                  be(ae(z.dropdownFooterText), 1)
                ], !0)
              ])) : W("", !0)
            ]),
            default: N(() => [
              H("div", {
                id: A(T),
                ref: "selectWrapperElement",
                class: "select-wrapper",
                "data-testid": "select-wrapper",
                role: "listbox",
                onClick: et
              }, [
                (y(), ee(xn, Fe({
                  id: u.value,
                  key: C.value,
                  ref: "inputElement",
                  autocapitalize: "off",
                  autocomplete: "off",
                  autocorrect: "off",
                  class: ["select-input", { "filtering-disabled": !z.enableFiltering, "hide-model-value": G.value && (!z.enableFiltering || !De.value), "input-has-focus": F.value || De.value }],
                  "data-testid": "select-input",
                  disabled: f.value,
                  error: z.error,
                  "model-value": w.value,
                  placeholder: O.value && !z.enableFiltering ? O.value.label : _.value,
                  readonly: v.value,
                  spellcheck: "false"
                }, P.value, {
                  onBlur: Ge,
                  onClick: Je,
                  onFocus: ot,
                  onKeydown: lt($e, ["enter"]),
                  onKeypress: ce,
                  onKeyup: [
                    (qe) => He(qe, De),
                    Ce[0] || (Ce[0] = lt(Ke(() => {
                    }, ["stop"]), ["enter"]))
                  ],
                  "onUpdate:modelValue": Xe
                }), yt({
                  after: N(() => [
                    te.value ? (y(), S("button", {
                      key: 0,
                      "aria-label": "Clear",
                      class: "clear-selection-button",
                      "data-testid": "clear-selection-icon",
                      type: "button",
                      onClick: Ue
                    }, [
                      Z(A(va), { decorative: "" })
                    ])) : W("", !0),
                    v.value ? W("", !0) : (y(), ee(A(zs), {
                      key: 1,
                      class: ue(["chevron-down-icon", { disabled: f.value }]),
                      decorative: ""
                    }, null, 8, ["class"]))
                  ]),
                  _: 2
                }, [
                  i.before ? {
                    name: "before",
                    fn: N(() => [
                      j(z.$slots, "before", {}, void 0, !0)
                    ]),
                    key: "0"
                  } : void 0,
                  z.$slots["label-tooltip"] ? {
                    name: "label-tooltip",
                    fn: N(() => [
                      j(z.$slots, "label-tooltip", {}, void 0, !0)
                    ]),
                    key: "1"
                  } : void 0
                ]), 1040, ["id", "class", "disabled", "error", "model-value", "placeholder", "readonly", "onKeyup"])),
                Z(Zt, { name: "kongponents-fade-transition" }, {
                  default: N(() => [
                    G.value && (!z.enableFiltering || !De.value) ? (y(), S("div", {
                      key: 0,
                      class: ue(["custom-selected-item-wrapper", { clearable: z.clearable, readonly: v.value }])
                    }, [
                      j(z.$slots, "selected-item-template", {
                        item: O.value
                      }, () => [
                        j(z.$slots, "item-template", {
                          item: O.value
                        }, void 0, !0)
                      ], !0)
                    ], 2)) : W("", !0)
                  ]),
                  _: 2
                }, 1024)
              ], 8, sz)
            ]),
            _: 2
          }, 1040, ["onClose", "onOpen", "onPopoverClick"])
        ]),
        _: 3
      }),
      z.help ? (y(), S("p", {
        key: 1,
        class: ue(["help-text", { "select-error": z.error }])
      }, ae(z.help), 3)) : W("", !0)
    ], 2));
  }
}), hz = /* @__PURE__ */ Me(pz, [["__scopeId", "data-v-3b6cbddc"]]), gz = { class: "k-slideout" }, mz = { class: "slideout-header" }, yz = {
  key: 0,
  class: "slideout-title",
  "data-testid": "slideout-title"
}, bz = { class: "slideout-content" }, wz = /* @__PURE__ */ se({
  __name: "KSlideout",
  props: {
    visible: { type: Boolean },
    hasOverlay: { type: Boolean, default: !0 },
    offsetTop: { default: 0 },
    closeOnBlur: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    title: { default: "" },
    maxWidth: { default: "500px" },
    zIndex: { default: 9999 }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    Yt((u) => ({
      "8a679a5a": r.value,
      "5dace9c6": u.maxWidth,
      df700f08: u.zIndex
    }));
    const a = t, n = mt("slideoutContainerElement"), r = b(() => Dt(e.offsetTop));
    Zb(n, (u) => {
      u.isTrusted && e.closeOnBlur && a("close");
    });
    const i = (u, l = !1) => {
      (e.visible && u.keyCode === 27 && e.closeOnEscape || l) && a("close");
    }, o = (u) => {
      typeof document < "u" && (u ? document == null || document.addEventListener("keydown", i) : document == null || document.removeEventListener("keydown", i));
    };
    return ne(() => e.visible, async (u) => {
      o(!!u);
    }, { immediate: !0 }), qa(() => {
      o(!1);
    }), (u, l) => (y(), S("div", gz, [
      Z(Zt, { name: "kongponents-fade-transition" }, {
        default: N(() => [
          u.visible ? (y(), S("div", {
            key: 0,
            class: ue(["slideout-backdrop", { "backdrop-transparent": !u.hasOverlay }])
          }, null, 2)) : W("", !0)
        ]),
        _: 1
      }),
      Z(Zt, { name: "kongponents-slide-in-transition" }, {
        default: N(() => [
          u.visible ? (y(), S("div", {
            key: 0,
            ref_key: "slideoutContainerElement",
            ref: n,
            class: "slideout-container",
            "data-testid": "slideout-container"
          }, [
            H("div", mz, [
              u.title || u.$slots.title ? (y(), S("div", yz, [
                j(u.$slots, "title", {}, () => [
                  be(ae(u.title), 1)
                ], !0)
              ])) : W("", !0),
              H("button", {
                "aria-label": "Close",
                class: "slideout-close-icon",
                "data-testid": "slideout-close-icon",
                type: "button",
                onClick: l[0] || (l[0] = Ke((s) => u.$emit("close"), ["stop"]))
              }, [
                Z(A(va), {
                  color: `var(--kui-color-text-neutral, ${A(Fa)})`,
                  decorative: ""
                }, null, 8, ["color"])
              ])
            ]),
            H("div", bz, [
              j(u.$slots, "default", {}, void 0, !0)
            ])
          ], 512)) : W("", !0)
        ]),
        _: 3
      })
    ]));
  }
}), Cz = /* @__PURE__ */ Me(wz, [["__scopeId", "data-v-f640c6f5"]]), kz = ["aria-current", "data-testid"], $z = { class: "step-circle" }, Sz = /* @__PURE__ */ se({
  __name: "KStep",
  props: {
    label: {},
    state: { default: "default" },
    maxLabelWidth: {}
  },
  setup(e) {
    const t = b(() => ({
      maxWidth: Dt(e.maxLabelWidth)
    }));
    return (a, n) => (y(), S("li", {
      "aria-current": a.state === "active" ? "step" : "false",
      class: "step",
      "data-testid": `step-${a.state}`
    }, [
      H("div", {
        class: ue(["step-container", `${a.state}`])
      }, [
        H("div", $z, [
          a.state === "completed" ? (y(), ee(A(Z1), {
            key: 0,
            color: `var(--kui-color-text-inverse, ${A(Jl)})`,
            size: A(Vt),
            title: "Completed"
          }, null, 8, ["color", "size"])) : a.state === "pending" ? (y(), ee(A(Ri), {
            key: 1,
            color: `var(--kui-color-text-primary, ${A(fh)})`,
            size: A(Vt),
            title: "Pending"
          }, null, 8, ["color", "size"])) : a.state === "error" ? (y(), ee(A(va), {
            key: 2,
            color: `var(--kui-color-text-inverse, ${A(Jl)})`,
            size: A(Vt),
            title: "Error"
          }, null, 8, ["color", "size"])) : W("", !0)
        ]),
        H("span", {
          class: "step-label",
          style: Ee(t.value)
        }, ae(a.label), 5)
      ], 2)
    ], 8, kz));
  }
}), Tz = /* @__PURE__ */ Me(Sz, [["__scopeId", "data-v-e91d1bd8"]]), Dz = {
  key: 0,
  class: "k-stepper"
}, Az = /* @__PURE__ */ se({
  __name: "KStepper",
  props: {
    steps: {},
    maxLabelWidth: { default: "170px" }
  },
  setup(e) {
    return (t, a) => t.steps && t.steps.length ? (y(), S("ol", Dz, [
      (y(!0), S(Ae, null, Le(t.steps, (n) => (y(), ee(Tz, {
        key: `step-${n.label.replace(/ /gi, "-")}`,
        label: n.label,
        "max-label-width": t.maxLabelWidth,
        state: n.state
      }, null, 8, ["label", "max-label-width", "state"]))), 128))
    ])) : W("", !0);
  }
}), Iz = /* @__PURE__ */ Me(Az, [["__scopeId", "data-v-5d71bb60"]]), Ez = { class: "table-column-visibility-menu" }, Mz = { class: "apply-button-wrapper" }, Oz = /* @__PURE__ */ se({
  __name: "ColumnVisibilityMenu",
  props: {
    columns: {},
    tableId: {},
    visibilityPreferences: {},
    disabled: { type: Boolean }
  },
  emits: ["update"],
  setup(e, { emit: t }) {
    const a = t, n = L(!1), r = L({}), i = L(!1), o = L(), u = L(""), l = () => {
      r.value = e.columns.reduce((m, C) => (m[C.key] = e.visibilityPreferences[C.key] === void 0 ? !0 : e.visibilityPreferences[C.key], m), {}), i.value = !1;
    }, s = pF((m) => {
      u.value = m, o.value && v(o.value);
    }, 500), d = b(() => u.value ? e.columns.filter((m) => (m.label ? m.label : m.key).toLowerCase().includes(u.value.toLowerCase())) : e.columns), c = () => {
      a("update", JSON.parse(JSON.stringify(r.value))), i.value = !1, u.value = "";
    }, f = (m) => {
      n.value = m, m && o.value && gt(() => {
        o.value && v(o.value);
      }), !m && i.value && l(), m || (u.value = "");
    }, v = (m) => {
      if (!(m.scrollHeight > m.clientHeight)) {
        m.classList.remove("is-bottom-overflowing");
        return;
      }
      const p = m.scrollHeight < m.clientHeight + m.scrollTop + 1;
      m.classList.toggle("is-bottom-overflowing", !p);
    };
    return ne(() => e.visibilityPreferences, () => {
      l();
    }, { immediate: !0 }), rt(() => {
      o.value && (o.value.addEventListener("scroll", (m) => {
        const C = m.currentTarget;
        v(C);
      }), v(o.value));
    }), N1(() => {
      l();
    }), (m, C) => (y(), S("div", Ez, [
      Z(Br, {
        "data-testid": "table-column-visibility-menu",
        disabled: m.disabled,
        "kpop-attributes": { placement: "bottom-end" },
        onToggleDropdown: f
      }, {
        items: N(() => [
          u.value || d.value.length > 5 ? (y(), ee(xn, {
            key: 0,
            modelValue: u.value,
            "onUpdate:modelValue": C[1] || (C[1] = (p) => u.value = p),
            modelModifiers: { trim: !0 },
            autocomplete: "off",
            class: "search-input",
            "data-testid": "search-input",
            placeholder: "Search columns",
            type: "search",
            onClick: C[2] || (C[2] = Ke(() => {
            }, ["stop"])),
            onInput: A(s)
          }, yt({
            before: N(() => [
              Z(A(Nu), { decorative: "" })
            ]),
            _: 2
          }, [
            u.value ? {
              name: "after",
              fn: N(() => [
                Z(nt, {
                  appearance: "tertiary",
                  "aria-label": "Clear search",
                  class: "clear-search",
                  "data-testid": "clear-search-button",
                  icon: "",
                  size: "small",
                  onClick: C[0] || (C[0] = Ke(() => u.value = "", ["stop"]))
                }, {
                  default: N(() => [
                    Z(A(va), { decorative: "" })
                  ]),
                  _: 1
                })
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["modelValue", "onInput"])) : W("", !0),
          H("div", {
            ref_key: "menuItemsRef",
            ref: o,
            class: "menu-items-wrapper"
          }, [
            (y(!0), S(Ae, null, Le(d.value, (p) => (y(), ee(Wu, {
              key: p.key,
              class: "column-visibility-menu-item",
              "data-testid": `column-visibility-menu-item-${p.key}`,
              onClick: Ke(() => {
                r.value[p.key] = !r.value[p.key], i.value = !0;
              }, ["stop"])
            }, {
              default: N(() => [
                Z(ls, {
                  modelValue: r.value[p.key],
                  "onUpdate:modelValue": (h) => r.value[p.key] = h,
                  "aria-labelledby": `${m.tableId}-${p.key}-visibility-checkbox-label`,
                  "data-testid": `column-visibility-checkbox-${p.key}`
                }, null, 8, ["modelValue", "onUpdate:modelValue", "aria-labelledby", "data-testid"]),
                Z(_a, {
                  id: `${m.tableId}-${p.key}-visibility-checkbox-label`,
                  class: "visibility-checkbox-label",
                  title: p.label
                }, {
                  default: N(() => [
                    be(ae(p.label), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "title"])
              ]),
              _: 2
            }, 1032, ["data-testid", "onClick"]))), 128))
          ], 512),
          H("div", Mz, [
            Z(nt, {
              appearance: "tertiary",
              class: "apply-button",
              "data-testid": "apply-button",
              onClick: c
            }, {
              default: N(() => C[3] || (C[3] = [
                be(" Apply ")
              ])),
              _: 1,
              __: [3]
            })
          ])
        ]),
        default: N(() => [
          Z(ga, {
            placement: "bottom-end",
            text: n.value ? void 0 : "Show/Hide Columns"
          }, {
            default: N(() => [
              Z(nt, {
                appearance: "tertiary",
                "aria-label": "Show/Hide Columns",
                class: "menu-button",
                "data-testid": "column-visibility-menu-button",
                disabled: m.disabled,
                icon: "",
                size: "large"
              }, {
                default: N(() => [
                  Z(A(Ay), { decorative: "" })
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["text"])
        ]),
        _: 1
      }, 8, ["disabled"])
    ]));
  }
}), d1 = /* @__PURE__ */ Me(Oz, [["__scopeId", "data-v-0033fccb"]]), xz = { class: "k-table" }, Pz = {
  key: 0,
  class: "table-toolbar",
  "data-testid": "table-toolbar"
}, Nz = {
  key: 0,
  class: "toolbar-default-items-container"
}, Lz = {
  key: 2,
  class: "table-error-state",
  "data-testid": "table-error-state"
}, Bz = {
  key: 3,
  class: "table-empty-state",
  "data-testid": "table-empty-state"
}, Rz = {
  key: 4,
  class: "table-container"
}, Fz = ["data-tableid"], zz = ["aria-sort", "data-testid", "onClick", "onMouseover"], Yz = ["onMousedown", "onMouseover"], Hz = ["aria-describedby"], qz = ["onMousedown", "onMouseover"], Wz = ["role", "tabindex"], _z = /* @__PURE__ */ se({
  __name: "KTable",
  props: {
    /**
     * Allow columns to be resized
     */
    resizeColumns: {
      type: Boolean,
      default: !1
    },
    /**
     * Used to customize the initial state of the table.
     * Column visibility/width.
     */
    tablePreferences: {
      type: Object,
      default: () => ({})
    },
    /**
     * Enable client side sort - only do this if using a fetcher
     * that returns static data
     */
    clientSort: {
      type: Boolean,
      default: !1
    },
    /**
     * Enables hover highlighting to table rows
     */
    rowHover: {
      type: Boolean,
      default: !0
    },
    sortHandlerFunction: {
      type: Function,
      default: () => ({})
    },
    /**
     * A function that conditionally specifies row attributes on each row
     */
    rowAttrs: {
      type: Function,
      default: () => ({})
    },
    /**
     * A function that conditionally specifies cell attributes
     */
    cellAttrs: {
      type: Function,
      default: () => ({})
    },
    /**
     * A prop that enables a loading skeleton
     */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * A prop to pass in a custom empty state title
     */
    emptyStateTitle: {
      type: String,
      default: "No Data"
    },
    /**
     * A prop to pass in a custom empty state message
     */
    emptyStateMessage: {
      type: String,
      default: "There is no data to display."
    },
    /**
     * A prop to pass in a custom empty state action route
     */
    emptyStateActionRoute: {
      type: [Object, String],
      default: ""
    },
    /**
     * A prop to pass in a custom empty state action message
     */
    emptyStateActionMessage: {
      type: String,
      default: ""
    },
    emptyStateIconVariant: {
      type: String,
      default: xa.Default
    },
    /**
     * A prop that enables the error state
     */
    error: {
      type: Boolean,
      default: !1
    },
    /**
     * A prop to pass in a custom error state title
     */
    errorStateTitle: {
      type: String,
      default: "An error occurred"
    },
    /**
     * A prop to pass in a custom error state message
     */
    errorStateMessage: {
      type: String,
      default: "Data cannot be displayed due to an error."
    },
    /**
     * A prop to pass in a custom error state action route
     */
    errorStateActionRoute: {
      type: [Object, String],
      default: ""
    },
    /**
     * A prop to pass in a custom error state action message
     */
    errorStateActionMessage: {
      type: String,
      default: ""
    },
    /**
     * A prop to pass in a fetcher function to enable server-side search, sort
     * and pagination
     */
    fetcher: {
      type: Function,
      default: void 0,
      required: !0
    },
    /**
     * A prop to trigger a revalidate of the fetcher function. Modifying this value
     * will trigger a manual refetch of the table data.
     */
    fetcherCacheKey: {
      type: String,
      default: ""
    },
    /**
     * A prop used to uniquely identify this table in the swrv cache
     */
    cacheIdentifier: {
      type: String,
      default: ""
    },
    /**
     * A prop to pass in a search string for server-side search
     */
    searchInput: {
      type: String,
      default: ""
    },
    /**
     * A prop to pass in an array of headers for the table
     */
    headers: {
      type: Array,
      default: () => []
    },
    /**
     * A prop to pass in an object of intial params for the initial fetcher function call
     */
    initialFetcherParams: {
      type: Object,
      default: null
    },
    /**
     * A prop to pass in the number of pagination neighbors used by the pagination component
     */
    paginationNeighbors: {
      type: Number,
      default: 1
    },
    /**
     * A prop to pass in an array of page sizes used by the pagination component
     */
    paginationPageSizes: {
      type: Array,
      default: () => [15, 30, 50, 75, 100],
      validator: (e) => !!e.length && e.every((t) => typeof t == "number")
    },
    /**
     * A prop to pass the total number of items in the set for the pagination text
     */
    paginationTotalItems: {
      type: Number,
      default: null
    },
    disablePaginationPageJump: {
      type: Boolean,
      default: !1
    },
    sortable: {
      type: Boolean,
      default: !0
    },
    disablePagination: {
      type: Boolean,
      default: !1
    },
    paginationOffset: {
      type: Boolean,
      default: !1
    },
    /**
     * A prop to pass to hide pagination for total table records is less than or equal to pagesize
     */
    hidePaginationWhenOptional: {
      type: Boolean,
      default: !1
    },
    maxHeight: {
      type: String,
      default: "none"
    }
  },
  emits: ["cell-click", "row-click", "error-action-click", "empty-state-action-click", "update:table-preferences", "sort", "state"],
  setup(e, { emit: t }) {
    Yt((oe) => ({
      "5d6dfa67": et.value
    }));
    const { useDebounce: a, useRequest: n, useSwrvState: r, clientSideSorter: i } = Nn(), o = e, u = t, l = ea(), s = Tt(), d = bt(), c = {
      pageSize: 15,
      page: 1,
      query: "",
      sortColumnKey: "",
      sortColumnOrder: "desc",
      offset: null
    }, f = L([]), v = L(), m = L([]), C = L([]), p = L(""), h = L(""), g = L(""), w = b(() => m.value.filter((oe) => oe.hidable).length > 0), $ = b(() => !!(w.value && !o.error && !re.value && !o.loading && f.value && f.value.length)), T = b(() => m.value.filter((oe) => oe.hidable)), O = b(() => $.value ? o.tablePreferences.columnVisibility || {} : {}), M = L($.value ? o.tablePreferences.columnVisibility || {} : {}), F = L(0), q = L(!1), x = L(1), Y = L(15), R = L(""), k = L(""), P = L("desc"), D = L(null), B = L([]), J = L(!0), _ = L(!1), te = L(!1), G = b(() => !!s.toolbar || $.value), pe = b(() => ({
      maxHeight: Dt(o.maxHeight)
    })), ce = (oe) => `column-${oe}`, $e = (oe) => `tooltip-${oe}`, ge = (oe) => oe, Se = (oe, we) => (E, V) => {
      const K = /^on[^a-z]/, me = {};
      for (const he in we)
        K.test(he) && we[he] && (me[he] = we[he]);
      return Object.keys(me).reduce((he, Ve) => {
        if (Ve.indexOf(oe) === 0) {
          const Pe = Ve.split(oe);
          he[Pe[1]] = (je) => me[Ve](je, E, V);
        }
        return he;
      }, {});
    }, Ue = b(() => (oe, we) => {
      const E = Se("onRow:", l)(we, "row"), V = Se("onCell:", l)(oe, "cell"), K = ["a", "button", "label", "input", "select"];
      return E.click && (_.value = !0), {
        ...E,
        ...V,
        click(me) {
          const he = me.target.className;
          let Ve = K.includes(me.target.tagName.toLowerCase()), Pe = !1;
          typeof he == "string" || Array.isArray(he) ? Pe = he.includes("k-popover") : typeof he == "object" && (Pe = Object.keys(he).includes("k-popover")), me.target.closest(".popover-content") !== null && (Pe = !0);
          for (let je = 0; je < K.length; je++)
            if (me.target.closest(K[je]) !== null) {
              Ve = !0;
              break;
            }
          if ((!Ve || me.target.hasAttribute("disabled")) && !Pe && (E.click || V.click))
            if (V.click) {
              u("cell-click", { data: oe });
              const je = V.click(me, oe, "cell");
              typeof je == "function" && je(me, oe);
            } else {
              u("row-click", { data: we });
              const je = E.click(me, we, "row");
              typeof je == "function" && je(me, we);
            }
        }
      };
    }), Ne = L(o.resizeColumns ? o.tablePreferences.columnWidths || {} : {}), He = b(() => {
      const oe = {};
      for (const we in Ne.value) {
        if (!Ne.value[we])
          continue;
        const E = Ne.value[we] + "px";
        oe[we] = {
          width: E,
          maxWidth: E,
          minWidth: E
        };
      }
      return oe;
    }), Xe = (oe, we) => ({
      // display the resize handle on the right side of the column if resizeColumns is enabled, hovering current column, and not the last column
      "resize-hover": Ge.value === oe.key && o.resizeColumns && we !== C.value.length - 1,
      resizable: o.resizeColumns,
      // display sort control if column is sortable, label is visible, and sorting is not disabled
      sortable: o.sortable && !oe.hideLabel && !!oe.sortable,
      // display active sorting styles if column is currently sorted
      "active-sort": o.sortable && !oe.hideLabel && !!oe.sortable && oe.key === k.value,
      [P.value]: o.sortable && oe.key === k.value && !oe.hideLabel,
      "is-scrolled": q.value,
      "has-tooltip": !!oe.tooltip
    }), ot = b(() => p.value ? "resizing" : h.value ? "resize-hover" : g.value ? "th-hover" : ""), Ge = b(() => {
      switch (ot.value) {
        case "resizing":
          return p.value;
        case "resize-hover":
          return h.value;
        case "th-hover":
          return g.value;
        default:
          return "";
      }
    }), Je = b(() => {
      var oe;
      return (oe = v.value) == null ? void 0 : oe.querySelectorAll("th.resizable");
    }), et = b(() => {
      var we;
      const oe = (we = Je.value) == null ? void 0 : we.item(0);
      if (oe) {
        const E = window == null ? void 0 : window.getComputedStyle(oe);
        if (E != null && E.height)
          return `${parseInt(E.height, 10)}px`;
      }
      return "auto";
    }), ie = (oe, we) => {
      var Ve;
      if (oe.button !== 0)
        return;
      let E = 0, V = 0;
      p.value = we;
      let K = null;
      (Ve = Je.value) == null || Ve.forEach((Pe) => {
        Pe.getAttribute("data-testid") === `table-header-${we}` && (K = document == null ? void 0 : document.querySelector(`[data-tableid="${d}"] [data-testid="table-header-${we}"]`));
      });
      const me = (Pe) => {
        const je = Pe.clientX - E;
        K == null || K.setAttribute("style", `width: ${V + je}px`), Ne.value[we] = V + je;
      }, he = () => {
        p.value = "", document == null || document.removeEventListener("mousemove", me), document == null || document.removeEventListener("mouseup", he), Ct();
      };
      if (E = oe.clientX, K) {
        const Pe = window == null ? void 0 : window.getComputedStyle(K);
        Pe != null && Pe.width && (V = parseInt(Pe.width, 10)), document == null || document.addEventListener("mousemove", me), document == null || document.addEventListener("mouseup", he);
      }
    }, le = L(!0), fe = async () => {
      var E, V;
      const oe = o.searchInput, we = await o.fetcher({
        pageSize: Y.value,
        page: x.value,
        query: oe || R.value,
        sortColumnKey: k.value,
        sortColumnOrder: P.value,
        offset: D.value
      });
      return f.value = we.data, F.value = o.paginationTotalItems || we.total || ((E = we.data) == null ? void 0 : E.length), o.paginationOffset && ((V = we.pagination) != null && V.offset ? (xe.value = we.pagination.offset, B.value[x.value] || B.value.push(we.pagination.offset)) : xe.value = null, J.value = we.pagination && "hasNextPage" in we.pagination ? we.pagination.hasNextPage : !0), f.value.length === 0 && x.value > 1 && (x.value = 1, B.value = [null], D.value = null), le.value = !1, we;
    }, z = () => {
      const oe = {
        ...c,
        ...o.initialFetcherParams
      };
      x.value = oe.page ?? c.page, Y.value = oe.pageSize ?? c.pageSize, R.value = oe.query ?? c.query, k.value = oe.sortColumnKey ?? c.sortColumnKey, P.value = oe.sortColumnOrder ?? c.sortColumnOrder, o.clientSort && k.value && P.value && i(k.value, "", P.value, f.value), o.paginationOffset && (D.value = oe.offset, B.value.push(oe.offset)), o.headers && o.headers.length && (m.value = o.headers), te.value = !0;
    };
    ne(() => o.headers, (oe) => {
      oe && oe.length && (m.value = oe);
    }, { deep: !0 });
    const Ce = b(() => B.value[x.value - 1]), xe = L(null), De = b(() => {
      if (!o.fetcher || !te.value)
        return "";
      let oe = d;
      return o.cacheIdentifier && (oe = o.cacheIdentifier), o.fetcherCacheKey && (oe += `-${o.fetcherCacheKey}`), `k-table_${oe}`;
    }), qe = L(""), { debouncedFn: ct, generateDebouncedFn: dt } = a((oe) => {
      qe.value = oe;
    }, 350), Qe = dt(0), { data: pt, error: It, revalidate: Ot, isValidating: Gt } = n(
      () => De.value,
      () => fe(),
      { revalidateOnFocus: !1, revalidateDebounce: 0 }
    ), { state: ta, hasData: xt, swrvState: Mt } = r(pt, It, Gt), re = L(!0), ze = b(() => ({
      hasData: xt.value,
      state: ta.value
    })), U = b(() => re.value ? "loading" : It.value ? "error" : "success"), { debouncedFn: de, generateDebouncedFn: Ie } = a(Ot, 500), X = Ie(0), I = (oe) => {
      const { key: we, useSortHandlerFunction: E } = oe, V = k.value + "";
      x.value = 1, k.value ? we === k.value ? P.value === "asc" ? P.value = "desc" : P.value = "asc" : (k.value = we, P.value = "asc", B.value = [null]) : (k.value = we, P.value = "asc", B.value = [null]), o.clientSort ? E && o.sortHandlerFunction ? o.sortHandlerFunction({
        key: we,
        prevKey: V,
        sortColumnOrder: P.value,
        data: f.value
      }) : i(we, V, P.value, f.value) : o.paginationOffset || de(), Ct();
    }, Q = ({ page: oe }) => {
      x.value = oe;
    }, ve = ({ pageSize: oe }) => {
      B.value = [null], D.value = null, Y.value = oe, x.value = 1, Ct();
    }, ke = (oe) => {
      oe && oe.target && typeof oe.target.scrollTop == "number" && (oe.target.scrollTop > 1 ? q.value = !0 : oe.target.scrollTop === 0 && (q.value = !q.value));
    }, Ze = b(() => ({
      pageSize: Y.value,
      sortColumnKey: k.value,
      sortColumnOrder: P.value,
      ...o.resizeColumns ? { columnWidths: Ne.value } : {},
      ...w.value ? { columnVisibility: M.value } : {}
    })), Ct = () => {
      U.value === "success" && u("update:table-preferences", Ze.value);
    }, Pt = () => {
      x.value++, D.value = xe.value;
    }, ba = () => {
      x.value--, D.value = Ce.value;
    }, ua = b(() => !!(o.fetcher && !o.disablePagination && !(!o.paginationOffset && o.hidePaginationWhenOptional && F.value <= o.paginationPageSizes[0]) && !(o.paginationOffset && o.hidePaginationWhenOptional && !Ce.value && !xe.value && f.value.length < o.paginationPageSizes[0]))), da = (oe) => oe.toLowerCase().replace(/[^[a-z0-9]/gi, "-");
    ne([M, m], (oe) => {
      const we = oe[0], V = oe[1].filter((K) => we[K.key] !== !1);
      JSON.stringify(V) !== JSON.stringify(C.value) && (C.value = V, Ct());
    }, { deep: !0, immediate: !0 }), ne(pt, (oe) => {
      oe != null && oe.length && !f.value.length && (f.value = oe);
    }, { deep: !0, immediate: !0 }), ne(ta, () => {
      switch (ta.value) {
        case Mt.PENDING:
          re.value = !0;
          break;
        case Mt.VALIDATING_HAS_DATA:
          re.value = kt.value;
          break;
        default:
          re.value = !1;
          break;
      }
    }, { immediate: !0 }), ne([ze, U], (oe) => {
      var we;
      u("state", {
        state: oe == null ? void 0 : oe[1],
        // newData[tableState]
        hasData: (we = oe == null ? void 0 : oe[0]) == null ? void 0 : we.hasData
        // newData[stateData].hasData
      });
    }), ne(() => o.searchInput, (oe) => {
      x.value !== 1 && (x.value = 1), oe === "" ? Qe(oe) : ct(oe);
    }, { immediate: !0 });
    const kt = L(!1);
    return ne([qe, x, Y], async (oe, we) => {
      const E = we == null ? void 0 : we[0], V = oe[0], K = oe[1];
      V !== E && K !== 1 && (x.value = 1, B.value = [null], D.value = null), te.value && !le.value && (kt.value = !0, V !== "" && V !== E ? await de() : await X(), kt.value = !1);
    }, { deep: !0, immediate: !0 }), ne($, (oe) => {
      oe && (M.value = o.tablePreferences.columnVisibility || {});
    }, { immediate: !0 }), rt(() => {
      console.warn(`The Kongponents 'KTable' component is deprecated and will be removed in the next major release.
We suggest using 'KTableData' component instead.
Docs: https://kongponents.konghq.com/components/table-data.html`), z();
    }), (oe, we) => (y(), S("div", xz, [
      G.value ? (y(), S("div", Pz, [
        j(oe.$slots, "toolbar", { state: ze.value }, void 0, !0),
        $.value ? (y(), S("div", Nz, [
          Z(d1, {
            columns: T.value,
            "table-id": A(d),
            "visibility-preferences": O.value,
            onUpdate: we[0] || (we[0] = (E) => M.value = E)
          }, null, 8, ["columns", "table-id", "visibility-preferences"])
        ])) : W("", !0)
      ])) : W("", !0),
      (re.value || e.loading || kt.value) && !e.error ? (y(), ee(Us, {
        key: 1,
        "data-testid": "table-skeleton",
        type: "table"
      })) : e.error ? (y(), S("div", Lz, [
        j(oe.$slots, "error-state", {}, () => [
          Z(Xn, {
            "icon-variant": "error",
            message: e.errorStateMessage,
            title: e.errorStateTitle
          }, yt({ _: 2 }, [
            e.errorStateActionMessage ? {
              name: "action",
              fn: N(() => [
                Z(nt, {
                  "data-testid": da(e.errorStateActionMessage),
                  to: e.errorStateActionRoute ? e.errorStateActionRoute : void 0,
                  onClick: we[1] || (we[1] = (E) => oe.$emit("error-action-click"))
                }, {
                  default: N(() => [
                    be(ae(e.errorStateActionMessage), 1)
                  ]),
                  _: 1
                }, 8, ["data-testid", "to"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["message", "title"])
        ], !0)
      ])) : !e.error && !re.value && !e.loading && !kt.value && f.value && !f.value.length ? (y(), S("div", Bz, [
        j(oe.$slots, "empty-state", {}, () => [
          Z(Xn, {
            "icon-variant": e.emptyStateIconVariant,
            message: e.emptyStateMessage,
            title: e.emptyStateTitle
          }, yt({ _: 2 }, [
            e.emptyStateActionMessage ? {
              name: "action",
              fn: N(() => [
                Z(nt, {
                  appearance: e.searchInput ? "tertiary" : "primary",
                  "data-testid": da(e.emptyStateActionMessage),
                  to: e.emptyStateActionRoute ? e.emptyStateActionRoute : void 0,
                  onClick: we[2] || (we[2] = (E) => oe.$emit("empty-state-action-click"))
                }, {
                  default: N(() => [
                    j(oe.$slots, "empty-state-action-icon", {}, void 0, !0),
                    be(" " + ae(e.emptyStateActionMessage), 1)
                  ]),
                  _: 3
                }, 8, ["appearance", "data-testid", "to"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["icon-variant", "message", "title"])
        ], !0)
      ])) : (y(), S("div", Rz, [
        H("div", {
          class: "table-wrapper",
          style: Ee(pe.value),
          onScrollPassive: ke
        }, [
          H("table", {
            class: ue(["table", {
              "has-hover": e.rowHover,
              "is-clickable": _.value
            }]),
            "data-tableid": A(d)
          }, [
            H("thead", {
              class: ue({ "is-scrolled": q.value })
            }, [
              H("tr", {
                ref_key: "headerRow",
                ref: v,
                class: ue({ "is-scrolled": q.value })
              }, [
                (y(!0), S(Ae, null, Le(C.value, (E, V) => (y(), S("th", {
                  key: `table-${A(d)}-headers-${V}`,
                  "aria-sort": e.sortable && E.key === k.value ? P.value === "asc" ? "ascending" : "descending" : void 0,
                  class: ue(["table-headers", Xe(E, V)]),
                  "data-testid": `table-header-${E.key}`,
                  style: Ee(He.value[E.key]),
                  onClick: () => {
                    e.sortable && E.sortable && (oe.$emit("sort", {
                      prevKey: k.value,
                      sortColumnKey: E.key,
                      sortColumnOrder: P.value === "asc" ? "desc" : "asc"
                      // display opposite because sortColumnOrder outdated
                    }), I(E));
                  },
                  onMouseleave: we[7] || (we[7] = (K) => g.value = ""),
                  onMouseover: (K) => g.value = E.key
                }, [
                  e.resizeColumns && V !== 0 ? (y(), S("div", {
                    key: 0,
                    class: "resize-handle previous",
                    onClick: we[3] || (we[3] = Ke(() => {
                    }, ["stop"])),
                    onMousedown: (K) => ie(K, C.value[V - 1].key),
                    onMouseleave: we[4] || (we[4] = (K) => h.value = ""),
                    onMouseover: (K) => h.value = C.value[V - 1].key
                  }, null, 40, Yz)) : W("", !0),
                  H("div", {
                    "aria-describedby": E.tooltip || oe.$slots[$e(E.key)] ? `${$e(E.key)}-${A(d)}` : void 0,
                    class: ue(["table-headers-container", { resized: p.value === E.key }])
                  }, [
                    j(oe.$slots, ce(E.key), {
                      column: ge(E)
                    }, () => [
                      H("span", {
                        class: ue(["table-header-label", {
                          "sr-only": E.hideLabel
                        }])
                      }, ae(E.label ? E.label : E.key), 3)
                    ], !0),
                    E.tooltip || oe.$slots[$e(E.key)] ? (y(), ee(ga, {
                      key: 0,
                      "data-testid": $e(E.key),
                      "tooltip-id": `${$e(E.key)}-${A(d)}`
                    }, {
                      content: N(() => [
                        j(oe.$slots, $e(E.key), {
                          column: ge(E)
                        }, () => [
                          be(ae(E.tooltip), 1)
                        ], !0)
                      ]),
                      default: N(() => [
                        Z(A(In), {
                          class: "header-tooltip-trigger",
                          color: `var(--kui-color-text-neutral, ${A(Fa)})`,
                          size: A(Ca)
                        }, null, 8, ["color", "size"])
                      ]),
                      _: 2
                    }, 1032, ["data-testid", "tooltip-id"])) : W("", !0),
                    e.sortable && !E.hideLabel && E.sortable ? (y(), ee(A(Ou), {
                      key: 1,
                      class: "sort-icon",
                      color: `var(--kui-color-text-neutral, ${A(Fa)})`,
                      size: A(Ca)
                    }, null, 8, ["color", "size"])) : W("", !0)
                  ], 10, Hz),
                  e.resizeColumns && V !== C.value.length - 1 ? (y(), S("div", {
                    key: 1,
                    class: "resize-handle",
                    onClick: we[5] || (we[5] = Ke(() => {
                    }, ["stop"])),
                    onMousedown: (K) => ie(K, E.key),
                    onMouseleave: we[6] || (we[6] = (K) => h.value = ""),
                    onMouseover: (K) => h.value = E.key
                  }, null, 40, qz)) : W("", !0)
                ], 46, zz))), 128))
              ], 2)
            ], 2),
            H("tbody", null, [
              (y(!0), S(Ae, null, Le(f.value, (E, V) => (y(), S("tr", Fe({ ref_for: !0 }, e.rowAttrs(E), {
                key: `table-${A(d)}-row-${V}`,
                role: _.value ? "link" : null,
                tabindex: _.value ? 0 : null
              }), [
                (y(!0), S(Ae, null, Le(C.value, (K, me) => (y(), S("td", Fe({ ref_for: !0 }, e.cellAttrs({ headerKey: K.key, row: E, rowIndex: V, colIndex: me }), {
                  key: `table-${A(d)}-cell-${me}`,
                  class: {
                    "resize-hover": e.resizeColumns && Ge.value === K.key && me !== C.value.length - 1
                  },
                  style: He.value[K.key]
                }, Bs(Ue.value(E[K.key], E), !0)), [
                  j(oe.$slots, K.key, {
                    row: ge(E),
                    rowKey: V,
                    rowValue: E[K.key]
                  }, () => [
                    be(ae(E[K.key]), 1)
                  ], !0)
                ], 16))), 128))
              ], 16, Wz))), 128))
            ])
          ], 10, Fz)
        ], 36),
        ua.value ? (y(), ee(Vs, {
          key: 0,
          class: "table-pagination",
          "current-page": x.value,
          "data-testid": "table-pagination",
          "disable-page-jump": e.disablePaginationPageJump,
          "initial-page-size": Y.value,
          neighbors: e.paginationNeighbors,
          offset: e.paginationOffset,
          "offset-next-button-disabled": !xe.value || !J.value,
          "offset-previous-button-disabled": !Ce.value,
          "page-sizes": e.paginationPageSizes,
          "total-count": F.value,
          onGetNextOffset: Pt,
          onGetPreviousOffset: ba,
          onPageChange: Q,
          onPageSizeChange: ve
        }, null, 8, ["current-page", "disable-page-jump", "initial-page-size", "neighbors", "offset", "offset-next-button-disabled", "offset-previous-button-disabled", "page-sizes", "total-count"])) : W("", !0)
      ]))
    ]));
  }
}), Uz = /* @__PURE__ */ Me(_z, [["__scopeId", "data-v-1e08f4e8"]]), Vz = { class: "k-tabs" }, Kz = {
  "aria-label": "Tabs",
  role: "tablist"
}, jz = ["id", "data-testid"], Gz = ["id", "aria-labelledby"], Qz = /* @__PURE__ */ se({
  __name: "KTabs",
  props: {
    tabs: {},
    modelValue: { default: "" },
    hidePanels: { type: Boolean },
    anchorTabindex: { default: 0 },
    beforeChange: { default: () => () => !0 }
  },
  emits: ["update:modelValue", "change"],
  setup(e, { emit: t }) {
    var u;
    const a = t, n = L(e.modelValue ? e.modelValue : (u = e.tabs[0]) == null ? void 0 : u.hash), r = async (l) => {
      (typeof e.beforeChange != "function" || await e.beforeChange(l)) && (n.value = l, a("change", l), a("update:modelValue", l));
    }, i = (l) => l.replace("#", ""), o = (l) => l.disabled ? "-1" : typeof e.anchorTabindex == "number" && e.anchorTabindex >= -1 && e.anchorTabindex <= 32767 ? String(e.anchorTabindex) : "0";
    return ne(() => e.modelValue, (l) => {
      n.value = l;
    }), (l, s) => (y(), S("div", Vz, [
      H("ul", Kz, [
        (y(!0), S(Ae, null, Le(l.tabs, (d) => (y(), S("li", {
          id: `${d.hash.replace("#", "")}-tab`,
          key: d.hash,
          class: ue(["tab-item", { active: n.value === d.hash }]),
          "data-testid": `${d.hash.replace("#", "")}-tab`
        }, [
          Z(nt, {
            appearance: "none",
            "aria-controls": l.hidePanels ? void 0 : `panel-${d.hash}`,
            "aria-selected": l.hidePanels ? void 0 : n.value === d.hash ? "true" : "false",
            class: ue(["tab-link", { disabled: d.disabled }]),
            disabled: d.disabled,
            role: "tab",
            tabindex: o(d),
            to: d.to,
            onClick: [
              (c) => d.disabled ? void 0 : r(d.hash),
              Ke((c) => d.disabled ? void 0 : r(d.hash), ["prevent"])
            ],
            onKeydown: [
              lt(Ke((c) => d.disabled ? void 0 : r(d.hash), ["prevent"]), ["enter"]),
              lt(Ke((c) => d.disabled ? void 0 : r(d.hash), ["prevent"]), ["space"])
            ]
          }, {
            default: N(() => [
              j(l.$slots, `${i(d.hash)}-anchor`, {}, () => [
                H("span", null, ae(d.title), 1)
              ])
            ]),
            _: 2
          }, 1032, ["aria-controls", "aria-selected", "class", "disabled", "tabindex", "to", "onClick", "onKeydown"])
        ], 10, jz))), 128))
      ]),
      l.hidePanels ? W("", !0) : (y(!0), S(Ae, { key: 0 }, Le(l.tabs, (d, c) => (y(), S("div", {
        id: `panel-${c}`,
        key: d.hash,
        "aria-labelledby": `${i(d.hash)}-tab`,
        class: "tab-container",
        role: "tabpanel"
      }, [
        n.value === d.hash ? j(l.$slots, i(d.hash), { key: 0 }) : W("", !0)
      ], 8, Gz))), 128))
    ]));
  }
}), Zz = /* @__PURE__ */ Me(Qz, [["__scopeId", "data-v-1bf1622c"]]), Xz = ["data-value"], Jz = ["id", "aria-invalid", "rows", "value"], Rl = 2048, Pp = fg ? 0 : vg(), Np = J$("field-sizing", "content"), eY = /* @__PURE__ */ se({
  inheritAttrs: !1,
  __name: "KTextArea",
  props: {
    modelValue: { default: "" },
    label: { default: "" },
    labelAttributes: { default: () => ({}) },
    characterLimit: { type: [Boolean, Number], default: () => Rl },
    rows: { default: 5 },
    error: { type: Boolean },
    resizable: { type: Boolean },
    autosize: { type: Boolean },
    help: { default: "" },
    isResizable: { type: Boolean },
    hasError: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "char-limit-exceeded"],
  setup(e, { emit: t }) {
    Yt((T) => ({
      "2fd719a0": T.rows
    })), ne(() => e.isResizable, (T) => {
      T && console.warn("KTextArea: `isResizable` prop is deprecated in favor of `resizable` prop. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#ktextarea");
    }, { immediate: !0 }), ne(() => e.hasError, (T) => {
      T && console.warn("KTextArea: `hasError` prop is deprecated. Please use `error` prop instead. See the migration guide for more details: https://kongponents.konghq.com/guide/migrating-to-version-9.html#ktextarea");
    }, { immediate: !0 });
    const a = t, n = ea(), r = Tt(), { stripRequiredLabel: i } = Nn(), o = b(() => (n == null ? void 0 : n.required) !== void 0 && String(n == null ? void 0 : n.required) !== "false"), u = L(""), l = b(() => i(e.label, o.value)), s = b(() => {
      var T, O;
      return !!((T = e.labelAttributes) != null && T.help || (O = e.labelAttributes) != null && O.info || r["label-tooltip"]);
    }), d = b(() => e.error || e.hasError || p.value ? !0 : void 0), c = L(0), f = b({
      get() {
        return e.modelValue;
      },
      set(T) {
        h({ target: { value: T } });
      }
    }), v = bt(), m = b(() => n.id ? String(n.id) : v), C = b(() => {
      const T = { ...n };
      return delete T.class, T;
    }), p = b(() => typeof e.characterLimit == "boolean" ? e.characterLimit ? u.value.length > Rl : !1 : u.value.length > e.characterLimit), h = (T) => {
      var M;
      const O = JSON.parse(JSON.stringify((M = T == null ? void 0 : T.target) == null ? void 0 : M.value));
      a("input", O), a("update:modelValue", O), u.value = O;
    }, g = b(() => {
      var O;
      const T = typeof e.characterLimit == "number" ? e.characterLimit : Rl;
      return p.value ? `${(O = u.value) == null ? void 0 : O.toString().length} / ${T}` : e.help;
    });
    ne(p, (T, O) => {
      T !== O && (a("char-limit-exceeded", {
        value: u.value,
        length: u.value.length,
        characterLimit: Number(e.characterLimit),
        limitExceeded: T
      }), c.value += 1);
    }), ne(f, (T, O) => {
      T !== O && h({ target: { value: T } });
    });
    const w = () => u.value ? u.value : e.modelValue, $ = fg ? () => {
    } : (T) => {
      const { target: O, clientX: M, clientY: F } = T;
      if (!(O instanceof HTMLTextAreaElement))
        return;
      const { right: q, bottom: x } = O.getBoundingClientRect();
      M > q - Pp && F > x - Pp && (O.style.height = "");
    };
    return (T, O) => (y(), S("div", {
      class: ue(["k-textarea", [T.$attrs.class, { "input-error": T.error || T.hasError || p.value }]])
    }, [
      T.label ? (y(), ee(_a, Fe({
        key: 0,
        for: m.value
      }, T.labelAttributes, { required: o.value }), yt({
        default: N(() => [
          be(ae(l.value) + " ", 1)
        ]),
        _: 2
      }, [
        s.value ? {
          name: "tooltip",
          fn: N(() => [
            j(T.$slots, "label-tooltip", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["for", "required"])) : W("", !0),
      H("div", {
        class: ue(["input-textarea-wrapper", {
          autosize: T.autosize,
          legacy: T.autosize && !A(Np)
        }]),
        "data-allow-mismatch": "class",
        "data-value": A(Np) ? null : u.value
      }, [
        H("textarea", Fe({ id: m.value }, C.value, {
          "aria-invalid": d.value,
          class: ["input-textarea", {
            resizable: T.resizable || T.isResizable
          }],
          rows: T.rows,
          value: w(),
          onDblclick: O[0] || (O[0] = //@ts-ignore
          (...M) => A($) && A($)(...M)),
          onInput: h
        }), null, 16, Jz)
      ], 10, Xz),
      Z(Zt, {
        mode: "out-in",
        name: "kongponents-fade-transition"
      }, {
        default: N(() => [
          g.value ? (y(), S("p", {
            key: String(c.value),
            class: "help-text"
          }, ae(g.value), 1)) : W("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), tY = /* @__PURE__ */ Me(eY, [["__scopeId", "data-v-00443db2"]]), aY = { class: "toaster-icon-container" }, nY = { class: "toaster-content" }, rY = {
  key: 0,
  class: "toaster-title"
}, iY = {
  key: 1,
  class: "toaster-message"
}, oY = ["onClick"], sY = /* @__PURE__ */ se({
  __name: "KToaster",
  props: {
    toasterState: { default: () => [] },
    zIndex: { default: 1e4 }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    Yt((r) => ({
      "6f45326c": r.zIndex
    }));
    const a = t, n = (r) => {
      switch (r) {
        case "info":
          return In;
        case "success":
          return sh;
        case "warning":
          return Lu;
        case "danger":
          return ny;
        case "system":
          return Pu;
        default:
          return In;
      }
    };
    return (r, i) => (y(), ee(L1, {
      class: "k-toaster",
      name: "kongponents-slide-up-transition",
      tag: "div"
    }, {
      default: N(() => [
        (y(!0), S(Ae, null, Le(r.toasterState, (o) => (y(), S("div", {
          key: o.key,
          class: ue(["toaster", `${o.appearance}`]),
          role: "alert"
        }, [
          H("div", aY, [
            (y(), ee(Ye(n(o.appearance)), {
              class: "toaster-icon",
              color: `var(--kui-color-text, ${A(Py)})`,
              decorative: ""
            }, null, 8, ["color"]))
          ]),
          H("div", nY, [
            o.title ? (y(), S("span", rY, ae(o.title), 1)) : W("", !0),
            o.message ? (y(), S("p", iY, ae(o.message), 1)) : W("", !0)
          ]),
          H("button", {
            "aria-label": "Close",
            class: "toaster-close-icon",
            "data-testid": "toaster-close-icon",
            type: "button",
            onClick: Ke((u) => a("close", o.key), ["stop"])
          }, [
            Z(A(va), {
              color: `var(--kui-color-text-neutral-weak, ${A(ch)})`,
              size: A(Ry)
            }, null, 8, ["color", "size"])
          ], 8, oY)
        ], 2))), 128))
      ]),
      _: 1
    }));
  }
}), c1 = /* @__PURE__ */ Me(sY, [["__scopeId", "data-v-1b3f294e"]]), lY = "kongponents-toaster-container", Fl = {
  timeoutMilliseconds: 5e3,
  appearance: ih.info
}, uY = 1e4;
class dY {
  constructor(t) {
    Xa(this, "toastersContainer", null);
    Xa(this, "toaster", null);
    Xa(this, "toasts", L([]));
    if (typeof document > "u") {
      console.warn("ToastManager should only be initialized in the browser environment. Docs: https://kongponents.konghq.com/components/toaster.html");
      return;
    }
    this.toastersContainer = document.createElement("div"), this.toastersContainer.id = lY, document.body.appendChild(this.toastersContainer), this.toaster = Z(c1, {
      toasterState: this.toasts.value,
      zIndex: t != null && t.zIndex ? t.zIndex : uY,
      onClose: (a) => this.close(a)
    }), this.toastersContainer && Bd(this.toaster, this.toastersContainer);
  }
  setTimer(t, a) {
    return setTimeout(() => this.close(t), a);
  }
  open(t) {
    const { key: a, timeoutMilliseconds: n, appearance: r, message: i, title: o } = t, u = a ? String(a) : ll(), l = r && Object.keys(ih).indexOf(r) !== -1 ? r : Fl.appearance, s = this.setTimer(a, n || Fl.timeoutMilliseconds), d = typeof t == "string" ? t : i;
    this.toasts.value.push({
      key: u,
      appearance: l,
      title: o,
      message: d,
      timer: s,
      timeoutMilliseconds: n || Fl.timeoutMilliseconds
    });
  }
  close(t) {
    var n, r;
    const a = (n = this.toasts.value) == null ? void 0 : n.findIndex((i) => t === i.key);
    clearTimeout((r = this.toasts.value[a]) == null ? void 0 : r.timer), this.toasts.value.splice(a, 1);
  }
  closeAll() {
    this.toasts.value.forEach((t) => clearTimeout(t == null ? void 0 : t.timer)), this.toasts.value = [];
  }
  destroy() {
    this.toastersContainer && (Bd(null, this.toastersContainer), this.toastersContainer.remove());
  }
}
/*!
  * vue-draggable-next v2.2.0
  * (c) 2023 Anish George
  * @license MIT
  */
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function Lp(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), a.push.apply(a, n);
  }
  return a;
}
function Ha(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Lp(Object(a), !0).forEach(function(n) {
      cY(e, n, a[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : Lp(Object(a)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(a, n));
    });
  }
  return e;
}
function Zo(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Zo = function(t) {
    return typeof t;
  } : Zo = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Zo(e);
}
function cY(e, t, a) {
  return t in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}
function dn() {
  return dn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];
      for (var n in a)
        Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
    }
    return e;
  }, dn.apply(this, arguments);
}
function fY(e, t) {
  if (e == null) return {};
  var a = {}, n = Object.keys(e), r, i;
  for (i = 0; i < n.length; i++)
    r = n[i], !(t.indexOf(r) >= 0) && (a[r] = e[r]);
  return a;
}
function vY(e, t) {
  if (e == null) return {};
  var a = fY(e, t), n, r;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      n = i[r], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (a[n] = e[n]);
  }
  return a;
}
var pY = "1.14.0";
function nn(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var gn = nn(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), Wi = nn(/Edge/i), Bp = nn(/firefox/i), ki = nn(/safari/i) && !nn(/chrome/i) && !nn(/android/i), f1 = nn(/iP(ad|od|hone)/i), hY = nn(/chrome/i) && nn(/android/i), v1 = {
  capture: !1,
  passive: !1
};
function at(e, t, a) {
  e.addEventListener(t, a, !gn && v1);
}
function tt(e, t, a) {
  e.removeEventListener(t, a, !gn && v1);
}
function Os(e, t) {
  if (t) {
    if (t[0] === ">" && (t = t.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(t);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(t);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(t);
      } catch {
        return !1;
      }
    return !1;
  }
}
function gY(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function Oa(e, t, a, n) {
  if (e) {
    a = a || document;
    do {
      if (t != null && (t[0] === ">" ? e.parentNode === a && Os(e, t) : Os(e, t)) || n && e === a)
        return e;
      if (e === a) break;
    } while (e = gY(e));
  }
  return null;
}
var Rp = /\s+/g;
function aa(e, t, a) {
  if (e && t)
    if (e.classList)
      e.classList[a ? "add" : "remove"](t);
    else {
      var n = (" " + e.className + " ").replace(Rp, " ").replace(" " + t + " ", " ");
      e.className = (n + (a ? " " + t : "")).replace(Rp, " ");
    }
}
function Be(e, t, a) {
  var n = e && e.style;
  if (n) {
    if (a === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? a = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (a = e.currentStyle), t === void 0 ? a : a[t];
    !(t in n) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), n[t] = a + (typeof a == "string" ? "" : "px");
  }
}
function Pr(e, t) {
  var a = "";
  if (typeof e == "string")
    a = e;
  else
    do {
      var n = Be(e, "transform");
      n && n !== "none" && (a = n + " " + a);
    } while (!t && (e = e.parentNode));
  var r = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return r && new r(a);
}
function p1(e, t, a) {
  if (e) {
    var n = e.getElementsByTagName(t), r = 0, i = n.length;
    if (a)
      for (; r < i; r++)
        a(n[r], r);
    return n;
  }
  return [];
}
function Ra() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function Et(e, t, a, n, r) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var i, o, u, l, s, d, c;
    if (e !== window && e.parentNode && e !== Ra() ? (i = e.getBoundingClientRect(), o = i.top, u = i.left, l = i.bottom, s = i.right, d = i.height, c = i.width) : (o = 0, u = 0, l = window.innerHeight, s = window.innerWidth, d = window.innerHeight, c = window.innerWidth), (t || a) && e !== window && (r = r || e.parentNode, !gn))
      do
        if (r && r.getBoundingClientRect && (Be(r, "transform") !== "none" || a && Be(r, "position") !== "static")) {
          var f = r.getBoundingClientRect();
          o -= f.top + parseInt(Be(r, "border-top-width")), u -= f.left + parseInt(Be(r, "border-left-width")), l = o + i.height, s = u + i.width;
          break;
        }
      while (r = r.parentNode);
    if (n && e !== window) {
      var v = Pr(r || e), m = v && v.a, C = v && v.d;
      v && (o /= C, u /= m, c /= m, d /= C, l = o + d, s = u + c);
    }
    return {
      top: o,
      left: u,
      bottom: l,
      right: s,
      width: c,
      height: d
    };
  }
}
function Fp(e, t, a) {
  for (var n = Tn(e, !0), r = Et(e)[t]; n; ) {
    var i = Et(n)[a], o = void 0;
    if (o = r >= i, !o) return n;
    if (n === Ra()) break;
    n = Tn(n, !1);
  }
  return !1;
}
function _r(e, t, a, n) {
  for (var r = 0, i = 0, o = e.children; i < o.length; ) {
    if (o[i].style.display !== "none" && o[i] !== Re.ghost && (n || o[i] !== Re.dragged) && Oa(o[i], a.draggable, e, !1)) {
      if (r === t)
        return o[i];
      r++;
    }
    i++;
  }
  return null;
}
function xd(e, t) {
  for (var a = e.lastElementChild; a && (a === Re.ghost || Be(a, "display") === "none" || t && !Os(a, t)); )
    a = a.previousElementSibling;
  return a || null;
}
function ca(e, t) {
  var a = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== Re.clone && (!t || Os(e, t)) && a++;
  return a;
}
function zp(e) {
  var t = 0, a = 0, n = Ra();
  if (e)
    do {
      var r = Pr(e), i = r.a, o = r.d;
      t += e.scrollLeft * i, a += e.scrollTop * o;
    } while (e !== n && (e = e.parentNode));
  return [t, a];
}
function mY(e, t) {
  for (var a in e)
    if (e.hasOwnProperty(a)) {
      for (var n in t)
        if (t.hasOwnProperty(n) && t[n] === e[a][n]) return Number(a);
    }
  return -1;
}
function Tn(e, t) {
  if (!e || !e.getBoundingClientRect) return Ra();
  var a = e, n = !1;
  do
    if (a.clientWidth < a.scrollWidth || a.clientHeight < a.scrollHeight) {
      var r = Be(a);
      if (a.clientWidth < a.scrollWidth && (r.overflowX == "auto" || r.overflowX == "scroll") || a.clientHeight < a.scrollHeight && (r.overflowY == "auto" || r.overflowY == "scroll")) {
        if (!a.getBoundingClientRect || a === document.body) return Ra();
        if (n || t) return a;
        n = !0;
      }
    }
  while (a = a.parentNode);
  return Ra();
}
function yY(e, t) {
  if (e && t)
    for (var a in t)
      t.hasOwnProperty(a) && (e[a] = t[a]);
  return e;
}
function zl(e, t) {
  return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var $i;
function h1(e, t) {
  return function() {
    if (!$i) {
      var a = arguments, n = this;
      a.length === 1 ? e.call(n, a[0]) : e.apply(n, a), $i = setTimeout(function() {
        $i = void 0;
      }, t);
    }
  };
}
function bY() {
  clearTimeout($i), $i = void 0;
}
function g1(e, t, a) {
  e.scrollLeft += t, e.scrollTop += a;
}
function m1(e) {
  var t = window.Polymer, a = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(e).cloneNode(!0) : a ? a(e).clone(!0)[0] : e.cloneNode(!0);
}
var oa = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function wY() {
  var e = [], t;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var n = [].slice.call(this.el.children);
        n.forEach(function(r) {
          if (!(Be(r, "display") === "none" || r === Re.ghost)) {
            e.push({
              target: r,
              rect: Et(r)
            });
            var i = Ha({}, e[e.length - 1].rect);
            if (r.thisAnimationDuration) {
              var o = Pr(r, !0);
              o && (i.top -= o.f, i.left -= o.e);
            }
            r.fromRect = i;
          }
        });
      }
    },
    addAnimationState: function(n) {
      e.push(n);
    },
    removeAnimationState: function(n) {
      e.splice(mY(e, {
        target: n
      }), 1);
    },
    animateAll: function(n) {
      var r = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof n == "function" && n();
        return;
      }
      var i = !1, o = 0;
      e.forEach(function(u) {
        var l = 0, s = u.target, d = s.fromRect, c = Et(s), f = s.prevFromRect, v = s.prevToRect, m = u.rect, C = Pr(s, !0);
        C && (c.top -= C.f, c.left -= C.e), s.toRect = c, s.thisAnimationDuration && zl(f, c) && !zl(d, c) && // Make sure animatingRect is on line between toRect & fromRect
        (m.top - c.top) / (m.left - c.left) === (d.top - c.top) / (d.left - c.left) && (l = kY(m, f, v, r.options)), zl(c, d) || (s.prevFromRect = d, s.prevToRect = c, l || (l = r.options.animation), r.animate(s, m, c, l)), l && (i = !0, o = Math.max(o, l), clearTimeout(s.animationResetTimer), s.animationResetTimer = setTimeout(function() {
          s.animationTime = 0, s.prevFromRect = null, s.fromRect = null, s.prevToRect = null, s.thisAnimationDuration = null;
        }, l), s.thisAnimationDuration = l);
      }), clearTimeout(t), i ? t = setTimeout(function() {
        typeof n == "function" && n();
      }, o) : typeof n == "function" && n(), e = [];
    },
    animate: function(n, r, i, o) {
      if (o) {
        Be(n, "transition", ""), Be(n, "transform", "");
        var u = Pr(this.el), l = u && u.a, s = u && u.d, d = (r.left - i.left) / (l || 1), c = (r.top - i.top) / (s || 1);
        n.animatingX = !!d, n.animatingY = !!c, Be(n, "transform", "translate3d(" + d + "px," + c + "px,0)"), this.forRepaintDummy = CY(n), Be(n, "transition", "transform " + o + "ms" + (this.options.easing ? " " + this.options.easing : "")), Be(n, "transform", "translate3d(0,0,0)"), typeof n.animated == "number" && clearTimeout(n.animated), n.animated = setTimeout(function() {
          Be(n, "transition", ""), Be(n, "transform", ""), n.animated = !1, n.animatingX = !1, n.animatingY = !1;
        }, o);
      }
    }
  };
}
function CY(e) {
  return e.offsetWidth;
}
function kY(e, t, a, n) {
  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - a.top, 2) + Math.pow(t.left - a.left, 2)) * n.animation;
}
var yr = [], Yl = {
  initializeByDefault: !0
}, _i = {
  mount: function(t) {
    for (var a in Yl)
      Yl.hasOwnProperty(a) && !(a in t) && (t[a] = Yl[a]);
    yr.forEach(function(n) {
      if (n.pluginName === t.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(t.pluginName, " more than once");
    }), yr.push(t);
  },
  pluginEvent: function(t, a, n) {
    var r = this;
    this.eventCanceled = !1, n.cancel = function() {
      r.eventCanceled = !0;
    };
    var i = t + "Global";
    yr.forEach(function(o) {
      a[o.pluginName] && (a[o.pluginName][i] && a[o.pluginName][i](Ha({
        sortable: a
      }, n)), a.options[o.pluginName] && a[o.pluginName][t] && a[o.pluginName][t](Ha({
        sortable: a
      }, n)));
    });
  },
  initializePlugins: function(t, a, n, r) {
    yr.forEach(function(u) {
      var l = u.pluginName;
      if (!(!t.options[l] && !u.initializeByDefault)) {
        var s = new u(t, a, t.options);
        s.sortable = t, s.options = t.options, t[l] = s, dn(n, s.defaults);
      }
    });
    for (var i in t.options)
      if (t.options.hasOwnProperty(i)) {
        var o = this.modifyOption(t, i, t.options[i]);
        typeof o < "u" && (t.options[i] = o);
      }
  },
  getEventProperties: function(t, a) {
    var n = {};
    return yr.forEach(function(r) {
      typeof r.eventProperties == "function" && dn(n, r.eventProperties.call(a[r.pluginName], t));
    }), n;
  },
  modifyOption: function(t, a, n) {
    var r;
    return yr.forEach(function(i) {
      t[i.pluginName] && i.optionListeners && typeof i.optionListeners[a] == "function" && (r = i.optionListeners[a].call(t[i.pluginName], n));
    }), r;
  }
};
function $Y(e) {
  var t = e.sortable, a = e.rootEl, n = e.name, r = e.targetEl, i = e.cloneEl, o = e.toEl, u = e.fromEl, l = e.oldIndex, s = e.newIndex, d = e.oldDraggableIndex, c = e.newDraggableIndex, f = e.originalEvent, v = e.putSortable, m = e.extraEventProperties;
  if (t = t || a && a[oa], !!t) {
    var C, p = t.options, h = "on" + n.charAt(0).toUpperCase() + n.substr(1);
    window.CustomEvent && !gn && !Wi ? C = new CustomEvent(n, {
      bubbles: !0,
      cancelable: !0
    }) : (C = document.createEvent("Event"), C.initEvent(n, !0, !0)), C.to = o || a, C.from = u || a, C.item = r || a, C.clone = i, C.oldIndex = l, C.newIndex = s, C.oldDraggableIndex = d, C.newDraggableIndex = c, C.originalEvent = f, C.pullMode = v ? v.lastPutMode : void 0;
    var g = Ha(Ha({}, m), _i.getEventProperties(n, t));
    for (var w in g)
      C[w] = g[w];
    a && a.dispatchEvent(C), p[h] && p[h].call(t, C);
  }
}
var SY = ["evt"], Qt = function(t, a) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.evt, i = vY(n, SY);
  _i.pluginEvent.bind(Re)(t, a, Ha({
    dragEl: ye,
    parentEl: $t,
    ghostEl: _e,
    rootEl: ht,
    nextEl: qn,
    lastDownEl: Xo,
    cloneEl: St,
    cloneHidden: Sn,
    dragStarted: hi,
    putSortable: Lt,
    activeSortable: Re.active,
    originalEvent: r,
    oldIndex: Ir,
    oldDraggableIndex: Si,
    newIndex: na,
    newDraggableIndex: wn,
    hideGhostForTarget: C1,
    unhideGhostForTarget: k1,
    cloneNowHidden: function() {
      Sn = !0;
    },
    cloneNowShown: function() {
      Sn = !1;
    },
    dispatchSortableEvent: function(u) {
      qt({
        sortable: a,
        name: u,
        originalEvent: r
      });
    }
  }, i));
};
function qt(e) {
  $Y(Ha({
    putSortable: Lt,
    cloneEl: St,
    targetEl: ye,
    rootEl: ht,
    oldIndex: Ir,
    oldDraggableIndex: Si,
    newIndex: na,
    newDraggableIndex: wn
  }, e));
}
var ye, $t, _e, ht, qn, Xo, St, Sn, Ir, na, Si, wn, Bo, Lt, Dr = !1, xs = !1, Ps = [], Fn, wa, Hl, ql, Yp, Hp, hi, br, Ti, Di = !1, Ro = !1, Jo, Rt, Wl = [], Su = !1, Ns = [], ul = typeof document < "u", Fo = f1, qp = Wi || gn ? "cssFloat" : "float", TY = ul && !hY && !f1 && "draggable" in document.createElement("div"), y1 = function() {
  if (ul) {
    if (gn)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), b1 = function(t, a) {
  var n = Be(t), r = parseInt(n.width) - parseInt(n.paddingLeft) - parseInt(n.paddingRight) - parseInt(n.borderLeftWidth) - parseInt(n.borderRightWidth), i = _r(t, 0, a), o = _r(t, 1, a), u = i && Be(i), l = o && Be(o), s = u && parseInt(u.marginLeft) + parseInt(u.marginRight) + Et(i).width, d = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + Et(o).width;
  if (n.display === "flex")
    return n.flexDirection === "column" || n.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (n.display === "grid")
    return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (i && u.float && u.float !== "none") {
    var c = u.float === "left" ? "left" : "right";
    return o && (l.clear === "both" || l.clear === c) ? "vertical" : "horizontal";
  }
  return i && (u.display === "block" || u.display === "flex" || u.display === "table" || u.display === "grid" || s >= r && n[qp] === "none" || o && n[qp] === "none" && s + d > r) ? "vertical" : "horizontal";
}, DY = function(t, a, n) {
  var r = n ? t.left : t.top, i = n ? t.right : t.bottom, o = n ? t.width : t.height, u = n ? a.left : a.top, l = n ? a.right : a.bottom, s = n ? a.width : a.height;
  return r === u || i === l || r + o / 2 === u + s / 2;
}, AY = function(t, a) {
  var n;
  return Ps.some(function(r) {
    var i = r[oa].options.emptyInsertThreshold;
    if (!(!i || xd(r))) {
      var o = Et(r), u = t >= o.left - i && t <= o.right + i, l = a >= o.top - i && a <= o.bottom + i;
      if (u && l)
        return n = r;
    }
  }), n;
}, w1 = function(t) {
  function a(i, o) {
    return function(u, l, s, d) {
      var c = u.options.group.name && l.options.group.name && u.options.group.name === l.options.group.name;
      if (i == null && (o || c))
        return !0;
      if (i == null || i === !1)
        return !1;
      if (o && i === "clone")
        return i;
      if (typeof i == "function")
        return a(i(u, l, s, d), o)(u, l, s, d);
      var f = (o ? u : l).options.group.name;
      return i === !0 || typeof i == "string" && i === f || i.join && i.indexOf(f) > -1;
    };
  }
  var n = {}, r = t.group;
  (!r || Zo(r) != "object") && (r = {
    name: r
  }), n.name = r.name, n.checkPull = a(r.pull, !0), n.checkPut = a(r.put), n.revertClone = r.revertClone, t.group = n;
}, C1 = function() {
  !y1 && _e && Be(_e, "display", "none");
}, k1 = function() {
  !y1 && _e && Be(_e, "display", "");
};
ul && document.addEventListener("click", function(e) {
  if (xs)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), xs = !1, !1;
}, !0);
var zn = function(t) {
  if (ye) {
    t = t.touches ? t.touches[0] : t;
    var a = AY(t.clientX, t.clientY);
    if (a) {
      var n = {};
      for (var r in t)
        t.hasOwnProperty(r) && (n[r] = t[r]);
      n.target = n.rootEl = a, n.preventDefault = void 0, n.stopPropagation = void 0, a[oa]._onDragOver(n);
    }
  }
}, IY = function(t) {
  ye && ye.parentNode[oa]._isOutsideThisEl(t.target);
};
function Re(e, t) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = t = dn({}, t), e[oa] = this;
  var a = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return b1(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(o, u) {
      o.setData("Text", u.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Re.supportPointer !== !1 && "PointerEvent" in window && !ki,
    emptyInsertThreshold: 5
  };
  _i.initializePlugins(this, e, a);
  for (var n in a)
    !(n in t) && (t[n] = a[n]);
  w1(t);
  for (var r in this)
    r.charAt(0) === "_" && typeof this[r] == "function" && (this[r] = this[r].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : TY, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? at(e, "pointerdown", this._onTapStart) : (at(e, "mousedown", this._onTapStart), at(e, "touchstart", this._onTapStart)), this.nativeDraggable && (at(e, "dragover", this), at(e, "dragenter", this)), Ps.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), dn(this, wY());
}
Re.prototype = /** @lends Sortable.prototype */
{
  constructor: Re,
  _isOutsideThisEl: function(t) {
    !this.el.contains(t) && t !== this.el && (br = null);
  },
  _getDirection: function(t, a) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, t, a, ye) : this.options.direction;
  },
  _onTapStart: function(t) {
    if (t.cancelable) {
      var a = this, n = this.el, r = this.options, i = r.preventOnFilter, o = t.type, u = t.touches && t.touches[0] || t.pointerType && t.pointerType === "touch" && t, l = (u || t).target, s = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || l, d = r.filter;
      if (BY(n), !ye && !(/mousedown|pointerdown/.test(o) && t.button !== 0 || r.disabled) && !s.isContentEditable && !(!this.nativeDraggable && ki && l && l.tagName.toUpperCase() === "SELECT") && (l = Oa(l, r.draggable, n, !1), !(l && l.animated) && Xo !== l)) {
        if (Ir = ca(l), Si = ca(l, r.draggable), typeof d == "function") {
          if (d.call(this, t, l, this)) {
            qt({
              sortable: a,
              rootEl: s,
              name: "filter",
              targetEl: l,
              toEl: n,
              fromEl: n
            }), Qt("filter", a, {
              evt: t
            }), i && t.cancelable && t.preventDefault();
            return;
          }
        } else if (d && (d = d.split(",").some(function(c) {
          if (c = Oa(s, c.trim(), n, !1), c)
            return qt({
              sortable: a,
              rootEl: c,
              name: "filter",
              targetEl: l,
              fromEl: n,
              toEl: n
            }), Qt("filter", a, {
              evt: t
            }), !0;
        }), d)) {
          i && t.cancelable && t.preventDefault();
          return;
        }
        r.handle && !Oa(s, r.handle, n, !1) || this._prepareDragStart(t, u, l);
      }
    }
  },
  _prepareDragStart: function(t, a, n) {
    var r = this, i = r.el, o = r.options, u = i.ownerDocument, l;
    if (n && !ye && n.parentNode === i) {
      var s = Et(n);
      if (ht = i, ye = n, $t = ye.parentNode, qn = ye.nextSibling, Xo = n, Bo = o.group, Re.dragged = ye, Fn = {
        target: ye,
        clientX: (a || t).clientX,
        clientY: (a || t).clientY
      }, Yp = Fn.clientX - s.left, Hp = Fn.clientY - s.top, this._lastX = (a || t).clientX, this._lastY = (a || t).clientY, ye.style["will-change"] = "all", l = function() {
        if (Qt("delayEnded", r, {
          evt: t
        }), Re.eventCanceled) {
          r._onDrop();
          return;
        }
        r._disableDelayedDragEvents(), !Bp && r.nativeDraggable && (ye.draggable = !0), r._triggerDragStart(t, a), qt({
          sortable: r,
          name: "choose",
          originalEvent: t
        }), aa(ye, o.chosenClass, !0);
      }, o.ignore.split(",").forEach(function(d) {
        p1(ye, d.trim(), _l);
      }), at(u, "dragover", zn), at(u, "mousemove", zn), at(u, "touchmove", zn), at(u, "mouseup", r._onDrop), at(u, "touchend", r._onDrop), at(u, "touchcancel", r._onDrop), Bp && this.nativeDraggable && (this.options.touchStartThreshold = 4, ye.draggable = !0), Qt("delayStart", this, {
        evt: t
      }), o.delay && (!o.delayOnTouchOnly || a) && (!this.nativeDraggable || !(Wi || gn))) {
        if (Re.eventCanceled) {
          this._onDrop();
          return;
        }
        at(u, "mouseup", r._disableDelayedDrag), at(u, "touchend", r._disableDelayedDrag), at(u, "touchcancel", r._disableDelayedDrag), at(u, "mousemove", r._delayedDragTouchMoveHandler), at(u, "touchmove", r._delayedDragTouchMoveHandler), o.supportPointer && at(u, "pointermove", r._delayedDragTouchMoveHandler), r._dragStartTimer = setTimeout(l, o.delay);
      } else
        l();
    }
  },
  _delayedDragTouchMoveHandler: function(t) {
    var a = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(a.clientX - this._lastX), Math.abs(a.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    ye && _l(ye), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var t = this.el.ownerDocument;
    tt(t, "mouseup", this._disableDelayedDrag), tt(t, "touchend", this._disableDelayedDrag), tt(t, "touchcancel", this._disableDelayedDrag), tt(t, "mousemove", this._delayedDragTouchMoveHandler), tt(t, "touchmove", this._delayedDragTouchMoveHandler), tt(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(t, a) {
    a = a || t.pointerType == "touch" && t, !this.nativeDraggable || a ? this.options.supportPointer ? at(document, "pointermove", this._onTouchMove) : a ? at(document, "touchmove", this._onTouchMove) : at(document, "mousemove", this._onTouchMove) : (at(ye, "dragend", this), at(ht, "dragstart", this._onDragStart));
    try {
      document.selection ? es(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(t, a) {
    if (Dr = !1, ht && ye) {
      Qt("dragStarted", this, {
        evt: a
      }), this.nativeDraggable && at(document, "dragover", IY);
      var n = this.options;
      !t && aa(ye, n.dragClass, !1), aa(ye, n.ghostClass, !0), Re.active = this, t && this._appendGhost(), qt({
        sortable: this,
        name: "start",
        originalEvent: a
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (wa) {
      this._lastX = wa.clientX, this._lastY = wa.clientY, C1();
      for (var t = document.elementFromPoint(wa.clientX, wa.clientY), a = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(wa.clientX, wa.clientY), t !== a); )
        a = t;
      if (ye.parentNode[oa]._isOutsideThisEl(t), a)
        do {
          if (a[oa]) {
            var n = void 0;
            if (n = a[oa]._onDragOver({
              clientX: wa.clientX,
              clientY: wa.clientY,
              target: t,
              rootEl: a
            }), n && !this.options.dragoverBubble)
              break;
          }
          t = a;
        } while (a = a.parentNode);
      k1();
    }
  },
  _onTouchMove: function(t) {
    if (Fn) {
      var a = this.options, n = a.fallbackTolerance, r = a.fallbackOffset, i = t.touches ? t.touches[0] : t, o = _e && Pr(_e, !0), u = _e && o && o.a, l = _e && o && o.d, s = Fo && Rt && zp(Rt), d = (i.clientX - Fn.clientX + r.x) / (u || 1) + (s ? s[0] - Wl[0] : 0) / (u || 1), c = (i.clientY - Fn.clientY + r.y) / (l || 1) + (s ? s[1] - Wl[1] : 0) / (l || 1);
      if (!Re.active && !Dr) {
        if (n && Math.max(Math.abs(i.clientX - this._lastX), Math.abs(i.clientY - this._lastY)) < n)
          return;
        this._onDragStart(t, !0);
      }
      if (_e) {
        o ? (o.e += d - (Hl || 0), o.f += c - (ql || 0)) : o = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: d,
          f: c
        };
        var f = "matrix(".concat(o.a, ",").concat(o.b, ",").concat(o.c, ",").concat(o.d, ",").concat(o.e, ",").concat(o.f, ")");
        Be(_e, "webkitTransform", f), Be(_e, "mozTransform", f), Be(_e, "msTransform", f), Be(_e, "transform", f), Hl = d, ql = c, wa = i;
      }
      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!_e) {
      var t = this.options.fallbackOnBody ? document.body : ht, a = Et(ye, !0, Fo, !0, t), n = this.options;
      if (Fo) {
        for (Rt = t; Be(Rt, "position") === "static" && Be(Rt, "transform") === "none" && Rt !== document; )
          Rt = Rt.parentNode;
        Rt !== document.body && Rt !== document.documentElement ? (Rt === document && (Rt = Ra()), a.top += Rt.scrollTop, a.left += Rt.scrollLeft) : Rt = Ra(), Wl = zp(Rt);
      }
      _e = ye.cloneNode(!0), aa(_e, n.ghostClass, !1), aa(_e, n.fallbackClass, !0), aa(_e, n.dragClass, !0), Be(_e, "transition", ""), Be(_e, "transform", ""), Be(_e, "box-sizing", "border-box"), Be(_e, "margin", 0), Be(_e, "top", a.top), Be(_e, "left", a.left), Be(_e, "width", a.width), Be(_e, "height", a.height), Be(_e, "opacity", "0.8"), Be(_e, "position", Fo ? "absolute" : "fixed"), Be(_e, "zIndex", "100000"), Be(_e, "pointerEvents", "none"), Re.ghost = _e, t.appendChild(_e), Be(_e, "transform-origin", Yp / parseInt(_e.style.width) * 100 + "% " + Hp / parseInt(_e.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(t, a) {
    var n = this, r = t.dataTransfer, i = n.options;
    if (Qt("dragStart", this, {
      evt: t
    }), Re.eventCanceled) {
      this._onDrop();
      return;
    }
    Qt("setupClone", this), Re.eventCanceled || (St = m1(ye), St.draggable = !1, St.style["will-change"] = "", this._hideClone(), aa(St, this.options.chosenClass, !1), Re.clone = St), n.cloneId = es(function() {
      Qt("clone", n), !Re.eventCanceled && (n.options.removeCloneOnHide || ht.insertBefore(St, ye), n._hideClone(), qt({
        sortable: n,
        name: "clone"
      }));
    }), !a && aa(ye, i.dragClass, !0), a ? (xs = !0, n._loopId = setInterval(n._emulateDragOver, 50)) : (tt(document, "mouseup", n._onDrop), tt(document, "touchend", n._onDrop), tt(document, "touchcancel", n._onDrop), r && (r.effectAllowed = "move", i.setData && i.setData.call(n, r, ye)), at(document, "drop", n), Be(ye, "transform", "translateZ(0)")), Dr = !0, n._dragStartId = es(n._dragStarted.bind(n, a, t)), at(document, "selectstart", n), hi = !0, ki && Be(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(t) {
    var a = this.el, n = t.target, r, i, o, u = this.options, l = u.group, s = Re.active, d = Bo === l, c = u.sort, f = Lt || s, v, m = this, C = !1;
    if (Su) return;
    function p(_, te) {
      Qt(_, m, Ha({
        evt: t,
        isOwner: d,
        axis: v ? "vertical" : "horizontal",
        revert: o,
        dragRect: r,
        targetRect: i,
        canSort: c,
        fromSortable: f,
        target: n,
        completed: g,
        onMove: function(pe, ce) {
          return zo(ht, a, ye, r, pe, Et(pe), t, ce);
        },
        changed: w
      }, te));
    }
    function h() {
      p("dragOverAnimationCapture"), m.captureAnimationState(), m !== f && f.captureAnimationState();
    }
    function g(_) {
      return p("dragOverCompleted", {
        insertion: _
      }), _ && (d ? s._hideClone() : s._showClone(m), m !== f && (aa(ye, Lt ? Lt.options.ghostClass : s.options.ghostClass, !1), aa(ye, u.ghostClass, !0)), Lt !== m && m !== Re.active ? Lt = m : m === Re.active && Lt && (Lt = null), f === m && (m._ignoreWhileAnimating = n), m.animateAll(function() {
        p("dragOverAnimationComplete"), m._ignoreWhileAnimating = null;
      }), m !== f && (f.animateAll(), f._ignoreWhileAnimating = null)), (n === ye && !ye.animated || n === a && !n.animated) && (br = null), !u.dragoverBubble && !t.rootEl && n !== document && (ye.parentNode[oa]._isOutsideThisEl(t.target), !_ && zn(t)), !u.dragoverBubble && t.stopPropagation && t.stopPropagation(), C = !0;
    }
    function w() {
      na = ca(ye), wn = ca(ye, u.draggable), qt({
        sortable: m,
        name: "change",
        toEl: a,
        newIndex: na,
        newDraggableIndex: wn,
        originalEvent: t
      });
    }
    if (t.preventDefault !== void 0 && t.cancelable && t.preventDefault(), n = Oa(n, u.draggable, a, !0), p("dragOver"), Re.eventCanceled) return C;
    if (ye.contains(t.target) || n.animated && n.animatingX && n.animatingY || m._ignoreWhileAnimating === n)
      return g(!1);
    if (xs = !1, s && !u.disabled && (d ? c || (o = $t !== ht) : Lt === this || (this.lastPutMode = Bo.checkPull(this, s, ye, t)) && l.checkPut(this, s, ye, t))) {
      if (v = this._getDirection(t, n) === "vertical", r = Et(ye), p("dragOverValid"), Re.eventCanceled) return C;
      if (o)
        return $t = ht, h(), this._hideClone(), p("revert"), Re.eventCanceled || (qn ? ht.insertBefore(ye, qn) : ht.appendChild(ye)), g(!0);
      var $ = xd(a, u.draggable);
      if (!$ || xY(t, v, this) && !$.animated) {
        if ($ === ye)
          return g(!1);
        if ($ && a === t.target && (n = $), n && (i = Et(n)), zo(ht, a, ye, r, n, i, t, !!n) !== !1)
          return h(), a.appendChild(ye), $t = a, w(), g(!0);
      } else if ($ && OY(t, v, this)) {
        var T = _r(a, 0, u, !0);
        if (T === ye)
          return g(!1);
        if (n = T, i = Et(n), zo(ht, a, ye, r, n, i, t, !1) !== !1)
          return h(), a.insertBefore(ye, T), $t = a, w(), g(!0);
      } else if (n.parentNode === a) {
        i = Et(n);
        var O = 0, M, F = ye.parentNode !== a, q = !DY(ye.animated && ye.toRect || r, n.animated && n.toRect || i, v), x = v ? "top" : "left", Y = Fp(n, "top", "top") || Fp(ye, "top", "top"), R = Y ? Y.scrollTop : void 0;
        br !== n && (M = i[x], Di = !1, Ro = !q && u.invertSwap || F), O = PY(t, n, i, v, q ? 1 : u.swapThreshold, u.invertedSwapThreshold == null ? u.swapThreshold : u.invertedSwapThreshold, Ro, br === n);
        var k;
        if (O !== 0) {
          var P = ca(ye);
          do
            P -= O, k = $t.children[P];
          while (k && (Be(k, "display") === "none" || k === _e));
        }
        if (O === 0 || k === n)
          return g(!1);
        br = n, Ti = O;
        var D = n.nextElementSibling, B = !1;
        B = O === 1;
        var J = zo(ht, a, ye, r, n, i, t, B);
        if (J !== !1)
          return (J === 1 || J === -1) && (B = J === 1), Su = !0, setTimeout(MY, 30), h(), B && !D ? a.appendChild(ye) : n.parentNode.insertBefore(ye, B ? D : n), Y && g1(Y, 0, R - Y.scrollTop), $t = ye.parentNode, M !== void 0 && !Ro && (Jo = Math.abs(M - Et(n)[x])), w(), g(!0);
      }
      if (a.contains(ye))
        return g(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    tt(document, "mousemove", this._onTouchMove), tt(document, "touchmove", this._onTouchMove), tt(document, "pointermove", this._onTouchMove), tt(document, "dragover", zn), tt(document, "mousemove", zn), tt(document, "touchmove", zn);
  },
  _offUpEvents: function() {
    var t = this.el.ownerDocument;
    tt(t, "mouseup", this._onDrop), tt(t, "touchend", this._onDrop), tt(t, "pointerup", this._onDrop), tt(t, "touchcancel", this._onDrop), tt(document, "selectstart", this);
  },
  _onDrop: function(t) {
    var a = this.el, n = this.options;
    if (na = ca(ye), wn = ca(ye, n.draggable), Qt("drop", this, {
      evt: t
    }), $t = ye && ye.parentNode, na = ca(ye), wn = ca(ye, n.draggable), Re.eventCanceled) {
      this._nulling();
      return;
    }
    Dr = !1, Ro = !1, Di = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), Tu(this.cloneId), Tu(this._dragStartId), this.nativeDraggable && (tt(document, "drop", this), tt(a, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), ki && Be(document.body, "user-select", ""), Be(ye, "transform", ""), t && (hi && (t.cancelable && t.preventDefault(), !n.dropBubble && t.stopPropagation()), _e && _e.parentNode && _e.parentNode.removeChild(_e), (ht === $t || Lt && Lt.lastPutMode !== "clone") && St && St.parentNode && St.parentNode.removeChild(St), ye && (this.nativeDraggable && tt(ye, "dragend", this), _l(ye), ye.style["will-change"] = "", hi && !Dr && aa(ye, Lt ? Lt.options.ghostClass : this.options.ghostClass, !1), aa(ye, this.options.chosenClass, !1), qt({
      sortable: this,
      name: "unchoose",
      toEl: $t,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), ht !== $t ? (na >= 0 && (qt({
      rootEl: $t,
      name: "add",
      toEl: $t,
      fromEl: ht,
      originalEvent: t
    }), qt({
      sortable: this,
      name: "remove",
      toEl: $t,
      originalEvent: t
    }), qt({
      rootEl: $t,
      name: "sort",
      toEl: $t,
      fromEl: ht,
      originalEvent: t
    }), qt({
      sortable: this,
      name: "sort",
      toEl: $t,
      originalEvent: t
    })), Lt && Lt.save()) : na !== Ir && na >= 0 && (qt({
      sortable: this,
      name: "update",
      toEl: $t,
      originalEvent: t
    }), qt({
      sortable: this,
      name: "sort",
      toEl: $t,
      originalEvent: t
    })), Re.active && ((na == null || na === -1) && (na = Ir, wn = Si), qt({
      sortable: this,
      name: "end",
      toEl: $t,
      originalEvent: t
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    Qt("nulling", this), ht = ye = $t = _e = qn = St = Xo = Sn = Fn = wa = hi = na = wn = Ir = Si = br = Ti = Lt = Bo = Re.dragged = Re.ghost = Re.clone = Re.active = null, Ns.forEach(function(t) {
      t.checked = !0;
    }), Ns.length = Hl = ql = 0;
  },
  handleEvent: function(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);
        break;
      case "dragenter":
      case "dragover":
        ye && (this._onDragOver(t), EY(t));
        break;
      case "selectstart":
        t.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var t = [], a, n = this.el.children, r = 0, i = n.length, o = this.options; r < i; r++)
      a = n[r], Oa(a, o.draggable, this.el, !1) && t.push(a.getAttribute(o.dataIdAttr) || LY(a));
    return t;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(t, a) {
    var n = {}, r = this.el;
    this.toArray().forEach(function(i, o) {
      var u = r.children[o];
      Oa(u, this.options.draggable, r, !1) && (n[i] = u);
    }, this), a && this.captureAnimationState(), t.forEach(function(i) {
      n[i] && (r.removeChild(n[i]), r.appendChild(n[i]));
    }), a && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(t, a) {
    return Oa(t, a || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(t, a) {
    var n = this.options;
    if (a === void 0)
      return n[t];
    var r = _i.modifyOption(this, t, a);
    typeof r < "u" ? n[t] = r : n[t] = a, t === "group" && w1(n);
  },
  /**
   * Destroy
   */
  destroy: function() {
    Qt("destroy", this);
    var t = this.el;
    t[oa] = null, tt(t, "mousedown", this._onTapStart), tt(t, "touchstart", this._onTapStart), tt(t, "pointerdown", this._onTapStart), this.nativeDraggable && (tt(t, "dragover", this), tt(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(a) {
      a.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), Ps.splice(Ps.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function() {
    if (!Sn) {
      if (Qt("hideClone", this), Re.eventCanceled) return;
      Be(St, "display", "none"), this.options.removeCloneOnHide && St.parentNode && St.parentNode.removeChild(St), Sn = !0;
    }
  },
  _showClone: function(t) {
    if (t.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Sn) {
      if (Qt("showClone", this), Re.eventCanceled) return;
      ye.parentNode == ht && !this.options.group.revertClone ? ht.insertBefore(St, ye) : qn ? ht.insertBefore(St, qn) : ht.appendChild(St), this.options.group.revertClone && this.animate(ye, St), Be(St, "display", ""), Sn = !1;
    }
  }
};
function EY(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function zo(e, t, a, n, r, i, o, u) {
  var l, s = e[oa], d = s.options.onMove, c;
  return window.CustomEvent && !gn && !Wi ? l = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (l = document.createEvent("Event"), l.initEvent("move", !0, !0)), l.to = t, l.from = e, l.dragged = a, l.draggedRect = n, l.related = r || t, l.relatedRect = i || Et(t), l.willInsertAfter = u, l.originalEvent = o, e.dispatchEvent(l), d && (c = d.call(s, l, o)), c;
}
function _l(e) {
  e.draggable = !1;
}
function MY() {
  Su = !1;
}
function OY(e, t, a) {
  var n = Et(_r(a.el, 0, a.options, !0)), r = 10;
  return t ? e.clientX < n.left - r || e.clientY < n.top && e.clientX < n.right : e.clientY < n.top - r || e.clientY < n.bottom && e.clientX < n.left;
}
function xY(e, t, a) {
  var n = Et(xd(a.el, a.options.draggable)), r = 10;
  return t ? e.clientX > n.right + r || e.clientX <= n.right && e.clientY > n.bottom && e.clientX >= n.left : e.clientX > n.right && e.clientY > n.top || e.clientX <= n.right && e.clientY > n.bottom + r;
}
function PY(e, t, a, n, r, i, o, u) {
  var l = n ? e.clientY : e.clientX, s = n ? a.height : a.width, d = n ? a.top : a.left, c = n ? a.bottom : a.right, f = !1;
  if (!o) {
    if (u && Jo < s * r) {
      if (!Di && (Ti === 1 ? l > d + s * i / 2 : l < c - s * i / 2) && (Di = !0), Di)
        f = !0;
      else if (Ti === 1 ? l < d + Jo : l > c - Jo)
        return -Ti;
    } else if (l > d + s * (1 - r) / 2 && l < c - s * (1 - r) / 2)
      return NY(t);
  }
  return f = f || o, f && (l < d + s * i / 2 || l > c - s * i / 2) ? l > d + s / 2 ? 1 : -1 : 0;
}
function NY(e) {
  return ca(ye) < ca(e) ? 1 : -1;
}
function LY(e) {
  for (var t = e.tagName + e.className + e.src + e.href + e.textContent, a = t.length, n = 0; a--; )
    n += t.charCodeAt(a);
  return n.toString(36);
}
function BY(e) {
  Ns.length = 0;
  for (var t = e.getElementsByTagName("input"), a = t.length; a--; ) {
    var n = t[a];
    n.checked && Ns.push(n);
  }
}
function es(e) {
  return setTimeout(e, 0);
}
function Tu(e) {
  return clearTimeout(e);
}
ul && at(document, "touchmove", function(e) {
  (Re.active || Dr) && e.cancelable && e.preventDefault();
});
Re.utils = {
  on: at,
  off: tt,
  css: Be,
  find: p1,
  is: function(t, a) {
    return !!Oa(t, a, t, !1);
  },
  extend: yY,
  throttle: h1,
  closest: Oa,
  toggleClass: aa,
  clone: m1,
  index: ca,
  nextTick: es,
  cancelNextTick: Tu,
  detectDirection: b1,
  getChild: _r
};
Re.get = function(e) {
  return e[oa];
};
Re.mount = function() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(n) {
    if (!n.prototype || !n.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(n));
    n.utils && (Re.utils = Ha(Ha({}, Re.utils), n.utils)), _i.mount(n);
  });
};
Re.create = function(e, t) {
  return new Re(e, t);
};
Re.version = pY;
var At = [], gi, Du, Au = !1, Ul, Vl, Ls, mi;
function RY() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return e.prototype = {
    dragStarted: function(a) {
      var n = a.originalEvent;
      this.sortable.nativeDraggable ? at(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? at(document, "pointermove", this._handleFallbackAutoScroll) : n.touches ? at(document, "touchmove", this._handleFallbackAutoScroll) : at(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(a) {
      var n = a.originalEvent;
      !this.options.dragOverBubble && !n.rootEl && this._handleAutoScroll(n);
    },
    drop: function() {
      this.sortable.nativeDraggable ? tt(document, "dragover", this._handleAutoScroll) : (tt(document, "pointermove", this._handleFallbackAutoScroll), tt(document, "touchmove", this._handleFallbackAutoScroll), tt(document, "mousemove", this._handleFallbackAutoScroll)), Wp(), ts(), bY();
    },
    nulling: function() {
      Ls = Du = gi = Au = mi = Ul = Vl = null, At.length = 0;
    },
    _handleFallbackAutoScroll: function(a) {
      this._handleAutoScroll(a, !0);
    },
    _handleAutoScroll: function(a, n) {
      var r = this, i = (a.touches ? a.touches[0] : a).clientX, o = (a.touches ? a.touches[0] : a).clientY, u = document.elementFromPoint(i, o);
      if (Ls = a, n || this.options.forceAutoScrollFallback || Wi || gn || ki) {
        Kl(a, this.options, u, n);
        var l = Tn(u, !0);
        Au && (!mi || i !== Ul || o !== Vl) && (mi && Wp(), mi = setInterval(function() {
          var s = Tn(document.elementFromPoint(i, o), !0);
          s !== l && (l = s, ts()), Kl(a, r.options, s, n);
        }, 10), Ul = i, Vl = o);
      } else {
        if (!this.options.bubbleScroll || Tn(u, !0) === Ra()) {
          ts();
          return;
        }
        Kl(a, this.options, Tn(u, !1), !1);
      }
    }
  }, dn(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function ts() {
  At.forEach(function(e) {
    clearInterval(e.pid);
  }), At = [];
}
function Wp() {
  clearInterval(mi);
}
var Kl = h1(function(e, t, a, n) {
  if (t.scroll) {
    var r = (e.touches ? e.touches[0] : e).clientX, i = (e.touches ? e.touches[0] : e).clientY, o = t.scrollSensitivity, u = t.scrollSpeed, l = Ra(), s = !1, d;
    Du !== a && (Du = a, ts(), gi = t.scroll, d = t.scrollFn, gi === !0 && (gi = Tn(a, !0)));
    var c = 0, f = gi;
    do {
      var v = f, m = Et(v), C = m.top, p = m.bottom, h = m.left, g = m.right, w = m.width, $ = m.height, T = void 0, O = void 0, M = v.scrollWidth, F = v.scrollHeight, q = Be(v), x = v.scrollLeft, Y = v.scrollTop;
      v === l ? (T = w < M && (q.overflowX === "auto" || q.overflowX === "scroll" || q.overflowX === "visible"), O = $ < F && (q.overflowY === "auto" || q.overflowY === "scroll" || q.overflowY === "visible")) : (T = w < M && (q.overflowX === "auto" || q.overflowX === "scroll"), O = $ < F && (q.overflowY === "auto" || q.overflowY === "scroll"));
      var R = T && (Math.abs(g - r) <= o && x + w < M) - (Math.abs(h - r) <= o && !!x), k = O && (Math.abs(p - i) <= o && Y + $ < F) - (Math.abs(C - i) <= o && !!Y);
      if (!At[c])
        for (var P = 0; P <= c; P++)
          At[P] || (At[P] = {});
      (At[c].vx != R || At[c].vy != k || At[c].el !== v) && (At[c].el = v, At[c].vx = R, At[c].vy = k, clearInterval(At[c].pid), (R != 0 || k != 0) && (s = !0, At[c].pid = setInterval((function() {
        n && this.layer === 0 && Re.active._onTouchMove(Ls);
        var D = At[this.layer].vy ? At[this.layer].vy * u : 0, B = At[this.layer].vx ? At[this.layer].vx * u : 0;
        typeof d == "function" && d.call(Re.dragged.parentNode[oa], B, D, e, Ls, At[this.layer].el) !== "continue" || g1(At[this.layer].el, B, D);
      }).bind({
        layer: c
      }), 24))), c++;
    } while (t.bubbleScroll && f !== l && (f = Tn(f, !1)));
    Au = s;
  }
}, 30), $1 = function(t) {
  var a = t.originalEvent, n = t.putSortable, r = t.dragEl, i = t.activeSortable, o = t.dispatchSortableEvent, u = t.hideGhostForTarget, l = t.unhideGhostForTarget;
  if (a) {
    var s = n || i;
    u();
    var d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : a, c = document.elementFromPoint(d.clientX, d.clientY);
    l(), s && !s.el.contains(c) && (o("spill"), this.onSpill({
      dragEl: r,
      putSortable: n
    }));
  }
};
function Pd() {
}
Pd.prototype = {
  startIndex: null,
  dragStart: function(t) {
    var a = t.oldDraggableIndex;
    this.startIndex = a;
  },
  onSpill: function(t) {
    var a = t.dragEl, n = t.putSortable;
    this.sortable.captureAnimationState(), n && n.captureAnimationState();
    var r = _r(this.sortable.el, this.startIndex, this.options);
    r ? this.sortable.el.insertBefore(a, r) : this.sortable.el.appendChild(a), this.sortable.animateAll(), n && n.animateAll();
  },
  drop: $1
};
dn(Pd, {
  pluginName: "revertOnSpill"
});
function Nd() {
}
Nd.prototype = {
  onSpill: function(t) {
    var a = t.dragEl, n = t.putSortable, r = n || this.sortable;
    r.captureAnimationState(), a.parentNode && a.parentNode.removeChild(a), r.animateAll();
  },
  drop: $1
};
dn(Nd, {
  pluginName: "removeOnSpill"
});
Re.mount(new RY());
Re.mount(Nd, Pd);
function FY() {
  return typeof window < "u" ? window.console : global.console;
}
const zY = FY();
function YY(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] || (t[n] = e(n));
  };
}
const HY = /-(\w)/g, _p = YY((e) => e.replace(HY, (t, a) => a ? a.toUpperCase() : ""));
function jl(e) {
  e.parentElement !== null && e.parentElement.removeChild(e);
}
function Up(e, t, a) {
  const n = a === 0 ? e.children[0] : e.children[a - 1].nextSibling;
  e.insertBefore(t, n);
}
function qY(e, t) {
  return Object.values(e).indexOf(t);
}
function WY(e, t, a, n) {
  if (!e)
    return [];
  const r = Object.values(e), i = t.length - n;
  return [...t].map((u, l) => l >= i ? r.length : r.indexOf(u));
}
function S1(e, t) {
  this.$nextTick(() => this.$emit(e.toLowerCase(), t));
}
function _Y(e) {
  return (t) => {
    this.realList !== null && this["onDrag" + e](t), S1.call(this, e, t);
  };
}
function UY(e) {
  return ["transition-group", "TransitionGroup"].includes(e);
}
function VY(e) {
  if (!e || e.length !== 1)
    return !1;
  const [{ type: t }] = e;
  return t ? UY(t.name) : !1;
}
function KY(e, t) {
  return t ? { ...t.props, ...t.attrs } : e;
}
const Iu = ["Start", "Add", "Remove", "Update", "End"], Eu = ["Choose", "Unchoose", "Sort", "Filter", "Clone"], jY = ["Move", ...Iu, ...Eu].map((e) => "on" + e);
let Gl = null;
const GY = {
  options: Object,
  list: {
    type: Array,
    required: !1,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: !1
  },
  clone: {
    type: Function,
    default: (e) => e
  },
  tag: {
    type: String,
    default: "div"
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: !1,
    default: null
  },
  component: {
    type: String,
    default: null
  },
  modelValue: {
    type: Array,
    required: !1,
    default: null
  }
}, QY = se({
  name: "VueDraggableNext",
  inheritAttrs: !1,
  emits: [
    "update:modelValue",
    "move",
    "change",
    ...Iu.map((e) => e.toLowerCase()),
    ...Eu.map((e) => e.toLowerCase())
  ],
  props: GY,
  data() {
    return {
      transitionMode: !1,
      noneFunctionalComponentMode: !1,
      headerOffset: 0,
      footerOffset: 0,
      _sortable: {},
      visibleIndexes: [],
      context: {}
    };
  },
  render() {
    const e = this.$slots.default ? this.$slots.default() : null, t = KY(this.$attrs, this.componentData);
    return e ? (this.transitionMode = VY(e), Rd(this.getTag(), t, e)) : Rd(this.getTag(), t, []);
  },
  created() {
    this.list !== null && this.modelValue !== null && zY.error("list props are mutually exclusive! Please set one.");
  },
  mounted() {
    const e = {};
    Iu.forEach((r) => {
      e["on" + r] = _Y.call(this, r);
    }), Eu.forEach((r) => {
      e["on" + r] = S1.bind(this, r);
    });
    const t = Object.keys(this.$attrs).reduce((r, i) => (r[_p(i)] = this.$attrs[i], r), {}), a = Object.assign({}, t, e, {
      onMove: (r, i) => this.onDragMove(r, i)
    });
    !("draggable" in a) && (a.draggable = ">*");
    const n = this.$el.nodeType === 1 ? this.$el : this.$el.parentElement;
    this._sortable = new Re(n, a), n.__draggable_component__ = this, this.computeIndexes();
  },
  beforeUnmount() {
    try {
      this._sortable !== void 0 && this._sortable.destroy();
    } catch {
    }
  },
  computed: {
    realList() {
      return this.list ? this.list : this.modelValue;
    }
  },
  watch: {
    $attrs: {
      handler(e) {
        this.updateOptions(e);
      },
      deep: !0
    },
    realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getTag() {
      return this.component ? zt(this.component) : this.tag;
    },
    updateOptions(e) {
      for (var t in e) {
        const a = _p(t);
        jY.indexOf(a) === -1 && this._sortable.option(a, e[t]);
      }
    },
    getChildrenNodes() {
      return this.$el.children;
    },
    computeIndexes() {
      this.$nextTick(() => {
        this.visibleIndexes = WY(this.getChildrenNodes(), this.$el.children, this.transitionMode, this.footerOffset);
      });
    },
    getUnderlyingVm(e) {
      const t = qY(this.getChildrenNodes() || [], e);
      if (t === -1)
        return null;
      const a = this.realList[t];
      return { index: t, element: a };
    },
    emitChanges(e) {
      this.$nextTick(() => {
        this.$emit("change", e);
      });
    },
    alterList(e) {
      if (this.list) {
        e(this.list);
        return;
      }
      const t = [...this.modelValue];
      e(t), this.$emit("update:modelValue", t);
    },
    spliceList() {
      const e = (t) => t.splice(...arguments);
      this.alterList(e);
    },
    updatePosition(e, t) {
      const a = (n) => n.splice(t, 0, n.splice(e, 1)[0]);
      this.alterList(a);
    },
    getVmIndex(e) {
      const t = this.visibleIndexes, a = t.length;
      return e > a - 1 ? a : t[e];
    },
    getComponent() {
      return this.$slots.default ? (
        //@ts-ignore
        this.$slots.default()[0].componentInstance
      ) : null;
    },
    resetTransitionData(e) {
      if (!this.noTransitionOnDrag || !this.transitionMode)
        return;
      var t = this.getChildrenNodes();
      t[e].data = null;
      const a = this.getComponent();
      a.children = [], a.kept = void 0;
    },
    onDragStart(e) {
      this.computeIndexes(), this.context = this.getUnderlyingVm(e.item), this.context && (e.item._underlying_vm_ = this.clone(this.context.element), Gl = e.item);
    },
    onDragAdd(e) {
      const t = e.item._underlying_vm_;
      if (t === void 0)
        return;
      jl(e.item);
      const a = this.getVmIndex(e.newIndex);
      this.spliceList(a, 0, t), this.computeIndexes();
      const n = { element: t, newIndex: a };
      this.emitChanges({ added: n });
    },
    onDragRemove(e) {
      if (Up(this.$el, e.item, e.oldIndex), e.pullMode === "clone") {
        jl(e.clone);
        return;
      }
      if (!this.context)
        return;
      const t = this.context.index;
      this.spliceList(t, 1);
      const a = { element: this.context.element, oldIndex: t };
      this.resetTransitionData(t), this.emitChanges({ removed: a });
    },
    onDragUpdate(e) {
      jl(e.item), Up(e.from, e.item, e.oldIndex);
      const t = this.context.index, a = this.getVmIndex(e.newIndex);
      this.updatePosition(t, a);
      const n = { element: this.context.element, oldIndex: t, newIndex: a };
      this.emitChanges({ moved: n });
    },
    updateProperty(e, t) {
      e.hasOwnProperty(t) && (e[t] += this.headerOffset);
    },
    onDragMove(e, t) {
      const a = this.move;
      if (!a || !this.realList)
        return !0;
      const n = this.getRelatedContextFromMoveEvent(e), r = this.context, i = this.computeFutureIndex(n, e);
      Object.assign(r, { futureIndex: i });
      const o = Object.assign({}, e, {
        relatedContext: n,
        draggedContext: r
      });
      return a(o, t);
    },
    onDragEnd() {
      this.computeIndexes(), Gl = null;
    },
    getTrargetedComponent(e) {
      return e.__draggable_component__;
    },
    getRelatedContextFromMoveEvent({ to: e, related: t }) {
      const a = this.getTrargetedComponent(e);
      if (!a)
        return { component: a };
      const n = a.realList, r = { list: n, component: a };
      if (e !== t && n && a.getUnderlyingVm) {
        const i = a.getUnderlyingVm(t);
        if (i)
          return Object.assign(i, r);
      }
      return r;
    },
    computeFutureIndex(e, t) {
      const a = [...t.to.children].filter((o) => o.style.display !== "none");
      if (a.length === 0)
        return 0;
      const n = a.indexOf(t.related), r = e.component.getVmIndex(n);
      return a.indexOf(Gl) !== -1 || !t.willInsertAfter ? r : r + 1;
    }
  }
}), ZY = ["data-testid"], XY = ["aria-controls", "aria-expanded", "aria-label"], JY = ["data-testid"], eH = {
  key: 0,
  class: "tree-item-icon",
  "data-testid": "tree-item-icon"
}, tH = {
  class: "tree-item-label",
  "data-testid": "tree-item-label"
}, aH = /* @__PURE__ */ se({
  __name: "KTreeItem",
  props: {
    item: {},
    disabled: { type: Boolean },
    hideIcons: { type: Boolean },
    collapsible: { type: Boolean },
    initialCollapse: { type: Boolean },
    hasChildren: { type: Boolean },
    controlsId: {}
  },
  emits: ["selected", "expanded"],
  setup(e, { expose: t, emit: a }) {
    const n = a, r = Tt(), i = b(() => !e.hideIcons || !!r["item-icon"]), o = (d) => {
      d.target && d.target.closest("a:not(.disabled), button:not([data-tree-item-trigger]), label, input, select") !== null || n("selected", e.item);
    }, u = L(!0), l = (d) => {
      u.value = d;
    };
    ne(() => e.initialCollapse, (d, c) => {
      d !== c && (u.value = !d);
    }, {
      immediate: !0
    });
    const s = () => {
      u.value = !u.value, n("expanded", u.value);
    };
    return t({ setExpandedValue: l, id: e.item.id }), (d, c) => (y(), S("div", {
      class: "tree-item-wrapper",
      "data-testid": `tree-item-wrapper-${d.item.id}`
    }, [
      d.collapsible && d.hasChildren ? (y(), S("span", {
        key: 0,
        "aria-controls": `tree-list-draggable-${d.controlsId}`,
        "aria-expanded": u.value,
        "aria-label": u.value ? "Collapse" : "Expand",
        class: ue(["tree-item-expanded-button", {
          collapsed: !u.value,
          expanded: u.value
        }]),
        "data-testid": "tree-item-expanded-button",
        role: "button",
        onClick: Ke(s, ["stop"]),
        onKeyup: lt(s, ["enter"])
      }, [
        Z(A(xu), {
          class: ue(["tree-item-expanded-icon", {
            collapsed: !u.value,
            expanded: u.value
          }]),
          "data-testid": "tree-item-expanded-icon",
          decorative: "",
          size: A(Vt),
          tabindex: "0"
        }, null, 8, ["class", "size"])
      ], 42, XY)) : W("", !0),
      H("button", {
        class: ue(["tree-item", {
          "not-draggable": d.disabled,
          selected: d.item.selected,
          expanded: d.collapsible && u.value,
          collapsed: d.collapsible && !u.value,
          "no-children": d.collapsible && !d.hasChildren
        }]),
        "data-testid": `tree-item-${d.item.id}`,
        "data-tree-item-trigger": "true",
        draggable: "false",
        type: "button",
        onClick: Ke(o, ["prevent"])
      }, [
        i.value ? (y(), S("div", eH, [
          j(d.$slots, "item-icon", {}, () => [
            Z(A($y), { decorative: "" })
          ], !0)
        ])) : W("", !0),
        H("div", tH, [
          j(d.$slots, "item-label", {}, () => [
            be(ae(d.item.name), 1)
          ], !0)
        ])
      ], 10, JY)
    ], 8, ZY));
  }
}), nH = /* @__PURE__ */ Me(aH, [["__scopeId", "data-v-18967eab"]]), Ld = ({ children: e = [] }) => e.length === 0 ? 0 : 1 + Math.max(...e.map(Ld)), rH = /* @__PURE__ */ se({
  __name: "KTreeDraggable",
  props: {
    items: {},
    disableDrag: { type: Boolean },
    filter: { type: [String, Function] },
    maxDepth: {},
    level: { default: 0 },
    parentId: {},
    hideIcons: { type: Boolean },
    group: {},
    collapsible: { type: Boolean },
    initialCollapseAll: { type: Boolean }
  },
  emits: ["change", "child-change", "selected"],
  setup(e, { expose: t, emit: a }) {
    const n = a, r = L(0), i = L([]), o = {
      tag: "div",
      // Note: force-fallback: true is required to override cursor when dragging
      "force-fallback": !0,
      animation: "100",
      draggable: ".tree-item-container",
      "item-key": "id",
      "ghost-class": "tree-item-dragged",
      "drag-class": "tree-item-grabbing",
      class: "child-drop-zone",
      "fallback-tolerance": 10
    }, u = L(!1), l = b(() => [".tree-item-expanded-button", ...(typeof e.filter == "function" ? e.filter() : e.filter).split(",").map((Y) => Y.trim()).filter(Boolean)].join(", ")), s = (x) => {
      var Y, R;
      return !((R = (Y = i.value.filter((k) => k.id === x.id)) == null ? void 0 : Y[0].children) != null && R.length);
    }, d = (x) => x.children || [], c = (x) => {
      e.parentId ? n("child-change", {
        parentId: e.parentId,
        children: i.value,
        target: (x == null ? void 0 : x.added) || (x == null ? void 0 : x.removed) || (x == null ? void 0 : x.moved)
      }) : n("change", {
        items: i.value,
        target: (x == null ? void 0 : x.added) || (x == null ? void 0 : x.removed) || (x == null ? void 0 : x.moved)
      });
    }, f = (x) => {
      n("child-change", x);
    }, v = (x) => {
      n("selected", x);
    }, m = L(/* @__PURE__ */ new Map()), C = (x, Y) => {
      m.value.set(Y, x);
    }, p = (x) => e.collapsible ? !!m.value.get(x) : !0, h = mt("tree-items"), g = () => {
      var x;
      i.value.forEach((Y) => {
        m.value.set(Y.id, !1);
      }), (x = h.value) == null || x.forEach((Y) => {
        Y == null || Y.setExpandedValue(!1);
      });
    }, w = () => {
      var x;
      i.value.forEach((Y) => {
        m.value.set(Y.id, !0);
      }), (x = h.value) == null || x.forEach((Y) => {
        Y == null || Y.setExpandedValue(!0);
      });
    }, $ = b(() => e.level > e.maxDepth - 1), T = (x) => {
      var D, B, J, _;
      const Y = ((B = (D = x.relatedContext) == null ? void 0 : D.component) == null ? void 0 : B.$attrs.level) || 0, R = (J = x.draggedContext) == null ? void 0 : J.element;
      let k = 0;
      return (_ = R.children) != null && _.length && (k = Ld(R)), !(Y + k > e.maxDepth - 1);
    }, O = (x) => {
      var k, P;
      const Y = ((P = (k = x.item) == null ? void 0 : k._underlying_vm_) == null ? void 0 : P.id) || "", R = i.value.find((D) => D.id === Y);
      u.value = !0, R && n("selected", R), F(!0);
    }, M = async () => {
      var x;
      u.value = !1, F(!1), r.value++, await gt(), (x = h.value) == null || x.forEach((Y) => {
        Y == null || Y.setExpandedValue(m.value.get(Y == null ? void 0 : Y.id));
      });
    }, F = (x) => {
      const Y = document == null ? void 0 : document.getElementsByTagName("html").item(0);
      Y && Y.classList.toggle("tree-list-grabbing", x);
    };
    ne(() => e.items, (x, Y) => {
      JSON.stringify(x) !== JSON.stringify(Y) && (i.value = x, i.value.forEach((R) => {
        R.children || (R.children = []);
      }));
    });
    const q = () => {
      i.value.forEach((x) => {
        m.value.set(x.id, !e.initialCollapseAll);
      });
    };
    return rt(async () => {
      i.value = e.items, i.value.forEach((x) => {
        x.children || (x.children = []);
      }), await gt(), e.collapsible && q();
    }), t({ collapseAll: g, expandAll: w }), (x, Y) => {
      const R = zt("KTreeDraggable", !0);
      return y(), ee(A(QY), Fe(o, {
        class: "tree-draggable",
        direction: "vertical",
        disabled: x.disableDrag,
        filter: l.value,
        group: { name: x.group, pull: [x.group], put: $.value ? [] : [x.group] },
        level: x.level,
        list: i.value,
        move: T,
        tag: "div",
        onChange: c,
        onEnd: M,
        onStart: O
      }), {
        default: N(() => [
          (y(!0), S(Ae, null, Le(i.value, (k) => (y(), S("div", {
            key: k.id,
            class: ue(["tree-item-container", {
              "has-no-children": s(k)
            }])
          }, [
            (y(), ee(nH, {
              key: `tree-item-${k.id}-${r.value}`,
              ref_for: !0,
              ref: "tree-items",
              collapsible: x.collapsible,
              "controls-id": k.id,
              disabled: x.disableDrag,
              "has-children": !s(k),
              "hide-icons": x.hideIcons,
              "initial-collapse": x.initialCollapseAll,
              item: k,
              onExpanded: (P) => C(P, k.id),
              onSelected: v
            }, yt({
              "item-label": N(() => [
                j(x.$slots, "item-label", { item: k }, () => [
                  be(ae(k.name), 1)
                ], !0)
              ]),
              _: 2
            }, [
              x.$slots["item-icon"] ? {
                name: "item-icon",
                fn: N(() => [
                  j(x.$slots, "item-icon", { item: k }, void 0, !0)
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["collapsible", "controls-id", "disabled", "has-children", "hide-icons", "initial-collapse", "item", "onExpanded"])),
            $a((y(), ee(R, {
              id: `tree-list-draggable-${k.id}`,
              key: `tree-item-${k.id}-children-${r.value}`,
              class: ue({
                collapsible: x.collapsible
              }),
              collapsible: x.collapsible,
              "disable-drag": x.disableDrag,
              filter: l.value,
              group: x.group,
              "hide-icons": x.hideIcons,
              "initial-collapse-all": x.initialCollapseAll,
              items: d(k),
              level: x.level + 1,
              "max-depth": x.maxDepth,
              "parent-id": k.id,
              onChildChange: f,
              onSelected: v
            }, yt({
              "item-label": N(({ item: P }) => [
                j(x.$slots, "item-label", { item: P }, void 0, !0)
              ]),
              _: 2
            }, [
              x.$slots["item-icon"] ? {
                name: "item-icon",
                fn: N(({ item: P }) => [
                  j(x.$slots, "item-icon", { item: P }, void 0, !0)
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["id", "class", "collapsible", "disable-drag", "filter", "group", "hide-icons", "initial-collapse-all", "items", "level", "max-depth", "parent-id"])), [
              [Nr, p(k.id)]
            ])
          ], 2))), 128))
        ]),
        _: 3
      }, 16, ["disabled", "filter", "group", "level", "list"]);
    };
  }
}), iH = /* @__PURE__ */ Me(rH, [["__scopeId", "data-v-a7e11d91"]]), oH = /* @__PURE__ */ se({
  __name: "KTreeList",
  props: {
    modelValue: { default: null },
    items: { default: null },
    disableDrag: { type: Boolean },
    ignoreDragSelectors: { type: [String, Function], default: "" },
    maxDepth: { default: 3 },
    width: { default: "" },
    hideIcons: { type: Boolean },
    group: { default: "k-tree-list" },
    collapsible: { type: Boolean },
    initialCollapseAll: { type: Boolean }
  },
  emits: ["change", "child-change", "selected"],
  setup(e, { expose: t, emit: a }) {
    const n = (p, h) => (p.forEach((g) => {
      var w;
      h.push(g.id), (w = g.children) != null && w.length && n(g.children, h);
    }), h), r = (p) => {
      const h = n(p, []), g = new Set(h);
      return h.length === g.size;
    }, i = (p, h) => {
      let g = !0;
      return p.forEach((w) => {
        g = g && (!w.children || Ld(w) <= h);
      }), g;
    };
    ne(() => e.modelValue, (p) => {
      p && !r(p) && Cn("modelValue", "Item `id` must be unique.");
    }, { immediate: !0 }), ne(() => e.items, (p) => {
      p && !r(p) && Cn("items", "Item `id` must be unique.");
    }, { immediate: !0 }), ne(() => e.maxDepth, (p) => {
      p > 5 && Cn("maxDepth", "Maximum depth must be less than or equal to 5.");
    }, { immediate: !0 }), ne([() => e.modelValue, () => e.items], ([p, h]) => {
      p && h && Cn("modelValue / items", "You should not provide both v-model (or props.modelValue) and props.items");
    }, { immediate: !0 });
    const o = L([]);
    ne([o, () => e.maxDepth], ([p, h]) => {
      i(p, h) || Cn(e.modelValue ? "modelValue" : "items", "Provided list depth exceeds `maxDepth`");
    }, {
      immediate: !0,
      deep: !0
    });
    const u = a, l = b({
      get() {
        return e.modelValue;
      },
      set(p) {
        o.value = p;
      }
    }), s = b(() => ({
      maxWidth: Dt(e.width)
    })), d = (p, h) => {
      (h || o.value).forEach((w) => {
        var $;
        w.id === p.id ? (w.selected = !0, u("selected", p)) : w.selected = !1, ($ = w.children) != null && $.length && d(p, w.children);
      });
    }, c = (p) => {
      u("change", p);
    }, f = (p) => {
      u("child-change", p);
    };
    ne(l, (p, h) => {
      JSON.stringify(p) !== JSON.stringify(h) && (o.value = p || [], o.value.forEach((g) => {
        g.children || (g.children = []);
      }));
    }), ne(() => e.items, (p, h) => {
      JSON.stringify(p) !== JSON.stringify(h) && (o.value = p || [], o.value.forEach((g) => {
        g.children || (g.children = []);
      }));
    });
    const v = mt("tree-draggable");
    return t({ collapseAll: () => {
      var p;
      (p = v.value) == null || p.collapseAll();
    }, expandAll: () => {
      var p;
      (p = v.value) == null || p.expandAll();
    } }), rt(() => {
      e.modelValue ? o.value = e.modelValue : e.items && (o.value = e.items), o.value.forEach((p) => {
        p.children || (p.children = []);
      });
    }), (p, h) => (y(), S("div", {
      class: "k-tree-list",
      "data-testid": "k-tree-list",
      style: Ee(p.width ? s.value : void 0)
    }, [
      Z(iH, {
        ref: "tree-draggable",
        collapsible: p.collapsible,
        "data-testid": `k-tree-list-${p.group}`,
        "disable-drag": p.disableDrag,
        filter: p.ignoreDragSelectors,
        group: p.group,
        "hide-icons": p.hideIcons,
        "initial-collapse-all": p.initialCollapseAll,
        items: o.value,
        "max-depth": p.maxDepth,
        onChange: c,
        onChildChange: f,
        onSelected: d
      }, yt({
        "item-label": N(({ item: g }) => [
          j(p.$slots, "item-label", { item: g })
        ]),
        _: 2
      }, [
        p.$slots["item-icon"] ? {
          name: "item-icon",
          fn: N(({ item: g }) => [
            j(p.$slots, "item-icon", { item: g })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["collapsible", "data-testid", "disable-drag", "filter", "group", "hide-icons", "initial-collapse-all", "items", "max-depth"])
    ], 4));
  }
}), sH = ["href"], lH = /* @__PURE__ */ se({
  __name: "KExternalLink",
  props: {
    href: {},
    hideIcon: { type: Boolean }
  },
  setup(e) {
    ne(() => e.href, (a) => {
      Op(a) || Cn("href", `\`href\` should be a valid URL, but got "${a}".`);
    }, { immediate: !0 });
    const t = b(() => !!Op(e.href));
    return (a, n) => t.value ? (y(), S("a", {
      key: 0,
      class: "k-external-link",
      href: a.href,
      rel: "noopener",
      target: "_blank"
    }, [
      j(a.$slots, "default", {}, void 0, !0),
      a.hideIcon ? W("", !0) : (y(), ee(A(uy), {
        key: 0,
        decorative: "",
        size: A(Ca)
      }, null, 8, ["size"]))
    ], 8, sH)) : W("", !0);
  }
}), uH = /* @__PURE__ */ Me(lH, [["__scopeId", "data-v-ec2a67ce"]]), dH = {
  key: 0,
  class: "truncate-expand-controls"
}, cH = {
  key: 0,
  "data-testid": "expand-trigger-wrapper"
}, fH = ["aria-label"], vH = {
  key: 0,
  "data-testid": "collapse-trigger-wrapper"
}, pH = {
  key: 0,
  "data-testid": "expand-trigger-wrapper"
}, hH = { key: 1 }, gH = /* @__PURE__ */ se({
  __name: "KTruncate",
  props: {
    rows: { default: 1 },
    truncateText: { type: Boolean },
    expanded: { type: Boolean },
    width: { default: "100%" }
  },
  setup(e) {
    Yt((C) => ({
      "7164fd89": u.value,
      "5e3d5385": A(l),
      "6972530a": C.rows
    })), ne(
      () => e.rows,
      (C) => {
        C < 0 && Cn("rows", `\`rows\` prop cannot be less than 0, but got "${C}".`);
      },
      { immediate: !0 }
    );
    const t = L(e.expanded), a = L(!1), n = L(), r = L(), i = L(), o = L(), u = L("0px"), l = Hy, s = L(0), d = async () => {
      var C;
      if (!e.truncateText && r.value && (C = r.value.children) != null && C.length) {
        const p = r.value.children, h = Number(String(l).replace(/px$/gi, ""));
        let g = 0;
        for (let $ = 0; $ < p.length; $++)
          g = p[$].offsetHeight > g ? p[$].offsetHeight : g;
        const w = (e.rows === 1 ? 0 : (e.rows - 1) * h) + g * e.rows + 6;
        u.value = r.value.offsetHeight > w ? `${w}px` : "auto", await gt(), c();
      }
    }, c = () => {
      if (r.value && i.value) {
        const C = e.truncateText ? r.value.scrollHeight : r.value.offsetHeight, p = o.value ? o.value.offsetHeight : 0;
        a.value = C > i.value.offsetHeight - p, f();
      }
    }, f = () => {
      if (!e.truncateText && (s.value = 0, r.value && i.value)) {
        const C = r.value.children;
        for (let p = 0; p < C.length; p++)
          C[p].offsetTop > i.value.offsetHeight ? (s.value += 1, C[p].getAttribute("tabindex") && (C[p].tabIndex = -1)) : C[p].getAttribute("tabindex") && (C[p].tabIndex = 0);
      }
    }, v = async () => {
      t.value = !t.value, await gt(), c();
    }, m = b(() => ({
      width: Dt(e.width)
    }));
    return rt(() => {
      n.value = or.create(d), n.value.observe(r.value), c();
    }), cn(() => {
      var C;
      (C = n.value) == null || C.unobserve(r.value);
    }), (C, p) => {
      const h = zt("KButton");
      return y(), S("div", {
        ref_key: "kTruncateWrapper",
        ref: i,
        class: ue(["k-truncate", [t.value ? "expanded" : "", `truncate-${C.truncateText ? "text" : "content"}`]]),
        style: Ee(m.value)
      }, [
        !C.truncateText && a.value ? (y(), S("div", dH, [
          t.value ? W("", !0) : (y(), S("div", cH, [
            j(C.$slots, "expand-trigger", {
              expand: v,
              truncatedCount: s.value
            }, () => [
              H("button", {
                "aria-label": `Show ${s.value} more items`,
                class: "expand-trigger",
                type: "button",
                onClick: Ke(v, ["stop"])
              }, ae(s.value), 9, fH)
            ], !0)
          ]))
        ])) : W("", !0),
        H("div", {
          ref_key: "kTruncateContainer",
          ref: r,
          class: "truncate-container"
        }, [
          j(C.$slots, "default", {}, void 0, !0),
          !C.truncateText && t.value ? (y(), S("div", vH, [
            j(C.$slots, "collapse-trigger", { collapse: v }, () => [
              H("button", {
                "aria-label": "Collapse content",
                class: "collapse-trigger",
                type: "button",
                onClick: Ke(v, ["stop"])
              }, [
                Z(A(ty), {
                  decorative: "",
                  size: A(Ca)
                }, null, 8, ["size"])
              ])
            ], !0)
          ])) : W("", !0)
        ], 512),
        C.truncateText && (a.value || t.value) ? (y(), S("div", {
          key: 1,
          ref_key: "textToggleControls",
          ref: o,
          class: "truncate-collapse-controls"
        }, [
          t.value ? W("", !0) : (y(), S("div", pH, [
            j(C.$slots, "expand-trigger", { expand: v }, () => [
              Z(h, {
                appearance: "tertiary",
                size: "small",
                onClick: Ke(v, ["stop"])
              }, {
                default: N(() => p[0] || (p[0] = [
                  be(" Show more ")
                ])),
                _: 1,
                __: [0]
              })
            ], !0)
          ])),
          t.value ? (y(), S("div", hH, [
            j(C.$slots, "collapse-trigger", { collapse: v }, () => [
              Z(h, {
                appearance: "tertiary",
                size: "small",
                onClick: Ke(v, ["stop"])
              }, {
                default: N(() => p[1] || (p[1] = [
                  be(" Show less ")
                ])),
                _: 1,
                __: [1]
              })
            ], !0)
          ])) : W("", !0)
        ], 512)) : W("", !0)
      ], 6);
    };
  }
}), mH = /* @__PURE__ */ Me(gH, [["__scopeId", "data-v-32767851"]]), yH = { class: "k-copy" }, bH = {
  key: 0,
  class: "copy-badge-text"
}, wH = ["id", "aria-label", "onClick"], CH = /* @__PURE__ */ se({
  __name: "KCopy",
  props: {
    badgeLabel: { default: "" },
    text: {},
    textTooltip: { default: "" },
    copyTooltip: { default: "" },
    format: { default: "default" },
    badge: { type: Boolean },
    monospace: { type: Boolean },
    truncate: { type: Boolean },
    successTooltip: { default: "Copied!" },
    truncationLimit: { default: 8 }
  },
  setup(e, { expose: t }) {
    const a = bt(), n = L(""), r = b(() => !e.badgeLabel || e.copyTooltip ? e.copyTooltip || "Copy" : `Copy ${e.badgeLabel.replace(/:$/, "")}`);
    ne(r, (p) => {
      n.value = p;
    }, { immediate: !0 });
    const i = b(() => `copy-tooltip-wrapper ${e.truncate && m.value || e.badge ? "truncate-content" : ""}`), o = b(() => e.format === "redacted" ? "*****" : e.format === "deleted" ? `*${String(e.text || "").substring(0, 5)}` : e.truncate && e.truncationLimit && v.value ? v.value.replace(/^"(.*)"$/, "$1") : e.text), u = b(() => {
      if (e.textTooltip)
        return e.textTooltip;
      if (!(e.format === "redacted" || !m.value))
        return e.text;
    }), l = (p) => {
      n.value = p || e.successTooltip, setTimeout(() => {
        n.value = r.value;
      }, 1800);
    }, s = async (p) => {
      if (!await p(e.text)) {
        l("Failed to copy");
        return;
      }
      l();
    };
    t({
      copy: () => {
        var p;
        document != null && document.getElementById(a) && ((p = document == null ? void 0 : document.getElementById(a)) == null || p.click());
      }
    });
    const c = L(), f = L(), v = b(() => e.truncate && typeof e.truncationLimit == "number" ? `${String(e.text || "").substring(0, e.truncationLimit) + "..."}` : null), m = L(!1), C = () => {
      var p, h;
      e.truncate && (e.truncationLimit !== "auto" && v.value ? m.value = !0 : e.truncationLimit === "auto" && c.value && (m.value = ((p = c.value) == null ? void 0 : p.offsetWidth) < ((h = c.value) == null ? void 0 : h.scrollWidth)));
    };
    return rt(() => {
      f.value = or.create(C), f.value.observe(c.value);
    }), cn(() => {
      f.value && f.value.unobserve(c.value);
    }), (p, h) => (y(), S("div", yH, [
      p.badge && p.badgeLabel ? (y(), S("span", bH, ae(p.badgeLabel), 1)) : W("", !0),
      H("div", {
        class: ue(["copy-container", { "copy-element": p.truncate || p.badge, "badge-styles": p.badge }])
      }, [
        p.format !== "hidden" ? (y(), ee(ga, {
          key: 0,
          class: ue([i.value]),
          "data-testid": "copy-tooltip-wrapper",
          "max-width": "500px",
          placement: "bottom-start",
          text: u.value
        }, {
          default: N(() => [
            H("div", {
              ref_key: "copyTextElement",
              ref: c,
              class: ue(["copy-text", { monospace: p.monospace || !p.badge }])
            }, ae(o.value), 3)
          ]),
          _: 1
        }, 8, ["class", "text"])) : W("", !0),
        Z(ga, {
          class: "text-icon-wrapper",
          "max-width": "500px",
          placement: "bottom-start",
          text: n.value
        }, {
          default: N(() => [
            Z(ah, null, {
              default: N(({ copyToClipboard: g }) => [
                H("button", {
                  id: A(a),
                  "aria-label": n.value,
                  class: "copy-to-clipboard-button",
                  "data-testid": "copy-to-clipboard",
                  type: "button",
                  onClick: Ke((w) => s(g), ["stop"])
                }, [
                  Z(A(lh), {
                    class: "text-icon",
                    decorative: "",
                    size: A(Ca)
                  }, null, 8, ["size"])
                ], 8, wH)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["text"])
      ], 2)
    ]));
  }
}), kH = /* @__PURE__ */ Me(CH, [["__scopeId", "data-v-5cce612d"]]), $H = {
  key: 0,
  class: "bulk-actions-dropdown-trigger-count"
}, SH = /* @__PURE__ */ se({
  __name: "BulkActionsDropdown",
  props: {
    disabled: { type: Boolean },
    count: { default: "" },
    buttonLabel: { default: "" }
  },
  setup(e) {
    return (t, a) => (y(), ee(Br, {
      class: "bulk-actions-dropdown",
      "data-testid": "bulk-actions-dropdown",
      disabled: t.disabled,
      "kpop-attributes": { placement: "bottom-end" }
    }, {
      items: N(() => [
        j(t.$slots, "items", {}, void 0, !0)
      ]),
      default: N(() => [
        Z(ga, {
          placement: "bottom-end",
          text: "Selected Row Actions"
        }, {
          default: N(() => [
            Z(nt, {
              appearance: "secondary",
              "aria-label": t.buttonLabel,
              class: "bulk-actions-dropdown-trigger",
              "data-testid": "bulk-actions-dropdown-trigger",
              disabled: t.disabled,
              icon: "",
              size: "large"
            }, {
              default: N(() => [
                Z(A(dh), {
                  class: "more-icon",
                  decorative: ""
                }),
                Z(Zt, { name: "kongponents-fade-transition" }, {
                  default: N(() => [
                    t.count ? (y(), S("span", $H, ae(t.count), 1)) : W("", !0)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["aria-label", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 8, ["disabled"]));
  }
}), TH = /* @__PURE__ */ Me(SH, [["__scopeId", "data-v-cf7c2833"]]), DH = {
  key: 0,
  class: "table-toolbar",
  "data-testid": "table-toolbar"
}, AH = {
  key: 0,
  class: "toolbar-default-items-container"
}, IH = {
  key: 2,
  class: "table-error-state",
  "data-testid": "table-error-state"
}, EH = {
  key: 3,
  class: "table-empty-state",
  "data-testid": "table-empty-state"
}, MH = {
  key: 4,
  class: "table-container"
}, OH = ["data-tableid"], xH = ["aria-sort", "data-key", "data-testid", "onClick", "onMouseover"], PH = ["onMousedown", "onMouseover"], NH = ["aria-describedby"], LH = {
  key: 1,
  class: "table-header-bulk-actions-container"
}, BH = ["onMousedown", "onMouseover"], RH = ["role", "tabindex"], FH = {
  key: 1,
  class: "expandable-row-control-container"
}, zH = ["aria-controls", "aria-expanded", "onClick"], YH = ["id"], HH = ["colspan"], qH = { class: "expandable-content-wrapper" }, WH = /* @__PURE__ */ se({
  __name: "KTableView",
  props: {
    data: { default: () => [] },
    headers: { default: () => [] },
    resizeColumns: { type: Boolean },
    tablePreferences: { default: () => ({}) },
    rowHover: { type: Boolean, default: !0 },
    rowAttrs: { default: () => () => ({}) },
    rowLink: { default: () => () => ({}) },
    rowBulkActionEnabled: { default: () => () => !0 },
    rowKey: {},
    cellAttrs: { default: () => () => ({}) },
    loading: { type: Boolean },
    emptyStateTitle: { default: "No Data" },
    emptyStateMessage: { default: "There is no data to display." },
    emptyStateActionRoute: {},
    emptyStateActionMessage: { default: "" },
    emptyStateIconVariant: { default: () => xa.Default },
    emptyStateButtonAppearance: { default: "primary" },
    error: { type: Boolean },
    errorStateTitle: { default: "An error occurred" },
    errorStateMessage: { default: "Data cannot be displayed due to an error." },
    errorStateActionRoute: {},
    errorStateActionMessage: { default: "" },
    maxHeight: { default: "none" },
    hidePagination: { type: Boolean },
    paginationAttributes: { default: () => ({}) },
    rowExpandable: { default: () => () => !1 },
    rowExpanded: { default: () => () => !1 },
    hideHeaders: { type: Boolean },
    nested: { type: Boolean },
    hidePaginationWhenOptional: { type: Boolean },
    hideToolbar: { type: Boolean },
    tooltipTarget: { default: "body" },
    "onRow:click": { type: Function },
    "onRow:dblclick": { type: Function },
    "onRow:auxclick": { type: Function },
    "onRow:contextmenu": { type: Function },
    "onRow:mouseover": { type: Function },
    "onRow:mouseout": { type: Function },
    "onRow:mouseenter": { type: Function },
    "onRow:mouseleave": { type: Function },
    "onRow:mousedown": { type: Function },
    "onRow:mouseup": { type: Function },
    "onRow:focus": { type: Function },
    "onRow:focusin": { type: Function },
    "onRow:blur": { type: Function },
    "onRow:focusout": { type: Function },
    "onRow:keydown": { type: Function },
    "onRow:keyup": { type: Function },
    "onRow:keypress": { type: Function },
    "onCell:click": { type: Function },
    "onCell:dblclick": { type: Function },
    "onCell:auxclick": { type: Function },
    "onCell:contextmenu": { type: Function },
    "onCell:mouseover": { type: Function },
    "onCell:mouseout": { type: Function },
    "onCell:mouseenter": { type: Function },
    "onCell:mouseleave": { type: Function },
    "onCell:mousedown": { type: Function },
    "onCell:mouseup": { type: Function },
    "onCell:focus": { type: Function },
    "onCell:focusin": { type: Function },
    "onCell:blur": { type: Function },
    "onCell:focusout": { type: Function },
    "onCell:keydown": { type: Function },
    "onCell:keyup": { type: Function },
    "onCell:keypress": { type: Function }
  },
  emits: ["page-change", "page-size-change", "get-next-offset", "get-previous-offset", "cell-click", "row-click", "error-action-click", "empty-state-action-click", "update:table-preferences", "sort", "row-select", "update:row-expanded", "row-actions-toggle"],
  setup(e, { emit: t }) {
    var we;
    Yt((E) => ({
      "7853f3d5": A(ot).expandable,
      "7ab671f2": Ce.value,
      "2813a86c": T.value,
      "632a8f9e": J.value
    }));
    const a = eh(e, ["resizeColumns", "tablePreferences", "rowHover", "rowAttrs", "rowLink", "rowBulkActionEnabled", "rowKey", "cellAttrs", "loading", "emptyStateTitle", "emptyStateMessage", "emptyStateActionMessage", "emptyStateIconVariant", "emptyStateButtonAppearance", "emptyStateActionRoute", "error", "errorStateTitle", "errorStateMessage", "errorStateActionMessage", "errorStateActionRoute", "maxHeight", "hidePagination", "paginationAttributes", "rowExpandable", "rowExpanded", "hideHeaders", "nested", "hidePaginationWhenOptional", "hideToolbar", "tooltipTarget", "data", "headers"]), n = t, r = Tt(), i = bt(), o = (E) => typeof e.rowKey == "function" && typeof e.rowKey(E) == "string" ? e.rowKey(E) : typeof e.rowKey == "string" && e.rowKey in E && typeof E[e.rowKey] == "string" ? E[e.rowKey] : "", u = mt("table-wrapper"), l = mt("header-row"), s = L([]), d = L([]), c = L(""), f = L(""), v = L(""), m = b(() => s.value.some((E) => E.key === We.ACTIONS)), C = b(() => s.value.filter((E) => E.hidable).length > 0), p = b(() => e.nested || !C.value || e.error ? !1 : r.toolbar ? !0 : !e.loading && !!e.data && !!e.data.length), h = b(() => e.loading || !(e.data && e.data.length)), g = b(() => s.value.filter((E) => E.hidable && !dt(E.key))), w = b(() => p.value ? e.tablePreferences.columnVisibility || {} : {}), $ = L(p.value ? e.tablePreferences.columnVisibility || {} : {}), T = L("100%"), O = L(!1), M = L(!1), F = L(!1), q = L(!1), x = L(e.tablePreferences.sortColumnKey || ""), Y = L(e.tablePreferences.sortColumnOrder || "desc"), R = L(!1), k = b(() => !e.hideToolbar && !e.nested && (!!r.toolbar || p.value || pe.value)), P = mt("actionsDropdown"), D = L(!1), B = b(() => ({
      maxHeight: Dt(e.maxHeight)
    })), J = b(() => `${vg()}px`), _ = L([]), te = b(() => !e.nested && !e.error && s.value.some((E) => E.key === We.BULK_ACTIONS) && !!(r["bulk-action-items"] || r["bulk-actions"]) && !!e.data.every((E) => o(E))), G = L([]), pe = b(() => e.nested || !te.value || e.error ? !1 : r.toolbar ? !0 : !e.loading && !!e.data && !!e.data.length), ce = b(() => {
      const E = _.value.length;
      return E ? E > 100 ? "99+" : String(E) : "";
    }), $e = L(/* @__PURE__ */ new WeakMap()), ge = (E) => `column-${E}`, Se = (E) => `tooltip-${E}`, Ue = (E, V) => (K, me) => {
      const he = /^on[^a-z]/, Ve = {};
      for (const Pe in V)
        he.test(Pe) && V[Pe] && (Ve[Pe] = V[Pe]);
      return Object.keys(Ve).reduce((Pe, je) => {
        if (je.indexOf(E) === 0) {
          const Nt = je.split(E);
          Pe[Nt[1]] = (Qa) => Ve[je](Qa, K, me);
        }
        return Pe;
      }, {});
    }, Ne = b(() => (E, V) => {
      const K = Ue("onRow:", a)(V, "row"), me = Ue("onCell:", a)(E, "cell"), he = ["a", "button", "label", "input", "select", 'span[role="checkbox"]'];
      return (K.click || me.click) && (R.value = !0), {
        ...K,
        ...me,
        click(Ve) {
          const Pe = Ve.target, je = Pe.className;
          let Nt = he.includes(Pe.tagName.toLowerCase()), Qa = !1;
          typeof je == "string" || Array.isArray(je) ? Qa = je.includes("k-popover") : typeof je == "object" && (Qa = Object.keys(je).includes("k-popover")), Pe.closest(".popover-content") !== null && (Qa = !0);
          for (let Za = 0; Za < he.length; Za++)
            if (Pe.closest(he[Za]) !== null) {
              Nt = !0;
              break;
            }
          if ((!Nt || Pe.hasAttribute("disabled")) && !Qa && (K.click || me.click))
            if (me.click) {
              n("cell-click", { data: E });
              const Za = me.click(Ve, E, "cell");
              typeof Za == "function" && Za(Ve, E);
            } else {
              n("row-click", { data: V });
              const Za = K.click(Ve, V, "row");
              typeof Za == "function" && Za(Ve, V);
            }
        }
      };
    }), He = parseInt(vh) * 2 + parseInt(Ca), Xe = { expandable: He, bulkActions: 48, actions: 54 }, ot = x$(Xe, (E) => `${E}px`), Ge = L(((we = e.tablePreferences) == null ? void 0 : we.columnWidths) || Xe), Je = b(() => {
      const E = {};
      for (const V in Ge.value) {
        const K = V;
        if (!Ge.value[K])
          continue;
        const me = Ge.value[K] + "px";
        E[K] = {
          width: me,
          maxWidth: me,
          minWidth: me
        };
      }
      return E;
    }), et = (E, V) => ({
      // display the resize handle on the right side of the column if resizeColumns is enabled, hovering current column, and not the last column
      "resize-hover": fe.value === E.key && V !== d.value.length - 1 && Qe(E),
      resizable: e.resizeColumns && !e.nested,
      // display sort control if column is sortable, label is visible, and sorting is not disabled
      sortable: !E.hideLabel && !!E.sortable,
      // display active sorting styles if column is currently sorted
      "active-sort": !E.hideLabel && !!E.sortable && E.key === x.value,
      [Y.value]: E.key === x.value && !E.hideLabel,
      "is-scrolled": M.value,
      "has-tooltip": !!E.tooltip,
      "sticky-column": De(E.key),
      "second-sticky-column": qe(E.key),
      "has-row-scroll-overlay": ct(E.key),
      "actions-column": E.key === We.ACTIONS
    }), ie = (E) => {
      if (E.sortable && E.key !== We.BULK_ACTIONS && E.key !== We.ACTIONS) {
        let V = "asc";
        E.key === x.value && Y.value === "asc" && (V = "desc"), n("sort", {
          prevKey: x.value,
          sortColumnKey: E.key,
          sortColumnOrder: V
        }), Gt(E);
      }
    }, le = b(() => c.value ? "resizing" : f.value ? "resize-hover" : v.value ? "th-hover" : ""), fe = b(() => {
      switch (le.value) {
        case "resizing":
          return c.value;
        case "resize-hover":
          return f.value;
        case "th-hover":
          return v.value;
        default:
          return "";
      }
    }), z = b(() => {
      var E;
      return (E = l.value) == null ? void 0 : E.querySelectorAll("th.resizable");
    }), Ce = b(() => {
      var V;
      const E = (V = z.value) == null ? void 0 : V.item(0);
      if (E) {
        const K = window == null ? void 0 : window.getComputedStyle(E);
        if (K != null && K.height)
          return `${parseInt(K.height, 10)}px`;
      }
      return "auto";
    }), xe = (E, V) => {
      var je;
      if (E.button !== 0)
        return;
      let K = 0, me = 0;
      c.value = V;
      let he = null;
      (je = z.value) == null || je.forEach((Nt) => {
        Nt.getAttribute("data-testid") === `table-header-${V}` && (he = document == null ? void 0 : document.querySelector(`[data-tableid="${i}"] [data-testid="table-header-${V}"]`));
      });
      const Ve = (Nt) => {
        const Qa = Nt.clientX - K;
        he == null || he.setAttribute("style", `width: ${me + Qa}px`), Ge.value[V] = me + Qa;
      }, Pe = () => {
        c.value = "", document == null || document.removeEventListener("mousemove", Ve), document == null || document.removeEventListener("mouseup", Pe), I(), Q.value && ua();
      };
      if (K = E.clientX, he) {
        const Nt = window == null ? void 0 : window.getComputedStyle(he);
        Nt != null && Nt.width && (me = parseInt(Nt.width, 10)), document == null || document.addEventListener("mousemove", Ve), document == null || document.addEventListener("mouseup", Pe);
      }
    }, De = (E) => F.value ? E === We.BULK_ACTIONS || E === We.EXPANDABLE : !1, qe = (E) => E === We.BULK_ACTIONS && Q.value, ct = (E) => F.value ? te.value ? E === We.BULK_ACTIONS : Q.value ? E === We.EXPANDABLE : !1 : !1, dt = (E) => E === We.EXPANDABLE || E === We.BULK_ACTIONS || E === We.ACTIONS, Qe = (E, V = !1) => {
      if (!e.resizeColumns || e.nested)
        return !1;
      if (V) {
        if (d.value.indexOf(E) === d.value.length - 1)
          return !1;
        const me = d.value[d.value.indexOf(E) - 1];
        return !dt(me.key);
      }
      const K = d.value[d.value.indexOf(E) + 1];
      return !dt(E.key) && !dt(K.key);
    }, pt = (E, V, K) => {
      n("row-actions-toggle", { row: E, open: V }), setTimeout(() => {
        K.isRowActionsDropdownOpen = V;
      }, V ? 0 : 100);
    }, It = b(() => !(e.hidePagination || e.nested || e.hidePaginationWhenOptional && e.data.length && e.paginationAttributes.totalCount && e.paginationAttributes.totalCount <= e.data.length));
    ne(() => e.headers, (E) => {
      if (E && E.length) {
        const V = E.filter((he) => he.key !== We.BULK_ACTIONS && he.key !== We.ACTIONS), K = E.find((he) => he.key === We.BULK_ACTIONS), me = E.find((he) => he.key === We.ACTIONS);
        K && V.unshift(K), me && V.push(me), s.value = V;
      }
    }, { deep: !0, immediate: !0 });
    const Ot = (E) => !E.hideLabel && !!E.sortable && E.key !== We.BULK_ACTIONS && E.key !== We.ACTIONS, Gt = (E) => {
      const { key: V } = E;
      x.value && V === x.value ? Y.value === "asc" ? Y.value = "desc" : Y.value = "asc" : (x.value = V, Y.value = "asc"), I();
    }, ta = (E) => {
      var K;
      const V = E.target;
      V && (typeof V.scrollTop == "number" || typeof V.scrollLeft == "number") && (V.scrollTop > 1 ? (O.value = !0, M.value = !0) : V.scrollTop === 0 && (M.value = !1), V.scrollLeft > 1 ? F.value = !0 : V.scrollLeft === 0 && (F.value = !1), V.scrollWidth === V.scrollLeft + V.clientWidth ? q.value = !1 : q.value = !0), (K = P.value) == null || K.forEach((me) => {
        me && me.closeDropdown && me.closeDropdown();
      });
    }, xt = (E) => G.value.find((V) => V.rowKey === o(E)), Mt = (E) => {
      if (typeof e.rowBulkActionEnabled != "function")
        return !1;
      const V = e.rowBulkActionEnabled(E);
      return typeof V == "boolean" ? V : V.enabled;
    }, re = (E) => {
      if (typeof e.rowBulkActionEnabled != "function")
        return "";
      const V = e.rowBulkActionEnabled(E);
      return typeof V == "boolean" ? "" : V.disabledTooltip || "";
    }, ze = (E, V) => {
      const { to: K } = e.rowLink(E);
      return !K || V === We.BULK_ACTIONS || V === We.ACTIONS ? "div" : typeof K == "object" ? "router-link" : "a";
    }, U = (E, V) => {
      if (V === We.BULK_ACTIONS || V === We.ACTIONS)
        return {};
      const { to: K, target: me } = e.rowLink(E), he = K && typeof K == "object", Ve = K && typeof K == "string";
      return {
        ...he && { to: K },
        ...Ve && { href: K },
        ...(he || Ve) && {
          ...me && { target: me }
        }
      };
    }, de = L(u1(e.tablePreferences, e.paginationAttributes)), Ie = (E) => {
      de.value = E.pageSize, n("page-size-change", E), I();
    }, X = b(() => ({
      sortColumnKey: x.value,
      sortColumnOrder: Y.value,
      ...e.resizeColumns ? { columnWidths: Ge.value } : {},
      ...C.value ? { columnVisibility: $.value } : {},
      ...de.value && !e.hidePagination && { pageSize: de.value }
    })), I = () => {
      n("update:table-preferences", X.value);
    }, Q = b(() => !e.nested && e.data.some((E) => e.rowExpandable(E))), ve = { key: We.EXPANDABLE, label: "Expandable rows controls", hideLabel: !0 }, ke = () => {
      const E = [];
      return e.data.forEach((V, K) => {
        e.rowExpanded(V) && E.push(K);
      }), E;
    }, Ze = L(ke()), Ct = async (E, V) => {
      ua(), await gt(), Ze.value.includes(E) ? (Ze.value = Ze.value.filter((K) => K !== E), n("update:row-expanded", { row: V, expanded: !1 })) : (Ze.value = [...Ze.value, E], n("update:row-expanded", { row: V, expanded: !0 }));
    }, Pt = b(() => d.value.filter((E) => E.key !== We.EXPANDABLE && E.key !== We.BULK_ACTIONS)), ba = L({}), ua = () => {
      if (typeof document > "u")
        return;
      const E = document == null ? void 0 : document.querySelector(`[data-tableid="${i}"]`), V = E == null ? void 0 : E.querySelectorAll("th"), K = {};
      V == null || V.forEach((me, he) => {
        const Ve = me.getAttribute("data-key");
        if (Ve === We.EXPANDABLE)
          return;
        let Pe = me.getBoundingClientRect().width;
        he === 1 && (Pe += He), he === V.length - 1 && (Pe -= 15), K[Ve] = Pe;
      }), ba.value = K;
    };
    ne([$, s, Q], (E) => {
      const [V, K, me] = E;
      let he = K.filter((Ve) => Ve.key === We.BULK_ACTIONS ? te.value : V[Ve.key] !== !1);
      he.find((Ve) => Ve.key === We.EXPANDABLE) && (he = he.filter((Ve) => Ve.key !== We.EXPANDABLE)), me && he.unshift(ve), JSON.stringify(he) !== JSON.stringify(d.value) && (d.value = he, I()), me && ua();
    }, { deep: !0, immediate: !0 }), ne(p, (E) => {
      E && ($.value = e.tablePreferences.columnVisibility || {});
    }, { immediate: !0 });
    const da = L(!1), kt = b(() => {
      const E = G.value.filter((V) => !V.disabled && e.data.find((K) => o(K) === V.rowKey));
      return !!E.filter((V) => V.selected).length && !!E.filter((V) => !V.selected).length;
    }), oe = (E) => {
      G.value.forEach((V) => {
        e.data.find((K) => o(K) === V.rowKey) && !V.disabled && (V.selected = E);
      });
    };
    return ne([() => e.data, G], (E) => {
      const [V, K] = E;
      if (V.forEach((me) => {
        if (!$e.value.get(me)) {
          const he = o(me) || ll();
          $e.value.set(me, `table-${i}-row-${he}`);
        }
      }), te.value) {
        V.forEach((Pe) => {
          xt(Pe) || G.value.push({
            rowKey: o(Pe),
            selected: !1,
            disabled: !Mt(Pe)
          });
        });
        const me = K.filter((Pe) => !Pe.disabled && V.find((je) => o(je) === Pe.rowKey));
        me.length && me.filter((Pe) => Pe.selected).length === me.length ? da.value = !0 : (me.filter((Pe) => !Pe.selected).length, me.length, da.value = !1);
        const he = V.filter((Pe) => {
          const je = K.find((Nt) => Nt.rowKey === o(Pe));
          return !!(je && je.selected);
        }), Ve = [];
        _.value.forEach((Pe) => {
          V.find((Nt) => o(Pe) === o(Nt)) || Ve.push(Pe);
        }), _.value = [...Ve, ...he];
      }
      Ze.value = ke();
    }, { deep: !0, immediate: !0 }), ne(_, (E) => {
      n("row-select", E);
    }), ne(() => e.tablePreferences, (E) => {
      E != null && E.columnWidths && (Ge.value = E.columnWidths);
    }), e0(u, (E) => {
      var K;
      const V = (K = E[0]) == null ? void 0 : K.target;
      V && (q.value = V.scrollWidth > V.clientWidth, T.value = V.clientHeight + "px", O.value = V.scrollHeight > V.clientHeight);
    }), (E, V) => (y(), S("div", {
      class: ue(["k-table-view", { "hide-headers": E.hideHeaders }])
    }, [
      k.value ? (y(), S("div", DH, [
        j(E.$slots, "toolbar", {}, void 0, !0),
        pe.value || p.value ? (y(), S("div", AH, [
          pe.value ? j(E.$slots, "bulk-actions", {
            key: 0,
            selectedRows: _.value
          }, () => [
            E.$slots["bulk-actions"] ? W("", !0) : (y(), ee(TH, {
              key: 0,
              "button-label": s.value.find((K) => K.key === A(We).BULK_ACTIONS).label,
              count: ce.value,
              disabled: !ce.value || E.loading || !E.data.length
            }, {
              items: N(() => [
                j(E.$slots, "bulk-action-items", { selectedRows: _.value }, void 0, !0)
              ]),
              _: 3
            }, 8, ["button-label", "count", "disabled"]))
          ], !0) : W("", !0),
          p.value ? (y(), ee(d1, {
            key: 1,
            columns: g.value,
            disabled: h.value,
            "table-id": A(i),
            "visibility-preferences": w.value,
            onUpdate: V[0] || (V[0] = (K) => $.value = K)
          }, null, 8, ["columns", "disabled", "table-id", "visibility-preferences"])) : W("", !0)
        ])) : W("", !0)
      ])) : W("", !0),
      E.loading && !E.error ? (y(), ee(Us, {
        key: 1,
        "data-testid": "table-skeleton",
        type: "table"
      })) : E.error ? (y(), S("div", IH, [
        j(E.$slots, "error-state", {}, () => [
          Z(Xn, {
            "icon-variant": "error",
            message: E.errorStateMessage,
            title: E.errorStateTitle
          }, yt({ _: 2 }, [
            E.errorStateActionMessage ? {
              name: "action",
              fn: N(() => [
                Z(nt, {
                  "data-testid": "error-state-action",
                  to: E.errorStateActionRoute,
                  onClick: V[1] || (V[1] = (K) => n("error-action-click"))
                }, {
                  default: N(() => [
                    be(ae(E.errorStateActionMessage), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["message", "title"])
        ], !0)
      ])) : !E.error && !E.loading && E.data && !E.data.length ? (y(), S("div", EH, [
        j(E.$slots, "empty-state", {}, () => [
          Z(Xn, {
            "icon-variant": E.emptyStateIconVariant,
            message: E.emptyStateMessage,
            title: E.emptyStateTitle
          }, yt({ _: 2 }, [
            E.emptyStateActionMessage ? {
              name: "action",
              fn: N(() => [
                Z(nt, {
                  appearance: E.emptyStateButtonAppearance,
                  "data-testid": "empty-state-action",
                  to: E.emptyStateActionRoute,
                  onClick: V[2] || (V[2] = (K) => n("empty-state-action-click"))
                }, {
                  default: N(() => [
                    j(E.$slots, "empty-state-action-icon", {}, void 0, !0),
                    be(" " + ae(E.emptyStateActionMessage), 1)
                  ]),
                  _: 3
                }, 8, ["appearance", "to"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["icon-variant", "message", "title"])
        ], !0)
      ])) : (y(), S("div", MH, [
        H("div", {
          ref: "table-wrapper",
          class: "table-wrapper",
          style: Ee(B.value),
          onScrollPassive: ta
        }, [
          H("table", {
            class: ue(["table", {
              "has-hover": E.rowHover && !D.value,
              "is-clickable": R.value
            }]),
            "data-tableid": A(i)
          }, [
            E.hideHeaders ? W("", !0) : (y(), S("thead", {
              key: 0,
              class: ue({ "is-scrolled": M.value })
            }, [
              H("tr", {
                ref: "header-row",
                class: ue({ "is-scrolled": M.value })
              }, [
                (y(!0), S(Ae, null, Le(d.value, (K, me) => (y(), S("th", {
                  key: `table-${A(i)}-headers-${K.key}`,
                  "aria-sort": K.key === x.value ? Y.value === "asc" ? "ascending" : "descending" : void 0,
                  class: ue(["table-headers", et(K, me)]),
                  "data-key": K.key,
                  "data-testid": `table-header-${K.key}`,
                  style: Ee(Je.value[K.key]),
                  onClick: () => ie(K),
                  onMouseleave: V[8] || (V[8] = (he) => v.value = ""),
                  onMouseover: (he) => v.value = K.key
                }, [
                  me !== 0 && Qe(K, !0) ? (y(), S("div", {
                    key: 0,
                    class: "resize-handle previous",
                    onClick: V[3] || (V[3] = Ke(() => {
                    }, ["stop"])),
                    onMousedown: (he) => xe(he, d.value[me - 1].key),
                    onMouseleave: V[4] || (V[4] = (he) => f.value = ""),
                    onMouseover: (he) => f.value = d.value[me - 1].key
                  }, null, 40, PH)) : W("", !0),
                  H("div", {
                    "aria-describedby": K.tooltip || r[Se(K.key)] ? `${Se(K.key)}-${A(i)}` : void 0,
                    class: ue(["table-headers-container", { resized: c.value === K.key }])
                  }, [
                    K.key !== A(We).BULK_ACTIONS ? j(E.$slots, ge(K.key), {
                      key: 0,
                      column: K
                    }, () => [
                      H("span", {
                        class: ue(["table-header-label", {
                          "sr-only": K.hideLabel || K.key === A(We).ACTIONS && K.hideLabel !== !1
                        }])
                      }, ae(K.label ? K.label : K.key), 3)
                    ], !0) : (y(), S("div", LH, [
                      Z(ls, {
                        modelValue: da.value,
                        "onUpdate:modelValue": V[5] || (V[5] = (he) => da.value = he),
                        "aria-label": "Toggle selection for all rows",
                        class: "table-header-bulk-actions-checkbox",
                        "data-testid": "table-header-bulk-actions-checkbox",
                        indeterminate: kt.value,
                        onChange: oe
                      }, null, 8, ["modelValue", "indeterminate"])
                    ])),
                    K.tooltip || E.$slots[Se(K.key)] ? (y(), ee(ga, {
                      key: 2,
                      "data-testid": Se(K.key),
                      "kpop-attributes": { target: E.tooltipTarget },
                      "max-width": "300",
                      "tooltip-id": `${Se(K.key)}-${A(i)}`
                    }, {
                      content: N(() => [
                        j(E.$slots, Se(K.key), { column: K }, () => [
                          be(ae(K.tooltip), 1)
                        ], !0)
                      ]),
                      default: N(() => [
                        Z(A(In), {
                          class: "header-tooltip-trigger",
                          color: `var(--kui-color-text-neutral, ${A(Fa)})`,
                          size: A(Ca),
                          tabindex: "0"
                        }, null, 8, ["color", "size"])
                      ]),
                      _: 2
                    }, 1032, ["data-testid", "kpop-attributes", "tooltip-id"])) : W("", !0),
                    Ot(K) ? (y(), S(Ae, { key: 3 }, [
                      x.value === K.key ? (y(), ee(A(Ou), {
                        key: 0,
                        class: "active-sort-icon",
                        color: `var(--kui-color-text-primary, ${A(fh)})`,
                        decorative: "",
                        size: A(Ca)
                      }, null, 8, ["color", "size"])) : (y(), ee(A(Ty), {
                        key: 1,
                        class: "sort-icon",
                        color: `var(--kui-color-text-neutral-weak, ${A(ch)})`,
                        size: A(Ca),
                        title: `Sort by ${K.label}`
                      }, null, 8, ["color", "size", "title"]))
                    ], 64)) : W("", !0)
                  ], 10, NH),
                  me !== d.value.length - 1 && Qe(K) ? (y(), S("div", {
                    key: 1,
                    class: "resize-handle",
                    onClick: V[6] || (V[6] = Ke(() => {
                    }, ["stop"])),
                    onMousedown: (he) => xe(he, K.key),
                    onMouseleave: V[7] || (V[7] = (he) => f.value = ""),
                    onMouseover: (he) => f.value = K.key
                  }, null, 40, BH)) : W("", !0),
                  ct(K.key) ? (y(), S("div", {
                    key: 2,
                    "aria-hidden": "true",
                    class: ue(["scroll-overlay row-overlay left", {
                      "overlay-visible": F.value
                    }])
                  }, null, 2)) : W("", !0),
                  K.key === A(We).ACTIONS ? (y(), S("div", {
                    key: 3,
                    "aria-hidden": "true",
                    class: ue(["scroll-overlay row-overlay right", {
                      "overlay-visible": q.value
                    }])
                  }, null, 2)) : W("", !0)
                ], 46, xH))), 128))
              ], 2)
            ], 2)),
            H("tbody", null, [
              (y(!0), S(Ae, null, Le(E.data, (K, me) => (y(), S(Ae, {
                key: $e.value.get(K)
              }, [
                H("tr", Fe({
                  class: {
                    "last-row": me === E.data.length - 1 && !Ze.value.includes(me)
                  },
                  role: E.rowLink(K).to ? "link" : void 0,
                  tabindex: R.value && !E.rowLink(K).to ? 0 : void 0
                }, { ref_for: !0 }, E.rowAttrs(K)), [
                  (y(!0), S(Ae, null, Le(d.value, (he, Ve) => (y(), ee(A(nh), {
                    key: `${$e.value.get(K)}-cell-${he.key}`,
                    data: { isRowActionsDropdownOpen: !1 }
                  }, {
                    default: N(({ data: Pe }) => [
                      H("td", Fe({
                        class: {
                          "resize-hover": fe.value === he.key && Ve !== d.value.length - 1 && Qe(he),
                          "row-link": !!E.rowLink(K).to,
                          "sticky-column": De(he.key),
                          "second-sticky-column": qe(he.key),
                          "has-row-scroll-overlay": ct(he.key),
                          "actions-column": he.key === A(We).ACTIONS
                        },
                        style: {
                          ...Je.value[he.key],
                          ...Pe.isRowActionsDropdownOpen ? { zIndex: 2 } : {}
                        }
                      }, { ref_for: !0 }, E.cellAttrs({ headerKey: he.key, row: K, rowIndex: me, colIndex: Ve }), Bs(Ne.value(K[he.key], K), !0)), [
                        he.key !== A(We).EXPANDABLE ? (y(), ee(Ye(ze(K, he.key)), Fe({
                          key: 0,
                          class: "cell-wrapper"
                        }, { ref_for: !0 }, U(K, he.key)), {
                          default: N(() => [
                            he.key !== A(We).BULK_ACTIONS && he.key !== A(We).ACTIONS ? j(E.$slots, he.key, {
                              key: 0,
                              row: K,
                              rowKey: me,
                              rowValue: K[he.key]
                            }, () => [
                              be(ae(K[he.key]), 1)
                            ], !0) : he.key === A(We).BULK_ACTIONS && xt(K) ? (y(), ee(ga, {
                              key: 1,
                              "kpop-attributes": { target: E.tooltipTarget },
                              "max-width": "200",
                              placement: "bottom-start",
                              text: Mt(K) ? void 0 : re(K)
                            }, {
                              default: N(() => [
                                Z(ls, {
                                  modelValue: xt(K).selected,
                                  "onUpdate:modelValue": (je) => xt(K).selected = je,
                                  "aria-label": "Toggle row selection",
                                  class: "bulk-actions-checkbox",
                                  "data-testid": "bulk-actions-checkbox",
                                  disabled: !Mt(K)
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                              ]),
                              _: 2
                            }, 1032, ["kpop-attributes", "text"])) : he.key === A(We).ACTIONS ? (y(), ee(Br, {
                              key: 2,
                              ref_for: !0,
                              ref: "actionsDropdown",
                              class: "actions-dropdown",
                              "data-testid": "actions-dropdown",
                              "kpop-attributes": { placement: "bottom-end" },
                              onToggleDropdown: (je) => pt(K, je, Pe)
                            }, {
                              items: N(() => [
                                j(E.$slots, "action-items", { row: K }, void 0, !0)
                              ]),
                              default: N(() => [
                                Z(nt, {
                                  appearance: "tertiary",
                                  "aria-label": he.label,
                                  class: "actions-dropdown-trigger",
                                  "data-testid": "row-actions-dropdown-trigger",
                                  icon: "",
                                  size: "small",
                                  onMouseleave: V[9] || (V[9] = (je) => D.value = !1),
                                  onMouseover: V[10] || (V[10] = (je) => D.value = !0)
                                }, {
                                  default: N(() => [
                                    Z(A(dh), {
                                      class: "more-icon",
                                      decorative: ""
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["aria-label"])
                              ]),
                              _: 2
                            }, 1032, ["onToggleDropdown"])) : W("", !0)
                          ]),
                          _: 2
                        }, 1040)) : E.rowExpandable(K) ? (y(), S("div", FH, [
                          H("button", {
                            "aria-controls": `table-${A(i)}-row-${me}-expandable-content`,
                            "aria-expanded": Ze.value.includes(me),
                            "aria-label": "Toggle row expandable content",
                            class: ue(["expandable-row-control", { expanded: Ze.value.includes(me) }]),
                            "data-testid": "expandable-row-control",
                            type: "button",
                            onClick: (je) => Ct(me, K)
                          }, [
                            Z(A(xu), {
                              class: "expandable-row-control-icon",
                              decorative: ""
                            })
                          ], 10, zH)
                        ])) : W("", !0),
                        ct(he.key) ? (y(), S("div", {
                          key: 2,
                          "aria-hidden": "true",
                          class: ue(["scroll-overlay row-overlay left", {
                            "overlay-visible": F.value
                          }])
                        }, null, 2)) : W("", !0),
                        he.key === A(We).ACTIONS ? (y(), S("div", {
                          key: 3,
                          "aria-hidden": "true",
                          class: ue(["scroll-overlay row-overlay right", {
                            "overlay-visible": q.value
                          }])
                        }, null, 2)) : W("", !0)
                      ], 16)
                    ]),
                    _: 2
                  }, 1024))), 128))
                ], 16, RH),
                Q.value && E.rowExpandable(K) ? $a((y(), S("tr", {
                  key: 0,
                  id: `table-${A(i)}-row-${me}-expandable-content`,
                  class: "expandable-content-row",
                  "data-testid": "expandable-content-row"
                }, [
                  H("td", {
                    colspan: d.value.length
                  }, [
                    H("div", qH, [
                      j(E.$slots, "row-expanded", {
                        columnWidths: ba.value,
                        nestedHeaders: Pt.value,
                        row: K
                      }, void 0, !0)
                    ])
                  ], 8, HH)
                ], 8, YH)), [
                  [Nr, Ze.value.includes(me)]
                ]) : W("", !0)
              ], 64))), 128))
            ])
          ], 10, OH)
        ], 36),
        !te.value && !Q.value ? (y(), S("div", {
          key: 0,
          "aria-hidden": "true",
          class: ue(["scroll-overlay table-overlay left", {
            "overlay-visible": F.value
          }])
        }, null, 2)) : W("", !0),
        m.value ? W("", !0) : (y(), S("div", {
          key: 1,
          "aria-hidden": "true",
          class: ue(["scroll-overlay table-overlay right", {
            "overlay-visible": q.value,
            "scrollbar-offset": O.value
          }])
        }, null, 2)),
        It.value ? (y(), ee(Vs, Fe({
          key: 2,
          class: "table-pagination",
          "data-testid": "table-pagination"
        }, E.paginationAttributes, {
          onGetNextOffset: V[11] || (V[11] = (K) => n("get-next-offset")),
          onGetPreviousOffset: V[12] || (V[12] = (K) => n("get-previous-offset")),
          onPageChange: V[13] || (V[13] = (K) => n("page-change", K)),
          onPageSizeChange: Ie
        }), null, 16)) : W("", !0)
      ]))
    ], 2));
  }
}), T1 = /* @__PURE__ */ Me(WH, [["__scopeId", "data-v-51e517c9"]]), _H = /* @__PURE__ */ se({
  __name: "KTableData",
  props: {
    fetcher: { type: Function },
    headers: { default: () => [] },
    fetcherCacheKey: { default: "" },
    cacheIdentifier: { default: "" },
    searchInput: { default: "" },
    initialFetcherParams: { default: () => ({}) },
    clientSort: { type: Boolean },
    sortHandlerFunction: {},
    sortable: { type: Boolean, default: !0 },
    resizeColumns: { type: Boolean },
    tablePreferences: { default: () => ({}) },
    rowHover: { type: Boolean, default: !0 },
    rowAttrs: { default: () => () => ({}) },
    rowLink: { default: () => () => ({}) },
    rowBulkActionEnabled: { default: () => () => !0 },
    rowKey: {},
    cellAttrs: { default: () => () => ({}) },
    loading: { type: Boolean },
    emptyStateTitle: { default: "No Data" },
    emptyStateMessage: { default: "There is no data to display." },
    emptyStateActionRoute: {},
    emptyStateActionMessage: { default: "" },
    emptyStateIconVariant: { default: () => xa.Default },
    emptyStateButtonAppearance: {},
    error: { type: Boolean },
    errorStateTitle: { default: "An error occurred" },
    errorStateMessage: { default: "Data cannot be displayed due to an error." },
    errorStateActionRoute: {},
    errorStateActionMessage: { default: "" },
    maxHeight: { default: "none" },
    hidePagination: { type: Boolean },
    paginationAttributes: { default: () => ({}) },
    rowExpandable: { default: () => () => !1 },
    rowExpanded: { default: () => () => !1 },
    hideHeaders: { type: Boolean },
    nested: { type: Boolean },
    hidePaginationWhenOptional: { type: Boolean },
    hideToolbar: { type: Boolean },
    tooltipTarget: {},
    "onRow:click": { type: Function },
    "onRow:dblclick": { type: Function },
    "onRow:auxclick": { type: Function },
    "onRow:contextmenu": { type: Function },
    "onRow:mouseover": { type: Function },
    "onRow:mouseout": { type: Function },
    "onRow:mouseenter": { type: Function },
    "onRow:mouseleave": { type: Function },
    "onRow:mousedown": { type: Function },
    "onRow:mouseup": { type: Function },
    "onRow:focus": { type: Function },
    "onRow:focusin": { type: Function },
    "onRow:blur": { type: Function },
    "onRow:focusout": { type: Function },
    "onRow:keydown": { type: Function },
    "onRow:keyup": { type: Function },
    "onRow:keypress": { type: Function },
    "onCell:click": { type: Function },
    "onCell:dblclick": { type: Function },
    "onCell:auxclick": { type: Function },
    "onCell:contextmenu": { type: Function },
    "onCell:mouseover": { type: Function },
    "onCell:mouseout": { type: Function },
    "onCell:mouseenter": { type: Function },
    "onCell:mouseleave": { type: Function },
    "onCell:mousedown": { type: Function },
    "onCell:mouseup": { type: Function },
    "onCell:focus": { type: Function },
    "onCell:focusin": { type: Function },
    "onCell:blur": { type: Function },
    "onCell:focusout": { type: Function },
    "onCell:keydown": { type: Function },
    "onCell:keyup": { type: Function },
    "onCell:keypress": { type: Function }
  },
  emits: ["state", "cell-click", "row-click", "error-action-click", "empty-state-action-click", "update:table-preferences", "sort", "row-select", "update:row-expanded", "row-actions-toggle"],
  setup(e, { expose: t, emit: a }) {
    const n = eh(e, ["resizeColumns", "tablePreferences", "rowHover", "rowAttrs", "rowLink", "rowBulkActionEnabled", "rowKey", "cellAttrs", "loading", "emptyStateTitle", "emptyStateMessage", "emptyStateActionMessage", "emptyStateIconVariant", "emptyStateButtonAppearance", "emptyStateActionRoute", "error", "errorStateTitle", "errorStateMessage", "errorStateActionMessage", "errorStateActionRoute", "maxHeight", "hidePagination", "paginationAttributes", "rowExpandable", "rowExpanded", "hideHeaders", "nested", "hidePaginationWhenOptional", "hideToolbar", "headers", "fetcherCacheKey", "cacheIdentifier", "searchInput", "initialFetcherParams", "clientSort", "sortable", "fetcher", "sortHandlerFunction", "tooltipTarget"]), r = b(() => {
      const re = /^on[^a-z]/;
      return L$(n, (ze, U) => re.test(U));
    }), i = a, o = Tt(), { useDebounce: u, useRequest: l, useSwrvState: s, clientSideSorter: d } = Nn(), c = bt(), f = L([]), v = b(() => e.sortable ? e.headers : e.headers.map((re) => ({ ...re, sortable: !1 }))), m = b(() => e.emptyStateButtonAppearance ? e.emptyStateButtonAppearance : e.searchInput ? "tertiary" : "primary"), C = L(0), p = L(1), h = L(u1(e.tablePreferences, e.paginationAttributes)), g = L(e.searchInput ?? ""), w = L(e.tablePreferences.sortColumnKey || e.initialFetcherParams.sortColumnKey || ""), $ = L(e.tablePreferences.sortColumnOrder || e.initialFetcherParams.sortColumnOrder || "desc"), T = L(!(w.value && e.clientSort)), O = L(null), M = L([]), F = L(!0), q = L(!1), x = {
      pageSize: h.value,
      page: p.value,
      query: g.value,
      sortColumnKey: w.value,
      sortColumnOrder: $.value,
      offset: O.value
    }, Y = b(() => ({
      totalCount: C.value,
      initialPageSize: h.value,
      currentPage: p.value,
      offsetPreviousButtonDisabled: !ge.value,
      offsetNextButtonDisabled: !Se.value || !F.value,
      ...e.paginationAttributes
    })), R = (re) => re.startsWith("column-"), k = (re) => re.startsWith("tooltip-"), P = (re) => v.value.some((ze) => ze.key === re), D = b(() => o ? Object.keys(o).filter(R) : []), B = b(() => o ? Object.keys(o).filter(k) : []), J = b(() => o ? Object.keys(o).filter(P) : []), _ = b(() => ({
      sortColumnKey: w.value,
      sortColumnOrder: $.value
    })), te = b(() => ({
      pageSize: h.value,
      page: p.value,
      query: g.value,
      offset: O.value,
      ...e.clientSort ? {} : _.value
    })), G = b(() => ({
      ...te.value,
      ..._.value
    })), pe = L(!0), ce = async () => {
      const re = await e.fetcher(G.value);
      return pe.value = !1, re;
    }, $e = () => {
      var ze;
      const re = {
        ...x,
        ...e.initialFetcherParams
      };
      p.value = re.page ?? x.page, h.value = re.pageSize ?? x.pageSize, g.value = re.query ?? x.query, w.value = re.sortColumnKey ?? x.sortColumnKey, $.value = re.sortColumnOrder ?? x.sortColumnOrder, e.clientSort && w.value && $.value && d(w.value, "", $.value, f.value), (ze = e.paginationAttributes) != null && ze.offset && (O.value = re.offset, M.value.push(re.offset)), q.value = !0;
    }, ge = b(() => M.value[p.value - 1]), Se = L(null), Ue = b(() => {
      if (!e.fetcher || !q.value)
        return "";
      let re = c;
      return e.cacheIdentifier && (re = e.cacheIdentifier), re += `-${JSON.stringify(te.value)}`, e.fetcherCacheKey && (re += `-${e.fetcherCacheKey}`), `k-table_${re}`;
    }), { debouncedFn: Ne, generateDebouncedFn: He } = u((re) => {
      g.value = re;
    }, 350), Xe = He(0), {
      data: ot,
      response: Ge,
      error: Je,
      revalidate: et,
      isValidating: ie,
      isLoading: le
    } = l(
      () => Ue.value,
      () => ce(),
      { revalidateOnFocus: !1, revalidateDebounce: 0 }
    ), { state: fe, hasData: z } = s(ot, Je, ie), Ce = b(() => ({
      hasData: z.value,
      state: fe.value
    })), xe = b(() => le.value ? "loading" : Je.value ? "error" : "success"), { debouncedFn: De } = u(et, 500), qe = ({ sortColumnKey: re, prevKey: ze, sortColumnOrder: U }) => {
      var X;
      T.value = !0;
      const de = v.value.find((I) => I.key === re) || {}, { useSortHandlerFunction: Ie } = de;
      if (i("sort", {
        prevKey: ze,
        sortColumnKey: re,
        sortColumnOrder: U
      }), p.value = 1, (!w.value || re !== w.value) && (M.value = [null]), w.value = re, $.value = U, e.clientSort)
        if (Ie && e.sortHandlerFunction) {
          const I = e.sortHandlerFunction({
            key: re,
            prevKey: ze,
            sortColumnOrder: $.value,
            data: f.value
          });
          I && (f.value = [...I]);
        } else
          d(re, ze, $.value, f.value);
      else (X = e.paginationAttributes) != null && X.offset || De();
    }, ct = ({ page: re }) => {
      p.value = re;
    }, dt = ({ pageSize: re }) => {
      M.value = [null], O.value = null, h.value = re, p.value = 1;
    }, Qe = ({ columnWidths: re, columnVisibility: ze }) => {
      pt.value = re, It.value = ze, Gt();
    }, pt = L({}), It = L({}), Ot = b(() => ({
      pageSize: h.value,
      sortColumnKey: w.value,
      sortColumnOrder: $.value,
      ...pt.value ? { columnWidths: pt.value } : {},
      ...It.value ? { columnVisibility: It.value } : {}
    })), Gt = () => {
      xe.value === "success" && i("update:table-preferences", Ot.value);
    }, ta = () => {
      p.value++, O.value = Se.value;
    }, xt = () => {
      p.value--, O.value = ge.value;
    }, Mt = b(() => {
      var ze, U, de;
      if (!e.fetcher || e.hidePagination)
        return !1;
      const re = ((U = (ze = e.paginationAttributes) == null ? void 0 : ze.pageSizes) == null ? void 0 : U[0]) ?? l1;
      return e.hidePaginationWhenOptional && p.value === 1 ? (de = e.paginationAttributes) != null && de.offset ? !!ge.value || !!Se.value || f.value.length >= re : C.value > re : !0;
    });
    return ne(Ge, (re) => {
      var ze, U, de, Ie;
      re != null && re.data && (f.value = [...re.data], C.value = ((ze = e.paginationAttributes) == null ? void 0 : ze.totalCount) || re.total || ((U = re.data) == null ? void 0 : U.length) || 0, (de = e.paginationAttributes) != null && de.offset && ((Ie = re.pagination) != null && Ie.offset ? (Se.value = re.pagination.offset, M.value[p.value] || M.value.push(re.pagination.offset)) : Se.value = null, F.value = re.pagination && "hasNextPage" in re.pagination ? re.pagination.hasNextPage || !1 : !0), f.value.length === 0 && p.value > 1 && (p.value = 1, M.value = [null], O.value = null), e.sortable && !T.value && qe({ sortColumnKey: w.value, prevKey: "", sortColumnOrder: $.value }));
    }, { deep: !0, immediate: !0 }), ne([Ce, xe], (re) => {
      const [ze, U] = re;
      i("state", {
        state: U,
        hasData: ze.hasData
      });
    }), ne(() => e.searchInput, (re) => {
      re === "" ? Xe(re) : Ne(re);
    }, { immediate: !0 }), ne([g, h], async (re, ze) => {
      const [U] = ze, [de] = re;
      de !== U && p.value !== 1 && (p.value = 1, M.value = [null], O.value = null);
    }, { deep: !0, immediate: !0 }), rt(() => {
      $e();
    }), t({
      revalidate: () => {
        et();
      }
    }), (re, ze) => (y(), ee(T1, Fe({
      "cell-attrs": re.cellAttrs,
      class: "k-table-data",
      data: f.value,
      "empty-state-action-message": re.emptyStateActionMessage,
      "empty-state-action-route": re.emptyStateActionRoute,
      "empty-state-button-appearance": m.value,
      "empty-state-icon-variant": re.emptyStateIconVariant,
      "empty-state-message": re.emptyStateMessage,
      "empty-state-title": re.emptyStateTitle,
      error: re.error,
      "error-state-action-message": re.errorStateActionMessage,
      "error-state-action-route": re.errorStateActionRoute,
      "error-state-message": re.errorStateMessage,
      "error-state-title": re.errorStateTitle,
      headers: v.value,
      "hide-headers": re.hideHeaders,
      "hide-pagination": re.hidePagination || !Mt.value,
      "hide-pagination-when-optional": !1,
      "hide-toolbar": re.hideToolbar,
      loading: re.loading || A(le),
      "max-height": re.maxHeight,
      nested: re.nested,
      "pagination-attributes": Y.value,
      "resize-columns": re.resizeColumns,
      "row-attrs": re.rowAttrs,
      "row-bulk-action-enabled": re.rowBulkActionEnabled,
      "row-expandable": re.rowExpandable,
      "row-expanded": re.rowExpanded,
      "row-hover": re.rowHover,
      "row-key": re.rowKey,
      "row-link": re.rowLink,
      "table-preferences": Ot.value,
      "tooltip-target": re.tooltipTarget
    }, r.value, {
      onEmptyStateActionClick: ze[0] || (ze[0] = (U) => i("empty-state-action-click")),
      onErrorActionClick: ze[1] || (ze[1] = (U) => i("error-action-click")),
      onGetNextOffset: ta,
      onGetPreviousOffset: xt,
      onPageChange: ct,
      onPageSizeChange: dt,
      onRowActionsToggle: ze[2] || (ze[2] = (U) => re.$emit("row-actions-toggle", U)),
      onRowSelect: ze[3] || (ze[3] = (U) => i("row-select", U)),
      onSort: qe,
      "onUpdate:rowExpanded": ze[4] || (ze[4] = (U) => i("update:row-expanded", U)),
      "onUpdate:tablePreferences": Qe
    }), yt({ _: 2 }, [
      o.toolbar && !re.hideToolbar ? {
        name: "toolbar",
        fn: N(() => [
          j(re.$slots, "toolbar", { state: Ce.value })
        ]),
        key: "0"
      } : void 0,
      o["bulk-actions"] ? {
        name: "bulk-actions",
        fn: N((U) => [
          j(re.$slots, "bulk-actions", ra(Ma(U)))
        ]),
        key: "1"
      } : void 0,
      o["bulk-action-items"] ? {
        name: "bulk-action-items",
        fn: N((U) => [
          j(re.$slots, "bulk-action-items", ra(Ma(U)))
        ]),
        key: "2"
      } : void 0,
      o["error-state"] ? {
        name: "error-state",
        fn: N(() => [
          j(re.$slots, "error-state")
        ]),
        key: "3"
      } : void 0,
      o["empty-state"] ? {
        name: "empty-state",
        fn: N(() => [
          j(re.$slots, "empty-state")
        ]),
        key: "4"
      } : void 0,
      o["empty-state-action-icon"] ? {
        name: "empty-state-action-icon",
        fn: N(() => [
          j(re.$slots, "empty-state-action-icon")
        ]),
        key: "5"
      } : void 0,
      Le(D.value, (U) => ({
        name: U,
        fn: N((de) => [
          j(re.$slots, U, ra(Ma(de)))
        ])
      })),
      Le(B.value, (U) => ({
        name: U,
        fn: N((de) => [
          j(re.$slots, U, ra(Ma(de)))
        ])
      })),
      Le(J.value, (U) => ({
        name: U,
        fn: N((de) => [
          j(re.$slots, U, ra(Ma(de)))
        ])
      })),
      o["action-items"] ? {
        name: "action-items",
        fn: N((U) => [
          j(re.$slots, "action-items", ra(Ma(U)))
        ]),
        key: "6"
      } : void 0,
      o["row-expanded"] ? {
        name: "row-expanded",
        fn: N((U) => [
          j(re.$slots, "row-expanded", ra(Ma(U)))
        ]),
        key: "7"
      } : void 0
    ]), 1040, ["cell-attrs", "data", "empty-state-action-message", "empty-state-action-route", "empty-state-button-appearance", "empty-state-icon-variant", "empty-state-message", "empty-state-title", "error", "error-state-action-message", "error-state-action-route", "error-state-message", "error-state-title", "headers", "hide-headers", "hide-pagination", "hide-toolbar", "loading", "max-height", "nested", "pagination-attributes", "resize-columns", "row-attrs", "row-bulk-action-enabled", "row-expandable", "row-expanded", "row-hover", "row-key", "row-link", "table-preferences", "tooltip-target"]));
  }
}), UH = {
  class: "k-slider",
  "data-testid": "k-slider"
}, VH = { class: "slider-container" }, KH = { class: "input-value" }, jH = ["id", "disabled", "list", "max", "min", "step"], GH = ["id"], QH = ["data-testid", "label", "value"], ZH = {
  "aria-hidden": "true",
  class: "slider-marks",
  "data-testid": "slider-marks"
}, XH = ["data-testid"], JH = /* @__PURE__ */ se({
  __name: "KSlider",
  props: /* @__PURE__ */ Ql({
    label: { default: "" },
    min: { default: 0 },
    max: { default: 10 },
    step: { default: 1 },
    showMarks: { type: Boolean, default: !1 },
    marks: { default: () => [] },
    showValue: { type: Boolean, default: !0 },
    disabled: { type: Boolean, default: !1 },
    labelAttributes: { default: () => ({}) }
  }, {
    modelValue: {
      required: !0,
      type: Number
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Ql(["change", "update:modelValue"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const a = t, n = bt(), r = b(() => ({ width: C(d.value) })), i = b(() => ({
      left: C(d.value),
      transform: `translateX(-${C(d.value)})`
    })), o = () => {
      a("change", d.value), l();
    }, u = mt("thumbPopover"), l = () => {
      var p;
      (p = u.value) == null || p.showPopover();
    }, s = () => {
      var p;
      (p = u.value) == null || p.hidePopover();
    }, d = Zl(e, "modelValue"), c = b(() => {
      const p = Math.max(
        (String(e.step).split(".")[1] || "").length,
        (String(e.min).split(".")[1] || "").length,
        (String(e.max).split(".")[1] || "").length
      );
      return Math.pow(10, p);
    }), f = b(() => {
      if (e.max <= e.min || e.step <= 0)
        return [];
      const p = [], h = e.min * c.value, g = e.max * c.value, w = e.step * c.value;
      for (let $ = h; $ <= g; $ += w)
        p.push($ / c.value);
      return p;
    }), v = (p) => p >= e.min && p <= e.max && f.value.includes(p), m = b(() => {
      var p, h;
      if (e.marks.length) {
        if (typeof e.marks[0] == "object")
          return e.marks.filter((g) => v(g.value));
        {
          const g = e.marks.filter((w) => v(w)).map((w) => ({
            label: String(w),
            value: w
          }));
          return ((p = g[0]) == null ? void 0 : p.value) !== e.min && g.unshift({ label: String(e.min), value: e.min }), ((h = g.at(-1)) == null ? void 0 : h.value) !== e.max && g.push({ label: String(e.max), value: e.max }), g;
        }
      }
      return e.showMarks ? f.value.map((g) => ({
        label: String(g),
        value: g
      })) : [
        {
          label: String(e.min),
          value: e.min
        },
        {
          label: String(e.max),
          value: e.max
        }
      ];
    }), C = (p) => `${(p - e.min) / (e.max - e.min) * 100}%`;
    return ne(() => e.max, (p) => {
      p <= e.min && console.warn(`KSlider: max value ${p} must be greater than min value ${e.min}.`);
    }, { immediate: !0 }), ne(() => e.step, (p) => {
      e.max > e.min && (p <= 0 || (e.max * c.value - e.min * c.value) % (p * c.value) !== 0) && console.warn(`KSlider: step value ${p} is invalid.`);
    }, { immediate: !0 }), ne(d, (p) => {
      e.max > e.min && !v(p) && (console.warn(`KSlider: value ${p} is out of range [${f.value.join(", ")}]. Setting to min value ${e.min}.`), d.value = e.min);
    }, { immediate: !0 }), ne(() => e.marks, (p) => {
      if (p.length) {
        let h = [];
        h = p.filter((g) => !v(typeof e.marks[0] == "object" ? g.value : g)), h.length && console.warn(`KSlider: marks [${h.map((g) => typeof h[0] == "object" ? g.value : g).join(", ")}] are out of range [${f.value.join(", ")}].`);
      }
    }, { immediate: !0 }), (p, h) => (y(), S("div", UH, [
      p.label ? (y(), ee(_a, Fe({ key: 0 }, p.labelAttributes, {
        for: `${A(n)}-input`
      }), {
        default: N(() => [
          be(ae(p.label), 1)
        ]),
        _: 1
      }, 16, ["for"])) : W("", !0),
      H("div", VH, [
        H("span", {
          "aria-hidden": "true",
          class: ue(["lower-range-track", { "is-disabled": p.disabled }]),
          style: Ee(r.value)
        }, null, 6),
        Z(ir, {
          ref: "thumbPopover",
          "aria-hidden": "true",
          disabled: p.disabled || !p.showValue,
          "hide-close-icon": "",
          placement: "top",
          "popover-timeout": 500,
          trigger: "hover",
          width: "auto"
        }, {
          content: N(() => [
            H("span", KH, ae(d.value), 1)
          ]),
          default: N(() => [
            H("span", {
              class: ue(["thumb", { "is-disabled": p.disabled }]),
              style: Ee(i.value)
            }, null, 6)
          ]),
          _: 1
        }, 8, ["disabled"]),
        $a(H("input", {
          id: `${A(n)}-input`,
          "onUpdate:modelValue": h[0] || (h[0] = (g) => d.value = g),
          "data-testid": "slider-input",
          disabled: p.disabled,
          list: `${A(n)}-markers`,
          max: p.max,
          min: p.min,
          step: p.step,
          type: "range",
          onBlur: s,
          onFocus: l,
          onInput: o,
          onMouseup: s,
          onTouchend: s
        }, null, 40, jH), [
          [
            Xl,
            d.value,
            void 0,
            { number: !0 }
          ]
        ]),
        H("datalist", {
          id: `${A(n)}-markers`,
          "data-testid": "slider-datalist-marks"
        }, [
          (y(!0), S(Ae, null, Le(m.value, (g) => (y(), S("option", {
            key: `datalist-mark-${g.value}`,
            "data-testid": `datalist-mark-${g.value}`,
            label: g.label,
            style: Ee({ left: C(g.value) }),
            value: g.value
          }, null, 12, QH))), 128))
        ], 8, GH),
        H("div", ZH, [
          (y(!0), S(Ae, null, Le(m.value, (g) => (y(), S("span", {
            key: `mark-${g.value}`,
            "data-testid": `mark-${g.value}`,
            style: Ee({ left: C(g.value) })
          }, ae(g.label || g.value), 13, XH))), 128))
        ])
      ])
    ]));
  }
}), eq = /* @__PURE__ */ Me(JH, [["__scopeId", "data-v-dea0bffd"]]), Vp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  KAlert: jy,
  KBadge: fi,
  KBreadcrumbs: h0,
  KButton: nt,
  KCard: Ih,
  KCatalog: Rw,
  KCatalogItem: Oh,
  KCheckbox: ls,
  KClipboardProvider: ah,
  KCodeBlock: fS,
  KCodeBlockIconButton: $r,
  KCollapse: wS,
  KComponent: nh,
  KCopy: kH,
  KDateTimePicker: KB,
  KDropdown: Br,
  KDropdownItem: Wu,
  KDropdownMenu: Br,
  KEmptyState: Xn,
  KExternalLink: uH,
  KFileUpload: QB,
  KInput: xn,
  KInputSwitch: tR,
  KLabel: _a,
  KModal: s1,
  KModalFullscreen: nF,
  KMultiselect: xF,
  KPagination: Vs,
  KPop: ir,
  KPrompt: zF,
  KRadio: GF,
  KSegmentedControl: Tg,
  KSelect: hz,
  KSkeleton: Us,
  KSkeletonBox: ka,
  KSlideout: Cz,
  KSlider: eq,
  KStepper: Iz,
  KTable: Uz,
  KTableData: _H,
  KTableView: T1,
  KTabs: Zz,
  KTextArea: tY,
  KToaster: c1,
  KToggle: Rs,
  KTooltip: ga,
  KTreeList: oH,
  KTruncate: mH,
  ToastManager: dY
}, Symbol.toStringTag, { value: "Module" })), bq = {
  install: (e) => {
    for (const t in Vp)
      e.component(t, Vp[t]);
  }
};
export {
  ti as AlertAppearances,
  nq as BadgeAppearances,
  rh as BadgeMethodAppearances,
  rq as BadgeSizes,
  B1 as ButtonAppearances,
  iq as ButtonSizes,
  sq as CardSizeArray,
  Fs as DateTimePickerModes,
  xa as EmptyStateIconVariants,
  oq as HeaderTags,
  jy as KAlert,
  fi as KBadge,
  h0 as KBreadcrumbs,
  nt as KButton,
  Ih as KCard,
  Rw as KCatalog,
  Oh as KCatalogItem,
  ls as KCheckbox,
  ah as KClipboardProvider,
  fS as KCodeBlock,
  $r as KCodeBlockIconButton,
  wS as KCollapse,
  nh as KComponent,
  kH as KCopy,
  KB as KDateTimePicker,
  Br as KDropdown,
  Wu as KDropdownItem,
  Br as KDropdownMenu,
  Xn as KEmptyState,
  uH as KExternalLink,
  QB as KFileUpload,
  xn as KInput,
  tR as KInputSwitch,
  _a as KLabel,
  s1 as KModal,
  nF as KModalFullscreen,
  xF as KMultiselect,
  Vs as KPagination,
  ir as KPop,
  zF as KPrompt,
  GF as KRadio,
  Tg as KSegmentedControl,
  hz as KSelect,
  Us as KSkeleton,
  ka as KSkeletonBox,
  Cz as KSlideout,
  eq as KSlider,
  Iz as KStepper,
  Uz as KTable,
  _H as KTableData,
  T1 as KTableView,
  Zz as KTabs,
  tY as KTextArea,
  c1 as KToaster,
  Rs as KToggle,
  ga as KTooltip,
  oH as KTreeList,
  mH as KTruncate,
  cq as MethodsArray,
  dq as ModeArray,
  R1 as ModeArrayCustom,
  F1 as ModeArrayRelative,
  z1 as ModeDateOnly,
  vq as PopPlacementsArray,
  fq as PopTriggerArray,
  pq as RadioTypesArray,
  mq as SkeletonBoxHeightArray,
  gq as SkeletonBoxWidthArray,
  hq as SkeletonTypeArray,
  yq as StepperStateArray,
  We as TableViewHeaderKeys,
  uq as TimepickerMode,
  dY as ToastManager,
  ih as ToasterAppearances,
  lq as TriggerAlignmentArray,
  Vp as components,
  bq as default
};
